webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1121)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(676),
  /* template */
  __webpack_require__(1498),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return webSocketServer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TaskWebSocketServer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return commandSocketServer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return systemType; });
// backend ip when in development mode
var ip = window.location.hostname + ':1236';

// backend ip when in production mode
if (true) {
  //20211115 modified: remove port 1236 to solve cros problem
  ip = '' + window.location.hostname; //測試用
}

// server with "http" prefix
var server = 'https://' + ip;
/* harmony default export */ __webpack_exports__["a"] = (server);
// baceknd websocket server used in Admin components
//20211115 modified
var webSocketServer = 'wss://' + window.location.hostname + ':1235';

// local websocket server for connecting peripherial devices (ex: cabinet firmware, fingerprinter)
var taskServer = 'localhost:8888';
var TaskWebSocketServer = 'ws://' + taskServer + '/socket';
var commandSocketServer = 'http://' + taskServer + '/';

// other settings
var version = '01.01'; // version: release, django, task-server, vue
var systemType = 'ADC'; // ADC, Tag

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// parse cookie.
// the login token is save in cookie.

function readCookie(cookieName) {
  var re = new RegExp('[; ]' + cookieName + '=([^\\s;]*)');
  var sMatch = (' ' + document.cookie).match(re);
  if (cookieName && sMatch) return sMatch[1];
  return '';
}

/* harmony default export */ __webpack_exports__["a"] = (readCookie);

/***/ }),
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1129)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(514),
  /* template */
  __webpack_require__(1513),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7d595b89",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(515),
  /* template */
  __webpack_require__(1487),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1114)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(666),
  /* template */
  __webpack_require__(1483),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1119)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(702),
  /* template */
  __webpack_require__(1491),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-61940532",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  data: function data() {
    return {
      appName: '',
      stage: '',
      progress: [],
      multiProgress: [],
      confirmProgress: [],
      actionProgress: []
    };
  },

  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    },
    currentApp: function currentApp() {
      return this.$store.state.currentApp;
    },
    currentStep: function currentStep() {
      return this.$store.state.currentStep;
    }
  },
  created: function created() {
    // name the title.
    this.$store.commit('SET_APP', this.$route.meta.appName);
    // prepare the data after login.
    if (this.$store.state.route.from.name === 'Login') {
      this.$store.dispatch('removeLogoutTimeout');
      this.$store.dispatch('setLogoutTimeout');
      this.$store.dispatch('getSystemInfo');
      this.$store.dispatch('getDrugInDevices');
      this.$store.dispatch('getDisabledDevices');
    }
    // initiate automatically logout
    this.$store.dispatch('removeLogoutTimeout');
    this.$store.dispatch('setLogoutTimeout');
  },
  mounted: function mounted() {
    this.checkVariableInitiated();
  },

  methods: {
    checkVariableInitiated: function checkVariableInitiated() {
      if (this.stage === '') console.error('stage not initiated.');

      // setup progress
      if (this.progress.length === 0) {
        console.error('progress not initiated');
      } else {
        this.$store.commit('SET_PROGRESS', this.progress);
      }

      if (this.multiProgress.length === 0) console.warn('multiProgress not initiated');
      if (this.confirmProgress.length === 0) console.warn('confirmProgress not initiated');
      if (this.actionProgress.length === 0) console.warn('actionProgress not initiated');
    },
    cancel: function cancel() {
      // make sure all apps have cancel function.
      console.error('cancel function not implemented');
    }
  }
}));

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1049)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(680),
  /* template */
  __webpack_require__(1374),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1133)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(688),
  /* template */
  __webpack_require__(1517),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 36 */,
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  props: ['confirmProgress', 'actionProgress'],
  data: function data() {
    return {
      progressIndex: 0
    };
  },
  created: function created() {
    this.$store.commit('SET_CURRENT_STEP', this.confirmProgress[0]);
    this.checkRxCheckShouldSkip();
  },
  mounted: function mounted() {},

  methods: {
    resetProgress: function resetProgress() {
      console.log('reset progress');
      this.progressIndex = 0;
    },
    nextProgress: function nextProgress() {
      console.log('next progress');
      this.progressIndex += 1;
    },
    checkRxCheckShouldSkip: function checkRxCheckShouldSkip() {
      console.log(this.currentProgress, this.$store.getters.selectedDrug.rx_check);
      if (this.currentProgress === 'rxCheck') {
        console.log('med need rxcheck: ', this.$store.getters.selectedDrug.rx_check);
        if (this.$store.getters.selectedDrug.rx_check === false) {
          this.nextProgress();
        }
      }
    }
  },
  computed: {
    currentSystem: function currentSystem() {
      return this.$store.getters.currentSystem;
    },
    currentDrugInDevice: function currentDrugInDevice() {
      return this.$store.state.drugInDevice.currentDrugInDevice;
    },
    currentDevice: function currentDevice() {
      return this.$store.state.device.currentDevice;
    },
    currentProgress: function currentProgress() {
      return this.confirmProgress[this.progressIndex];
    },
    currentSchedule: function currentSchedule() {
      return this.$store.getters.currentSchedule;
    },
    currentDrug: function currentDrug() {
      return this.$store.getters.currentDrug;
    },
    currentEvent: function currentEvent() {
      return this.$store.state.event.currentEvent;
    },
    selectedDrugTotalAmount: function selectedDrugTotalAmount() {
      return this.$store.state.drug.selectedDrugTotalAmount;
    },
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  watch: {
    currentProgress: function currentProgress(val) {
      console.log(val);
      this.$store.commit('SET_CURRENT_STEP', this.currentProgress);
      this.checkRxCheckShouldSkip();
    }
  }
}));

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  props: ['multiProgress', 'confirmProgress', 'actionProgress'],
  data: function data() {
    return {
      progressIndex: 0
    };
  },

  computed: {
    currentProgress: function currentProgress() {
      return this.multiProgress[this.progressIndex];
    },
    currentDevice: function currentDevice() {
      return this.$store.state.device.currentDevice;
    },
    currentDrugInDevice: function currentDrugInDevice() {
      return this.$store.state.drugInDevice.currentDrugInDevice;
    },
    currentDrug: function currentDrug() {
      return this.$store.getters.currentDrug;
    },
    currentSchedule: function currentSchedule() {
      return this.$store.getters.currentSchedule;
    },
    instance: function instance() {
      return this.$store.state.instance;
    },
    nextDevice: function nextDevice() {
      return this.$store.state.device.nextDevice;
    },
    nextDrugInDevice: function nextDrugInDevice() {
      return this.$store.state.drugInDevice.nextDrugInDevice;
    },
    nextEvent: function nextEvent() {
      return this.$store.state.event.nextEvent;
    },
    nextDrug: function nextDrug() {
      return this.$store.getters.nextDrug;
    },
    selectedDrugTotalAmount: function selectedDrugTotalAmount() {
      return this.$store.state.drug.selectedDrugTotalAmount;
    },
    errorDevices: function errorDevices() {
      return this.$store.state.device.errorDevices;
    }
  },
  methods: {
    nextProgress: function nextProgress() {
      this.progressIndex += 1;
    },
    resetProgress: function resetProgress() {
      this.progressIndex = 0;
    }
  }
}));

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1093)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(709),
  /* template */
  __webpack_require__(1448),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1102)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(558),
  /* template */
  __webpack_require__(1463),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(697),
  /* template */
  __webpack_require__(1413),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MESSAGE_POPED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_APP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_APP_CANCEL_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLOSE_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREATE_INSTANCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SHOW_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SHOW_LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SHOW_LOADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FRONETEND_PANEL_USER_LOGINED; });
/* unused harmony export GET_DRUG_IN_DEVICES */
/* unused harmony export SELECT_DEVICES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SELECT_DRUG_IN_DEVICES_FROM_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return SET_CURRENT_DRUG_BY_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return RESET_DEVICES_MODULE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return RESET_EVENT_MODULE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return RESET_DRUG_IN_DEVICE_MODULE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return RESET_DRUG_MODULE; });
/* unused harmony export WEBSOCKET_CONNECT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return SET_CURRENT_DEVICE_FROM_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return SET_CURRENT_DEVICE_FROM_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return SET_NEXT_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return REMOVE_NEXT_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return SETUP_LOCKED_DEVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return SET_CURRENT_DRUG_IN_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return SET_NEXT_DRUG_IN_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return REMOVE_NEXT_DRUG_IN_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SET_DRUG_IN_DEVICE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return FILTER_DRUG_IN_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return SET_SELECTED_DRUG_IN_DEVICE_DIRECTLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return DRUG_IN_DEVICE_USED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return DRUG_STORAGE_EVENT_FIRED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return SELECT_DRUG_IN_DEVICES_FROM_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_PROGRESS; });
/* unused harmony export TO_NEXT_PROGRESS */
/* unused harmony export BACK_PREVIOUS_PROGRESS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_CURRENT_STEP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return SET_CURRENT_NET; });
/* unused harmony export SET_CONFIRM_STAGE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return CHANGE_DEVICE_SELECTED_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return ADD_DEVICE_TO_SELECTED_LIST; });
/* unused harmony export GET_USER_INFO */
/* unused harmony export LOGIN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return ALERT_POPED; });
/* unused harmony export SELECT_EVENT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SET_CURRENT_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return FILTER_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SET_MED_RECORD_NO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_TODAY_SCHEDULE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SET_CURRENT_SCHEDULE_BY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SET_SCHEDULE_MED_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return RESET_SCHEDULE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SET_CURRENT_SCHEDULE_DIRECTLY; });
var SET_MESSAGE = 'SET_MESSAGE';
var MESSAGE_POPED = 'MESSAGE_POPED';
var SET_APP = 'SET_APP';
var SET_APP_CANCEL_STATUS = 'SET_APP_CANCEL_STATUS';
var CLOSE_MESSAGE = 'CLOSE_MESSAGE';
var CREATE_INSTANCE = 'CREATE_INSTANCE';
var SHOW_MODAL = 'SHOW_MODAL';
var SHOW_LOGOUT = 'SHOW_LOGOUT';
var SHOW_LOADER = 'SHOW_LOADER';
var FRONETEND_PANEL_USER_LOGINED = 'FRONETEND_PANEL_USER_LOGINED';

// DRUG
var GET_DRUG_IN_DEVICES = 'GET_DRUG_IN_DEVICES';
var SELECT_DEVICES = 'SELECT_DEVICES';
var SELECT_DRUG_IN_DEVICES_FROM_SELECTED = 'SELECT_DRUG_IN_DEVICES_FROM_SELECTED';
var SET_CURRENT_DRUG_BY_INDEX = 'SET_CURRENT_DRUG_BY_INDEX';

// DEVICE
var RESET_DEVICES_MODULE = 'RESET_DEVICES_MODULE';
var RESET_EVENT_MODULE = 'RESET_EVENT_MODULE';
var RESET_DRUG_IN_DEVICE_MODULE = 'RESET_DRUG_IN_DEVICE_MODULE';
var RESET_DRUG_MODULE = 'RESET_DRUG_MODULE';

var WEBSOCKET_CONNECT = 'WEBSOCKET_CONNECT';
var SET_CURRENT_DEVICE_FROM_SELECTED = 'SET_CURRENT_DEVICE_FROM_SELECTED';
var SET_CURRENT_DEVICE_FROM_ALL = 'SET_CURRENT_DEVICE_FROM_ALL';
var SET_NEXT_DEVICE = 'SET_NEXT_DEVICE';
var REMOVE_NEXT_DEVICE = 'REMOVE_NEXT_DEVICE';
var SETUP_LOCKED_DEVICES = 'SETUP_LOCKED_DEVICES';

// DRUG IN DEVICE
var SET_CURRENT_DRUG_IN_DEVICE = 'SET_CURRENT_DRUG_IN_DEVICE';
var SET_NEXT_DRUG_IN_DEVICE = 'SET_NEXT_DRUG_IN_DEVICE';
var REMOVE_NEXT_DRUG_IN_DEVICE = 'REMOVE_NEXT_DRUG_IN_DEVICE';
var SET_DRUG_IN_DEVICE_LIST = 'SET_DRUG_IN_DEVICE_LIST'; // this function is not good at all.
var FILTER_DRUG_IN_DEVICE = 'FILTER_DRUG_IN_DEVICE';
var SET_SELECTED_DRUG_IN_DEVICE_DIRECTLY = 'SET_SELECTED_DRUG_IN_DEVICE_DIRECTLY';
var DRUG_IN_DEVICE_USED = 'DRUG_IN_DEVICE_USED';
var DRUG_STORAGE_EVENT_FIRED = 'DRUG_STORAGE_EVENT_FIRED';
var SELECT_DRUG_IN_DEVICES_FROM_ALL = 'SELECT_DRUG_IN_DEVICES_FROM_ALL';

var SET_PROGRESS = 'SET_PROGRESS';
var TO_NEXT_PROGRESS = 'TO_NEXT_PROGRESS';
var BACK_PREVIOUS_PROGRESS = 'BACK_PREVIOUS_PROGRESS';
var SET_CURRENT_STEP = 'SET_CURRENT_STEP';

var SET_CURRENT_NET = 'SET_CURRENT_NET';
var SET_CONFIRM_STAGE = 'SET_CONFIRM_STAGE';
var CHANGE_DEVICE_SELECTED_STATUS = 'CHANGE_DEVICE_SELECTED_STATUS';
var ADD_DEVICE_TO_SELECTED_LIST = 'ADD_DEVICE_TO_SELECTED_LIST';

var GET_USER_INFO = 'GET_USER_INFO';
var LOGIN = 'LOGIN';
var LOGOUT = 'LOGOUT';
var ALERT_POPED = 'ALERT_POPED';

// EVENT
var SELECT_EVENT = 'SELECT_EVENT';
var SET_CURRENT_EVENT = 'SET_CURRENT_EVENT';
var FILTER_EVENTS = 'FILTER_EVENTS';
var SET_MED_RECORD_NO = 'SET_MED_RECORD_NO';

// Schedule
var SET_TODAY_SCHEDULE = 'SET_TODAY_SCHEDULE';
var SET_CURRENT_SCHEDULE_BY_ID = 'SET_CURRENT_SCHEDULE_BY_ID';
var SET_SCHEDULE_MED_LIST = 'SET_SCHEDULE_MED_LIST';
var RESET_SCHEDULE = 'RESET_SCHEDULE';
var SET_CURRENT_SCHEDULE_DIRECTLY = 'SET_CURRENT_SCHEDULE_DIRECTLY';

/***/ }),
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1100)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(665),
  /* template */
  __webpack_require__(1459),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1097)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(691),
  /* template */
  __webpack_require__(1455),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-44250478",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1086)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(701),
  /* template */
  __webpack_require__(1434),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(708),
  /* template */
  __webpack_require__(1456),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1040)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(669),
  /* template */
  __webpack_require__(1363),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-01ae535a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1057)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(687),
  /* template */
  __webpack_require__(1386),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0fee1b06",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(1405),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1087)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(681),
  /* template */
  __webpack_require__(1435),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-389f5d16",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1126)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(696),
  /* template */
  __webpack_require__(1507),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-71119b0d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(712),
  /* template */
  __webpack_require__(1400),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Autoix__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Autoix___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Autoix__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Login__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Main__ = __webpack_require__(1295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_CreateDrug__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_CreateDrug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_CreateDrug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_CheckAmount__ = __webpack_require__(1269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_CheckAmount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_CheckAmount__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_FetchDrug__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_FetchDrug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_FetchDrug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_SetReturnBox__ = __webpack_require__(1326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_SetReturnBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_SetReturnBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_DrugInfo__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_DrugInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_DrugInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_RecycleDrug__ = __webpack_require__(1296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_RecycleDrug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_RecycleDrug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_RefillDrug__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_RefillDrug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_RefillDrug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_RemoveOutdatedDrug__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_RemoveOutdatedDrug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_RemoveOutdatedDrug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_RemoveDrug__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_RemoveDrug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_RemoveDrug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_UserManual__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_UserManual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_UserManual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_UserManual_Index__ = __webpack_require__(1331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_UserManual_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_UserManual_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_UserManual_Barcode__ = __webpack_require__(1329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_UserManual_Barcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_UserManual_Barcode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_UserManual_Password__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_UserManual_Password___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_UserManual_Password__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_UserManual_Fingerprint__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_UserManual_Fingerprint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_UserManual_Fingerprint__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_StorageError__ = __webpack_require__(1327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_StorageError___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_StorageError__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_ReturnDrug__ = __webpack_require__(1313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_ReturnDrug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_ReturnDrug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_DisableDevicesList__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_DisableDevicesList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_DisableDevicesList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Schedule__ = __webpack_require__(1321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Schedule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_Schedule__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_ScheduleReturn__ = __webpack_require__(1325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_ScheduleReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_ScheduleReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_FetchDrugGroup__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_FetchDrugGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_FetchDrugGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_FetchDrugCombo__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_FetchDrugCombo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_FetchDrugCombo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_LockBox__ = __webpack_require__(1291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_LockBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_LockBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_DrugStorageSummary__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_DrugStorageSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_DrugStorageSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_FetchDrugSchedule__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_FetchDrugSchedule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_FetchDrugSchedule__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_Waste__ = __webpack_require__(1333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_Waste___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_Waste__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_RecycleEmpty__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_RecycleEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_RecycleEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_ReturnEmpty__ = __webpack_require__(1317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_ReturnEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_ReturnEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_Admin__ = __webpack_require__(1193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_Admin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_Admin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_Admin_AdminLogin__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_Admin_AdminLogin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_Admin_AdminLogin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_Admin_ADCManagement__ = __webpack_require__(1194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_Admin_ADCManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_Admin_ADCManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_Admin_ADCManagement_ADCList__ = __webpack_require__(1196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_Admin_ADCManagement_ADCList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_Admin_ADCManagement_ADCList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_Admin_ADCManagement_DrugList__ = __webpack_require__(1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_Admin_ADCManagement_DrugList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_Admin_ADCManagement_DrugList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_Admin_ADCManagement_Planning__ = __webpack_require__(1205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_Admin_ADCManagement_Planning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_Admin_ADCManagement_Planning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_Admin_ADCManagement_PlanningList__ = __webpack_require__(1206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_Admin_ADCManagement_PlanningList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_Admin_ADCManagement_PlanningList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_Admin_ADCManagement_ScheduleList__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_Admin_ADCManagement_ScheduleList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_Admin_ADCManagement_ScheduleList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_Admin_ADCManagement_ShiftArrange__ = __webpack_require__(1209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_Admin_ADCManagement_ShiftArrange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__components_Admin_ADCManagement_ShiftArrange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_Admin_ADCManagement_FetchScheduleList__ = __webpack_require__(1204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_Admin_ADCManagement_FetchScheduleList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_Admin_ADCManagement_FetchScheduleList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_Admin_ADCManagement_CarList__ = __webpack_require__(1197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_Admin_ADCManagement_CarList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_Admin_ADCManagement_CarList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_Admin_ADCManagement_CrossLineList__ = __webpack_require__(1200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_Admin_ADCManagement_CrossLineList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__components_Admin_ADCManagement_CrossLineList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_Admin_ADCManagement_ShoulderList__ = __webpack_require__(1211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_Admin_ADCManagement_ShoulderList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__components_Admin_ADCManagement_ShoulderList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_Admin_DataImport__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_Admin_DataImport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__components_Admin_DataImport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_Admin_DataImport_DrugImport__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_Admin_DataImport_DrugImport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__components_Admin_DataImport_DrugImport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_Admin_DataImport_TagDrugStorageImport__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_Admin_DataImport_TagDrugStorageImport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__components_Admin_DataImport_TagDrugStorageImport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_Admin_DataImport_UserImport__ = __webpack_require__(1223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_Admin_DataImport_UserImport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__components_Admin_DataImport_UserImport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_Admin_ReportExport__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_Admin_ReportExport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__components_Admin_ReportExport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_Admin_ReportExport_EventSummary__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_Admin_ReportExport_EventSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__components_Admin_ReportExport_EventSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_Admin_ReportExport_CustomReport__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_Admin_ReportExport_CustomReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__components_Admin_ReportExport_CustomReport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_Admin_ReportExport_CrossLineReport__ = __webpack_require__(1226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_Admin_ReportExport_CrossLineReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__components_Admin_ReportExport_CrossLineReport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_Admin_ReportExport_ShoulderReport__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_Admin_ReportExport_ShoulderReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__components_Admin_ReportExport_ShoulderReport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_Admin_ReportExport_TimeLogSummary__ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_Admin_ReportExport_TimeLogSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__components_Admin_ReportExport_TimeLogSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_Admin_ReportExport_IpCamTimeLogSummary__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_Admin_ReportExport_IpCamTimeLogSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__components_Admin_ReportExport_IpCamTimeLogSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_Admin_ReportExport_TimeLogAnalysis__ = __webpack_require__(1233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_Admin_ReportExport_TimeLogAnalysis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__components_Admin_ReportExport_TimeLogAnalysis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_Admin_ReportExport_TimeSyncSummary__ = __webpack_require__(1235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_Admin_ReportExport_TimeSyncSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__components_Admin_ReportExport_TimeSyncSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_Admin_ReportExport_NTPLogSummary__ = __webpack_require__(1230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_Admin_ReportExport_NTPLogSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__components_Admin_ReportExport_NTPLogSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_Admin_ReportExport_OtherPcLogSummary__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_Admin_ReportExport_OtherPcLogSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__components_Admin_ReportExport_OtherPcLogSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_Admin_SystemSettings__ = __webpack_require__(1236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_Admin_SystemSettings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__components_Admin_SystemSettings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_Admin_SystemSettings_DrugSettings__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_Admin_SystemSettings_DrugSettings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__components_Admin_SystemSettings_DrugSettings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_Admin_SystemSettings_ControlDrugSettings__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_Admin_SystemSettings_ControlDrugSettings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__components_Admin_SystemSettings_ControlDrugSettings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_Admin_SystemSettings_DrugGroupSettings__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_Admin_SystemSettings_DrugGroupSettings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__components_Admin_SystemSettings_DrugGroupSettings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_Admin_SystemSettings_GeneralSettings__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_Admin_SystemSettings_GeneralSettings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__components_Admin_SystemSettings_GeneralSettings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_Admin_SystemSettings_AreaSettings__ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_Admin_SystemSettings_AreaSettings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__components_Admin_SystemSettings_AreaSettings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_Admin_SystemSettings_UserGroupSettings__ = __webpack_require__(1252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_Admin_SystemSettings_UserGroupSettings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__components_Admin_SystemSettings_UserGroupSettings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_Admin_SystemSettings_UserSettings__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_Admin_SystemSettings_UserSettings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__components_Admin_SystemSettings_UserSettings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_Admin_SystemSettings_ComboSettings__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_Admin_SystemSettings_ComboSettings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69__components_Admin_SystemSettings_ComboSettings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_Admin_SystemSettings_DrugDBSettings__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_Admin_SystemSettings_DrugDBSettings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70__components_Admin_SystemSettings_DrugDBSettings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_Admin_SystemSettings_ParaSettings__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_Admin_SystemSettings_ParaSettings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71__components_Admin_SystemSettings_ParaSettings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_Admin_TagManagement__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_Admin_TagManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72__components_Admin_TagManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_Admin_TagManagement_TagList__ = __webpack_require__(1260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_Admin_TagManagement_TagList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73__components_Admin_TagManagement_TagList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_Admin_TagManagement_DrugList__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_Admin_TagManagement_DrugList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74__components_Admin_TagManagement_DrugList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_Admin_TagManagement_Planning__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_Admin_TagManagement_Planning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75__components_Admin_TagManagement_Planning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__components_Admin_TagManagement_PlanningList__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__components_Admin_TagManagement_PlanningList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76__components_Admin_TagManagement_PlanningList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__components_Admin_TicketManagement__ = __webpack_require__(1261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__components_Admin_TicketManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77__components_Admin_TicketManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__components_Admin_TicketManagement_CarTicketList__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__components_Admin_TicketManagement_CarTicketList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78__components_Admin_TicketManagement_CarTicketList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__components_Admin_TicketManagement_CrossLineTicketList__ = __webpack_require__(1263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__components_Admin_TicketManagement_CrossLineTicketList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79__components_Admin_TicketManagement_CrossLineTicketList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__components_Admin_TicketManagement_ShoulderTicketList__ = __webpack_require__(1264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__components_Admin_TicketManagement_ShoulderTicketList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80__components_Admin_TicketManagement_ShoulderTicketList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__components_Admin_ConfirmManagement__ = __webpack_require__(1213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__components_Admin_ConfirmManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81__components_Admin_ConfirmManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__components_Admin_ConfirmManagement_CarConfirmList__ = __webpack_require__(1214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__components_Admin_ConfirmManagement_CarConfirmList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82__components_Admin_ConfirmManagement_CarConfirmList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__components_Admin_ConfirmManagement_CrossLineConfirmList__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__components_Admin_ConfirmManagement_CrossLineConfirmList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83__components_Admin_ConfirmManagement_CrossLineConfirmList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__components_Admin_ConfirmManagement_ShoulderConfirmList__ = __webpack_require__(1219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__components_Admin_ConfirmManagement_ShoulderConfirmList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84__components_Admin_ConfirmManagement_ShoulderConfirmList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__components_Dev_DevPanel__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__components_Dev_DevPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85__components_Dev_DevPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__vuex_store__ = __webpack_require__(214);
// router settings.





// main comp.































// admin comp.



// ADC management












// DataImport





// Report export












// System setting












// Tag management






//20190807 add
// Ticket management





//20190921 add
//Confirm management





// dev comp




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  linkActiveClass: 'active',
  routes: [{
    path: '/aaaaaa',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Autoix___default.a,
    redirect: { name: 'Main' },
    meta: { appType: 'cabinet' },
    children: [{
      path: 'main',
      name: 'Main',
      component: __WEBPACK_IMPORTED_MODULE_5__components_Main___default.a,
      meta: { appType: 'cabinet' }
    }, {
      path: 'create-drug',
      name: 'createDrug',
      component: __WEBPACK_IMPORTED_MODULE_6__components_CreateDrug___default.a,
      meta: { appType: 'cabinet', appName: '新增藥物' }
    }, {
      path: 'fetch-drug',
      name: 'fetchDrug',
      component: __WEBPACK_IMPORTED_MODULE_8__components_FetchDrug___default.a,
      meta: { appType: 'cabinet', appName: '一般取藥' }
    }, {
      path: 'drug-info',
      name: 'drugInfo',
      component: __WEBPACK_IMPORTED_MODULE_10__components_DrugInfo___default.a,
      meta: { appType: 'cabinet', appName: '藥物資訊' }
    }, {
      path: 'inventory',
      name: 'inventory',
      component: __WEBPACK_IMPORTED_MODULE_7__components_CheckAmount___default.a,
      meta: { appType: 'cabinet', appName: '盤點藥物' }
    }, {
      path: 'set-return-box',
      name: 'setReturnBox',
      component: __WEBPACK_IMPORTED_MODULE_9__components_SetReturnBox___default.a,
      meta: { appType: 'cabinet', appName: '設定退藥盒' }
    }, {
      path: 'return-drug',
      name: 'returnDrug',
      component: __WEBPACK_IMPORTED_MODULE_21__components_ReturnDrug___default.a,
      meta: { appType: 'cabinet', appName: '一般退藥' }
    }, {
      path: 'recycle-drug',
      name: 'recycleDrug',
      component: __WEBPACK_IMPORTED_MODULE_11__components_RecycleDrug___default.a,
      meta: { appType: 'cabinet', appName: '回收退藥' }
    }, {
      path: 'refill-drug',
      name: 'refillDrug',
      component: __WEBPACK_IMPORTED_MODULE_12__components_RefillDrug___default.a,
      meta: { appType: 'cabinet', appName: '補充藥物' }
    }, {
      path: 'remove-outdated-drug',
      name: 'removeOutdatedDrug',
      component: __WEBPACK_IMPORTED_MODULE_13__components_RemoveOutdatedDrug___default.a,
      meta: { appType: 'cabinet', appName: '移除過期' }
    }, {
      path: 'remove-drug',
      name: 'removeDrug',
      component: __WEBPACK_IMPORTED_MODULE_14__components_RemoveDrug___default.a,
      meta: { appType: 'cabinet', appName: '移除藥物' }
    }, {
      path: 'user-manual',
      name: 'userManual',
      component: __WEBPACK_IMPORTED_MODULE_15__components_UserManual___default.a,
      redirect: { name: 'userIndex' },
      meta: { appType: 'cabinet', appName: '使用者選單' },
      children: [{
        path: 'index',
        name: 'userIndex',
        component: __WEBPACK_IMPORTED_MODULE_16__components_UserManual_Index___default.a,
        meta: { appType: 'cabinet' }
      }, {
        path: 'barcode',
        name: 'userBarcode',
        component: __WEBPACK_IMPORTED_MODULE_17__components_UserManual_Barcode___default.a,
        meta: { appType: 'cabinet' }
      }, {
        path: 'password',
        name: 'userPassword',
        component: __WEBPACK_IMPORTED_MODULE_18__components_UserManual_Password___default.a,
        meta: { appType: 'cabinet' }
      }, {
        path: 'fingerprint',
        name: 'userFingerprint',
        component: __WEBPACK_IMPORTED_MODULE_19__components_UserManual_Fingerprint___default.a,
        meta: { appType: 'cabinet' }
      }]
    }, {
      path: 'storage-error',
      name: 'storageError',
      component: __WEBPACK_IMPORTED_MODULE_20__components_StorageError___default.a,
      meta: { appType: 'cabinet', appName: '存量不符' }
    }, {
      path: 'disabled-devices-list',
      name: 'disabledDevices',
      component: __WEBPACK_IMPORTED_MODULE_22__components_DisableDevicesList___default.a,
      meta: { appType: 'cabinet', appName: '待維修藥盒' }
    }, {
      path: 'schedule',
      name: 'schedule',
      component: __WEBPACK_IMPORTED_MODULE_23__components_Schedule___default.a,
      meta: { appType: 'cabinet', appName: '醫囑取藥' }
    }, {
      path: 'schedule-return',
      name: 'scheduleReturn',
      component: __WEBPACK_IMPORTED_MODULE_24__components_ScheduleReturn___default.a,
      meta: { appType: 'cabinet', appName: '醫囑退藥' }
    }, {
      path: 'fetch-drug-group',
      name: 'fetchDrugGroup',
      component: __WEBPACK_IMPORTED_MODULE_25__components_FetchDrugGroup___default.a,
      meta: { appType: 'cabinet', appName: '類別取藥' }
    }, {
      path: 'fetch-drug-combo',
      name: 'fetchDrugCombo',
      component: __WEBPACK_IMPORTED_MODULE_26__components_FetchDrugCombo___default.a,
      meta: { appType: 'cabinet', appName: '套藥取藥' }
    }, {
      path: 'fetch-drug-schedule',
      name: 'fetchDrugSchedule',
      component: __WEBPACK_IMPORTED_MODULE_29__components_FetchDrugSchedule___default.a,
      meta: { appType: 'cabinet', appName: '批次取藥' }
    }, {
      path: 'lock-box',
      name: 'lockBox',
      component: __WEBPACK_IMPORTED_MODULE_27__components_LockBox___default.a,
      meta: { appType: 'cabinet', appName: '保險藥盒' }
    }, {
      path: 'drugstorage-summary',
      name: 'drugStorageSummary',
      component: __WEBPACK_IMPORTED_MODULE_28__components_DrugStorageSummary___default.a,
      meta: { appType: 'cabinet', appName: '藥品統計' }
    }, {
      path: 'waste',
      name: 'waste',
      component: __WEBPACK_IMPORTED_MODULE_30__components_Waste___default.a,
      meta: { appType: 'cabinet', appName: '拋棄藥物' }
    }, {
      path: 'recycel-empty',
      name: 'recycleEmpty',
      component: __WEBPACK_IMPORTED_MODULE_31__components_RecycleEmpty___default.a,
      meta: { appType: 'cabinet', appName: '空瓶交換' }
    }, {
      path: 'return-empty',
      name: 'returnEmpty',
      component: __WEBPACK_IMPORTED_MODULE_32__components_ReturnEmpty___default.a,
      meta: { appType: 'cabinet', appName: '退回空瓶' }
    }]
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Login___default.a,
    meta: { appType: 'cabinet' }
  }, {
    path: '/',
    name: 'AdminLogin',
    component: __WEBPACK_IMPORTED_MODULE_34__components_Admin_AdminLogin___default.a,
    meta: { appType: 'admin' }
  }, {
    path: '/admin',
    name: 'Admin',
    component: __WEBPACK_IMPORTED_MODULE_33__components_Admin___default.a,
    meta: { appType: 'admin' },
    children: [{
      path: 'car-management',
      name: 'ADCManagement',
      component: __WEBPACK_IMPORTED_MODULE_35__components_Admin_ADCManagement___default.a,
      redirect: { name: 'ADCList' },
      meta: { appType: 'admin' },
      children: [{
        path: 'adc-list',
        name: 'ADCList',
        component: __WEBPACK_IMPORTED_MODULE_36__components_Admin_ADCManagement_ADCList___default.a,
        meta: { appType: 'admin' }
      }, {
        path: 'drug-list',
        name: 'DrugList',
        component: __WEBPACK_IMPORTED_MODULE_37__components_Admin_ADCManagement_DrugList___default.a,
        meta: { appType: 'admin' }
      }, {
        path: 'car-list',
        name: 'CarList',
        component: __WEBPACK_IMPORTED_MODULE_43__components_Admin_ADCManagement_CarList___default.a,
        meta: { appType: 'admin' }
      }, {
        path: 'cross-line-list',
        name: 'CrossLineList',
        component: __WEBPACK_IMPORTED_MODULE_44__components_Admin_ADCManagement_CrossLineList___default.a,
        meta: { appType: 'admin' }
      }, {
        path: 'shoulder-list',
        name: 'ShoulderList',
        component: __WEBPACK_IMPORTED_MODULE_45__components_Admin_ADCManagement_ShoulderList___default.a,
        meta: { appType: 'admin' }
      }, {
        path: 'planning',
        name: 'Planning',
        component: __WEBPACK_IMPORTED_MODULE_38__components_Admin_ADCManagement_Planning___default.a,
        meta: { appType: 'admin' }
      }, {
        path: 'planning-list',
        name: 'PlanningList',
        component: __WEBPACK_IMPORTED_MODULE_39__components_Admin_ADCManagement_PlanningList___default.a,
        meta: { appType: 'admin' }
      }, {
        path: 'schedule-list',
        name: 'ScheduleList',
        component: __WEBPACK_IMPORTED_MODULE_40__components_Admin_ADCManagement_ScheduleList___default.a,
        meta: { appType: 'admin' }
      }, {
        path: 'shift-arrange',
        name: 'ShiftArrange',
        component: __WEBPACK_IMPORTED_MODULE_41__components_Admin_ADCManagement_ShiftArrange___default.a,
        meta: { appType: 'admin' }
      }, {
        path: 'fetch-schedule-list',
        name: 'FetchScheduleList',
        component: __WEBPACK_IMPORTED_MODULE_42__components_Admin_ADCManagement_FetchScheduleList___default.a,
        meta: { appType: 'admin' }
      }]
    }, {
      path: 'tag-management',
      name: 'TagManagement',
      component: __WEBPACK_IMPORTED_MODULE_72__components_Admin_TagManagement___default.a,
      redirect: { name: 'TagList' },
      meta: { appType: 'admin' },
      children: [{
        path: 'tag-list',
        name: 'TagList',
        component: __WEBPACK_IMPORTED_MODULE_73__components_Admin_TagManagement_TagList___default.a,
        meta: { appType: 'admin' }
      }, {
        path: 'drug-list',
        name: 'TagDrugList',
        component: __WEBPACK_IMPORTED_MODULE_74__components_Admin_TagManagement_DrugList___default.a,
        meta: { appType: 'admin' }
      }, {
        path: 'planning',
        name: 'TagPlanning',
        component: __WEBPACK_IMPORTED_MODULE_75__components_Admin_TagManagement_Planning___default.a,
        meta: { appType: 'admin' }
      }, {
        path: 'planning-list',
        name: 'TagPlanningList',
        component: __WEBPACK_IMPORTED_MODULE_76__components_Admin_TagManagement_PlanningList___default.a,
        meta: { appType: 'admin' }
      }]
    }, {
      path: 'report-export',
      name: 'ReportExport',
      component: __WEBPACK_IMPORTED_MODULE_50__components_Admin_ReportExport___default.a,
      meta: { appType: 'admin' },
      redirect: { name: 'NTPLogSummary' },
      children: [{
        path: 'ntp-log-summary',
        name: 'NTPLogSummary',
        component: __WEBPACK_IMPORTED_MODULE_59__components_Admin_ReportExport_NTPLogSummary___default.a,
        meta: { appType: 'admin' }
      }, {
        path: 'other-pc-log-summary',
        name: 'OtherPcLogSummary',
        component: __WEBPACK_IMPORTED_MODULE_60__components_Admin_ReportExport_OtherPcLogSummary___default.a,
        meta: { appType: 'admin' }
      }, {
        path: 'time-log-summary',
        name: 'TimeLogSummary',
        component: __WEBPACK_IMPORTED_MODULE_55__components_Admin_ReportExport_TimeLogSummary___default.a,
        meta: { appType: 'admin' }
      }, {
        path: 'time-log-analysis',
        name: 'TimeLogAnalysis',
        component: __WEBPACK_IMPORTED_MODULE_57__components_Admin_ReportExport_TimeLogAnalysis___default.a,
        meta: { appType: 'admin' }
      }, {
        path: 'ipcam-time-log-summary',
        name: 'IpCamTimeLogSummary',
        component: __WEBPACK_IMPORTED_MODULE_56__components_Admin_ReportExport_IpCamTimeLogSummary___default.a,
        meta: { appType: 'admin' }
      }, {
        path: 'time-sync-summary',
        name: 'TimeSyncSummary',
        component: __WEBPACK_IMPORTED_MODULE_58__components_Admin_ReportExport_TimeSyncSummary___default.a,
        meta: { appType: 'admin' }
      }, {
        path: 'custom-report',
        name: 'CustomReport',
        component: __WEBPACK_IMPORTED_MODULE_52__components_Admin_ReportExport_CustomReport___default.a,
        meta: { appType: 'admin' }
      }, {
        path: 'cross-line-report',
        name: 'CrossLineReport',
        component: __WEBPACK_IMPORTED_MODULE_53__components_Admin_ReportExport_CrossLineReport___default.a,
        meta: { appType: 'admin' }
      }, {
        path: 'shoulder-report',
        name: 'ShoulderReport',
        component: __WEBPACK_IMPORTED_MODULE_54__components_Admin_ReportExport_ShoulderReport___default.a,
        meta: { appType: 'admin' }
      }]
    }, {
      path: 'data-import',
      name: 'DataImport',
      component: __WEBPACK_IMPORTED_MODULE_46__components_Admin_DataImport___default.a,
      redirect: { name: 'DrugImport' },
      meta: { appType: 'admin' },
      children: [{
        path: 'drug-import',
        name: 'DrugImport',
        component: __WEBPACK_IMPORTED_MODULE_47__components_Admin_DataImport_DrugImport___default.a,
        meta: { appType: 'admin' }
      }, {
        path: 'user-import',
        name: 'UserImport',
        component: __WEBPACK_IMPORTED_MODULE_49__components_Admin_DataImport_UserImport___default.a,
        meta: { appType: 'admin' }
      }, {
        path: 'tag-drug-storage-import',
        name: 'TagDrugStorageImport',
        component: __WEBPACK_IMPORTED_MODULE_48__components_Admin_DataImport_TagDrugStorageImport___default.a,
        meta: { appType: 'admin' }
      }]
    }, {
      path: 'system-settings',
      name: 'SystemSettings',
      component: __WEBPACK_IMPORTED_MODULE_61__components_Admin_SystemSettings___default.a,
      redirect: { name: 'DrugSettings' },
      meta: { appType: 'admin' },
      children: [{
        path: 'drug-settings',
        name: 'DrugSettings',
        component: __WEBPACK_IMPORTED_MODULE_62__components_Admin_SystemSettings_DrugSettings___default.a,
        redirect: { name: 'DrugDBSettings' },
        meta: { appType: 'admin' },
        children: [{
          path: 'drug-db-settings',
          name: 'DrugDBSettings',
          component: __WEBPACK_IMPORTED_MODULE_70__components_Admin_SystemSettings_DrugDBSettings___default.a,
          meta: { appType: 'admin' }
        }, {
          path: 'drug-group-settings',
          name: 'DrugGroupSettings',
          component: __WEBPACK_IMPORTED_MODULE_64__components_Admin_SystemSettings_DrugGroupSettings___default.a,
          meta: { appType: 'admin' }
        }, {
          path: 'combo-settings',
          name: 'ComboSettings',
          component: __WEBPACK_IMPORTED_MODULE_69__components_Admin_SystemSettings_ComboSettings___default.a,
          meta: { appType: 'admin' }
        }, {
          path: 'control-drug-settiings',
          name: 'ControlDrugSettings',
          component: __WEBPACK_IMPORTED_MODULE_63__components_Admin_SystemSettings_ControlDrugSettings___default.a,
          meta: { appType: 'admin' }
        }]
      }, {
        path: 'user-settings',
        name: 'UserSettings',
        component: __WEBPACK_IMPORTED_MODULE_68__components_Admin_SystemSettings_UserSettings___default.a,
        meta: { appType: 'admin' }
      }, {
        path: 'user-group-settings',
        name: 'UserGroupSettings',
        component: __WEBPACK_IMPORTED_MODULE_67__components_Admin_SystemSettings_UserGroupSettings___default.a,
        meta: { appType: 'admin' }
      }, {
        path: 'general-settings',
        name: 'GeneralSettings',
        component: __WEBPACK_IMPORTED_MODULE_65__components_Admin_SystemSettings_GeneralSettings___default.a,
        meta: { appType: 'admin' }
      }, {
        path: 'area-settings',
        name: 'AreaSettings',
        component: __WEBPACK_IMPORTED_MODULE_66__components_Admin_SystemSettings_AreaSettings___default.a,
        meta: { appType: 'admin' }
      }, {
        path: 'para-settings',
        name: 'ParaSettings',
        component: __WEBPACK_IMPORTED_MODULE_71__components_Admin_SystemSettings_ParaSettings___default.a,
        meta: { appType: 'admin' }
      }]
    }, {
      path: 'ticket-management',
      name: 'TicketManagement',
      component: __WEBPACK_IMPORTED_MODULE_77__components_Admin_TicketManagement___default.a,
      redirect: { name: 'CarTicketList' },
      meta: { appType: 'admin' },
      children: [{
        path: 'car-ticket-list',
        name: 'CarTicketList',
        component: __WEBPACK_IMPORTED_MODULE_78__components_Admin_TicketManagement_CarTicketList___default.a,
        meta: { appType: 'admin' }
      }, {
        path: 'cross-line-ticket-list',
        name: 'CrossLineTicketList',
        component: __WEBPACK_IMPORTED_MODULE_79__components_Admin_TicketManagement_CrossLineTicketList___default.a,
        meta: { appType: 'admin' }
      }, {
        path: 'shoulder-ticket-list',
        name: 'ShoulderTicketList',
        component: __WEBPACK_IMPORTED_MODULE_80__components_Admin_TicketManagement_ShoulderTicketList___default.a,
        meta: { appType: 'admin' }
      }]
    }, {
      path: 'confirm-management',
      name: 'ConfirmManagement',
      component: __WEBPACK_IMPORTED_MODULE_81__components_Admin_ConfirmManagement___default.a,
      redirect: { name: 'CarConfirmList' },
      meta: { appType: 'admin' },
      children: [{
        path: 'car-confirm-list',
        name: 'CarConfirmList',
        component: __WEBPACK_IMPORTED_MODULE_82__components_Admin_ConfirmManagement_CarConfirmList___default.a,
        meta: { appType: 'admin' }
      }, {
        path: 'cross-line-confirm-list',
        name: 'CrossLineConfirmList',
        component: __WEBPACK_IMPORTED_MODULE_83__components_Admin_ConfirmManagement_CrossLineConfirmList___default.a,
        meta: { appType: 'admin' }
      }, {
        path: 'shoulder-confirm-list',
        name: 'ShoulderConfirmList',
        component: __WEBPACK_IMPORTED_MODULE_84__components_Admin_ConfirmManagement_ShoulderConfirmList___default.a,
        meta: { appType: 'admin' }
      }]
    }]
  }, {
    path: '/dev-panel',
    name: 'DevPanel',
    component: __WEBPACK_IMPORTED_MODULE_85__components_Dev_DevPanel___default.a,
    meta: { appType: 'developer' }
  }]
});

// determine the system type for different router path.
router.beforeEach(function (to, from, next) {
  // setup global loader
  __WEBPACK_IMPORTED_MODULE_86__vuex_store__["a" /* default */].commit('SHOW_LOADER', true);

  // manage the input url
  switch (to.fullPath.split('/')[1]) {
    case 'admin':
      // if user is not logined
      if (__WEBPACK_IMPORTED_MODULE_86__vuex_store__["a" /* default */].state.user.user === null) {
        router.push({ name: 'AdminLogin' });
      } else {
        next();
      }
      break;
    //case 'admin-login':
    case '':
      next();
      break;
    default:
      if (__WEBPACK_IMPORTED_MODULE_86__vuex_store__["a" /* default */].state.user.user === null) {
        router.push({ name: 'AdminLogin' });
      } else {
        next();
      }
  }
});

router.afterEach(function (to, from) {
  __WEBPACK_IMPORTED_MODULE_86__vuex_store__["a" /* default */].commit('SHOW_LOADER', false);
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1092)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(546),
  /* template */
  __webpack_require__(1447),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(686),
  /* template */
  __webpack_require__(1543),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__functions_readCookie__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mutation_types__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__module_user__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__module_drug__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__module_devices__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__module_drugInDevice__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__module_event__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__module_schedule__ = __webpack_require__(719);




var _mutations;


















__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* default */]);

// detecte drawer in errorDevices.
function hasOnlyDrawer(errorDevices) {
  if (errorDevices.length === 1 && errorDevices[0].type === 'drawer') return true;
  return false;
}

// detect box in errorDevices.
function hasBox(errorDevices) {
  for (var i = 0; i < errorDevices.length; i += 1) {
    if (errorDevices[i].type === 'box') return true;
  }
  return false;
}

// filter out force_shutdown system and disabled devices from errorDevices.
function filterErrorDevices(systems, disableDevices, errorDevices) {
  var systemStatus = [];
  var filterDevices = errorDevices;

  // filter out force shutdown system
  if (systems.length > 0) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(systems).forEach(function (sys) {
      systemStatus.push(!sys.force_shutdown);
    });
    filterDevices = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.filter(filterDevices, function (dev) {
      return systemStatus[dev.system];
    });
  }

  // filter out disabled devices.
  if (disableDevices.length > 0) {
    disableDevices.forEach(function (disDev) {
      if (disDev.pos_row === 0) {
        // filter out drawer
        filterDevices = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.reject(filterDevices, { system: disDev.net.system.relative_index - 1, drawerId: disDev.net.row_id });
      }
      filterDevices = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.reject(filterDevices, { system: disDev.net.system.relative_index - 1, drawerId: disDev.net.row_id, col: disDev.relative_col, row: disDev.pos_row });
    });
  }
  return filterDevices;
}

// NOTICE: object would not be detected instaly in vue instace.
var state = {
  progress: [], // progress steps shows on progressbar.vue
  showLogout: false, // show logout button
  showLoader: false, // show global loader
  currentStep: '', // current step in progress
  generalSetting: null, // the settings of this system fetched from backend
  instance: undefined, // axios instance
  expiredDrugCount: 0, //
  modalStatus: { // modalStatus: use for specific modal.
    lowAmount: false,
    lockDevice: false,
    lockDrawer: false,
    medGroupSelect: false
  },
  message: {
    type: '',
    status: false,
    context: '',
    keepOnTop: false,
    showLockDevice: false
  },
  messagePop: false,
  currentApp: {
    name: '',
    cancel: true
  },
  timeoutId: null,
  logoutAccuTime: 0,
  humidity: 0,
  temperature: 0,
  frontendLogined: false,
  loginedUsers: [],
  connectionStatus: null,
  systemLayoutChecked: false,
  disableDevices: [],
  webSocket: null,
  webSocketReady: false,
  cabinetSerials: [],
  fingerprinterStatus: undefined,
  fingerprinterConnected: false,
  checkFingerprinterStatusFn: undefined,
  apps: {
    management: {
      title: '藥物管理',
      functions: {
        schedule: {
          name: '醫囑取藥',
          icon_name: 'calendar-drug.svg',
          url_name: 'schedule',
          privilege: false,
          ready: true
        },
        scheduleReturn: {
          name: '醫囑退藥',
          icon_name: 'calendar-arrow.svg',
          url_name: 'scheduleReturn',
          privilege: true,
          ready: true
        },
        fetchDrug: {
          name: '一般取藥',
          icon_name: 'medical-drug-pill.svg',
          url_name: 'fetchDrug',
          privilege: false,
          ready: true
        },
        returnDrug: {
          name: '一般退藥',
          icon_name: 'back-arrow.svg',
          url_name: 'returnDrug',
          privilege: false,
          ready: true
        },
        refillDrug: {
          name: '補充藥物',
          icon_name: 'medicine-bottle.svg',
          url_name: 'refillDrug',
          privilege: false,
          ready: false
        },
        inventory: {
          name: '盤點藥物',
          icon_name: 'cabinet.svg',
          url_name: 'inventory',
          privilege: false,
          ready: true
        },
        createDrug: {
          name: '新增藥物',
          icon_name: 'add-tool.svg',
          url_name: 'createDrug',
          privilege: false,
          ready: true
        },
        removeDrug: {
          name: '移除藥物',
          icon_name: 'round-delete-button.svg',
          url_name: 'removeDrug',
          privilege: false
        },
        removeOutdatedDrug: {
          name: '移除過期',
          icon_name: 'time-left.svg',
          url_name: 'removeOutdatedDrug',
          privilege: false,
          ready: false
        },
        recycleDrug: {
          name: '回收退藥',
          icon_name: 'recycle.svg',
          url_name: 'recycleDrug',
          privilege: true
        },
        lockBox: {
          name: '藥物保管箱',
          icon_name: 'locked.svg',
          url_name: 'lockBox',
          privilege: false,
          ready: false
        },
        waste: {
          name: '拋棄藥物',
          icon_name: 'garbage.svg',
          url_name: 'waste',
          privilege: true,
          ready: true
        },
        fetchDrugSchedule: {
          name: '批次取藥',
          icon_name: 'drug.svg',
          url_name: 'fetchDrugSchedule',
          privilege: false,
          ready: true
        },
        recycleEmpty: {
          name: '空瓶交換',
          icon_name: 'recycle-vial.svg',
          url_name: 'recycleEmpty',
          privilege: false,
          ready: true
        },
        returnEmpty: {
          name: '退回空瓶',
          icon_name: 'return-vial.svg',
          url_name: 'returnEmpty',
          privilege: true,
          ready: true
        }
      }
    },
    setting: {
      title: '藥櫃設定',
      functions: {
        drugInfo: {
          name: '藥物資訊',
          icon_name: 'information-symbol.svg',
          url_name: 'drugInfo',
          privilege: true,
          ready: true
        },
        userManual: {
          name: '使用者選單',
          icon_name: 'settings-gears.svg',
          url_name: 'userManual',
          privilege: true,
          ready: true
        },
        setReturnBox: {
          name: '設定退藥盒',
          icon_name: 'export.svg',
          url_name: 'setReturnBox',
          privilege: true,
          ready: true
        },
        storageError: {
          name: '存量不符',
          icon_name: 'danger.svg',
          url_name: 'storageError',
          privilege: true,
          ready: false
        },
        drugStorageSummary: {
          name: '藥品統計',
          icon_name: 'result.svg',
          url_name: 'drugStorageSummary',
          privilege: true,
          ready: false
        },
        disabledDevices: {
          name: '待維修藥盒',
          icon_name: 'wrench.svg',
          url_name: 'disabledDevices',
          privilege: false,
          ready: true
        }
        // {
        //   name: '藥物複檢',
        //   icon_name: 'correct.svg',
        //   url_name: 'recheckDrug',
        // },
      }
    }
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["a" /* CREATE_INSTANCE */], function (state) {
  state.instance = __WEBPACK_IMPORTED_MODULE_5_axios___default.a.create({
    baseURL: __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */],
    timeout: 600 * 1000, // timeout for 20 secs
    headers: {
      Authorization: 'Token ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__functions_readCookie__["a" /* default */])('Token')
    }
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["b" /* SET_MESSAGE */], function (state, payload) {
  if (state.message.keepOnTop) {
    console.log('previous message is keepOnTop know, close it first to reset.');
  } else {
    state.message.type = payload.type;
    state.message.status = true;
    state.message.context = payload.context;
    state.message.showUnlock = false;
    state.message.confirm = true;
    state.message.keepOnTop = false;
    state.message.showLockDevice = false;

    // set showUnlock attr.
    if (payload.showUnlock !== undefined) {
      state.message.showUnlock = payload.showUnlock;
    }

    // set confirm attr.
    if (payload.confirm !== undefined) {
      state.message.confirm = payload.confirm;
    }

    // keepOnTop: make sure the message would only be closed by confirm button on message comp.
    if (payload.keepOnTop !== undefined) {
      state.message.keepOnTop = payload.keepOnTop;
    }

    if (payload.showLockDevice !== undefined) {
      state.message.showLockDevice = payload.showLockDevice;
    }
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["c" /* CLOSE_MESSAGE */], function (state, forceClose) {
  if (state.message.keepOnTop && (forceClose === undefined || forceClose === false)) {
    console.log('previous message is keepOnTop know, close it first to reset.');
  } else {
    state.message.status = false;
    state.message.context = '';
    state.message.keepOnTop = false;
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["d" /* MESSAGE_POPED */], function (state, status) {
  state.messagePop = status;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["e" /* SET_APP */], function (state, appName) {
  state.currentApp.name = appName;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["f" /* SET_APP_CANCEL_STATUS */], function (state, status) {
  state.currentApp.cancel = status;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["g" /* SET_PROGRESS */], function (state, progress) {
  state.progress = progress;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["h" /* SET_CURRENT_STEP */], function (state, step) {
  state.currentStep = step;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["i" /* SHOW_MODAL */], function (state, payload) {
  state.modalStatus[payload.modalName] = payload.status;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["j" /* FRONETEND_PANEL_USER_LOGINED */], function (state, loginedUsers) {
  state.loginedUsers = loginedUsers;
  if (state.loginedUsers.length === 0) {
    state.frontendLogined = false;
  } else {
    state.frontendLogined = true;
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["k" /* SHOW_LOGOUT */], function (state, status) {
  state.showLogout = status;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_10__mutation_types__["l" /* SHOW_LOADER */], function (state, status) {
  state.showLoader = status;
}), _mutations);

var actions = {
  // flow of init system:
  // send reset command -> get serial -> send checkout layout command -> get layout data -> send layout data -> success
  // -> ask for system id -> get system id -> request system info.
  webSocketConnect: function webSocketConnect(_ref) {
    var state = _ref.state,
        commit = _ref.commit,
        getters = _ref.getters,
        dispatch = _ref.dispatch;

    if (state.webSocket === null) {
      state.webSocket = new WebSocket(__WEBPACK_IMPORTED_MODULE_7__config__["e" /* TaskWebSocketServer */]);
      // check cabinet series
      state.webSocket.onopen = function (e) {
        console.debug('socket connected.');
        state.webSocketReady = true;
        // dispatch('resetAndGetLocalSerialNumber');
      };

      state.webSocket.onmessage = function (e) {
        // console.debug(e.data);
        try {
          var rawData = JSON.parse(e.data);
          if (rawData.task_status === 'failed') {
            if (rawData.command === 'reset' || rawData.command === 'get_layout' || rawData.command === 'check_status') {
              commit('SET_MESSAGE', { type: 'error', context: '連線有誤，重新嘗試中', confirm: false });
            }
          }
          if (rawData.task_status === 'success') {
            var resultData = rawData.result_data;
            switch (rawData.command) {
              case 'reset':
                {
                  if (state.message.context === '連線有誤，重新嘗試中') commit('CLOSE_MESSAGE');
                  // state.connectionStatus = true;
                  state.cabinetSerials = resultData.cab_serials;
                  dispatch('sendScanLocalLayoutCommand');
                  break;
                }
              case 'get_layout':
                {
                  if (state.message.context === '連線有誤，重新嘗試中') commit('CLOSE_MESSAGE');
                  __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */] + '/adc-control/consumer_result/', {
                    command: 'get_layout',
                    data: resultData.layout_data
                  }).then(function (res) {
                    if (res.status === 200) {
                      dispatch('initSystem');
                      state.systemLayoutChecked = true;
                    }
                  });
                  break;
                }
              case 'check_status':
                {
                  if (state.message.context === '連線有誤，重新嘗試中') commit('CLOSE_MESSAGE');
                  state.device.errorDevices = filterErrorDevices(getters.systems, state.disableDevices, resultData.data);
                  var env = resultData.env;
                  state.humidity = env.humidity;
                  state.temperature = env.temperature;
                  break;
                }
              case 'capture_finger':
                {
                  if (state.checkFingerprinterStatusFn === undefined) {
                    state.checkFingerprinterStatusFn = setInterval(function () {
                      dispatch('sendCheckFingerPrinterStatusCommand');
                    }, 300);
                  }
                  break;
                }
              case 'check_fingerprinter_status':
                {
                  var status = resultData.status;
                  state.fingerprinterStatus = status;
                  if (rawData.task_status === 'failed') {
                    state.fingerprinterConnected = false;
                  }

                  if (rawData.task_status === 'success') {
                    state.fingerprinterConnected = true;
                  }

                  if (status === 'finger_captured') {
                    clearInterval(state.checkFingerprinterStatusFn);
                    state.checkFingerprinterStatusFn = undefined;
                    dispatch('sendGetFingerFeatureCommand');
                  }
                  if (status === 'standby') {
                    clearInterval(state.checkFingerprinterStatusFn);
                    state.checkFingerprinterStatusFn = undefined;
                  }
                  break;
                }
              case 'get_finger_feature':
                {
                  if (resultData.feature !== '') {
                    state.user.fingerprint = resultData.feature;
                  }
                  break;
                }
              case 'cancel_capture':
                {
                  clearInterval(state.checkFingerprinterStatusFn);
                  state.checkFingerprinterStatusFn = undefined;
                  break;
                }
              default:
                {
                  console.warn('command not handled.', rawData);
                }
            }
          }
        } catch (err) {
          console.warn(err);
        }
      };
    }
  },
  submitCommand: function submitCommand(_ref2, payload) {
    var state = _ref2.state;

    var data = new FormData();
    if (payload.command) data.append('command', payload.command);
    if (payload.appendData) {
      data.append('append_data', payload.appendData);
    } else {
      data.append('append_data', '');
    }
    fetch(__WEBPACK_IMPORTED_MODULE_7__config__["f" /* commandSocketServer */], {
      method: 'POST',
      mode: 'no-cors',
      body: data
    });
  },
  getStorageError: function getStorageError(_ref3) {
    var state = _ref3.state;

    state.apps.setting.functions.storageError.ready = false;
    return state.instance.get('/api/event/', {
      params: {
        event: 'STORAGE_ERROR',
        system: state.device.systemId,
        drug_storage__isnull: false,
        checked: 'false'
      }
    }).then(function (res) {
      res.data.results.forEach(function (item) {
        item.selected = false;
        item.device = state.device.allDevices[item.device.id];
      });
      state.drugInDevice.storageError = res.data.results;
      state.drugInDevice.storageErrorCount = res.data.total;
      state.apps.setting.functions.storageError.ready = true;
    });
  },

  // get the content of external device.
  getExternalDevice: function getExternalDevice(_ref4) {
    var state = _ref4.state;

    return state.instance.get('/api/external-device/').then(function (res) {
      state.externalCmpn = res.data[0];
    });
  },
  getDisabledDevices: function getDisabledDevices(_ref5) {
    var state = _ref5.state;

    // check whether disabled devices exists.
    state.apps.setting.functions.disabledDevices.privilege = false;
    return state.instance.get('/api/device/', {
      params: {
        net__system__status: 'Ready',
        net__system: state.device.systemId,
        error: true
      }
    }).then(function (res) {
      if (res.data.results.length > 0) {
        state.apps.setting.functions.disabledDevices.privilege = true;
      }
      state.disableDevices = res.data.results;
    });
  },
  initSystemInfo: function initSystemInfo(_ref6) {
    var dispatch = _ref6.dispatch,
        commit = _ref6.commit,
        state = _ref6.state;

    commit('CREATE_INSTANCE');
    var promise = [];
    promise.push(dispatch('getSystemInfo'));
    promise.push(dispatch('getDrugInDevices'));
    promise.push(dispatch('getLowStockDrugInDevice'));
    promise.push(dispatch('getDisabledDevices'));
    promise.push(dispatch('getStorageError'));
    promise.push(dispatch('getExternalDevice'));
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promise);
  },
  resetAll: function resetAll(_ref7) {
    var commit = _ref7.commit;

    commit('RESET_DEVICES_MODULE');
    commit('RESET_EVENT_MODULE');
    commit('RESET_DRUG_IN_DEVICE_MODULE');
    commit('RESET_DRUG_MODULE');
    commit('RESET_SCHEDULE');
  },
  resetCabinet: function resetCabinet() {
    return state.instance.post('/adc-control/reset-cabinet/').then(function (res) {
      console.log('reset cabinet');
      // console.log(process);
    });
  },
  setLogoutTimeout: function setLogoutTimeout(_ref8) {
    var state = _ref8.state,
        commit = _ref8.commit;

    // console.log('counting up timer for logout');
    state.timeoutId = setInterval(function () {
      state.logoutAccuTime += 1;
    }, 1000);
  },
  removeLogoutTimeout: function removeLogoutTimeout(_ref9) {
    var state = _ref9.state,
        commit = _ref9.commit;

    // console.log('clear timer for logout');
    clearInterval(state.timeoutId);
    state.logoutAccuTime = 0;
  }
};

// getters should be refracted first
var getters = {
  instance: function instance(state, getters) {
    return state.instance;
  },
  modalStatus: function modalStatus(state, getters) {
    return state.modalStatus;
  },
  frontendLogined: function frontendLogined(state, getters) {
    return state.frontendLogined;
  },
  loginedUsers: function loginedUsers(state, getters) {
    return state.loginedUsers;
  },
  connectionStatus: function connectionStatus(state) {
    return state.connectionStatus;
  },
  disableDevices: function disableDevices(state) {
    return state.disableDevices;
  },
  messageStatus: function messageStatus(state) {
    return state.message.status;
  }
};

var store = new __WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* default */].Store({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
  plugins: [
    // createLogger(),
  ],
  modules: {
    user: __WEBPACK_IMPORTED_MODULE_11__module_user__["a" /* default */],
    drug: __WEBPACK_IMPORTED_MODULE_12__module_drug__["a" /* default */],
    device: __WEBPACK_IMPORTED_MODULE_13__module_devices__["a" /* default */],
    drugInDevice: __WEBPACK_IMPORTED_MODULE_14__module_drugInDevice__["a" /* default */],
    event: __WEBPACK_IMPORTED_MODULE_15__module_event__["a" /* default */],
    schedule: __WEBPACK_IMPORTED_MODULE_16__module_schedule__["a" /* default */]
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1128)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(513),
  /* template */
  __webpack_require__(1510),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(614),
  /* template */
  __webpack_require__(1387),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(644),
  /* template */
  __webpack_require__(1500),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1153)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(668),
  /* template */
  __webpack_require__(1547),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(673),
  /* template */
  __webpack_require__(1411),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1077)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(679),
  /* template */
  __webpack_require__(1418),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1140)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(690),
  /* template */
  __webpack_require__(1526),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9704d750",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1107)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(694),
  /* template */
  __webpack_require__(1472),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1127)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(703),
  /* template */
  __webpack_require__(1509),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(706),
  /* template */
  __webpack_require__(1361),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1048)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(710),
  /* template */
  __webpack_require__(1373),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1113)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(711),
  /* template */
  __webpack_require__(1482),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1143)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(517),
  /* template */
  __webpack_require__(1533),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'ClipLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '35px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size,
        width: this.size,
        borderWidth: '2px',
        borderStyle: 'solid',
        borderColor: this.color + ' ' + this.color + ' transparent',
        borderRadius: this.radius,
        background: 'transparent'
      };
    }
  }
});

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    fields: {
      type: Array,
      required: true
    },
    loadOnStart: {
      type: Boolean,
      default: true
    },
    apiUrl: {
      type: String,
      default: ''
    },
    httpMethod: {
      type: String,
      default: 'get',
      validator: function validator(value) {
        return ['get', 'post'].indexOf(value) > -1;
      }
    },
    reactiveApiUrl: {
      type: Boolean,
      default: true
    },
    apiMode: {
      type: Boolean,
      default: true
    },
    data: {
      type: [Array, Object],
      default: null
    },
    dataTotal: {
      type: Number,
      default: 0
    },
    dataManager: {
      type: Function,
      default: null
    },
    dataPath: {
      type: String,
      default: 'data'
    },
    paginationPath: {
      type: [String],
      default: 'links.pagination'
    },
    queryParams: {
      type: [Object, Function],
      default: function _default() {
        return {
          sort: 'sort',
          page: 'page',
          perPage: 'per_page'
        };
      }
    },
    appendParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    httpOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    httpFetch: {
      type: Function,
      default: null
    },
    perPage: {
      type: Number,
      default: 10
    },
    initialPage: {
      type: Number,
      default: 1
    },
    sortOrder: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    multiSort: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    tableHeight: {
      type: String,
      default: null
    },

    multiSortKey: {
      type: String,
      default: 'alt'
    },

    rowClassCallback: {
      type: [String, Function],
      default: ''
    },
    rowClass: {
      type: [String, Function],
      default: ''
    },
    detailRowComponent: {
      type: String,
      default: ''
    },
    detailRowTransition: {
      type: String,
      default: ''
    },
    trackBy: {
      type: String,
      default: 'id'
    },
    css: {
      type: Object,
      default: function _default() {
        return {
          tableClass: 'ui blue selectable celled stackable attached table',
          loadingClass: 'loading',
          ascendingIcon: 'blue chevron up icon',
          descendingIcon: 'blue chevron down icon',
          ascendingClass: 'sorted-asc',
          descendingClass: 'sorted-desc',
          sortableIcon: '',
          detailRowClass: 'vuetable-detail-row',
          handleIcon: 'grey sidebar icon',
          tableBodyClass: 'vuetable-semantic-no-top vuetable-fixed-layout',
          tableHeaderClass: 'vuetable-fixed-layout'
        };
      }
    },
    minRows: {
      type: Number,
      default: 0
    },
    silent: {
      type: Boolean,
      default: false
    },
    noDataTemplate: {
      type: String,
      default: function _default() {
        return 'No Data Available';
      }
    },
    showSortIcons: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      eventPrefix: 'vuetable:',
      tableFields: [],
      tableData: null,
      tablePagination: null,
      currentPage: this.initialPage,
      selectedTo: [],
      visibleDetailRows: [],
      lastScrollPosition: 0,
      scrollBarWidth: '17px',
      scrollVisible: false
    };
  },
  mounted: function mounted() {
    this.normalizeFields();
    this.normalizeSortOrder();
    if (this.isFixedHeader) {
      this.scrollBarWidth = this.getScrollBarWidth() + 'px';
    }
    this.$nextTick(function () {
      this.fireEvent('initialized', this.tableFields);
    });

    if (this.loadOnStart) {
      this.loadData();
    }
    if (this.isFixedHeader) {
      var elem = this.$el.getElementsByClassName('vuetable-body-wrapper')[0];
      if (elem != null) {
        elem.addEventListener('scroll', this.handleScroll);
      }
    }
  },
  destroyed: function destroyed() {
    var elem = this.$el.getElementsByClassName('vuetable-body-wrapper')[0];
    if (elem != null) {
      elem.removeEventListener('scroll', this.handleScroll);
    }
  },

  computed: {
    version: function version() {
      return VERSION;
    },
    useDetailRow: function useDetailRow() {
      if (this.tableData && this.tableData[0] && this.detailRowComponent !== '' && typeof this.tableData[0][this.trackBy] === 'undefined') {
        this.warn('You need to define unique row identifier in order for detail-row feature to work. Use `track-by` prop to define one!');
        return false;
      }

      return this.detailRowComponent !== '';
    },
    countVisibleFields: function countVisibleFields() {
      return this.tableFields.filter(function (field) {
        return field.visible;
      }).length;
    },
    countTableData: function countTableData() {
      if (this.tableData === null) {
        return 0;
      }
      return this.tableData.length;
    },
    displayEmptyDataRow: function displayEmptyDataRow() {
      return this.countTableData === 0 && this.noDataTemplate.length > 0;
    },
    lessThanMinRows: function lessThanMinRows() {
      if (this.tableData === null || this.tableData.length === 0) {
        return true;
      }
      return this.tableData.length < this.minRows;
    },
    blankRows: function blankRows() {
      if (this.tableData === null || this.tableData.length === 0) {
        return this.minRows;
      }
      if (this.tableData.length >= this.minRows) {
        return 0;
      }

      return this.minRows - this.tableData.length;
    },
    isApiMode: function isApiMode() {
      return this.apiMode;
    },
    isDataMode: function isDataMode() {
      return !this.apiMode;
    },
    isFixedHeader: function isFixedHeader() {
      return this.tableHeight != null;
    }
  },
  methods: {
    getScrollBarWidth: function getScrollBarWidth() {
      var outer = document.createElement('div');
      var inner = document.createElement('div');

      outer.style.visibility = 'hidden';
      outer.style.width = '100px';

      inner.style.width = '100%';

      outer.appendChild(inner);
      document.body.appendChild(outer);

      var widthWithoutScrollbar = outer.offsetWidth;

      outer.style.overflow = 'scroll';

      var widthWithScrollbar = inner.offsetWidth;

      document.body.removeChild(outer);

      return widthWithoutScrollbar - widthWithScrollbar;
    },
    handleScroll: function handleScroll(e) {
      var horizontal = e.currentTarget.scrollLeft;
      if (horizontal != this.lastScrollPosition) {
        var header = this.$el.getElementsByClassName('vuetable-head-wrapper')[0];
        if (header != null) {
          header.scrollLeft = horizontal;
        }
        this.lastScrollPosition = horizontal;
      }
    },
    normalizeFields: function normalizeFields() {
      if (typeof this.fields === 'undefined') {
        this.warn('You need to provide "fields" prop.');
        return;
      }

      this.tableFields = [];
      var self = this;
      var obj = void 0;
      this.fields.forEach(function (field, i) {
        if (typeof field === 'string') {
          obj = {
            name: field,
            title: self.setTitle(field),
            titleClass: '',
            dataClass: '',
            callback: null,
            visible: true
          };
        } else {
          obj = {
            name: field.name,
            width: field.width,
            title: field.title === undefined ? self.setTitle(field.name) : field.title,
            sortField: field.sortField,
            titleClass: field.titleClass === undefined ? '' : field.titleClass,
            dataClass: field.dataClass === undefined ? '' : field.dataClass,
            callback: field.callback === undefined ? '' : field.callback,
            visible: field.visible === undefined ? true : field.visible
          };
        }
        self.tableFields.push(obj);
      });
    },
    setData: function setData(data) {
      if (data === null || typeof data === 'undefined') return;

      this.fireEvent('loading');

      if (Array.isArray(data)) {
        this.tableData = data;
        this.fireEvent('loaded');
        return;
      }

      this.tableData = this.getObjectValue(data, this.dataPath, null);
      this.tablePagination = this.getObjectValue(data, this.paginationPath, null);

      this.$nextTick(function () {
        this.fixHeader();
        this.fireEvent('pagination-data', this.tablePagination);
        this.fireEvent('loaded');
      });
    },
    setTitle: function setTitle(str) {
      if (this.isSpecialField(str)) {
        return '';
      }

      return this.titleCase(str);
    },
    getTitle: function getTitle(field) {
      if (typeof field.title === 'function') return field.title();

      return typeof field.title === 'undefined' ? field.name.replace('.', ' ') : field.title;
    },
    renderTitle: function renderTitle(field) {
      var title = this.getTitle(field);

      if (title.length > 0 && this.isInCurrentSortGroup(field) || this.hasSortableIcon(field)) {
        var style = 'opacity:' + this.sortIconOpacity(field) + ';position:relative;float:right';
        var iconTag = this.showSortIcons ? this.renderIconTag(['sort-icon', this.sortIcon(field)], 'style="' + style + '"') : '';
        return title + ' ' + iconTag;
      }

      return title;
    },
    renderSequence: function renderSequence(index) {
      return this.tablePagination ? this.tablePagination.from + index : index;
    },
    renderNormalField: function renderNormalField(field, item) {
      return this.hasCallback(field) ? this.callCallback(field, item) : this.getObjectValue(item, field.name, '');
    },
    isSpecialField: function isSpecialField(fieldName) {
      return fieldName.slice(0, 2) === '__';
    },
    titleCase: function titleCase(str) {
      return str.replace(/\w+/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    camelCase: function camelCase(str) {
      var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '_';

      var self = this;
      return str.split(delimiter).map(function (item) {
        return self.titleCase(item);
      }).join('');
    },
    notIn: function notIn(str, arr) {
      return arr.indexOf(str) === -1;
    },
    loadData: function loadData() {
      var success = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.loadSuccess;
      var failed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.loadFailed;

      if (this.isDataMode) {
        this.callDataManager();
        return;
      }

      this.fireEvent('loading');

      this.httpOptions['params'] = this.getAppendParams(this.getAllQueryParams());

      return this.fetch(this.apiUrl, this.httpOptions).then(success, failed).catch(function () {
        return failed();
      });
    },
    fetch: function fetch(apiUrl, httpOptions) {
      return this.httpFetch ? this.httpFetch(apiUrl, httpOptions) : __WEBPACK_IMPORTED_MODULE_1_axios___default.a[this.httpMethod](apiUrl, httpOptions);
    },
    loadSuccess: function loadSuccess(response) {
      this.fireEvent('load-success', response);

      var body = this.transform(response.data);

      this.tableData = this.getObjectValue(body, this.dataPath, null);
      this.tablePagination = this.getObjectValue(body, this.paginationPath, null);

      if (this.tablePagination === null) {
        this.warn('vuetable: pagination-path "' + this.paginationPath + '" not found. ' + 'It looks like the data returned from the sever does not have pagination information ' + "or you may have set it incorrectly.\n" + 'You can explicitly suppress this warning by setting pagination-path="".');
      }

      this.$nextTick(function () {
        this.fixHeader();
        this.fireEvent('pagination-data', this.tablePagination);
        this.fireEvent('loaded');
      });
    },
    fixHeader: function fixHeader() {
      if (!this.isFixedHeader) {
        return;
      }

      var elem = this.$el.getElementsByClassName('vuetable-body-wrapper')[0];
      if (elem != null) {
        if (elem.scrollHeight > elem.clientHeight) {
          this.scrollVisible = true;
        } else {
          this.scrollVisible = false;
        }
      }
    },
    loadFailed: function loadFailed(response) {
      console.error('load-error', response);
      this.fireEvent('load-error', response);
      this.fireEvent('loaded');
    },
    transform: function transform(data) {
      var func = 'transform';

      if (this.parentFunctionExists(func)) {
        return this.$parent[func].call(this.$parent, data);
      }

      return data;
    },
    parentFunctionExists: function parentFunctionExists(func) {
      return func !== '' && typeof this.$parent[func] === 'function';
    },
    callParentFunction: function callParentFunction(func, args) {
      var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (this.parentFunctionExists(func)) {
        return this.$parent[func].call(this.$parent, args);
      }

      return defaultValue;
    },
    fireEvent: function fireEvent(eventName, args) {
      this.$emit(this.eventPrefix + eventName, args);
    },
    warn: function warn(msg) {
      if (!this.silent) {
        console.warn(msg);
      }
    },
    getAllQueryParams: function getAllQueryParams() {
      var params = {};

      if (typeof this.queryParams === 'function') {
        params = this.queryParams(this.sortOrder, this.currentPage, this.perPage);
        return (typeof params === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(params)) !== 'object' ? {} : params;
      }

      params[this.queryParams.sort] = this.getSortParam();
      params[this.queryParams.page] = this.currentPage;
      params[this.queryParams.perPage] = this.perPage;

      return params;
    },
    getSortParam: function getSortParam() {
      if (!this.sortOrder || this.sortOrder.field == '') {
        return '';
      }

      if (typeof this.$parent['getSortParam'] === 'function') {
        return this.$parent['getSortParam'].call(this.$parent, this.sortOrder);
      }

      return this.getDefaultSortParam();
    },
    getDefaultSortParam: function getDefaultSortParam() {
      var result = '';

      for (var i = 0; i < this.sortOrder.length; i++) {
        var fieldName = typeof this.sortOrder[i].sortField === 'undefined' ? this.sortOrder[i].field : this.sortOrder[i].sortField;

        result += fieldName + '|' + this.sortOrder[i].direction + (i + 1 < this.sortOrder.length ? ',' : '');
      }
      return result;
    },
    getAppendParams: function getAppendParams(params) {
      for (var x in this.appendParams) {
        params[x] = this.appendParams[x];
      }

      return params;
    },
    extractName: function extractName(string) {
      return string.split(':')[0].trim();
    },
    extractArgs: function extractArgs(string) {
      return string.split(':')[1];
    },
    isSortable: function isSortable(field) {
      return !(typeof field.sortField === 'undefined');
    },
    isInCurrentSortGroup: function isInCurrentSortGroup(field) {
      return this.currentSortOrderPosition(field) !== false;
    },
    hasSortableIcon: function hasSortableIcon(field) {
      return this.isSortable(field) && this.css.sortableIcon != '';
    },
    currentSortOrderPosition: function currentSortOrderPosition(field) {
      if (!this.isSortable(field)) {
        return false;
      }

      for (var i = 0; i < this.sortOrder.length; i++) {
        if (this.fieldIsInSortOrderPosition(field, i)) {
          return i;
        }
      }

      return false;
    },
    fieldIsInSortOrderPosition: function fieldIsInSortOrderPosition(field, i) {
      return this.sortOrder[i].field === field.name && this.sortOrder[i].sortField === field.sortField;
    },
    orderBy: function orderBy(field, event) {
      if (!this.isSortable(field)) return;

      var key = this.multiSortKey.toLowerCase() + 'Key';

      if (this.multiSort && event[key]) {
        this.multiColumnSort(field);
      } else {
        this.singleColumnSort(field);
      }

      this.currentPage = 1;
      if (this.apiMode || this.dataManager) {
        this.loadData();
      }
    },
    multiColumnSort: function multiColumnSort(field) {
      var i = this.currentSortOrderPosition(field);

      if (i === false) {
        this.sortOrder.push({
          field: field.name,
          sortField: field.sortField,
          direction: 'asc'
        });
      } else {
        if (this.sortOrder[i].direction === 'asc') {
          this.sortOrder[i].direction = 'desc';
        } else {
          this.sortOrder.splice(i, 1);
        }
      }
    },
    singleColumnSort: function singleColumnSort(field) {
      if (this.sortOrder.length === 0) {
        this.clearSortOrder();
      }

      this.sortOrder.splice(1);

      if (this.fieldIsInSortOrderPosition(field, 0)) {
        this.sortOrder[0].direction = this.sortOrder[0].direction === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortOrder[0].direction = 'asc';
      }
      this.sortOrder[0].field = field.name;
      this.sortOrder[0].sortField = field.sortField;
    },
    clearSortOrder: function clearSortOrder() {
      this.sortOrder.push({
        field: '',
        sortField: '',
        direction: 'asc'
      });
    },
    sortClass: function sortClass(field) {
      var cls = '';
      var i = this.currentSortOrderPosition(field);

      if (i !== false) {
        cls = this.sortOrder[i].direction == 'asc' ? this.css.ascendingClass : this.css.descendingClass;
      }

      return cls;
    },
    sortIcon: function sortIcon(field) {
      var cls = this.css.sortableIcon;
      var i = this.currentSortOrderPosition(field);

      if (i !== false) {
        cls = this.sortOrder[i].direction == 'asc' ? this.css.ascendingIcon : this.css.descendingIcon;
      }

      return cls;
    },
    sortIconOpacity: function sortIconOpacity(field) {
      var max = 1.0,
          min = 0.3,
          step = 0.3;

      var count = this.sortOrder.length;
      var current = this.currentSortOrderPosition(field);

      if (max - count * step < min) {
        step = (max - min) / (count - 1);
      }

      var opacity = max - current * step;

      return opacity;
    },
    hasCallback: function hasCallback(item) {
      return item.callback ? true : false;
    },
    callCallback: function callCallback(field, item) {
      if (!this.hasCallback(field)) return;

      if (typeof field.callback == 'function') {
        return field.callback(this.getObjectValue(item, field.name));
      }

      var args = field.callback.split('|');
      var func = args.shift();

      if (typeof this.$parent[func] === 'function') {
        var value = this.getObjectValue(item, field.name);

        return args.length > 0 ? this.$parent[func].apply(this.$parent, [value].concat(args)) : this.$parent[func].call(this.$parent, value);
      }

      return null;
    },
    getObjectValue: function getObjectValue(object, path, defaultValue) {
      defaultValue = typeof defaultValue === 'undefined' ? null : defaultValue;

      var obj = object;
      if (path.trim() != '') {
        var keys = path.split('.');
        keys.forEach(function (key) {
          if (obj !== null && typeof obj[key] !== 'undefined' && obj[key] !== null) {
            obj = obj[key];
          } else {
            obj = defaultValue;
            return;
          }
        });
      }
      return obj;
    },
    toggleCheckbox: function toggleCheckbox(dataItem, fieldName, event) {
      var isChecked = event.target.checked;
      var idColumn = this.trackBy;

      if (dataItem[idColumn] === undefined) {
        this.warn('__checkbox field: The "' + this.trackBy + '" field does not exist! Make sure the field you specify in "track-by" prop does exist.');
        return;
      }

      var key = dataItem[idColumn];
      if (isChecked) {
        this.selectId(key);
      } else {
        this.unselectId(key);
      }
      this.$emit('vuetable:checkbox-toggled', isChecked, dataItem);
    },
    selectId: function selectId(key) {
      if (!this.isSelectedRow(key)) {
        this.selectedTo.push(key);
      }
    },
    unselectId: function unselectId(key) {
      this.selectedTo = this.selectedTo.filter(function (item) {
        return item !== key;
      });
    },
    isSelectedRow: function isSelectedRow(key) {
      return this.selectedTo.indexOf(key) >= 0;
    },
    rowSelected: function rowSelected(dataItem, fieldName) {
      var idColumn = this.trackBy;
      var key = dataItem[idColumn];

      return this.isSelectedRow(key);
    },
    checkCheckboxesState: function checkCheckboxesState(fieldName) {
      if (!this.tableData) return;

      var self = this;
      var idColumn = this.trackBy;
      var selector = 'th.vuetable-th-checkbox-' + idColumn + ' input[type=checkbox]';
      var els = document.querySelectorAll(selector);

      if (els.forEach === undefined) els.forEach = function (cb) {
        [].forEach.call(els, cb);
      };

      var selected = this.tableData.filter(function (item) {
        return self.selectedTo.indexOf(item[idColumn]) >= 0;
      });

      if (selected.length <= 0) {
        els.forEach(function (el) {
          el.indeterminate = false;
        });
        return false;
      } else if (selected.length < this.perPage) {
          els.forEach(function (el) {
            el.indeterminate = true;
          });
          return true;
        } else {
            els.forEach(function (el) {
              el.indeterminate = false;
            });
            return true;
          }
    },
    toggleAllCheckboxes: function toggleAllCheckboxes(fieldName, event) {
      var self = this;
      var isChecked = event.target.checked;
      var idColumn = this.trackBy;

      if (isChecked) {
        this.tableData.forEach(function (dataItem) {
          self.selectId(dataItem[idColumn]);
        });
      } else {
        this.tableData.forEach(function (dataItem) {
          self.unselectId(dataItem[idColumn]);
        });
      }
      this.$emit('vuetable:checkbox-toggled-all', isChecked);
    },
    gotoPreviousPage: function gotoPreviousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.loadData();
      }
    },
    gotoNextPage: function gotoNextPage() {
      if (this.currentPage < this.tablePagination.last_page) {
        this.currentPage++;
        this.loadData();
      }
    },
    gotoPage: function gotoPage(page) {
      if (page != this.currentPage && page > 0 && page <= this.tablePagination.last_page) {
        this.currentPage = page;
        this.loadData();
      }
    },
    isVisibleDetailRow: function isVisibleDetailRow(rowId) {
      return this.visibleDetailRows.indexOf(rowId) >= 0;
    },
    showDetailRow: function showDetailRow(rowId) {
      if (!this.isVisibleDetailRow(rowId)) {
        this.visibleDetailRows.push(rowId);
      }
    },
    hideDetailRow: function hideDetailRow(rowId) {
      if (this.isVisibleDetailRow(rowId)) {
        this.visibleDetailRows.splice(this.visibleDetailRows.indexOf(rowId), 1);
      }
    },
    toggleDetailRow: function toggleDetailRow(rowId) {
      if (this.isVisibleDetailRow(rowId)) {
        this.hideDetailRow(rowId);
      } else {
        this.showDetailRow(rowId);
      }
    },
    showField: function showField(index) {
      if (index < 0 || index > this.tableFields.length) return;

      this.tableFields[index].visible = true;
    },
    hideField: function hideField(index) {
      if (index < 0 || index > this.tableFields.length) return;

      this.tableFields[index].visible = false;
    },
    toggleField: function toggleField(index) {
      if (index < 0 || index > this.tableFields.length) return;

      this.tableFields[index].visible = !this.tableFields[index].visible;
    },
    renderIconTag: function renderIconTag(classes) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      return typeof this.css.renderIcon === 'undefined' ? '<i class="' + classes.join(' ') + '" ' + options + '></i>' : this.css.renderIcon(classes, options);
    },
    makePagination: function makePagination() {
      var total = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var currentPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var pagination = {};
      total = total === null ? this.dataTotal : total;
      perPage = perPage === null ? this.perPage : perPage;
      currentPage = currentPage === null ? this.currentPage : currentPage;

      return {
        'total': total,
        'per_page': perPage,
        'current_page': currentPage,
        'last_page': Math.ceil(total / perPage) || 0,
        'next_page_url': '',
        'prev_page_url': '',
        'from': (currentPage - 1) * perPage + 1,
        'to': Math.min(currentPage * perPage, total)
      };
    },
    normalizeSortOrder: function normalizeSortOrder() {
      this.sortOrder.forEach(function (item) {
        item.sortField = item.sortField || item.field;
      });
    },
    callDataManager: function callDataManager() {
      if (this.dataManager === null && this.data === null) return;

      if (Array.isArray(this.data)) {
        return this.setData(this.data);
      }

      this.normalizeSortOrder();

      return this.setData(this.dataManager ? this.dataManager(this.sortOrder, this.makePagination()) : this.data);
    },
    onRowClass: function onRowClass(dataItem, index) {
      if (this.rowClassCallback !== '') {
        this.warn('"row-class-callback" prop is deprecated, please use "row-class" prop instead.');
        return;
      }

      if (typeof this.rowClass === 'function') {
        return this.rowClass(dataItem, index);
      }

      return this.rowClass;
    },
    onRowChanged: function onRowChanged(dataItem) {
      this.fireEvent('row-changed', dataItem);
      return true;
    },
    onRowClicked: function onRowClicked(dataItem, event) {
      this.$emit(this.eventPrefix + 'row-clicked', dataItem, event);
      return true;
    },
    onRowDoubleClicked: function onRowDoubleClicked(dataItem, event) {
      this.$emit(this.eventPrefix + 'row-dblclicked', dataItem, event);
    },
    onDetailRowClick: function onDetailRowClick(dataItem, event) {
      this.$emit(this.eventPrefix + 'detail-row-clicked', dataItem, event);
    },
    onCellClicked: function onCellClicked(dataItem, field, event) {
      this.$emit(this.eventPrefix + 'cell-clicked', dataItem, field, event);
    },
    onCellDoubleClicked: function onCellDoubleClicked(dataItem, field, event) {
      this.$emit(this.eventPrefix + 'cell-dblclicked', dataItem, field, event);
    },
    onCellRightClicked: function onCellRightClicked(dataItem, field, event) {
      this.$emit(this.eventPrefix + 'cell-rightclicked', dataItem, field, event);
    },
    changePage: function changePage(page) {
      if (page === 'prev') {
        this.gotoPreviousPage();
      } else if (page === 'next') {
        this.gotoNextPage();
      } else {
        this.gotoPage(page);
      }
    },
    reload: function reload() {
      return this.loadData();
    },
    refresh: function refresh() {
      this.currentPage = 1;
      return this.loadData();
    },
    resetData: function resetData() {
      this.tableData = null;
      this.tablePagination = null;
      this.fireEvent('data-reset');
    }
  },
  watch: {
    'multiSort': function multiSort(newVal, oldVal) {
      if (newVal === false && this.sortOrder.length > 1) {
        this.sortOrder.splice(1);
        this.loadData();
      }
    },
    'apiUrl': function apiUrl(newVal, oldVal) {
      if (this.reactiveApiUrl && newVal !== oldVal) this.refresh();
    },
    'data': function data(newVal, oldVal) {
      this.setData(newVal);
    },
    'tableHeight': function tableHeight(newVal, oldVal) {
      this.fixHeader();
    }
  }
});

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuetablePaginationMixin_vue__ = __webpack_require__(1192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuetablePaginationMixin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__VuetablePaginationMixin_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__VuetablePaginationMixin_vue___default.a]
});

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    css: {
      type: Object,
      default: function _default() {
        return {
          wrapperClass: 'ui right floated pagination menu',
          activeClass: 'active large',
          disabledClass: 'disabled',
          pageClass: 'item',
          linkClass: 'icon item',
          paginationClass: 'ui bottom attached segment grid',
          paginationInfoClass: 'left floated left aligned six wide column',
          dropdownClass: 'ui search dropdown',
          icons: {
            first: 'angle double left icon',
            prev: 'left chevron icon',
            next: 'right chevron icon',
            last: 'angle double right icon'
          }
        };
      }
    },
    onEachSide: {
      type: Number,
      default: function _default() {
        return 2;
      }
    }
  },
  data: function data() {
    return {
      eventPrefix: 'vuetable-pagination:',
      tablePagination: null
    };
  },
  computed: {
    totalPage: function totalPage() {
      return this.tablePagination === null ? 0 : this.tablePagination.last_page;
    },
    isOnFirstPage: function isOnFirstPage() {
      return this.tablePagination === null ? false : this.tablePagination.current_page === 1;
    },
    isOnLastPage: function isOnLastPage() {
      return this.tablePagination === null ? false : this.tablePagination.current_page === this.tablePagination.last_page;
    },
    notEnoughPages: function notEnoughPages() {
      return this.totalPage < this.onEachSide * 2 + 4;
    },
    windowSize: function windowSize() {
      return this.onEachSide * 2 + 1;
    },
    windowStart: function windowStart() {
      if (!this.tablePagination || this.tablePagination.current_page <= this.onEachSide) {
        return 1;
      } else if (this.tablePagination.current_page >= this.totalPage - this.onEachSide) {
        return this.totalPage - this.onEachSide * 2;
      }

      return this.tablePagination.current_page - this.onEachSide;
    }
  },
  methods: {
    loadPage: function loadPage(page) {
      this.$emit(this.eventPrefix + 'change-page', page);
    },
    isCurrentPage: function isCurrentPage(page) {
      return page === this.tablePagination.current_page;
    },
    setPaginationData: function setPaginationData(tablePagination) {
      this.tablePagination = tablePagination;
    },
    resetData: function resetData() {
      this.tablePagination = null;
    }
  }
});

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Message__ = __webpack_require__(1342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_Message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_Loader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//import JQuery from 'jquery';





//const $ = JQuery;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      openPanel: false
    };
  },

  components: {
    Message: __WEBPACK_IMPORTED_MODULE_2__components_common_Message___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_3__components_common_Loader___default.a
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapState */])({
    errorDevices: function errorDevices(state) {
      return state.device.errorDevices;
    },
    currentDevice: function currentDevice(state) {
      return state.device.currentDevice;
    },
    instance: function instance(state) {
      return state.instance;
    },
    user: function user(state) {
      return state.user.user;
    },
    logoutAccuTime: function logoutAccuTime(state) {
      return state.logoutAccuTime;
    },
    connectionStatus: function connectionStatus(state) {
      return state.connectionStatus;
    },
    showLoader: function showLoader(state) {
      return state.showLoader;
    },
    logoutLimitSec: function logoutLimitSec(state) {
      if (state.generalSetting !== null) {
        return state.generalSetting.app_login_timeout * 60;
      }
      return null;
    },
    adminLogoutLimitSec: function adminLogoutLimitSec(state) {
      return 60 * 60;
    }
  }),
  created: function created() {
    var _this = this;

    this.resetTimeout();

    // mouse click, mouse hover, keypress event listener to reset timeout.
    window.addEventListener('click', function () {
      _this.resetTimeout();
    });
    window.addEventListener('mouseover', function () {
      _this.resetTimeout();
    });
    window.addEventListener('keypress', function (event) {
      _this.resetTimeout();
    });

    $(window).on('beforeunload', function () {
      // due to axios can not perform sync request, thus we have to use ajax to perform sync request.
      // after unload, window won't wait async function finish. It will directly shutdown all procedures.
      // which leads to logout api cannot be called before window closed.
      if (_this.$route.meta.appType === 'cabinet') {
        // logout record.
        var drugStorageId = _this.$store.state.drugInDevice.currentDrugInDevice !== null ? _this.$store.state.drugInDevice.currentDrugInDevice.id : undefined;
        $.ajax({
          type: 'POST',
          async: false,
          url: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */] + '/api/event/',
          dataType: 'json',
          data: {
            drugStorage: drugStorageId,
            employee: _this.$store.state.user.user.id,
            event_type: 'LOGOUT'
          }
        });
        // set user offline
        $.ajax({
          type: 'POST',
          async: false, // this is the key!
          url: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */] + '/api/user-offline/',
          dataType: 'json',
          data: { user_id: _this.$store.state.user.user.id }
        });
      }
    });
  },
  destroyed: function destroyed() {
    // this.$store.dispatch('sendCancelFingerCaptureCommand');
  },

  methods: {
    showPanel: function showPanel() {
      this.openPanel = !this.openPanel;
    },
    resetTimeout: function resetTimeout() {
      this.$store.dispatch('removeLogoutTimeout');
      this.$store.dispatch('setLogoutTimeout');
    }
  },
  watch: {
    logoutAccuTime: function logoutAccuTime(val) {
      var _this2 = this;

      // auto logout for cabinet
      if (val >= this.logoutLimitSec) {
        if (this.$route.meta.appType === 'cabinet' && this.$route.name !== 'Login') {
          this.$store.dispatch('setOffline').then(function () {
            _this2.$store.dispatch('logout');
          });
          this.$store.commit('SET_MESSAGE', {
            type: 'success',
            context: '閒置時間過久，系統已自動登出'
          });
          this.$router.push({ name: 'Login' });
        }
      }
      // auto logout for admin
      if (val >= this.adminLogoutLimitSec) {
        if (this.$route.meta.appType === 'admin' && this.$route.name !== 'AdminLogin') {
          this.$store.dispatch('logout');
          this.$store.commit('SET_MESSAGE', {
            type: 'success',
            context: '閒置時間過久，系統已自動登出'
          });
          this.$router.push({ name: 'AdminLogin' });
        }
      }
    },
    connectionStatus: function connectionStatus(val) {
      if (val === 'error') {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '連線失敗，嘗試重新連線中',
          confirm: false
        });
      }
      if (val === 'success') {
        this.$store.commit('CLOSE_MESSAGE');
      }
    },
    errorDevices: function errorDevices(val) {
      if (val.length > 0) {
        this.resetTimeout();
      }
    }
  }
});

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_popper_js__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Admin_LockedMask__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Admin_LockedMask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Admin_LockedMask__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//import $ from 'jquery';




window.$ = $;
window.Popper = __WEBPACK_IMPORTED_MODULE_4_popper_js__["default"];

__webpack_require__(727);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Admin',
  data: function data() {
    return {
      version: __WEBPACK_IMPORTED_MODULE_5__config__["d" /* version */],
      systemType: __WEBPACK_IMPORTED_MODULE_5__config__["b" /* systemType */],
      socket: null,
      pageShouldChecked: false,
      fixedLinkCode4SuperUser: 'B01',
      fixedLinkCodeObj: [],
      department: this.$store.state.user.user.department.name
      //reportExportPrivilege: false,
    };
  },

  components: {
    LockedMask: __WEBPACK_IMPORTED_MODULE_6__Admin_LockedMask___default.a
  },
  methods: {
    getFixedLinkCode: function getFixedLinkCode() {
      var _this = this;

      return this.instance.get('/api/fixed-link-code/').then(function (res) {
        res.data.forEach(function (data) {
          _this.fixedLinkCodeObj[data.fixed_link_code] = data.id;
        });
      });
    },
    logout: function logout() {
      this.$store.dispatch('logout');
      this.$router.push({ name: 'AdminLogin' });
    },
    home: function home() {
      this.$router.push({ name: 'Admin' });
    },
    checkFrontendUserLogined: function checkFrontendUserLogined() {
      var _this2 = this;

      this.instance.get('/api/user/', {
        params: {
          online: true
        }
      }).then(function (res) {
        _this2.$store.commit('FRONETEND_PANEL_USER_LOGINED', res.data.results);
      });
    },
    checkedPath: function checkedPath(route) {
      if (route.path.split('/').includes('report-export')) {
        this.pageShouldChecked = false;
      } else {
        this.pageShouldChecked = true;
      }
    },
    eventNotification: function eventNotification() {
      var _this3 = this;

      this.socket = new WebSocket(__WEBPACK_IMPORTED_MODULE_5__config__["c" /* webSocketServer */] + '/update-drug-storage-signal/');
      this.socket.onopen = function (e) {
        _this3.socket.send(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({ message: 'connected' }));
      };
      this.socket.onmessage = function (e) {
        if (JSON.parse(e.data).message) {
          //const msg = JSON.parse(JSON.parse(e.data).message);
          var msg = JSON.parse(e.data).message;
          console.log(msg);
          if (msg.command === 'drug_storage_updated') {
            _this3.$store.commit('DRUG_STORAGE_EVENT_FIRED', msg.id);
          }
        }
      };
    }
  },
  created: function created() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this4.getFixedLinkCode();

            case 2:
              if (_this4.department == 'Admin') // || this.department=='xx市政府警察局交通警察大隊')
                {
                  //this.reportExportPrivilege = true;
                  console.log('departname:', _this4.department);
                  //await this.getFixedLinkCode();
                  _this4.$store.state.user.user.department.fixed_link_code = _this4.fixedLinkCodeObj[_this4.fixedLinkCode4SuperUser];
                  /*
                  if(this.$store.state.user.user.username=='B01User') {
                    this.$store.state.user.user.department.fixed_link_code = this.fixedLinkCodeObj['B01'];
                  }
                  if(this.$store.state.user.user.username=='B03User') {
                    this.$store.state.user.user.department.fixed_link_code = this.fixedLinkCodeObj['B03']; 
                  }
                  */
                }
              //else
              //  this.reportExportPrivilege = false;
              _this4.$store.commit('CREATE_INSTANCE');
              if (_this4.$store.state.webSocket !== null) {
                _this4.$store.state.webSocket.close();
              }
              //this.eventNotification();
              _this4.checkedPath(_this4.$route);
              console.log('systems', _this4.$store.state.device.systems);

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this4);
    }))();
  },

  computed: {
    user: function user() {
      return this.$store.state.user.user;
    },
    GreetingMsg: function GreetingMsg() {
      var hourNow = __WEBPACK_IMPORTED_MODULE_3_moment___default()().hour();
      if (hourNow >= 5 && hourNow < 11) {
        return '早安';
      }
      if (hourNow >= 11 && hourNow <= 17) {
        return '午安';
      }
      return '晚安';
    },
    frontendLogined: function frontendLogined() {
      return this.$store.getters.frontendLogined;
    },
    route: function route() {
      return this.$route;
    },
    instance: function instance() {
      return this.$store.state.instance;
    },
    serverPrivilege2: function serverPrivilege2() {
      return this.$store.state.user.user.server_privilege2;
    },
    navs: function navs() {
      // lists for navigator
      var data = {
        ADCManagement: {
          name: '車輛查詢',
          url: 'ADCManagement',
          privilege: true,
          child: {
            CarList: {
              name: '區間測速資訊',
              url: 'CarList',
              privilege: true
            },
            CrossLineList: {
              name: '違規停車資訊',
              url: 'CrossLineList',
              privilege: false
            },
            ShoulderList: {
              name: '行駛路肩資訊',
              url: 'ShoulderList',
              privilege: true
            }
          }
        },
        ConfirmManagement: {
          name: '認證查詢',
          url: 'ConfirmManagement',
          privilege: true,
          child: {
            CarConfirmList: {
              name: '區間超速',
              url: 'CarConfirmList',
              privilege: true
            },
            CrossLineConfirmList: {
              name: '違規停車',
              url: 'CrossLineConfirmList',
              privilege: false
            },
            ShoulderConfirmList: {
              name: '行駛路肩',
              url: 'ShoulderConfirmList',
              privilege: true
            }
          }
        },
        TicketManagement: {
          name: '開單查詢',
          url: 'TicketManagement',
          privilege: true,
          child: {
            CarTicketList: {
              name: '區間超速',
              url: 'CarTicketList',
              privilege: true
            },
            CrossLineTicketList: {
              name: '違規停車',
              url: 'CrossLineTicketList',
              privilege: false
            },
            ShoulderTicketList: {
              name: '行駛路肩',
              url: 'ShoulderTicketList',
              privilege: true
            }
          }
        },
        ReportExport: {
          name: '紀錄報表',
          url: 'ReportExport',
          privilege: this.reportExportPrivilege,
          child: {
            NTPLogSummary: {
              name: 'NTP資料報表',
              url: 'NTPLogSummary',
              privilege: true
            },
            OtherPcLogSummary: {
              name: '獨立主機資料報表',
              url: 'OtherPcLogSummary',
              privilege: true
            },
            TimeLogSummary: {
              name: '系統校時報表',
              url: 'TimeLogSummary',
              privilege: false
            },
            TimeLogAnalysis: {
              name: '系統校時分析報表',
              url: 'TimeLogAnalysis',
              privilege: false
            },
            IpCamTimeLogSummary: {
              name: '攝影機對時報表',
              url: 'IpCamTimeLogSummary',
              privilege: false
            },
            TimeSyncSummary: {
              name: '電腦設備同步確認報表',
              url: 'TimeSyncSummary',
              privilege: false
            },
            CustomReport: {
              name: '區間速率報表',
              url: 'CustomReport',
              privilege: true
            },
            CrossLineReport: {
              name: '違規停車報表',
              url: 'CrossLineReport',
              privilege: false
            },
            ShoulderReport: {
              name: '行駛路肩報表',
              url: 'ShoulderReport',
              privilege: true
            }
          }
        },
        SystemSettings: {
          name: '系統設定',
          url: 'SystemSettings',
          privilege: false,
          child: {
            UserSettings: {
              name: '使用者設定',
              url: 'UserSettings',
              privilege: true
            },
            ParaSettings: {
              name: '參數設定',
              url: 'ParaSettings',
              privilege: true
            }
          }
        }
      };
      // handle privilege here.
      data.SystemSettings.privilege = this.$store.state.user.user.is_superuser;
      //if(data.ReportExport.privilege==false)
      //  data.ReportExport.privilege = this.$store.state.user.user.is_superuser;
      /*
      if(this.$store.state.user.user.username=='B01_1F' ||this.$store.state.user.user.username=='B03_1F') {
        data.TicketManagement.privilege = false  
      }
      if(this.$store.state.user.user.username=='B01_2F' ||this.$store.state.user.user.username=='B03_2F') {
        data.ADCManagement.privilege = false  
      }
      */
      if (this.serverPrivilege2 !== null && this.serverPrivilege2 !== undefined) {
        data.ADCManagement.privilege = this.serverPrivilege2.car_privilege;
        data.ConfirmManagement.privilege = this.serverPrivilege2.confirm_privilege;
        data.TicketManagement.privilege = this.serverPrivilege2.ticket_privilege;
        data.ReportExport.privilege = this.serverPrivilege2.report_output;
      }
      if (this.$store.state.user.user.username == 'esttw') {
        data.ReportExport.child.TimeLogAnalysis.privilege = true;
      }
      return data;
    }
  },
  watch: {
    route: function route(val) {
      this.checkedPath(val);
    },
    fixedLinkCode4SuperUser: function fixedLinkCode4SuperUser(val) {
      this.fixedLinkCode4SuperUser = val;
      this.$store.state.user.user.department.fixed_link_code = this.fixedLinkCodeObj[val];
    }
  }
});

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_AdminPatch__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_AdminPatch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_AdminPatch__);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ADCManagement',
  components: {
    Patch: __WEBPACK_IMPORTED_MODULE_0__common_AdminPatch___default.a
  }
});

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ADCDetail',
  data: function data() {
    return {
      area: [],
      department: [],
      user: [],
      adminId: null,
      areaId: 0,
      systemName: '',
      alert_outdated_day: 0,
      return_to_original_cmpn: false,
      settings: null,
      createReason: false,
      reason: ''
    };
  },

  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    },

    // 退藥理由是用';'串在一起存在db裡
    returnReason: function returnReason() {
      var reasons = [];
      this.rowData.settings.return_reason.split(';').forEach(function (reason) {
        reasons.push(reason);
      });
      return reasons;
    }
  },
  methods: {
    // 取得所有區域位置
    getArea: function getArea() {
      var _this = this;

      return this.instance.get('/api/area/').then(function (res) {
        res.data.forEach(function (data) {
          _this.area.push({
            label: data.name,
            value: data.id
          });
        });
      });
    },

    // 取得所有部門
    getDepartment: function getDepartment() {
      var _this2 = this;

      return this.instance.get('/api/department/').then(function (res) {
        res.data.forEach(function (data) {
          _this2.department.push({
            label: data.name,
            value: data.id
          });
        });
      });
    },

    // 取得所有使用者
    getUser: function getUser() {
      var _this3 = this;

      return this.instance.get('/api/user/').then(function (res) {
        res.data.results.forEach(function (data) {
          _this3.user.push({
            label: data.username,
            value: data.id
          });
        });
      });
    },

    // 儲存設定
    saveSetting: function saveSetting() {
      return this.instance.patch('/api/general-setting/' + this.settings.id + '/', this.settings).then(function (res) {
        console.log(res);
      });
    },

    // 新增退藥理由
    addReason: function addReason() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var reasons;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                reasons = _this4.returnReason.join(';');

                console.log(_this4.returnReason, reasons);
                _this4.instance.patch('/api/general-setting/' + _this4.rowData.settings.id + '/', {
                  return_reason: reasons.concat(';' + _this4.reason)
                }).then(function () {
                  _this4.$store.commit('SET_MESSAGE', {
                    type: 'success',
                    context: '新增成功'
                  });
                  _this4.createReason = false;
                  _this4.$parent.refresh();
                });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },

    // 刪除退藥理由
    deleteReason: function deleteReason(ind) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log(_this5.returnReason.splice(ind, 1));
                _this5.instance.patch('/api/general-setting/' + _this5.rowData.settings.id + '/', {
                  return_reason: _this5.returnReason.join(';')
                }).then(function () {
                  _this5.$store.commit('SET_MESSAGE', {
                    type: 'success',
                    context: '刪除成功'
                  });
                  _this5.$parent.refresh();
                });

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },

    // 儲存整個系統相關設定
    save: function save() {
      var _this6 = this;

      this.instance.patch('/api/system/' + this.rowData.id + '/', {
        admin: this.adminId,
        area: this.areaId,
        name: this.systemName
      }).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(res) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  console.log(res);
                  _context3.next = 3;
                  return _this6.saveSetting();

                case 3:
                  _this6.$store.commit('SET_MESSAGE', {
                    type: 'success',
                    context: '更新成功'
                  });
                  _this6.$parent.refresh();

                case 5:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, _this6);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function () {
        _this6.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '請確認設定欄位皆已填妥資料'
        });
      });
    }
  },
  created: function created() {
    this.getArea();
    this.getDepartment();
    this.getUser();
    if (this.rowData.admin !== null) this.adminId = this.rowData.admin.id;
    if (this.rowData.area !== null) this.areaId = this.rowData.area.id;
    this.systemName = this.rowData.name;
    this.settings = this.rowData.settings;
  }
});

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_Vuetable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_Vuetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_Vuetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_VuetablePagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_VuetablePagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_VuetablePagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_functions_readCookie__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ADCDetail__ = __webpack_require__(1195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ADCDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ADCDetail__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('adc-detail', __WEBPACK_IMPORTED_MODULE_6__ADCDetail___default.a);
// 顯示系統藥盒數量及抽屜量
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('count-device', {
  name: 'CountDevice',
  props: ['rowData', 'rowIndex', 'rowField'],
  template: '\n  <span>{{ rowData.net_count }} / {{ rowData.device_count }}</span>'
});

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ADCList',
  data: function data() {
    return {
      boostrapCss: {
        tableClass: 'table table-bordered table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: ''
          }
        }
      },
      httpOptions: {
        headers: {
          Authorization: 'Token ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__vuex_functions_readCookie__["a" /* default */])('Token')
        }
      },
      server: __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */],
      fields: [{
        name: 'name',
        title: '名稱'
      }, {
        name: 'area.name',
        title: '所屬區域'
      }, {
        name: 'area.department.name',
        title: '所屬單位'
      }, {
        name: 'admin.username',
        title: '管理者'
      }, {
        name: '__component:count-device',
        title: '抽屜數量 / 藥盒數量'
      }]
    };
  },

  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_Vuetable___default.a,
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_VuetablePagination___default.a
  },
  methods: {
    onCellClicked: function onCellClicked(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.id);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    drawerCount: function drawerCount(netSet) {
      var dCount = netSet.length;
      var bCount = 0;
      netSet.forEach(function (net) {
        net.device_set.forEach(function (item) {
          bCount += 1;
        });
      });
      return dCount + ' / ' + bCount;
    }
  }
});

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetable_2_src_components_Vuetable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetable_2_src_components_Vuetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuetable_2_src_components_Vuetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vuex_functions_readCookie__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CheckDetail__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CheckDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__CheckDetail__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].component('check-detail', __WEBPACK_IMPORTED_MODULE_11__CheckDetail___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CarList',
  data: function data() {
    return {
      //20220307 add
      currentPage: 1,
      //20200807 add
      totalIllegalNum: '',
      alarmIllegalNum: '',
      tableDataLen: undefined,
      tmpId: '',
      startDate: undefined,
      endDate: undefined,
      loadingData: false,
      paras: [],
      boostrapCss: {
        tableClass: 'table table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: ''
          }
        }
      },
      httpOptions: {
        headers: {
          Authorization: 'Token ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__vuex_functions_readCookie__["a" /* default */])('Token')
        }
      },
      server: __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */],
      fields: [
      //20220307 add
      {
        name: '__slot:index',
        title: '序號'
      },
      /*
      {
        name: 'xactno',
        //sortField: 'xactno',
        title: '流水號',
      },
      */
      {
        name: 'plt_no.plt_no',
        //sortField: 'plt_no.plt_no',
        title: '車牌號碼'
      },
      /*
      {
        name: 'car_tp.car_tp',
        title: '車別代碼',
      },
      */
      {
        name: 'vli_dateTime_in',
        sortField: 'vli_dateTime_in',
        title: '進入時間',
        callback: this.readableDate
      }, {
        name: 'vli_dateTime_out',
        sortField: 'vli_dateTime_out',
        title: '離開時間',
        callback: this.readableDate
      }, {
        name: 'pass_time',
        title: '通過時間(秒)'
      }, {
        name: 'speed',
        sortField: 'speed',
        title: '車速'
      }, {
        name: 'fixed_link_code.fixed_link_code',
        title: '固定桿代碼'
      }, {
        name: 'rule_code.rule_code',
        title: '條款代碼'
      }, {
        name: 'status',
        title: '開單狀態',
        //sortField: 'status',
        callback: this.status
      }],
      queryString: '',
      alarmSpeed: '',
      moreParams: {
        fixed_link_code_id: this.$store.state.user.user.department.fixed_link_code,
        start_date: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'),
        end_date: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD')
      }
    };
  },

  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_7_vuetable_2_src_components_Vuetable___default.a,
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_10__common_Loader___default.a
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getPara();

            case 2:
              _this.alarmSpeed = _this.paras[0].alarmSpeed;
              _this.alarmIllegalNum = _this.paras[0].alarmIllegalNum;
              //this.loadingData = false;

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    startDate: function startDate(val) {
      if (val > this.endDate && this.endDate !== '') {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '開始時間不可晚於結束時間'
        });
        this.startDate = this.endDate;
      }
    },
    endDate: function endDate(val) {
      if (val < this.startDate && this.startDate !== '') {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '結束時間不可早於開始時間'
        });
        this.endDate = this.startDate;
      }
    }
  },
  methods: {
    onRowClass: function onRowClass(data, index) {
      if (parseInt(data.speed, 10) >= this.alarmSpeed) {
        return 'over-speed';
      }
      return '';
    },
    onLoading: function onLoading() {
      this.loadingData = true;
      console.log('loading... show your spinner here');
    },
    onLoaded: function onLoaded() {
      this.loadingData = false;
      console.log('loaded! .. hide your spinner here');
      this.tableDataLen = this.$refs.vuetable.tableData.length;
      console.log('datalen:', this.tableDataLen);
      if (this.tableDataLen > 0) {
        console.log('id:', this.$refs.vuetable.tableData[0].id);
        this.onCellClicked(this.$refs.vuetable.tableData[0]);
      }
      //20200807 add
      this.totalIllegalNum = this.$refs.vuetable.tablePagination.total;
      console.log('totalIllegalNum:', this.totalIllegalNum);
    },
    onCellClicked: function onCellClicked(data, field, event) {
      var _this2 = this;

      console.log('cellclicked');
      console.log('tmpId:', this.tmpId);
      console.log('nowId:', data.id);
      console.log('vuetable:', this.$refs.vuetable);
      if (this.tmpId == '') this.tmpId = data.id;else if (this.tmpId !== '' && this.tmpId != data.id) {
        this.$refs.vuetable.toggleDetailRow(this.tmpId);
        this.tmpId = data.id;
      } else if (this.tmpId == data.id) this.tmpId = '';
      //this.$refs.vuetable.toggleDetailRow(data.id);
      setTimeout(function () {
        _this2.$refs.vuetable.toggleDetailRow(data.id);
      }, 50);
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.currentPage = paginationData.current_page;
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet: function onFilterSet() {
      var _this3 = this;

      if (this.startDate == undefined || this.endDate == undefined) {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '請輸入查詢區間'
        });
        return;
      }
      console.log('start:', this.startDate);
      console.log('end:', this.endDate);
      if (this.queryString == "尚未處理") this.queryString = "t0";else if (this.queryString == "已開單") this.queryString = "t1";else if (this.queryString == "未違規") this.queryString = "t2";else if (this.queryString == "無法開單") this.queryString = "t3";
      this.moreParams = {
        search: this.queryString,
        fixed_link_code_id: this.$store.state.user.user.department.fixed_link_code,
        start_date: this.startDate,
        end_date: this.endDate
      };
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].nextTick(function () {
        return _this3.$refs.vuetable.refresh();
      });
    },
    getSortParam: function getSortParam(sortOrder) {
      return sortOrder.map(function (sort) {
        return (sort.direction === 'desc' ? '-' : '') + sort.field;
      }).join(',');
    },
    readableDate: function readableDate(value) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format('YY/MM/DD HH:mm:ss.SSS'); //0~23hr format
    },
    status: function status(value) {
      if (value == "t0") return "尚未處理";else if (value == "t1") return "已開單";else if (value == "t2") return "未違規";else if (value == "t3") return "無法開單";
    },
    getPara: function getPara() {
      var _this4 = this;

      return this.instance.get('/api/fixed-link-code/', {
        params: {
          fixed_link_code_id: this.$store.state.user.user.department.fixed_link_code
        }
      }).then(function (res) {
        _this4.paras = res.data;
      });
    }
  },
  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    },
    user: function user() {
      return this.$store.state.user;
    }
  }
  // computed: mapState({
  //   system: state => state.system,
  // }),
});

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(8);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CheckDetail',
  data: function data() {
    return {
      status: null,
      sourceOfPicture: '',
      img_string: '顯示照片',
      carName: '汽車',
      carTypes: [],
      plt_no: '',
      randomNum: ''
    };
  },

  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  components: {},
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var img;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.rowData.car_tp != null) {
                _this.carName = _this.rowData.car_tp.car_name;
              }
              if (_this.rowData.plt_no != null) {
                _this.plt_no = _this.rowData.plt_no.plt_no;
              }
              img = document.getElementById('bigpic');

              _this.randomNum = Math.random();
              _this.sourceOfPicture = '/media/interval/done/' + _this.rowData.fixed_link_code.fixed_link_code + '/' + _this.rowData.img_filename + '?t=' + _this.randomNum;
              _this.img_string = "關閉照片";
              img.src = _this.sourceOfPicture;
              img.style.display = "block";
              img.class = "car-image";

            case 9:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  created: function created() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.getCarType();

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },

  methods: {
    putIntoData: function putIntoData(response, data) {
      var _this3 = this;

      response.data.forEach(function (item) {
        _this3[data].push(item);
      });
    },
    getCarType: function getCarType() {
      var _this4 = this;

      return this.instance.get('/api/car-type/').then(function (res) {
        _this4.putIntoData(res, 'carTypes');
      });
    },
    showImg: function showImg() {
      var img = document.getElementById('bigpic');
      this.randomNum = Math.random();
      this.sourceOfPicture = '/media/interval/done/' + this.rowData.fixed_link_code.fixed_link_code + '/' + this.rowData.img_filename + '?t=' + this.randomNum;
      console.log(this.sourceOfPicture);
      if (img.style.display == "none") {
        this.img_string = "關閉照片";
        img.src = this.sourceOfPicture;
        img.style.display = "block";
        img.class = "car-image";
      } else {
        this.img_string = "顯示照片";
        img.style.display = "none";
      }
    },
    breakLaw: function breakLaw() {
      var _this5 = this;

      if (this.carName == '' || this.plt_no == '') {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '車號及車種資訊請勿空白'
        });
        return;
      }
      this.instance.patch('/api/interval-speed-data/' + this.rowData.id + '/', {
        xactno: this.rowData.xactno,
        status: "t1",
        user: this.$store.state.user.user.username,
        car_name: this.carName,
        plt_no: this.plt_no
      }).then(function () {
        //this.$parent.refresh();
        /*this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功, 已認證',
        });*/
        _this5.$parent.refresh();
      }).catch(function (err) {
        _this5.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: err.response.data
        });
      });
    },
    uncertain: function uncertain() {
      var _this6 = this;

      this.instance.patch('/api/interval-speed-data/' + this.rowData.id + '/', {
        xactno: this.rowData.xactno,
        status: "t3",
        user: this.$store.state.user.user.username,
        car_name: this.carName,
        plt_no: this.plt_no
      }).then(function () {
        //this.$parent.refresh();
        /*this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功',
        });*/
        _this6.$parent.refresh();
      }).catch(function (err) {
        _this6.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: err.response.data
        });
      });
    },
    pass: function pass() {
      var _this7 = this;

      this.instance.patch('/api/interval-speed-data/' + this.rowData.id + '/', {
        xactno: this.rowData.xactno,
        status: "t2",
        user: this.$store.state.user.user.username,
        car_name: this.carName,
        plt_no: this.plt_no
      }).then(function () {
        //this.$parent.refresh();
        /*this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功',
        });*/
        _this7.$parent.refresh();
      }).catch(function (err) {
        _this7.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: err.response.data
        });
      });
    },
    updateCarName: function updateCarName() {
      var _this8 = this;

      this.instance.patch('/api/interval-speed-data/' + this.rowData.id + '/', {
        xactno: this.rowData.xactno,
        car_name: this.carName,
        plt_no: this.plt_no
      }).then(function () {
        //this.$parent.refresh();
        /*this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功',
        });*/
        _this8.$parent.refresh();
      }).catch(function (err) {
        _this8.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: err.response.data
        });
      });
    }
  }
});

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_viewerjs_dist_viewer_css__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_viewerjs_dist_viewer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_viewerjs_dist_viewer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_viewer__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_viewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_v_viewer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(10);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_v_viewer___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CrossLineCheckDetail',
  data: function data() {
    return {
      status: null,
      sourceOfPicture: '',
      img_string: '顯示照片',
      carName: '汽車',
      carTypes: [],
      plt_no: '',
      randomNum: ''
    };
  },

  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  components: {},
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var img;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.rowData.car_tp != null) {
                _this.carName = _this.rowData.car_tp.car_name;
              }
              if (_this.rowData.plt_no != null) {
                _this.plt_no = _this.rowData.plt_no.plt_no;
              }
              img = document.getElementById('bigpic');

              _this.randomNum = Math.random();
              _this.sourceOfPicture = '/media/crossline/done/' + _this.rowData.fixed_link_code.fixed_link_code + '/' + _this.rowData.img_filename + '?t=' + _this.randomNum;
              _this.img_string = "關閉照片";
              img.src = _this.sourceOfPicture;
              img.style.display = "block";
              img.class = "car-image";

            case 9:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  created: function created() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.getCarType();

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },

  methods: {
    putIntoData: function putIntoData(response, data) {
      var _this3 = this;

      response.data.forEach(function (item) {
        _this3[data].push(item);
      });
    },
    getCarType: function getCarType() {
      var _this4 = this;

      return this.instance.get('/api/car-type/').then(function (res) {
        _this4.putIntoData(res, 'carTypes');
      });
    },
    showImg: function showImg() {
      var img = document.getElementById('bigpic');
      this.randomNum = Math.random();
      this.sourceOfPicture = '/media/crossline/done/' + this.rowData.fixed_link_code.fixed_link_code + '/' + this.rowData.img_filename + '?t=' + this.randomNum;
      console.log(this.sourceOfPicture);
      if (img.style.display == "none") {
        this.img_string = "關閉照片";
        img.src = this.sourceOfPicture;
        img.style.display = "block";
        img.class = "car-image";
      } else {
        this.img_string = "顯示照片";
        img.style.display = "none";
      }
    },
    breakLaw: function breakLaw() {
      var _this5 = this;

      if (this.carName == '' || this.plt_no == '') {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '車號及車種資訊請勿空白'
        });
        return;
      }
      this.instance.patch('/api/cross-line-data/' + this.rowData.id + '/', {
        xactno: this.rowData.xactno,
        status: "t1",
        user: this.$store.state.user.user.username,
        car_name: this.carName,
        plt_no: this.plt_no
      }).then(function () {
        //this.$parent.refresh();
        /*this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功, 已認證',
        });*/
        _this5.$parent.refresh();
      }).catch(function (err) {
        _this5.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: err.response.data
        });
      });
    },
    uncertain: function uncertain() {
      var _this6 = this;

      this.instance.patch('/api/cross-line-data/' + this.rowData.id + '/', {
        xactno: this.rowData.xactno,
        status: "t3",
        user: this.$store.state.user.user.username,
        car_name: this.carName,
        plt_no: this.plt_no
      }).then(function () {
        //this.$parent.refresh();
        /*this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功',
        });*/
        _this6.$parent.refresh();
      }).catch(function (err) {
        _this6.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: err.response.data
        });
      });
    },
    pass: function pass() {
      var _this7 = this;

      this.instance.patch('/api/cross-line-data/' + this.rowData.id + '/', {
        xactno: this.rowData.xactno,
        status: "t2",
        user: this.$store.state.user.user.username,
        car_name: this.carName,
        plt_no: this.plt_no
      }).then(function () {
        //this.$parent.refresh();
        /*this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功',
        });*/
        _this7.$parent.refresh();
      }).catch(function (err) {
        _this7.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: err.response.data
        });
      });
    },
    updateCarName: function updateCarName() {
      var _this8 = this;

      this.instance.patch('/api/cross-line-data/' + this.rowData.id + '/', {
        xactno: this.rowData.xactno,
        car_name: this.carName,
        plt_no: this.plt_no
      }).then(function () {
        //this.$parent.refresh();
        /*this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功',
        });*/
        _this8.$parent.refresh();
      }).catch(function (err) {
        _this8.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: err.response.data
        });
      });
    }
  }
});

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetable_2_src_components_Vuetable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetable_2_src_components_Vuetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuetable_2_src_components_Vuetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vuex_functions_readCookie__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CrossLineCheckDetail__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CrossLineCheckDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__CrossLineCheckDetail__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].component('cross-line-check-detail', __WEBPACK_IMPORTED_MODULE_11__CrossLineCheckDetail___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CrossLineList',
  data: function data() {
    return {
      tableDataLen: undefined,
      tmpId: '',
      startDate: undefined,
      endDate: undefined,
      loadingData: false,
      paras: [],
      boostrapCss: {
        tableClass: 'table table-striped table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: ''
          }
        }
      },
      httpOptions: {
        headers: {
          Authorization: 'Token ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__vuex_functions_readCookie__["a" /* default */])('Token')
        }
      },
      server: __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */],
      fields: [{
        name: 'xactno',
        sortField: 'xactno',
        title: '流水號'
      }, {
        name: 'plt_no.plt_no',
        //sortField: 'plt_no.plt_no',
        title: '車牌號碼'
      }, {
        name: 'car_tp.car_tp',
        title: '車別代碼'
      }, {
        name: 'vli_dateTime_in',
        sortField: 'vli_dateTime_in',
        title: '違規時間',
        callback: this.readableDate
      }, {
        name: 'fixed_link_code.fixed_link_code',
        title: '固定桿代碼'
      }, {
        name: 'rule_code.rule_code',
        title: '條款代碼'
      }, {
        name: 'status',
        title: '開單狀態',
        sortField: 'status',
        callback: this.status
      }],
      queryString: '',
      moreParams: {
        fixed_link_code_id: this.$store.state.user.user.department.fixed_link_code,
        start_date: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'),
        end_date: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD')
      }
    };
  },

  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_7_vuetable_2_src_components_Vuetable___default.a,
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_10__common_Loader___default.a
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getPara();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    startDate: function startDate(val) {
      if (val > this.endDate && this.endDate !== '') {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '開始時間不可晚於結束時間'
        });
        this.startDate = this.endDate;
      }
    },
    endDate: function endDate(val) {
      if (val < this.startDate && this.startDate !== '') {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '結束時間不可早於開始時間'
        });
        this.endDate = this.startDate;
      }
    }
  },
  methods: {
    onLoading: function onLoading() {
      this.loadingData = true;
      console.log('loading... show your spinner here');
    },
    onLoaded: function onLoaded() {
      this.loadingData = false;
      console.log('loaded! .. hide your spinner here');
      this.tableDataLen = this.$refs.vuetable.tableData.length;
      console.log('datalen:', this.tableDataLen);
      if (this.tableDataLen > 0) {
        console.log('id:', this.$refs.vuetable.tableData[0].id);
        this.onCellClicked(this.$refs.vuetable.tableData[0]);
      }
    },
    onCellClicked: function onCellClicked(data, field, event) {
      var _this2 = this;

      console.log('cellclicked');
      console.log('tmpId:', this.tmpId);
      console.log('nowId:', data.id);
      if (this.tmpId == '') this.tmpId = data.id;else if (this.tmpId !== '' && this.tmpId != data.id) {
        this.$refs.vuetable.toggleDetailRow(this.tmpId);
        this.tmpId = data.id;
      } else if (this.tmpId == data.id) this.tmpId = '';
      //this.$refs.vuetable.toggleDetailRow(data.id);
      setTimeout(function () {
        _this2.$refs.vuetable.toggleDetailRow(data.id);
      }, 50);
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet: function onFilterSet() {
      var _this3 = this;

      if (this.startDate == undefined || this.endDate == undefined) {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '請輸入查詢區間'
        });
        return;
      }
      if (this.queryString == "尚未處理") this.queryString = "t0";else if (this.queryString == "已開單") this.queryString = "t1";else if (this.queryString == "未違規") this.queryString = "t2";else if (this.queryString == "無法開單") this.queryString = "t3";
      this.moreParams = {
        search: this.queryString,
        fixed_link_code_id: this.$store.state.user.user.department.fixed_link_code,
        start_date: this.startDate,
        end_date: this.endDate
      };
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].nextTick(function () {
        return _this3.$refs.vuetable.refresh();
      });
    },
    getSortParam: function getSortParam(sortOrder) {
      return sortOrder.map(function (sort) {
        return (sort.direction === 'desc' ? '-' : '') + sort.field;
      }).join(',');
    },
    readableDate: function readableDate(value) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format('YY/MM/DD HH:mm:ss.SSS'); //0~23hr format
    },
    status: function status(value) {
      if (value == "t0") return "尚未處理";else if (value == "t1") return "已開單";else if (value == "t2") return "未違規";else if (value == "t3") return "無法開單";
    },
    getPara: function getPara() {
      var _this4 = this;

      return this.instance.get('/api/fixed-link-code/', {
        params: {
          fixed_link_code_id: this.$store.state.user.user.department.fixed_link_code
        }
      }).then(function (res) {
        _this4.paras = res.data;
      });
    }
  },
  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    },
    user: function user() {
      return this.$store.state.user;
    }
  }
  // computed: mapState({
  //   system: state => state.system,
  // }),
});

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Confirm__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Confirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_Confirm__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ADCDrugDetail',
  data: function data() {
    return {
      Data: null,
      confirm: false
    };
  },

  components: {
    Confirm: __WEBPACK_IMPORTED_MODULE_3__common_Confirm___default.a
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  mounted: function mounted() {
    this.Data = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.rowData);
    // this.Data = this.rowData;
  },

  methods: {
    update: function update() {
      var _this = this;

      if (this.Data.max_stock >= this.Data.stock) {
        this.instance.put('/api/drug-storage/' + this.Data.id + '/', {
          id: this.Data.id,
          type: 'ADMIN_UPDATE',
          stock: this.Data.stock,
          device: this.Data.device.id,
          medication: this.Data.medication.id,
          max_stock: this.Data.max_stock,
          expired_date: this.Data.expired_date,
          patch_number: this.Data.patch_number,
          inventoried_in_tag_system: this.Data.inventoried_in_tag_system,
          number1: this.Data.stock - this.rowData.stock
        }).then(function (res) {
          _this.$store.commit('SET_MESSAGE', { type: 'success', context: '更新成功' });
          _this.$parent.refresh();
          console.log(_this.$parent.$parent);
          _this.$parent.$parent.$parent.refresh();
        }).catch(function (err) {
          var context = '';
          if (err.response) {
            context = err.response.data;
          }
          _this.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: context
          });
        });
      } else {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '最大庫存不可小於庫存量'
        });
      }
    },
    confirmDel: function confirmDel(response) {
      var _this2 = this;

      this.$store.commit('SET_MESSAGE', { type: 'warn', context: '刪除中', confirm: false });
      this.confirm = false;
      if (response) {
        this.instance.delete('/api/drug-storage/' + this.Data.id + '/', {
          data: {
            type: 'ADMIN_DELETE'
          }
        }).then(function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return _this2.$parent.refresh();

                  case 2:
                    _context.next = 4;
                    return _this2.$parent.$parent.$parent.refresh();

                  case 4:
                    _this2.$store.commit('CLOSE_MESSAGE');

                  case 5:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this2);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      }
    },
    del: function del() {
      this.confirm = true;
    }
  },
  watch: {
    Data: {
      deep: true,
      handler: function handler(val, oldVal) {
        console.log('data changed.');
        val.stock = parseInt(oldVal.stock, 10);
        val.max_stock = parseInt(oldVal.max_stock, 10);
      }
    }
  }
});

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_Vuetable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_Vuetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_Vuetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_functions_readCookie__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DrugListDrugStorages__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DrugListDrugStorages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__DrugListDrugStorages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__flowComp_ResetLowAmountLimit__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__flowComp_ResetLowAmountLimit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__flowComp_ResetLowAmountLimit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__common_Loader__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('adc-drug-detail-drug-storage', __WEBPACK_IMPORTED_MODULE_6__DrugListDrugStorages___default.a);

// 更改安全存量
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('action', {
  name: 'minAmount',
  props: ['rowData'],
  data: function data() {
    return {
      showModal: false
    };
  },

  components: {
    ResetLowAmountModal: __WEBPACK_IMPORTED_MODULE_7__flowComp_ResetLowAmountLimit___default.a
  },
  computed: {},
  methods: {
    showLowAmountModal: function showLowAmountModal() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch('getTotalDrugAmountInstanly', _this.rowData.id);

              case 2:
                _context.next = 4;
                return _this.$store.dispatch('getLowAmountLimitData', _this.rowData.id);

              case 4:
                _this.showModal = true;

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    closeModal: function closeModal() {
      this.showModal = false;
      this.$parent.refresh();
    }
  },
  template: '\n    <div>\n      <button class="btn-sm btn btn-info" @click="showLowAmountModal">\u66F4\u6539\u5B89\u5168\u5B58\u91CF</button>\n      <ResetLowAmountModal v-if="showModal" v-on:closeModal="closeModal" :showNumPad="false" :currentAmount="rowData.min_amount" :limitAmount="rowData.total_avalaible_max_amount"></ResetLowAmountModal>\n    </div>\n  '
});

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ADCDrugList',
  data: function data() {
    return {
      loadingData: false,
      boostrapCss: {
        tableClass: 'table table-bordered table-sm  table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger'
      },
      httpOptions: {
        headers: {
          Authorization: 'Token ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__vuex_functions_readCookie__["a" /* default */])('Token')
        }
      },
      sortOrder: [{
        field: 'device',
        direction: 'asc'
      }],
      fields: [{
        name: 'medication.code',
        title: '流水號'
      }, {
        name: 'medication.CGMH_number',
        title: '車牌號碼'
      }, {
        name: 'medication.generic_name',
        title: '車別代碼',
        sortField: 'medication.generic_name'
      }, {
        name: '__slot:total_amount',
        title: '進入時間',
        titleClass: 'text-center',
        dataClass: 'text-center'
      }, {
        name: 'avaliable_amount',
        title: '離開時間',
        titleClass: 'text-center',
        dataClass: 'text-center'
      },
      /*
      {
        name: 'min_amount',
        title: '安全存量',
        titleClass: 'text-center',
        dataClass: 'text-center',
      },
      {
        name: 'drug_storage_count',
        title: '藥倉數量',
        titleClass: 'text-center',
        dataClass: 'text-center',
      },
      */
      {
        name: '__component:action',
        title: '動作',
        titleClass: 'text-center',
        dataClass: 'text-center'
      }],
      server: __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */],
      systemType: 'ADC',
      moreParams: {},
      createDrugStorage: true,
      systems: [],
      systemId: undefined,
      devices: [],
      deviceId: '',
      medicines: [],
      stock: 0,
      maxStock: 0,
      date: '',
      batch: '',
      searchDrug: '',
      medName: ''
    };
  },

  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_Vuetable___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_8__common_Loader___default.a
  },
  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    },
    drugStorageChangedTime: function drugStorageChangedTime() {
      return this.$store.state.drugInDevice.drugStorageChangedTime;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this2.loadingData = true;
              _context2.next = 3;
              return _this2.getSystem();

            case 3:
              _this2.loadingData = false;

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },

  methods: {
    onRowClass: function onRowClass(data, index) {
      if (data.min_amount >= data.avaliable_amount) {
        return 'low-amount-med';
      }
      return '';
    },

    // for table sorting
    getSortParam: function getSortParam(sortOrder) {
      return sortOrder.map(function (sort) {
        if (sort.field === 'device') {
          return (sort.direction === 'desc' ? '-' : '') + 'device_id';
        }
        if (sort.field === 'medication.generic_name') {
          return (sort.direction === 'desc' ? '-' : '') + 'medication__generic_name';
        }
        return (sort.direction === 'desc' ? '-' : '') + sort.field;
      }).join(',');
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onCellClicked: function onCellClicked(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.id);
    },
    updateTable: function updateTable() {
      this.moreParams.device__net__system_id = this.systemId;
      this.$refs.vuetable.refresh();
    },
    getSystem: function getSystem() {
      var _this3 = this;

      return this.instance.get('/api/system/', {
        params: {
          type: 'ADC'
        }
      }).then(function (res) {
        _this3.systems = res.data.results;
      });
    },
    getDeviece: function getDeviece() {
      var _this4 = this;

      var sys = this.system[this.systemId];
      sys.net_set.forEach(function (net) {
        net.device_set.forEach(function (device) {
          _this4.devices.push(device);
        });
      });
    },
    getMedcines: function getMedcines() {
      var _this5 = this;

      this.instance.get('/api/medication/').then(function (res) {
        _this5.medicines = res.data.results;
      });
    },

    // 表格搜尋功能
    onFilterSet: function onFilterSet() {
      var _this6 = this;

      this.moreParams = {
        search: this.medName,
        system: this.systemId
      };
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick(function () {
        return _this6.$refs.vuetable.refresh();
      });
    },

    // 下載藥倉報告
    download: function download() {
      if (this.systemId) {
        window.open(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */] + '/export-ADC-drug-storage/?system=' + this.systemId, '_blank');
      } else {
        window.open(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */] + '/export-ADC-drug-storage/', '_blank');
      }
    }
  },
  watch: {
    maxStock: function maxStock(val) {
      if (val < this.stock) this.maxStock = this.stock;
    },
    stock: function stock(val) {
      if (this.stock > this.maxStock) this.maxStock = this.stock;
    },
    drugStorageChangedTime: function drugStorageChangedTime(val) {
      var _this7 = this;

      console.log(val, this.$refs.vuetable.visibleDetailRows);
      this.$refs.vuetable.refresh();
      this.$refs.vuetable.visibleDetailRows.forEach(function (id) {
        console.log(id);
        _this7.$refs.vuetable.toggleDetailRow(id);
        setTimeout(function () {
          _this7.$refs.vuetable.toggleDetailRow(id);
        }, 100);
      });
    }
  }
});

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_Vuetable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_Vuetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_Vuetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_functions_readCookie__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DrugDetail__ = __webpack_require__(1201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DrugDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__DrugDetail__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('adc-drug-detail', __WEBPACK_IMPORTED_MODULE_5__DrugDetail___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('expired-date', {
  name: 'expiredDate',
  props: ['rowData'],
  computed: {
    isExpired: function isExpired() {
      if (__WEBPACK_IMPORTED_MODULE_1_moment___default()(this.rowData.expired_date, 'YYYY-MM-DD').diff(__WEBPACK_IMPORTED_MODULE_1_moment___default()(), 'days') >= 0) {
        return false;
      }
      return true;
    }
  },
  template: '\n    <span :class="{ \'red-text\': isExpired }">\n      {{ rowData.expired_date }}\n    </span>\n  '
});

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['rowData'],
  name: 'DrugListDrugStorages',
  data: function data() {
    return {
      httpOptions: {
        headers: {
          Authorization: 'Token ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__vuex_functions_readCookie__["a" /* default */])('Token')
        }
      },
      boostrapCss: {
        tableClass: 'custom-table table',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: ''
          }
        }
      },
      fields: [{
        name: 'device',
        title: '位置',
        callback: 'readablePosistion',
        titleClass: 'w-25'
      }, {
        name: 'stock',
        title: '庫存'
      }, {
        name: 'max_stock',
        title: '最大庫存'
      }, {
        name: '__component:expired-date',
        title: '有效期限'
      }, {
        name: 'patch_number',
        title: '批號',
        titleClass: 'w-25'
      }],
      moreParams: {},
      server: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */]
    };
  },

  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_Vuetable___default.a
  },
  created: function created() {
    this.moreParams = {
      medication: this.rowData.medication.id,
      device__net__system: this.$parent.httpOptions.params.system
    };
  },
  mounted: function mounted() {
    // this.$refs.vuetable2.setData(this.rowData.drug_storage);
  },

  methods: {
    onCellClicked: function onCellClicked(data) {
      this.$refs.vuetable2.toggleDetailRow(data.id);
    },
    readablePosistion: function readablePosistion(val) {
      var pos = val.net.system.name + ' - ' + val.net.open_times + '\u85E5\u6AC3 - ' + val.net.row_id + '\u5C64';
      if (val.pos_row !== 0) {
        pos = pos + ' - ' + val.pos_row + '\u5217 - ' + val.relative_col + '\u884C';
      }
      if (val.specific_type === 'return_device') {
        pos = pos + ' (\u9000\u85E5\u76D2)';
      }
      return pos;
    }
  }
});

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_Vuetable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_Vuetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_Vuetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_VuetablePagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_VuetablePagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_VuetablePagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_functions_readCookie__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_util__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FetchScheduleList',
  data: function data() {
    return {
      moreParams: {},
      queryString: '',
      boostrapCss: {
        tableClass: 'table table-bordered table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: ''
          }
        }
      },
      httpOptions: {
        headers: {
          Authorization: 'Token ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__vuex_functions_readCookie__["a" /* default */])('Token')
        }
      },
      server: __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */],
      fields: [{
        name: '__checkbox'
      }, {
        name: 'medication.code',
        title: '藥碼'
      }, {
        name: 'medication.CGMH_number',
        title: '料位號'
      }, {
        name: 'medication.generic_name',
        title: '學名'
      }, {
        name: 'patient.med_record_number',
        title: '病歷號'
      }, {
        name: 'amount',
        title: '取藥量'
      }, {
        name: 'fetch_date',
        title: '取藥日期'
      }]
    };
  },

  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_Vuetable___default.a,
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_VuetablePagination___default.a
  },
  computed: {
    instance: function instance() {
      return this.$store.getters.instance;
    }
  },
  methods: {
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet: function onFilterSet() {
      var _this = this;

      this.moreParams = {
        search: this.queryString
      };
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].nextTick(function () {
        return _this.$refs.vuetable.refresh();
      });
    },
    deleteSchedule: function deleteSchedule() {
      var _this2 = this;

      var selected = this.$refs.vuetable.selectedTo;
      if (selected.length !== 0) {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '刪除藥單中...',
          confirm: false
        });
        var promises = [];
        selected.forEach(function (id) {
          promises.push(_this2.instance.delete('/api/fetch-schedule/' + id + '/'));
        });
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.all(promises).then(function (res) {
          _this2.$refs.vuetable.refresh();
          _this2.$store.commit('SET_MESSAGE', {
            type: 'success',
            context: '刪除成功'
          });
        });
      } else {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '請至少選擇一項藥單',
          confirm: true
        });
      }
      this.$refs.vuetable.selectedTo = [];
    },
    uploadFile: function uploadFile() {
      var _this3 = this;

      if (document.getElementById('batch-file-input').files.length !== 0) {
        this.$store.commit('SET_MESSAGE', { type: 'warn', context: '上傳資料處理中', confirm: false });
        var form = new FormData();
        form.append('file', document.getElementById('batch-file-input').files[0]);
        this.$store.getters.instance.post('/upload-to-fetch_schedule/', form, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          timeout: 60000
        }).then(function (res) {
          var context = '<p>上傳成功</p>';
          if (res.data.loaded_perscription !== undefined) {
            context += '<p>\u532F\u5165\u85E5\u55AE\u6578: ' + res.data.loaded_perscription + '</p>';
          }
          if (res.data.total_perscription !== undefined) {
            context += '<p>\u7E3D\u85E5\u55AE\u6578: ' + res.data.total_perscription + '</p>';
          }
          if (res.data.num_replicated_prescription !== undefined) {
            if (res.data.num_replicated_prescription > 0) {
              res.data.replicated_prescriptions.forEach(function (item) {
                context += '<p>\u672A\u532F\u5165\u7684\u91CD\u8907\u85E5\u55AE:  ' + item + '</p>';
              });
            }
          }
          _this3.$store.commit('SET_MESSAGE', { type: 'success', context: context });
          _this3.$refs.vuetable.refresh();
        }).catch(function (err) {
          var errorResponse = err.response.data;
          var context = '<p>上傳失敗</p>';
          if (err.response) {
            if (errorResponse.medication_code_not_found !== undefined) {
              if (errorResponse.medication_code_not_found.length > 0) context += '<p>\u8CC7\u6599\u5EAB\u7121\u6B64\u85E5\u78BC: ' + errorResponse.medication_code_not_found + '</p>';
            }
            // if (errorResponse.decode_error) {
            //   if (errorResponse.decode_error.length > 0) context += `<p>資料有誤行列: ${errorResponse.decode_error}</p>`;
            // }
            if (errorResponse.loaded_perscription !== undefined) context += '<p>\u532F\u5165\u85E5\u55AE\u6578: ' + errorResponse.loaded_perscription + '</p>';
            if (errorResponse.total_perscription !== undefined) context += '<p>\u7E3D\u85E5\u55AE\u6578: ' + errorResponse.total_perscription + '</p>';
            if (errorResponse.num_replicated_prescription !== undefined) {
              if (errorResponse.num_replicated_prescription > 0) {
                errorResponse.replicated_prescriptions.forEach(function (item) {
                  context += '<p>\u672A\u532F\u5165\u7684\u91CD\u8907\u85E5\u55AE:  ' + item + '</p>';
                });
              }
            }
          }
          _this3.$store.commit('SET_MESSAGE', { type: 'error', context: context });
          _this3.$refs.vuetable.refresh();
        });
      } else {
        this.$store.commit('SET_MESSAGE', { type: 'error', context: '請先選擇上傳檔案' });
      }
    }
  }
});

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_Vuetable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_Vuetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_Vuetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vuex_functions_readCookie__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(8);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ADCPlanning',
  data: function data() {
    return {
      boostrapCss: {
        tableClass: 'table table-striped table-bordered table-sm table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: ''
          }
        }
      },
      httpOptions: {
        headers: {
          Authorization: 'Token ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__vuex_functions_readCookie__["a" /* default */])('Token')
        }
      },
      server: __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */],
      fields: [{
        name: '__checkbox'
      }, {
        name: 'device',
        title: '位置',
        callback: 'readablePosistion'
      }, {
        name: 'medication.code',
        title: '藥碼'
      }, {
        name: 'medication.CGMH_number',
        title: '料位號'
      }, {
        name: 'medication.generic_name',
        title: '學名'
      }, {
        name: 'patch_number',
        title: '批號'
      }, {
        name: 'expired_date',
        title: '有效期限'
      }, {
        name: 'stock',
        title: '存量'
      }, {
        name: 'max_stock',
        title: '最大存量'
      }, {
        name: '__slot:num-refill',
        title: '待補數量'
      }],
      moreParams: {},
      systemId: undefined,
      systems: []
    };
  },

  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_Vuetable___default.a
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getSystem();

            case 2:
              _context.next = 4;
              return _this.getRefillData();

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    getSystem: function getSystem() {
      var _this2 = this;

      return this.instance.get('/api/system/', {
        params: {
          type: 'ADC'
        }
      }).then(function (res) {
        _this2.systems = res.data.results;
        console.log(_this2.systems);
      });
    },
    onFilterSet: function onFilterSet() {
      this.getRefillData();
    },
    getRefillData: function getRefillData(systemId) {
      var _this3 = this;

      var filteredData = [];
      this.instance.get(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */] + '/api/drug-storage-not-full/', {
        params: {
          device__net__system: this.systemId
        }
      }).then(function (res) {
        res.data.forEach(function (item) {
          var theExpiredDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(item.expired_date);
          var todayDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()();
          var remainExpiredDays = theExpiredDate.diff(todayDate, 'days');
          if (remainExpiredDays >= 0) {
            filteredData.push(item);
          }
        });
        _this3.$refs.vuetable.setData(filteredData);
      });
    },
    onCellClicked: function onCellClicked(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.id);
    },
    setRefill: function setRefill() {
      var _this4 = this;

      var selected = this.$refs.vuetable.selectedTo;
      if (selected.length !== 0) {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '新增補藥規劃中...',
          confirm: false
        });
        var promises = [];
        selected.forEach(function (drugStorageId) {
          promises.push(_this4.instance.post('/api/refill-order/', {
            drug_storage_id: drugStorageId
          }));
        });

        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.all(promises).then(function (res) {
          console.log(res);
          _this4.$store.commit('SET_MESSAGE', {
            type: 'success',
            context: '新增完成',
            confirm: true
          });
          _this4.$refs.vuetable.selectedTo = [];
          _this4.getRefillData();
        });
      } else {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '請至少選擇一項藥物',
          confirm: true
        });
      }
    },
    readablePosistion: function readablePosistion(val) {
      var pos = val.net.system.name + '-' + val.net.open_times + '\u85E5\u6AC3-' + val.net.row_id + '\u5C64';
      if (val.pos_row !== 0) {
        pos = pos + '-' + val.pos_row + '\u5217-' + val.relative_col + '\u884C';
      }
      return pos;
    }
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])({
    instance: function instance(state) {
      return state.instance;
    },
    drugStorageChangedTime: function drugStorageChangedTime(state) {
      return state.drugInDevice.drugStorageChangedTime;
    }
  }),
  watch: {
    drugStorageChangedTime: function drugStorageChangedTime() {
      this.getRefillData();
    }
  }
});

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_Vuetable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_Vuetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_Vuetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vuex_functions_readCookie__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(8);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ADCPlanningList',
  data: function data() {
    return {
      boostrapCss: {
        tableClass: 'table table-striped table-bordered table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: ''
          }
        }
      },
      httpOptions: {
        headers: {
          Authorization: 'Token ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__vuex_functions_readCookie__["a" /* default */])('Token')
        }
      },
      server: __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */],
      fields: [{
        name: '__checkbox'
      }, {
        name: 'drug_storage.device',
        title: '位置',
        callback: 'readablePosistion'
      }, {
        name: 'drug_storage.medication.code',
        title: '藥碼'
      }, {
        name: 'drug_storage.medication.CGMH_number',
        title: '料位號'
      }, {
        name: 'drug_storage.medication.generic_name',
        title: '學名'
      },
      // {
      //   name: '__slot:medication-name',
      //   title: '藥物',
      //   // titleClass: 'w-380',
      // },
      {
        name: 'drug_storage.patch_number',
        title: '批號'
      }, {
        name: 'drug_storage.expired_date',
        title: '有效期限'
      }, {
        name: 'drug_storage.stock',
        title: '目前存量'
      }, {
        name: 'drug_storage.max_stock',
        title: '最大存量'
      },
      // {
      //   name: '__slot:num-refill',
      //   title: '待補數量',
      // },
      {
        name: '__slot:refill-box',
        title: '待補量'
      }],
      systems: [],
      systemId: undefined,
      moreParams: {}
    };
  },

  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_Vuetable___default.a
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getSystem();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    onCellClicked: function onCellClicked(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.id);
    },
    getSystem: function getSystem() {
      var _this2 = this;

      return this.instance.get('/api/system/', {
        params: {
          type: 'ADC'
        }
      }).then(function (res) {
        _this2.systems = res.data.results;
      });
    },
    onFilterSet: function onFilterSet() {
      var _this3 = this;

      this.moreParams = {
        drug_storage__device__net__system: this.systemId
      };
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].nextTick(function () {
        return _this3.$refs.vuetable.refresh();
      });
    },
    deleteOrder: function deleteOrder() {
      var _this4 = this;

      var selected = this.$refs.vuetable.selectedTo;
      if (selected.length !== 0) {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '刪除補藥規劃中...',
          confirm: false
        });
        var promises = [];
        selected.forEach(function (id) {
          promises.push(_this4.instance.delete('/api/refill-order/' + id + '/'));
        });
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.all(promises).then(function (res) {
          _this4.$refs.vuetable.refresh();
          _this4.$store.commit('SET_MESSAGE', {
            type: 'success',
            context: '刪除成功'
          });
        });
      } else {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '請至少選擇一項補藥規劃',
          confirm: true
        });
      }
    },
    readablePosistion: function readablePosistion(val) {
      var pos = val.net.system.name + '-' + val.net.open_times + '\u85E5\u6AC3-' + val.net.row_id + '\u5C64';
      if (val.pos_row !== 0) {
        pos = pos + '-' + val.pos_row + '\u5217-' + val.relative_col + '\u884C';
      }
      return pos;
    },
    outputTable: function outputTable() {
      this.instance.get('/export-refill-table/', {
        params: {
          system: this.systemId
        },
        responseType: 'blob'
      }).then(function (res) {
        __WEBPACK_IMPORTED_MODULE_4_file_saver___default.a.saveAs(res.data, 'AUTOIX-補藥清單.xlsx');
      });
    }
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])({
    instance: function instance(state) {
      return state.instance;
    },
    drugStorageChangedTime: function drugStorageChangedTime(state) {
      return state.drugInDevice.drugStorageChangedTime;
    }
  }),
  watch: {
    drugStorageChangedTime: function drugStorageChangedTime(val) {
      console.log(val);
      this.$refs.vuetable.refresh();
    }
  }
});

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ScheduleDetail',
  props: ['rowData'],
  data: function data() {
    return {
      comboMedsEvent: null
    };
  },
  created: function created() {
    this.checkMedUsage();
  },

  methods: {
    checkMedUsage: function checkMedUsage() {
      console.log('check medication usage');
      var events = {};
      this.rowData.fetch_event.forEach(function (event) {
        events[event.medication.id] = event;
      });

      var comboMeds = this.rowData.combo_relationship;
      comboMeds.forEach(function (combo) {
        if (events[combo.child_medication.id]) {
          combo.event = events[combo.child_medication.id];
          combo.fetched = true;
        } else {
          combo.event = null;
          combo.fetched = false;
        }
      });

      this.comboMedsEvent = comboMeds;
    }
  },
  filters: {
    timeFromNow: function timeFromNow(val) {
      __WEBPACK_IMPORTED_MODULE_0_moment___default.a.locale('zh-tw');
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(val).fromNow();
    },
    fetchedZh: function fetchedZh(val) {
      if (val) return '已取藥';
      return '未取藥';
    }
  }
});

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_Vuetable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_Vuetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_Vuetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_free_solid_svg_icons__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Calendar__ = __webpack_require__(1336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_Calendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ScheduleDetail__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ScheduleDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ScheduleDetail__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('schedule-detail', __WEBPACK_IMPORTED_MODULE_5__ScheduleDetail___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('gender-template', {
  props: ['rowData'],
  template: '\n    <font-awesome-icon :icon="maleIcon" v-if="rowData.patient.gender === \'male\'" style="color: blue; width: 50px"/>\n    <font-awesome-icon :icon="femaleIcon" v-else style="color: red; width: 50px"/>\n  ',
  computed: {
    femaleIcon: function femaleIcon() {
      return __WEBPACK_IMPORTED_MODULE_3__fortawesome_free_solid_svg_icons__["a" /* faFemale */];
    },
    maleIcon: function maleIcon() {
      return __WEBPACK_IMPORTED_MODULE_3__fortawesome_free_solid_svg_icons__["b" /* faMale */];
    }
  }
});

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ScheduleList',
  data: function data() {
    return {
      boostrapCss: {
        tableClass: 'table table-striped table-bordered table-sm table-sm',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link'
        }
      },
      fields: [{
        name: '__component:gender-template',
        title: '性別',
        titleClass: 'text-center gender-column',
        dataClass: 'text-center'
      }, {
        name: 'patient.name',
        title: '病人名稱'
      }, {
        name: 'patient.med_record_number',
        title: '病歷號'
      }, {
        name: 'bed.code',
        title: '病床'
      }, {
        name: 'time',
        title: '手術時間',
        callback: 'readableTime'
      }, {
        name: 'medication.generic_name',
        title: '使用套組'
      }],
      scheduleList: []
    };
  },

  components: {
    Calendar: __WEBPACK_IMPORTED_MODULE_4__common_Calendar___default.a,
    Vuetable: __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_Vuetable___default.a
  },
  computed: {
    instance: function instance() {
      return this.$store.getters.instance;
    }
  },
  methods: {
    getDatetime: function getDatetime(val) {
      console.log(val);
      this.getScheduleListByDate(val);
    },
    getScheduleListByDate: function getScheduleListByDate(date) {
      var _this = this;

      this.instance.get('/api/schedule/', {
        params: {
          date: date
        }
      }).then(function (res) {
        _this.scheduleList = res.data;
        _this.$refs.vuetable.setData(_this.scheduleList);
      });
    },
    genderZh: function genderZh(val) {
      if (val === 'female') return '女';
      if (val === 'male') return '男';
      return null;
    },
    readableTime: function readableTime(val) {
      return val.split('T').join(' ');
    },
    onCellClicked: function onCellClicked(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.id);
    }
  }
});

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(24);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ShiftArrange',
  data: function data() {
    return {
      users: [],
      draggedElementId: null,
      currentDate: null,
      todayShift: [],
      beds: []
    };
  },

  computed: {
    instance: function instance() {
      return this.$store.getters.instance;
    },
    shiftTable: function shiftTable() {
      var shiftTable = [];
      this.beds.forEach(function (bed) {
        shiftTable.push({
          bed: bed,
          response: [],
          circular: [],
          management: []
        });
      });

      this.todayShift.forEach(function (shift) {
        console.log(shift);
        var shiftItem = shiftTable[shift.bed.code - 1];
        shiftItem.bed.id = shift.bed.id;
        shiftItem[shift.employee_duty].push({ employee: shift.employee, shiftId: shift.id });
      });
      return shiftTable;
    }
  },
  methods: {
    getUsers: function getUsers(url) {
      var _this = this;

      this.instance.get(url).then(function (res) {
        if (res.data.next_page_url !== null) {
          _this.getUsers(res.data.next_page_url);
        } else {
          _this.users = _this.users.concat(res.data.results);
          _this.users = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.orderBy(_this.users, ['last_name', 'first_name']);
        }
      });
    },
    getBedCount: function getBedCount() {
      var _this2 = this;

      this.instance.get('/api/bed/').then(function (res) {
        _this2.beds = res.data;
      });
    },
    getShift: function getShift(date) {
      var _this3 = this;

      this.instance.get('/api/shift', { params: { date: date } }).then(function (res) {
        _this3.todayShift = res.data;
      });
    },
    onDrag: function onDrag(event) {
      this.draggedElementId = event.target.id;
    },
    onDragover: function onDragover(event) {
      // console.log('ondragover', event);
    },
    onDrop: function onDrop(droppedType, event) {
      var _this4 = this;

      var draggedElement = document.getElementById(this.draggedElementId);
      var data = {
        date: this.currentDate,
        employee: parseInt(draggedElement.getAttribute('userid'), 10),
        employee_duty: droppedType,
        bed: parseInt(event.target.getAttribute('bedid'), 10)
      };
      console.log(data);
      this.instance.post('/api/shift/', data).then(function (res) {
        _this4.getShift(_this4.currentDate);
      });
    },
    setShift: function setShift() {
      //
    },
    deleteShift: function deleteShift(id) {
      var _this5 = this;

      this.instance.delete('/api/shift/' + id + '/').then(function (res) {
        _this5.getShift(_this5.currentDate);
      });
    }
  },
  created: function created() {
    this.getBedCount();
    this.getUsers('/api/user/');
    this.currentDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY-MM-DD');
    this.getShift(this.currentDate);
  }
});

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_viewerjs_dist_viewer_css__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_viewerjs_dist_viewer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_viewerjs_dist_viewer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_viewer__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_viewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_v_viewer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(10);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//import 'video.js/dist/video-js.css'
//import VueVideoPlayer from 'vue-video-player'




__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_v_viewer___default.a);
//Vue.use(VueVideoPlayer)

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ShoulderCheckDetail',
  data: function data() {
    return {
      status: null,
      sourceOfPicture: '',
      img_string: '顯示照片',
      carName: '汽車',
      carTypes: [],
      plt_no: '',
      randomNum: ''
      /*
      playerOptions: {
          // videojs options
          muted: true,
          language: 'en',
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          autoplay: true,
          width: 800,
          sources: [{
            type: "video/mp4",
            src: "",
          }],
      },
      playVideoFlag: false,
      playVideoMsg: "撥放影片",
      sourceOfVideo: '',
      */
    };
  },

  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  components: {},
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var img;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.rowData.car_tp != null) {
                _this.carName = _this.rowData.car_tp.car_name;
              }
              if (_this.rowData.plt_no != null) {
                _this.plt_no = _this.rowData.plt_no.plt_no;
              }
              img = document.getElementById('bigpic');

              _this.randomNum = Math.random();
              _this.sourceOfPicture = '/media/shoulder/done/' + _this.rowData.fixed_link_code.fixed_link_code + '/' + _this.rowData.img_filename + '?t=' + _this.randomNum;
              _this.img_string = "關閉照片";
              img.src = _this.sourceOfPicture;
              img.style.display = "block";
              img.class = "car-image";
              //////
              /*
              var newFilename = this.rowData.img_filename.replace('jpg', 'mp4'); 
              console.log('newFilename:', newFilename);
              this.sourceOfVideo = `/media/shoulder/done/${this.rowData.fixed_link_code.fixed_link_code}/${newFilename}`;
              console.log('sourceOfVideo:',this.sourceOfVideo);
              this.playerOptions.sources[0].src=this.sourceOfVideo;
              */
              ////////

            case 9:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  created: function created() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.getCarType();

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },

  methods: {
    /*
    playVideo() {  
      if(this.playVideoMsg=="撥放影片") {
        console.log('1');
        var img = document.getElementById('bigpic')
        this.img_string="顯示照片";
        img.style.display = "none";  
        this.playVideoMsg="結束撥放";
        this.playVideoFlag = true;      
      }
      else {
        console.log('2'); 
        this.playVideoMsg="撥放影片";
        this.playVideoFlag = false;          
      }
    },
    // listen event
    onPlayerPlay(player) {
      // console.log('player play!', player)
    },
    onPlayerPause(player) {
      // console.log('player pause!', player)
    },
    // ...player event
     // or listen state event
    playerStateChanged(playerCurrentState) {
      // console.log('player current update state', playerCurrentState)
    },
     // player is ready
    playerReadied(player) {
      console.log('the player is readied', player)
      // you can use it to do something...
      // player.[methods]
    },
    */
    putIntoData: function putIntoData(response, data) {
      var _this3 = this;

      response.data.forEach(function (item) {
        _this3[data].push(item);
      });
    },
    getCarType: function getCarType() {
      var _this4 = this;

      return this.instance.get('/api/car-type/').then(function (res) {
        _this4.putIntoData(res, 'carTypes');
      });
    },
    showImg: function showImg() {
      var img = document.getElementById('bigpic');
      this.randomNum = Math.random();
      this.sourceOfPicture = '/media/shoulder/done/' + this.rowData.fixed_link_code.fixed_link_code + '/' + this.rowData.img_filename + '?t=' + this.randomNum;
      console.log(this.sourceOfPicture);
      if (img.style.display == "none") {
        this.img_string = "關閉照片";
        img.src = this.sourceOfPicture;
        img.style.display = "block";
        img.class = "car-image";
      } else {
        this.img_string = "顯示照片";
        img.style.display = "none";
      }
    },
    breakLaw: function breakLaw() {
      var _this5 = this;

      if (this.carName == '' || this.plt_no == '') {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '車號及車種資訊請勿空白'
        });
        return;
      }
      this.instance.patch('/api/shoulder-data/' + this.rowData.id + '/', {
        xactno: this.rowData.xactno,
        status: "t1",
        user: this.$store.state.user.user.username,
        car_name: this.carName,
        plt_no: this.plt_no
      }).then(function () {
        /*this.$parent.refresh();
        this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功, 已認證',
        });*/
        _this5.$parent.refresh();
      }).catch(function (err) {
        _this5.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: err.response.data
        });
      });
    },
    uncertain: function uncertain() {
      var _this6 = this;

      this.instance.patch('/api/shoulder-data/' + this.rowData.id + '/', {
        xactno: this.rowData.xactno,
        status: "t3",
        user: this.$store.state.user.user.username,
        car_name: this.carName,
        plt_no: this.plt_no
      }).then(function () {
        /*this.$parent.refresh();
        this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功',
        });*/
        _this6.$parent.refresh();
      }).catch(function (err) {
        _this6.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: err.response.data
        });
      });
    },
    pass: function pass() {
      var _this7 = this;

      this.instance.patch('/api/shoulder-data/' + this.rowData.id + '/', {
        xactno: this.rowData.xactno,
        status: "t2",
        user: this.$store.state.user.user.username,
        car_name: this.carName,
        plt_no: this.plt_no
      }).then(function () {
        /*this.$parent.refresh();
        this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功',
        });*/
        _this7.$parent.refresh();
      }).catch(function (err) {
        _this7.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: err.response.data
        });
      });
    },
    updateCarName: function updateCarName() {
      var _this8 = this;

      this.instance.patch('/api/shoulder-data/' + this.rowData.id + '/', {
        xactno: this.rowData.xactno,
        car_name: this.carName,
        plt_no: this.plt_no
      }).then(function () {
        /*this.$parent.refresh();
        this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功',
        });*/
        _this8.$parent.refresh();
      }).catch(function (err) {
        _this8.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: err.response.data
        });
      });
    }
  }
});

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetable_2_src_components_Vuetable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetable_2_src_components_Vuetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuetable_2_src_components_Vuetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vuex_functions_readCookie__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ShoulderCheckDetail__ = __webpack_require__(1210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ShoulderCheckDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ShoulderCheckDetail__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].component('shoulder-check-detail', __WEBPACK_IMPORTED_MODULE_11__ShoulderCheckDetail___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ShoulderList',
  data: function data() {
    return {
      tableDataLen: undefined,
      tmpId: '',
      startDate: undefined,
      endDate: undefined,
      loadingData: false,
      paras: [],
      boostrapCss: {
        tableClass: 'table table-striped table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: ''
          }
        }
      },
      httpOptions: {
        headers: {
          Authorization: 'Token ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__vuex_functions_readCookie__["a" /* default */])('Token')
        }
      },
      server: __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */],
      fields: [{
        name: 'xactno',
        sortField: 'xactno',
        title: '流水號'
      }, {
        name: 'plt_no.plt_no',
        //sortField: 'plt_no.plt_no',
        title: '車牌號碼'
      }, {
        name: 'car_tp.car_tp',
        title: '車別代碼'
      }, {
        name: 'vli_dateTime_in',
        sortField: 'vli_dateTime_in',
        title: '違規時間',
        callback: this.readableDate
      }, {
        name: 'fixed_link_code.fixed_link_code',
        title: '固定桿代碼'
      }, {
        name: 'rule_code.rule_code',
        title: '條款代碼'
      }, {
        name: 'status',
        title: '開單狀態',
        sortField: 'status',
        callback: this.status
      }],
      queryString: '',
      moreParams: {
        fixed_link_code_id: this.$store.state.user.user.department.fixed_link_code,
        start_date: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'),
        end_date: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD')
      }
    };
  },

  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_7_vuetable_2_src_components_Vuetable___default.a,
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_10__common_Loader___default.a
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getPara();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    startDate: function startDate(val) {
      if (val > this.endDate && this.endDate !== '') {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '開始時間不可晚於結束時間'
        });
        this.startDate = this.endDate;
      }
    },
    endDate: function endDate(val) {
      if (val < this.startDate && this.startDate !== '') {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '結束時間不可早於開始時間'
        });
        this.endDate = this.startDate;
      }
    }
  },
  methods: {
    onLoading: function onLoading() {
      this.loadingData = true;
      console.log('loading... show your spinner here');
    },
    onLoaded: function onLoaded() {
      this.loadingData = false;
      console.log('loaded! .. hide your spinner here');
      this.tableDataLen = this.$refs.vuetable.tableData.length;
      console.log('datalen:', this.tableDataLen);
      if (this.tableDataLen > 0) {
        console.log('id:', this.$refs.vuetable.tableData[0].id);
        this.onCellClicked(this.$refs.vuetable.tableData[0]);
      }
    },
    onCellClicked: function onCellClicked(data, field, event) {
      var _this2 = this;

      console.log('cellclicked');
      console.log('tmpId:', this.tmpId);
      console.log('nowId:', data.id);
      if (this.tmpId == '') this.tmpId = data.id;else if (this.tmpId !== '' && this.tmpId != data.id) {
        this.$refs.vuetable.toggleDetailRow(this.tmpId);
        this.tmpId = data.id;
      } else if (this.tmpId == data.id) this.tmpId = '';
      //this.$refs.vuetable.toggleDetailRow(data.id);
      setTimeout(function () {
        _this2.$refs.vuetable.toggleDetailRow(data.id);
      }, 50);
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet: function onFilterSet() {
      var _this3 = this;

      if (this.startDate == undefined || this.endDate == undefined) {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '請輸入查詢區間'
        });
        return;
      }
      if (this.queryString == "尚未處理") this.queryString = "t0";else if (this.queryString == "已開單") this.queryString = "t1";else if (this.queryString == "未違規") this.queryString = "t2";else if (this.queryString == "無法開單") this.queryString = "t3";
      this.moreParams = {
        search: this.queryString,
        fixed_link_code_id: this.$store.state.user.user.department.fixed_link_code,
        start_date: this.startDate,
        end_date: this.endDate
      };
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].nextTick(function () {
        return _this3.$refs.vuetable.refresh();
      });
    },
    getSortParam: function getSortParam(sortOrder) {
      return sortOrder.map(function (sort) {
        return (sort.direction === 'desc' ? '-' : '') + sort.field;
      }).join(',');
    },
    readableDate: function readableDate(value) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format('YY/MM/DD HH:mm:ss.SSS'); //0~23hr format
    },
    status: function status(value) {
      if (value == "t0") return "尚未處理";else if (value == "t1") return "已開單";else if (value == "t2") return "未違規";else if (value == "t3") return "無法開單";
    },
    getPara: function getPara() {
      var _this4 = this;

      return this.instance.get('/api/fixed-link-code/', {
        params: {
          fixed_link_code_id: this.$store.state.user.user.department.fixed_link_code
        }
      }).then(function (res) {
        _this4.paras = res.data;
      });
    }
  },
  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    },
    user: function user() {
      return this.$store.state.user;
    }
  }
  // computed: mapState({
  //   system: state => state.system,
  // }),
});

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_recaptcha__ = __webpack_require__(1560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminLogin',
  components: {
    VueRecaptcha: __WEBPACK_IMPORTED_MODULE_0_vue_recaptcha__["a" /* default */]
  },
  data: function data() {
    return {
      username: '',
      password: ''
    };
  },
  created: function created() {
    console.log('jquery:', jQuery().jquery);
  },

  methods: {
    onCaptchaVerified: function onCaptchaVerified(recaptchaToken) {
      var _this = this;

      this.$store.dispatch('loginAndGetUser', {
        username: this.username,
        password: this.password,
        recaptchaToken: recaptchaToken
      }).then(function () {
        if (_this.$store.state.user.user.is_admin === false) {
          _this.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: '您沒有權限登入後台，請聯絡管理員'
          });
        } else {
          _this.$router.push({ name: 'Admin' });
        }
      }).catch(function (err) {
        console.log(err.response);
        if (err.response !== undefined) {
          if (err.response.status == 401) {
            _this.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: '疑似為機器人，禁止登入'
            });
          } else {
            _this.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: '帳號或密碼錯誤'
            });
          }
        } else {
          _this.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: '伺服器連線失敗'
          });
        }
      });
    },
    onCaptchaExpired: function onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    },
    login: function login() {
      this.$refs.recaptcha.execute();
    }
  }
});

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_AdminPatch__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_AdminPatch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_AdminPatch__);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ADCManagement',
  components: {
    Patch: __WEBPACK_IMPORTED_MODULE_0__common_AdminPatch___default.a
  }
});

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_VuetablePagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_VuetablePagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_VuetablePagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetable_2_src_components_Vuetable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetable_2_src_components_Vuetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuetable_2_src_components_Vuetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__vuex_functions_readCookie__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ConfirmCheckDetail__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ConfirmCheckDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__ConfirmCheckDetail__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].component('confirm-check-detail', __WEBPACK_IMPORTED_MODULE_12__ConfirmCheckDetail___default.a);

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
  name: 'CarConfirmList',
  data: function data() {
    return {
      //20220307 add
      currentPage: 1,
      radioValue: 't1',
      statusType: 't1',
      waitConfirmFlag: false,
      tableConfirmData: [],
      tableDataLen: undefined,
      tmpId: '',
      startDate: undefined,
      endDate: undefined,
      loadingData: false,
      paras: [],
      boostrapCss: {
        tableClass: 'table table-striped table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: ''
          }
        }
      },
      httpOptions: {
        headers: {
          Authorization: 'Token ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__vuex_functions_readCookie__["a" /* default */])('Token')
        }
      },
      server: __WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */],
      fields: [
      //20220307 add
      {
        name: '__slot:index',
        title: '序號'
      },
      /*
      {
        name: 'xactno',
        sortField: 'xactno',
        title: '流水號',
      },
      */
      {
        name: 'plt_no.plt_no',
        //sortField: 'plt_no.plt_no',
        title: '車牌號碼'
      },
      /*
      {
        name: 'car_tp.car_tp',
        sortField: 'car_tp__car_tp',
        title: '車別代碼',
      },
      */
      {
        name: 'vli_dateTime_in',
        sortField: 'vli_dateTime_in',
        title: '進入時間',
        callback: this.readableDate
      }, {
        name: 'vli_dateTime_out',
        sortField: 'vli_dateTime_out',
        title: '離開時間',
        callback: this.readableDate
      }, {
        name: 'pass_time',
        title: '通過時間(秒)'
      }, {
        name: 'speed',
        sortField: 'speed',
        title: '車速'
      }, {
        name: 'fixed_link_code.fixed_link_code',
        title: '固定桿代碼'
      }, {
        name: 'rule_code.rule_code',
        title: '條款代碼'
      }, {
        name: 'status',
        title: '開單狀態',
        sortField: 'status',
        callback: this.status
      }, {
        name: 'user',
        sortField: 'user',
        title: '認證人員'
        //callback: this.status,
      }],
      sortOrder: [{
        sortField: 'car_tp__car_tp',
        direction: 'asc'
      }],
      queryString: '',
      moreParams: {
        fixed_link_code_id: this.$store.state.user.user.department.fixed_link_code,
        status: 't1',
        user: this.$store.state.user.user.username,
        start_date: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD'),
        end_date: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD'),
        department: this.$store.state.user.user.department.name,
        checked: false
      }
    };
  },

  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_8_vuetable_2_src_components_Vuetable___default.a,
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_VuetablePagination___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_11__common_Loader___default.a
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getPara();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    startDate: function startDate(val) {
      if (val > this.endDate && this.endDate !== '') {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '開始時間不可晚於結束時間'
        });
        this.startDate = this.endDate;
      }
    },
    endDate: function endDate(val) {
      if (val < this.startDate && this.startDate !== '') {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '結束時間不可早於開始時間'
        });
        this.endDate = this.startDate;
      }
    }
  },
  methods: {
    onLoading: function onLoading() {
      this.loadingData = true;
      console.log('loading... show your spinner here');
    },
    onLoaded: function onLoaded() {
      this.loadingData = false;
      console.log('loaded! .. hide your spinner here');
      this.tableDataLen = this.$refs.vuetable.tableData.length;
      this.tableConfirmData = this.$refs.vuetable.tableData;
      console.log('datalen:', this.tableDataLen);
      if (this.tableDataLen > 0) {
        console.log('id:', this.$refs.vuetable.tableData[0].id);
        this.onCellClicked(this.$refs.vuetable.tableData[0]);
      }
    },
    onCellClicked: function onCellClicked(data, field, event) {
      var _this2 = this;

      console.log('cellclicked');
      console.log('tmpId:', this.tmpId);
      console.log('nowId:', data.id);
      console.log('vuetable:', this.$refs.vuetable);
      if (this.tmpId == '') this.tmpId = data.id;else if (this.tmpId !== '' && this.tmpId != data.id) {
        this.$refs.vuetable.toggleDetailRow(this.tmpId);
        this.tmpId = data.id;
      } else if (this.tmpId == data.id) this.tmpId = '';
      //this.$refs.vuetable.toggleDetailRow(data.id);
      setTimeout(function () {
        _this2.$refs.vuetable.toggleDetailRow(data.id);
      }, 50);
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.currentPage = paginationData.current_page;
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    downloadErrorImg: function downloadErrorImg() {
      if (this.startDate == undefined || this.endDate == undefined) {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '請輸入查詢區間'
        });
        return;
      }
      window.open(__WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */] + '/download1236/download-zip-file/?fid=' + this.$store.state.user.user.department.fixed_link_code + '&start=' + this.startDate + '&end=' + this.endDate, '_blank');
    },
    confirmTicket: function confirmTicket() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var recordIDList;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.loadingData = true;
                _this3.waitConfirmFlag = true;
                recordIDList = [];

                console.log('this.tableConfirmData:', _this3.tableConfirmData);
                _this3.tableConfirmData.forEach(function (item) {
                  recordIDList.push(item.id);
                });
                _context2.next = 7;
                return _this3.instance.patch('/api/interval-speed-data/' + recordIDList[0] + '/', {
                  recordIDList: recordIDList,
                  reviewer: _this3.$store.state.user.user.username
                }).then(function (res) {
                  //this.$parent.refresh();
                  console.log(res.data);
                  window.open(__WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */] + '/download1236/download-zip-file/?zipFile=' + res.data, '_blank');
                  /*this.$store.commit('SET_MESSAGE', {
                    type: 'success',
                    context: '更新成功, 已開單',
                  });*/
                  var vm = _this3;
                  __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].nextTick(function () {
                    return _this3.$refs.vuetable.refresh();
                  });
                }).catch(function (err) {
                  _this3.$store.commit('SET_MESSAGE', {
                    type: 'error',
                    //context: err.response.data,
                    context: '錯誤,無法開單'
                    //context: err
                  });
                });

              case 7:
                _this3.waitConfirmFlag = false;
                _this3.loadingData = false;

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    onFilterSet: function onFilterSet() {
      var _this4 = this;

      if (this.startDate == undefined || this.endDate == undefined) {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '請輸入查詢區間'
        });
        return;
      }
      console.log('start:', this.startDate);
      console.log('end:', this.endDate);
      /*
      if(this.queryString=="尚未處理")
          this.queryString="t0"
        else if(this.queryString=="已開單")
          this.queryString="t1"
        else if(this.queryString=="未違規")
          this.queryString="t2"  
        else if(this.queryString=="無法開單")
          this.queryString="t3" 
      */
      this.moreParams = {
        search: this.queryString,
        fixed_link_code_id: this.$store.state.user.user.department.fixed_link_code,
        //status: 't1',
        status: this.statusType,
        user: this.$store.state.user.user.username,
        start_date: this.startDate,
        end_date: this.endDate,
        department: this.$store.state.user.user.department.name,
        checked: false
      };
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].nextTick(function () {
        return _this4.$refs.vuetable.refresh();
      });
    },
    getSortParam: function getSortParam(sortOrder) {
      return sortOrder.map(function (sort) {
        return (sort.direction === 'desc' ? '-' : '') + sort.sortField;
      }).join(',');
    },
    readableDate: function readableDate(value) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format('YY/MM/DD HH:mm:ss.SSS'); //0~23hr format
    },

    /*
    status(value) {
      if(value=="t0")
        return "尚未處理"
      else if(value=="t1")
        return "已開單"
      else if(value=="t2")
        return "未違規"
      else if(value=="t3")
        return "無法開單"
    },
    */
    getPara: function getPara() {
      var _this5 = this;

      return this.instance.get('/api/fixed-link-code/', {
        params: {
          fixed_link_code_id: this.$store.state.user.user.department.fixed_link_code
        }
      }).then(function (res) {
        _this5.paras = res.data;
      });
    }
  },
  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    },
    user: function user() {
      return this.$store.state.user;
    }
  }
}, 'watch', {
  radioValue: function radioValue(val) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this6.loadingData = true;
              _this6.statusType = val;
              console.log('statusType:', _this6.statusType);
              _this6.moreParams['status'] = _this6.statusType;
              console.log('this.moreParams:', _this6.moreParams);
              _context3.next = 7;
              return _this6.instance.get('/api/interval-speed-data/', _this6.moreParams).then(function () {
                var vm = _this6;
                __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].nextTick(function () {
                  return _this6.$refs.vuetable.refresh();
                });
              }).catch(function (err) {
                _this6.$store.commit('SET_MESSAGE', {
                  type: 'error',
                  context: err.response.data
                });
              });

            case 7:
              _this6.loadingData = false;

            case 8:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this6);
    }))();
  }
}));

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(8);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ConfirmCheckDetail',
  data: function data() {
    return {
      status: null,
      sourceOfPicture: '',
      img_string: '顯示照片',
      //carName: '',
      randomNum: ''
    };
  },

  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  components: {},
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var img;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              img = document.getElementById('bigpic');

              _this.randomNum = Math.random();
              _this.sourceOfPicture = '/media/interval/done/' + _this.rowData.fixed_link_code.fixed_link_code + '/' + _this.rowData.img_filename + '?t=' + _this.randomNum;
              _this.img_string = "關閉照片";
              img.src = _this.sourceOfPicture;
              img.style.display = "block";
              img.class = "car-image";

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  methods: {
    showImg: function showImg() {
      var img = document.getElementById('bigpic');
      this.randomNum = Math.random();
      this.sourceOfPicture = '/media/interval/done/' + this.rowData.fixed_link_code.fixed_link_code + '/' + this.rowData.img_filename + '?t=' + this.randomNum;
      console.log(this.sourceOfPicture);
      if (img.style.display == "none") {
        this.img_string = "關閉照片";
        img.src = this.sourceOfPicture;
        img.style.display = "block";
        img.class = "car-image";
      } else {
        this.img_string = "顯示照片";
        img.style.display = "none";
      }
    },
    returnModify: function returnModify() {
      var _this2 = this;

      this.instance.patch('/api/interval-speed-data/' + this.rowData.id + '/', {
        xactno: this.rowData.xactno,
        status: "t0"
      }).then(function () {
        //this.$parent.refresh();
        /*this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功, 已退回',
        });*/
        _this2.$parent.refresh();
      }).catch(function (err) {
        _this2.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: err.response.data
        });
      });
    }
  }
});

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(8);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'confirmCrossLineCheckDetail',
  data: function data() {
    return {
      status: null,
      sourceOfPicture: '',
      img_string: '顯示照片',
      //carName: '',
      randomNum: ''
    };
  },

  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  components: {},
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var img;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              img = document.getElementById('bigpic');

              _this.randomNum = Math.random();
              _this.sourceOfPicture = '/media/crossline/done/' + _this.rowData.fixed_link_code.fixed_link_code + '/' + _this.rowData.img_filename + '?t=' + _this.randomNum;
              _this.img_string = "關閉照片";
              img.src = _this.sourceOfPicture;
              img.style.display = "block";
              img.class = "car-image";

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  methods: {
    showImg: function showImg() {
      var img = document.getElementById('bigpic');
      this.randomNum = Math.random();
      this.sourceOfPicture = '/media/crossline/done/' + this.rowData.fixed_link_code.fixed_link_code + '/' + this.rowData.img_filename + '?t=' + this.randomNum;
      console.log(this.sourceOfPicture);
      if (img.style.display == "none") {
        this.img_string = "關閉照片";
        img.src = this.sourceOfPicture;
        img.style.display = "block";
        img.class = "car-image";
      } else {
        this.img_string = "顯示照片";
        img.style.display = "none";
      }
    },
    returnModify: function returnModify() {
      var _this2 = this;

      this.instance.patch('/api/cross-line-data/' + this.rowData.id + '/', {
        xactno: this.rowData.xactno,
        status: "t0"
      }).then(function () {
        //this.$parent.refresh();
        /*this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功, 已退回',
        });*/
        _this2.$parent.refresh();
      }).catch(function (err) {
        _this2.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: err.response.data
        });
      });
    }
  }
});

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(10);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//import 'video.js/dist/video-js.css'
//import VueVideoPlayer from 'vue-video-player'


//Vue.use(VueVideoPlayer)

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'confirmShoulderCheckDetail',
  data: function data() {
    return {
      status: null,
      sourceOfPicture: '',
      img_string: '顯示照片',
      //carName: '',
      randomNum: ''
      /*
      playerOptions: {
          // videojs options
          muted: true,
          language: 'en',
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          autoplay: true,
          width: 800,
          sources: [{
            type: "video/mp4",
            src: "",
          }],
      },
      playVideoFlag: false,
      playVideoMsg: "撥放影片",
      sourceOfVideo: '',
      */
    };
  },

  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  components: {},
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var img;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              img = document.getElementById('bigpic');

              _this.randomNum = Math.random();
              _this.sourceOfPicture = '/media/shoulder/done/' + _this.rowData.fixed_link_code.fixed_link_code + '/' + _this.rowData.img_filename + '?t=' + _this.randomNum;
              _this.img_string = "關閉照片";
              img.src = _this.sourceOfPicture;
              img.style.display = "block";
              img.class = "car-image";
              //////
              /*
              var newFilename = this.rowData.img_filename.replace('jpg', 'mp4'); 
              console.log('newFilename:', newFilename);
              this.sourceOfVideo = `/media/shoulder/done/${this.rowData.fixed_link_code.fixed_link_code}/${newFilename}`;
              console.log('sourceOfVideo:',this.sourceOfVideo);
              this.playerOptions.sources[0].src=this.sourceOfVideo;
              */
              ////////

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  methods: {
    /*
    playVideo() {  
      if(this.playVideoMsg=="撥放影片") {
        console.log('1');
        var img = document.getElementById('bigpic')
        this.img_string="顯示照片";
        img.style.display = "none";  
        this.playVideoMsg="結束撥放";
        this.playVideoFlag = true;      
      }
      else {
        console.log('2'); 
        this.playVideoMsg="撥放影片";
        this.playVideoFlag = false;          
      }
    },
    // listen event
    onPlayerPlay(player) {
      // console.log('player play!', player)
    },
    onPlayerPause(player) {
      // console.log('player pause!', player)
    },
    // ...player event
     // or listen state event
    playerStateChanged(playerCurrentState) {
      // console.log('player current update state', playerCurrentState)
    },
     // player is ready
    playerReadied(player) {
      console.log('the player is readied', player)
      // you can use it to do something...
      // player.[methods]
    },
    */
    showImg: function showImg() {
      var img = document.getElementById('bigpic');
      this.randomNum = Math.random();
      this.sourceOfPicture = '/media/shoulder/done/' + this.rowData.fixed_link_code.fixed_link_code + '/' + this.rowData.img_filename + '?t=' + this.randomNum;
      console.log(this.sourceOfPicture);
      if (img.style.display == "none") {
        this.img_string = "關閉照片";
        img.src = this.sourceOfPicture;
        img.style.display = "block";
        img.class = "car-image";
      } else {
        this.img_string = "顯示照片";
        img.style.display = "none";
      }
    },
    returnModify: function returnModify() {
      var _this2 = this;

      this.instance.patch('/api/shoulder-data/' + this.rowData.id + '/', {
        xactno: this.rowData.xactno,
        status: "t0"
      }).then(function () {
        /*this.$parent.refresh();
        this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功, 已退回',
        });*/
        _this2.$parent.refresh();
      }).catch(function (err) {
        _this2.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: err.response.data
        });
      });
    }
  }
});

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetable_2_src_components_Vuetable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetable_2_src_components_Vuetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuetable_2_src_components_Vuetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vuex_functions_readCookie__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ConfirmCrossLineCheckDetail__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ConfirmCrossLineCheckDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ConfirmCrossLineCheckDetail__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].component('confirm-cross-line-check-detail', __WEBPACK_IMPORTED_MODULE_11__ConfirmCrossLineCheckDetail___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ConfirmCrossLineList',
  data: function data() {
    return {
      waitConfirmFlag: false,
      tableConfirmData: [],
      tableDataLen: undefined,
      tmpId: '',
      startDate: undefined,
      endDate: undefined,
      loadingData: false,
      paras: [],
      boostrapCss: {
        tableClass: 'table table-striped table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: ''
          }
        }
      },
      httpOptions: {
        headers: {
          Authorization: 'Token ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__vuex_functions_readCookie__["a" /* default */])('Token')
        }
      },
      server: __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */],
      fields: [{
        name: 'xactno',
        sortField: 'xactno',
        title: '流水號'
      }, {
        name: 'plt_no.plt_no',
        //sortField: 'plt_no.plt_no',
        title: '車牌號碼'
      }, {
        name: 'car_tp.car_tp',
        sortField: 'car_tp__car_tp',
        title: '車別代碼'
      }, {
        name: 'vli_dateTime_in',
        sortField: 'vli_dateTime_in',
        title: '違規時間',
        callback: this.readableDate
      }, {
        name: 'fixed_link_code.fixed_link_code',
        title: '固定桿代碼'
      }, {
        name: 'rule_code.rule_code',
        title: '條款代碼'
      },
      /*{
        name: 'status',
        title: '開單狀態',
        sortField: 'status',
        callback: this.status,
      },*/
      {
        name: 'user',
        sortField: 'user',
        title: '認證人員'
        //callback: this.status,
      }],
      sortOrder: [{
        sortField: 'car_tp__car_tp',
        direction: 'asc'
      }],
      queryString: '',
      moreParams: {
        fixed_link_code_id: this.$store.state.user.user.department.fixed_link_code,
        status: 't1',
        user: this.$store.state.user.user.username,
        start_date: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'),
        end_date: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'),
        department: this.$store.state.user.user.department.name,
        checked: false
      }
    };
  },

  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_7_vuetable_2_src_components_Vuetable___default.a,
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_10__common_Loader___default.a
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getPara();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    startDate: function startDate(val) {
      if (val > this.endDate && this.endDate !== '') {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '開始時間不可晚於結束時間'
        });
        this.startDate = this.endDate;
      }
    },
    endDate: function endDate(val) {
      if (val < this.startDate && this.startDate !== '') {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '結束時間不可早於開始時間'
        });
        this.endDate = this.startDate;
      }
    }
  },
  methods: {
    onLoading: function onLoading() {
      this.loadingData = true;
      console.log('loading... show your spinner here');
    },
    onLoaded: function onLoaded() {
      this.loadingData = false;
      console.log('loaded! .. hide your spinner here');
      this.tableDataLen = this.$refs.vuetable.tableData.length;
      this.tableConfirmData = this.$refs.vuetable.tableData;
      console.log('datalen:', this.tableDataLen);
      if (this.tableDataLen > 0) {
        console.log('id:', this.$refs.vuetable.tableData[0].id);
        this.onCellClicked(this.$refs.vuetable.tableData[0]);
      }
    },
    onCellClicked: function onCellClicked(data, field, event) {
      var _this2 = this;

      console.log('cellclicked');
      console.log('tmpId:', this.tmpId);
      console.log('nowId:', data.id);
      if (this.tmpId == '') this.tmpId = data.id;else if (this.tmpId !== '' && this.tmpId != data.id) {
        this.$refs.vuetable.toggleDetailRow(this.tmpId);
        this.tmpId = data.id;
      } else if (this.tmpId == data.id) this.tmpId = '';
      //this.$refs.vuetable.toggleDetailRow(data.id);
      setTimeout(function () {
        _this2.$refs.vuetable.toggleDetailRow(data.id);
      }, 50);
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    downloadErrorImg: function downloadErrorImg() {
      if (this.startDate == undefined || this.endDate == undefined) {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '請輸入查詢區間'
        });
        return;
      }
      window.open(__WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */] + '/download1236/download-zip-file/?fid=' + this.$store.state.user.user.department.fixed_link_code + '&start=' + this.startDate + '&end=' + this.endDate, '_blank');
    },
    confirmTicket: function confirmTicket() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var recordIDList;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.loadingData = true;
                _this3.waitConfirmFlag = true;
                recordIDList = [];

                console.log('this.tableConfirmData:', _this3.tableConfirmData);
                _this3.tableConfirmData.forEach(function (item) {
                  recordIDList.push(item.id);
                });
                _context2.next = 7;
                return _this3.instance.patch('/api/cross-line-data/' + recordIDList[0] + '/', {
                  recordIDList: recordIDList,
                  reviewer: _this3.$store.state.user.user.username
                }).then(function (res) {
                  //this.$parent.refresh();
                  console.log(res.data);
                  window.open(__WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */] + '/download1236/download-zip-file/?zipFile=' + res.data, '_blank');
                  /*this.$store.commit('SET_MESSAGE', {
                    type: 'success',
                    context: '更新成功, 已開單',
                  });*/
                  var vm = _this3;
                  __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].nextTick(function () {
                    return _this3.$refs.vuetable.refresh();
                  });
                }).catch(function (err) {
                  _this3.$store.commit('SET_MESSAGE', {
                    type: 'error',
                    //context: err.response.data,
                    //context: '錯誤,無法開單'
                    context: err
                  });
                });

              case 7:
                _this3.waitConfirmFlag = false;
                _this3.loadingData = false;

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    onFilterSet: function onFilterSet() {
      var _this4 = this;

      if (this.startDate == undefined || this.endDate == undefined) {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '請輸入查詢區間'
        });
        return;
      }
      /*
         if(this.queryString=="尚未處理")
             this.queryString="t0"
           else if(this.queryString=="已開單")
             this.queryString="t1"
           else if(this.queryString=="未違規")
             this.queryString="t2"  
           else if(this.queryString=="無法開單")
             this.queryString="t3"
         */
      this.moreParams = {
        search: this.queryString,
        fixed_link_code_id: this.$store.state.user.user.department.fixed_link_code,
        status: 't1',
        user: this.$store.state.user.user.username,
        start_date: this.startDate,
        end_date: this.endDate,
        department: this.$store.state.user.user.department.name,
        checked: false
      };
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].nextTick(function () {
        return _this4.$refs.vuetable.refresh();
      });
    },
    getSortParam: function getSortParam(sortOrder) {
      return sortOrder.map(function (sort) {
        return (sort.direction === 'desc' ? '-' : '') + sort.sortField;
      }).join(',');
    },
    readableDate: function readableDate(value) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format('YY/MM/DD HH:mm:ss.SSS'); //0~23hr format
    },

    /*
       status(value) {
         if(value=="t0")
           return "尚未處理"
         else if(value=="t1")
           return "已開單"
         else if(value=="t2")
           return "未違規"
         else if(value=="t3")
           return "無法開單"
       },
    */
    getPara: function getPara() {
      var _this5 = this;

      return this.instance.get('/api/fixed-link-code/', {
        params: {
          fixed_link_code_id: this.$store.state.user.user.department.fixed_link_code
        }
      }).then(function (res) {
        _this5.paras = res.data;
      });
    }
  },
  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    },
    user: function user() {
      return this.$store.state.user;
    }
  }
  // computed: mapState({
  //   system: state => state.system,
  // }),
});

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetable_2_src_components_Vuetable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetable_2_src_components_Vuetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuetable_2_src_components_Vuetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vuex_functions_readCookie__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ConfirmShoulderCheckDetail__ = __webpack_require__(1217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ConfirmShoulderCheckDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ConfirmShoulderCheckDetail__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].component('confirm-shoulder-check-detail', __WEBPACK_IMPORTED_MODULE_11__ConfirmShoulderCheckDetail___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ConfirmShoulderList',
  data: function data() {
    return {
      waitConfirmFlag: false,
      tableConfirmData: [],
      tableDataLen: undefined,
      tmpId: '',
      startDate: undefined,
      endDate: undefined,
      loadingData: false,
      paras: [],
      boostrapCss: {
        tableClass: 'table table-striped table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: ''
          }
        }
      },
      httpOptions: {
        headers: {
          Authorization: 'Token ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__vuex_functions_readCookie__["a" /* default */])('Token')
        }
      },
      server: __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */],
      fields: [{
        name: 'xactno',
        sortField: 'xactno',
        title: '流水號'
      }, {
        name: 'plt_no.plt_no',
        //sortField: 'plt_no.plt_no',
        title: '車牌號碼'
      }, {
        name: 'car_tp.car_tp',
        sortField: 'car_tp__car_tp',
        title: '車別代碼'
      }, {
        name: 'vli_dateTime_in',
        sortField: 'vli_dateTime_in',
        title: '違規時間',
        callback: this.readableDate
      }, {
        name: 'fixed_link_code.fixed_link_code',
        title: '固定桿代碼'
      }, {
        name: 'rule_code.rule_code',
        title: '條款代碼'
      },
      /*{
        name: 'status',
        title: '開單狀態',
        sortField: 'status',
        callback: this.status,
      },*/
      {
        name: 'user',
        sortField: 'user',
        title: '認證人員'
        //callback: this.status,
      }],
      sortOrder: [{
        sortField: 'car_tp__car_tp',
        direction: 'asc'
      }],
      queryString: '',
      moreParams: {
        fixed_link_code_id: this.$store.state.user.user.department.fixed_link_code,
        status: 't1',
        user: this.$store.state.user.user.username,
        start_date: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'),
        end_date: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'),
        department: this.$store.state.user.user.department.name,
        checked: false
      }
    };
  },

  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_7_vuetable_2_src_components_Vuetable___default.a,
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_10__common_Loader___default.a
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getPara();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    startDate: function startDate(val) {
      if (val > this.endDate && this.endDate !== '') {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '開始時間不可晚於結束時間'
        });
        this.startDate = this.endDate;
      }
    },
    endDate: function endDate(val) {
      if (val < this.startDate && this.startDate !== '') {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '結束時間不可早於開始時間'
        });
        this.endDate = this.startDate;
      }
    }
  },
  methods: {
    onLoading: function onLoading() {
      this.loadingData = true;
      console.log('loading... show your spinner here');
    },
    onLoaded: function onLoaded() {
      this.loadingData = false;
      console.log('loaded! .. hide your spinner here');
      this.tableDataLen = this.$refs.vuetable.tableData.length;
      this.tableConfirmData = this.$refs.vuetable.tableData;
      console.log('datalen:', this.tableDataLen);
      if (this.tableDataLen > 0) {
        console.log('id:', this.$refs.vuetable.tableData[0].id);
        this.onCellClicked(this.$refs.vuetable.tableData[0]);
      }
    },
    onCellClicked: function onCellClicked(data, field, event) {
      var _this2 = this;

      console.log('cellclicked');
      console.log('tmpId:', this.tmpId);
      console.log('nowId:', data.id);
      if (this.tmpId == '') this.tmpId = data.id;else if (this.tmpId !== '' && this.tmpId != data.id) {
        this.$refs.vuetable.toggleDetailRow(this.tmpId);
        this.tmpId = data.id;
      } else if (this.tmpId == data.id) this.tmpId = '';
      //this.$refs.vuetable.toggleDetailRow(data.id);
      setTimeout(function () {
        _this2.$refs.vuetable.toggleDetailRow(data.id);
      }, 50);
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    downloadErrorImg: function downloadErrorImg() {
      if (this.startDate == undefined || this.endDate == undefined) {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '請輸入查詢區間'
        });
        return;
      }
      window.open(__WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */] + '/download1236/download-zip-file/?fid=' + this.$store.state.user.user.department.fixed_link_code + '&start=' + this.startDate + '&end=' + this.endDate + '&shoulder=1', '_blank');
    },
    confirmTicket: function confirmTicket() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var recordIDList;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.loadingData = true;
                _this3.waitConfirmFlag = true;
                recordIDList = [];

                console.log('this.tableConfirmData:', _this3.tableConfirmData);
                _this3.tableConfirmData.forEach(function (item) {
                  recordIDList.push(item.id);
                });
                _context2.next = 7;
                return _this3.instance.patch('/api/shoulder-data/' + recordIDList[0] + '/', {
                  recordIDList: recordIDList,
                  reviewer: _this3.$store.state.user.user.username
                }).then(function (res) {
                  //this.$parent.refresh();
                  console.log(res.data);
                  window.open(__WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */] + '/download1236/download-zip-file/?zipFile=' + res.data, '_blank');
                  /*this.$store.commit('SET_MESSAGE', {
                    type: 'success',
                    context: '更新成功, 已開單',
                  });*/
                  var vm = _this3;
                  __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].nextTick(function () {
                    return _this3.$refs.vuetable.refresh();
                  });
                }).catch(function (err) {
                  _this3.$store.commit('SET_MESSAGE', {
                    type: 'error',
                    //context: err.response.data,
                    //context: '錯誤,無法開單'
                    context: err
                  });
                });

              case 7:
                _this3.waitConfirmFlag = false;
                _this3.loadingData = false;

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    onFilterSet: function onFilterSet() {
      var _this4 = this;

      if (this.startDate == undefined || this.endDate == undefined) {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '請輸入查詢區間'
        });
        return;
      }
      /*
         if(this.queryString=="尚未處理")
             this.queryString="t0"
           else if(this.queryString=="已開單")
             this.queryString="t1"
           else if(this.queryString=="未違規")
             this.queryString="t2"  
           else if(this.queryString=="無法開單")
             this.queryString="t3"
         */
      this.moreParams = {
        search: this.queryString,
        fixed_link_code_id: this.$store.state.user.user.department.fixed_link_code,
        status: 't1',
        user: this.$store.state.user.user.username,
        start_date: this.startDate,
        end_date: this.endDate,
        department: this.$store.state.user.user.department.name,
        checked: false
      };
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].nextTick(function () {
        return _this4.$refs.vuetable.refresh();
      });
    },
    getSortParam: function getSortParam(sortOrder) {
      return sortOrder.map(function (sort) {
        return (sort.direction === 'desc' ? '-' : '') + sort.sortField;
      }).join(',');
    },
    readableDate: function readableDate(value) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format('YY/MM/DD HH:mm:ss.SSS'); //0~23hr format
    },

    /*
       status(value) {
         if(value=="t0")
           return "尚未處理"
         else if(value=="t1")
           return "已開單"
         else if(value=="t2")
           return "未違規"
         else if(value=="t3")
           return "無法開單"
       },
    */
    getPara: function getPara() {
      var _this5 = this;

      return this.instance.get('/api/fixed-link-code/', {
        params: {
          fixed_link_code_id: this.$store.state.user.user.department.fixed_link_code
        }
      }).then(function (res) {
        _this5.paras = res.data;
      });
    }
  },
  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    },
    user: function user() {
      return this.$store.state.user;
    }
  }
  // computed: mapState({
  //   system: state => state.system,
  // }),
});

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_AdminPatch__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_AdminPatch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_AdminPatch__);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ADCManagement',
  components: {
    Patch: __WEBPACK_IMPORTED_MODULE_0__common_AdminPatch___default.a
  }
});

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DataImportBase',
  props: ['title', 'uploadUrl', 'downloadUrl'],
  data: function data() {
    return {
      uploadFile: '',
      uploadProgress: 0,
      resultMsg: []
    };
  },

  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  methods: {
    onChange: function onChange(event) {
      this.uploadFile = event.target.files;
    },
    upload: function upload() {
      var _this = this;

      if (this.uploadFile !== '') {
        // if (this.uploadFile[0].type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        this.resultMsg = [];
        var data = new FormData();
        data.append('file', this.uploadFile[0]);
        this.instance.post(this.uploadUrl, data, {
          onUploadProgress: function onUploadProgress(progressEvent) {
            console.log('event: ', progressEvent.loaded, progressEvent.total, progressEvent.loaded / progressEvent.total);
            _this.uploadProgress = progressEvent.loaded / progressEvent.total * 100;
          },
          timeout: 60000,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function (res) {
          console.log('done');
          _this.uploadProgress = 0;
          _this.$store.commit('SET_MESSAGE', {
            type: 'success',
            context: '更新完成'
          });
          res.data.split('->').forEach(function (msg) {
            _this.resultMsg.push(msg);
          });
        }).catch(function (error) {
          var context = '';
          if (error.response) {
            context = error.response.data;
          }

          _this.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: '\u4E0A\u50B3\u5931\u6557: ' + context
          });

          _this.uploadProgress = 0;
        });
        // } else {
        //   this.$store.commit('SET_MESSAGE', {
        //     type: 'error',
        //     context: '請確認上傳檔案為.xlsx',
        //   });
        // }
      } else {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '請先選擇上傳檔案'
        });
      }
    },
    download: function download() {
      window.open('' + __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */] + this.downloadUrl, '_blank');
    }
  }
});

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataImportBase__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataImportBase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__DataImportBase__);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DrugImport',
  components: {
    DataImportBase: __WEBPACK_IMPORTED_MODULE_0__DataImportBase___default.a
  }
});

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataImportBase__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataImportBase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__DataImportBase__);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TagDrugStorageImport',
  components: {
    DataImportBase: __WEBPACK_IMPORTED_MODULE_0__DataImportBase___default.a
  }
});

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataImportBase__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataImportBase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__DataImportBase__);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserImport',
  components: {
    DataImportBase: __WEBPACK_IMPORTED_MODULE_0__DataImportBase___default.a
  }
});

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LockedMask',
  computed: {
    loginedUsers: function loginedUsers() {
      return this.$store.getters.loginedUsers;
    }
  }
});

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_AdminPatch__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_AdminPatch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_AdminPatch__);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ADCManagement',
  components: {
    Patch: __WEBPACK_IMPORTED_MODULE_0__common_AdminPatch___default.a
  }
});

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_file_saver__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__QueryFilter__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__QueryFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__QueryFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CrossLineReport',
  components: {
    QueryFilter: __WEBPACK_IMPORTED_MODULE_4__QueryFilter___default.a
  },
  data: function data() {
    return {
      reportFunctions: [],
      downloadProgress: undefined,
      department: this.$store.state.user.user.department.name,
      isMerge: false
    };
  },

  computed: {
    instance: function instance() {
      return this.$store.getters.instance;
    }
  },
  methods: {
    dateFilled: function dateFilled(emitPayload) {
      if (emitPayload.start_date === undefined || emitPayload.start_date === '' || emitPayload.end_date === undefined || emitPayload.end_date === '') {
        return false;
      }
      return true;
    },
    getReportFunctions: function getReportFunctions() {
      var _this = this;

      this.reportFunctions = [];
      this.instance.get('/api/report-functions/').then(function (res) {
        res.data.forEach(function (item) {
          if (item.function_name.search("cross") !== -1 && item.on_status) {
            _this.reportFunctions.push(item);
          }
        });
      });
    },
    connectWebSocket: function connectWebSocket(filename) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, rejects) {
        var wb = new WebSocket(__WEBPACK_IMPORTED_MODULE_3__config__["c" /* webSocketServer */] + '/download-report/' + _this2.$store.state.user.user.id);
        wb.onopen = function () {
          _this2.downloadProgress = 0;
          resolve(wb);
        };
        wb.onmessage = function (res) {
          var data = JSON.parse(res.data);
          if (data.error) {
            _this2.$store.commit('CLOSE_MESSAGE');
            _this2.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: data.error
            });
          }

          if (data.progress !== undefined) {
            _this2.downloadProgress = parseFloat(data.progress);
          }
          if (data.download_path !== undefined) {
            //this.instance.get(data.download_path, { responseType: 'blob' })
            //20200807 add
            __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(data.download_path, { responseType: 'blob' }).then(function (res) {
              __WEBPACK_IMPORTED_MODULE_2_file_saver___default.a.saveAs(res.data, filename + '.xlsx');
              _this2.$store.commit('SET_MESSAGE', {
                type: 'success',
                context: '下載成功'
              });
            });
            wb.close(); // close the socket after downloading
          }
        };
        wb.onclose = function () {
          rejects(wb);
        };
      });
    },
    downloadReport: function downloadReport(params, functionName, FileName) {
      var _this3 = this;

      params.function_name = functionName;
      this.connectWebSocket(FileName).then(function (wb) {
        wb.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params));
      }).catch(function (wb) {
        _this3.$store.commit('SET_MESSAGE', { type: 'error', context: '下載失敗' });
        wb.close();
      });
    },

    // downloadReport(emitPayload, functionName, FileName) {
    //   this.$store.commit('SET_MESSAGE', {
    //     type: 'warn',
    //     context: '下載中...',
    //   });
    //   emitPayload.function_name = functionName;
    //   this.instance.get('/export-report/', {
    //     params: emitPayload,
    //     responseType: 'blob',
    //   })
    //   .then((res) => {
    //     console.log('download success');
    //     FileSaver.saveAs(res.data, `AUTOIX-${FileName}.xlsx`);
    //     this.$store.commit('CLOSE_MESSAGE');
    //   })
    //   .catch((err) => {
    //     const reader = new FileReader();
    //     reader.addEventListener('loadend', (e) => {
    //       const eventCount = parseInt(e.srcElement.result, 10);
    //       if (eventCount > 0) {
    //         this.$store.commit('SET_MESSAGE', {
    //           type: 'error',
    //           context: '範圍資料過多，請縮小範圍',
    //         });
    //       }
    //       if (eventCount === 0) {
    //         this.$store.commit('SET_MESSAGE', {
    //           type: 'error',
    //           context: '範圍內無資料',
    //         });
    //       }
    //     });
    //     reader.readAsText(err.response.data);
    //   });
    // },
    report: function report(emitPayload, functionName, FileName, useDate) {
      if (this.isMerge == false) {
        emitPayload.fixed_link_code_id = this.$store.state.user.user.department.fixed_link_code;
      } else {
        emitPayload.fixed_link_code_id = '';
      }
      if (useDate) {
        if (this.dateFilled(emitPayload) === false) {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: '請確定已選填日期'
          });
        } else {
          this.downloadReport(emitPayload, functionName, FileName);
        }
      } else {
        this.downloadReport(emitPayload, functionName, FileName);
      }
    }
  },
  created: function created() {
    this.getReportFunctions();
  },

  watch: {
    downloadProgress: function downloadProgress(val) {
      console.log(val);
      this.$store.commit('SET_MESSAGE', {
        context: '\n        <h6>\u7522\u751F\u5831\u544A\u4E2D</h6>\n        <div class="progress">\n          <div class="progress-bar progress-bar-striped" \n            role="progressbar" \n            style="width: ' + val + '%; background-color: #117a8b" \n            aria-valuenow="' + val + '" \n            aria-valuemin="0" \n            aria-valuemax="100">\n          </div>\n        </div>\n        ',
        type: 'clean',
        confirm: false
      });
    }
  }
});

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_file_saver__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__QueryFilter__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__QueryFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__QueryFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CustomReport',
  components: {
    QueryFilter: __WEBPACK_IMPORTED_MODULE_4__QueryFilter___default.a
  },
  data: function data() {
    return {
      reportFunctions: [],
      downloadProgress: undefined,
      department: this.$store.state.user.user.department.name,
      isMerge: false,
      radioValue: 'illegalCar'
    };
  },

  computed: {
    instance: function instance() {
      return this.$store.getters.instance;
    }
  },
  methods: {
    dateFilled: function dateFilled(emitPayload) {
      if (emitPayload.start_date === undefined || emitPayload.start_date === '' || emitPayload.end_date === undefined || emitPayload.end_date === '') {
        return false;
      }
      return true;
    },
    getReportFunctions: function getReportFunctions() {
      var _this = this;

      this.reportFunctions = [];
      this.instance.get('/api/report-functions/').then(function (res) {
        res.data.forEach(function (item) {
          if (item.function_name.search("car") !== -1 && item.on_status) {
            _this.reportFunctions.push(item);
          }
        });
      });
    },
    connectWebSocket: function connectWebSocket(filename) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, rejects) {
        var wb = new WebSocket(__WEBPACK_IMPORTED_MODULE_3__config__["c" /* webSocketServer */] + '/download-report/' + _this2.$store.state.user.user.id);
        wb.onopen = function () {
          _this2.downloadProgress = 0;
          resolve(wb);
        };
        wb.onmessage = function (res) {
          var data = JSON.parse(res.data);
          if (data.error) {
            _this2.$store.commit('CLOSE_MESSAGE');
            _this2.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: data.error
            });
          }

          if (data.progress !== undefined) {
            _this2.downloadProgress = parseFloat(data.progress);
          }
          if (data.download_path !== undefined) {
            //this.instance.get(data.download_path, { responseType: 'blob' })
            //20200807 add
            __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(data.download_path, { responseType: 'blob' }).then(function (res) {
              __WEBPACK_IMPORTED_MODULE_2_file_saver___default.a.saveAs(res.data, filename + '.xlsx');
              _this2.$store.commit('SET_MESSAGE', {
                type: 'success',
                context: '下載成功'
              });
            });
            wb.close(); // close the socket after downloading
          }
        };
        wb.onclose = function () {
          rejects(wb);
        };
      });
    },
    downloadReport: function downloadReport(params, functionName, FileName) {
      var _this3 = this;

      params.function_name = functionName;
      this.connectWebSocket(FileName).then(function (wb) {
        wb.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params));
      }).catch(function (wb) {
        _this3.$store.commit('SET_MESSAGE', { type: 'error', context: '下載失敗' });
        wb.close();
      });
    },

    // downloadReport(emitPayload, functionName, FileName) {
    //   this.$store.commit('SET_MESSAGE', {
    //     type: 'warn',
    //     context: '下載中...',
    //   });
    //   emitPayload.function_name = functionName;
    //   this.instance.get('/export-report/', {
    //     params: emitPayload,
    //     responseType: 'blob',
    //   })
    //   .then((res) => {
    //     console.log('download success');
    //     FileSaver.saveAs(res.data, `AUTOIX-${FileName}.xlsx`);
    //     this.$store.commit('CLOSE_MESSAGE');
    //   })
    //   .catch((err) => {
    //     const reader = new FileReader();
    //     reader.addEventListener('loadend', (e) => {
    //       const eventCount = parseInt(e.srcElement.result, 10);
    //       if (eventCount > 0) {
    //         this.$store.commit('SET_MESSAGE', {
    //           type: 'error',
    //           context: '範圍資料過多，請縮小範圍',
    //         });
    //       }
    //       if (eventCount === 0) {
    //         this.$store.commit('SET_MESSAGE', {
    //           type: 'error',
    //           context: '範圍內無資料',
    //         });
    //       }
    //     });
    //     reader.readAsText(err.response.data);
    //   });
    // },
    report: function report(emitPayload, functionName, FileName, useDate) {
      emitPayload.detailType = this.radioValue;
      if (this.isMerge == false) {
        emitPayload.fixed_link_code_id = this.$store.state.user.user.department.fixed_link_code;
      } else {
        emitPayload.fixed_link_code_id = '';
      }
      if (useDate) {
        if (this.dateFilled(emitPayload) === false) {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: '請確定已選填日期'
          });
        } else {
          this.downloadReport(emitPayload, functionName, FileName);
        }
      } else {
        this.downloadReport(emitPayload, functionName, FileName);
      }
    }
  },
  created: function created() {
    this.getReportFunctions();
  },

  watch: {
    radioValue: function radioValue(val) {
      this.radioValue = val;
      console.log(this.radioValue);
    },
    downloadProgress: function downloadProgress(val) {
      console.log(val);
      this.$store.commit('SET_MESSAGE', {
        context: '\n        <h6>\u7522\u751F\u5831\u544A\u4E2D</h6>\n        <div class="progress">\n          <div class="progress-bar progress-bar-striped" \n            role="progressbar" \n            style="width: ' + val + '%; background-color: #117a8b" \n            aria-valuenow="' + val + '" \n            aria-valuemin="0" \n            aria-valuemax="100">\n          </div>\n        </div>\n        ',
        type: 'clean',
        confirm: false
      });
    }
  }
});

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_Vuetable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_Vuetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_Vuetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_VuetablePagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_VuetablePagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_VuetablePagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vuex_functions_readCookie__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__QueryFilter__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__QueryFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__QueryFilter__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('username', {
  name: 'Username',
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  template: '\n    <div>{{ rowData.employee_name }}</div>\n  '
});

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('device', {
  name: 'Device',
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  filters: {
    readablePosistion: function readablePosistion(val) {
      var pos = val.net.open_times + '\u85E5\u6AC3 - ' + val.net.row_id + '\u5C64';
      if (val.pos_row !== 0) {
        pos = pos + ' - ' + val.pos_row + '\u5217 - ' + val.relative_col + '\u884C';
      }
      return pos;
    }
  },
  template: '\n    <div v-if="rowData.device !== null || rowData.device !== undefined">{{ rowData.device | readablePosistion }}</div>\n    <div v-else>{{ rowData.device_posistion }}</div>\n  '
});

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EventSummary',
  data: function data() {
    return {
      moreParams: {},
      eventTable: [],
      httpOptions: {
        headers: {
          Authorization: 'Token ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__vuex_functions_readCookie__["a" /* default */])('Token')
        }
      },
      boostrapCss: {
        tableClass: 'table table-striped table-bordered table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: ''
          }
        }
      },
      fields: [{
        name: 'event_type.event_name_zh',
        sortField: 'event_type',
        title: '動作類別'
      }, {
        name: 'medication_generic_name',
        sortField: 'medication',
        title: '藥名'
      }, {
        name: '__component:username',
        sortField: 'employee',
        title: '使用者'
      }, {
        name: 'review_employee_name',
        title: '覆核者'
      }, {
        name: 'med_record_no',
        title: '病歷(單)號'
      }, {
        name: 'device_posistion',
        title: '操作位置'
      }, {
        name: 'number1',
        title: '變動量'
      }, {
        name: 'batch_no',
        title: '批號'
      }, {
        name: 'stock',
        title: '現藥盒量'
      }, {
        name: 'total_stock',
        title: '總存量'
      }, {
        name: 'record_time',
        title: '時間',
        sortField: 'record_time',
        callback: this.readableDate
      }],
      server: __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */],
      system: [],
      selectSystem: '',
      selectType: '',
      startDate: '',
      endDate: '',
      downloadProgress: undefined
    };
  },

  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_Vuetable___default.a,
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_VuetablePagination___default.a,
    QueryFilter: __WEBPACK_IMPORTED_MODULE_9__QueryFilter___default.a
  },
  methods: {
    getSortParam: function getSortParam(sortOrder) {
      return sortOrder.map(function (sort) {
        return (sort.direction === 'desc' ? '-' : '') + sort.sortField;
      }).join(',');
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    readableDate: function readableDate(value) {
      //20190426 modified by aaron
      //return moment(value).format('MM/DD kk:mm'); 1~24horu format
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format('MM/DD HH:mm'); //0~23hr format
    },
    filter: function filter(params) {
      var _this = this;

      this.moreParams = params;
      console.log(params);
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].nextTick(function () {
        return _this.$refs.vuetable.refresh();
      });
    },
    readableDevice: function readableDevice(device) {
      if (device !== null) return '\u7B2C' + device.net.open_times + '\u85E5\u6AC3 - ' + device.net.row_id + '\u5C64 - ' + device.pos_row + '\u5217 - ' + device.relative_col + '\u884C';
      return undefined;
    },
    connectWebSocket: function connectWebSocket() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, rejects) {
        var wb = new WebSocket(__WEBPACK_IMPORTED_MODULE_8__config__["c" /* webSocketServer */] + '/download-report/' + _this2.$store.state.user.user.id);
        wb.onopen = function () {
          _this2.downloadProgress = 0;
          resolve(wb);
        };
        wb.onmessage = function (res) {
          var data = JSON.parse(res.data);
          if (data.error) {
            _this2.$store.commit('CLOSE_MESSAGE');
            _this2.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: data.error
            });
          }

          if (data.progress !== undefined) {
            _this2.downloadProgress = parseFloat(data.progress);
          }

          if (data.download_path !== undefined) {
            _this2.instance.get(data.download_path, { responseType: 'blob' }).then(function (res) {
              __WEBPACK_IMPORTED_MODULE_4_file_saver___default.a.saveAs(res.data, 'AUTOIX-事件紀錄.xlsx');
              _this2.$store.commit('SET_MESSAGE', {
                type: 'success',
                context: '下載成功'
              });
            });
            wb.close(); // close the socket after downloading
          }
        };
        wb.onclose = function () {
          rejects(wb);
        };
      });
    },
    report: function report(params) {
      var _this3 = this;

      params.function_name = 'export_event_table';
      this.connectWebSocket().then(function (ws) {
        ws.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params));
      }).catch(function (ws) {
        _this3.$store.commit('SET_MESSAGE', { type: 'error', context: '下載失敗' });
        ws.close();
      });
    }
  },
  watch: {
    downloadProgress: function downloadProgress(val) {
      console.log(val);
      this.$store.commit('SET_MESSAGE', {
        context: '\n        <h6>\u7522\u751F\u5831\u544A\u4E2D</h6>\n        <div class="progress">\n          <div class="progress-bar progress-bar-striped" \n            role="progressbar" \n            style="width: ' + val + '%; background-color: #117a8b" \n            aria-valuenow="' + val + '" \n            aria-valuemin="0" \n            aria-valuemax="100">\n          </div>\n        </div>\n        ',
        type: 'clean',
        confirm: false
      });
    }
  }
});

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_Vuetable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_Vuetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_Vuetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_VuetablePagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_VuetablePagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_VuetablePagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vuex_functions_readCookie__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__QueryFilter__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__QueryFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__QueryFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_v_charts__ = __webpack_require__(1190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_v_charts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_v_charts__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_v_charts___default.a);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('username', {
  name: 'Username',
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  template: '\n    <div>{{ rowData.employee_name }}</div>\n  '
});

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'IpCamTimeLogSummary',
  data: function data() {
    this.yaxis = {
      max: 1,
      min: 0,
      minInterval: 1,
      name: '                              (1:對時成功, 0:對時失敗)'
    };
    this.colors = ['#c23531', '#00C851'];
    return {
      chartData: {
        columns: ['時間', '台61彰化段北上區間起點', '台61彰化段北上區間終點'],
        rows: []
      },
      showStartDate: true,
      showDate: false,
      showReportButton: true,
      moreParams: {},
      loadingData: false,
      fixed_link_code_id: undefined,
      Params: {
        start_date: undefined
        //end_date: undefined,
      },
      eventTable: [],
      httpOptions: {
        headers: {
          Authorization: 'Token ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__vuex_functions_readCookie__["a" /* default */])('Token')
        }
      },
      boostrapCss: {
        tableClass: 'table table-striped table-bordered table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: ''
          }
        }
      },
      fields: [],
      server: __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */],
      system: [],
      selectSystem: '',
      selectType: '',
      startDate: '',
      endDate: '',
      downloadProgress: undefined,
      filteredData: [],
      isChartType: true,
      //20200903 add
      timeErrorFlag: false,
      errorContext: ''
      /////////////////
    };
  },
  created: function created() {
    this.clearChartData();
    this.fixed_link_code_id = this.$store.state.user.user.department.fixed_link_code;
    this.Params.start_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD');
    //this.Params.end_date = moment().format('YYYY-MM-DD');
    console.log('this.fixed_link_code_id:', this.fixed_link_code_id);
    this.filter(this.Params);
  },

  computed: {
    user: function user() {
      return this.$store.state.user.user.username;
    },
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_Vuetable___default.a,
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_VuetablePagination___default.a,
    QueryFilter: __WEBPACK_IMPORTED_MODULE_9__QueryFilter___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_10__common_Loader___default.a
  },
  methods: {
    clearChartData: function clearChartData() {
      this.chartData.rows = [];
      var HStr = void 0;
      var MStr = void 0;
      for (var i = 0; i < 24; i++) {
        for (var j = 0; j < 6; j++) {
          if (i < 10) {
            HStr = '0' + i.toString();
          } else {
            HStr = i.toString();
          }
          if (j == 0) {
            MStr = '00';
          } else {
            MStr = j.toString() * 10;
          }
          var tmpStr = HStr + ':' + MStr;
          //console.log('tmpStr',tmpStr);
          var tmpData = { '時間': tmpStr, '台61彰化段北上區間起點': 0, '台61彰化段北上區間終點': 0 };
          this.chartData.rows.push(tmpData);
        }
      }
    },
    downloadReport: function downloadReport(params) {
      if (params.start_date == undefined) {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '請輸入查詢日期'
        });
        return;
      }
      window.open(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */] + '/download1236/download-ipcam-report/?fid=' + this.$store.state.user.user.department.fixed_link_code + '&start=' + params.start_date, '_blank');
    },
    getSortParam: function getSortParam(sortOrder) {
      return sortOrder.map(function (sort) {
        return (sort.direction === 'desc' ? '-' : '') + sort.sortField;
      }).join(',');
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    readableDate: function readableDate(value) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format('YY/MM/DD HH:mm:ss.SSS'); //0~23hr format
    },
    readableDate_loc: function readableDate_loc(value) {
      if (value == 'NIn') {
        return '台61彰化段北上區間起點';
      } else if (value == 'Nout') {
        return '台61彰化段北上區間終點';
      }
    },
    filter: function filter(params) {
      var _this = this;

      if (this.loadingData == false) {
        this.clearChartData();
        this.loadingData = true;
        //const filteredData = [];
        this.Params.start_date = params.start_date;
        //this.Params.end_date=params.end_date;
        ////////////////
        //while (this.filteredData.length>0) {
        //  this.filteredData.pop();
        //}
        this.filteredData = [];
        console.log('fields:', this.fields);
        var t = __WEBPACK_IMPORTED_MODULE_3_moment___default()(params.start_date).format("YYYY-MM-DD");
        console.log(parseInt(__WEBPACK_IMPORTED_MODULE_3_moment___default()(t).format("YYYYMMDD"), 10));
        if (parseInt(__WEBPACK_IMPORTED_MODULE_3_moment___default()(t).format("YYYYMMDD"), 10) < 20200811) {
          this.isChartType = false;
          console.log('aaa');
        } else {
          this.isChartType = true;
          console.log('bbb');
        }
        console.log('fields:', this.fields);
        ///////////////////
        this.instance.get(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */] + '/api/ipcam-time-log/', {
          params: {
            start_date: this.Params.start_date,
            //end_date: this.Params.end_date,
            fixed_link_code_id: this.fixed_link_code_id
          }
        }).then(function (res) {
          console.log(res);
          res.data.forEach(function (item) {
            item.check_loc = _this.readableDate_loc(item.check_loc);
            item.check_time = _this.readableDate(item.check_time);
            item.ipcam1_time = _this.readableDate(item.ipcam1_time);
            item.ipcam2_time = _this.readableDate(item.ipcam2_time);
            item.ipcam3_time = _this.readableDate(item.ipcam3_time);
            _this.filteredData.push(item);
            /////////////////////
            var Hdata = parseInt(item.check_time.substring(9, 11), 10);
            var Mdata = parseInt(item.check_time.substring(12, 14), 10);
            var index = Hdata * 6 + Math.floor(Mdata / 10);
            //console.log('index:',item.check_time,Hdata,Mdata,index);
            _this.chartData.rows[index][item.check_loc] = 1;
            /////////////////////
          });
          //this.$refs.vuetable.setData(filteredData);
          _this.loadingData = false;
          ////////
          var checkIndex = 24 * 6;
          if (__WEBPACK_IMPORTED_MODULE_3_moment___default()(params.start_date).format("YYYY-MM-DD") == __WEBPACK_IMPORTED_MODULE_3_moment___default()().format("YYYY-MM-DD")) {
            var hourNow = __WEBPACK_IMPORTED_MODULE_3_moment___default()().hour();
            checkIndex = hourNow * 6;
          }
          //20200903 add
          _this.timeErrorFlag = false;
          _this.errorContext = '';
          for (var i = 0; i < checkIndex; i++) {
            if (_this.chartData.rows[i]['台61彰化段北上區間起點'] == 0 || _this.chartData.rows[i]['台61彰化段北上區間終點'] == 0) {
              _this.timeErrorFlag = true;
              if (_this.chartData.rows[i]['台61彰化段北上區間起點'] == 0) {
                _this.errorContext += '<strong><p>\u8D77\u9EDE\u7570\u5E38: ' + _this.chartData.rows[i]['時間'] + '</p></strong>';
              }
              if (_this.chartData.rows[i]['台61彰化段北上區間終點'] == 0) {
                _this.errorContext += '<strong><p>\u7D42\u9EDE\u7570\u5E38: ' + _this.chartData.rows[i]['時間'] + '</p></strong>';
              }
              //this.$store.commit('SET_MESSAGE', {
              // type: 'error',
              //  context: '攝影機對時異常，請注意!',
              //});
            }
          }
          console.log('this.timeErrorFlag:', _this.timeErrorFlag);
          ////////
        }).catch(function (err) {
          _this.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: '無法取得校時資料'
          });
          _this.loadingData = false;
        });
      }
    },
    connectWebSocket: function connectWebSocket() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, rejects) {
        var wb = new WebSocket(__WEBPACK_IMPORTED_MODULE_8__config__["c" /* webSocketServer */] + '/download-report/' + _this2.$store.state.user.user.id);
        wb.onopen = function () {
          _this2.downloadProgress = 0;
          resolve(wb);
        };
        wb.onmessage = function (res) {
          var data = JSON.parse(res.data);
          if (data.error) {
            _this2.$store.commit('CLOSE_MESSAGE');
            _this2.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: data.error
            });
          }

          if (data.progress !== undefined) {
            _this2.downloadProgress = parseFloat(data.progress);
          }

          if (data.download_path !== undefined) {
            _this2.instance.get(data.download_path, { responseType: 'blob' }).then(function (res) {
              __WEBPACK_IMPORTED_MODULE_4_file_saver___default.a.saveAs(res.data, 'AUTOIX-事件紀錄.xlsx');
              _this2.$store.commit('SET_MESSAGE', {
                type: 'success',
                context: '下載成功'
              });
            });
            wb.close(); // close the socket after downloading
          }
        };
        wb.onclose = function () {
          rejects(wb);
        };
      });
    },
    report: function report(params) {
      var _this3 = this;

      params.function_name = 'export_event_table';
      this.connectWebSocket().then(function (ws) {
        ws.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params));
      }).catch(function (ws) {
        _this3.$store.commit('SET_MESSAGE', { type: 'error', context: '下載失敗' });
        ws.close();
      });
    }
  },
  watch: {
    downloadProgress: function downloadProgress(val) {
      console.log(val);
      this.$store.commit('SET_MESSAGE', {
        context: '\n        <h6>\u7522\u751F\u5831\u544A\u4E2D</h6>\n        <div class="progress">\n          <div class="progress-bar progress-bar-striped" \n            role="progressbar" \n            style="width: ' + val + '%; background-color: #117a8b" \n            aria-valuenow="' + val + '" \n            aria-valuemin="0" \n            aria-valuemax="100">\n          </div>\n        </div>\n        ',
        type: 'clean',
        confirm: false
      });
    }
  }
});

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_Vuetable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_Vuetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_Vuetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_VuetablePagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_VuetablePagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_VuetablePagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vuex_functions_readCookie__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__QueryFilter__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__QueryFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__QueryFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__common_Loader__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('username', {
  name: 'Username',
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  template: '\n    <div>{{ rowData.employee_name }}</div>\n  '
});

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NTPLogSummary',
  data: function data() {
    return {
      showStartDate: true,
      showDate: false,
      showReportButton: true,
      moreParams: {},
      loadingData: false,
      fixed_link_code_id: undefined,
      Params: {
        start_date: undefined
        //end_date: undefined,
      },
      eventTable: [],
      httpOptions: {
        headers: {
          Authorization: 'Token ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__vuex_functions_readCookie__["a" /* default */])('Token')
        }
      },
      boostrapCss: {
        tableClass: 'table table-striped table-bordered table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: ''
          }
        }
      },
      fields: [],
      server: __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */],
      system: [],
      selectSystem: '',
      selectType: '',
      startDate: '',
      endDate: '',
      downloadProgress: undefined,
      filteredData: []
    };
  },
  created: function created() {
    this.fixed_link_code_id = this.$store.state.user.user.department.fixed_link_code;
    this.Params.start_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD');
    //this.Params.end_date = moment().format('YYYY-MM-DD');
    console.log('this.fixed_link_code_id:', this.fixed_link_code_id);
    this.filter(this.Params);
  },

  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_Vuetable___default.a,
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_VuetablePagination___default.a,
    QueryFilter: __WEBPACK_IMPORTED_MODULE_9__QueryFilter___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_10__common_Loader___default.a
  },
  methods: {
    downloadReport: function downloadReport(params) {
      if (params.start_date == undefined) {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '請輸入查詢日期'
        });
        return;
      }
      window.open(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */] + '/download1236/download-ntp-report/?fid=' + this.$store.state.user.user.department.fixed_link_code + '&start=' + params.start_date, '_blank');
    },
    getSortParam: function getSortParam(sortOrder) {
      return sortOrder.map(function (sort) {
        return (sort.direction === 'desc' ? '-' : '') + sort.sortField;
      }).join(',');
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    readableDate: function readableDate(value) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format('YY/MM/DD HH:mm:ss.SSS'); //0~23hr format
    },
    readableDate_loc: function readableDate_loc(value) {
      if (value == 'Nin') {
        return '台61彰化段北上區間起點';
      } else if (value == 'Nout') {
        return '台61彰化段北上區間終點';
      }
    },
    filter: function filter(params) {
      var _this = this;

      this.loadingData = true;
      //const filteredData = [];
      this.Params.start_date = params.start_date;
      //this.Params.end_date=params.end_date;
      ////////////////
      //while (this.filteredData.length>0) {
      //  this.filteredData.pop();
      //}
      this.filteredData = [];
      console.log('fields:', this.fields);
      var t = __WEBPACK_IMPORTED_MODULE_3_moment___default()(params.start_date).format("YYYY-MM-DD");
      ///////////////////
      this.instance.get(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */] + '/api/ntp-log/', {
        params: {
          start_date: this.Params.start_date,
          //end_date: this.Params.end_date,
          fixed_link_code_id: this.fixed_link_code_id
        }
      }).then(function (res) {
        console.log(res);
        res.data.forEach(function (item) {
          item.check_loc = _this.readableDate_loc(item.check_loc);
          item.check_time = _this.readableDate(item.check_time);
          item.check_NTPtime = _this.readableDate(item.check_NTPtime);
          _this.filteredData.push(item);
        });
        //this.$refs.vuetable.setData(filteredData);
        _this.loadingData = false;
      }).catch(function (err) {
        _this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '無法取得NTP資料'
        });
        _this.loadingData = false;
      });
    },
    connectWebSocket: function connectWebSocket() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, rejects) {
        var wb = new WebSocket(__WEBPACK_IMPORTED_MODULE_8__config__["c" /* webSocketServer */] + '/download-report/' + _this2.$store.state.user.user.id);
        wb.onopen = function () {
          _this2.downloadProgress = 0;
          resolve(wb);
        };
        wb.onmessage = function (res) {
          var data = JSON.parse(res.data);
          if (data.error) {
            _this2.$store.commit('CLOSE_MESSAGE');
            _this2.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: data.error
            });
          }

          if (data.progress !== undefined) {
            _this2.downloadProgress = parseFloat(data.progress);
          }

          if (data.download_path !== undefined) {
            _this2.instance.get(data.download_path, { responseType: 'blob' }).then(function (res) {
              __WEBPACK_IMPORTED_MODULE_4_file_saver___default.a.saveAs(res.data, 'AUTOIX-事件紀錄.xlsx');
              _this2.$store.commit('SET_MESSAGE', {
                type: 'success',
                context: '下載成功'
              });
            });
            wb.close(); // close the socket after downloading
          }
        };
        wb.onclose = function () {
          rejects(wb);
        };
      });
    },
    report: function report(params) {
      var _this3 = this;

      params.function_name = 'export_event_table';
      this.connectWebSocket().then(function (ws) {
        ws.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params));
      }).catch(function (ws) {
        _this3.$store.commit('SET_MESSAGE', { type: 'error', context: '下載失敗' });
        ws.close();
      });
    }
  },
  watch: {
    downloadProgress: function downloadProgress(val) {
      console.log(val);
      this.$store.commit('SET_MESSAGE', {
        context: '\n        <h6>\u7522\u751F\u5831\u544A\u4E2D</h6>\n        <div class="progress">\n          <div class="progress-bar progress-bar-striped" \n            role="progressbar" \n            style="width: ' + val + '%; background-color: #117a8b" \n            aria-valuenow="' + val + '" \n            aria-valuemin="0" \n            aria-valuemax="100">\n          </div>\n        </div>\n        ',
        type: 'clean',
        confirm: false
      });
    }
  }
});

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_Vuetable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_Vuetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_Vuetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_VuetablePagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_VuetablePagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_VuetablePagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vuex_functions_readCookie__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__QueryFilter__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__QueryFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__QueryFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__common_Loader__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('username', {
  name: 'Username',
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  template: '\n    <div>{{ rowData.employee_name }}</div>\n  '
});

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'OtherPcLogSummary',
  data: function data() {
    return {
      showStartDate: true,
      showDate: false,
      showReportButton: true,
      moreParams: {},
      loadingData: false,
      fixed_link_code_id: undefined,
      Params: {
        start_date: undefined
        //end_date: undefined,
      },
      eventTable: [],
      httpOptions: {
        headers: {
          Authorization: 'Token ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__vuex_functions_readCookie__["a" /* default */])('Token')
        }
      },
      boostrapCss: {
        tableClass: 'table table-striped table-bordered table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: ''
          }
        }
      },
      fields: [],
      server: __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */],
      system: [],
      selectSystem: '',
      selectType: '',
      startDate: '',
      endDate: '',
      downloadProgress: undefined,
      filteredData: []
    };
  },
  created: function created() {
    this.fixed_link_code_id = this.$store.state.user.user.department.fixed_link_code;
    this.Params.start_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD');
    //this.Params.end_date = moment().format('YYYY-MM-DD');
    console.log('this.fixed_link_code_id:', this.fixed_link_code_id);
    this.filter(this.Params);
  },

  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_Vuetable___default.a,
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_VuetablePagination___default.a,
    QueryFilter: __WEBPACK_IMPORTED_MODULE_9__QueryFilter___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_10__common_Loader___default.a
  },
  methods: {
    downloadReport: function downloadReport(params) {
      if (params.start_date == undefined) {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '請輸入查詢日期'
        });
        return;
      }
      window.open(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */] + '/download1236/download-other-pc-report/?fid=' + this.$store.state.user.user.department.fixed_link_code + '&start=' + params.start_date, '_blank');
    },
    getSortParam: function getSortParam(sortOrder) {
      return sortOrder.map(function (sort) {
        return (sort.direction === 'desc' ? '-' : '') + sort.sortField;
      }).join(',');
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    readableDate: function readableDate(value) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format('YY/MM/DD HH:mm:ss.SSS'); //0~23hr format
    },
    readableDate_loc: function readableDate_loc(value) {
      if (value == 'Nin') {
        return '台61彰化段北上區間起點';
      } else if (value == 'Nout') {
        return '台61彰化段北上區間終點';
      }
    },
    filter: function filter(params) {
      var _this = this;

      this.loadingData = true;
      //const filteredData = [];
      this.Params.start_date = params.start_date;
      //this.Params.end_date=params.end_date;
      ////////////////
      //while (this.filteredData.length>0) {
      //  this.filteredData.pop();
      //}
      this.filteredData = [];
      console.log('fields:', this.fields);
      var t = __WEBPACK_IMPORTED_MODULE_3_moment___default()(params.start_date).format("YYYY-MM-DD");
      ///////////////////
      this.instance.get(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */] + '/api/other-pc-log/', {
        params: {
          start_date: this.Params.start_date,
          //end_date: this.Params.end_date,
          fixed_link_code_id: this.fixed_link_code_id
        }
      }).then(function (res) {
        console.log(res);
        res.data.forEach(function (item) {
          item.check_loc = _this.readableDate_loc(item.check_loc);
          item.check_time = _this.readableDate(item.check_time);
          item.check_otherpctime = _this.readableDate(item.check_otherpctime);
          _this.filteredData.push(item);
        });
        //this.$refs.vuetable.setData(filteredData);
        _this.loadingData = false;
      }).catch(function (err) {
        _this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '無法取獨立主機資料'
        });
        _this.loadingData = false;
      });
    },
    connectWebSocket: function connectWebSocket() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, rejects) {
        var wb = new WebSocket(__WEBPACK_IMPORTED_MODULE_8__config__["c" /* webSocketServer */] + '/download-report/' + _this2.$store.state.user.user.id);
        wb.onopen = function () {
          _this2.downloadProgress = 0;
          resolve(wb);
        };
        wb.onmessage = function (res) {
          var data = JSON.parse(res.data);
          if (data.error) {
            _this2.$store.commit('CLOSE_MESSAGE');
            _this2.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: data.error
            });
          }

          if (data.progress !== undefined) {
            _this2.downloadProgress = parseFloat(data.progress);
          }

          if (data.download_path !== undefined) {
            _this2.instance.get(data.download_path, { responseType: 'blob' }).then(function (res) {
              __WEBPACK_IMPORTED_MODULE_4_file_saver___default.a.saveAs(res.data, 'AUTOIX-事件紀錄.xlsx');
              _this2.$store.commit('SET_MESSAGE', {
                type: 'success',
                context: '下載成功'
              });
            });
            wb.close(); // close the socket after downloading
          }
        };
        wb.onclose = function () {
          rejects(wb);
        };
      });
    },
    report: function report(params) {
      var _this3 = this;

      params.function_name = 'export_event_table';
      this.connectWebSocket().then(function (ws) {
        ws.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params));
      }).catch(function (ws) {
        _this3.$store.commit('SET_MESSAGE', { type: 'error', context: '下載失敗' });
        ws.close();
      });
    }
  },
  watch: {
    downloadProgress: function downloadProgress(val) {
      console.log(val);
      this.$store.commit('SET_MESSAGE', {
        context: '\n        <h6>\u7522\u751F\u5831\u544A\u4E2D</h6>\n        <div class="progress">\n          <div class="progress-bar progress-bar-striped" \n            role="progressbar" \n            style="width: ' + val + '%; background-color: #117a8b" \n            aria-valuenow="' + val + '" \n            aria-valuemin="0" \n            aria-valuemax="100">\n          </div>\n        </div>\n        ',
        type: 'clean',
        confirm: false
      });
    }
  }
});

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'QueryFilter',
  props: {
    showDate: {
      type: Boolean,
      default: true
    },
    showStartDate: {
      type: Boolean,
      default: false
    },
    showEventType: {
      type: Boolean,
      default: true
    },
    showSystem: {
      type: Boolean,
      default: true
    },
    showFilterButton: {
      type: Boolean,
      default: true
    },
    showReportButton: {
      type: Boolean,
      default: true
    },
    showMedRecordNum: {
      type: Boolean,
      default: false
    },
    showMedication: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      startDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY-MM-DD'),
      endDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY-MM-DD'),
      selectType: [],
      selectSystem: undefined,
      eventTable: [],
      moreParams: {},
      systems: [],
      searchDrug: '',
      searchMedicines: [],
      medicineSelected: {},
      medRecordNum: ''
    };
  },
  created: function created() {},

  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  methods: {
    emitFilterParams: function emitFilterParams(val) {
      if (this.startDate !== undefined) {
        this.moreParams.start_date = this.startDate;
      } else {
        delete this.moreParams.start_date;
      }
      if (this.endDate !== undefined) {
        this.moreParams.end_date = this.endDate;
      } else {
        delete this.moreParams.end_date;
      }
      this.$emit(val, this.moreParams);
    },
    filterEvent: function filterEvent() {
      this.emitFilterParams('filter');
    },
    getReport: function getReport() {
      this.emitFilterParams('report');
    }
  },
  watch: {
    startDate: function startDate(val) {
      if (val > this.endDate && this.endDate !== '') {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '開始時間不可晚於結束時間'
        });
        this.startDate = this.endDate;
      }
    },
    endDate: function endDate(val) {
      if (val < this.startDate && this.startDate !== '') {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '結束時間不可早於開始時間'
        });
        this.endDate = this.startDate;
      }
    }
  }
});

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_file_saver__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__QueryFilter__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__QueryFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__QueryFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ShoulderReport',
  components: {
    QueryFilter: __WEBPACK_IMPORTED_MODULE_4__QueryFilter___default.a
  },
  data: function data() {
    return {
      reportFunctions: [],
      downloadProgress: undefined,
      department: this.$store.state.user.user.department.name,
      isMerge: false
    };
  },

  computed: {
    instance: function instance() {
      return this.$store.getters.instance;
    }
  },
  methods: {
    dateFilled: function dateFilled(emitPayload) {
      if (emitPayload.start_date === undefined || emitPayload.start_date === '' || emitPayload.end_date === undefined || emitPayload.end_date === '') {
        return false;
      }
      return true;
    },
    getReportFunctions: function getReportFunctions() {
      var _this = this;

      this.reportFunctions = [];
      this.instance.get('/api/report-functions/').then(function (res) {
        res.data.forEach(function (item) {
          if (item.function_name.search("shoulder") !== -1 && item.on_status) {
            _this.reportFunctions.push(item);
          }
        });
      });
    },
    connectWebSocket: function connectWebSocket(filename) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, rejects) {
        var wb = new WebSocket(__WEBPACK_IMPORTED_MODULE_3__config__["c" /* webSocketServer */] + '/download-report/' + _this2.$store.state.user.user.id);
        wb.onopen = function () {
          _this2.downloadProgress = 0;
          resolve(wb);
        };
        wb.onmessage = function (res) {
          var data = JSON.parse(res.data);
          if (data.error) {
            _this2.$store.commit('CLOSE_MESSAGE');
            _this2.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: data.error
            });
          }

          if (data.progress !== undefined) {
            _this2.downloadProgress = parseFloat(data.progress);
          }
          if (data.download_path !== undefined) {
            //this.instance.get(data.download_path, { responseType: 'blob' })
            //20200807 add
            __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(data.download_path, { responseType: 'blob' }).then(function (res) {
              __WEBPACK_IMPORTED_MODULE_2_file_saver___default.a.saveAs(res.data, filename + '.xlsx');
              _this2.$store.commit('SET_MESSAGE', {
                type: 'success',
                context: '下載成功'
              });
            });
            wb.close(); // close the socket after downloading
          }
        };
        wb.onclose = function () {
          rejects(wb);
        };
      });
    },
    downloadReport: function downloadReport(params, functionName, FileName) {
      var _this3 = this;

      params.function_name = functionName;
      this.connectWebSocket(FileName).then(function (wb) {
        wb.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params));
      }).catch(function (wb) {
        _this3.$store.commit('SET_MESSAGE', { type: 'error', context: '下載失敗' });
        wb.close();
      });
    },

    // downloadReport(emitPayload, functionName, FileName) {
    //   this.$store.commit('SET_MESSAGE', {
    //     type: 'warn',
    //     context: '下載中...',
    //   });
    //   emitPayload.function_name = functionName;
    //   this.instance.get('/export-report/', {
    //     params: emitPayload,
    //     responseType: 'blob',
    //   })
    //   .then((res) => {
    //     console.log('download success');
    //     FileSaver.saveAs(res.data, `AUTOIX-${FileName}.xlsx`);
    //     this.$store.commit('CLOSE_MESSAGE');
    //   })
    //   .catch((err) => {
    //     const reader = new FileReader();
    //     reader.addEventListener('loadend', (e) => {
    //       const eventCount = parseInt(e.srcElement.result, 10);
    //       if (eventCount > 0) {
    //         this.$store.commit('SET_MESSAGE', {
    //           type: 'error',
    //           context: '範圍資料過多，請縮小範圍',
    //         });
    //       }
    //       if (eventCount === 0) {
    //         this.$store.commit('SET_MESSAGE', {
    //           type: 'error',
    //           context: '範圍內無資料',
    //         });
    //       }
    //     });
    //     reader.readAsText(err.response.data);
    //   });
    // },
    report: function report(emitPayload, functionName, FileName, useDate) {
      if (this.isMerge == false) {
        emitPayload.fixed_link_code_id = this.$store.state.user.user.department.fixed_link_code;
        emitPayload.isMerge = 0;
      } else {
        emitPayload.fixed_link_code_id = this.$store.state.user.user.department.fixed_link_code;
        emitPayload.isMerge = 1;
      }
      if (useDate) {
        if (this.dateFilled(emitPayload) === false) {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: '請確定已選填日期'
          });
        } else {
          this.downloadReport(emitPayload, functionName, FileName);
        }
      } else {
        this.downloadReport(emitPayload, functionName, FileName);
      }
    }
  },
  created: function created() {
    this.getReportFunctions();
  },

  watch: {
    downloadProgress: function downloadProgress(val) {
      console.log(val);
      this.$store.commit('SET_MESSAGE', {
        context: '\n        <h6>\u7522\u751F\u5831\u544A\u4E2D</h6>\n        <div class="progress">\n          <div class="progress-bar progress-bar-striped" \n            role="progressbar" \n            style="width: ' + val + '%; background-color: #117a8b" \n            aria-valuenow="' + val + '" \n            aria-valuemin="0" \n            aria-valuemax="100">\n          </div>\n        </div>\n        ',
        type: 'clean',
        confirm: false
      });
    }
  }
});

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_Vuetable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_Vuetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_Vuetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_VuetablePagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_VuetablePagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_VuetablePagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vuex_functions_readCookie__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__QueryFilter__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__QueryFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__QueryFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__common_Loader__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('username', {
  name: 'Username',
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  template: '\n    <div>{{ rowData.employee_name }}</div>\n  '
});

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TimeLogAnalysis',
  data: function data() {
    return {
      showStartDate: false,
      showDate: true,
      showReportButton: false,
      moreParams: {},
      loadingData: false,
      fixed_link_code_id: undefined,
      Params: {
        start_date: undefined,
        end_date: undefined
      },
      eventTable: [],
      httpOptions: {
        headers: {
          Authorization: 'Token ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__vuex_functions_readCookie__["a" /* default */])('Token')
        }
      },
      boostrapCss: {
        tableClass: 'table table-striped table-bordered table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: ''
          }
        }
      },
      fields: [{
        name: 'check_loc',
        //sortField: 'check_loc',
        title: '地點',
        callback: this.readableDate_loc
      }, {
        name: 'check_time',
        //sortField: 'check_time',
        title: '系統時間',
        callback: this.readableDate
      }, {
        name: 'check_NTPtime',
        //sortField: 'check_NTPtime',
        title: 'NTP Server時間',
        callback: this.readableDate
      }, {
        name: 'check_status',
        title: '時間誤差'
      }],
      server: __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */],
      system: [],
      selectSystem: '',
      selectType: '',
      startDate: '',
      endDate: '',
      downloadProgress: undefined
    };
  },
  created: function created() {
    this.fixed_link_code_id = this.$store.state.user.user.department.fixed_link_code;
    this.Params.start_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD');
    this.Params.end_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD');
    console.log('this.fixed_link_code_id:', this.fixed_link_code_id);
    this.filter(this.Params);
  },

  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_Vuetable___default.a,
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_VuetablePagination___default.a,
    QueryFilter: __WEBPACK_IMPORTED_MODULE_9__QueryFilter___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_10__common_Loader___default.a
  },
  methods: {
    downloadReport: function downloadReport(params) {
      if (params.start_date == undefined) {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '請輸入查詢日期'
        });
        return;
      }
      window.open(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */] + '/download1236/download-time-report/?fid=' + this.$store.state.user.user.department.fixed_link_code + '&start=' + params.start_date, '_blank');
    },
    getSortParam: function getSortParam(sortOrder) {
      return sortOrder.map(function (sort) {
        return (sort.direction === 'desc' ? '-' : '') + sort.sortField;
      }).join(',');
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    readableDate: function readableDate(value) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format('YY/MM/DD HH:mm:ss.SSS'); //0~23hr format
    },
    readableDate_loc: function readableDate_loc(value) {
      if (value == 'NIn') {
        return '台61彰化段北上區間起點';
      } else if (value == 'Nout') {
        return '台61彰化段北上區間終點';
      } else if (value == 'Server') {
        return '伺服器電腦';
      }
    },
    filter: function filter(params) {
      var _this = this;

      if (this.loadingData == false) {
        this.loadingData = true;
        var filteredData = [];
        this.Params.start_date = params.start_date;
        this.Params.end_date = params.end_date;
        this.instance.get(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */] + '/api/time-log-analysis/', {
          params: {
            start_date: this.Params.start_date,
            end_date: this.Params.end_date,
            fixed_link_code_id: this.fixed_link_code_id
          }
        }).then(function (res) {
          console.log(res);
          res.data.forEach(function (item) {
            filteredData.push(item);
          });
          _this.$refs.vuetable.setData(filteredData);
          _this.loadingData = false;
        }).catch(function (err) {
          _this.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: '無法取得校時資料'
          });
          _this.loadingData = false;
        });
      }
    },
    connectWebSocket: function connectWebSocket() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, rejects) {
        var wb = new WebSocket(__WEBPACK_IMPORTED_MODULE_8__config__["c" /* webSocketServer */] + '/download-report/' + _this2.$store.state.user.user.id);
        wb.onopen = function () {
          _this2.downloadProgress = 0;
          resolve(wb);
        };
        wb.onmessage = function (res) {
          var data = JSON.parse(res.data);
          if (data.error) {
            _this2.$store.commit('CLOSE_MESSAGE');
            _this2.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: data.error
            });
          }

          if (data.progress !== undefined) {
            _this2.downloadProgress = parseFloat(data.progress);
          }

          if (data.download_path !== undefined) {
            _this2.instance.get(data.download_path, { responseType: 'blob' }).then(function (res) {
              __WEBPACK_IMPORTED_MODULE_4_file_saver___default.a.saveAs(res.data, 'AUTOIX-事件紀錄.xlsx');
              _this2.$store.commit('SET_MESSAGE', {
                type: 'success',
                context: '下載成功'
              });
            });
            wb.close(); // close the socket after downloading
          }
        };
        wb.onclose = function () {
          rejects(wb);
        };
      });
    },
    report: function report(params) {
      var _this3 = this;

      params.function_name = 'export_event_table';
      this.connectWebSocket().then(function (ws) {
        ws.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params));
      }).catch(function (ws) {
        _this3.$store.commit('SET_MESSAGE', { type: 'error', context: '下載失敗' });
        ws.close();
      });
    }
  },
  watch: {
    downloadProgress: function downloadProgress(val) {
      console.log(val);
      this.$store.commit('SET_MESSAGE', {
        context: '\n        <h6>\u7522\u751F\u5831\u544A\u4E2D</h6>\n        <div class="progress">\n          <div class="progress-bar progress-bar-striped" \n            role="progressbar" \n            style="width: ' + val + '%; background-color: #117a8b" \n            aria-valuenow="' + val + '" \n            aria-valuemin="0" \n            aria-valuemax="100">\n          </div>\n        </div>\n        ',
        type: 'clean',
        confirm: false
      });
    }
  }
});

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_Vuetable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_Vuetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_Vuetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_VuetablePagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_VuetablePagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_VuetablePagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vuex_functions_readCookie__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__QueryFilter__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__QueryFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__QueryFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__common_Loader__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('username', {
  name: 'Username',
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  template: '\n    <div>{{ rowData.employee_name }}</div>\n  '
});

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TimeLogSummary',
  data: function data() {
    return {
      showStartDate: true,
      showDate: false,
      showReportButton: true,
      moreParams: {},
      loadingData: false,
      fixed_link_code_id: undefined,
      Params: {
        start_date: undefined
        //end_date: undefined,
      },
      eventTable: [],
      httpOptions: {
        headers: {
          Authorization: 'Token ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__vuex_functions_readCookie__["a" /* default */])('Token')
        }
      },
      boostrapCss: {
        tableClass: 'table table-striped table-bordered table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: ''
          }
        }
      },
      fields: [],
      server: __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */],
      system: [],
      selectSystem: '',
      selectType: '',
      startDate: '',
      endDate: '',
      downloadProgress: undefined,
      filteredData: [],
      isOldType: false
    };
  },
  created: function created() {
    this.fixed_link_code_id = this.$store.state.user.user.department.fixed_link_code;
    this.Params.start_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD');
    //this.Params.end_date = moment().format('YYYY-MM-DD');
    console.log('this.fixed_link_code_id:', this.fixed_link_code_id);
    this.filter(this.Params);
  },

  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_Vuetable___default.a,
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_VuetablePagination___default.a,
    QueryFilter: __WEBPACK_IMPORTED_MODULE_9__QueryFilter___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_10__common_Loader___default.a
  },
  methods: {
    downloadReport: function downloadReport(params) {
      if (params.start_date == undefined) {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '請輸入查詢日期'
        });
        return;
      }
      window.open(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */] + '/download1236/download-time-report/?fid=' + this.$store.state.user.user.department.fixed_link_code + '&start=' + params.start_date, '_blank');
    },
    getSortParam: function getSortParam(sortOrder) {
      return sortOrder.map(function (sort) {
        return (sort.direction === 'desc' ? '-' : '') + sort.sortField;
      }).join(',');
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    readableDate: function readableDate(value) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format('YY/MM/DD HH:mm:ss.SSS'); //0~23hr format
    },
    readableDate_loc: function readableDate_loc(value) {
      if (value == 'NIn') {
        return '台61彰化段北上區間起點';
      } else if (value == 'Nout') {
        return '台61彰化段北上區間終點';
      } else if (value == 'Server') {
        return '伺服器電腦';
      }
    },
    filter: function filter(params) {
      var _this = this;

      this.loadingData = true;
      //const filteredData = [];
      this.Params.start_date = params.start_date;
      //this.Params.end_date=params.end_date;
      ////////////////
      //while (this.filteredData.length>0) {
      //  this.filteredData.pop();
      //}
      this.filteredData = [];
      console.log('fields:', this.fields);
      var t = __WEBPACK_IMPORTED_MODULE_3_moment___default()(params.start_date).format("YYYY-MM-DD");
      console.log(parseInt(__WEBPACK_IMPORTED_MODULE_3_moment___default()(t).format("YYYYMMDD"), 10));
      if (parseInt(__WEBPACK_IMPORTED_MODULE_3_moment___default()(t).format("YYYYMMDD"), 10) > 20200511) {
        this.isOldType = false;
        console.log('aaa');
      } else {
        this.isOldType = true;
        console.log('bbb');
      }
      console.log('fields:', this.fields);
      ///////////////////
      this.instance.get(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */] + '/api/time-log/', {
        params: {
          start_date: this.Params.start_date,
          //end_date: this.Params.end_date,
          fixed_link_code_id: this.fixed_link_code_id
        }
      }).then(function (res) {
        console.log(res);
        res.data.forEach(function (item) {
          item.check_loc = _this.readableDate_loc(item.check_loc);
          item.check_time = _this.readableDate(item.check_time);
          item.check_NTPtime = _this.readableDate(item.check_NTPtime);
          _this.filteredData.push(item);
        });
        //this.$refs.vuetable.setData(filteredData);
        _this.loadingData = false;
      }).catch(function (err) {
        _this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '無法取得校時資料'
        });
        _this.loadingData = false;
      });
    },
    connectWebSocket: function connectWebSocket() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, rejects) {
        var wb = new WebSocket(__WEBPACK_IMPORTED_MODULE_8__config__["c" /* webSocketServer */] + '/download-report/' + _this2.$store.state.user.user.id);
        wb.onopen = function () {
          _this2.downloadProgress = 0;
          resolve(wb);
        };
        wb.onmessage = function (res) {
          var data = JSON.parse(res.data);
          if (data.error) {
            _this2.$store.commit('CLOSE_MESSAGE');
            _this2.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: data.error
            });
          }

          if (data.progress !== undefined) {
            _this2.downloadProgress = parseFloat(data.progress);
          }

          if (data.download_path !== undefined) {
            _this2.instance.get(data.download_path, { responseType: 'blob' }).then(function (res) {
              __WEBPACK_IMPORTED_MODULE_4_file_saver___default.a.saveAs(res.data, 'AUTOIX-事件紀錄.xlsx');
              _this2.$store.commit('SET_MESSAGE', {
                type: 'success',
                context: '下載成功'
              });
            });
            wb.close(); // close the socket after downloading
          }
        };
        wb.onclose = function () {
          rejects(wb);
        };
      });
    },
    report: function report(params) {
      var _this3 = this;

      params.function_name = 'export_event_table';
      this.connectWebSocket().then(function (ws) {
        ws.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params));
      }).catch(function (ws) {
        _this3.$store.commit('SET_MESSAGE', { type: 'error', context: '下載失敗' });
        ws.close();
      });
    }
  },
  watch: {
    downloadProgress: function downloadProgress(val) {
      console.log(val);
      this.$store.commit('SET_MESSAGE', {
        context: '\n        <h6>\u7522\u751F\u5831\u544A\u4E2D</h6>\n        <div class="progress">\n          <div class="progress-bar progress-bar-striped" \n            role="progressbar" \n            style="width: ' + val + '%; background-color: #117a8b" \n            aria-valuenow="' + val + '" \n            aria-valuemin="0" \n            aria-valuemax="100">\n          </div>\n        </div>\n        ',
        type: 'clean',
        confirm: false
      });
    }
  }
});

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_Vuetable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_Vuetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_Vuetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_VuetablePagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_VuetablePagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_VuetablePagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vuex_functions_readCookie__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__QueryFilter__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__QueryFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__QueryFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__common_Loader__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('username', {
  name: 'Username',
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  template: '\n    <div>{{ rowData.employee_name }}</div>\n  '
});

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TimeSyncSummary',
  data: function data() {
    return {
      showStartDate: true,
      showDate: false,
      showReportButton: false,
      moreParams: {},
      loadingData: false,
      fixed_link_code_id: undefined,
      Params: {
        start_date: undefined
        //end_date: undefined,
      },
      eventTable: [],
      httpOptions: {
        headers: {
          Authorization: 'Token ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__vuex_functions_readCookie__["a" /* default */])('Token')
        }
      },
      boostrapCss: {
        tableClass: 'table table-striped table-bordered table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: ''
          }
        }
      },
      fields: [],
      server: __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */],
      system: [],
      selectSystem: '',
      selectType: '',
      startDate: '',
      endDate: '',
      downloadProgress: undefined,
      filteredData: [],
      isOldType: false
    };
  },
  created: function created() {
    this.fixed_link_code_id = this.$store.state.user.user.department.fixed_link_code;
    this.Params.start_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD');
    //this.Params.end_date = moment().format('YYYY-MM-DD');
    console.log('this.fixed_link_code_id:', this.fixed_link_code_id);
    this.filter(this.Params);
  },

  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_Vuetable___default.a,
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_6_vuetable_2_src_components_VuetablePagination___default.a,
    QueryFilter: __WEBPACK_IMPORTED_MODULE_9__QueryFilter___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_10__common_Loader___default.a
  },
  methods: {
    downloadReport: function downloadReport(params) {
      if (params.start_date == undefined) {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '請輸入查詢日期'
        });
        return;
      }
      window.open(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */] + '/download1236/download-sync-report/?fid=' + this.$store.state.user.user.department.fixed_link_code + '&start=' + params.start_date, '_blank');
    },
    getSortParam: function getSortParam(sortOrder) {
      return sortOrder.map(function (sort) {
        return (sort.direction === 'desc' ? '-' : '') + sort.sortField;
      }).join(',');
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    readableDate: function readableDate(value) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format('YY/MM/DD HH:mm:ss.SSS'); //0~23hr format
    },
    filter: function filter(params) {
      var _this = this;

      if (this.loadingData == false) {
        this.loadingData = true;
        this.Params.start_date = params.start_date;
        this.filteredData = [];
        this.instance.get(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */] + '/api/time-sync-log/', {
          params: {
            start_date: this.Params.start_date,
            fixed_link_code_id: this.fixed_link_code_id
          }
        }).then(function (res) {
          console.log(res);
          res.data.forEach(function (item) {
            item.server = _this.readableDate(item.server);
            item.cmp1_time = _this.readableDate(item.cmp1_time);
            item.cmp2_time = _this.readableDate(item.cmp2_time);
            if (_this.fixed_link_code_id == 8 || _this.fixed_link_code_id == 9) {
              item.cmp3_time = _this.readableDate(item.cmp3_time);
            }
            _this.filteredData.push(item);
          });
          //this.$refs.vuetable.setData(filteredData);
          _this.loadingData = false;
        }).catch(function (err) {
          _this.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: '無法取得電腦設備同步確認資料'
          });
          _this.loadingData = false;
        });
      }
    },
    connectWebSocket: function connectWebSocket() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, rejects) {
        var wb = new WebSocket(__WEBPACK_IMPORTED_MODULE_8__config__["c" /* webSocketServer */] + '/download-report/' + _this2.$store.state.user.user.id);
        wb.onopen = function () {
          _this2.downloadProgress = 0;
          resolve(wb);
        };
        wb.onmessage = function (res) {
          var data = JSON.parse(res.data);
          if (data.error) {
            _this2.$store.commit('CLOSE_MESSAGE');
            _this2.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: data.error
            });
          }

          if (data.progress !== undefined) {
            _this2.downloadProgress = parseFloat(data.progress);
          }

          if (data.download_path !== undefined) {
            _this2.instance.get(data.download_path, { responseType: 'blob' }).then(function (res) {
              __WEBPACK_IMPORTED_MODULE_4_file_saver___default.a.saveAs(res.data, 'AUTOIX-事件紀錄.xlsx');
              _this2.$store.commit('SET_MESSAGE', {
                type: 'success',
                context: '下載成功'
              });
            });
            wb.close(); // close the socket after downloading
          }
        };
        wb.onclose = function () {
          rejects(wb);
        };
      });
    },
    report: function report(params) {
      var _this3 = this;

      params.function_name = 'export_event_table';
      this.connectWebSocket().then(function (ws) {
        ws.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params));
      }).catch(function (ws) {
        _this3.$store.commit('SET_MESSAGE', { type: 'error', context: '下載失敗' });
        ws.close();
      });
    }
  },
  watch: {
    downloadProgress: function downloadProgress(val) {
      console.log(val);
      this.$store.commit('SET_MESSAGE', {
        context: '\n        <h6>\u7522\u751F\u5831\u544A\u4E2D</h6>\n        <div class="progress">\n          <div class="progress-bar progress-bar-striped" \n            role="progressbar" \n            style="width: ' + val + '%; background-color: #117a8b" \n            aria-valuenow="' + val + '" \n            aria-valuemin="0" \n            aria-valuemax="100">\n          </div>\n        </div>\n        ',
        type: 'clean',
        confirm: false
      });
    }
  }
});

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_AdminPatch__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_AdminPatch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_AdminPatch__);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ADCManagement',
  components: {
    Patch: __WEBPACK_IMPORTED_MODULE_0__common_AdminPatch___default.a
  }
});

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_Vuetable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_Vuetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_Vuetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_functions_readCookie__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AreaSettingsDetail__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AreaSettingsDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__AreaSettingsDetail__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('area-settings-detail', __WEBPACK_IMPORTED_MODULE_5__AreaSettingsDetail___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ADCList',
  data: function data() {
    return {
      boostrapCss: {
        tableClass: 'table table-striped table-bordered table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: ''
          }
        }
      },
      httpOptions: {
        headers: {
          Authorization: 'Token ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__vuex_functions_readCookie__["a" /* default */])('Token')
        }
      },
      server: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */],
      fields: [{
        name: 'name',
        title: '區域名稱'
      }, {
        name: 'department.name',
        title: '所屬單位'
      }, {
        name: '__slot:actions',
        title: '動作'
      }],
      areaName: '',
      departments: [],
      selectedDepartment: ''
    };
  },

  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_Vuetable___default.a
  },
  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  created: function created() {
    this.getDepartment();
  },

  methods: {
    onCellClicked: function onCellClicked(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.id);
    },
    getDepartment: function getDepartment() {
      var _this = this;

      this.instance.get('/api/department/').then(function (res) {
        _this.departments = res.data;
      });
    },
    createArea: function createArea() {
      var _this2 = this;

      this.instance.post('/api/area/', {
        name: this.areaName,
        department: this.selectedDepartment
      }).then(function () {
        _this2.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '新增成功'
        });
        _this2.$refs.vuetable.refresh();
      });
    },
    deleteArea: function deleteArea(id) {
      var _this3 = this;

      this.instance.delete('/api/area/' + id + '/').then(function () {
        _this3.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '刪除成功'
        });
        _this3.$refs.vuetable.refresh();
      });
    }
  }
});

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AreaSettingsDetail',
  props: ['rowData', 'rowIndex']
});

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ComboDetail',
  props: ['rowData', 'rowIndex'],
  data: function data() {
    return {
      searchDrug: '',
      searchMedicines: [],
      addToComboMed: {},
      dose: 1
    };
  },

  computed: {
    instance: function instance() {
      return this.$store.getters.instance;
    },
    pairAddable: function pairAddable() {
      if (this.addToComboMed.id === undefined) return false;
      if (this.dose < 1) return false;
      return true;
    }
  },
  methods: {
    setMedicine: function setMedicine(index) {
      this.addToComboMed = this.searchMedicines[index];
      this.searchDrug = this.addToComboMed.generic_name;
      this.searchMedicines = [];
    },
    addDrugToCombo: function addDrugToCombo() {
      var _this = this;

      this.instance.post('/api/combo-medication-set/', {
        parent_medication: this.rowData.medication.id,
        child_medication_quantity: this.dose,
        child_medication: this.addToComboMed.id
      }).then(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$store.commit('SET_MESSAGE', {
                  context: '新增成功',
                  type: 'success'
                });
                _context.next = 3;
                return _this.$parent.$parent.getComboDrugCategory();

              case 3:
                _context.next = 5;
                return _this.$parent.$parent.getComboSet();

              case 5:
                // reset the variables
                _this.addToComboMed = {};
                _this.searchDrug = '';
                // hack to let the component reload.
                _this.$parent.toggleDetailRow(_this.rowIndex + 1);
                _this.$parent.toggleDetailRow(_this.rowIndex + 1);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))).catch(function (err) {
        console.log(err);
        _this.$store.commit('SET_MESSAGE', {
          context: err.response.data,
          type: 'error'
        });
      });
    },
    deleteFromCombo: function deleteFromCombo(id) {
      var _this2 = this;

      this.instance.delete('/api/combo-medication-set/' + id + '/').then(function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(res) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _this2.$store.commit('SET_MESSAGE', {
                    context: '刪除成功',
                    type: 'success'
                  });
                  _context2.next = 3;
                  return _this2.$parent.$parent.getComboDrugCategory();

                case 3:
                  _context2.next = 5;
                  return _this2.$parent.$parent.getComboSet();

                case 5:
                  // hack to let the component reload.
                  _this2.$parent.toggleDetailRow(_this2.rowIndex + 1);
                  _this2.$parent.toggleDetailRow(_this2.rowIndex + 1);

                case 7:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this2);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  },
  watch: {
    searchDrug: function searchDrug(val) {
      var _this3 = this;

      if (val.length >= 3 && this.searchDrug !== this.addToComboMed.generic_name) {
        this.instance.get('/api/medication/', {
          params: {
            search: val
          }
        }).then(function (res) {
          _this3.searchMedicines = res.data.results;
        });
      } else {
        this.searchMedicines = [];
      }
    }
  }
});

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetable_2_src_components_Vuetable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetable_2_src_components_Vuetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetable_2_src_components_Vuetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vuex_functions_readCookie__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ComboDetail__ = __webpack_require__(1239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ComboDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ComboDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_CreateSpecialMedicineForm__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_CreateSpecialMedicineForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__common_CreateSpecialMedicineForm__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].component('combo-detail', __WEBPACK_IMPORTED_MODULE_8__ComboDetail___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DrugDBSettings',
  data: function data() {
    return {
      boostrapCss: {
        tableClass: 'table table-bordered table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: ''
          }
        }
      },
      httpOptions: {
        headers: {
          Authorization: 'Token ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__vuex_functions_readCookie__["a" /* default */])('Token')
        }
      },
      comboField: [{
        name: 'medication.generic_name',
        title: '套藥名稱'
      }, {
        name: 'pairsCount',
        title: '數量',
        titleClass: 'text-center',
        dataClass: 'text-center'
      }, {
        name: '__slot:actions',
        title: '動作',
        titleClass: 'text-center w-25',
        dataClass: 'text-center'
      }],
      itemActions: [{
        name: 'delete-combo',
        label: '刪除套藥',
        icon: 'glyphicon glyphicon-zoom-in',
        class: 'btn btn-info',
        extra: { title: 'View' }
      }],
      server: __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */],
      comboSet: {},
      createForm: false
    };
  },

  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_4_vuetable_2_src_components_Vuetable___default.a,
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination___default.a,
    CreateSpecialMedicineForm: __WEBPACK_IMPORTED_MODULE_9__common_CreateSpecialMedicineForm___default.a
  },
  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getComboDrugCategory();

            case 2:
              _context.next = 4;
              return _this.getComboSet();

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    dataCreated: function dataCreated() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.closeForm();
                _context2.next = 3;
                return _this2.getComboDrugCategory();

              case 3:
                _context2.next = 5;
                return _this2.getComboSet();

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    closeForm: function closeForm() {
      this.createForm = false;
    },
    getComboDrugCategory: function getComboDrugCategory() {
      var _this3 = this;

      this.comboSet = {};
      return this.instance.get('/api/medication/', {
        params: {
          type: 'combo'
        }
      }).then(function (res) {
        res.data.results.forEach(function (medication) {
          _this3.comboSet[medication.id] = {
            medication: medication,
            combo: [],
            pairsCount: 0,
            id: medication.id
          };
        });
      });
    },
    onComboClicked: function onComboClicked(data, field, event) {
      this.$refs.vuetableCombo.toggleDetailRow(data.id);
    },
    getComboSet: function getComboSet() {
      var _this4 = this;

      return this.instance.get('/api/combo-medication-set/').then(function (res) {
        res.data.forEach(function (pair) {
          try {
            var oneSet = _this4.comboSet[pair.parent_medication.id];
            oneSet.combo.push({ medication: pair.child_medication, dose: pair.child_medication_quantity, relation_id: pair.id });
            oneSet.pairsCount += 1;
          } catch (e) {
            console.error(e);
          }
        });
        _this4.$refs.vuetableCombo.setData(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(_this4.comboSet));
      });
    },
    deleteCombo: function deleteCombo(data) {
      var _this5 = this;

      return this.instance.delete('/api/medication/' + data.id + '/').then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(res) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _this5.$store.commit('SET_MESSAGE', {
                    type: 'success',
                    context: '刪除成功'
                  });
                  _context3.next = 3;
                  return _this5.getComboDrugCategory();

                case 3:
                  _context3.next = 5;
                  return _this5.getComboSet();

                case 5:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, _this5);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
});

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ControlDetail',
  props: ['rowData', 'rowIndex'],
  data: function data() {
    return {
      searchDrug: '',
      searchMedicines: [],
      addToControlMed: {},
      dose: 1
    };
  },

  computed: {
    instance: function instance() {
      return this.$store.getters.instance;
    },
    pairAddable: function pairAddable() {
      if (this.addToControlMed.id === undefined) return false;
      if (this.dose < 1) return false;
      return true;
    }
  },
  methods: {
    setMedicine: function setMedicine(index) {
      this.addToControlMed = this.searchMedicines[index];
      this.searchDrug = this.addToControlMed.generic_name;
      this.searchMedicines = [];
    },
    addDrugToControl: function addDrugToControl() {
      var _this = this;

      this.instance.post('/api/control-medication-set/', {
        parent_medication: this.rowData.medication.id,
        child_medication_quantity: this.dose,
        child_medication: this.addToControlMed.id
      }).then(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$store.commit('SET_MESSAGE', {
                  context: '新增成功',
                  type: 'success'
                });
                _context.next = 3;
                return _this.$parent.$parent.getControlDrugCategory();

              case 3:
                _context.next = 5;
                return _this.$parent.$parent.getControlSet();

              case 5:
                // hack to let the component reload.
                _this.$parent.toggleDetailRow(_this.rowIndex + 1);
                _this.$parent.toggleDetailRow(_this.rowIndex + 1);

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      })));
    },
    deleteFromControl: function deleteFromControl(id) {
      var _this2 = this;

      this.instance.delete('/api/control-medication-set/' + id + '/').then(function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(res) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _this2.$store.commit('SET_MESSAGE', {
                    context: '刪除成功',
                    type: 'success'
                  });
                  _context2.next = 3;
                  return _this2.$parent.$parent.getControlDrugCategory();

                case 3:
                  _context2.next = 5;
                  return _this2.$parent.$parent.getControlSet();

                case 5:
                  // hack to let the component reload.
                  _this2.$parent.toggleDetailRow(_this2.rowIndex + 1);
                  _this2.$parent.toggleDetailRow(_this2.rowIndex + 1);

                case 7:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this2);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  },
  watch: {
    searchDrug: function searchDrug(val) {
      var _this3 = this;

      if (val.length >= 3 && this.searchDrug !== this.addToControlMed.generic_name) {
        this.instance.get('/api/medication/', {
          params: {
            search: val
          }
        }).then(function (res) {
          _this3.searchMedicines = res.data.results;
        });
      } else {
        this.searchMedicines = [];
      }
    }
  }
});

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetable_2_src_components_Vuetable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetable_2_src_components_Vuetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetable_2_src_components_Vuetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vuex_functions_readCookie__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ControlDrugDetail__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ControlDrugDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ControlDrugDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_CreateSpecialMedicineForm__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_CreateSpecialMedicineForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__common_CreateSpecialMedicineForm__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].component('control-detail', __WEBPACK_IMPORTED_MODULE_8__ControlDrugDetail___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DrugDBSettings',
  data: function data() {
    return {
      boostrapCss: {
        tableClass: 'table table-bordered table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: ''
          }
        }
      },
      httpOptions: {
        headers: {
          Authorization: 'Token ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__vuex_functions_readCookie__["a" /* default */])('Token')
        }
      },
      comboField: [{
        name: 'medication.generic_name',
        title: '管制藥組名稱'
      }, {
        name: 'pairsCount',
        title: '數量',
        titleClass: 'text-center',
        dataClass: 'text-center'
      }, {
        name: '__slot:actions',
        title: '動作',
        titleClass: 'text-center w-25',
        dataClass: 'text-center'
      }],
      itemActions: [{
        name: 'delete-combo',
        label: '刪除套藥',
        icon: 'glyphicon glyphicon-zoom-in',
        class: 'btn btn-info',
        extra: { title: 'View' }
      }],
      server: __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */],
      comboSet: {},
      createForm: false
    };
  },

  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_4_vuetable_2_src_components_Vuetable___default.a,
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination___default.a,
    CreateSpecialMedicineForm: __WEBPACK_IMPORTED_MODULE_9__common_CreateSpecialMedicineForm___default.a
  },
  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getControlDrugCategory();

            case 2:
              _context.next = 4;
              return _this.getControlSet();

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    dataCreated: function dataCreated() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.closeForm();
                _context2.next = 3;
                return _this2.getControlDrugCategory();

              case 3:
                _context2.next = 5;
                return _this2.getControlSet();

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    closeForm: function closeForm() {
      this.createForm = false;
    },
    getControlDrugCategory: function getControlDrugCategory() {
      var _this3 = this;

      this.comboSet = {};
      return this.instance.get('/api/medication/', {
        params: {
          type: 'control'
        }
      }).then(function (res) {
        res.data.results.forEach(function (medication) {
          _this3.comboSet[medication.id] = {
            medication: medication,
            combo: [],
            pairsCount: 0,
            id: medication.id
          };
        });
      });
    },
    onControlClicked: function onControlClicked(data, field, event) {
      this.$refs.vuetableCombo.toggleDetailRow(data.id);
    },
    getControlSet: function getControlSet() {
      var _this4 = this;

      return this.instance.get('/api/control-medication-set/').then(function (res) {
        res.data.forEach(function (pair) {
          var oneSet = _this4.comboSet[pair.parent_medication.id];
          oneSet.combo.push({ medication: pair.child_medication, dose: pair.child_medication_quantity, relation_id: pair.id });
          oneSet.pairsCount += 1;
        });
        _this4.$refs.vuetableCombo.setData(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(_this4.comboSet));
      });
    },
    deleteControl: function deleteControl(data) {
      var _this5 = this;

      return this.instance.delete('/api/medication/' + data.id + '/').then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(res) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _this5.$store.commit('SET_MESSAGE', {
                    type: 'success',
                    context: '刪除成功'
                  });
                  _context3.next = 3;
                  return _this5.getControlDrugCategory();

                case 3:
                  _context3.next = 5;
                  return _this5.getControlSet();

                case 5:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, _this5);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
});

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetable_2_src_components_Vuetable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetable_2_src_components_Vuetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetable_2_src_components_Vuetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_VuetablePagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_VuetablePagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_VuetablePagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_functions_readCookie__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_CreateMedicineForm__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_CreateMedicineForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_CreateMedicineForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DrugSettingsDetail__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DrugSettingsDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__DrugSettingsDetail__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('drug-settings-detail', __WEBPACK_IMPORTED_MODULE_6__DrugSettingsDetail___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DrugDBSettings',
  data: function data() {
    return {
      boostrapCss: {
        tableClass: 'table table-striped table-bordered table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: ''
          }
        }
      },
      httpOptions: {
        headers: {
          Authorization: 'Token ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__vuex_functions_readCookie__["a" /* default */])('Token')
        }
      },
      fields: [{
        name: 'code',
        sortField: 'code',
        title: '藥碼'
      }, {
        name: 'CGMH_number',
        sortField: 'CGMH_number',
        title: '料位號'
      }, {
        name: 'generic_name',
        sortField: 'generic_name',
        title: '學名'
      },
      // {
      //   name: 'product_name',
      //   title: '產品名',
      // },
      {
        name: 'pack_content',
        title: 'pc/盒',
        titleClass: 'text-center',
        dataClass: 'text-center'
      }, {
        name: 'restrained_class',
        title: '管制等級',
        titleClass: 'text-center',
        dataClass: 'text-center'
      }],
      server: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */],
      createForm: false,
      moreParams: {},
      medName: ''
    };
  },

  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_1_vuetable_2_src_components_Vuetable___default.a,
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_VuetablePagination___default.a,
    CreateMedicineForm: __WEBPACK_IMPORTED_MODULE_5__common_CreateMedicineForm___default.a
  },
  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  methods: {
    getSortParam: function getSortParam(sortOrder) {
      return sortOrder.map(function (sort) {
        return (sort.direction === 'desc' ? '-' : '') + sort.field;
      }).join(',');
    },
    onPaginationData: function onPaginationData(paginationData) {
      // this.$refs.paginationInfoTop.setPaginationData(paginationData);
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetableMed.changePage(page);
    },
    onMedClicked: function onMedClicked(data, field, event) {
      this.$refs.vuetableMed.toggleDetailRow(data.id);
    },
    onFilterSet: function onFilterSet() {
      var _this = this;

      this.moreParams = {
        search: this.medName
      };
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].nextTick(function () {
        return _this.$refs.vuetableMed.refresh();
      });
    },
    closeForm: function closeForm() {
      this.createForm = false;
    }
  }
});

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DrugGroupDetail',
  props: ['rowData', 'rowIndex', 'rowField'],
  data: function data() {
    return {
      medicineSet: [],
      searchDrug: '',
      searchMedicines: [],
      addToGroupMed: {}
    };
  },

  computed: {
    instance: function instance() {
      return this.$store.getters.instance;
    }
  },
  methods: {
    addDrugToGroup: function addDrugToGroup() {
      var _this = this;

      var group = [this.rowData.id].concat(this.addToGroupMed.group);
      this.instance.patch('/api/medication/' + this.addToGroupMed.id + '/', {
        group: group
      }).then(function () {
        _this.$parent.refresh();
        console.log(_this.rowIndex);
        // hack to let the component reload.
        _this.$parent.toggleDetailRow(_this.rowIndex + 1);
        _this.$parent.toggleDetailRow(_this.rowIndex + 1);
        _this.searchDrug = '';
      });
    },
    deleteDrugFromGroup: function deleteDrugFromGroup(index) {
      var _this2 = this;

      var med = this.medicineSet[index];
      var editGroup = med.group.filter(function (e) {
        return e !== _this2.rowData.id;
      });
      this.instance.patch('/api/medication/' + med.id + '/', {
        group: editGroup
      }).then(function () {
        _this2.$parent.refresh();
      });
    },
    setMedicine: function setMedicine(index) {
      this.addToGroupMed = this.searchMedicines[index];
      this.searchDrug = this.addToGroupMed.generic_name;
      this.searchMedicines = [];
    },
    getMedDetail: function getMedDetail() {
      var _this3 = this;

      this.instance.get('/api/medication-group/' + this.rowData.id + '/').then(function (res) {
        _this3.medicineSet = res.data.medicine_set;
      });
    }
  },
  created: function created() {
    this.getMedDetail();
  },

  watch: {
    searchDrug: function searchDrug(val) {
      var _this4 = this;

      if (val.length >= 3 && this.searchDrug !== this.addToGroupMed.generic_name) {
        this.instance.get('/api/medication/', {
          params: {
            search: val
          }
        }).then(function (res) {
          _this4.searchMedicines = res.data.results;
        });
      } else {
        this.searchMedicines = [];
      }
    },
    rowData: function rowData() {
      this.getMedDetail();
    }
  }
});

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetable_2_src_components_Vuetable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetable_2_src_components_Vuetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetable_2_src_components_Vuetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_VuetablePagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_VuetablePagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_VuetablePagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_functions_readCookie__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_CreateDrugGroupForm__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_CreateDrugGroupForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_CreateDrugGroupForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DrugGroupDetail__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DrugGroupDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__DrugGroupDetail__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('drug-group-detail', __WEBPACK_IMPORTED_MODULE_6__DrugGroupDetail___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('medication-group-count', {
  name: 'medicationGroupCount',
  props: ['rowData', 'rowIndex', 'rowField'],
  template: '\n    <span>{{ rowData.medicine_set.length }}</span>\n  '
});

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DrugGroupSettings',
  data: function data() {
    return {
      boostrapCss: {
        tableClass: 'table table-striped table-bordered table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: ''
          }
        }
      },
      httpOptions: {
        headers: {
          Authorization: 'Token ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__vuex_functions_readCookie__["a" /* default */])('Token')
        }
      },
      categoryField: [{
        name: 'name',
        title: '群組名稱'
      }, {
        name: '__component:medication-group-count',
        title: '藥物數量',
        titleClass: 'text-center w-25',
        dataClass: 'text-center'
        // callback: 'drawerCount',
      }, {
        name: '__slot:actions',
        title: '動作',
        titleClass: 'text-center w-25',
        dataClass: 'text-center'
      }],
      server: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */],
      createDrugGroupForm: false
    };
  },

  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_1_vuetable_2_src_components_Vuetable___default.a,
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_VuetablePagination___default.a,
    CreateDrugGroupForm: __WEBPACK_IMPORTED_MODULE_5__common_CreateDrugGroupForm___default.a
  },
  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  methods: {
    dataCreated: function dataCreated() {
      this.closeDrugGroupForm();
      this.$refs.vuetableGroup.refresh();
    },
    onGroupClicked: function onGroupClicked(data, field, event) {
      this.$refs.vuetableGroup.toggleDetailRow(data.id);
    },
    closeDrugGroupForm: function closeDrugGroupForm() {
      this.createDrugGroupForm = false;
    },
    deleteGroup: function deleteGroup(data) {
      var _this = this;

      this.instance.delete('/api/medication-group/' + data.id + '/').then(function (res) {
        _this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '刪除成功'
        });
        _this.$refs.vuetableGroup.refresh();
      });
    }
  }
});

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DrugList',
  computed: {
    serverPrivilege: function serverPrivilege() {
      return this.$store.state.user.user.server_privilege;
    }
  }
});

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      medicineData: {},
      photo1: null,
      photo2: null,
      photo3: null
    };
  },

  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  mounted: function mounted() {
    this.medicineData = this.rowData;
  },

  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  methods: {
    onChange: function onChange(event) {
      var id = event.target.id;
      console.log(id);
      console.log(id === this.rowIndex + '-phtot2');
      switch (id) {
        case this.rowIndex + '-photo1':
          this.photo1 = event.target.files[0];
          break;
        case this.rowIndex + '-photo2':
          this.photo2 = event.target.files[0];
          break;
        case this.rowIndex + '-photo3':
          this.photo3 = event.target.files[0];
          break;
        default:
          console.log(id);
      }
    },
    updateMedicine: function updateMedicine() {
      var _this = this;

      var data = new FormData();
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(this.medicineData).forEach(function (entries) {
        var key = entries[0];
        var value = entries[1];
        if (key !== 'drug_picture_1' && key !== 'drug_picture_2' && key !== 'drug_box_picture' && key !== 'id' && key !== 'group' && value !== null) {
          console.log(entries[0], entries[1]);
          data.append(entries[0], entries[1]);
        }
      });
      if (this.photo1) data.append('drug_picture_1', this.photo1);
      if (this.photo2) data.append('drug_picture_2', this.photo2);
      if (this.photo3) data.append('drug_box_picture', this.photo3);

      // console.log(data);
      this.instance.patch('/api/medication/' + this.rowData.id + '/', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (res) {
        _this.$parent.refresh();
        _this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新完成'
        });
      });
    },
    deleteMedicine: function deleteMedicine() {
      var _this2 = this;

      this.instance.delete('/api/medication/' + this.rowData.id + '/').then(function () {
        _this2.$parent.refresh();
        _this2.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新完成'
        });
      });
    }
  }
});

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GeneralSetting',
  data: function data() {
    return {
      createReason: false,
      reason: ''
    };
  },
  created: function created() {
    //

    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    },
    generalSetting: function generalSetting() {
      return this.$store.state.generalSetting;
    },
    returnReason: function returnReason() {
      return this.$store.state.generalSetting.return_reason;
    }
  },
  methods: {
    addReason: function addReason() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var reasons;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                reasons = _this2.returnReason.join(';');

                console.log(_this2.returnReason, reasons);
                _this2.instance.patch('/api/general-setting/' + _this2.generalSetting.id + '/', {
                  return_reason: reasons.concat(';' + _this2.reason)
                }).then(function () {
                  _this2.$store.commit('SET_MESSAGE', {
                    type: 'success',
                    context: '新增成功'
                  });
                  _this2.$store.dispatch('getSystemInfo');
                  _this2.createReason = false;
                });

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    deleteReason: function deleteReason(ind) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log(_this3.returnReason.splice(ind, 1));
                _this3.instance.patch('/api/general-setting/' + _this3.generalSetting.id + '/', {
                  return_reason: _this3.returnReason.join(';')
                }).then(function () {
                  _this3.$store.commit('SET_MESSAGE', {
                    type: 'success',
                    context: '刪除成功'
                  });
                  _this3.$store.dispatch('getSystemInfo');
                });

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  }
});

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_PasswordChange__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_PasswordChange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_PasswordChange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_Confirm__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_Confirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_Confirm__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ParaDetail',
  data: function data() {
    return {
      //location: null,
      //location_code: null,
      road_speed_limit: 0,
      break_value: 0,
      break_value_slow: 0,
      alarmSpeed: 0,
      alarmIllegalNum: 0
    };
  },

  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  components: {
    PasswordChange: __WEBPACK_IMPORTED_MODULE_3__components_common_PasswordChange___default.a,
    Confirm: __WEBPACK_IMPORTED_MODULE_4__components_common_Confirm___default.a
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              //this.location = this.rowData.location;
              //this.location_code = this.rowData.location_code;
              _this.road_speed_limit = _this.rowData.road_speed_limit;
              _this.break_value = _this.rowData.break_value;
              _this.break_value_slow = _this.rowData.break_value_slow;
              _this.alarmSpeed = _this.rowData.alarmSpeed;
              _this.alarmIllegalNum = _this.rowData.alarmIllegalNum;

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  methods: {
    updatePara: function updatePara() {
      var _this2 = this;

      this.instance.patch('/api/fixed-link-code/' + this.rowData.id + '/', {
        //location: this.location,
        //location_code: this.location_code,
        road_speed_limit: this.road_speed_limit,
        break_value: this.break_value,
        break_value_slow: this.break_value_slow,
        alarmSpeed: this.alarmSpeed,
        alarmIllegalNum: this.alarmIllegalNum
      }).then(function () {
        _this2.$parent.refresh();
        _this2.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功'
        });
        _this2.$parent.refresh();
      }).catch(function (err) {
        _this2.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: err.response.data
        });
      });
    }
  }
});

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_VuetablePagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_VuetablePagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_VuetablePagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetable_2_src_components_Vuetable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetable_2_src_components_Vuetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetable_2_src_components_Vuetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vuex_functions_readCookie__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ParaDetail__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ParaDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ParaDetail__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('para-detail', __WEBPACK_IMPORTED_MODULE_7__ParaDetail___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ParaSettings',
  data: function data() {
    return {
      boostrapCss: {
        tableClass: 'table table-striped table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: ''
          }
        }
      },
      httpOptions: {
        headers: {
          Authorization: 'Token ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__vuex_functions_readCookie__["a" /* default */])('Token')
        }
      },
      server: __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */],
      fields: [{
        name: 'fixed_link_code',
        title: '固定桿代碼'
      }, {
        name: 'location',
        title: '地點名稱'
      }, {
        name: 'verInfo',
        title: '軟體版本/日期'
      }, {
        name: 'location_code',
        title: '地點代碼'
      }, {
        name: 'road_speed_limit',
        title: '道路限速'
      }, {
        name: 'break_value',
        title: '舉發車速(超速)'
      }, {
        name: 'break_value_slow',
        title: '舉發車速(龜速)'
      }, {
        name: 'alarmSpeed',
        title: '警示違規車速'
      }, {
        name: 'alarmIllegalNum',
        title: '警示違規筆數'
      }],
      moreParams: undefined
    };
  },

  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_4_vuetable_2_src_components_Vuetable___default.a,
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_VuetablePagination___default.a
  },
  methods: {
    onCellClicked: function onCellClicked(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.id);
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    }
  },
  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    }
  }
  // computed: mapState({
  //   system: state => state.system,
  // }),
});

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_PasswordChange__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_PasswordChange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_PasswordChange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_Confirm__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_Confirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_common_Confirm__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserDetail',
  data: function data() {
    return {
      Data: '',
      jobTitle: [],
      departments: [],
      serverPrivilege2Group: [],
      //medAppPrivilegeGroup: [],
      //taskPrivilegeGroup: [],
      firstName: null,
      lastName: null,
      //email: null,
      title: null,
      department: null,
      serverPrivilege2: '',
      //medAppPrivilege: null,
      //taskPrivilege: null,
      barcode: null,
      isAdmin: false,
      isSuperuser: false,
      showPasswordChange: false,
      showConfirm: false,
      systemType: __WEBPACK_IMPORTED_MODULE_3__config__["b" /* systemType */]
    };
  },

  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  components: {
    PasswordChange: __WEBPACK_IMPORTED_MODULE_4__components_common_PasswordChange___default.a,
    Confirm: __WEBPACK_IMPORTED_MODULE_5__components_common_Confirm___default.a
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.Data = _this.rowData;
              _this.getJobTitle();
              _this.getDepartment();
              _context.next = 5;
              return _this.getServerPrivilege2Group();

            case 5:
              _this.serverPrivilege2 = _this.rowData.server_privilege2.id;
              //if (this.systemType === 'ADC') {
              //await this.getMedAppPrivilegeGroup();
              //await this.getTaskPrivilegeGroup();
              // await this.getServerPrivilegeGroup();
              // this.serverPrivilege = this.rowData.server_privilege.id;
              //if (this.rowData.med_app_privilege !== null) {
              //  this.medAppPrivilege = this.rowData.med_app_privilege.id;
              //}
              //if (this.rowData.med_app_privilege !== null) {
              //  this.taskPrivilege = this.rowData.task_privilege.id;
              //}
              //}
              _this.firstName = _this.rowData.first_name;
              _this.lastName = _this.rowData.last_name;
              //this.email = this.rowData.email;
              _this.barcode = _this.rowData.barcode;
              _this.isAdmin = _this.rowData.is_admin;
              _this.isSuperuser = _this.rowData.is_superuser;
              _this.title = _this.rowData.title.id;
              _this.department = _this.rowData.department.id;

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  methods: {
    putIntoData: function putIntoData(response, data) {
      var _this2 = this;

      response.data.forEach(function (item) {
        _this2[data].push(item);
      });
    },
    pushToCheckData: function pushToCheckData(item, checkedData) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(item).forEach(function (i) {
        var attrName = i[0];
        var attrValue = i[1];

        if (attrName !== 'id' && attrName !== 'id') {
          if (attrValue) {
            checkedData.push(attrName);
          }
        }
      });
    },
    getDepartment: function getDepartment() {
      var _this3 = this;

      return this.instance.get('/api/department/').then(function (res) {
        _this3.putIntoData(res, 'departments');
      });
    },
    getJobTitle: function getJobTitle() {
      var _this4 = this;

      return this.instance.get('/api/job-title/').then(function (res) {
        _this4.putIntoData(res, 'jobTitle');
      });
    },
    getServerPrivilege2Group: function getServerPrivilege2Group() {
      var _this5 = this;

      return this.instance.get('/api/server-privilege2/').then(function (res) {
        _this5.putIntoData(res, 'serverPrivilege2Group');
      });
    },

    /*
    getTaskPrivilegeGroup() {
      return this.instance.get('/api/task-privilege/')
      .then((res) => {
        this.putIntoData(res, 'taskPrivilegeGroup');
      });
    },
    getMedAppPrivilegeGroup() {
      return this.instance.get('/api/med-app-privilege/')
      .then((res) => {
        this.putIntoData(res, 'medAppPrivilegeGroup');
        // this.medAppPrivilegeGroup.forEach((item) => {
        //   if (item.id === this.rowData.med_app_privilege.id) {
        //     this.thisMedAppPrivilegeGroup = item;
        //     // this.pushToCheckData(item, this.checkedMedApp);
        //   }
        // });
      });
    },
    */
    updateUser: function updateUser() {
      var _this6 = this;

      this.instance.patch('/api/user/' + this.rowData.id + '/', {
        first_name: this.firstName,
        last_name: this.lastName,
        //email: this.email,
        department: this.department,
        title: this.title,
        server_privilege2: this.serverPrivilege2,
        //med_app_privilege: this.medAppPrivilege,
        //task_privilege: this.taskPrivilege,
        barcode: this.barcode,
        is_admin: this.isAdmin,
        is_superuser: this.isSuperuser
      }).then(function () {
        _this6.$parent.refresh();
        _this6.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功'
        });
        _this6.$parent.refresh();
      }).catch(function (err) {
        _this6.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: err.response.data
        });
      });
    },
    confirmDel: function confirmDel(res) {
      if (res) this.deleteUser();
      this.showConfirm = false;
    },
    deleteUser: function deleteUser() {
      var _this7 = this;

      this.instance.delete('/api/user/' + this.rowData.id + '/').then(function (res) {
        _this7.$parent.refresh();
        _this7.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '刪除成功'
        });
      });
    },
    closePanel: function closePanel() {
      this.showPasswordChange = false;
    }
  }
});

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_Vuetable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_Vuetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_Vuetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_functions_readCookie__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserGroupSettingsDetail__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserGroupSettingsDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__UserGroupSettingsDetail__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('user-group-settings-detail', __WEBPACK_IMPORTED_MODULE_5__UserGroupSettingsDetail___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserGroupSettings',
  data: function data() {
    return {
      boostrapCss: {
        tableClass: 'table table-striped table-bordered table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: ''
          }
        }
      },
      httpOptions: {
        headers: {
          Authorization: 'Token ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__vuex_functions_readCookie__["a" /* default */])('Token')
        }
      },
      server: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */],
      fields: {
        server: [{
          name: 'name',
          title: '名稱'
        }, {
          name: 'adc_management',
          title: '藥櫃管理',
          callback: 'humanlized'
        }, {
          name: 'tag_management',
          title: '標籤管理',
          callback: 'humanlized'
        }, {
          name: 'report_output',
          title: '紀錄報表',
          callback: 'humanlized'
        }, {
          name: 'data_import',
          title: '資料匯入',
          callback: 'humanlized'
        }, {
          name: 'system_setting',
          title: '系統設定',
          callback: 'humanlized'
        }, {
          name: '__slot:action',
          title: '動作'
        }],
        medApp: [{
          name: 'name',
          title: '名稱'
        }, {
          name: 'fetch',
          title: '取藥',
          callback: 'humanlized'
        }, {
          name: 'return_drug',
          title: '退藥',
          callback: 'humanlized'
        }, {
          name: 'inventory',
          title: '盤點',
          callback: 'humanlized'
        },
        // {
        //   name: 'plan_create',
        //   title: '預排新增',
        // },
        // {
        //   name: 'plan_remove',
        //   title: '預排移除',
        // },
        // {
        //   name: 'plan_refill',
        //   title: '預排補藥',
        // },
        // {
        //   name: 'recheck',
        //   title: '覆核',
        // },
        {
          name: 'remove_outdated',
          title: '移除過期藥物',
          callback: 'humanlized'
        }, {
          name: 'create',
          title: '新增',
          callback: 'humanlized'
        }, {
          name: 'remove',
          title: '移除',
          callback: 'humanlized'
        }, {
          name: 'refill',
          title: '補藥',
          callback: 'humanlized'
        }, {
          name: '__slot:action',
          title: '動作'
        }]
      },
      checkedServer: [],
      checkedMedApp: [],
      createServerP: false,
      createMedAppP: false,
      medAppName: '',
      serverName: ''
    };
  },

  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_Vuetable___default.a
  },
  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  methods: {
    onCellClicked: function onCellClicked(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.id);
    },
    humanlized: function humanlized(value) {
      if (value) {
        return '<h6>是</h6>';
      }
      return '<h6>否</h6>';
    },
    addMedAppP: function addMedAppP() {
      var _this = this;

      var data = {};
      this.checkedMedApp.forEach(function (item) {
        data[item] = true;
      });
      data.name = this.medAppName;

      this.instance.post('/api/med-app-privilege/', data).then(function (res) {
        _this.$refs.vuetableMedApp.refresh();
        _this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '新增成功'
        });
        _this.createMedAppP = false;
      });
    },
    deleteMedAppP: function deleteMedAppP(id) {
      var _this2 = this;

      this.instance.delete('/api/med-app-privilege/' + id + '/').then(function (res) {
        _this2.$refs.vuetableMedApp.refresh();
        _this2.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '刪除成功'
        });
      });
    },
    addServerP: function addServerP() {
      var _this3 = this;

      var data = {};
      this.checkedServer.forEach(function (item) {
        data[item] = true;
      });
      data.name = this.serverName;

      this.instance.post('/api/server-privilege/', data).then(function (res) {
        _this3.$refs.vuetableServer.refresh();
        _this3.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '新增成功'
        });
        _this3.createServerP = false;
      });
    },
    deleteServerP: function deleteServerP(id) {
      var _this4 = this;

      this.instance.delete('/api/server-privilege/' + id + '/').then(function (res) {
        _this4.$refs.vuetableServer.refresh();
        _this4.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '刪除成功'
        });
      });
    }
  }
  // computed: mapState({
  //   system: state => state.system,
  // }),
});

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserGroupSettingsDetail'
});

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_VuetablePagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_VuetablePagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_VuetablePagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetable_2_src_components_Vuetable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetable_2_src_components_Vuetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetable_2_src_components_Vuetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vuex_functions_readCookie__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UserDetail__ = __webpack_require__(1251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UserDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__UserDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_CreateUserForm__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_CreateUserForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__common_CreateUserForm__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('user-detail', __WEBPACK_IMPORTED_MODULE_7__UserDetail___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserSettings',
  data: function data() {
    return {
      boostrapCss: {
        tableClass: 'table table-striped table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: ''
          }
        }
      },
      httpOptions: {
        headers: {
          Authorization: 'Token ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__vuex_functions_readCookie__["a" /* default */])('Token')
        }
      },
      server: __WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */],
      fields: [{
        name: 'username',
        sortField: 'username',
        title: '帳號'
      }, {
        name: 'last_name',
        sortField: 'last_name',
        title: '姓'
      }, {
        name: 'first_name',
        sortField: 'first_name',
        title: '名'
      },
      // {
      //   name: 'email',
      //   title: '信箱',
      // },
      {
        name: 'title.name',
        title: '職稱'
      }, {
        name: 'department.name',
        title: '所屬單位'
      }, {
        name: 'barcode',
        title: '警員代碼'
      }],
      createForm: false,
      username: '',
      moreParams: undefined
    };
  },

  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_4_vuetable_2_src_components_Vuetable___default.a,
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_VuetablePagination___default.a,
    CreateUserForm: __WEBPACK_IMPORTED_MODULE_8__common_CreateUserForm___default.a
  },
  methods: {
    onCellClicked: function onCellClicked(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.id);
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    closeForm: function closeForm() {
      this.createForm = false;
    },
    onFilterSet: function onFilterSet() {
      var _this = this;

      this.moreParams = {
        search: this.username
      };
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].nextTick(function () {
        return _this.$refs.vuetable.refresh();
      });
    },
    getSortParam: function getSortParam(sortOrder) {
      return sortOrder.map(function (sort) {
        return (sort.direction === 'desc' ? '-' : '') + sort.field;
      }).join(',');
    }
  },
  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    }
  }
  // computed: mapState({
  //   system: state => state.system,
  // }),
});

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_AdminPatch__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_AdminPatch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_AdminPatch__);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ADCManagement',
  components: {
    Patch: __WEBPACK_IMPORTED_MODULE_0__common_AdminPatch___default.a
  }
});

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_Vuetable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_Vuetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_Vuetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_VuetablePagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_VuetablePagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_VuetablePagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_functions_readCookie__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Confirm__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Confirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__common_Confirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_CreateDrugStorageForm__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_CreateDrugStorageForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_CreateDrugStorageForm__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import DrugDetail from './DrugDetail';



// Vue.component('tag-drug-detail', DrugDetail);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('delete-drug-storage', {
  name: 'DeleteDrugStorage',
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  data: function data() {
    return {
      confirm: false
    };
  },

  components: {
    Confirm: __WEBPACK_IMPORTED_MODULE_6__common_Confirm___default.a
  },
  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  template: '\n    <div>\n      <button class="btn btn-danger btn-sm" @click="del">\u522A\u9664</button>\n      <Confirm v-show="confirm" :message="\'\u78BA\u5B9A\u522A\u9664?\'" v-on:response="confirmDel" />\n    </div>\n  ',
  methods: {
    confirmDel: function confirmDel(response) {
      var _this = this;

      this.confirm = false;
      if (response) {
        this.instance.delete('/api/drug-storage/' + this.rowData.id + '/', {
          data: {
            type: 'ADMIN_DELETE'
          }
        }).then(function (res) {
          _this.$parent.refresh();
        }).then(function () {
          _this.$parent.$parent.getTagSystem().then(function () {
            console.log('reset net');
            _this.$parent.$parent.setCurrentTag();
            _this.$parent.$parent.setCurrentNet();
          });
        });
      }
    },
    del: function del() {
      this.confirm = true;
    }
  }
});

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TagDrugList',
  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_Vuetable___default.a,
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_VuetablePagination___default.a,
    CreateDrugStorageForm: __WEBPACK_IMPORTED_MODULE_7__common_CreateDrugStorageForm___default.a
  },
  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    },
    drugStorageChangeTime: function drugStorageChangeTime() {
      return this.$store.getters.drugStorageChangeTime;
    }
  },
  data: function data() {
    return {
      boostrapCss: {
        tableClass: 'table table-striped table-bordered table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: ''
          }
        }
      },
      httpOptions: {
        headers: {
          Authorization: 'Token ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__vuex_functions_readCookie__["a" /* default */])('Token')
        }
      },
      fields: [{
        name: 'device.series',
        sortField: 'device__pos_col',
        title: '位置'
      }, {
        name: 'medication.CGMH_number',
        title: '料位號'
      }, {
        name: 'medication.generic_name',
        title: '藥名'
      }, {
        name: 'stock',
        title: '庫存'
      }, {
        name: 'max_stock',
        title: '最大庫存'
      },
      // {
      //   name: 'expired_date',
      //   title: '有效期限',
      // },
      // {
      //   name: 'patch_number',
      //   title: '批號',
      // },
      {
        name: 'inventoried_in_tag_system',
        title: '盤點與否',
        callback: 'booleanToZh'
      }, {
        name: '__component:delete-drug-storage',
        title: '刪除'
      }],
      sortOrder: [{
        sortField: 'device__pos_col',
        direction: 'asc'
      }],
      server: __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */],
      moreParams: {},
      tagSystems: [],
      tagId: '',
      currentTag: {},
      nets: [],
      netId: '',
      currentNet: {},
      devices: [],
      deviceId: null,
      currentDevice: {},
      createForm: false,
      searchDrug: '',
      medicines: [],
      currentMedicine: {},
      stock: 0,
      maxStock: 0,
      inventoried: false,
      date: null,
      batch: '',
      currentTagContainMed: false
    };
  },
  mounted: function mounted() {
    this.getTagSystem();
    // this.webSocketForUpdate();
  },

  methods: {
    getSortParam: function getSortParam(sortOrder) {
      return sortOrder.map(function (sort) {
        return (sort.direction === 'desc' ? '-' : '') + sort.sortField;
      }).join(',');
    },
    booleanToZh: function booleanToZh(val) {
      return val === true ? '是' : '否';
    },
    getTagSystem: function getTagSystem() {
      var _this2 = this;

      return this.instance.get('/api/system/', {
        params: {
          type: 'Tag'
        }
      }).then(function (res) {
        _this2.tagSystems = res.data.results;
      });
    },
    getCurrentTag: function getCurrentTag(id) {
      return this.instance.get('/api/system/' + id + '/');
    },
    setCurrentTag: function setCurrentTag() {
      var _this3 = this;

      this.getCurrentTag(this.tagSystems[this.tagId].id).then(function (res) {
        console.log(res);
        _this3.currentTag = res.data;
        _this3.nets = _this3.currentTag.net_set;
      }).catch(function (err) {
        _this3.$store.commit('SET_MESSAGES', {
          type: 'error',
          content: '選擇系統資料有誤'
        });
      });
    },
    setCurrentNet: function setCurrentNet() {
      var _this4 = this;

      this.currentNet = this.nets[this.netId];
      this.moreParams.device__net = this.currentNet.id;
      this.devices = [];
      this.nets[this.netId].device_set.forEach(function (d) {
        if (d.drugstorage_set.length === 0) {
          _this4.devices.push(d);
        }
      });
      // handling the first time vuetable was hidden
      this.$refs.vuetable.refresh();
    },
    onCellClicked: function onCellClicked(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.id);
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    checkFormFilled: function checkFormFilled() {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.currentMedicine).length !== 0 && this.stock !== 0 && this.maxStock !== 0) {
        return true;
      }
      return false;
    },
    checkMedExists: function checkMedExists(medId) {
      this.instance.get('/api/drug-storage/', {
        params: {
          device__net__system: this.$store.state.device.systemId,
          med_id: medId
        }
      }).then(function (res) {
        if (res.data.results.length > 0) {
          return true;
        }
        return false;
      });
    },
    popCreateForm: function popCreateForm() {
      if (this.devices.length > 0) {
        this.createForm = true;
      } else {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '此欄位已無空間新增藥物'
        });
      }
    },
    cancelForm: function cancelForm() {
      this.createForm = false;
    }
  },
  watch: {
    searchDrug: function searchDrug(val) {
      var _this5 = this;

      if (val.length >= 3 && this.searchDrug !== this.currentMedicine.generic_name) {
        this.instance.get('/api/medication/', {
          params: {
            search: val
          }
        }).then(function (res) {
          _this5.medicines = res.data.results;
        });
      } else {
        this.medicines = [];
      }
    },
    drugStorageChangeTime: function drugStorageChangeTime() {
      this.$refs.vuetable.refresh();
    }
  }
});

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_Vuetable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_Vuetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_Vuetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_functions_readCookie__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TagPlanning',
  data: function data() {
    return {
      boostrapCss: {
        tableClass: 'table table-striped table-bordered table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: ''
          }
        }
      },
      httpOptions: {
        headers: {
          Authorization: 'Token ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__vuex_functions_readCookie__["a" /* default */])('Token')
        }
      },
      server: __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */],
      fields: [{
        name: '__checkbox'
      },
      // {
      //   name: 'device',
      //   title: '位置',
      //   callback: 'readablePosistion',
      // },
      {
        name: 'device.id',
        title: '位置'
        // callback: 'readablePosistion',
      }, {
        name: 'medication.generic_name',
        title: '藥物'
      }, {
        name: 'stock',
        title: '目前存量'
      }, {
        name: 'max_stock',
        title: '最大存量'
      }, {
        name: '__slot:num-refill',
        title: '待補數量'
      }]
    };
  },

  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_Vuetable___default.a
  },
  methods: {
    onCellClicked: function onCellClicked(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.id);
    },
    setRefill: function setRefill() {
      var _this = this;

      var selected = this.$refs.vuetable.selectedTo;
      if (selected.length !== 0) {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '新增補藥規劃中...',
          confirm: false
        });
        var promises = [];
        selected.forEach(function (drugStorageId) {
          promises.push(_this.instance.post('/api/refill-order/', {
            drug_storage_id: drugStorageId
          }));
        });

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.all(promises).then(function (res) {
          console.log(res);
          _this.$store.commit('SET_MESSAGE', {
            type: 'success',
            context: '新增完成',
            confirm: true
          });
          _this.$refs.vuetable.selectedTo = [];
          _this.$refs.vuetable.refresh();
        });
      } else {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '請至少選擇一項藥物',
          confirm: true
        });
      }
    },
    readablePosistion: function readablePosistion(val) {
      var pos = '\u7B2C' + val.net.row_id + '\u5C64';
      if (val.pos_row !== 0) {
        pos = pos + ' - ' + val.pos_row + '\u5217 - ' + val.relative_col + '\u884C';
      }
      return pos;
    }
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])({
    systems: function systems(state) {
      return state.systems;
    },
    instance: function instance(state) {
      return state.instance;
    }
  })
});

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_Vuetable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_Vuetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_Vuetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_functions_readCookie__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TagPlanningList',
  data: function data() {
    return {
      boostrapCss: {
        tableClass: 'table table-striped table-bordered table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: ''
          }
        }
      },
      httpOptions: {
        headers: {
          Authorization: 'Token ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__vuex_functions_readCookie__["a" /* default */])('Token')
        }
      },
      server: __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */],
      fields: [{
        name: 'drug_storage.device.id',
        title: '位置'
      }, {
        name: 'drug_storage.medication.generic_name',
        title: '藥物'
      }, {
        name: 'drug_storage.stock',
        title: '目前存量'
      }, {
        name: 'drug_storage.max_stock',
        title: '最大存量'
      }, {
        name: '__slot:num-refill',
        title: '待補數量'
      }, {
        name: '__slot:action',
        title: '動作'
      }]
    };
  },

  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_Vuetable___default.a
  },
  methods: {
    onCellClicked: function onCellClicked(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.id);
    },
    setRefill: function setRefill() {
      var _this = this;

      var promises = [];
      var selected = this.$refs.vuetable.selectedTo;
      selected.forEach(function (drugStorageId) {
        promises.push(_this.instance.post('/api/refill-order/', {
          drug_storage_id: drugStorageId
        }));
      });

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.all(promises).then(function (res) {
        console.log(res);
      });
    },
    deleteOrder: function deleteOrder(id) {
      var _this2 = this;

      this.instance.delete('/api/refill-order/' + id + '/').then(function (res) {
        _this2.$refs.vuetable.refresh();
        _this2.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '刪除成功'
        });
      });
    }
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])({
    systems: function systems(state) {
      return state.systems;
    },
    instance: function instance(state) {
      return state.instance;
    }
  })
});

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TagDetail',
  data: function data() {
    return {
      // system attribute
      systemName: '',
      systemArea: '',
      systemAdmin: '',
      systemLoginMode: [],
      systemAlertOudatedDay: 0,
      area: [],
      department: [],
      user: [],
      systemInventoryBeforeFetch: false,
      systemMedRecordInput: false,
      systemReturnOriginalCmpn: false
    };
  },

  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  methods: {
    getArea: function getArea() {
      var _this = this;

      return this.instance.get('/api/area/').then(function (res) {
        res.data.forEach(function (data) {
          _this.area.push({
            label: data.name,
            value: data.id
          });
        });
      });
    },
    getDepartment: function getDepartment() {
      var _this2 = this;

      return this.instance.get('/api/department/').then(function (res) {
        res.data.forEach(function (data) {
          _this2.department.push({
            label: data.name,
            value: data.id
          });
        });
      });
    },
    getUser: function getUser() {
      var _this3 = this;

      return this.instance.get('/api/user/').then(function (res) {
        res.data.results.forEach(function (data) {
          _this3.user.push({
            label: data.username,
            value: data.id
          });
        });
      });
    },
    save: function save() {
      var _this4 = this;

      this.instance.patch('/api/system/' + this.rowData.id + '/', {
        name: this.systemName,
        area: this.systemArea,
        admin: this.systemAdmin,
        login_mode: this.systemLoginMode,
        alert_outdated_day: this.systemAlertOudatedDay,
        check_amount_first: this.systemInventoryBeforeFetch,
        return_to_original_cmpn: this.systemReturnOriginalCmpn,
        med_record_input: this.systemMedRecordInput
      }).then(function (res) {
        console.log(res);
        _this4.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功'
        });
        _this4.$parent.refresh();
      });
    }
  },
  created: function created() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this5.getArea();

            case 2:
              _context.next = 4;
              return _this5.getDepartment();

            case 4:
              _context.next = 6;
              return _this5.getUser();

            case 6:
              if (_this5.rowData.admin !== null) _this5.systemAdmin = _this5.rowData.admin.id;
              if (_this5.rowData.area !== null) _this5.systemArea = _this5.rowData.area.id;
              _this5.systemName = _this5.rowData.name;
              _this5.systemAlertOudatedDay = _this5.rowData.alert_outdated_day;
              _this5.systemLoginMode = _this5.rowData.login_mode;
              _this5.systemInventoryBeforeFetch = _this5.rowData.check_amount_first;
              _this5.systemMedRecordInput = _this5.rowData.med_record_input;
              _this5.systemReturnOriginalCmpn = _this5.rowData.return_to_original_cmpn;

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this5);
    }))();
  }
});

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_Vuetable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_Vuetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_Vuetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_VuetablePagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_VuetablePagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_VuetablePagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_functions_readCookie__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TagDetail__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TagDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__TagDetail__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('tag-detail', __WEBPACK_IMPORTED_MODULE_6__TagDetail___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TagList',
  data: function data() {
    return {
      boostrapCss: {
        tableClass: 'table table-striped table-bordered table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: ''
          }
        }
      },
      httpOptions: {
        headers: {
          Authorization: 'Token ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__vuex_functions_readCookie__["a" /* default */])('Token')
        }
      },
      server: __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */],
      fields: [{
        name: 'name',
        title: '名稱'
      }, {
        name: 'area.name',
        title: '所屬區域'
      }, {
        name: 'area.department.name',
        title: '所屬單位'
      }, {
        name: 'admin.username',
        title: '管理者'
      }]
    };
  },

  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_2_vuetable_2_src_components_Vuetable___default.a,
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_3_vuetable_2_src_components_VuetablePagination___default.a
  },
  methods: {
    onCellClicked: function onCellClicked(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.id);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    }
  }
  // computed: mapState({
  //   system: state => state.system,
  // }),
});

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_AdminPatch__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_AdminPatch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_AdminPatch__);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ADCManagement',
  components: {
    Patch: __WEBPACK_IMPORTED_MODULE_0__common_AdminPatch___default.a
  }
});

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetable_2_src_components_Vuetable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetable_2_src_components_Vuetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuetable_2_src_components_Vuetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vuex_functions_readCookie__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TicketCheckDetail__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TicketCheckDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__TicketCheckDetail__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].component('ticket-check-detail', __WEBPACK_IMPORTED_MODULE_11__TicketCheckDetail___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CarTicketList',
  data: function data() {
    return {
      //20220307 add
      currentPage: 1,
      tableDataLen: undefined,
      tmpId: '',
      startDate: undefined,
      endDate: undefined,
      loadingData: false,
      paras: [],
      boostrapCss: {
        tableClass: 'table table-striped table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: ''
          }
        }
      },
      httpOptions: {
        headers: {
          Authorization: 'Token ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__vuex_functions_readCookie__["a" /* default */])('Token')
        }
      },
      server: __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */],
      fields: [
      //20220307 add
      {
        name: '__slot:index',
        title: '序號'
      },
      /*
      {
        name: 'xactno',
        sortField: 'xactno',
        title: '流水號',
      },
      */
      {
        name: 'plt_no.plt_no',
        //sortField: 'plt_no.plt_no',
        title: '車牌號碼'
      },
      /*
      {
        name: 'car_tp.car_tp',
        sortField: 'car_tp__car_tp',
        title: '車別代碼',
      },
      */
      {
        name: 'vli_dateTime_in',
        sortField: 'vli_dateTime_in',
        title: '進入時間',
        callback: this.readableDate
      }, {
        name: 'vli_dateTime_out',
        sortField: 'vli_dateTime_out',
        title: '離開時間',
        callback: this.readableDate
      }, {
        name: 'pass_time',
        title: '通過時間(秒)'
      }, {
        name: 'speed',
        sortField: 'speed',
        title: '車速'
      }, {
        name: 'fixed_link_code.fixed_link_code',
        title: '固定桿代碼'
      }, {
        name: 'rule_code.rule_code',
        title: '條款代碼'
      },
      /*{
        name: 'status',
        title: '開單狀態',
        sortField: 'status',
        callback: this.status,
      },*/
      {
        name: 'user',
        sortField: 'user',
        title: '認證人員'
        //callback: this.status,
      }, {
        name: 'reviewer',
        sortField: 'reviewer',
        title: '開單人員'
      }],
      sortOrder: [{
        sortField: 'car_tp__car_tp',
        direction: 'asc'
      }],
      queryString: '',
      moreParams: {
        fixed_link_code_id: this.$store.state.user.user.department.fixed_link_code,
        status: 't1',
        user: this.$store.state.user.user.username,
        start_date: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'),
        end_date: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'),
        department: this.$store.state.user.user.department.name,
        checked: true
      }
    };
  },

  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_7_vuetable_2_src_components_Vuetable___default.a,
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_10__common_Loader___default.a
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getPara();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    startDate: function startDate(val) {
      if (val > this.endDate && this.endDate !== '') {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '開始時間不可晚於結束時間'
        });
        this.startDate = this.endDate;
      }
    },
    endDate: function endDate(val) {
      if (val < this.startDate && this.startDate !== '') {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '結束時間不可早於開始時間'
        });
        this.endDate = this.startDate;
      }
    }
  },
  methods: {
    onLoading: function onLoading() {
      this.loadingData = true;
      console.log('loading... show your spinner here');
    },
    onLoaded: function onLoaded() {
      this.loadingData = false;
      console.log('loaded! .. hide your spinner here');
      this.tableDataLen = this.$refs.vuetable.tableData.length;
      console.log('datalen:', this.tableDataLen);
      if (this.tableDataLen > 0) {
        console.log('id:', this.$refs.vuetable.tableData[0].id);
        this.onCellClicked(this.$refs.vuetable.tableData[0]);
      }
    },
    onCellClicked: function onCellClicked(data, field, event) {
      var _this2 = this;

      console.log('cellclicked');
      console.log('tmpId:', this.tmpId);
      console.log('nowId:', data.id);
      console.log('vuetable:', this.$refs.vuetable);
      if (this.tmpId == '') this.tmpId = data.id;else if (this.tmpId !== '' && this.tmpId != data.id) {
        this.$refs.vuetable.toggleDetailRow(this.tmpId);
        this.tmpId = data.id;
      } else if (this.tmpId == data.id) this.tmpId = '';
      //this.$refs.vuetable.toggleDetailRow(data.id);
      setTimeout(function () {
        _this2.$refs.vuetable.toggleDetailRow(data.id);
      }, 50);
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.currentPage = paginationData.current_page;
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet: function onFilterSet() {
      var _this3 = this;

      if (this.startDate == undefined || this.endDate == undefined) {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '請輸入查詢區間'
        });
        return;
      }
      console.log('start:', this.startDate);
      console.log('end:', this.endDate);
      /*
      if(this.queryString=="尚未處理")
          this.queryString="t0"
        else if(this.queryString=="已開單")
          this.queryString="t1"
        else if(this.queryString=="未違規")
          this.queryString="t2"  
        else if(this.queryString=="無法開單")
          this.queryString="t3" 
      */
      this.moreParams = {
        search: this.queryString,
        fixed_link_code_id: this.$store.state.user.user.department.fixed_link_code,
        status: 't1',
        user: this.$store.state.user.user.username,
        start_date: this.startDate,
        end_date: this.endDate,
        department: this.$store.state.user.user.department.name,
        checked: true
      };
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].nextTick(function () {
        return _this3.$refs.vuetable.refresh();
      });
    },
    getSortParam: function getSortParam(sortOrder) {
      return sortOrder.map(function (sort) {
        return (sort.direction === 'desc' ? '-' : '') + sort.sortField;
      }).join(',');
    },
    readableDate: function readableDate(value) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format('YY/MM/DD HH:mm:ss.SSS'); //0~23hr format
    },

    /*
    status(value) {
      if(value=="t0")
        return "尚未處理"
      else if(value=="t1")
        return "已開單"
      else if(value=="t2")
        return "未違規"
      else if(value=="t3")
        return "無法開單"
    },
    */
    getPara: function getPara() {
      var _this4 = this;

      return this.instance.get('/api/fixed-link-code/', {
        params: {
          fixed_link_code_id: this.$store.state.user.user.department.fixed_link_code
        }
      }).then(function (res) {
        _this4.paras = res.data;
      });
    }
  },
  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    },
    user: function user() {
      return this.$store.state.user;
    }
  }
  // computed: mapState({
  //   system: state => state.system,
  // }),
});

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetable_2_src_components_Vuetable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetable_2_src_components_Vuetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuetable_2_src_components_Vuetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vuex_functions_readCookie__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TicketCrossLineCheckDetail__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TicketCrossLineCheckDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__TicketCrossLineCheckDetail__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].component('ticket-cross-line-check-detail', __WEBPACK_IMPORTED_MODULE_11__TicketCrossLineCheckDetail___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TicketCrossLineList',
  data: function data() {
    return {
      tableDataLen: undefined,
      tmpId: '',
      startDate: undefined,
      endDate: undefined,
      loadingData: false,
      paras: [],
      boostrapCss: {
        tableClass: 'table table-striped table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: ''
          }
        }
      },
      httpOptions: {
        headers: {
          Authorization: 'Token ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__vuex_functions_readCookie__["a" /* default */])('Token')
        }
      },
      server: __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */],
      fields: [{
        name: 'xactno',
        sortField: 'xactno',
        title: '流水號'
      }, {
        name: 'plt_no.plt_no',
        //sortField: 'plt_no.plt_no',
        title: '車牌號碼'
      }, {
        name: 'car_tp.car_tp',
        sortField: 'car_tp__car_tp',
        title: '車別代碼'
      }, {
        name: 'vli_dateTime_in',
        sortField: 'vli_dateTime_in',
        title: '違規時間',
        callback: this.readableDate
      }, {
        name: 'fixed_link_code.fixed_link_code',
        title: '固定桿代碼'
      }, {
        name: 'rule_code.rule_code',
        title: '條款代碼'
      },
      /*{
        name: 'status',
        title: '開單狀態',
        sortField: 'status',
        callback: this.status,
      },*/
      {
        name: 'user',
        sortField: 'user',
        title: '認證人員'
        //callback: this.status,
      }, {
        name: 'reviewer',
        sortField: 'reviewer',
        title: '開單人員'
      }],
      sortOrder: [{
        sortField: 'car_tp__car_tp',
        direction: 'asc'
      }],
      queryString: '',
      moreParams: {
        fixed_link_code_id: this.$store.state.user.user.department.fixed_link_code,
        status: 't1',
        user: this.$store.state.user.user.username,
        start_date: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'),
        end_date: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'),
        department: this.$store.state.user.user.department.name,
        checked: true
      }
    };
  },

  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_7_vuetable_2_src_components_Vuetable___default.a,
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_10__common_Loader___default.a
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getPara();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    startDate: function startDate(val) {
      if (val > this.endDate && this.endDate !== '') {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '開始時間不可晚於結束時間'
        });
        this.startDate = this.endDate;
      }
    },
    endDate: function endDate(val) {
      if (val < this.startDate && this.startDate !== '') {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '結束時間不可早於開始時間'
        });
        this.endDate = this.startDate;
      }
    }
  },
  methods: {
    onLoading: function onLoading() {
      this.loadingData = true;
      console.log('loading... show your spinner here');
    },
    onLoaded: function onLoaded() {
      this.loadingData = false;
      console.log('loaded! .. hide your spinner here');
      this.tableDataLen = this.$refs.vuetable.tableData.length;
      console.log('datalen:', this.tableDataLen);
      if (this.tableDataLen > 0) {
        console.log('id:', this.$refs.vuetable.tableData[0].id);
        this.onCellClicked(this.$refs.vuetable.tableData[0]);
      }
    },
    onCellClicked: function onCellClicked(data, field, event) {
      var _this2 = this;

      console.log('cellclicked');
      console.log('tmpId:', this.tmpId);
      console.log('nowId:', data.id);
      if (this.tmpId == '') this.tmpId = data.id;else if (this.tmpId !== '' && this.tmpId != data.id) {
        this.$refs.vuetable.toggleDetailRow(this.tmpId);
        this.tmpId = data.id;
      } else if (this.tmpId == data.id) this.tmpId = '';
      //this.$refs.vuetable.toggleDetailRow(data.id);
      setTimeout(function () {
        _this2.$refs.vuetable.toggleDetailRow(data.id);
      }, 50);
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet: function onFilterSet() {
      var _this3 = this;

      if (this.startDate == undefined || this.endDate == undefined) {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '請輸入查詢區間'
        });
        return;
      }
      /*
         if(this.queryString=="尚未處理")
             this.queryString="t0"
           else if(this.queryString=="已開單")
             this.queryString="t1"
           else if(this.queryString=="未違規")
             this.queryString="t2"  
           else if(this.queryString=="無法開單")
             this.queryString="t3"
         */
      this.moreParams = {
        search: this.queryString,
        fixed_link_code_id: this.$store.state.user.user.department.fixed_link_code,
        status: 't1',
        user: this.$store.state.user.user.username,
        start_date: this.startDate,
        end_date: this.endDate,
        department: this.$store.state.user.user.department.name,
        checked: true
      };
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].nextTick(function () {
        return _this3.$refs.vuetable.refresh();
      });
    },
    getSortParam: function getSortParam(sortOrder) {
      return sortOrder.map(function (sort) {
        return (sort.direction === 'desc' ? '-' : '') + sort.sortField;
      }).join(',');
    },
    readableDate: function readableDate(value) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format('YY/MM/DD HH:mm:ss.SSS'); //0~23hr format
    },

    /*
       status(value) {
         if(value=="t0")
           return "尚未處理"
         else if(value=="t1")
           return "已開單"
         else if(value=="t2")
           return "未違規"
         else if(value=="t3")
           return "無法開單"
       },
    */
    getPara: function getPara() {
      var _this4 = this;

      return this.instance.get('/api/fixed-link-code/', {
        params: {
          fixed_link_code_id: this.$store.state.user.user.department.fixed_link_code
        }
      }).then(function (res) {
        _this4.paras = res.data;
      });
    }
  },
  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    },
    user: function user() {
      return this.$store.state.user;
    }
  }
  // computed: mapState({
  //   system: state => state.system,
  // }),
});

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetable_2_src_components_Vuetable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetable_2_src_components_Vuetable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuetable_2_src_components_Vuetable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vuex_functions_readCookie__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TicketShoulderCheckDetail__ = __webpack_require__(1267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TicketShoulderCheckDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__TicketShoulderCheckDetail__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].component('ticket-shoulder-check-detail', __WEBPACK_IMPORTED_MODULE_11__TicketShoulderCheckDetail___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TicketShoulderList',
  data: function data() {
    return {
      tableDataLen: undefined,
      tmpId: '',
      startDate: undefined,
      endDate: undefined,
      loadingData: false,
      paras: [],
      boostrapCss: {
        tableClass: 'table table-striped table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: ''
          }
        }
      },
      httpOptions: {
        headers: {
          Authorization: 'Token ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__vuex_functions_readCookie__["a" /* default */])('Token')
        }
      },
      server: __WEBPACK_IMPORTED_MODULE_9__config__["a" /* default */],
      fields: [{
        name: 'xactno',
        sortField: 'xactno',
        title: '流水號'
      }, {
        name: 'plt_no.plt_no',
        //sortField: 'plt_no.plt_no',
        title: '車牌號碼'
      }, {
        name: 'car_tp.car_tp',
        sortField: 'car_tp__car_tp',
        title: '車別代碼'
      }, {
        name: 'vli_dateTime_in',
        sortField: 'vli_dateTime_in',
        title: '違規時間',
        callback: this.readableDate
      }, {
        name: 'fixed_link_code.fixed_link_code',
        title: '固定桿代碼'
      }, {
        name: 'rule_code.rule_code',
        title: '條款代碼'
      },
      /*{
        name: 'status',
        title: '開單狀態',
        sortField: 'status',
        callback: this.status,
      },*/
      {
        name: 'user',
        sortField: 'user',
        title: '認證人員'
        //callback: this.status,
      }, {
        name: 'reviewer',
        sortField: 'reviewer',
        title: '開單人員'
      }],
      sortOrder: [{
        sortField: 'car_tp__car_tp',
        direction: 'asc'
      }],
      queryString: '',
      moreParams: {
        fixed_link_code_id: this.$store.state.user.user.department.fixed_link_code,
        status: 't1',
        user: this.$store.state.user.user.username,
        start_date: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'),
        end_date: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'),
        department: this.$store.state.user.user.department.name,
        checked: true
      }
    };
  },

  components: {
    Vuetable: __WEBPACK_IMPORTED_MODULE_7_vuetable_2_src_components_Vuetable___default.a,
    VuetablePagination: __WEBPACK_IMPORTED_MODULE_5_vuetable_2_src_components_VuetablePagination___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_10__common_Loader___default.a
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getPara();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    startDate: function startDate(val) {
      if (val > this.endDate && this.endDate !== '') {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '開始時間不可晚於結束時間'
        });
        this.startDate = this.endDate;
      }
    },
    endDate: function endDate(val) {
      if (val < this.startDate && this.startDate !== '') {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '結束時間不可早於開始時間'
        });
        this.endDate = this.startDate;
      }
    }
  },
  methods: {
    onLoading: function onLoading() {
      this.loadingData = true;
      console.log('loading... show your spinner here');
    },
    onLoaded: function onLoaded() {
      this.loadingData = false;
      console.log('loaded! .. hide your spinner here');
      this.tableDataLen = this.$refs.vuetable.tableData.length;
      console.log('datalen:', this.tableDataLen);
      if (this.tableDataLen > 0) {
        console.log('id:', this.$refs.vuetable.tableData[0].id);
        this.onCellClicked(this.$refs.vuetable.tableData[0]);
      }
    },
    onCellClicked: function onCellClicked(data, field, event) {
      var _this2 = this;

      console.log('cellclicked');
      console.log('tmpId:', this.tmpId);
      console.log('nowId:', data.id);
      if (this.tmpId == '') this.tmpId = data.id;else if (this.tmpId !== '' && this.tmpId != data.id) {
        this.$refs.vuetable.toggleDetailRow(this.tmpId);
        this.tmpId = data.id;
      } else if (this.tmpId == data.id) this.tmpId = '';
      //this.$refs.vuetable.toggleDetailRow(data.id);
      setTimeout(function () {
        _this2.$refs.vuetable.toggleDetailRow(data.id);
      }, 50);
    },
    onPaginationData: function onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage: function onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet: function onFilterSet() {
      var _this3 = this;

      if (this.startDate == undefined || this.endDate == undefined) {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '請輸入查詢區間'
        });
        return;
      }
      /*
         if(this.queryString=="尚未處理")
             this.queryString="t0"
           else if(this.queryString=="已開單")
             this.queryString="t1"
           else if(this.queryString=="未違規")
             this.queryString="t2"  
           else if(this.queryString=="無法開單")
             this.queryString="t3"
         */
      this.moreParams = {
        search: this.queryString,
        fixed_link_code_id: this.$store.state.user.user.department.fixed_link_code,
        status: 't1',
        user: this.$store.state.user.user.username,
        start_date: this.startDate,
        end_date: this.endDate,
        department: this.$store.state.user.user.department.name,
        checked: true
      };
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].nextTick(function () {
        return _this3.$refs.vuetable.refresh();
      });
    },
    getSortParam: function getSortParam(sortOrder) {
      return sortOrder.map(function (sort) {
        return (sort.direction === 'desc' ? '-' : '') + sort.sortField;
      }).join(',');
    },
    readableDate: function readableDate(value) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format('YY/MM/DD HH:mm:ss.SSS'); //0~23hr format
    },

    /*
       status(value) {
         if(value=="t0")
           return "尚未處理"
         else if(value=="t1")
           return "已開單"
         else if(value=="t2")
           return "未違規"
         else if(value=="t3")
           return "無法開單"
       },
    */
    getPara: function getPara() {
      var _this4 = this;

      return this.instance.get('/api/fixed-link-code/', {
        params: {
          fixed_link_code_id: this.$store.state.user.user.department.fixed_link_code
        }
      }).then(function (res) {
        _this4.paras = res.data;
      });
    }
  },
  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    },
    user: function user() {
      return this.$store.state.user;
    }
  }
  // computed: mapState({
  //   system: state => state.system,
  // }),
});

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(8);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TicketCheckDetail',
  data: function data() {
    return {
      status: null,
      sourceOfPicture: '',
      img_string: '顯示照片',
      //carName: '',
      randomNum: '',
      apiUrl: undefined
    };
  },

  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  components: {},
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var img;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.apiUrl = '/api/interval-speed-data/';
              img = document.getElementById('bigpic');

              _this.randomNum = Math.random();
              _this.sourceOfPicture = '/media/interval/done/' + _this.rowData.fixed_link_code.fixed_link_code + '/' + _this.rowData.img_filename + '?t=' + _this.randomNum;
              _this.img_string = "關閉照片";
              img.src = _this.sourceOfPicture;
              img.style.display = "block";
              img.class = "car-image";

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  methods: {
    returnModify: function returnModify() {
      var _this2 = this;

      this.instance.patch('' + this.apiUrl + this.rowData.id + '/', {
        xactno: this.rowData.xactno,
        status: "t0",
        checked: false
      }).then(function () {
        _this2.$parent.refresh();
        _this2.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功, 已退回'
        });
        _this2.$parent.refresh();
      }).catch(function (err) {
        _this2.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: err.response.data
        });
      });
    },
    showImg: function showImg() {
      var img = document.getElementById('bigpic');
      this.randomNum = Math.random();
      this.sourceOfPicture = '/media/interval/done/' + this.rowData.fixed_link_code.fixed_link_code + '/' + this.rowData.img_filename + '?t=' + this.randomNum;
      console.log(this.sourceOfPicture);
      if (img.style.display == "none") {
        this.img_string = "關閉照片";
        img.src = this.sourceOfPicture;
        img.style.display = "block";
        img.class = "car-image";
      } else {
        this.img_string = "顯示照片";
        img.style.display = "none";
      }
    }
  }
});

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(8);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TicketCrossLineCheckDetail',
  data: function data() {
    return {
      status: null,
      sourceOfPicture: '',
      img_string: '顯示照片',
      //carName: '',
      randomNum: '',
      apiUrl: undefined
    };
  },

  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  components: {},
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var img;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.apiUrl = '/api/interval-speed-data/';
              img = document.getElementById('bigpic');

              _this.randomNum = Math.random();
              _this.sourceOfPicture = '/media/crossline/done/' + _this.rowData.fixed_link_code.fixed_link_code + '/' + _this.rowData.img_filename + '?t=' + _this.randomNum;
              _this.img_string = "關閉照片";
              img.src = _this.sourceOfPicture;
              img.style.display = "block";
              img.class = "car-image";

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  methods: {
    returnModify: function returnModify() {
      var _this2 = this;

      this.instance.patch('' + this.apiUrl + this.rowData.id + '/', {
        xactno: this.rowData.xactno,
        status: "t0",
        checked: false
      }).then(function () {
        _this2.$parent.refresh();
        _this2.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功, 已退回'
        });
        _this2.$parent.refresh();
      }).catch(function (err) {
        _this2.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: err.response.data
        });
      });
    },
    showImg: function showImg() {
      var img = document.getElementById('bigpic');
      this.randomNum = Math.random();
      this.sourceOfPicture = '/media/crossline/done/' + this.rowData.fixed_link_code.fixed_link_code + '/' + this.rowData.img_filename + '?t=' + this.randomNum;
      console.log(this.sourceOfPicture);
      if (img.style.display == "none") {
        this.img_string = "關閉照片";
        img.src = this.sourceOfPicture;
        img.style.display = "block";
        img.class = "car-image";
      } else {
        this.img_string = "顯示照片";
        img.style.display = "none";
      }
    }
  }
});

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(10);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//import 'video.js/dist/video-js.css'
//import VueVideoPlayer from 'vue-video-player'


//Vue.use(VueVideoPlayer)

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TicketShoulderCheckDetail',
  data: function data() {
    return {
      status: null,
      sourceOfPicture: '',
      img_string: '顯示照片',
      //carName: '',
      randomNum: '',
      apiUrl: undefined
      /*
      playerOptions: {
          // videojs options
          muted: true,
          language: 'en',
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          autoplay: true,
          width: 800,
          sources: [{
            type: "video/mp4",
            src: "",
          }],
      },
      playVideoFlag: false,
      playVideoMsg: "撥放影片",
      sourceOfVideo: '',
      */
    };
  },

  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  components: {},
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var img;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.apiUrl = '/api/interval-speed-data/';
              img = document.getElementById('bigpic');

              _this.randomNum = Math.random();
              _this.sourceOfPicture = '/media/shoulder/done/' + _this.rowData.fixed_link_code.fixed_link_code + '/' + _this.rowData.img_filename + '?t=' + _this.randomNum;
              _this.img_string = "關閉照片";
              img.src = _this.sourceOfPicture;
              img.style.display = "block";
              img.class = "car-image";
              //////
              /*
              var newFilename = this.rowData.img_filename.replace('jpg', 'mp4'); 
              console.log('newFilename:', newFilename);
              this.sourceOfVideo = `/media/shoulder/done/${this.rowData.fixed_link_code.fixed_link_code}/${newFilename}`;
              console.log('sourceOfVideo:',this.sourceOfVideo);
              this.playerOptions.sources[0].src=this.sourceOfVideo;
              */
              ////////

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  methods: {
    returnModify: function returnModify() {
      var _this2 = this;

      this.instance.patch('' + this.apiUrl + this.rowData.id + '/', {
        xactno: this.rowData.xactno,
        status: "t0",
        checked: false
      }).then(function () {
        _this2.$parent.refresh();
        _this2.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功, 已退回'
        });
        _this2.$parent.refresh();
      }).catch(function (err) {
        _this2.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: err.response.data
        });
      });
    },

    /*
    playVideo() {  
      if(this.playVideoMsg=="撥放影片") {
        console.log('1');
        var img = document.getElementById('bigpic')
        this.img_string="顯示照片";
        img.style.display = "none";  
        this.playVideoMsg="結束撥放";
        this.playVideoFlag = true;      
      }
      else {
        console.log('2'); 
        this.playVideoMsg="撥放影片";
        this.playVideoFlag = false;          
      }
    },
    // listen event
    onPlayerPlay(player) {
      // console.log('player play!', player)
    },
    onPlayerPause(player) {
      // console.log('player pause!', player)
    },
    // ...player event
     // or listen state event
    playerStateChanged(playerCurrentState) {
      // console.log('player current update state', playerCurrentState)
    },
     // player is ready
    playerReadied(player) {
      console.log('the player is readied', player)
      // you can use it to do something...
      // player.[methods]
    },
    */
    showImg: function showImg() {
      var img = document.getElementById('bigpic');
      this.randomNum = Math.random();
      this.sourceOfPicture = '/media/shoulder/done/' + this.rowData.fixed_link_code.fixed_link_code + '/' + this.rowData.img_filename + '?t=' + this.randomNum;
      console.log(this.sourceOfPicture);
      if (img.style.display == "none") {
        this.img_string = "關閉照片";
        img.src = this.sourceOfPicture;
        img.style.display = "block";
        img.class = "car-image";
      } else {
        this.img_string = "顯示照片";
        img.style.display = "none";
      }
    }
  }
});

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_Navbar__ = __webpack_require__(1343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_Navbar__);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Autoix',
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_0__common_Navbar___default.a
  }
});

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_PositionSelection__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_PositionSelection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__flowComp_PositionSelection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flowComp_DrugInDeviceList__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flowComp_DrugInDeviceList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__flowComp_DrugInDeviceList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flowComp_ProgressBar__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flowComp_ProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__flowComp_ProgressBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CheckAmountFlow_MultiFlow__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CheckAmountFlow_MultiFlow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__CheckAmountFlow_MultiFlow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_BottomButtons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_BottomButtons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__common_BottomButtons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__flowComp_MedicineGroupSelect__ = __webpack_require__(1351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__flowComp_MedicineGroupSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__flowComp_MedicineGroupSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Confirm__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Confirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__common_Confirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SplitLayout__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SplitLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__SplitLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ComponentBase_AppBase__ = __webpack_require__(33);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CheckAmount',
  extends: __WEBPACK_IMPORTED_MODULE_12__ComponentBase_AppBase__["a" /* default */],
  components: {
    SelectBox: __WEBPACK_IMPORTED_MODULE_3__flowComp_PositionSelection___default.a,
    DrugList: __WEBPACK_IMPORTED_MODULE_4__flowComp_DrugInDeviceList___default.a,
    ProgressBar: __WEBPACK_IMPORTED_MODULE_5__flowComp_ProgressBar___default.a,
    MultiFlow: __WEBPACK_IMPORTED_MODULE_6__CheckAmountFlow_MultiFlow___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_7__common_Loader___default.a,
    BottomButtons: __WEBPACK_IMPORTED_MODULE_8__common_BottomButtons___default.a,
    MedicineGroupSelect: __WEBPACK_IMPORTED_MODULE_9__flowComp_MedicineGroupSelect___default.a,
    ConfirmModal: __WEBPACK_IMPORTED_MODULE_10__common_Confirm___default.a,
    SplitLayout: __WEBPACK_IMPORTED_MODULE_11__SplitLayout___default.a
  },
  data: function data() {
    return {
      resumeDrugInDeviceList: [],
      showInterruptModal: false,
      interruptEvent: undefined
    };
  },
  created: function created() {
    this.stage = 'selectDrug';
    this.progress = this.setupProgress();
    this.multiProgress = this.setupMultiProgress();
    this.confirmProgress = this.setupConfirmProgress();
    this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
  },
  mounted: function mounted() {
    this.checkInterruptEvent();
  },

  computed: {
    filterDrugInDeviceList: function filterDrugInDeviceList() {
      return this.$store.state.drugInDevice.filterDrugInDeviceList;
    },
    modalStatus: function modalStatus() {
      return this.$store.state.modalStatus;
    },
    sortedSelectedDrugInDevice: function sortedSelectedDrugInDevice() {
      return this.$store.state.drugInDevice.sortedSelectedDrugInDevice;
    },
    currentDrugInDevice: function currentDrugInDevice() {
      return this.$store.getters.currentDrugInDevice;
    }
  },
  methods: {
    setupProgress: function setupProgress() {
      var prog = [];
      prog.push({ en: 'selectDrug', zh: '選擇藥物' });
      if (this.$store.state.user.user.task_privilege.inventory_drug === false) {
        prog.push({ en: 'rxCheck', zh: '覆核動作' });
      }
      prog.push({ en: 'action', zh: '更新數量' });
      return prog;
    },
    setupMultiProgress: function setupMultiProgress() {
      var prog = [];
      prog.push('confirm');
      prog.push('finish');
      return prog;
    },
    setupConfirmProgress: function setupConfirmProgress() {
      var prog = [];
      if (this.$store.state.user.user.task_privilege.inventory_drug === false) {
        prog.push('rxCheck');
      }
      prog.push('action');
      prog.push('next');
      return prog;
    },
    getGroupAndSelect: function getGroupAndSelect(groupId) {
      this.$store.dispatch('unSelectAllDrugStorageAndDevices');
      this.$store.dispatch('selectDrugStorageByGroupId', groupId);
    },
    selectAllRestrainedMed: function selectAllRestrainedMed() {
      this.$store.dispatch('unSelectAllDrugStorageAndDevices');
      this.$store.dispatch('selectAllRestrainedDrugStorage');
    },
    selectAllNormalMed: function selectAllNormalMed() {
      this.$store.dispatch('unSelectAllDrugStorageAndDevices');
      this.$store.dispatch('selectAllNormalDrugStorage');
    },
    checkInterruptEvent: function checkInterruptEvent() {
      var _this = this;

      this.instance.get('/api/event/', {
        params: {
          event: 'SUSPENDED_INVENTORY',
          per_page: 1
        }
      }).then(function (res) {
        if (res.data.results.length > 0) {
          var lastEvent = res.data.results[0];
          if (lastEvent.checked === false) {
            _this.resumeDrugInDeviceList = lastEvent.number2.split('-');
            _this.interruptEvent = lastEvent;
            _this.showInterruptModal = true;
          }
        }
      });
    },
    goBackInterrupt: function goBackInterrupt(response) {
      var _this2 = this;

      if (response) {
        this.resumeDrugInDeviceList.forEach(function (id) {
          _this2.$store.commit('SELECT_DRUG_IN_DEVICES_FROM_SELECTED', id);
        });
        this.startFlow();
      }
      this.instance.patch('/api/event/' + this.interruptEvent.id + '/', {
        checked: true
      });
      this.showInterruptModal = false;
    },
    remainDrugInDevices: function remainDrugInDevices() {
      var sortedDrugDeviceIds = [];
      this.sortedSelectedDrugInDevice.forEach(function (item) {
        sortedDrugDeviceIds.push(item.id);
      });
      var currentIndex = sortedDrugDeviceIds.indexOf(this.currentDrugInDevice.id);
      if (currentIndex !== -1) {
        return sortedDrugDeviceIds.slice(currentIndex, sortedDrugDeviceIds.length).join('-');
      }
      return undefined;
    },
    cancel: function cancel() {
      this.$router.push({ name: 'Main' });
      if (this.sortedSelectedDrugInDevice.length > 0 && this.stage !== 'selectDrug') {
        this.$store.dispatch('recordAction', { eventType: 'SUSPENDED_INVENTORY', number2: this.remainDrugInDevices() });
      }
      this.$store.dispatch('recordAction', { eventType: 'CANCEL_INVENTORY' });
    },
    checkAll: function checkAll() {
      this.$store.dispatch('selectAllDrugStorageAndDevices');
    },
    unCheckAll: function unCheckAll() {
      this.$store.dispatch('unSelectAllDrugStorageAndDevices');
    },
    startFlow: function startFlow() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this3.$store.state.drugInDevice.selectedDrugInDevice).length === 0)) {
                  _context.next = 4;
                  break;
                }

                _this3.$store.commit('SET_MESSAGE', { type: 'error', context: '請至少選擇一項儲存藥物' });
                _context.next = 7;
                break;

              case 4:
                _context.next = 6;
                return _this3.$store.dispatch('fromFirstDrugInDevice');

              case 6:
                _this3.stage = 'setFlowData';

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    getAllConfirmData: function getAllConfirmData() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.$store.dispatch('resetAll');
                _context2.next = 3;
                return _this4.$store.dispatch('getDrugInDevices');

              case 3:
                _context2.next = 5;
                return _this4.$store.dispatch('getSystemInfo');

              case 5:
                _this4.stage = 'selectDrug';
                _this4.$store.commit('SET_CURRENT_STEP', 'selectDrug');

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    showLowAmountModal: function showLowAmountModal() {
      this.$store.commit('SHOW_MODAL', { modalName: 'lowAmount', status: true });
    },
    selectMedByGroup: function selectMedByGroup() {
      this.$store.commit('SHOW_MODAL', { modalName: 'medGroupSelect', status: true });
    }
  },
  watch: {
    stage: function stage(val) {
      if (val === 'selectDrug') {
        this.$store.commit('SHOW_LOGOUT', true);
      } else {
        this.$store.commit('SHOW_LOGOUT', false);
      }
    }
  }
});

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ComponentBase_ConfirmFlowBase__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_Action__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_Action___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__flowComp_Action__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flowComp_ResetLowAmountLimit__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flowComp_ResetLowAmountLimit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__flowComp_ResetLowAmountLimit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flowComp_RxCheckBarcode__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flowComp_RxCheckBarcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__flowComp_RxCheckBarcode__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ConfirmFlow',
  extends: __WEBPACK_IMPORTED_MODULE_2__ComponentBase_ConfirmFlowBase__["a" /* default */],
  data: function data() {
    return {
      storageAmount: 0,
      packCount: 0,
      reviewer: undefined
    };
  },

  components: {
    Action: __WEBPACK_IMPORTED_MODULE_3__flowComp_Action___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_4__common_Loader___default.a,
    ResetLowAmonutModal: __WEBPACK_IMPORTED_MODULE_5__flowComp_ResetLowAmountLimit___default.a,
    RxCheckBarcode: __WEBPACK_IMPORTED_MODULE_6__flowComp_RxCheckBarcode___default.a
  },
  destroyed: function destroyed() {
    this.closeModal();
  },

  methods: {
    confirmRx: function confirmRx(reviewer) {
      this.reviewer = reviewer.id;
      this.nextProgress();
    },
    closeModal: function closeModal() {
      this.$store.commit('SHOW_MODAL', { modalName: 'lowAmount', status: false });
    },
    getActionData: function getActionData(data) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.storageAmount = parseInt(data.num, 10);
                _this.packCount = parseInt(data.packCount, 10);
                _this.nextProgress();
                // close the modal before leaving
                _this.closeModal();
                _context.next = 6;
                return _this.emitData();

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    emitData: function emitData() {
      var _this2 = this;

      var eventType = void 0;
      if (this.storageAmount === this.currentDrugInDevice.stock) {
        eventType = 'INVENTORY';
      } else {
        eventType = 'STORAGE_ERROR';
      }

      var data = {
        id: this.currentDrugInDevice.id,
        device: this.currentDrugInDevice.device.id,
        stock: this.storageAmount, // only update here.
        max_stock: this.currentDrugInDevice.max_stock,
        expired_date: this.currentDrugInDevice.expired_date,
        patch_number: this.currentDrugInDevice.patch_number,
        medication: this.currentDrugInDevice.medication.id,
        pack_count: this.packCount,
        number1: this.storageAmount - this.currentDrugInDevice.stock, // delta
        type: eventType,
        review_employee: this.reviewer
      };

      return this.instance.put('/api/drug-storage/' + data.id + '/', data).then(function (res) {
        setTimeout(function () {
          _this2.$emit('confirmationFinish');
          _this2.resetProgress();
        });
      });
    }
  },
  mounted: function mounted() {},

  computed: {
    selectedDrugLowAmountLimitData: function selectedDrugLowAmountLimitData() {
      return this.$store.getters.selectedDrugLowAmountLimitData;
    },
    modalStatus: function modalStatus() {
      return this.$store.getters.modalStatus;
    }
  }
});

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ComponentBase_MultiFlowBase__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_DrugInfo__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_DrugInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__flowComp_DrugInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConfirmFlow__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConfirmFlow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ConfirmFlow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SplitLayout__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SplitLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__SplitLayout__);


//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'multiFlow',
  extends: __WEBPACK_IMPORTED_MODULE_2__ComponentBase_MultiFlowBase__["a" /* default */],
  data: function data() {
    return {};
  },

  components: {
    DrugInfo: __WEBPACK_IMPORTED_MODULE_3__flowComp_DrugInfo___default.a,
    ConfirmFlow: __WEBPACK_IMPORTED_MODULE_4__ConfirmFlow___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_5__common_Loader___default.a,
    SplitLayout: __WEBPACK_IMPORTED_MODULE_6__SplitLayout___default.a
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log('create');
              _context.next = 3;
              return _this.$store.dispatch('fromFirstDrugInDevice');

            case 3:
              console.log('created');

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    getConfirmData: function getConfirmData() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.nextProgress();

                if (!(_this2.nextDrugInDevice !== null)) {
                  _context2.next = 8;
                  break;
                }

                // check whether next index is over the keys' array length
                console.log('get confirm data');
                _context2.next = 5;
                return _this2.$store.dispatch('toNextDrugInDevice');

              case 5:
                _this2.resetProgress();
                _context2.next = 10;
                break;

              case 8:
                console.log('leave multiflow');
                _this2.$emit('setAllConfirmData');

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_ProgressBar__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_ProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__flowComp_ProgressBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flowComp_ScanBarcode__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flowComp_ScanBarcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__flowComp_ScanBarcode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flowComp_PositionSelection__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flowComp_PositionSelection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__flowComp_PositionSelection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flowComp_DrugSelection__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flowComp_DrugSelection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__flowComp_DrugSelection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__flowComp_UpDownPanel__ = __webpack_require__(1358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__flowComp_UpDownPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__flowComp_UpDownPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CreateDrugFlow_MultiFlow__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CreateDrugFlow_MultiFlow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__CreateDrugFlow_MultiFlow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_BottomButtons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_BottomButtons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__common_BottomButtons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__flowComp_DrugInfo__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__flowComp_DrugInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__flowComp_DrugInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SplitLayout__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SplitLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__SplitLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ComponentBase_AppBase__ = __webpack_require__(33);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AddNewDrug',
  extends: __WEBPACK_IMPORTED_MODULE_13__ComponentBase_AppBase__["a" /* default */],
  data: function data() {
    return {
      stage: 'scanBarcode'
    };
  },

  components: {
    ProgressBar: __WEBPACK_IMPORTED_MODULE_3__flowComp_ProgressBar___default.a,
    SelectBox: __WEBPACK_IMPORTED_MODULE_5__flowComp_PositionSelection___default.a,
    SelectDrug: __WEBPACK_IMPORTED_MODULE_6__flowComp_DrugSelection___default.a,
    MultiFlow: __WEBPACK_IMPORTED_MODULE_8__CreateDrugFlow_MultiFlow___default.a,
    ScanBarcode: __WEBPACK_IMPORTED_MODULE_4__flowComp_ScanBarcode___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_10__common_Loader___default.a,
    DrugInfo: __WEBPACK_IMPORTED_MODULE_11__flowComp_DrugInfo___default.a,
    BottomButtons: __WEBPACK_IMPORTED_MODULE_9__common_BottomButtons___default.a,
    SplitLayout: __WEBPACK_IMPORTED_MODULE_12__SplitLayout___default.a
  },
  created: function created() {
    this.stage = 'scanBarcode';
    this.progress = [{ en: 'selectDrug', zh: '選擇藥物' }, { en: 'selectPosition', zh: '選擇位置' }, { en: 'setMaxStock', zh: '最大庫存' }, { en: 'setExpiredDate', zh: '有效期限' }, { en: 'action', zh: '儲存藥物' }, { en: 'setMinStorage', zh: '安全庫存' }];
    this.multiProgress = ['confirm', 'setMinStorage'];
    this.confirmProgress = ['setMaxStock', 'setExpiredDate', 'action'];
    this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
  },

  computed: {
    selectedDevices: function selectedDevices() {
      return this.$store.state.device.selectedDevices;
    },
    selectDrug: function selectDrug() {
      return this.$store.state.drug.selectedDrug;
    }
  },
  methods: {
    confrimPosition: function confrimPosition() {
      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.selectedDevices).length !== 0) {
        this.stage = 'setFlowData';
      } else {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '請至少選擇一個藥盒'
        });
      }
    },
    getAllConfirmData: function getAllConfirmData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$store.dispatch('resetAll');
                _this.$store.dispatch('getSystemInfo');
                _this.$store.dispatch('getDrugInDevices');
                _this.stage = 'scanBarcode';
                _this.$store.commit('SET_CURRENT_STEP', 'selectDrug');

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getBarcode: function getBarcode(data) {
      var _this2 = this;

      this.instance.get('/api/medication/?package_code2=' + data).then(function (res) {
        if (res.data.results.length === 0) {
          _this2.instance.get('/api/medication/?package_code=' + data).then(function (res) {
            if (res.data.results.length === 0) {
              _this2.$store.commit('SET_MESSAGE', {
                type: 'warn',
                context: '查無此藥'
              });
            } else {
              _this2.$store.dispatch('setDrug', res.data.results[0].id);
              _this2.stage = 'selectPosition';
            }
          });
        } else {
          _this2.$store.dispatch('setDrug', res.data.results[0].id);
          _this2.stage = 'selectPosition';
        }
      });
    },
    cancel: function cancel() {
      this.$store.dispatch('recordAction', { eventType: 'CANCEL_LOAD' });
      this.$router.push({ name: 'Main' });
    }
  },
  watch: {
    selectDrug: function selectDrug(val) {
      if (val) this.stage = 'selectPosition';
    },
    stage: function stage(val) {
      if (val === 'scanBarcode') {
        this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
      } else {
        this.$store.commit('SET_CURRENT_STEP', val);
      }
    }
  }
});

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flowComp_MaxStockSet__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flowComp_MaxStockSet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__flowComp_MaxStockSet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flowComp_DateSelection__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flowComp_DateSelection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__flowComp_DateSelection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flowComp_NumberSet__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flowComp_NumberSet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__flowComp_NumberSet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_Action__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_Action___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__flowComp_Action__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flowComp_CurrentLocationPanel__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flowComp_CurrentLocationPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__flowComp_CurrentLocationPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ComponentBase_ConfirmFlowBase__ = __webpack_require__(37);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
  This component collect the data from the flowComp and emit to Multiflow compoment.
*/








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'confirmFlow',
  extends: __WEBPACK_IMPORTED_MODULE_6__ComponentBase_ConfirmFlowBase__["a" /* default */],
  data: function data() {
    return {
      maxAmount: 0,
      patchNumber: '',
      expirationDate: '',
      storageAmount: 0,
      actionData: {}
    };
  },

  components: {
    confirmMaxStock: __WEBPACK_IMPORTED_MODULE_0__flowComp_MaxStockSet___default.a,
    confirmExpirationDate: __WEBPACK_IMPORTED_MODULE_1__flowComp_DateSelection___default.a,
    confirmStorage: __WEBPACK_IMPORTED_MODULE_2__flowComp_NumberSet___default.a,
    Action: __WEBPACK_IMPORTED_MODULE_3__flowComp_Action___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_4__common_Loader___default.a,
    CurrentLocationPanel: __WEBPACK_IMPORTED_MODULE_5__flowComp_CurrentLocationPanel___default.a
  },
  methods: {
    getMaxAmountData: function getMaxAmountData(amountData) {
      this.maxAmount = amountData.amount;
      this.patchNumber = amountData.patchNumber;
      this.nextProgress();
      this.$store.commit('SET_CURRENT_STEP', 'setExpiredDate');
    },
    getExpirationDate: function getExpirationDate(date) {
      this.expirationDate = date;
      this.nextProgress();
    },
    getActionData: function getActionData(data) {
      var _this = this;

      this.actionData = data;
      this.nextProgress();
      var postData = {
        device: this.currentDevice.id,
        medication: this.selectedDrug.id,
        max_stock: this.maxAmount,
        patch_number: this.patchNumber,
        expired_date: this.expirationDate,
        stock: this.actionData.num,
        pack_count: this.actionData.packCount,
        number1: this.actionData.num,
        type: 'LOAD' // event type: for event recording
      };

      this.instance.post('/api/drug-storage/', postData).then(function () {
        _this.$emit('confirmationFinish');
        _this.resetProgress();
      });
    }
  },
  computed: {
    selectedDrug: function selectedDrug() {
      return this.$store.state.drug.selectedDrug;
    }
  }
});

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ComponentBase_MultiFlowBase__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConfirmFlow__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConfirmFlow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ConfirmFlow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flowComp_DrugInfo__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flowComp_DrugInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__flowComp_DrugInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flowComp_NumberSet__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flowComp_NumberSet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__flowComp_NumberSet__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreateDrugMultiFlow',
  extends: __WEBPACK_IMPORTED_MODULE_2__ComponentBase_MultiFlowBase__["a" /* default */],
  components: {
    confirmFlow: __WEBPACK_IMPORTED_MODULE_3__ConfirmFlow___default.a,
    DrugInfo: __WEBPACK_IMPORTED_MODULE_4__flowComp_DrugInfo___default.a,
    setMinStorage: __WEBPACK_IMPORTED_MODULE_5__flowComp_NumberSet___default.a
  },
  data: function data() {
    return {
      minStorage: 0,
      currentDrugInSystem: {}
    };
  },

  computed: {
    selectedDevicesID: function selectedDevicesID() {
      return this.$store.state.device.selectedDevicesID;
    },
    selectedDrug: function selectedDrug() {
      return this.$store.state.drug.selectedDrug;
    },
    selectedDrugTotalAmount: function selectedDrugTotalAmount() {
      return this.$store.state.drug.selectedDrugTotalAmount;
    }
  },
  mounted: function mounted() {
    // init the first of selected devices.
    this.$store.commit('SET_CURRENT_DEVICE_FROM_SELECTED', this.selectedDevicesID[0]);
    this.$store.commit('SET_CURRENT_STEP', 'setMaxStock');
  },

  methods: {
    getConfirmData: function getConfirmData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('get confirm data, next Device:', _this.nextDevice);

                if (!(_this.nextDevice !== null)) {
                  _context.next = 7;
                  break;
                }

                // check whether next index is over the keys' array length
                _this.$store.commit('SET_CURRENT_DEVICE_FROM_SELECTED', _this.nextDevice.id);
                _this.$store.commit('SET_CURRENT_STEP', 'setMaxStock');
                _this.resetProgress();
                _context.next = 14;
                break;

              case 7:
                console.log('leave multiflow.');
                _context.next = 10;
                return _this.getCurrentDrugInSystem();

              case 10:
                _context.next = 12;
                return _this.$store.dispatch('getTotalDrugAmountInstanly', _this.selectedDrug.id);

              case 12:
                _this.$store.commit('SET_CURRENT_STEP', 'setMinStorage');
                _this.nextProgress();

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getMinStorage: function getMinStorage(val) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.minStorage = val;
                _this2.setMinStock().then(function (res) {
                  _this2.$emit('setAllConfirmData');
                }).catch(function (err) {
                  console.log(err);
                  _this2.$store.commit('SET_MESSAGE', {
                    type: 'error',
                    context: '\u5B89\u5168\u5B58\u91CF\u4E0D\u53EF\u5927\u65BC\u7E3D\u6700\u5927\u5EAB\u5B58\u91CF: ' + err.response.data.max_stock
                  });
                });

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getCurrentDrugInSystem: function getCurrentDrugInSystem() {
      var _this3 = this;

      return this.instance.get('/api/total-storage-in-system/?medication=' + this.selectedDrug.id).then(function (res) {
        _this3.currentDrugInSystem = res.data.results[0];
        _this3.minStorage = res.data.results[0].min_stock;
      });
    },
    setMinStock: function setMinStock() {
      return this.instance.patch('/api/total-storage-in-system/' + this.currentDrugInSystem.id + '/', {
        min_stock: this.minStorage
      });
    }
  }
});

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(8);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DevPanel',
  data: function data() {
    return {
      showNetIndex: [],
      previousDevices: {},
      detectedDevices: [],
      systemsCopy: [],
      previousTestCabInd: 0,
      previousTestDrawerInd: 0,
      testTimes: 0,
      systemName: ''
    };
  },

  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    },
    systemLayoutChecked: function systemLayoutChecked() {
      return this.$store.state.systemLayoutChecked;
    },
    errorDevices: function errorDevices() {
      return this.$store.state.device.errorDevices;
    }
  },
  created: function created() {
    this.getDetectedDevices();
    this.initLocalSystem();
    this.systemName = this.systemsCopy[0].name;
  },
  mounted: function mounted() {},

  methods: {
    openTargetDrawerAndDevices: function openTargetDrawerAndDevices(event) {
      var cabInd = parseInt(event.target.elements.cabInd.value, 10);
      var drawerInd = parseInt(event.target.elements.drawerInd.value, 10);
      console.log(cabInd, drawerInd);
      // reset the test time counter if cab or drawer changed
      if (cabInd !== this.previousTestCabInd || drawerInd !== this.previousTestDrawerInd) {
        this.testTimes = 0;
        this.previousTestCabInd = cabInd;
        this.previousTestDrawerInd = drawerInd;
        localStorage.setItem('previous', this.previousTestCabInd + ';' + this.previousTestDrawerInd);
      }

      this.testTimes += 1;
      localStorage.setItem('testTimes', this.testTimes);

      this.openAllDevices(this.systems[cabInd - 1].net_set[drawerInd - 1]);
    },
    initLocalSystem: function initLocalSystem() {
      this.systemsCopy = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(this.$store.state.device.systems);
      this.systemsCopy.forEach(function (sys) {
        sys.net_set.forEach(function (net) {
          sys.serial = net.system_serial;
          net.toggled = false;
          net.position = 0;
          net.LED_color = null;
          net.LED_status = null;
          net.device_set.forEach(function (device) {
            device.LED_color = null;
            device.LED_status = null;
          });
        });
      });
    },
    toggleNet: function toggleNet(sysInd, netInd) {
      console.log(this.systemsCopy[sysInd].net_set[netInd].toggled);
      this.systemsCopy[sysInd].net_set[netInd].toggled = !this.systemsCopy[sysInd].net_set[netInd].toggled;
      this.$forceUpdate();
    },
    resetSystem: function resetSystem() {
      var system = this.systems;
      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.previousDevices).length !== 0) {
        var key = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.previousDevices)[0];
        var systemId = key.split('-')[0];
        var drawerId = key.split('-')[1];
        system[systemId].net_set[drawerId - 1].LED_color = null;
        system[systemId].net_set[drawerId - 1].LED_status = null;
        this.systems = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.systems, system);
      }
    },
    openAllDevices: function openAllDevices(net) {
      var _this = this;

      var deviceSet = net.device_set;
      __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.orderBy(deviceSet, ['pos_row', 'pos_col']).forEach(function (item) {
        console.log(item.pos_row, item.pos_col);
      });
      var times = 0;
      var intervalTime = 0;
      __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.orderBy(deviceSet, ['pos_row', 'pos_col']).forEach(function (device) {
        setTimeout(function () {
          _this.openDeviceById(device.id);
        }, times * intervalTime);
        times += 1;
      });
    },
    openDeviceById: function openDeviceById(deviceId) {
      this.$store.dispatch('openDevice', deviceId);
    },
    getDetectedDevices: function getDetectedDevices() {
      var _this2 = this;

      return this.instance.get('/api/detected-device/').then(function (res) {
        _this2.detectedDevices = [];
        _this2.detectedDevices = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], _this2.detectedDevices, res.data);
      });
    },
    sendLayoutCommand: function sendLayoutCommand() {
      return this.instance.post('/adc-control/send-layout-message/');
    },
    delDevice: function delDevice(deviceId) {
      var _this3 = this;

      var ans = confirm('delete this device? all drugStorage in this device will be deleted simultaneously.');
      if (ans) {
        this.instance.delete('/api/device/' + deviceId + '/').then(function () {
          // alert('已刪除');
          _this3.$store.dispatch('getSystemInfo').then(function () {
            _this3.initLocalSystem();
          });
        });
      }
    },
    setupDetectedDevice: function setupDetectedDevice(deviceId) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */] + '/adc-control/setup-detected-device/', { id: deviceId }).then(function () {
        // alert('完成新增');
        _this4.$store.dispatch('getSystemInfo').then(function () {
          _this4.initLocalSystem();
        }).then(function () {
          _this4.getDetectedDevices();
        });
      });
    },
    removeDetectedDevice: function removeDetectedDevice(deviceId) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_6__config__["a" /* default */] + '/api/detected-device/' + deviceId + '/').then(function () {
        // alert('完成刪除');
        _this5.$store.dispatch('getSystemInfo').then(function () {
          _this5.initLocalSystem();
        }).then(function () {
          _this5.getDetectedDevices();
        });
      });
    },
    removeAllDevices: function removeAllDevices() {
      this.instance.get('/adc-control/remove-all-devices/');
    },
    removeAllDrugStorages: function removeAllDrugStorages() {
      this.instance.get('/remove-all-drug-storages/');
    },
    createRandomDrugStorages: function createRandomDrugStorages() {
      this.instance.post('/create-random-drug-storages/', { systemId: this.$store.state.device.systemId });
    },
    removeAllEvent: function removeAllEvent() {
      this.instance.get('/remove-all-events/');
    },
    updateSystemStatus: function updateSystemStatus(errorDevices) {
      var _this6 = this;

      var system = this.systemsCopy;
      var nowDevices = {};
      if (errorDevices.length !== 0) {
        errorDevices.forEach(function (d) {
          if (d.type === 'drawer') {
            nowDevices[d.system + '-' + d.drawerId] = 'drawer';
            // this.$set(system[d.system].net_set[d.drawerId - 1], 'LED_color', d.LED_color);
            // this.$set(system[d.system].net_set[d.drawerId - 1], 'LED_status', d.LED_status);
            system[d.system].net_set[d.drawerId - 1].LED_color = d.LED_color;
            system[d.system].net_set[d.drawerId - 1].LED_status = d.LED_status;
          }
          if (d.type === 'box') {
            nowDevices[d.system + '-' + d.drawerId + '-' + d.boxId] = 'box';
            var device = system[d.system].net_set[d.drawerId - 1].device_set[d.boxId];
            // this.$set(this.system[d.system].net_set[d.drawerId - 1].device_set[d.boxId - 1], 'LED_color', d.LED_color);
            // this.$set(device, 'LED_status', d.LED_status);
            // this.$set(device, 'LED_color', d.LED_color);
            device.LED_status = d.LED_status;
            device.LED_color = d.LED_color;
          }
        });
        // compare which device is closed
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(nowDevices).forEach(function (key) {
          if (key in _this6.previousDevices) {
            delete _this6.previousDevices[key];
          }
        });

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(this.previousDevices).forEach(function (item) {
          var key = item[0];
          var type = item[1];
          var keySplit = key.split('-');
          var systemId = keySplit[0];
          var drawerId = keySplit[1];

          if (type === 'drawer') {
            system[systemId].net_set[drawerId - 1].LED_color = null;
            system[systemId].net_set[drawerId - 1].LED_status = null;
          }
          if (type === 'box') {
            var boxId = keySplit[2];
            system[systemId].net_set[drawerId - 1].device_set[boxId].LED_color = null;
            system[systemId].net_set[drawerId - 1].device_set[boxId].LED_status = null;
          }
        });
        this.previousDevices = nowDevices;
        this.systems = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.systems, system);
        this.$forceUpdate();
      }
    }
  },
  watch: {
    systemLayoutChecked: function systemLayoutChecked(val) {
      console.log(val);
      this.initLocalSystem();
    },
    errorDevices: function errorDevices(val) {
      this.updateSystemStatus(val);
    }
  }
});

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_BottomButtons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_BottomButtons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_BottomButtons__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DisableDevicesList',
  computed: {
    disableDevices: function disableDevices() {
      return this.$store.getters.disableDevices;
    }
  },
  components: {
    BottomButtons: __WEBPACK_IMPORTED_MODULE_0__common_BottomButtons___default.a
  },
  mounted: function mounted() {
    this.$store.commit('SET_APP', '待維修藥盒');
  },

  methods: {
    cancel: function cancel() {
      this.$router.push({ name: 'Main' });
    }
  }
});

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flowComp_ProgressBar__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flowComp_ProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__flowComp_ProgressBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flowComp_DrugSelection__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flowComp_DrugSelection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__flowComp_DrugSelection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flowComp_DrugInfoWeb__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flowComp_DrugInfoWeb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__flowComp_DrugInfoWeb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_BottomButtons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_BottomButtons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_BottomButtons__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DrugInfo',
  data: function data() {
    return {
      showWeb: false,
      progress: [{
        en: 'selectDrug',
        zh: '選擇藥物'
      }]
    };
  },

  components: {
    drugSelection: __WEBPACK_IMPORTED_MODULE_1__flowComp_DrugSelection___default.a,
    drugInfoWeb: __WEBPACK_IMPORTED_MODULE_2__flowComp_DrugInfoWeb___default.a,
    progressbar: __WEBPACK_IMPORTED_MODULE_0__flowComp_ProgressBar___default.a,
    BottomButtons: __WEBPACK_IMPORTED_MODULE_3__common_BottomButtons___default.a
  },
  created: function created() {
    this.$store.commit('SET_APP', '藥物資訊');
    this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
    this.$store.commit('SET_PROGRESS', this.progress);
  },

  computed: {
    drug: function drug() {
      return this.$store.state.drug.selectedDrug;
    }
  },
  watch: {
    drug: function drug(val) {
      if (val !== '') {
        this.showWeb = true;
      } else {
        this.showWeb = false;
      }
    }
  },
  methods: {
    cancel: function cancel() {
      this.$router.push({ name: 'Main' });
    },
    closetab: function closetab() {
      this.showWeb = false;
    }
  }
});

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_BottomButtons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_BottomButtons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_BottomButtons__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DrugStorageSummary',
  components: {
    BottomButtons: __WEBPACK_IMPORTED_MODULE_2__common_BottomButtons___default.a
  },
  created: function created() {
    this.$store.commit('SET_APP', '藥物統計');
  },

  computed: {
    summaryData: function summaryData() {
      var summary = {};
      this.$store.getters.drugInDeviceList.forEach(function (element) {
        if (summary[element.medication.id] === undefined) {
          summary[element.medication.id] = {};
          summary[element.medication.id].medication = element.medication;
          summary[element.medication.id].medication_CGMH_number = element.medication.CGMH_number;
          summary[element.medication.id].total = 0;
          summary[element.medication.id].count = 0;
        }
        summary[element.medication.id].total += element.stock;
        summary[element.medication.id].count += 1;
      });
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.orderBy(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(summary), ['medication_CGMH_number']);
    }
  },
  methods: {
    cancel: function cancel() {
      this.$router.push({ name: 'Main' });
    }
  }
});

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ComponentBase_AppBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flowComp_ScanBarcode__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flowComp_ScanBarcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__flowComp_ScanBarcode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flowComp_PositionSelection__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flowComp_PositionSelection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__flowComp_PositionSelection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flowComp_DrugInDeviceList__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flowComp_DrugInDeviceList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__flowComp_DrugInDeviceList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__flowComp_ProgressBar__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__flowComp_ProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__flowComp_ProgressBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FetchDrugFlow_MultiFlow__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FetchDrugFlow_MultiFlow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__FetchDrugFlow_MultiFlow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_BottomButtons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_BottomButtons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__common_BottomButtons__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FetchDrug',
  extends: __WEBPACK_IMPORTED_MODULE_3__ComponentBase_AppBase__["a" /* default */],
  components: {
    scanBarcode: __WEBPACK_IMPORTED_MODULE_4__flowComp_ScanBarcode___default.a,
    selectBox: __WEBPACK_IMPORTED_MODULE_5__flowComp_PositionSelection___default.a,
    drugList: __WEBPACK_IMPORTED_MODULE_6__flowComp_DrugInDeviceList___default.a,
    progressBar: __WEBPACK_IMPORTED_MODULE_7__flowComp_ProgressBar___default.a,
    MultiFlow: __WEBPACK_IMPORTED_MODULE_8__FetchDrugFlow_MultiFlow___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_9__common_Loader___default.a,
    BottomButtons: __WEBPACK_IMPORTED_MODULE_10__common_BottomButtons___default.a
  },
  data: function data() {
    return {
      barcodeData: {},
      startActionType: 'FETCH'
    };
  },

  computed: {
    DrugStorageWithSameDrug: function DrugStorageWithSameDrug() {
      return this.$store.state.drugInDevice.DrugStorageWithSameDrug;
    },
    DrugStorageWithSameDrugID: function DrugStorageWithSameDrugID() {
      return this.$store.state.drugInDevice.DrugStorageWithSameDrugID;
    },
    generalSetting: function generalSetting() {
      return this.$store.state.generalSetting;
    }
  },
  created: function created() {
    this.stage = this.$route.params.stage || 'scanBarcode';
    this.progress = this.setupProgress();
    this.multiProgress = this.setupMultiProgress();
    this.confirmProgress = this.setupConfirmProgress();
    this.actionProgress = this.setupActionProgress();
  },
  mounted: function mounted() {
    this.$store.commit('SET_APP', '一般取藥');
    this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
    this.$store.commit('SET_PROGRESS', this.progress);
  },

  methods: {
    setupProgress: function setupProgress() {
      var prog = [];
      prog.push({ en: 'selectDrug', zh: '選擇藥物' });
      prog.push({ en: 'setFetchNum', zh: '設定處方籤數量' });
      if (this.$store.state.schedule.currentSchedule === null) {
        if (this.startActionType === 'FETCH') {
          prog.push({ en: 'MedIdInput', zh: '輸入病歷號' });
        }
        if (this.startActionType === 'FETCH_TRANSFER') {
          prog.push({ en: 'MedIdInput', zh: '輸入本單編號' });
        }
      }
      if (this.$store.state.user.user.task_privilege.fetch_drug === false) {
        prog.push({ en: 'rxCheck', zh: '覆核動作' });
      }
      if (this.generalSetting.check_amount_first) {
        prog.push({ en: 'confirmAmount', zh: '確認數量' });
      }
      prog.push({ en: 'action', zh: '進行取藥' });

      return prog;
    },
    setupConfirmProgress: function setupConfirmProgress() {
      var prog = [];
      prog.push('setFetchNum');
      if (this.$store.state.schedule.currentSchedule === null) {
        prog.push('MedIdInput');
      }
      if (this.$store.state.user.user.task_privilege.fetch_drug === false) {
        prog.push('rxCheck');
      }
      prog.push('actionWrap');
      return prog;
    },
    setupActionProgress: function setupActionProgress() {
      var prog = [];
      if (this.generalSetting.check_amount_first) {
        prog.push('confirmAmount');
      }
      prog.push('action');
      prog.push('next');
      return prog;
    },
    setupMultiProgress: function setupMultiProgress() {
      var prog = [];
      prog.push('confirm');
      prog.push('finish');
      return prog;
    },
    cancel: function cancel() {
      this.$store.dispatch('recordAction', { eventType: 'CANCEL_FETCH' });
      this.$router.push({ name: 'Main' });
    },
    startFlow: function startFlow(startActionType) {
      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.$store.state.drugInDevice.selectedDrugInDevice).length === 0) {
        this.$store.commit('SET_MESSAGE', { type: 'error', context: '請至少選擇一項儲存藥物' });
      } else {
        this.$store.dispatch('fromFirstDrugInDevice');
        this.stage = 'setFlowData';
        this.startActionType = startActionType;
        this.$store.commit('SET_PROGRESS', this.progress);
      }
    },
    getAllConfirmData: function getAllConfirmData() {
      // refetch data
      this.$store.dispatch('resetAll');
      this.$store.dispatch('getSystemInfo');
      this.$store.dispatch('getDrugInDevices');
      this.stage = 'scanBarcode';
      this.barcodeData = {};
    },
    getBarcode: function getBarcode(data) {
      var _this = this;

      console.log(data);
      // 長庚: 料位號 (3碼) + 數量(3碼) + 病歷號(7碼)
      var barcodeString = data.toString();
      //20190424 modified
      var code;
      var amount;
      var medRecordId;
      console.log('barcodeLen:', barcodeString.length);
      if (barcodeString.length >= 20 && barcodeString.length <= 22) {
        console.log('new barcode type');
        code = barcodeString.slice(0, 3);
        amount = parseInt(barcodeString.slice(3, 6), 10);
        medRecordId = barcodeString.slice(6, 18);
        medRecordId = medRecordId.split(' ').join(''); //filter space char  
        console.log('料位號:', code);
        console.log('數量:', amount);
        console.log('病歷號:', medRecordId);
      } else {
        console.log('old barcode type');
        code = barcodeString.slice(0, 3);
        amount = parseInt(barcodeString.slice(3, 6), 10);
        medRecordId = barcodeString.slice(6, barcodeString.length).split('\r')[0];
        //20190510 新增化療藥局的病歷號會帶空白
        medRecordId = medRecordId.split(' ').join(''); //filter space char
        console.log('料位號:', code);
        console.log('數量:', amount);
        console.log('病歷號:', medRecordId);
      }

      this.instance.get('/api/medication/?CGMH_number=' + code).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res) {
          var medId, drugStorage;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(res.data.results.length === 0)) {
                    _context.next = 4;
                    break;
                  }

                  _this.$store.commit('SET_MESSAGE', { type: 'warn', context: '資料庫查無此藥' });
                  _context.next = 21;
                  break;

                case 4:
                  medId = res.data.results[0].id;
                  _context.next = 7;
                  return _this.$store.dispatch('getDrugInDevicesWithSameDrug', medId);

                case 7:
                  if (!(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this.DrugStorageWithSameDrug).length === 0)) {
                    _context.next = 11;
                    break;
                  }

                  _this.$store.commit('SET_MESSAGE', { type: 'warn', context: '藥櫃無存放此藥物或此藥物已取完' });
                  _context.next = 21;
                  break;

                case 11:
                  drugStorage = _this.DrugStorageWithSameDrug[_this.DrugStorageWithSameDrugID[0]];

                  _this.$store.commit('SELECT_DRUG_IN_DEVICES_FROM_SELECTED', drugStorage.id);
                  _context.next = 15;
                  return _this.$store.dispatch('fromFirstDrugInDevice');

                case 15:
                  _this.barcodeData.amount = amount;
                  _this.barcodeData.medRecordId = medRecordId;
                  _this.$store.commit('SET_CURRENT_DEVICE_FROM_ALL', drugStorage.device.id);
                  console.log('start flow');
                  _this.$store.commit('SET_MED_RECORD_NO', medRecordId);
                  _this.stage = 'setFlowData';

                case 21:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  },
  watch: {
    stage: function stage(val) {
      if (val === 'scanBarcode') {
        this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
      } else {
        this.$store.commit('SET_CURRENT_STEP', val);
      }

      if (val === 'scanBarcode' || val === 'selectDrug') {
        this.$store.commit('SHOW_LOGOUT', true);
      } else {
        this.$store.commit('SHOW_LOGOUT', false);
      }
    }
  }
});

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flowComp_ProgressBar__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flowComp_ProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__flowComp_ProgressBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FetchDrugGroupFlow_MultiFlow__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FetchDrugGroupFlow_MultiFlow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__FetchDrugGroupFlow_MultiFlow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_BottomButtons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_BottomButtons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_BottomButtons__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FetchDrugCombo',
  components: {
    progressBar: __WEBPACK_IMPORTED_MODULE_2__flowComp_ProgressBar___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_3__common_Loader___default.a,
    MultiFlow: __WEBPACK_IMPORTED_MODULE_4__FetchDrugGroupFlow_MultiFlow___default.a,
    BottomButtons: __WEBPACK_IMPORTED_MODULE_5__common_BottomButtons___default.a
  },
  data: function data() {
    return {
      group: [],
      getMedGroup: false,
      currentGroupIndex: 0,
      stage: 'medGroupList',
      scheduleId: null
    };
  },
  created: function created() {
    this.$store.commit('SET_APP', '套組取藥');
    this.$store.commit('SET_PROGRESS', this.progress);
    this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
    this.getGroup();
  },

  computed: {
    instance: function instance() {
      return this.$store.getters.instance;
    },
    progress: function progress() {
      var p = [];
      p.push({ en: 'selectDrug', zh: '選擇藥物' });
      if (this.$store.state.schedule.currentSchedule === null) {
        p.push({ en: 'medIdInput', zh: '輸入病歷號' });
      }
      if (this.$store.state.generalSetting.check_amount_first) {
        p.push({ en: 'confirmAmount', zh: '確認數量' });
      }
      p.push({ en: 'action', zh: '進行取藥' });
      return p;
    },
    multiProgress: function multiProgress() {
      var p = [];
      if (this.$store.state.schedule.currentSchedule === null) {
        p.push('medIdInput');
      }
      p.push('confirm');
      p.push('finish');
      return p;
    },
    confirmProgress: function confirmProgress() {
      return ['action'];
    },
    actionProgress: function actionProgress() {
      var prog = [];
      if (this.$store.state.generalSetting.check_amount_first) {
        prog.push('confirmAmount');
      }
      prog.push('action');
      prog.push('next');
      return prog;
    }
  },
  methods: {
    getGroup: function getGroup() {
      var _this = this;

      this.instance.get('/api/combo-medication-set/').then(function (res) {
        var comboMedSets = {};
        res.data.forEach(function (relation) {
          if (comboMedSets[relation.parent_medication.id] === undefined) {
            comboMedSets[relation.parent_medication.id] = {};
            comboMedSets[relation.parent_medication.id].name = relation.parent_medication.generic_name;
            comboMedSets[relation.parent_medication.id].childMedSet = [];
            comboMedSets[relation.parent_medication.id].selected = false;
          }
          var childMed = relation.child_medication;
          childMed.selected = false;
          childMed.drugInDevice = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(_this.$store.getters.drugInDeviceList, function (drugStorage) {
            return drugStorage.medication.id === childMed.id && drugStorage.stock > 0;
          });
          childMed.amountInSystem = 0;
          childMed.drugInDevice.forEach(function (d) {
            childMed.amountInSystem += d.stock;
          });
          comboMedSets[relation.parent_medication.id].childMedSet.push(childMed);
        });
        console.log(comboMedSets);
        _this.group = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(comboMedSets);
        _this.getMedGroup = true;
      });
    },
    selectMed: function selectMed(index) {
      var med = this.group[this.currentGroupIndex].childMedSet[index];
      med.selected = !med.selected;
      console.log(med);
      var payload = {
        med: med,
        drugStorage: med.drugInDevice,
        amount: 1,
        select: med.selected
      };
      this.$store.dispatch('setDrugListForFetch', payload);
    },
    cancel: function cancel() {
      this.$router.push({ name: 'Main' });
    },
    startFlow: function startFlow() {
      this.stage = 'startFlow';
      // this.$store.dispatch('startSchedulMed');
    },
    getAllConfirmData: function getAllConfirmData() {
      // refetch data
      this.$store.dispatch('resetAll');
      this.stage = 'ScheduleList';
      this.$router.push({ name: 'schedule' });
    }
  }
});

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flowComp_Action__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flowComp_Action___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__flowComp_Action__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__flowComp_ActionBreak__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__flowComp_ActionBreak___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__flowComp_ActionBreak__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__flowComp_ScanBarcode__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__flowComp_ScanBarcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__flowComp_ScanBarcode__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FetchActionWrap',
  props: {
    amount: Number,
    barcodeData: Object,
    medRecordId: String,
    // scheduleId: Number,
    actionProgress: Array,
    startActionType: String,
    reviewer: Object
  },
  components: {
    Action: __WEBPACK_IMPORTED_MODULE_6__flowComp_Action___default.a,
    ActionBreak: __WEBPACK_IMPORTED_MODULE_7__flowComp_ActionBreak___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_8__common_Loader___default.a,
    ScanBarcode: __WEBPACK_IMPORTED_MODULE_9__flowComp_ScanBarcode___default.a
  },
  computed: {
    currentDrugInDevice: function currentDrugInDevice() {
      return this.$store.state.drugInDevice.currentDrugInDevice;
    },
    drugStorageWithSameDrug: function drugStorageWithSameDrug() {
      return this.$store.state.drugInDevice.DrugStorageWithSameDrug;
    },
    instance: function instance() {
      return this.$store.state.instance;
    },
    fetchReadOnly: function fetchReadOnly() {
      if (this.barcodeData !== undefined && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.barcodeData).length > 0) return true;
      return false;
    }
  },
  data: function data() {
    return {
      stage: '',
      totalAmount: 0, // already fetched
      drugStorageInQueue: [], // device queue with same drug
      drugStorageList: [],
      theDrugStorage: {},
      theDrugStorageIndex: 0,
      actionData: [],
      forAction: {
        defaultNum: 0,
        checkNum: 0,
        deviceId: 0
      },
      residual: 0,
      getEmitTimes: 0,
      progressIndex: 0,
      scheduleId: undefined,
      oriNextDrugStorageId: undefined
    };
  },
  destroyed: function destroyed() {
    console.log('一般取藥 ActionWrap destroyed');
    this.totalAmount = 0;
    this.drugStorageInQueue = {};
    this.drugStorageInQueueId = [];
    this.theDrugStorage = {};
    this.theDrugStorageIndex = 0;
    this.forAction = {
      defaultNum: 0,
      checkNum: 0,
      deviceId: 0
    };
    this.getEmitTimes = 0;
    this.$store.commit('SET_APP_CANCEL_STATUS', true);
  },
  created: function created() {
    this.$store.commit('SET_APP_CANCEL_STATUS', false);
    // console.log(this.forAction);
    // prepare for the first Action child. remove the first one(user selected one), then set the remains into state.
    this.drugStorageInQueue = this.drugStorageWithSameDrug;
    console.log(this.drugStorageWithSameDrug);

    // this.$store.commit('SET_CONFIRM_STAGE', 'confirmAmount');
    this.moveCurrentStorageToHead(this.currentDrugInDevice.id);
    this.residual = this.amount;
    this.theDrugStorage = this.drugStorageList[this.theDrugStorageIndex];
    this.$store.commit('SET_CURRENT_DRUG_IN_DEVICE', this.theDrugStorage.id);
    // prepare forAction data
    if (this.actionProgress[0] === 'confirmAmount') {
      this.forAction = {
        defaultNum: this.theDrugStorage.stock,
        checkNum: this.theDrugStorage.max_stock,
        deviceId: this.theDrugStorage.device.id
      };
      this.$store.commit('SET_CURRENT_STEP', 'confirmAmount');
    }
    if (this.actionProgress[0] === 'action') {
      this.forAction = {
        defaultNum: this.amount,
        checkNum: this.theDrugStorage.stock,
        deviceId: this.theDrugStorage.device.id
      };
      this.$store.commit('SET_CURRENT_STEP', 'action');
    }
    this.stage = this.actionProgress[0]; // well, it seems that the new refaction could not fit actionWrap flow.
  },

  methods: {
    confirmAmountFinish: function confirmAmountFinish() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var nextDrugStorage, tmpNextDrugStorage;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('drugstorage', _this.theDrugStorage);
                _context.next = 3;
                return _this.$store.dispatch('updateCurrentDrugInDevice', _this.theDrugStorage.id);

              case 3:
                // notice: the stock of drugStorage might change here.
                _this.theDrugStorage = _this.$store.state.drugInDevice.allDrugInDevice[_this.theDrugStorage.id];
                //
                _this.forAction = {
                  defaultNum: _this.amount - _this.totalAmount, // the resident number for child.
                  checkNum: _this.theDrugStorage.stock > _this.residual ? _this.residual : _this.theDrugStorage.stock,
                  deviceId: _this.theDrugStorage.device.id
                };

                _this.stage = 'next';
                // 如果確認之後為0 就跳過該藥盒
                if (_this.currentDrugInDevice.stock === 0) {
                  if (_this.theDrugStorageIndex + 1 < _this.drugStorageList.length) {
                    _this.theDrugStorageIndex += 1;
                    _this.residual = _this.amount - _this.totalAmount;
                    _this.theDrugStorage = _this.drugStorageList[_this.theDrugStorageIndex];
                    _this.forAction = {
                      defaultNum: _this.amount - _this.totalAmount, // the resident number for child.
                      checkNum: _this.theDrugStorage.stock > _this.residual ? _this.residual : _this.theDrugStorage.stock,
                      deviceId: _this.theDrugStorage.device.id
                    };
                    // set next DrugStorage
                    nextDrugStorage = _this.drugStorageList[_this.theDrugStorageIndex];

                    _this.$store.commit('SET_NEXT_DEVICE', nextDrugStorage.device.id);
                    _this.$store.commit('SET_NEXT_DRUG_IN_DEVICE', nextDrugStorage.id);
                    _this.stage = 'break';
                  } else {
                    if (_this.amount - _this.totalAmount > 0) {
                      _this.$store.commit('SET_MESSAGE', {
                        type: 'warn',
                        context: '\u5C1A\u6709' + (_this.amount - _this.totalAmount) + '\u672A\u62FF\uFF0C\u8ACB\u81EA\u884C\u81F3\u5916\u90E8\u85E5\u76D2\u62FF\u53D6\u3002',
                        keepOnTop: true
                      });
                    }
                    //20190426 add
                    console.log('store.state.drugInDevice.currentDrugInDevice:', _this.$store.state.drugInDevice.currentDrugInDevice);
                    console.log('store.state.drugInDevice.nextDrugInDevice:', _this.$store.state.drugInDevice.nextDrugInDevice);
                    if (_this.$store.state.drugInDevice.nextDrugInDevice) {
                      console.log('store.state.drugInDevice.currentDrugInDevice.id:', _this.$store.state.drugInDevice.currentDrugInDevice.id);
                      console.log('store.state.drugInDevice.nextDrugInDevice.id:', _this.$store.state.drugInDevice.nextDrugInDevice.id);
                      //console.log(this.$store.state.drugInDevice);
                      _this.resetNextDrugInDevice();
                      //沒有下個藥要取
                      if (_this.$store.state.drugInDevice.sortedSelectedDrugInDeviceIndex >= _this.$store.state.drugInDevice.sortedSelectedDrugInDevice.length - 1) {
                        console.log('remove:case a');
                        _this.$store.commit('REMOVE_NEXT_DRUG_IN_DEVICE');
                        _this.$store.commit('REMOVE_NEXT_DEVICE');
                      } else //還有下個藥可取
                        {
                          if (_this.$store.state.drugInDevice.currentDrugInDevice.id === _this.$store.state.drugInDevice.nextDrugInDevice.id) {
                            //去撈下個排序的藥的id並設為next device
                            tmpNextDrugStorage = _this.$store.state.drugInDevice.sortedSelectedDrugInDevice[_this.$store.state.drugInDevice.sortedSelectedDrugInDeviceIndex + 1];

                            console.log(tmpNextDrugStorage);
                            if (tmpNextDrugStorage) {
                              console.log('tmpNextDrugStorage.device.id:', tmpNextDrugStorage.device.id);
                              _this.$store.commit('SET_NEXT_DEVICE', tmpNextDrugStorage.device.id);
                              _this.$store.commit('SET_NEXT_DRUG_IN_DEVICE', tmpNextDrugStorage.id);
                            } else {
                              console.log('remove:case b');
                              _this.$store.commit('REMOVE_NEXT_DRUG_IN_DEVICE');
                              _this.$store.commit('REMOVE_NEXT_DEVICE');
                            }
                          }
                        }
                    } else {
                      console.log('remove:case c');
                      _this.$store.commit('REMOVE_NEXT_DRUG_IN_DEVICE');
                      _this.$store.commit('REMOVE_NEXT_DEVICE');
                    }
                    setTimeout(function () {
                      _this.$emit('setActionData');
                    }, 1000);
                  }
                } else {
                  // notice: the stock of drugStorage might change here.
                  _this.theDrugStorage = _this.$store.state.drugInDevice.allDrugInDevice[_this.theDrugStorage.id];
                  //
                  _this.forAction = {
                    defaultNum: _this.amount - _this.totalAmount, // the resident number for child.
                    checkNum: _this.theDrugStorage.stock > _this.residual ? _this.residual : _this.theDrugStorage.stock,
                    deviceId: _this.theDrugStorage.device.id
                  };
                  setTimeout(function () {
                    _this.stage = 'action';
                    _this.$store.commit('SET_CURRENT_STEP', 'action');
                  }, 200);
                  _this.getTotalSumInstanly(_this.amount - _this.totalAmount);
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    moveCurrentStorageToHead: function moveCurrentStorageToHead(drugStorageId) {
      var current = this.drugStorageInQueue[drugStorageId];
      delete this.drugStorageInQueue[drugStorageId];
      this.drugStorageList = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.drugStorageInQueue);
      // 領藥條件： 最接近過期 > 散裝量最多
      //this.drugStorageList = _.orderBy(this.drugStorageList, [(o) => { return new Date(o.expired_date); }, (o) => { return o.stock - (o.medication.pack_content * o.pack_count); }], ['asc', 'desc']);
      //20190524
      // 領藥條件： 最接近過期 > 散裝量最小 
      this.drugStorageList = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.orderBy(this.drugStorageList, [function (o) {
        return new Date(o.expired_date);
      }, function (o) {
        return o.stock - o.medication.pack_content * o.pack_count;
      }], ['asc', 'asc']);
      this.drugStorageList.unshift(current); // insert the current one to the head.
      // this.$store.commit('SET_SELECTED_DRUG_IN_DEVICE_DIRECTLY', this.drugStorageList);
    },
    saveData: function saveData(data) {
      var _this2 = this;

      console.log(data);
      var currentDrugStorage = this.theDrugStorage;
      if (this.currentDrugInDevice.stock - data.num < 0) {
        throw new Error('the saving stock should not be miuns');
      } else {
        var remainPc = currentDrugStorage.stock - currentDrugStorage.medication.pack_content * currentDrugStorage.pack_count;
        var remainPackCount = currentDrugStorage.pack_count;
        if (remainPackCount !== 0 && currentDrugStorage.medication.pack_content !== 0) {
          remainPackCount = currentDrugStorage.pack_count - Math.ceil((data.num - remainPc) / currentDrugStorage.medication.pack_content);
        }
        console.log(remainPackCount);
        if (this.$store.state.schedule.currentSchedule) {
          this.scheduleId = this.$store.state.schedule.currentSchedule.id;
        }

        var medRecrodNumber = null;
        if (this.medRecordId !== undefined) {
          medRecrodNumber = this.medRecordId;
        } else if (this.barcodeData !== undefined) {
          medRecrodNumber = this.barcodeData.medRecordId;
        } else if (this.$store.state.schedule.currentSchedule !== undefined) {
          medRecrodNumber = this.$store.state.schedule.currentSchedule.patient.med_record_number;
        } else {
          medRecrodNumber = null;
        }
        // console.log(this.medRecordId, this.barcodeData, this.$store.state.schedule.currentSchedule, medRecrodNumber);

        // becareful that other components used this comp.
        var eventType = 'FETCH';
        if (this.startActionType === 'FETCH_TRANSFER') {
          eventType = 'FETCH_TRANSFER';
        }

        var sentData = {
          id: currentDrugStorage.id,
          device: data.device,
          stock: currentDrugStorage.stock - data.num, // only update here.
          max_stock: currentDrugStorage.max_stock,
          expired_date: currentDrugStorage.expired_date,
          patch_number: currentDrugStorage.patch_number,
          medication: currentDrugStorage.medication.id,
          med_record_no: medRecrodNumber,
          number1: -data.num,
          number2: this.scheduleId,
          pack_count: remainPackCount,
          type: eventType,
          review_employee: this.reviewer === undefined ? undefined : this.reviewer.id
        };

        if (data.emptyCount > 0) {
          sentData.empty_count = currentDrugStorage.empty_count + data.emptyCount;
        }

        this.stage = 'next';
        return this.instance.put('/api/drug-storage/' + sentData.id + '/', sentData).then(function (drugStorageActionRes) {
          // update the amount after saving
          _this2.$store.dispatch('getTotalDrugAmountInstanly', currentDrugStorage.medication.id);

          // record Return Empty if neeed
          if (data.emptyCount > 0) {
            _this2.$store.dispatch('recordAction', { eventType: 'RETURN_EMPTY', number1: data.emptyCount }).then(function () {
              var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(eventActionRes) {
                var event;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        event = {
                          id: drugStorageActionRes.data,
                          checked: true,
                          related_events: [eventActionRes.data]
                        };
                        _context2.next = 3;
                        return _this2.instance.patch('/api/event/' + event.id + '/', event);

                      case 3:
                      case 'end':
                        return _context2.stop();
                    }
                  }
                }, _callee2, _this2);
              }));

              return function (_x) {
                return _ref.apply(this, arguments);
              };
            }());
          }

          console.log('set drug storage.');
        }).catch(function (res) {
          console.log('fetch drug error');
        });
      }
    },
    goOn: function goOn() {
      var defaultNumCalc = 0;
      var checkNumCalc = 0;
      if (this.actionProgress[0] === 'confirmAmount') {
        defaultNumCalc = this.theDrugStorage.stock;
        checkNumCalc = this.theDrugStorage.max_stock;
      }
      if (this.actionProgress[0] === 'action') {
        defaultNumCalc = this.residual;
        checkNumCalc = this.theDrugStorage.stock > this.residual ? this.residual : this.theDrugStorage.stock;
      }

      this.forAction = {
        defaultNum: defaultNumCalc, // the resident number for child.
        checkNum: checkNumCalc,
        deviceId: this.theDrugStorage.device.id
      };
      this.$store.commit('SET_CURRENT_DRUG_IN_DEVICE', this.theDrugStorage.id);
      this.stage = this.actionProgress[0]; // TODO: remove it here.
      this.getEmitTimes = 0;
      this.resetNextDrugInDevice();
    },
    resetNextDrugInDevice: function resetNextDrugInDevice() {
      // reset drugStorage id if it has been changed previous.
      console.log('resetNextDrugInDevice');
      if (this.$store.state.drugInDevice.nextDrugInDevice) {
        // save the drugStorage id temporaliy.
        this.oriNextDrugStorageId = this.$store.state.drugInDevice.nextDrugInDevice.id;
      }
      console.log('this.oriNextDrugStorageId:', this.oriNextDrugStorageId);
      if (this.oriNextDrugStorageId) {
        this.$store.commit('SET_NEXT_DEVICE', this.$store.state.drugInDevice.allDrugInDevice[this.oriNextDrugStorageId].device.id);
        this.$store.commit('SET_NEXT_DRUG_IN_DEVICE', this.oriNextDrugStorageId);
      }
    },
    getTotalSumInstanly: function getTotalSumInstanly(val) {
      console.log('get total amount instanly', val, this.residual);
      console.log('theDrugStorageIndex:', this.theDrugStorageIndex);
      console.log('drugStorageList.length:', this.drugStorageList.length);
      // check fetch amount from current drugStorage is enough or not
      if (val < this.residual) {
        //20190429 modified
        //if (this.theDrugStorageIndex + 1 <= this.drugStorageList.length) {
        if (this.theDrugStorageIndex + 1 < this.drugStorageList.length) {
          var nextDrugStorage = this.drugStorageList[this.theDrugStorageIndex + 1];
          if (this.$store.state.drugInDevice.nextDrugInDevice) {
            // save the drugStorage id temporaliy.
            this.oriNextDrugStorageId = this.$store.state.drugInDevice.nextDrugInDevice.id;
          }
          console.log('nextDrugStorage.device.id:', nextDrugStorage.device.id);
          this.$store.commit('SET_NEXT_DEVICE', nextDrugStorage.device.id);
          this.$store.commit('SET_NEXT_DRUG_IN_DEVICE', nextDrugStorage.id);
        } else {
          console.log('no enough amount for fetching.');
        }
      } else {
        this.resetNextDrugInDevice();
        console.log('sortedSelectedDrugInDeviceIndex:', this.$store.state.drugInDevice.sortedSelectedDrugInDeviceIndex);
        console.log('sortedSelectedDrugInDevice.length:', this.$store.state.drugInDevice.sortedSelectedDrugInDevice.length);
        console.log('store.state.drugInDevice.currentDrugInDevice.id:', this.$store.state.drugInDevice.currentDrugInDevice.id);
        if (this.$store.state.drugInDevice.nextDrugInDevice) {
          console.log('store.state.drugInDevice.nextDrugInDevice.id:', this.$store.state.drugInDevice.nextDrugInDevice.id);
        }
        if (this.$store.state.drugInDevice.sortedSelectedDrugInDeviceIndex >= this.$store.state.drugInDevice.sortedSelectedDrugInDevice.length - 1) {
          console.log('remove:case aa');
          this.$store.commit('REMOVE_NEXT_DRUG_IN_DEVICE');
          this.$store.commit('REMOVE_NEXT_DEVICE');
        } else //還有下個藥可取
          {
            if (this.$store.state.drugInDevice.nextDrugInDevice) {
              if (this.$store.state.drugInDevice.currentDrugInDevice.id === this.$store.state.drugInDevice.nextDrugInDevice.id) {
                //去撈下個排序的藥的id並設為next device
                var tmp2NextDrugStorage = this.$store.state.drugInDevice.sortedSelectedDrugInDevice[this.$store.state.drugInDevice.sortedSelectedDrugInDeviceIndex + 1];
                console.log(tmp2NextDrugStorage);
                if (tmp2NextDrugStorage) {
                  console.log('tmp2NextDrugStorage.device.id:', tmp2NextDrugStorage.device.id);
                  this.$store.commit('SET_NEXT_DEVICE', tmp2NextDrugStorage.device.id);
                  this.$store.commit('SET_NEXT_DRUG_IN_DEVICE', tmp2NextDrugStorage.id);
                } else {
                  console.log('remove:case bb');
                  this.$store.commit('REMOVE_NEXT_DRUG_IN_DEVICE');
                  this.$store.commit('REMOVE_NEXT_DEVICE');
                }
              }
            }
          }
      }
    },
    getThisAmount: function getThisAmount(data) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.getEmitTimes += 1; // prevent over emitting

                if (!(_this3.getEmitTimes === 1)) {
                  _context3.next = 7;
                  break;
                }

                // this.stage = 'next';
                // data: device, num
                _this3.totalAmount += data.num;
                _context3.next = 5;
                return _this3.saveData(data);

              case 5:

                // record Return Empty if neeed
                // if (data.emptyCount > 0) {
                //   await this.$store.dispatch('recordAction', { eventType: 'RETURN_EMPTY', number1: data.emptyCount });
                // }

                // increment the index
                _this3.theDrugStorageIndex += 1;
                // await this.$store.dispatch('getTotalDrugAmountInstanly', this.$store.state.drug.selectedDrugID);
                if (_this3.totalAmount < _this3.amount) {
                  if (_this3.theDrugStorageIndex < _this3.drugStorageList.length) {
                    _this3.residual = _this3.amount - _this3.totalAmount;
                    _this3.theDrugStorage = _this3.drugStorageList[_this3.theDrugStorageIndex];
                    _this3.stage = 'break';
                  } else {
                    _this3.$store.commit('SET_MESSAGE', {
                      type: 'warn',
                      context: '\u5C1A\u6709' + (_this3.amount - _this3.totalAmount) + '\u672A\u62FF\uFF0C\u8ACB\u81EA\u884C\u81F3\u5916\u90E8\u85E5\u76D2\u62FF\u53D6\u3002',
                      keepOnTop: true
                    });
                    // TODO: here is not emit yet. thus the action will stop at here.
                    // make fetch drug in outside drug box is recorded.
                    _this3.getEmitTimes = 0;
                    setTimeout(function () {
                      _this3.$emit('setActionData');
                    }, 1000);
                  }
                } else {
                  console.log('finished');
                  // this.resetNextDrugInDevice();
                  _this3.$emit('setActionData');
                }

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  }
});

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ComponentBase_ConfirmFlowBase__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flowComp_NumberSet__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flowComp_NumberSet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__flowComp_NumberSet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flowComp_TextInput__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flowComp_TextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__flowComp_TextInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ActionWrap__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ActionWrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ActionWrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flowComp_RxCheckBarcode__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flowComp_RxCheckBarcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__flowComp_RxCheckBarcode__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ConfirmFlow',
  extends: __WEBPACK_IMPORTED_MODULE_0__ComponentBase_ConfirmFlowBase__["a" /* default */],
  props: ['barcodeData', 'startActionType'],
  data: function data() {
    return {
      perscription: 0,
      defaultAmount: 0,
      fetchData: [],
      medRecordId: '',
      reviewer: undefined
    };
  },

  components: {
    ConfirmStorage: __WEBPACK_IMPORTED_MODULE_1__flowComp_NumberSet___default.a,
    ActionWrap: __WEBPACK_IMPORTED_MODULE_3__ActionWrap___default.a,
    MedIdInput: __WEBPACK_IMPORTED_MODULE_2__flowComp_TextInput___default.a,
    RxCheckBarcode: __WEBPACK_IMPORTED_MODULE_4__flowComp_RxCheckBarcode___default.a
  },
  methods: {
    confirmRx: function confirmRx(reviewer) {
      this.reviewer = reviewer;
      this.nextProgress();
    },
    getStorageAmount: function getStorageAmount(amount) {
      this.perscription = parseInt(amount, 10);
      if (this.perscription > this.selectedDrugTotalAmount) {
        this.$store.commit('SET_MESSAGE', { type: 'warn', context: '處方籤大於總存量，藥櫃存量將無法滿足取藥量' });
      }
      this.nextProgress();
    },
    getFetchData: function getFetchData() {
      console.log('confirmation finished');
      this.$emit('confirmationFinish');
      this.resetProgress();
      this.perscription = 0; // reset perscription
    },
    getMedId: function getMedId(data) {
      console.log(data);
      this.medRecordId = data;
      this.$store.commit('SET_MED_RECORD_NO', data);
      if (data === '' || data === undefined) {
        this.$store.commit('SET_MESSAGE', { type: 'error', context: '病歷號不可以為空' });
      } else {
        this.nextProgress();
      }
    }
  },
  mounted: function mounted() {
    this.$store.commit('SET_CURRENT_STEP', this.currentProgress);
    // barcode amount
    if (this.barcodeData.amount && this.currentProgress === 'setFetchNum') this.nextProgress();
    if (this.barcodeData.medRecordId && this.currentProgress === 'MedIdInput') this.nextProgress();
    if (this.barcodeData.amount) {
      this.perscription = this.barcodeData.amount;
      this.medRecordId = this.barcodeData.medRecordId;
    }

    if (this.$store.state.schedule.currentSchedule !== null) {
      this.medRecordId = this.$store.state.schedule.currentSchedule.patient.med_record_number;
    }
  },

  computed: {
    textInpuTitle: function textInpuTitle() {
      if (this.startActionType === 'FETCH') return '輸入病歷號';
      if (this.startActionType === 'FETCH_TRANSFER') return '輸入本單編號';
      return '';
    }
  },
  watch: {
    confirmProgress: function confirmProgress(val) {
      // reset data for next flow
      if (val === 'setFetchNum') {
        this.perscription = 0;
        this.defaultAmount = 0;
        this.fetchData = [];
        this.medRecordId = '';
      }
    }
  }
});

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ComponentBase_MultiFlowBase__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flowComp_DrugInfo__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flowComp_DrugInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__flowComp_DrugInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConfirmFlow__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConfirmFlow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ConfirmFlow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_Loader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'multiFlow',
  extends: __WEBPACK_IMPORTED_MODULE_0__ComponentBase_MultiFlowBase__["a" /* default */],
  props: ['barcodeData', 'startActionType'],
  data: function data() {
    return {
      checkFun: undefined
    };
  },

  components: {
    DrugInfo: __WEBPACK_IMPORTED_MODULE_1__flowComp_DrugInfo___default.a,
    ConfirmFlow: __WEBPACK_IMPORTED_MODULE_2__ConfirmFlow___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_3__common_Loader___default.a
  },
  created: function created() {
    this.$store.commit('SET_CURRENT_STEP', 'setFetchNum');
  },

  methods: {
    getConfirmData: function getConfirmData() {
      var _this = this;

      this.nextProgress();
      this.checkFun = setInterval(function () {
        _this.checkDevicesCloseAndEmit();
      }, 500);
    },
    nextStep: function nextStep() {
      // Multi fetch drug function is now disabled.
      if (this.$store.state.drugInDevice.sortedSelectedDrugInDeviceIndex < this.$store.state.drugInDevice.sortedSelectedDrugInDevice.length - 1) {
        console.log('get confirm data, move to next');
        this.$store.dispatch('toNextDrugInDevice');
        this.resetProgress();
      } else {
        console.log('leave multiflow, finish workflow');
        this.$emit('setAllConfirmData');
      }
    },

    //20190412 modified by aaron
    checkDevicesCloseAndEmit: function checkDevicesCloseAndEmit() {
      if (this.nextDevice) {
        if (this.nextDevice.net.id === this.currentDevice.net.id && this.errorDevices.length > 1) {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            confirm: false,
            context: '請先關閉所有藥盒'
          });
        } else if (this.nextDevice.net.id !== this.currentDevice.net.id && this.errorDevices.length > 0) {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            confirm: false,
            context: '請先關閉所有藥盒及抽屜'
          });
        } else {
          this.$store.commit('CLOSE_MESSAGE');
          if (this.checkFun) {
            clearInterval(this.checkFun);
          }
          this.nextStep();
        }
      } else {
        /*
        this.$store.commit('CLOSE_MESSAGE');
        if (this.checkFun) {
          clearInterval(this.checkFun);
        }
        this.nextStep();
        */
        if (this.errorDevices.length > 0) {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            confirm: false,
            context: '請先關閉所有藥盒及抽屜'
          });
        } else {
          this.$store.commit('CLOSE_MESSAGE');
          if (this.checkFun) {
            clearInterval(this.checkFun);
          }
          this.nextStep();
        }
      }
    }
  },
  computed: {
    selectedDrugInDevice: function selectedDrugInDevice() {
      return this.$store.state.drugInDevice.selectedDrugInDevice;
    }
  }
});

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flowComp_ProgressBar__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flowComp_ProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__flowComp_ProgressBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FetchDrugGroupFlow_MultiFlow__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FetchDrugGroupFlow_MultiFlow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__FetchDrugGroupFlow_MultiFlow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_BottomButtons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_BottomButtons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_BottomButtons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ComponentBase_AppBase__ = __webpack_require__(33);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FetchDrugGroup',
  extends: __WEBPACK_IMPORTED_MODULE_5__ComponentBase_AppBase__["a" /* default */],
  components: {
    progressBar: __WEBPACK_IMPORTED_MODULE_1__flowComp_ProgressBar___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_2__common_Loader___default.a,
    MultiFlow: __WEBPACK_IMPORTED_MODULE_3__FetchDrugGroupFlow_MultiFlow___default.a,
    BottomButtons: __WEBPACK_IMPORTED_MODULE_4__common_BottomButtons___default.a
  },
  data: function data() {
    return {
      group: [],
      getMedGroup: false,
      currentGroupIndex: 0,
      stage: 'medGroupList',
      scheduleId: null
    };
  },
  created: function created() {
    this.stage = 'medGroupList';
    this.progress = this.setupProgress();
    this.multiProgress = this.setupMultiProgress();
    this.confirmProgress = this.setupConfirmProgress();
    this.actionProgress = this.setupActionProgress();
    this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
    this.getGroup();
  },

  computed: {
    DrugsForFetchList: function DrugsForFetchList() {
      return this.$store.state.drug.DrugsForFetchList;
    }
  },
  methods: {
    setupProgress: function setupProgress() {
      var p = [];
      p.push({ en: 'selectDrug', zh: '選擇藥物' });
      if (this.$store.state.schedule.currentSchedule === null) {
        p.push({ en: 'medIdInput', zh: '輸入病歷號' });
      }
      //20190422 add 覆核動作
      if (this.$store.state.user.user.task_privilege.fetch_drug === false) {
        p.push({ en: 'rxCheck', zh: '覆核動作' });
      }
      if (this.$store.state.generalSetting.check_amount_first) {
        p.push({ en: 'confirmAmount', zh: '確認數量' });
      }
      p.push({ en: 'action', zh: '進行取藥' });
      return p;
    },
    setupMultiProgress: function setupMultiProgress() {
      var p = [];
      if (this.$store.state.schedule.currentSchedule === null) {
        p.push('medIdInput');
      }
      p.push('confirm');
      p.push('finish');
      return p;
    },
    setupConfirmProgress: function setupConfirmProgress() {
      //20190422 modified
      /*
      return [
        'start',
        'action',
      ];
      */
      var prog = [];
      prog.push('start');
      if (this.$store.state.user.user.task_privilege.fetch_drug === false) {
        prog.push('rxCheck');
      }
      prog.push('action');
      return prog;
    },
    setupActionProgress: function setupActionProgress() {
      var prog = [];
      if (this.$store.state.generalSetting.check_amount_first) {
        prog.push('confirmAmount');
      }
      prog.push('action');
      prog.push('next');
      return prog;
    },
    getGroup: function getGroup() {
      var _this = this;

      this.instance.get('/api/medication-group/').then(function (res) {
        res.data.forEach(function (group) {
          group.medicine_set.forEach(function (item) {
            item.selected = false;
            item.drugInDevice = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(_this.$store.getters.drugInDeviceList, function (drugStorage) {
              return drugStorage.medication.id === item.id && drugStorage.stock > 0;
            });
            item.amountInSystem = 0;
            item.drugInDevice.forEach(function (d) {
              item.amountInSystem += d.stock;
            });
          });
        });
        _this.group = res.data;
        _this.getMedGroup = true;
      });
    },
    selectMed: function selectMed(index) {
      var med = this.group[this.currentGroupIndex].medicine_set[index];
      med.selected = !med.selected;
      var payload = {
        med: med,
        drugStorage: med.drugInDevice,
        amount: 1,
        select: med.selected
      };
      this.$store.dispatch('setDrugListForFetch', payload);
    },
    cancel: function cancel() {
      this.$router.push({ name: 'Main' });
    },
    startFlow: function startFlow() {
      for (var i = 0; i < this.$store.state.drug.DrugsForFetchList.length; i += 1) {
        var fetchItem = this.$store.state.drug.DrugsForFetchList[i];
        if (fetchItem.med.restrained_class > 0) {
          this.$store.dispatch('printQR', fetchItem);
        }
      }
      this.stage = 'startFlow';
    },
    getAllConfirmData: function getAllConfirmData() {
      // refetch data
      this.$store.dispatch('resetAll');
      //20190411 add by aaron
      this.$store.dispatch('getDrugInDevices');
      this.stage = 'ScheduleList';
      this.$router.push({ name: 'schedule' });
    }
  }
});

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flowComp_Action__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flowComp_Action___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__flowComp_Action__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__flowComp_ActionBreak__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__flowComp_ActionBreak___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__flowComp_ActionBreak__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__flowComp_ScanBarcode__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__flowComp_ScanBarcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__flowComp_ScanBarcode__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FetchActionWrap',
  props: {
    amount: Number,
    barcodeData: Object,
    medRecordId: String,
    // scheduleId: Number,
    actionProgress: Array,
    startActionType: String,
    reviewer: Object
  },
  components: {
    Action: __WEBPACK_IMPORTED_MODULE_6__flowComp_Action___default.a,
    ActionBreak: __WEBPACK_IMPORTED_MODULE_7__flowComp_ActionBreak___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_8__common_Loader___default.a,
    ScanBarcode: __WEBPACK_IMPORTED_MODULE_9__flowComp_ScanBarcode___default.a
  },
  computed: {
    currentDrugInDevice: function currentDrugInDevice() {
      return this.$store.state.drugInDevice.currentDrugInDevice;
    },
    drugStorageWithSameDrug: function drugStorageWithSameDrug() {
      return this.$store.state.drugInDevice.DrugStorageWithSameDrug;
    },
    instance: function instance() {
      return this.$store.state.instance;
    },
    fetchReadOnly: function fetchReadOnly() {
      if (this.barcodeData !== undefined && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.barcodeData).length > 0) return true;
      return false;
    }
  },
  data: function data() {
    return {
      stage: '',
      totalAmount: 0, // already fetched
      drugStorageInQueue: [], // device queue with same drug
      drugStorageList: [],
      theDrugStorage: {},
      theDrugStorageIndex: 0,
      actionData: [],
      forAction: {
        defaultNum: 0,
        checkNum: 0,
        deviceId: 0
      },
      residual: 0,
      getEmitTimes: 0,
      progressIndex: 0,
      scheduleId: undefined,
      oriNextDrugStorageId: undefined
    };
  },
  destroyed: function destroyed() {
    console.log('類別取藥 ActionWrap destroyed');
    this.totalAmount = 0;
    this.drugStorageInQueue = {};
    this.drugStorageInQueueId = [];
    this.theDrugStorage = {};
    this.theDrugStorageIndex = 0;
    this.forAction = {
      defaultNum: 0,
      checkNum: 0,
      deviceId: 0
    };
    this.getEmitTimes = 0;
    this.$store.commit('SET_APP_CANCEL_STATUS', true);
  },
  created: function created() {
    this.$store.commit('SET_APP_CANCEL_STATUS', false);
    // console.log(this.forAction);
    // prepare for the first Action child. remove the first one(user selected one), then set the remains into state.
    this.drugStorageInQueue = this.drugStorageWithSameDrug;
    console.log(this.drugStorageWithSameDrug);

    // this.$store.commit('SET_CONFIRM_STAGE', 'confirmAmount');
    this.moveCurrentStorageToHead(this.currentDrugInDevice.id);
    this.residual = this.amount;
    this.theDrugStorage = this.drugStorageList[this.theDrugStorageIndex];
    this.$store.commit('SET_CURRENT_DRUG_IN_DEVICE', this.theDrugStorage.id);
    // prepare forAction data
    if (this.actionProgress[0] === 'confirmAmount') {
      this.forAction = {
        defaultNum: this.theDrugStorage.stock,
        checkNum: this.theDrugStorage.max_stock,
        deviceId: this.theDrugStorage.device.id
      };
      this.$store.commit('SET_CURRENT_STEP', 'confirmAmount');
    }
    if (this.actionProgress[0] === 'action') {
      this.forAction = {
        defaultNum: this.amount,
        checkNum: this.theDrugStorage.stock,
        deviceId: this.theDrugStorage.device.id
      };
      this.$store.commit('SET_CURRENT_STEP', 'action');
    }
    this.stage = this.actionProgress[0]; // well, it seems that the new refaction could not fit actionWrap flow.
  },

  methods: {
    confirmAmountFinish: function confirmAmountFinish() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var nextDrugStorage, tmpNextDrugStorage;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('drugstorage', _this.theDrugStorage);
                _context.next = 3;
                return _this.$store.dispatch('updateCurrentDrugInDevice', _this.theDrugStorage.id);

              case 3:
                // notice: the stock of drugStorage might change here.
                _this.theDrugStorage = _this.$store.state.drugInDevice.allDrugInDevice[_this.theDrugStorage.id];
                //
                _this.forAction = {
                  defaultNum: _this.amount - _this.totalAmount, // the resident number for child.
                  //checkNum: this.theDrugStorage.stock > this.residual ? this.residual : this.theDrugStorage.stock,
                  checkNum: _this.theDrugStorage.stock,
                  deviceId: _this.theDrugStorage.device.id
                };
                //amount表示要取的數量
                //totalAmount表示已經取的數量
                //residual表示剩餘要取的數量
                //theDrugStorage.stock表示庫存量

                _this.stage = 'next';
                // 如果確認之後為0 就跳過該藥盒
                if (_this.currentDrugInDevice.stock === 0) {
                  if (_this.theDrugStorageIndex + 1 < _this.drugStorageList.length) {
                    _this.theDrugStorageIndex += 1;
                    _this.residual = _this.amount - _this.totalAmount;
                    _this.theDrugStorage = _this.drugStorageList[_this.theDrugStorageIndex];
                    _this.forAction = {
                      defaultNum: _this.amount - _this.totalAmount, // the resident number for child.
                      checkNum: _this.theDrugStorage.stock > _this.residual ? _this.residual : _this.theDrugStorage.stock,
                      deviceId: _this.theDrugStorage.device.id
                    };
                    // set next DrugStorage
                    nextDrugStorage = _this.drugStorageList[_this.theDrugStorageIndex];

                    _this.$store.commit('SET_NEXT_DEVICE', nextDrugStorage.device.id);
                    _this.$store.commit('SET_NEXT_DRUG_IN_DEVICE', nextDrugStorage.id);
                    _this.stage = 'break';
                  } else {
                    if (_this.amount - _this.totalAmount > 0) {
                      _this.$store.commit('SET_MESSAGE', {
                        type: 'warn',
                        context: '\u5C1A\u6709' + (_this.amount - _this.totalAmount) + '\u672A\u62FF\uFF0C\u8ACB\u81EA\u884C\u81F3\u5916\u90E8\u85E5\u76D2\u62FF\u53D6\u3002',
                        keepOnTop: true
                      });
                    }
                    //20190426 add
                    console.log('store.state.drugInDevice.currentDrugInDevice:', _this.$store.state.drugInDevice.currentDrugInDevice);
                    console.log('store.state.drugInDevice.nextDrugInDevice:', _this.$store.state.drugInDevice.nextDrugInDevice);
                    if (_this.$store.state.drugInDevice.nextDrugInDevice) {
                      console.log('store.state.drugInDevice.currentDrugInDevice.id:', _this.$store.state.drugInDevice.currentDrugInDevice.id);
                      console.log('store.state.drugInDevice.nextDrugInDevice.id:', _this.$store.state.drugInDevice.nextDrugInDevice.id);
                      //console.log(this.$store.state.drugInDevice);
                      _this.resetNextDrugInDevice();
                      //沒有下個藥要取
                      if (_this.$store.state.drugInDevice.sortedSelectedDrugInDeviceIndex >= _this.$store.state.drugInDevice.sortedSelectedDrugInDevice.length - 1) {
                        console.log('remove:case a');
                        _this.$store.commit('REMOVE_NEXT_DRUG_IN_DEVICE');
                        _this.$store.commit('REMOVE_NEXT_DEVICE');
                      } else //還有下個藥可取
                        {
                          if (_this.$store.state.drugInDevice.currentDrugInDevice.id === _this.$store.state.drugInDevice.nextDrugInDevice.id) {
                            //去撈下個排序的藥的id並設為next device
                            tmpNextDrugStorage = _this.$store.state.drugInDevice.sortedSelectedDrugInDevice[_this.$store.state.drugInDevice.sortedSelectedDrugInDeviceIndex + 1];

                            console.log(tmpNextDrugStorage);
                            if (tmpNextDrugStorage) {
                              console.log('tmpNextDrugStorage.device.id:', tmpNextDrugStorage.device.id);
                              _this.$store.commit('SET_NEXT_DEVICE', tmpNextDrugStorage.device.id);
                              _this.$store.commit('SET_NEXT_DRUG_IN_DEVICE', tmpNextDrugStorage.id);
                            } else {
                              console.log('remove:case b');
                              _this.$store.commit('REMOVE_NEXT_DRUG_IN_DEVICE');
                              _this.$store.commit('REMOVE_NEXT_DEVICE');
                            }
                          }
                        }
                    } else {
                      console.log('remove:case c');
                      _this.$store.commit('REMOVE_NEXT_DRUG_IN_DEVICE');
                      _this.$store.commit('REMOVE_NEXT_DEVICE');
                    }
                    setTimeout(function () {
                      _this.$emit('setActionData');
                    }, 1000);
                  }
                } else {
                  // notice: the stock of drugStorage might change here.
                  _this.theDrugStorage = _this.$store.state.drugInDevice.allDrugInDevice[_this.theDrugStorage.id];
                  //
                  _this.forAction = {
                    defaultNum: _this.amount - _this.totalAmount, // the resident number for child.
                    //checkNum: this.theDrugStorage.stock > this.residual ? this.residual : this.theDrugStorage.stock,
                    checkNum: _this.theDrugStorage.stock,
                    deviceId: _this.theDrugStorage.device.id
                  };
                  setTimeout(function () {
                    _this.stage = 'action';
                    _this.$store.commit('SET_CURRENT_STEP', 'action');
                  }, 200);
                  _this.getTotalSumInstanly(_this.amount - _this.totalAmount);
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    moveCurrentStorageToHead: function moveCurrentStorageToHead(drugStorageId) {
      var current = this.drugStorageInQueue[drugStorageId];
      delete this.drugStorageInQueue[drugStorageId];
      this.drugStorageList = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.drugStorageInQueue);
      this.drugStorageList = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.orderBy(this.drugStorageList, function (o) {
        return __WEBPACK_IMPORTED_MODULE_4_moment___default()(o.expired_date);
      });
      this.drugStorageList.unshift(current); // insert the current one to the head.
      // this.$store.commit('SET_SELECTED_DRUG_IN_DEVICE_DIRECTLY', this.drugStorageList);
    },
    saveData: function saveData(data) {
      var _this2 = this;

      console.log(data);
      var currentDrugStorage = this.theDrugStorage;
      if (this.currentDrugInDevice.stock - data.num < 0) {
        throw new Error('the saving stock should not be miuns');
      } else {
        var remainPc = currentDrugStorage.stock - currentDrugStorage.medication.pack_content * currentDrugStorage.pack_count;
        var remainPackCount = currentDrugStorage.pack_count;
        if (remainPackCount !== 0) {
          remainPackCount = currentDrugStorage.pack_count - Math.ceil((data.num - remainPc) / currentDrugStorage.medication.pack_content);
        }
        console.log(remainPackCount);
        if (this.$store.state.schedule.currentSchedule) {
          this.scheduleId = this.$store.state.schedule.currentSchedule.id;
        }

        var medRecrodNumber = null;
        if (this.medRecordId !== undefined) {
          medRecrodNumber = this.medRecordId;
        } else if (this.barcodeData !== undefined) {
          medRecrodNumber = this.barcodeData.medRecordId;
        } else if (this.$store.state.schedule.currentSchedule !== undefined) {
          medRecrodNumber = this.$store.state.schedule.currentSchedule.patient.med_record_number;
        } else {
          medRecrodNumber = null;
        }
        // console.log(this.medRecordId, this.barcodeData, this.$store.state.schedule.currentSchedule, medRecrodNumber);

        // becareful that other components used this comp.
        var eventType = 'FETCH';
        if (this.startActionType === 'FETCH_TRANSFER') {
          eventType = 'FETCH_TRANSFER';
        }

        var sentData = {
          id: currentDrugStorage.id,
          device: data.device,
          stock: currentDrugStorage.stock - data.num, // only update here.
          max_stock: currentDrugStorage.max_stock,
          expired_date: currentDrugStorage.expired_date,
          patch_number: currentDrugStorage.patch_number,
          medication: currentDrugStorage.medication.id,
          med_record_no: medRecrodNumber,
          number1: -data.num,
          number2: this.scheduleId,
          pack_count: remainPackCount,
          type: eventType,
          review_employee: this.reviewer === undefined ? undefined : this.reviewer.id
        };
        console.log(sentData);

        if (data.emptyCount > 0) {
          sentData.empty_count = currentDrugStorage.empty_count + data.emptyCount;
        }

        this.stage = 'next';
        return this.instance.put('/api/drug-storage/' + sentData.id + '/', sentData).then(function (drugStorageActionRes) {
          // update the amount after saving
          _this2.$store.dispatch('getTotalDrugAmountInstanly', currentDrugStorage.medication.id);

          // record Return Empty if neeed
          if (data.emptyCount > 0) {
            _this2.$store.dispatch('recordAction', { eventType: 'RETURN_EMPTY', number1: data.emptyCount }).then(function () {
              var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(eventActionRes) {
                var event;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        event = {
                          id: drugStorageActionRes.data,
                          checked: true,
                          related_events: [eventActionRes.data]
                        };
                        _context2.next = 3;
                        return _this2.instance.patch('/api/event/' + event.id + '/', event);

                      case 3:
                      case 'end':
                        return _context2.stop();
                    }
                  }
                }, _callee2, _this2);
              }));

              return function (_x) {
                return _ref.apply(this, arguments);
              };
            }());
          }
          if (_this2.$store.state.generalSetting.mode === 'nursing') {
            console.log('send to his');
            console.log('dose value:', _this2.$store.state.drug.doseForHisOutput);
            // send fetch record back to CGMH HIS
            _this2.$store.dispatch('returnFetchDataToCGMHHIS', {
              medication: currentDrugStorage.medication.code,
              //dose: 'xxx',
              //20190403 modified
              //dose: this.$store.state.drug.doseForHisOutput,
              dose: data.num, //類別取藥沒有劑量,故用數量代替
              qty: data.num,
              //rx_user: this.reviewer.id === undefined ? this.$store.state.user.user.username : this.reviewer.username,
              //20190403 modified
              rx_user: _this2.reviewer === undefined ? _this2.$store.state.user.user.username : _this2.reviewer.username
            });
          }
          console.log('set drug storage.');
        }).catch(function (res) {
          console.log('fetch drug error');
        });
      }
    },
    goOn: function goOn() {
      var defaultNumCalc = 0;
      var checkNumCalc = 0;
      if (this.actionProgress[0] === 'confirmAmount') {
        defaultNumCalc = this.theDrugStorage.stock;
        checkNumCalc = this.theDrugStorage.max_stock;
      }
      if (this.actionProgress[0] === 'action') {
        defaultNumCalc = this.residual;
        checkNumCalc = this.theDrugStorage.stock > this.residual ? this.residual : this.theDrugStorage.stock;
      }

      this.forAction = {
        defaultNum: defaultNumCalc, // the resident number for child.
        checkNum: checkNumCalc,
        deviceId: this.theDrugStorage.device.id
      };
      this.$store.commit('SET_CURRENT_DRUG_IN_DEVICE', this.theDrugStorage.id);
      this.stage = this.actionProgress[0]; // TODO: remove it here.
      this.getEmitTimes = 0;
      this.resetNextDrugInDevice();
    },
    resetNextDrugInDevice: function resetNextDrugInDevice() {
      // reset drugStorage id if it has been changed previous.
      console.log('resetNextDrugInDevice');
      if (this.$store.state.drugInDevice.nextDrugInDevice) {
        // save the drugStorage id temporaliy.
        this.oriNextDrugStorageId = this.$store.state.drugInDevice.nextDrugInDevice.id;
      }
      console.log('this.oriNextDrugStorageId:', this.oriNextDrugStorageId);
      if (this.oriNextDrugStorageId) {
        this.$store.commit('SET_NEXT_DEVICE', this.$store.state.drugInDevice.allDrugInDevice[this.oriNextDrugStorageId].device.id);
        this.$store.commit('SET_NEXT_DRUG_IN_DEVICE', this.oriNextDrugStorageId);
      }
    },
    getTotalSumInstanly: function getTotalSumInstanly(val) {
      console.log('get total amount instanly', val, this.residual);
      console.log('theDrugStorageIndex:', this.theDrugStorageIndex);
      console.log('drugStorageList.length:', this.drugStorageList.length);
      // check fetch amount from current drugStorage is enough or not
      if (val < this.residual) {
        //20190429 modified
        //if (this.theDrugStorageIndex + 1 <= this.drugStorageList.length) {
        if (this.theDrugStorageIndex + 1 < this.drugStorageList.length) {
          var nextDrugStorage = this.drugStorageList[this.theDrugStorageIndex + 1];
          if (this.$store.state.drugInDevice.nextDrugInDevice) {
            // save the drugStorage id temporaliy.
            this.oriNextDrugStorageId = this.$store.state.drugInDevice.nextDrugInDevice.id;
          }
          console.log('nextDrugStorage.device.id:', nextDrugStorage.device.id);
          this.$store.commit('SET_NEXT_DEVICE', nextDrugStorage.device.id);
          this.$store.commit('SET_NEXT_DRUG_IN_DEVICE', nextDrugStorage.id);
        } else {
          console.log('no enough amount for fetching.');
        }
      } else {
        this.resetNextDrugInDevice();
        console.log('sortedSelectedDrugInDeviceIndex:', this.$store.state.drugInDevice.sortedSelectedDrugInDeviceIndex);
        console.log('sortedSelectedDrugInDevice.length:', this.$store.state.drugInDevice.sortedSelectedDrugInDevice.length);
        console.log('store.state.drugInDevice.currentDrugInDevice.id:', this.$store.state.drugInDevice.currentDrugInDevice.id);
        if (this.$store.state.drugInDevice.nextDrugInDevice) {
          console.log('store.state.drugInDevice.nextDrugInDevice.id:', this.$store.state.drugInDevice.nextDrugInDevice.id);
        }
        if (this.$store.state.drugInDevice.sortedSelectedDrugInDeviceIndex >= this.$store.state.drugInDevice.sortedSelectedDrugInDevice.length - 1) {
          console.log('remove:case aa');
          this.$store.commit('REMOVE_NEXT_DRUG_IN_DEVICE');
          this.$store.commit('REMOVE_NEXT_DEVICE');
        } else //還有下個藥可取
          {
            if (this.$store.state.drugInDevice.nextDrugInDevice) {
              if (this.$store.state.drugInDevice.currentDrugInDevice.id === this.$store.state.drugInDevice.nextDrugInDevice.id) {
                //去撈下個排序的藥的id並設為next device
                var tmp2NextDrugStorage = this.$store.state.drugInDevice.sortedSelectedDrugInDevice[this.$store.state.drugInDevice.sortedSelectedDrugInDeviceIndex + 1];
                console.log(tmp2NextDrugStorage);
                if (tmp2NextDrugStorage) {
                  console.log('tmp2NextDrugStorage.device.id:', tmp2NextDrugStorage.device.id);
                  this.$store.commit('SET_NEXT_DEVICE', tmp2NextDrugStorage.device.id);
                  this.$store.commit('SET_NEXT_DRUG_IN_DEVICE', tmp2NextDrugStorage.id);
                } else {
                  console.log('remove:case bb');
                  this.$store.commit('REMOVE_NEXT_DRUG_IN_DEVICE');
                  this.$store.commit('REMOVE_NEXT_DEVICE');
                }
              }
            }
          }
      }
    },
    getThisAmount: function getThisAmount(data) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.getEmitTimes += 1; // prevent over emitting

                if (!(_this3.getEmitTimes === 1)) {
                  _context3.next = 8;
                  break;
                }

                console.log('hello actionwrap');
                // this.stage = 'next';
                // data: device, num
                _this3.totalAmount += data.num;
                _context3.next = 6;
                return _this3.saveData(data);

              case 6:

                // record Return Empty if neeed
                // if (data.emptyCount > 0) {
                //   await this.$store.dispatch('recordAction', { eventType: 'RETURN_EMPTY', number1: data.emptyCount });
                // }

                // increment the index
                _this3.theDrugStorageIndex += 1;
                // await this.$store.dispatch('getTotalDrugAmountInstanly', this.$store.state.drug.selectedDrugID);
                if (_this3.totalAmount < _this3.amount) {
                  if (_this3.theDrugStorageIndex < _this3.drugStorageList.length) {
                    _this3.residual = _this3.amount - _this3.totalAmount;
                    _this3.theDrugStorage = _this3.drugStorageList[_this3.theDrugStorageIndex];
                    _this3.stage = 'break';
                  } else {
                    _this3.$store.commit('SET_MESSAGE', {
                      type: 'warn',
                      context: '\u5C1A\u6709' + (_this3.amount - _this3.totalAmount) + '\u672A\u62FF\uFF0C\u8ACB\u81EA\u884C\u81F3\u5916\u90E8\u85E5\u76D2\u62FF\u53D6\u3002',
                      keepOnTop: true
                    });
                    // TODO: here is not emit yet. thus the action will stop at here.
                    // make fetch drug in outside drug box is recorded.
                    _this3.getEmitTimes = 0;
                    setTimeout(function () {
                      _this3.$emit('setActionData');
                    }, 1000);
                  }
                } else {
                  console.log('finished');
                  // this.resetNextDrugInDevice();
                  _this3.$emit('setActionData');
                }

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  }
});

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ComponentBase_ConfirmFlowBase__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ActionWrap__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ActionWrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ActionWrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flowComp_RxCheckBarcode__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flowComp_RxCheckBarcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__flowComp_RxCheckBarcode__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ConfirmFlow',
  extends: __WEBPACK_IMPORTED_MODULE_0__ComponentBase_ConfirmFlowBase__["a" /* default */],
  props: ['confirmProgress', 'medRecordId'],
  data: function data() {
    return {
      reviewer: undefined
    };
  },

  components: {
    ActionWrap: __WEBPACK_IMPORTED_MODULE_1__ActionWrap___default.a,
    RxCheckBarcode: __WEBPACK_IMPORTED_MODULE_2__flowComp_RxCheckBarcode___default.a
  },
  created: function created() {
    this.$store.dispatch('getDrugInDevicesWithSameDrug', this.currentDrug.med.id);
  },
  mounted: function mounted() {
    console.log('mounted');
    this.nextProgress();
  },

  computed: {},
  methods: {
    getFetchData: function getFetchData(data) {
      //this.resetProgress();
      //console.log('get from actionwrap');
      this.$emit('confirmationFinish');
      // gave time for component unmount
      //setTimeout(() => {
      //  this.nextProgress();
      //}, 100);
    },
    confirmRx: function confirmRx(reviewer) {
      this.reviewer = reviewer;
      this.nextProgress();
    }
  }
});

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ComponentBase_MultiFlowBase__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_DrugInfo__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_DrugInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__flowComp_DrugInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flowComp_TextInput__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flowComp_TextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__flowComp_TextInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConfirmFlow__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConfirmFlow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ConfirmFlow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__common_Loader__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'multiflow',
  extends: __WEBPACK_IMPORTED_MODULE_2__ComponentBase_MultiFlowBase__["a" /* default */],
  data: function data() {
    return {
      stage: 'start',
      medRecordId: '',
      checkFun: undefined
    };
  },

  components: {
    DrugInfo: __WEBPACK_IMPORTED_MODULE_3__flowComp_DrugInfo___default.a,
    ConfirmFlow: __WEBPACK_IMPORTED_MODULE_5__ConfirmFlow___default.a,
    MedIdInput: __WEBPACK_IMPORTED_MODULE_4__flowComp_TextInput___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_6__common_Loader___default.a
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.$store.state.schedule.currentSchedule !== null) {
                _this.medRecordId = _this.$store.state.schedule.currentSchedule.patient.med_record_number;
              }
              _context.next = 3;
              return _this.$store.dispatch('fromFirstDrug');

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {},
  methods: {
    getMedId: function getMedId(data) {
      if (data === '' || data === undefined) {
        this.$store.commit('SET_MESSAGE', { type: 'error', context: '病歷號不可以為空' });
      } else {
        this.medRecordId = data;
        this.nextProgress();
      }
    },
    getConfirmData: function getConfirmData() {
      var _this2 = this;

      //20190411 add by aaron
      console.log('get confirm data');
      this.nextProgress();
      //////////////////
      this.checkFun = setInterval(function () {
        _this2.checkDevicesCloseAndEmit();
      }, 500);
    },
    nextStep: function nextStep() {
      //this.nextProgress(); //20190411 marked by aaron
      //console.log('get confirm data');
      if (this.nextDrug === null) {
        this.$emit('setAllConfirmData');
      } else {
        this.$store.dispatch('toNextDrug');
        this.resetProgress();
      }
    },

    //20190412 modified by aaron
    checkDevicesCloseAndEmit: function checkDevicesCloseAndEmit() {
      if (this.nextDevice) {
        if (this.nextDevice.net.id === this.currentDevice.net.id && this.errorDevices.length > 1) {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            confirm: false,
            context: '請先關閉所有藥盒'
          });
        } else if (this.nextDevice.net.id !== this.currentDevice.net.id && this.errorDevices.length > 0) {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            confirm: false,
            context: '請先關閉所有藥盒及抽屜'
          });
        } else {
          this.$store.commit('CLOSE_MESSAGE');
          if (this.checkFun) {
            clearInterval(this.checkFun);
          }
          this.nextStep();
        }
      } else {
        /*
        this.$store.commit('CLOSE_MESSAGE');
        if (this.checkFun) {
          clearInterval(this.checkFun);
        }
        this.nextStep();
        */
        if (this.errorDevices.length > 0) {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            confirm: false,
            context: '請先關閉所有藥盒及抽屜'
          });
        } else {
          this.$store.commit('CLOSE_MESSAGE');
          if (this.checkFun) {
            clearInterval(this.checkFun);
          }
          this.nextStep();
        }
      }
    }
  }
});

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_free_solid_svg_icons__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FetchDrugScheduleFlow_MultiFlow__ = __webpack_require__(1290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FetchDrugScheduleFlow_MultiFlow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__FetchDrugScheduleFlow_MultiFlow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flowComp_ProgressBar__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flowComp_ProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__flowComp_ProgressBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_BottomButtons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_BottomButtons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__common_BottomButtons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ComponentBase_AppBase__ = __webpack_require__(33);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FetchDrugSchedule',
  extends: __WEBPACK_IMPORTED_MODULE_9__ComponentBase_AppBase__["a" /* default */],
  components: {
    progressBar: __WEBPACK_IMPORTED_MODULE_6__flowComp_ProgressBar___default.a,
    MultiFlow: __WEBPACK_IMPORTED_MODULE_5__FetchDrugScheduleFlow_MultiFlow___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_7__common_Loader___default.a,
    BottomButtons: __WEBPACK_IMPORTED_MODULE_8__common_BottomButtons___default.a
  },
  data: function data() {
    return {
      summarySelectedMed: {},
      schedules: [],
      viewMethod: '',
      faPills: __WEBPACK_IMPORTED_MODULE_4__fortawesome_free_solid_svg_icons__["e" /* faPills */],
      faCircle: __WEBPACK_IMPORTED_MODULE_4__fortawesome_free_solid_svg_icons__["d" /* faCircle */]
    };
  },

  computed: {
    schedulesByDrug: function schedulesByDrug() {
      var byDrug = {};
      this.schedules.forEach(function (item) {
        if (byDrug[item.medication.id] === undefined) {
          byDrug[item.medication.id] = {};
          byDrug[item.medication.id].medication = item.medication;
          byDrug[item.medication.id].listSet = [];
        }
        byDrug[item.medication.id].listSet.push(item);
      });
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(byDrug).forEach(function (item) {
        item.selected = false;
        item.amountInSystem = item.listSet[0].amountInSystem;
        for (var i = 0; i < item.listSet.length; i += 1) {
          var theList = item.listSet[i];
          if (theList.selected) {
            item.selected = true;
            break;
          }
        }
      });
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(byDrug);
    }
  },
  created: function created() {
    this.stage = 'selectDrug';
    this.viewMethod = 'drugCategory';
    this.progress = this.setupProgress();
    this.multiProgress = this.setupMultiProgress();
    this.confirmProgress = this.setupConfirmProgress();
    this.actionProgress = this.setupActionWrapProgress();
  },
  mounted: function mounted() {
    this.schedules = [];
    this.getScheduleData('/api/fetch-schedule/');
  },

  methods: {
    setupProgress: function setupProgress() {
      var p = [];
      p.push({ en: 'selectDrug', zh: '選擇藥物' });
      //20190422 add 覆核動作
      if (this.$store.state.user.user.task_privilege.fetch_drug === false) {
        p.push({ en: 'rxCheck', zh: '覆核動作' });
      }
      if (this.$store.state.generalSetting.check_amount_first) {
        p.push({ en: 'confirmAmount', zh: '確認數量' });
      }
      p.push({ en: 'action', zh: '進行取藥' });
      return p;
    },
    setupMultiProgress: function setupMultiProgress() {
      return ['confirm', 'finish'];
    },
    setupConfirmProgress: function setupConfirmProgress() {
      //20190422 modified
      /*
      return [
        'actionWrap',
      ];
      */
      var prog = [];
      if (this.$store.state.user.user.task_privilege.fetch_drug === false) {
        prog.push('rxCheck');
      }
      prog.push('actionWrap');
      return prog;
    },
    setupActionWrapProgress: function setupActionWrapProgress() {
      var prog = [];
      if (this.$store.state.generalSetting.check_amount_first) {
        prog.push('confirmAmount');
      }
      prog.push('action');
      prog.push('next');
      return prog;
    },
    getScheduleData: function getScheduleData(url) {
      var _this = this;

      this.stage = 'loading';
      return this.instance.get(url).then(function (res) {
        res.data.results.forEach(function (item) {
          item.selected = false;
          item.drugInDevice = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(_this.$store.getters.drugInDeviceList, function (drugStorage) {
            return drugStorage.medication.id === item.medication.id && drugStorage.stock > 0;
          });
          item.amountInSystem = 0;
          item.drugInDevice.forEach(function (d) {
            item.amountInSystem += d.stock;
          });
          _this.schedules.push(item);
        });
        if (res.data.next_page_url !== null) {
          var _url = res.data.next_page_url.substr(res.data.next_page_url.indexOf('/', 7));
          _this.getScheduleData(_url);
        }
        _this.stage = 'selectDrug';
      });
    },
    selectMed: function selectMed(index, selected) {
      var schedule = this.schedules[index];
      if (selected !== undefined) {
        schedule.selected = selected;
      } else {
        schedule.selected = !schedule.selected;
      }
      // add if selected
      if (schedule.selected) {
        if (this.summarySelectedMed[schedule.medication.id] === undefined) {
          this.summarySelectedMed[schedule.medication.id] = {
            med: schedule.medication, drugStorage: schedule.drugInDevice, amount: 0, select: schedule.selected, schedules: []
          };
        }
        this.summarySelectedMed[schedule.medication.id].amount += schedule.amount;
        this.summarySelectedMed[schedule.medication.id].schedules.push(schedule.id);
      } else {
        this.summarySelectedMed[schedule.medication.id].amount -= schedule.amount;
        var removeScheduleInd = this.summarySelectedMed[schedule.medication.id].schedules.findIndex(function (element) {
          return element === schedule.id;
        });
        if (removeScheduleInd) {
          this.summarySelectedMed[schedule.medication.id].schedules.splice(removeScheduleInd, 1);
        }
        // delete the item if amount is zero.
        if (this.summarySelectedMed[schedule.medication.id].amount === 0) {
          delete this.summarySelectedMed[schedule.medication.id];
        }
      }
    },
    cancel: function cancel() {
      this.$store.dispatch('recordAction', { eventType: 'CANCEL_FETCH' });
      this.$router.push({ name: 'Main' });
    },
    startFlow: function startFlow() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(this.summarySelectedMed).forEach(function (item) {
        _this2.$store.dispatch('setDrugListForFetch', item);
      });
      this.stage = 'startFlow';
    },
    getAllConfirmData: function getAllConfirmData() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this3.stage = 'loading';
                _this3.summarySelectedMed = {}; // reset variable
                _this3.schedules = [];
                // refetch data
                _this3.$store.dispatch('resetAll');
                _context.next = 6;
                return _this3.$store.dispatch('getDrugInDevices');

              case 6:
                _context.next = 8;
                return _this3.getScheduleData('/api/fetch-schedule/');

              case 8:
                _this3.stage = 'selectDrug';
                _this3.$store.commit('SET_CURRENT_STEP', 'selectDrug');

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    selectAll: function selectAll() {
      this.summarySelectedMed = {};
      for (var i = 0; i < this.schedules.length; i += 1) {
        if (this.schedules[i].amountInSystem > 0) this.selectMed(i, true);
      }
    },
    deselectAll: function deselectAll() {
      for (var i = 0; i < this.schedules.length; i += 1) {
        if (this.schedules[i].amountInSystem > 0) this.selectMed(i, false);
      }
    },
    selectScheduleByDrug: function selectScheduleByDrug(drugItem) {
      var _this4 = this;

      drugItem.listSet.forEach(function (item) {
        var index = _this4.schedules.findIndex(function (o) {
          return o.id === item.id;
        });
        _this4.selectMed(index, !drugItem.selected);
      });
    }
  },
  filters: {
    zhFetched: function zhFetched(val) {
      if (val) return '已取藥';
      return '未取藥';
    }
  }
});

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__flowComp_Action__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__flowComp_Action___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__flowComp_Action__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__flowComp_ActionBreak__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__flowComp_ActionBreak___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__flowComp_ActionBreak__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__common_Loader__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FetchActionWrap',
  props: {
    amount: Number,
    barcodeData: Object,
    medRecordId: String,
    // scheduleId: Number,
    actionProgress: Array,
    startActionType: String,
    schedules: Array,
    summarySelectedMed: Object,
    reviewer: Object
  },
  components: {
    Action: __WEBPACK_IMPORTED_MODULE_8__flowComp_Action___default.a,
    ActionBreak: __WEBPACK_IMPORTED_MODULE_9__flowComp_ActionBreak___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_10__common_Loader___default.a
  },
  computed: {
    currentDrugInDevice: function currentDrugInDevice() {
      return this.$store.state.drugInDevice.currentDrugInDevice;
    },
    drugStorageWithSameDrug: function drugStorageWithSameDrug() {
      return this.$store.state.drugInDevice.DrugStorageWithSameDrug;
    },
    instance: function instance() {
      return this.$store.state.instance;
    },
    fetchReadOnly: function fetchReadOnly() {
      if (this.barcodeData !== undefined && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.barcodeData).length > 0) return true;
      return false;
    },
    currentDrug: function currentDrug() {
      return this.$store.getters.currentDrug;
    }
  },
  data: function data() {
    return {
      stage: '',
      totalAmount: 0, // already fetched
      drugStorageInQueue: [], // device queue with same drug
      drugStorageList: [],
      theDrugStorage: {},
      theDrugStorageIndex: 0,
      actionData: [],
      forAction: {
        defaultNum: 0,
        checkNum: 0,
        deviceId: 0
      },
      residual: 0,
      getEmitTimes: 0,
      progressIndex: 0,
      scheduleId: undefined,
      saveDatas: [],
      oriNextDrugStorageId: undefined,
      saveProgress: 0,
      saveTaskCount: 0
    };
  },
  destroyed: function destroyed() {
    console.log('批次取藥 ActionWrap destroyed');
    this.totalAmount = 0;
    this.drugStorageInQueue = {};
    this.drugStorageInQueueId = [];
    this.theDrugStorage = {};
    this.theDrugStorageIndex = 0;
    this.forAction = {
      defaultNum: 0,
      checkNum: 0,
      deviceId: 0
    };
    this.getEmitTimes = 0;
    this.saveDatas = [];
  },
  created: function created() {
    // console.log(this.forAction);
    // prepare for the first Action child. remove the first one(user selected one), then set the remains into state.
    this.drugStorageInQueue = this.drugStorageWithSameDrug;
    console.log(this.drugStorageWithSameDrug);

    // this.$store.commit('SET_CONFIRM_STAGE', 'confirmAmount');
    this.moveCurrentStorageToHead(this.currentDrugInDevice.id);
    this.residual = this.amount;
    this.theDrugStorage = this.drugStorageList[this.theDrugStorageIndex];
    this.$store.commit('SET_CURRENT_DRUG_IN_DEVICE', this.theDrugStorage.id);
    // prepare forAction data
    if (this.actionProgress[0] === 'confirmAmount') {
      this.forAction = {
        defaultNum: this.theDrugStorage.stock,
        checkNum: this.theDrugStorage.max_stock,
        deviceId: this.theDrugStorage.device.id
      };
      this.$store.commit('SET_CURRENT_STEP', 'confirmAmount');
    }
    if (this.actionProgress[0] === 'action') {
      this.forAction = {
        defaultNum: this.amount,
        checkNum: this.theDrugStorage.stock,
        deviceId: this.theDrugStorage.device.id
      };
      this.$store.commit('SET_CURRENT_STEP', 'action');
    }
    this.stage = this.actionProgress[0]; // well, it seems that the new refaction could not fit actionWrap flow.
  },

  methods: {
    confirmAmountFinish: function confirmAmountFinish() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var nextDrugStorage, tmpNextDrugStorage;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('drugstorage', _this.theDrugStorage);
                _context.next = 3;
                return _this.$store.dispatch('updateCurrentDrugInDevice', _this.theDrugStorage.id);

              case 3:
                // notice: the stock of drugStorage might change here.
                _this.theDrugStorage = _this.$store.state.drugInDevice.allDrugInDevice[_this.theDrugStorage.id];
                //
                _this.forAction = {
                  defaultNum: _this.amount - _this.totalAmount, // the resident number for child.
                  checkNum: _this.theDrugStorage.stock > _this.residual ? _this.residual : _this.theDrugStorage.stock,
                  deviceId: _this.theDrugStorage.device.id
                };

                _this.stage = 'next';
                // 如果確認之後為0 就跳過該藥盒
                if (_this.currentDrugInDevice.stock === 0) {
                  if (_this.theDrugStorageIndex + 1 < _this.drugStorageList.length) {
                    _this.theDrugStorageIndex += 1;
                    _this.residual = _this.amount - _this.totalAmount;
                    _this.theDrugStorage = _this.drugStorageList[_this.theDrugStorageIndex];
                    _this.forAction = {
                      defaultNum: _this.amount - _this.totalAmount, // the resident number for child.
                      checkNum: _this.theDrugStorage.stock > _this.residual ? _this.residual : _this.theDrugStorage.stock,
                      deviceId: _this.theDrugStorage.device.id
                    };
                    // set next DrugStorage
                    nextDrugStorage = _this.drugStorageList[_this.theDrugStorageIndex];

                    _this.$store.commit('SET_NEXT_DEVICE', nextDrugStorage.device.id);
                    _this.$store.commit('SET_NEXT_DRUG_IN_DEVICE', nextDrugStorage.id);
                    _this.stage = 'break';
                  } else {
                    if (_this.amount - _this.totalAmount > 0) {
                      _this.$store.commit('SET_MESSAGE', {
                        type: 'warn',
                        context: '\u5C1A\u6709' + (_this.amount - _this.totalAmount) + '\u672A\u62FF\uFF0C\u8ACB\u81EA\u884C\u81F3\u5916\u90E8\u85E5\u76D2\u62FF\u53D6\u3002',
                        keepOnTop: true
                      });
                    }
                    //20190426 add
                    console.log('store.state.drugInDevice.currentDrugInDevice:', _this.$store.state.drugInDevice.currentDrugInDevice);
                    console.log('store.state.drugInDevice.nextDrugInDevice:', _this.$store.state.drugInDevice.nextDrugInDevice);
                    if (_this.$store.state.drugInDevice.nextDrugInDevice) {
                      console.log('store.state.drugInDevice.currentDrugInDevice.id:', _this.$store.state.drugInDevice.currentDrugInDevice.id);
                      console.log('store.state.drugInDevice.nextDrugInDevice.id:', _this.$store.state.drugInDevice.nextDrugInDevice.id);
                      //console.log(this.$store.state.drugInDevice);
                      _this.resetNextDrugInDevice();
                      //沒有下個藥要取
                      if (_this.$store.getters.nextDrug === null) {
                        console.log('remove:case a');
                        _this.$store.commit('REMOVE_NEXT_DRUG_IN_DEVICE');
                        _this.$store.commit('REMOVE_NEXT_DEVICE');
                      } else //還有下個藥可取
                        {
                          if (_this.$store.state.drugInDevice.currentDrugInDevice.id === _this.$store.state.drugInDevice.nextDrugInDevice.id) {
                            //去撈下個藥的id並設為next device
                            tmpNextDrugStorage = _this.$store.getters.nextDrug;

                            console.log(tmpNextDrugStorage);
                            if (tmpNextDrugStorage) {
                              console.log('tmpNextDrugStorage.device.id:', tmpNextDrugStorage.drugStorage[0].id);
                              _this.$store.commit('SET_NEXT_DRUG_IN_DEVICE', tmpNextDrugStorage.drugStorage[0].id);
                              _this.$store.commit('SET_NEXT_DEVICE', tmpNextDrugStorage.drugStorage[0].device.id);
                            } else {
                              console.log('remove:case b');
                              _this.$store.commit('REMOVE_NEXT_DRUG_IN_DEVICE');
                              _this.$store.commit('REMOVE_NEXT_DEVICE');
                            }
                          }
                        }
                    } else {
                      console.log('remove:case c');
                      _this.$store.commit('REMOVE_NEXT_DRUG_IN_DEVICE');
                      _this.$store.commit('REMOVE_NEXT_DEVICE');
                    }
                    setTimeout(function () {
                      _this.$emit('setActionData');
                    }, 1000);
                  }
                } else {
                  // notice: the stock of drugStorage might change here.
                  _this.theDrugStorage = _this.$store.state.drugInDevice.allDrugInDevice[_this.theDrugStorage.id];
                  //
                  _this.forAction = {
                    defaultNum: _this.amount - _this.totalAmount, // the resident number for child.
                    checkNum: _this.theDrugStorage.stock > _this.residual ? _this.residual : _this.theDrugStorage.stock,
                    deviceId: _this.theDrugStorage.device.id
                  };
                  setTimeout(function () {
                    _this.stage = 'action';
                    _this.$store.commit('SET_CURRENT_STEP', 'action');
                  }, 200);
                  _this.getTotalSumInstanly(_this.amount - _this.totalAmount);
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    moveCurrentStorageToHead: function moveCurrentStorageToHead(drugStorageId) {
      var current = this.drugStorageInQueue[drugStorageId];
      console.log(drugStorageId, current);
      delete this.drugStorageInQueue[drugStorageId];
      this.drugStorageList = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.drugStorageInQueue);
      this.drugStorageList = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.orderBy(this.drugStorageList, function (o) {
        return __WEBPACK_IMPORTED_MODULE_6_moment___default()(o.expired_date);
      });
      this.drugStorageList.unshift(current); // insert the current one to the head.
      // this.$store.commit('SET_SELECTED_DRUG_IN_DEVICE_DIRECTLY', this.drugStorageList);
    },
    saveData: function saveData(data) {
      var currentDrugStorage = this.theDrugStorage;
      if (this.currentDrugInDevice.stock - data.num < 0) {
        throw new Error('the saving stock should not be miuns');
      } else {
        var remainPc = currentDrugStorage.stock - currentDrugStorage.medication.pack_content * currentDrugStorage.pack_count;
        var remainPackCount = currentDrugStorage.pack_count;
        if (remainPackCount !== 0) {
          remainPackCount = currentDrugStorage.pack_count - Math.ceil((data.num - remainPc) / currentDrugStorage.medication.pack_content);
        }
        if (this.$store.state.schedule.currentSchedule) {
          this.scheduleId = this.$store.state.schedule.currentSchedule.id;
        }

        var medRecrodNumber = null;
        if (this.medRecordId) medRecrodNumber = this.medRecordId;
        if (this.barcodeData.medRecordId) medRecrodNumber = this.barcodeData.medRecordId;
        if (this.$store.state.schedule.currentSchedule) medRecrodNumber = this.$store.state.schedule.currentSchedule.patient.med_record_number;
        console.log(this.medRecordId, this.barcodeData, this.$store.state.schedule.currentSchedule, medRecrodNumber);

        // becareful that other components used this comp.
        var eventType = 'FETCH';
        if (this.startActionType === 'FETCH_TRANSFER') {
          eventType = 'FETCH_TRANSFER';
        }

        var sentData = {
          id: currentDrugStorage.id,
          device: data.device,
          stock: currentDrugStorage.stock - data.num, // only update here.
          max_stock: currentDrugStorage.max_stock,
          expired_date: currentDrugStorage.expired_date,
          patch_number: currentDrugStorage.patch_number,
          medication: currentDrugStorage.medication.id,
          med_record_no: medRecrodNumber,
          number1: -data.num,
          number2: this.scheduleId,
          pack_count: remainPackCount,
          type: eventType,
          review_employee: this.reviewer === undefined ? undefined : this.reviewer.id
        };
        console.log(currentDrugStorage.stock, data.num, sentData);

        this.stage = 'next';
        return sentData;
      }
    },
    goOn: function goOn() {
      console.log(this.theDrugStorage);
      var defaultNumCalc = 0;
      var checkNumCalc = 0;
      if (this.actionProgress[0] === 'confirmAmount') {
        defaultNumCalc = this.theDrugStorage.stock;
        checkNumCalc = this.theDrugStorage.max_stock;
      }
      if (this.actionProgress[0] === 'action') {
        defaultNumCalc = this.residual;
        checkNumCalc = this.theDrugStorage.stock > this.residual ? this.residual : this.theDrugStorage.stock;
      }

      this.forAction = {
        defaultNum: defaultNumCalc, // the resident number for child.
        checkNum: checkNumCalc,
        deviceId: this.theDrugStorage.device.id
      };
      console.log(this.forAction);
      this.$store.commit('SET_CURRENT_DRUG_IN_DEVICE', this.theDrugStorage.id);
      this.stage = this.actionProgress[0]; // TODO: remove it here.
      this.getEmitTimes = 0;
      // reset drugStorage id if it has been changed previous.
      this.resetNextDrugInDevice();
    },
    resetNextDrugInDevice: function resetNextDrugInDevice() {
      // reset drugStorage id if it has been changed previous.
      console.log('resetNextDrugInDevice');
      if (this.$store.state.drugInDevice.nextDrugInDevice) {
        // save the drugStorage id temporaliy.
        this.oriNextDrugStorageId = this.$store.state.drugInDevice.nextDrugInDevice.id;
      }
      console.log('this.oriNextDrugStorageId:', this.oriNextDrugStorageId);
      if (this.oriNextDrugStorageId) {
        this.$store.commit('SET_NEXT_DEVICE', this.$store.state.drugInDevice.allDrugInDevice[this.oriNextDrugStorageId].device.id);
        this.$store.commit('SET_NEXT_DRUG_IN_DEVICE', this.oriNextDrugStorageId);
      }
    },
    getTotalSumInstanly: function getTotalSumInstanly(val) {
      console.log('get total amount instanly', val);
      console.log('theDrugStorageIndex:', this.theDrugStorageIndex);
      console.log('drugStorageList.length:', this.drugStorageList.length);
      if (val < this.residual) {
        //20190429 modified
        //if (this.theDrugStorageIndex + 1 <= this.drugStorageList.length) {
        if (this.theDrugStorageIndex + 1 < this.drugStorageList.length) {
          var nextDrugStorage = this.drugStorageList[this.theDrugStorageIndex + 1];
          if (this.$store.state.drugInDevice.nextDrugInDevice) {
            // save the drugStorage id temporaliy.
            this.oriNextDrugStorageId = this.$store.state.drugInDevice.nextDrugInDevice.id;
          }
          console.log('nextDrugStorage.device.id:', nextDrugStorage.device.id);
          this.$store.commit('SET_NEXT_DEVICE', nextDrugStorage.device.id);
          this.$store.commit('SET_NEXT_DRUG_IN_DEVICE', nextDrugStorage.id);
          console.log('set next device');
        } else {
          console.log('no enough amount for fetching.');
        }
      } else {
        this.resetNextDrugInDevice();
        if (this.$store.getters.nextDrug === null) {
          console.log('remove:case aa');
          this.$store.commit('REMOVE_NEXT_DRUG_IN_DEVICE');
          this.$store.commit('REMOVE_NEXT_DEVICE');
        } else //還有下個藥可取
          {
            if (this.$store.state.drugInDevice.nextDrugInDevice) {
              if (this.$store.state.drugInDevice.currentDrugInDevice.id === this.$store.state.drugInDevice.nextDrugInDevice.id) {
                //去撈下個藥的id並設為next device
                var tmp2NextDrugStorage = this.$store.getters.nextDrug;
                console.log(tmp2NextDrugStorage);
                if (tmp2NextDrugStorage) {
                  console.log('tmp2NextDrugStorage.device.id:', tmp2NextDrugStorage.drugStorage[0].id);
                  this.$store.commit('SET_NEXT_DRUG_IN_DEVICE', tmp2NextDrugStorage.drugStorage[0].id);
                  this.$store.commit('SET_NEXT_DEVICE', tmp2NextDrugStorage.drugStorage[0].device.id);
                } else {
                  console.log('remove:case bb');
                  this.$store.commit('REMOVE_NEXT_DRUG_IN_DEVICE');
                  this.$store.commit('REMOVE_NEXT_DEVICE');
                }
              }
            }
          }
      }
    },
    getThisAmount: function getThisAmount(data) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$store.commit('SET_APP_CANCEL_STATUS', false);
                console.log(_this2.$store.state.currentApp.cancel);
                _this2.getEmitTimes += 1; // prevent over emitting

                if (!(_this2.getEmitTimes === 1)) {
                  _context2.next = 34;
                  break;
                }

                // data: device, num
                _this2.totalAmount += data.num;
                // this.saveDatas.push(this.saveData(data));
                _this2.stage = 'next';
                _context2.next = 8;
                return _this2.saveDataOneByOne(_this2.saveData(data));

              case 8:
                _context2.prev = 8;
                _context2.next = 11;
                return _this2.deleteSchedules(_this2.summarySelectedMed[_this2.currentDrug.med.id]);

              case 11:
                _context2.next = 16;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2['catch'](8);

                _this2.$store.commit('SET_MESSAGE', { type: 'warn', context: '刪除藥單錯誤' });

              case 16:

                // increment the index
                _this2.theDrugStorageIndex += 1;
                // await this.$store.dispatch('getTotalDrugAmountInstanly', this.$store.state.drug.selectedDrugID);

                if (!(_this2.totalAmount < _this2.amount)) {
                  _context2.next = 32;
                  break;
                }

                if (!(_this2.theDrugStorageIndex < _this2.drugStorageList.length)) {
                  _context2.next = 25;
                  break;
                }

                _this2.residual = _this2.amount - _this2.totalAmount;
                _this2.theDrugStorage = _this2.drugStorageList[_this2.theDrugStorageIndex];
                console.log(_this2.theDrugStorage);
                _this2.stage = 'break';
                _context2.next = 30;
                break;

              case 25:
                _this2.$store.commit('SET_MESSAGE', {
                  type: 'warn',
                  context: '\u5C1A\u6709' + (_this2.amount - _this2.totalAmount) + '\u672A\u62FF\uFF0C\u8ACB\u81EA\u884C\u81F3\u5916\u90E8\u85E5\u76D2\u62FF\u53D6\u3002',
                  keepOnTop: true
                });
                _this2.getEmitTimes = 0;
                // remove the res of schedules, since the remain amount would be fetched outside.
                _context2.next = 29;
                return _this2.removeTheRestSchedules(_this2.summarySelectedMed[_this2.currentDrug.med.id]);

              case 29:
                _this2.$emit('setActionData');

              case 30:
                _context2.next = 34;
                break;

              case 32:
                _this2.$emit('setActionData');
                console.log('finished');

              case 34:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[8, 13]]);
      }))();
    },
    saveDataOneByOne: function saveDataOneByOne(item) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var currentSelectMed, amountUsedInTheDrugStorage, originalStockInTheDrugStorage, _loop, j, _ret;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                currentSelectMed = _this3.summarySelectedMed[_this3.currentDrug.med.id];
                // reverse the fetch amount and save it to db.
                // array of actions. (due to crossing drugStorages.)

                amountUsedInTheDrugStorage = Math.abs(item.number1); // amount has used in current DrugStorage

                originalStockInTheDrugStorage = item.stock + amountUsedInTheDrugStorage; // 先推算回還沒拿取之前的數量
                // iterate tasks

                _this3.saveTaskCount = currentSelectMed.schedules.length;
                _loop = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _loop(j) {
                  var scheduleId, schedule, copyItem, _copyItem;

                  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _loop$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _this3.saveProgress = j + 1;
                          scheduleId = currentSelectMed.schedules[j];
                          schedule = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.find(_this3.schedules, function (o) {
                            return o.id === scheduleId;
                          });
                          // schedule.fetched indicates that it is all saved into db.

                          if (!(schedule.fetched === false)) {
                            _context3.next = 38;
                            break;
                          }

                          if (!(amountUsedInTheDrugStorage - schedule.amount >= 0)) {
                            _context3.next = 23;
                            break;
                          }

                          // 輪到這張藥單數量剛好取完或是還有剩餘
                          amountUsedInTheDrugStorage -= schedule.amount;
                          originalStockInTheDrugStorage -= schedule.amount;
                          copyItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);

                          copyItem.number1 = -schedule.amount;
                          copyItem.med_record_no = schedule.patient.med_record_number;
                          copyItem.stock = originalStockInTheDrugStorage;
                          /* eslint-disable no-await-in-loop */
                          console.log('enough amount. save.');
                          _context3.prev = 12;
                          _context3.next = 15;
                          return _this3.instance.put('/api/drug-storage/' + item.id + '/', copyItem);

                        case 15:
                          _context3.next = 20;
                          break;

                        case 17:
                          _context3.prev = 17;
                          _context3.t0 = _context3['catch'](12);

                          _this3.$store.commit('SET_MESSAGE', { type: 'warn', context: '\u5132\u5B58\u53D6\u85E5\u932F\u8AA4:' + item.id });

                        case 20:
                          schedule.fetched = true;
                          _context3.next = 38;
                          break;

                        case 23:
                          if (!(amountUsedInTheDrugStorage > 0)) {
                            _context3.next = 38;
                            break;
                          }

                          _copyItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);

                          _copyItem.number1 = -amountUsedInTheDrugStorage; // remain number in the drugStorage.
                          schedule.amount -= amountUsedInTheDrugStorage; // 該藥單扣掉已經取走的部份
                          _copyItem.med_record_no = schedule.patient.med_record_number;
                          /* eslint-disable no-await-in-loop */
                          console.log('amount insuffcient, to next drugstorage.', amountUsedInTheDrugStorage, schedule.amount);
                          _context3.prev = 29;
                          _context3.next = 32;
                          return _this3.instance.put('/api/drug-storage/' + item.id + '/', _copyItem);

                        case 32:
                          _context3.next = 37;
                          break;

                        case 34:
                          _context3.prev = 34;
                          _context3.t1 = _context3['catch'](29);

                          _this3.$store.commit('SET_MESSAGE', { type: 'warn', context: '\u5132\u5B58\u53D6\u85E5\u932F\u8AA4:' + item.id });

                        case 37:
                          return _context3.abrupt('return', 'break');

                        case 38:
                        case 'end':
                          return _context3.stop();
                      }
                    }
                  }, _loop, _this3, [[12, 17], [29, 34]]);
                });
                j = 0;

              case 6:
                if (!(j < currentSelectMed.schedules.length)) {
                  _context4.next = 14;
                  break;
                }

                return _context4.delegateYield(_loop(j), 't0', 8);

              case 8:
                _ret = _context4.t0;

                if (!(_ret === 'break')) {
                  _context4.next = 11;
                  break;
                }

                return _context4.abrupt('break', 14);

              case 11:
                j += 1;
                _context4.next = 6;
                break;

              case 14:
                _this3.saveTaskCount = 0;
                _this3.saveProgress = 0;

              case 16:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    deleteSchedules: function deleteSchedules(currrentSummaryMed) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var schedules, promises, deletedScheduleId;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                schedules = currrentSummaryMed.schedules;
                promises = [];
                deletedScheduleId = [];

                schedules.forEach(function (id) {
                  var schedule = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.find(_this4.schedules, function (o) {
                    return o.id === id;
                  });
                  if (schedule.fetched) {
                    // only delete it if fetched.
                    promises.push(_this4.instance.delete('/api/fetch-schedule/' + id + '/'));
                    deletedScheduleId.push(id);
                  }
                });
                // remove the deleted schedule ids. this is used when fetchDrug across different devices.
                deletedScheduleId.forEach(function (id) {
                  var ind = schedules.findIndex(function (o) {
                    return o === id;
                  });
                  schedules.splice(ind, 1);
                });
                return _context5.abrupt('return', __WEBPACK_IMPORTED_MODULE_5_axios___default.a.all(promises));

              case 6:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    removeTheRestSchedules: function removeTheRestSchedules(currrentSummaryMed) {
      var _this5 = this;

      var schedules = currrentSummaryMed.schedules;
      var promises = [];
      schedules.forEach(function (id) {
        promises.push(_this5.instance.delete('/api/fetch-schedule/' + id + '/'));
      });
      return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.all(promises);
    }
  }
});

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ActionWrap__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ActionWrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ActionWrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ComponentBase_ConfirmFlowBase__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flowComp_RxCheckBarcode__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flowComp_RxCheckBarcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__flowComp_RxCheckBarcode__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ConfirmFlow',
  extends: __WEBPACK_IMPORTED_MODULE_1__ComponentBase_ConfirmFlowBase__["a" /* default */],
  props: ['schedules', 'summarySelectedMed'],
  data: function data() {
    return {
      barcodeData: {},
      reviewer: undefined
    };
  },

  components: {
    ActionWrap: __WEBPACK_IMPORTED_MODULE_0__ActionWrap___default.a,
    RxCheckBarcode: __WEBPACK_IMPORTED_MODULE_2__flowComp_RxCheckBarcode___default.a
  },
  created: function created() {
    this.$store.dispatch('getDrugInDevicesWithSameDrug', this.currentDrug.med.id);
  },

  computed: {},
  methods: {
    getFetchData: function getFetchData(data) {
      this.$emit('confirmationFinish');
    },
    confirmRx: function confirmRx(reviewer) {
      this.reviewer = reviewer;
      this.nextProgress();
    }
  }
});

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_DrugInfo__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_DrugInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__flowComp_DrugInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConfirmFlow__ = __webpack_require__(1289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConfirmFlow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ConfirmFlow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ComponentBase_MultiFlowBase__ = __webpack_require__(38);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'multiflow',
  extends: __WEBPACK_IMPORTED_MODULE_6__ComponentBase_MultiFlowBase__["a" /* default */],
  props: ['schedules', 'summarySelectedMed'],
  data: function data() {
    return {
      checkFun: undefined
    };
  },

  components: {
    DrugInfo: __WEBPACK_IMPORTED_MODULE_3__flowComp_DrugInfo___default.a,
    ConfirmFlow: __WEBPACK_IMPORTED_MODULE_4__ConfirmFlow___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_5__common_Loader___default.a
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$store.dispatch('fromFirstDrug');

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {},
  methods: {
    getConfirmData: function getConfirmData() {
      var _this2 = this;

      this.nextProgress();
      this.checkFun = setInterval(function () {
        _this2.checkDevicesCloseAndEmit();
      }, 500);
    },
    nextStep: function nextStep() {
      var _this3 = this;

      this.$store.commit('SET_APP_CANCEL_STATUS', true);
      if (this.nextDrug === null) {
        this.$emit('setAllConfirmData');
      } else {
        this.$store.dispatch('toNextDrug');
        setTimeout(function () {
          _this3.resetProgress();
        }, 100);
      }
    },

    //20190412 modified by aaron
    checkDevicesCloseAndEmit: function checkDevicesCloseAndEmit() {
      if (this.nextDevice) {
        if (this.nextDevice.net.id === this.currentDevice.net.id && this.errorDevices.length > 1) {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            confirm: false,
            context: '請先關閉所有藥盒'
          });
        } else if (this.nextDevice.net.id !== this.currentDevice.net.id && this.errorDevices.length > 0) {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            confirm: false,
            context: '請先關閉所有藥盒及抽屜'
          });
        } else {
          this.$store.commit('CLOSE_MESSAGE');
          if (this.checkFun) {
            clearInterval(this.checkFun);
          }
          this.nextStep();
        }
      } else {
        /*
        this.$store.commit('CLOSE_MESSAGE');
        if (this.checkFun) {
          clearInterval(this.checkFun);
        }
        this.nextStep();
        */
        if (this.errorDevices.length > 0) {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            confirm: false,
            context: '請先關閉所有藥盒及抽屜'
          });
        } else {
          this.$store.commit('CLOSE_MESSAGE');
          if (this.checkFun) {
            clearInterval(this.checkFun);
          }
          this.nextStep();
        }
      }
    }
  }
});

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fortawesome_free_solid_svg_icons__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__flowComp_ProgressBar__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__flowComp_ProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__flowComp_ProgressBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_BottomButtons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_BottomButtons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__common_BottomButtons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__flowComp_PositionSelection__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__flowComp_PositionSelection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__flowComp_PositionSelection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__LockBoxFlow_MultiFlow__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__LockBoxFlow_MultiFlow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__LockBoxFlow_MultiFlow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__common_Loader__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* This app is not implmented with AppBase structure. */










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LockBox',
  components: {
    progressBar: __WEBPACK_IMPORTED_MODULE_8__flowComp_ProgressBar___default.a,
    BottomButtons: __WEBPACK_IMPORTED_MODULE_9__common_BottomButtons___default.a,
    PositionSelection: __WEBPACK_IMPORTED_MODULE_10__flowComp_PositionSelection___default.a,
    MultiFlow: __WEBPACK_IMPORTED_MODULE_11__LockBoxFlow_MultiFlow___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_12__common_Loader___default.a
  },
  data: function data() {
    return {
      stage: 'select',
      password: '',
      actionType: '',
      progress: [{
        en: 'selectDrug',
        zh: '選擇動作'
      }, {
        en: 'selectPosition',
        zh: '選擇位置'
      }, {
        en: 'action',
        zh: '進行動作'
      }]
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.$store.commit('SET_APP', '藥物保管箱');
    this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
    this.$store.commit('SET_PROGRESS', this.progress);
  },

  computed: {
    allDevices: function allDevices() {
      return this.$store.getters.allDevices;
    },
    selectedDevices: function selectedDevices() {
      return this.$store.state.device.selectedDevices;
    },
    selectedDevicesID: function selectedDevicesID() {
      return this.$store.state.device.selectedDevicesID;
    },
    arrowDownIcon: function arrowDownIcon() {
      return __WEBPACK_IMPORTED_MODULE_7__fortawesome_free_solid_svg_icons__["g" /* faArrowDown */];
    },
    arrowUpIcon: function arrowUpIcon() {
      return __WEBPACK_IMPORTED_MODULE_7__fortawesome_free_solid_svg_icons__["h" /* faArrowUp */];
    },
    boxOpenIcon: function boxOpenIcon() {
      return __WEBPACK_IMPORTED_MODULE_7__fortawesome_free_solid_svg_icons__["i" /* faBoxOpen */];
    },
    lockedAndFilledDevices: function lockedAndFilledDevices() {
      var results = {};
      var devs = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(this.allDevices), ['device.net.open_times', 'device.net.row_id', 'device.pos_row', 'device.relative_col']);
      var targetDevices = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.filter(devs, function (o) {
        return o.specific_type === 'lock_device' && o.drugstorage_set.length > 0;
      });
      targetDevices.forEach(function (dev) {
        // dev.selected = false;
        results[dev.id] = dev;
      });
      return results;
    }
  },
  methods: {
    cancel: function cancel() {
      this.$router.push({ name: 'Main' });
    },
    startflow: function startflow() {
      this.stage = 'startFlow';
    },
    selectAction: function selectAction(val) {
      this.stage = val;
      this.actionType = val;
      this.$store.commit('SET_CURRENT_STEP', 'selectPosition');
    },
    getAllConfirmData: function getAllConfirmData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // this.stage = 'loader';
                // this.$store.commit('RESET_DEVICES_MODULE');
                // await this.$store.dispatch('getSystemInfo');
                // this.stage = 'select';
                _this.$router.push({ name: 'Main' });

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    confirmPassword: function confirmPassword() {
      if (this.password === '1234') {
        this.stage = 'selectLockedBox';
      } else {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '密碼錯誤'
        });
      }
    },
    getLockedAndFilledDevice: function getLockedAndFilledDevice() {
      var results = {};
      var devs = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(this.allDevices), ['device.net.open_times', 'device.net.row_id', 'device.pos_row', 'device.relative_col']);
      var targetDevices = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.filter(devs, function (o) {
        return o.specific_type === 'lock_device' && o.drugstorage_set.length > 0;
      });
      targetDevices.forEach(function (dev) {
        dev.selected = false;
        results[dev.id] = dev;
      });
      console.log('set ');
      this.lockedAndFilledDevices = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, results); // array must be registed into data, then vue can detect the changes.
      // this.$set(this, 'lockedAndFilledDevices', results);
    },
    selectDevice: function selectDevice(index) {
      this.$store.commit('ADD_DEVICE_TO_SELECTED_LIST', this.lockedAndFilledDevices[index].id);
    },
    selectAllDevices: function selectAllDevices() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.lockedAndFilledDevices).forEach(function (id) {
        _this2.$store.commit('ADD_DEVICE_TO_SELECTED_LIST', id);
      });
    }
  }
});

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fortawesome_free_solid_svg_icons__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_Action__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_Action___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__flowComp_Action__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LockBoxConfirmFlow',
  props: ['actionType'],
  data: function data() {
    return {
      fakeNumber: 1,
      emitTime: 0
    };
  },

  components: {
    Action: __WEBPACK_IMPORTED_MODULE_3__flowComp_Action___default.a
  },
  methods: {
    getActionData: function getActionData(data) {
      var _this = this;

      if (this.emitTime === 0) {
        if (this.actionType === 'lock') {
          var fakeDrugStorage = {
            device: this.currentDevice.id,
            medication: this.selectedDrug.id,
            max_stock: 1,
            patch_number: this.patchNumber,
            expired_date: __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY-MM-DD'),
            stock: data.num,
            pack_count: 0,
            // min_stock: this.minStorage,
            number1: data.num,
            type: 'LOCKUP' // event type: for event recording
          };
          this.instance.post('/api/drug-storage/', fakeDrugStorage).then(function (res) {
            _this.$emit('confirmationFinish');
          });
        }

        if (this.actionType === 'unlock') {
          var promises = [];
          this.currentDevice.drugstorage_set.forEach(function (item) {
            promises.push(_this.instance.delete('/api/drug-storage/' + item.id + '/', {
              data: {
                type: 'UNLOCK'
              }
            }));
          });
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.all(promises).then(function () {
            _this.$emit('confirmationFinish');
          });
        }
      }
      this.emitTime += 1;
    }
  },
  computed: {
    selectedDrug: function selectedDrug() {
      return this.$store.state.drug.selectedDrug;
    },
    currentDevice: function currentDevice() {
      return this.$store.state.device.currentDevice;
    },
    instance: function instance() {
      return this.$store.state.instance;
    },
    arrowDownIcon: function arrowDownIcon() {
      return __WEBPACK_IMPORTED_MODULE_2__fortawesome_free_solid_svg_icons__["g" /* faArrowDown */];
    },
    arrowUpIcon: function arrowUpIcon() {
      return __WEBPACK_IMPORTED_MODULE_2__fortawesome_free_solid_svg_icons__["h" /* faArrowUp */];
    },
    boxOpenIcon: function boxOpenIcon() {
      return __WEBPACK_IMPORTED_MODULE_2__fortawesome_free_solid_svg_icons__["i" /* faBoxOpen */];
    },
    selectedDevicesID: function selectedDevicesID() {
      return this.$store.state.device.selectedDevicesID;
    }
  }
});

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_free_solid_svg_icons__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConfirmFlow__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConfirmFlow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ConfirmFlow__);
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LockBoxMultiFlow',
  props: ['actionType'],
  data: function data() {
    return {
      stage: ''
    };
  },

  components: {
    ConfirmFlow: __WEBPACK_IMPORTED_MODULE_1__ConfirmFlow___default.a
  },
  created: function created() {
    this.$store.commit('SET_CURRENT_DEVICE_FROM_SELECTED', this.selectedDevicesID[0]);
    this.setFakeMedication();
  },
  mounted: function mounted() {
    this.stage = 'confirm';
  },

  methods: {
    getConfirmData: function getConfirmData() {
      var _this = this;

      this.stage = 'finish';
      if (this.nextDevice !== null) {
        this.$store.commit('SET_CURRENT_DEVICE_FROM_SELECTED', this.nextDevice.id);
        setTimeout(function () {
          _this.stage = 'confirm';
        }, 100);
      } else {
        this.$emit('setAllConfirmData');
      }
    },
    setFakeMedication: function setFakeMedication() {
      var _this2 = this;

      this.instance.get('/api/medication/', {
        params: {
          code: 'Lock_Med'
        }
      }).then(function (res) {
        _this2.$store.dispatch('setDrug', res.data.results[0].id);
      });
    }
  },
  computed: {
    nextDevice: function nextDevice() {
      return this.$store.state.device.nextDevice;
    },
    selectedDevicesID: function selectedDevicesID() {
      return this.$store.state.device.selectedDevicesID;
    },
    instance: function instance() {
      return this.$store.getters.instance;
    },
    arrowDownIcon: function arrowDownIcon() {
      return __WEBPACK_IMPORTED_MODULE_0__fortawesome_free_solid_svg_icons__["g" /* faArrowDown */];
    },
    boxOpenIcon: function boxOpenIcon() {
      return __WEBPACK_IMPORTED_MODULE_0__fortawesome_free_solid_svg_icons__["i" /* faBoxOpen */];
    }
  }
});

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flowComp_ScanBarcode__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flowComp_ScanBarcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__flowComp_ScanBarcode__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Login',
  data: function data() {
    return {
      username: '',
      password: '',
      barcode: '',
      errorMsgBarcode: '',
      errorMsg: '',
      loginMode: 'password',
      showSaver: true,
      connected: false,
      connectionMsg: '藥櫃連線中',
      server: __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */],
      checkConnectionfun: null,
      lastConnectedTime: '',
      lastRetryTime: '',
      retryTimes: 0,
      version: __WEBPACK_IMPORTED_MODULE_5__config__["d" /* version */]
    };
  },

  components: {
    ScanBarcode: __WEBPACK_IMPORTED_MODULE_6__flowComp_ScanBarcode___default.a
  },
  methods: {
    detetmineRedirect: function detetmineRedirect() {
      this.$store.commit('CLOSE_MESSAGE');
      if (this.$store.state.apps.management.functions[this.$store.state.generalSetting.login_to_app].privilege) {
        this.$router.push({ name: this.$store.state.generalSetting.login_to_app });
      } else {
        this.$router.push({ name: 'Main' });
      }
    },
    closeScreenSaver: function closeScreenSaver() {
      var _this = this;

      if (this.connected) {
        this.showSaver = false;
        setTimeout(function () {
          _this.showSaver = true;
        }, 30000);
      }
      if (false) {
        this.showSaver = false;
        setTimeout(function () {
          _this.showSaver = true;
        }, 30000);
      }
    },
    login: function login() {
      var _this2 = this;

      return this.$store.dispatch('loginAndGetUser', {
        username: this.username,
        password: this.password
      }).then(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.$store.commit('SHOW_LOADER', true);
                //20190520 add by aaron
                _this2.$store.commit('RESET_DRUG_IN_DEVICE_MODULE', true);
                _context.next = 4;
                return _this2.$store.dispatch('getSystemInfo');

              case 4:
                _context.next = 6;
                return _this2.$store.dispatch('getDrugInDevices');

              case 6:
                _this2.$store.dispatch('setOnline');
                _this2.detetmineRedirect();

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))).catch(function (err) {
        _this2.$store.commit('SHOW_LOADER', false);
        console.error(err);
        if (err.response !== undefined) {
          _this2.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: '帳號或密碼錯誤'
          });
        } else {
          _this2.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: '伺服器連線失敗'
          });
        }
      });
    },
    getBarcodeToLogin: function getBarcodeToLogin(val) {
      var _this3 = this;

      if (this.connected) {
        this.$store.dispatch('barcodeLoginAndGetUser', {
          barcode: val
        }).then(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _this3.$store.commit('SHOW_LOADER', true);
                  //20190520 add by aaron
                  _this3.$store.commit('RESET_DRUG_IN_DEVICE_MODULE', true);
                  _context2.next = 4;
                  return _this3.$store.dispatch('getSystemInfo');

                case 4:
                  _context2.next = 6;
                  return _this3.$store.dispatch('getDrugInDevices');

                case 6:
                  _this3.$store.dispatch('setOnline');
                  _this3.detetmineRedirect();

                case 8:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this3);
        }))).catch(function (err) {
          _this3.$store.commit('SHOW_LOADER', false);
          if (err.response !== undefined) {
            _this3.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: '條碼登入失敗'
            });
          } else {
            _this3.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: '伺服器連線失敗'
            });
          }
        });
      } else {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '請確認系統連線狀況'
        });
      }
    },
    getFingerprintToLogin: function getFingerprintToLogin(feature) {
      var _this4 = this;

      if (this.connected) {
        this.$store.dispatch('fingerpinrtLoginAndGetUser', {
          feature: feature
        }).then(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _this4.$store.commit('SHOW_LOADER', true);
                  //20190520 add by aaron
                  _this4.$store.commit('RESET_DRUG_IN_DEVICE_MODULE', true);
                  _context3.next = 4;
                  return _this4.$store.dispatch('getSystemInfo');

                case 4:
                  _context3.next = 6;
                  return _this4.$store.dispatch('getDrugInDevices');

                case 6:
                  _this4.$store.dispatch('setOnline');
                  _this4.detetmineRedirect();

                case 8:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, _this4);
        }))).catch(function (err) {
          _this4.$store.commit('SHOW_LOADER', false);
          if (err.response !== undefined) {
            _this4.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: '指紋登入失敗'
            });
          } else {
            _this4.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: '伺服器連線失敗'
            });
          }
          // fire again
          _this4.$store.dispatch('sendScanFingerCommand');
        });
      } else {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '請確認系統連線狀況'
        });
        // fire again
        this.$store.dispatch('sendScanFingerCommand');
      }
    },

    // checkConnectionRepeatly() {
    //   if (this.checkConnectionfun === null) {
    //     this.checkConnectionfun = setInterval(async () => {
    //       console.log('check connection every 10 secs.', this.connected);
    //       if (this.connected === false) {
    //         this.retryTimes += 1;
    //       }
    //       if (this.retryTimes === 30) { // retry one minutes already
    //         this.$store.commit('SET_MESSAGE', {
    //           type: 'error',
    //           context: '嘗試重新連線超過五分鐘，請與管理員聯繫',
    //           confirm: true,
    //         });
    //       }
    //       if (this.connected) {
    //         clearInterval(this.checkConnectionfun);
    //         this.checkConnectionfun = null;
    //       }
    //     }, 10000);
    //   }
    // },
    debounceDetction: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function (vm) {
      if (vm.systemLayoutChecked) {
        vm.connected = true;
        vm.connectionMsg = '藥櫃系統掃描完成';
        vm.lastConnectedTime = __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('HH:mm:ss');
        vm.checkFingerprint();
      } else {
        vm.connected = false;
        vm.connectionMsg = '藥櫃系統掃描失敗';
        vm.lastRetryTime = __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('HH:mm:ss');
      }
    }, 2000),
    checkSystemSerial: function checkSystemSerial() {
      // if serial number is recorded, then scan layout directly.
      if (this.$store.state.cabinetSerials.length === 0) {
        this.$store.dispatch('resetAndGetLocalSerialNumber');
      } else {
        this.$store.dispatch('sendScanLocalLayoutCommand');
      }
    },
    checkFingerprint: function checkFingerprint() {
      if (this.$store.state.generalSetting.can_login_with_fingerprinter) {
        this.$store.dispatch('sendScanFingerCommand');
      }
    }
  },
  computed: {
    systemLayoutChecked: function systemLayoutChecked() {
      return this.$store.state.systemLayoutChecked;
    },
    connectionStatus: function connectionStatus() {
      return this.$store.state.connectionStatus;
    },
    fingerprint: function fingerprint() {
      return this.$store.state.user.fingerprint;
    },
    webSocketReady: function webSocketReady() {
      return this.$store.state.webSocketReady;
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    if (this.$store.state.webSocket.readyState === 1) {
      this.$store.dispatch('sendCancelFingerCaptureCommand');
      setTimeout(function () {
        _this5.checkSystemSerial();
      }, 500);
    }
    this.lastRetryTime = __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('HH:mm:ss');
  },
  created: function created() {
    this.$store.dispatch('webSocketConnect');
    this.$store.commit('SET_APP', '登入');
  },
  destroyed: function destroyed() {
    clearInterval(this.checkConnectionfun);
    this.$store.dispatch('sendCancelFingerCaptureCommand');
  },

  watch: {
    systemLayoutChecked: function systemLayoutChecked(val) {
      this.debounceDetction(this);
    },
    fingerprint: function fingerprint(val) {
      this.getFingerprintToLogin(val);
    },
    webSocketReady: function webSocketReady(val) {
      var _this6 = this;

      if (val === true) {
        this.$store.dispatch('sendCancelFingerCaptureCommand');
        setTimeout(function () {
          _this6.checkSystemSerial();
        }, 500);
        this.lastRetryTime = __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('HH:mm:ss');
      }
    }
  }
});

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_ClipLoader__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_ClipLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_ClipLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Clock__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Clock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__common_Clock__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].component('action-button', {
  props: {
    title: {
      type: String,
      default: ''
    },
    clickable: {
      type: Boolean,
      default: true
    }
  },
  template: '\n    <button class="btn control-button control-button-red" :disabled="clickable === false">\n      <div class="button-inside-wrap">\n        <span>{{ title }}</span>\n      </div>\n    </button>\n  '
});

function humanlized(context) {
  var errorMsg = '<h5>偵測到藥盒或藥櫃未關閉</h5><hr/>';
  var drawer = [];
  var box = [];
  var drawerMsg = ' ';
  var boxMsg = '';
  context.forEach(function (element) {
    if (element.type === 'drawer') drawer.push(element);
    if (element.type === 'box') box.push(element);
  });

  if (drawer.length !== 0) {
    drawer.forEach(function (d) {
      drawerMsg = drawerMsg.concat('<p>\u7B2C ' + (d.system + 1) + ' \u85E5\u6AC3 - \u7B2C ' + d.drawerId + ' \u5C64\u62BD\u5C5C </p>');
    });
    errorMsg = errorMsg.concat(drawerMsg);
  }

  if (box.length !== 0) {
    box.forEach(function (b) {
      boxMsg = boxMsg.concat('<p>\u7B2C ' + (b.system + 1) + ' \u85E5\u6AC3 - \u7B2C ' + b.drawerId + ' \u5C64\u62BD\u5C5C - <span class="device-warning-msg">' + b.row + ' \u5217 - ' + b.col + ' \u884C</span> \u85E5\u76D2</p>');
    });
    // boxMsg = boxMsg.concat('抽屜未關</h6>');
    errorMsg = errorMsg.concat(boxMsg);
  }
  errorMsg = errorMsg.concat('<hr/><p>請關閉所有抽屜及藥盒</p>');

  return errorMsg;
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Main',
  data: function data() {
    return {
      hour: '',
      min: '',
      sec: '',
      month: '',
      day: '',
      version: '',
      timeoutFun: null,
      intervalFun: null,
      timeRemain: 1000 * 10,
      mountedFinished: true,
      errorDevicesPrevious: [],
      errorDevicesPreviousBySys: {},
      confirmTimes: 0
    };
  },

  components: {
    Clock: __WEBPACK_IMPORTED_MODULE_8__common_Clock___default.a,
    ClipLoader: __WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_ClipLoader___default.a
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$store.commit('CLOSE_MESSAGE');
              _this.$store.commit('SET_APP', '功能選擇');
              _this.$store.dispatch('resetAll');
              _this.version = __WEBPACK_IMPORTED_MODULE_7__config__["d" /* version */];
              // indicate the loading progress on main panel
              _this.$store.state.apps.management.functions.removeOutdatedDrug.ready = false;
              _this.$store.state.apps.management.functions.refillDrug.ready = false;
              _this.$store.state.apps.setting.functions.drugStorageSummary.ready = false;
              _this.$store.state.apps.management.functions.schedule.ready = false;
              //20190411 add by aaron
              _this.$store.state.apps.management.functions.fetchDrugSchedule.ready = false;
              // this.$store.dispatch('webSocketConnect');
              _context.next = 11;
              return _this.$store.dispatch('initSystemInfo');

            case 11:
              // this.mountedFinished = true;
              // update the loading progress.
              _this.$store.state.apps.management.functions.removeOutdatedDrug.ready = true;
              _this.$store.state.apps.management.functions.refillDrug.ready = true;
              _this.$store.state.apps.setting.functions.drugStorageSummary.ready = true;
              _this.$store.state.apps.management.functions.schedule.ready = true;
              //20190411 add by aaron
              _this.$store.state.apps.management.functions.fetchDrugSchedule.ready = true;

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    this.startTime();
    this.$store.commit('SHOW_LOGOUT', true);
  },
  destroyed: function destroyed() {
    this.$store.commit('SHOW_LOGOUT', false);
  },

  methods: {
    startTime: function startTime() {
      var today = new Date();
      this.hour = today.getHours();
      this.min = today.getMinutes();
      this.sec = today.getSeconds();
      this.min = this.checkTime(this.min);
      this.sec = this.checkTime(this.sec);
      this.month = today.getMonth() + 1;
      this.day = today.getDate();
      setTimeout(this.startTime, 500);
    },
    checkTime: function checkTime(i) {
      if (i < 10) {
        return '0'.concat(i);
      }
      return i;
    },

    debouncedDetectErrorDevice: __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.debounce(function (vm) {
      if (vm.errorDevices.length !== 0) {
        if (vm.$store.state.currentApp.name === '功能選擇' && vm.$store.state.message.keepOnTop === false) {
          vm.$store.commit('SET_MESSAGE', {
            type: 'error',
            // context: this.errorDevices,
            context: humanlized(vm.errorDevices),
            showUnlock: true,
            confirm: true
          });
        }
      } else {
        if (vm.$store.state.messagePop && vm.$store.state.message.keepOnTop === false) {
          vm.$store.commit('CLOSE_MESSAGE');
        }
      }
    }, 100),
    hasAtLeastTwoErrorDrawers: function hasAtLeastTwoErrorDrawers(errorDevices) {
      var drawerids = [];
      errorDevices.forEach(function (item) {
        if (item.type === 'drawer') {
          drawerids.push(item.drawerId);
        }
      });

      if (drawerids.length >= 2) return true;
      return false;
    },
    checkArraySame: function checkArraySame(a, b) {
      // console.log(a, b);
      if (a === b) return true;
      if (a == null || b == null) return false;
      if (a.length !== b.length) return false;

      // If you don't care about the order of the elements inside
      // the array, you should sort both arrays here.

      for (var i = 0; i < a.length; i += 1) {
        if (a[i] !== b[i]) return false;
      }
      return true;
    },
    errorDevicesAndPreviousErrorDevicesAreSame: function errorDevicesAndPreviousErrorDevicesAreSame() {
      var nowDeviceId = [];
      var preDeviceId = [];
      this.errorDevices.forEach(function (item) {
        nowDeviceId.push(item.system + '-' + item.drawerId);
      });
      this.errorDevicesPrevious.forEach(function (item) {
        preDeviceId.push(item.system + '-' + item.drawerId);
      });
      return this.checkArraySame(nowDeviceId, preDeviceId);
    },
    forceShutDown: function forceShutDown(systemId) {
      this.$store.getters.instance.patch('/api/system/' + systemId + '/', {
        force_shutdown: true
      });
    },
    separateDeviceBySys: function separateDeviceBySys(errorDevices) {
      var _this2 = this;

      this.errorDevicesPreviousBySys = {};
      errorDevices.forEach(function (item) {
        if (!(item.system in _this2.errorDevicesPreviousBySys)) {
          _this2.errorDevicesPreviousBySys[item.system] = [];
        } else {
          _this2.errorDevicesPreviousBySys[item.system].push(item);
        }
      });
    }
  },
  computed: {
    messageStatus: function messageStatus() {
      return this.$store.getters.messageStatus;
    },
    time: function time() {
      return this.month + '/' + this.day + ' ' + this.hour + ':' + this.min + ':' + this.sec;
    },
    lowCount: function lowCount() {
      return this.$store.state.drugInDevice.drugInDeviceLowStockList.length;
    },
    outdateCount: function outdateCount() {
      return this.$store.state.drugInDevice.expiredDrugInDevice.length;
    },
    storageErrorCount: function storageErrorCount() {
      return this.$store.state.drugInDevice.storageErrorCount;
    },
    medAppPrivilege: function medAppPrivilege() {
      return this.$store.state.user.user.med_app_privilege;
    },
    errorDevices: function errorDevices() {
      return this.$store.state.device.errorDevices;
    },
    all_functions: function all_functions() {
      return this.$store.state.apps;
    }
  },
  filters: {
    areaFormat: function areaFormat(obj) {
      return obj.department.name + obj.name;
    }
  },
  watch: {
    errorDevices: function errorDevices() {
      this.debouncedDetectErrorDevice(this);
    },
    messageStatus: function messageStatus(val) {
      var _this3 = this;

      if (val === false) {
        if (this.errorDevicesAndPreviousErrorDevicesAreSame()) {
          console.log('same error devices');
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.errorDevicesPreviousBySys).forEach(function (errorDevicesInSys) {
            if (_this3.hasAtLeastTwoErrorDrawers(errorDevicesInSys)) {
              var systemId = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this3.$store.getters.systems)[errorDevicesInSys[0].system];
              _this3.forceShutDown(systemId);
            }
          });
          if (this.hasAtLeastTwoErrorDrawers(this.errorDevicesPrevious)) {
            this.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: '因硬體問題，已限制藥櫃取用。請與工程人員聯絡或重新登入。',
              keepOnTop: true
            });
            this.$router.push({ name: 'Login' });
          }
        } else {
          console.log('not same error devices');
        }
        this.errorDevicesPrevious = this.errorDevices.slice();
        this.separateDeviceBySys(this.errorDevicesPrevious);
        console.log(val);
      }
    }
  }
});

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flowComp_ProgressBar__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flowComp_ProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__flowComp_ProgressBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flowComp_EventTable__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flowComp_EventTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__flowComp_EventTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_BottomButtons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_BottomButtons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_BottomButtons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RecycleDrugFlow_MultiFlow__ = __webpack_require__(1298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RecycleDrugFlow_MultiFlow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__RecycleDrugFlow_MultiFlow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ComponentBase_AppBase__ = __webpack_require__(33);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RecycleDrug',
  extends: __WEBPACK_IMPORTED_MODULE_6__ComponentBase_AppBase__["a" /* default */],
  data: function data() {
    return {
      eventType: 'RETURN'
    };
  },

  computed: {
    currentSystem: function currentSystem() {
      return this.$store.getters.currentSystem;
    }
  },
  components: {
    progressBar: __WEBPACK_IMPORTED_MODULE_1__flowComp_ProgressBar___default.a,
    EventTable: __WEBPACK_IMPORTED_MODULE_2__flowComp_EventTable___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_3__common_Loader___default.a,
    MultiFlow: __WEBPACK_IMPORTED_MODULE_5__RecycleDrugFlow_MultiFlow___default.a,
    BottomButtons: __WEBPACK_IMPORTED_MODULE_4__common_BottomButtons___default.a
  },
  created: function created() {
    this.stage = 'selectEvent';
    this.progress = this.setupProgress();
    this.multiProgress = this.setupMultiProgress();
    this.confirmProgress = this.setupConfirmProgress();
    this.$store.commit('SET_CURRENT_STEP', 'selectEvent');
  },
  mounted: function mounted() {},

  methods: {
    setupProgress: function setupProgress() {
      return [{ en: 'selectEvent', zh: '選擇退藥紀錄' }, { en: 'action', zh: '進行回收' }];
    },
    setupMultiProgress: function setupMultiProgress() {
      return ['confirm', 'finish'];
    },
    setupConfirmProgress: function setupConfirmProgress() {
      return ['action', 'finish'];
    },
    cancel: function cancel() {
      this.$router.push({ name: 'Main' });
      this.$store.dispatch('recordAction', { eventType: 'CANCEL_RECYCLE' });
    },
    startFlow: function startFlow() {
      if (this.$store.state.event.selectedEventId.length !== 0) {
        this.stage = 'setFlowData';
      } else {
        this.$store.commit('SET_MESSAGE', { type: 'error', context: '請置少選擇一項事件' });
      }
    },
    getAllConfirmData: function getAllConfirmData(data) {
      var _this = this;

      this.$store.dispatch('resetAll');
      this.stage = 'finish';
      setTimeout(function () {
        _this.stage = 'selectEvent';
      }, 1300);
      // this.$router.push({ name: 'Main' });
    }
  }
});

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ComponentBase_ConfirmFlowBase__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flowComp_Action__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flowComp_Action___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__flowComp_Action__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_Loader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ConfirmFlow',
  extends: __WEBPACK_IMPORTED_MODULE_0__ComponentBase_ConfirmFlowBase__["a" /* default */],
  props: [],
  data: function data() {
    return {
      amount: 0,
      emitTimes: 0
    };
  },

  components: {
    Action: __WEBPACK_IMPORTED_MODULE_1__flowComp_Action___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_2__common_Loader___default.a
  },
  mounted: function mounted() {
    this.$store.commit('SET_CURRENT_STEP', this.currentProgress);
  },

  methods: {
    getActionData: function getActionData(data) {
      if (this.emitTimes === 0) {
        this.amount = data.num;
        this.emitData();
      }
      this.emitTimes += 1;
    },
    emitData: function emitData() {
      this.nextProgress();
      var event = {
        id: this.currentEvent.id,
        checked: true
      };
      // delete the drugStorage
      this.instance.delete('/api/drug-storage/' + this.currentEvent.drug_storage + '/', {
        data: {
          type: 'RECYCLE'
        }
      });
      this.$emit('confirmationFinish');
      // patch the event as checked.
      this.instance.patch('/api/event/' + event.id + '/', event);
      this.resetProgress();
      this.emitTimes = 0;
    }
  },
  computed: {}
});

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flowComp_DrugInfo__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flowComp_DrugInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__flowComp_DrugInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConfirmFlow__ = __webpack_require__(1297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConfirmFlow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ConfirmFlow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ComponentBase_MultiFlowBase__ = __webpack_require__(38);

//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'multiFlow',
  extends: __WEBPACK_IMPORTED_MODULE_4__ComponentBase_MultiFlowBase__["a" /* default */],
  props: [],
  data: function data() {
    return {};
  },

  components: {
    DrugInfo: __WEBPACK_IMPORTED_MODULE_1__flowComp_DrugInfo___default.a,
    ConfirmFlow: __WEBPACK_IMPORTED_MODULE_2__ConfirmFlow___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_3__common_Loader___default.a
  },
  methods: {
    getConfirmData: function getConfirmData() {
      var _this = this;

      this.nextProgress();
      if (this.nextEvent === null) {
        this.$emit('setAllConfirmData');
      } else {
        this.$store.dispatch('toNextEvent');
        console.log('next event');
        setTimeout(function () {
          _this.resetProgress();
        }, 200);
      }
    }
  },
  created: function created() {
    this.$store.dispatch('fromFirstEvent');
  },
  mounted: function mounted() {},

  computed: {
    selectedEvent: function selectedEvent() {
      return this.$store.state.event.selectedEvent;
    },
    eventKeys: function eventKeys() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.state.event.selectedEvent);
    }
  }
});

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flowComp_ProgressBar__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flowComp_ProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__flowComp_ProgressBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flowComp_EventTable__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flowComp_EventTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__flowComp_EventTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ComponentBase_AppBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RecycleEmptyFlow_MultiFlow__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RecycleEmptyFlow_MultiFlow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__RecycleEmptyFlow_MultiFlow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_BottomButtons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_BottomButtons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_BottomButtons__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReturnEmpty',
  extends: __WEBPACK_IMPORTED_MODULE_2__ComponentBase_AppBase__["a" /* default */],
  data: function data() {
    return {
      eventType: 'RETURN_EMPTY',
      stage: ''
    };
  },

  components: {
    progressBar: __WEBPACK_IMPORTED_MODULE_0__flowComp_ProgressBar___default.a,
    eventTable: __WEBPACK_IMPORTED_MODULE_1__flowComp_EventTable___default.a,
    BottomButtons: __WEBPACK_IMPORTED_MODULE_5__common_BottomButtons___default.a,
    MultiFlow: __WEBPACK_IMPORTED_MODULE_3__RecycleEmptyFlow_MultiFlow___default.a
  },
  created: function created() {
    this.progress = this.setupProgress();
    this.multiProgress = this.setupMultiProgress();
    this.confirmProgress = this.setupConfirmProgress();
    this.actionProgress = this.setupActionProgress();
    this.$store.commit('SET_CURRENT_STEP', 'selectEvent');
    this.stage = 'eventList';
  },

  methods: {
    cancel: function cancel() {
      this.$store.dispatch('recordAction', { eventType: 'CANCEL_RECYCLE_EMPTY' });
      this.$router.push({ name: 'Main' });
    },
    setupProgress: function setupProgress() {
      var prog = [];
      prog.push({ en: 'selectEvent', zh: '選擇事件' });
      // prog.push({ en: 'setStorage', zh: '空瓶交換數量' });
      prog.push({ en: 'action', zh: '開始動作' });
      return prog;
    },
    setupMultiProgress: function setupMultiProgress() {
      var prog = [];
      prog.push('confirm');
      prog.push('finish');
      return prog;
    },
    setupConfirmProgress: function setupConfirmProgress() {
      var prog = [];
      // prog.push('setStorage');
      prog.push('action');
      return prog;
    },
    setupActionProgress: function setupActionProgress() {
      var prog = [];
      prog.push('action');
      prog.push('next');
      return prog;
    },
    startFlow: function startFlow() {
      this.stage = 'setFlowData';
    },
    getAllConfirmData: function getAllConfirmData() {
      this.$store.dispatch('resetAll');
      this.$store.dispatch('getDrugInDevices');
      this.stage = 'eventList';
      this.$store.commit('SET_CURRENT_STEP', 'selectEvent');
    }
  }
});

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_Action__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_Action___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__flowComp_Action__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_Loader__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ActionWrap',
  props: ['amountPayload'],
  data: function data() {
    return {
      stage: ''
    };
  },

  components: {
    Action: __WEBPACK_IMPORTED_MODULE_3__flowComp_Action___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_4__common_Loader___default.a
  },
  computed: {
    currentEvent: function currentEvent() {
      return this.$store.state.event.currentEvent;
    },
    currentDrugInDevice: function currentDrugInDevice() {
      return this.$store.getters.currentDrugInDevice;
    },
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  mounted: function mounted() {
    this.stage = 'action';
    this.$store.commit('SET_CURRENT_STEP', 'action');
  },

  methods: {
    asyncForEach: function asyncForEach(promises) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('start');
                // promises.forEach(async (p) => {
                //   console.log(p);
                //   await p;
                // });
                console.log('done');

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getThisAmount: function getThisAmount(data) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var promises, _loop, i, sentData;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                // 注意：回收空瓶數量是不能讓user調整的
                _this2.stage = 'finish';

                // 如果有先執行 refineSelectedEvents 的話

                if (!_this2.currentEvent.sameDeviceEvent) {
                  _context5.next = 13;
                  break;
                }

                promises = [];
                _loop = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _loop(i) {
                  var currentEvent, drugStorage, sentData;
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _loop$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          currentEvent = _this2.currentEvent.sameDeviceEvent[i];
                          drugStorage = _this2.$store.state.drugInDevice.allDrugInDevice[currentEvent.drug_storage];

                          // the "num" attribute is the amount of empty amount for returning.

                          sentData = {
                            id: drugStorage.id,
                            device: drugStorage.device.id,
                            stock: drugStorage.stock,
                            max_stock: drugStorage.max_stock,
                            expired_date: drugStorage.expired_date,
                            patch_number: drugStorage.patch_number,
                            medication: drugStorage.medication.id,
                            number1: currentEvent.number1,
                            pack_count: drugStorage.pack_count,
                            empty_count: drugStorage.empty_count - currentEvent.number1,
                            type: 'RECYCLE_EMPTY'
                          };
                          // after saving the empty count to drugStorage, we need to update the event as returned.
                          /* eslint-disable no-await-in-loop */

                          _context3.next = 5;
                          return _this2.instance.put('/api/drug-storage/' + sentData.id + '/', sentData).then(function () {
                            var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(res) {
                              var recoredEventIDs, event;
                              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                                while (1) {
                                  switch (_context2.prev = _context2.next) {
                                    case 0:
                                      recoredEventIDs = [];
                                      // keep the old relative event.

                                      currentEvent.related_events.forEach(function (item) {
                                        if (item.id !== null) {
                                          recoredEventIDs.push(item.id);
                                        }
                                      });
                                      // add new.
                                      recoredEventIDs.push(res.data);
                                      event = {
                                        id: currentEvent.id,
                                        checked: true,
                                        related_events: recoredEventIDs
                                      };
                                      /* eslint-disable no-await-in-loop */

                                      _context2.next = 6;
                                      return _this2.instance.patch('/api/event/' + event.id + '/', event);

                                    case 6:
                                    case 'end':
                                      return _context2.stop();
                                  }
                                }
                              }, _callee2, _this2);
                            }));

                            return function (_x) {
                              return _ref.apply(this, arguments);
                            };
                          }());

                        case 5:
                        case 'end':
                          return _context3.stop();
                      }
                    }
                  }, _loop, _this2);
                });
                i = 0;

              case 5:
                if (!(i < _this2.currentEvent.sameDeviceEvent.length)) {
                  _context5.next = 10;
                  break;
                }

                return _context5.delegateYield(_loop(i), 't0', 7);

              case 7:
                i += 1;
                _context5.next = 5;
                break;

              case 10:
                // await this.asyncForEach(promises);
                _this2.$emit('setActionData');
                _context5.next = 15;
                break;

              case 13:
                // the "num" attribute is the amount of empty amount for returning.
                sentData = {
                  id: _this2.currentDrugInDevice.id,
                  device: _this2.currentDrugInDevice.device.id,
                  stock: _this2.currentDrugInDevice.stock,
                  max_stock: _this2.currentDrugInDevice.max_stock,
                  expired_date: _this2.currentDrugInDevice.expired_date,
                  patch_number: _this2.currentDrugInDevice.patch_number,
                  medication: _this2.currentDrugInDevice.medication.id,
                  number1: data.num,
                  pack_count: _this2.currentDrugInDevice.pack_count,
                  empty_count: _this2.currentDrugInDevice.empty_count - data.num,
                  type: 'RECYCLE_EMPTY'
                };
                // after saving the empty count to drugStorage, we need to update the event as returned.

                _this2.instance.put('/api/drug-storage/' + sentData.id + '/', sentData).then(function () {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(res) {
                    var recoredEventIDs, event;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            recoredEventIDs = [];

                            _this2.currentEvent.related_events.forEach(function (item) {
                              if (item.id !== null) {
                                recoredEventIDs.push(item.id);
                              }
                            });
                            recoredEventIDs.push(res.data);
                            event = {
                              id: _this2.currentEvent.id,
                              checked: true,
                              related_events: recoredEventIDs
                            };
                            _context4.next = 6;
                            return _this2.instance.patch('/api/event/' + event.id + '/', event);

                          case 6:
                            _this2.$emit('setActionData');

                          case 7:
                          case 'end':
                            return _context4.stop();
                        }
                      }
                    }, _callee3, _this2);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 15:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee4, _this2);
      }))();
    }
  }
});

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flowComp_NumberSet__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flowComp_NumberSet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__flowComp_NumberSet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ComponentBase_ConfirmFlowBase__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ActionWrap__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ActionWrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ActionWrap__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'confirmFlow',
  extends: __WEBPACK_IMPORTED_MODULE_1__ComponentBase_ConfirmFlowBase__["a" /* default */],
  components: {
    ConfirmStorage: __WEBPACK_IMPORTED_MODULE_0__flowComp_NumberSet___default.a,
    ActionWrap: __WEBPACK_IMPORTED_MODULE_2__ActionWrap___default.a
  },
  data: function data() {
    return {
      amountPayload: {
        emptyCount: 0
      }
    };
  },
  mounted: function mounted() {
    this.$store.commit('SET_CURRENT_STEP', this.currentProgress);
    this.amountPayload.emptyCount = Math.abs(this.currentEvent.number1); // recycle all amount in the event.
  },

  methods: {
    getStorage: function getStorage(num) {
      this.amountPayload.emptyCount = num;
      if (num > Math.abs(this.currentEvent.number1)) {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '回收空瓶數量不可大於該次退回空瓶數量'
        });
      } else {
        this.nextProgress();
      }
    },
    getActionData: function getActionData(val) {
      this.resetProgress();
      this.$emit('confirmationFinish');
    }
  }
});

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConfirmFlow__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConfirmFlow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ConfirmFlow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flowComp_DrugInfo__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flowComp_DrugInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__flowComp_DrugInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ComponentBase_MultiFlowBase__ = __webpack_require__(38);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'multiFlow',
  extends: __WEBPACK_IMPORTED_MODULE_3__ComponentBase_MultiFlowBase__["a" /* default */],
  components: {
    ConfirmFlow: __WEBPACK_IMPORTED_MODULE_0__ConfirmFlow___default.a,
    DrugInfo: __WEBPACK_IMPORTED_MODULE_1__flowComp_DrugInfo___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_2__common_Loader___default.a
  },
  methods: {
    getConfirmData: function getConfirmData() {
      var _this = this;

      console.log('get confirm data');
      this.nextProgress();
      if (this.nextEvent !== null) {
        this.$store.dispatch('toNextEvent');
        setTimeout(function () {
          _this.resetProgress();
        }, 200);
      } else {
        this.$emit('setAllConfirmData');
      }
    }
  },
  created: function created() {
    this.$store.dispatch('refineSelectedEvents');
    this.$store.dispatch('fromFirstEvent');
  },

  computed: {
    selectedEventId: function selectedEventId() {
      return this.$store.state.event.selectedEventId;
    }
  }
});

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__flowComp_DrugInDeviceList__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__flowComp_DrugInDeviceList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__flowComp_DrugInDeviceList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__flowComp_ProgressBar__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__flowComp_ProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__flowComp_ProgressBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RefillDrugFlow_MultiFlow__ = __webpack_require__(1306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RefillDrugFlow_MultiFlow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__RefillDrugFlow_MultiFlow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_BottomButtons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_BottomButtons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__common_BottomButtons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__flowComp_ScanBarcode__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__flowComp_ScanBarcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__flowComp_ScanBarcode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__flowComp_RefillSelection__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__flowComp_RefillSelection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__flowComp_RefillSelection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ComponentBase_AppBase__ = __webpack_require__(33);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RefillDrug',
  extends: __WEBPACK_IMPORTED_MODULE_14__ComponentBase_AppBase__["a" /* default */],
  components: {
    drugList: __WEBPACK_IMPORTED_MODULE_7__flowComp_DrugInDeviceList___default.a,
    progressBar: __WEBPACK_IMPORTED_MODULE_8__flowComp_ProgressBar___default.a,
    MultiFlow: __WEBPACK_IMPORTED_MODULE_9__RefillDrugFlow_MultiFlow___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_10__common_Loader___default.a,
    BottomButtons: __WEBPACK_IMPORTED_MODULE_11__common_BottomButtons___default.a,
    ScanBarcode: __WEBPACK_IMPORTED_MODULE_12__flowComp_ScanBarcode___default.a,
    RefillSelection: __WEBPACK_IMPORTED_MODULE_13__flowComp_RefillSelection___default.a
  },
  data: function data() {
    return {
      enterType: '',
      showRefillSelection: false,
      drugStorageIdsForSelected: [],
      startType: 'refill',
      refillToNewDevice: false
    };
  },

  computed: {},
  created: function created() {
    this.stage = 'selectDrug';
    this.progress = this.setupProgress();
    this.multiProgress = this.setupMultiProgress();
    this.confirmProgress = this.setupConfirmProgress();
    this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$store.dispatch('getRefillOrder');

            case 2:
              _context.next = 4;
              return _this.getRefillData();

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    setupProgress: function setupProgress() {
      var prog = [];
      prog.push({ en: 'selectDrug', zh: '選擇補充藥物' });
      if (this.refillToNewDevice) {
        prog.push({ en: 'setMaxAmount', zh: '設定最大庫存' });
      } else {
        prog.push({ en: 'setPatch', zh: '確認批號' });
      }
      prog.push({ en: 'setExpirationDate', zh: '確認效期' });
      if (this.$store.state.user.user.task_privilege.refill_drug === false) {
        prog.push({ en: 'rxCheck', zh: '覆核動作' });
      }
      prog.push({ en: 'action', zh: '進行補藥' });
      return prog;
    },
    setupMultiProgress: function setupMultiProgress() {
      return ['confirm', 'finish'];
    },
    setupConfirmProgress: function setupConfirmProgress() {
      var p = [];
      // remove individual refill temporaily. please notice this might effect the old version.
      if (this.refillToNewDevice) {
        p.push('setMaxAmount');
      } else {
        p.push('setPatch');
      }
      p.push('setExpirationDate');
      p.push('autoCalcRefillPayload');
      if (this.$store.state.user.user.task_privilege.refill_drug === false) {
        p.push('rxCheck');
      }
      p.push('action');
      p.push('finish');
      return p;
    },
    getDrugStorages: function getDrugStorages(drugStorageList, targetMedId) {
      return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.filter(drugStorageList, function (drugStorage) {
        return drugStorage.medication.id === targetMedId;
      });
    },
    getBarcode: function getBarcode(val) {
      var _this2 = this;

      this.instance.get('/api/medication/', { params: { package_code2: val } }).then(function (res) {
        if (res.data.total === 0) {
          _this2.instance.get('/api/medication/', { params: { package_code: val } }).then(function (res) {
            if (res.data.total === 0) {
              _this2.$store.commit('SET_MESSAGE', {
                type: 'warn',
                context: '查無此藥物，請確認條碼為藥盒(身)條碼'
              });
            } else {
              var targetMed = res.data.results[0];
              var drugStorages = [];
              //20190408 料位號(targetMed.CGMH_number)
              console.log(targetMed.CGMH_number);
              _this2.$store.commit('FILTER_DRUG_IN_DEVICE', { mode: '', searchText: targetMed.CGMH_number });
              /////////////////////////////////////////////////
              // search refill planning first.
              drugStorages = _this2.getDrugStorages(_this2.$store.state.drugInDevice.RefillDrugInDeviceList, targetMed.id);
              if (drugStorages.length === 0) {
                drugStorages = _this2.getDrugStorages(_this2.$store.getters.drugInDeviceList, targetMed.id);
              }
              if (drugStorages.length === 1) {
                _this2.$store.commit('SELECT_DRUG_IN_DEVICES_FROM_ALL', drugStorages[0].id);
                _this2.$store.commit('SET_CURRENT_DEVICE_FROM_ALL', drugStorages[0].device.id);
                _this2.$store.dispatch('setDrug', drugStorages[0].medication.id);
                _this2.stage = 'setFlowData';
              } else if (drugStorages.length > 1) {
                _this2.drugStorageIdsForSelected = drugStorages.map(function (x) {
                  return x.id;
                });
                //this.showRefillSelection = true;
              } else {
                _this2.$store.commit('SET_MESSAGE', {
                  type: 'warn',
                  context: '藥櫃內無存放此藥物'
                });
              }
            }
          });
        } else {
          var targetMed = res.data.results[0];
          var drugStorages = [];
          //20190408 料位號(targetMed.CGMH_number)
          console.log(targetMed.CGMH_number);
          _this2.$store.commit('FILTER_DRUG_IN_DEVICE', { mode: '', searchText: targetMed.CGMH_number });
          /////////////////////////////////////////////////    
          // search refill planning first.
          drugStorages = _this2.getDrugStorages(_this2.$store.state.drugInDevice.RefillDrugInDeviceList, targetMed.id);
          if (drugStorages.length === 0) {
            drugStorages = _this2.getDrugStorages(_this2.$store.getters.drugInDeviceList, targetMed.id);
          }
          if (drugStorages.length === 1) {
            _this2.$store.commit('SELECT_DRUG_IN_DEVICES_FROM_ALL', drugStorages[0].id);
            _this2.$store.commit('SET_CURRENT_DEVICE_FROM_ALL', drugStorages[0].device.id);
            _this2.$store.dispatch('setDrug', drugStorages[0].medication.id);
            _this2.stage = 'setFlowData';
          } else if (drugStorages.length > 1) {
            _this2.drugStorageIdsForSelected = drugStorages.map(function (x) {
              return x.id;
            });
            //this.showRefillSelection = true;
          } else {
            _this2.$store.commit('SET_MESSAGE', {
              type: 'warn',
              context: '藥櫃內無存放此藥物'
            });
          }
        }
      });
    },
    selectionDone: function selectionDone() {
      this.showRefillSelection = false;
      this.stage = 'setFlowData';
    },
    cancel: function cancel() {
      this.$router.push({ name: 'Main' });
      this.$store.dispatch('recordAction', { eventType: 'CANCEL_REFILL' });
    },
    cancelSelection: function cancelSelection() {
      this.showRefillSelection = false;
    },
    changeStage: function changeStage(val) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.deselectAll(); // clear the buffer

                if (!(val === 'selectDrug')) {
                  _context2.next = 4;
                  break;
                }

                _context2.next = 4;
                return _this3.getRefillData();

              case 4:
                if (!(val === 'selectLowStock')) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 7;
                return _this3.$store.dispatch('getLowStockDrugInDevice');

              case 7:
                if (!(val === 'refill')) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 10;
                return _this3.$store.dispatch('getRefillOrder');

              case 10:
                _this3.stage = val;

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    startFlow: function startFlow() {
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.$store.state.drugInDevice.selectedDrugInDevice).length === 0) {
        this.$store.commit('SET_MESSAGE', { type: 'error', context: '請至少選擇一項儲存藥物' });
      } else {
        this.stage = 'setFlowData';
      }
    },
    getNewDeviceForRefill: function getNewDeviceForRefill(deviceId) {
      // update progress
      this.refillToNewDevice = true;
      this.progress = this.setupProgress();
      this.$store.commit('SET_PROGRESS', this.progress);
      this.confirmProgress = this.setupConfirmProgress();
      // update data and start flow.
      this.$store.commit('SET_CURRENT_DEVICE_FROM_ALL', deviceId);
      this.stage = 'setFlowData';
      this.startType = 'createNewDrugStorage';
    },
    getRefillData: function getRefillData() {
      var _this4 = this;

      // filter out the drugStorage in the refill plan.
      return this.instance.get('/api/drug-storage/', {
        params: {
          device__net__system: this.$store.state.device.systemId,
          refill: true
        }
      }).then(function (res) {
        var filteredList = [];
        res.data.results.forEach(function (item) {
          item.selected = false;
          var theExpiredDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()(item.expired_date);
          var todayDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()();
          var remainExpiredDays = theExpiredDate.diff(todayDate, 'days');
          if (remainExpiredDays >= 0) {
            filteredList.push(item);
          }
        });

        _this4.$store.commit('SET_DRUG_IN_DEVICE_LIST', filteredList);
      });
    },
    getAllConfirmData: function getAllConfirmData(data) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this5.stage = 'finish';
                _this5.$store.dispatch('resetAll');
                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([_this5.$store.dispatch('getSystemInfo'), _this5.getRefillData(), _this5.$store.dispatch('getLowStockDrugInDevice'), _this5.$store.dispatch('getRefillOrder')]);

              case 4:
                _this5.$store.commit('SET_CURRENT_STEP', 'selectDrug');
                _this5.stage = 'selectDrug';
                _this5.startType = 'refill';
                _this5.progress = _this5.setupProgress();
                _this5.multiProgress = _this5.setupMultiProgress();
                _this5.confirmProgress = _this5.setupConfirmProgress();

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    selectAll: function selectAll() {
      this.$store.dispatch('unSelectAllDrugStorageAndDevices');
      this.$store.dispatch('selectAllDrugStorageAndDevices');
    },
    deselectAll: function deselectAll() {
      this.$store.dispatch('unSelectAllDrugStorageAndDevices');
    },
    getDrugStorageWithSameMed: function getDrugStorageWithSameMed(drugStorageList) {
      // save the selected medication information
      this.$store.dispatch('setDrug', drugStorageList[0].medication.id);
      // let user select drugStorage with same medication
      this.$store.commit('SET_DRUG_IN_DEVICE_LIST', drugStorageList);
      this.stage = 'DrugStorageInOneMed';
    }
  },
  watch: {
    stage: function stage(val) {
      switch (val) {
        case 'selectDrug':
          this.progress[0].zh = '選擇補充藥倉';
          this.$store.commit('SHOW_LOGOUT', true);
          break;
        case 'selectLowStock':
          this.progress[0].zh = '存量過低清單';
          this.$store.commit('SHOW_LOGOUT', true);
          break;
        case 'refill':
          this.progress[0].zh = '藥倉補藥規劃';
          this.$store.commit('SHOW_LOGOUT', true);
          break;
        default:
          this.$store.commit('SHOW_LOGOUT', false);
          console.log(this.stage);
      }
    }
  }
});

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flowComp_Action__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flowComp_Action___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__flowComp_Action__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RefillAction',
  props: ['amountPayload', 'startType'], // amount: 補充數量
  components: {
    Action: __WEBPACK_IMPORTED_MODULE_0__flowComp_Action___default.a
  },
  computed: {
    currentDrugInDevice: function currentDrugInDevice() {
      return this.$store.state.drugInDevice.currentDrugInDevice;
    },
    DrugStorageWithSameDrugID: function DrugStorageWithSameDrugID() {
      return this.$store.state.drugInDevice.DrugStorageWithSameDrugID;
    },
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  data: function data() {
    return {
      stage: '',
      totalAmount: 0, // already fetched
      DeviceInQueue: [], // device queue with same drug
      actionData: [],
      forAction: {
        defaultNum: 0,
        checkNum: 0,
        deviceId: 0
      },
      emitTimes: 0
    };
  },
  beforeCreate: function beforeCreate() {
    this.totalAmount = 0;
    this.DeviceInQueue = [];
    this.actionData = [];
  },
  created: function created() {
    if (this.startType === 'createNewDrugStorage') {
      this.forAction = {
        defaultNum: this.amountPayload.amount,
        checkNum: this.amountPayload.maxAmount,
        deviceId: this.$store.state.device.currentDevice.id
      };
    } else {
      // prepare for the first Action child.
      this.DeviceInQueue = this.DrugStorageWithSameDrugID;
      console.log(this.DeviceInQueue);
      console.log(this.currentDrugInDevice.id);
      this.DeviceInQueue.pop(this.DeviceInQueue.indexOf(this.currentDrugInDevice.id));
      this.forAction = {
        defaultNum: this.amountPayload.amount,
        checkNum: this.currentDrugInDevice.max_stock - this.currentDrugInDevice.stock,
        deviceId: this.currentDrugInDevice.device.id
      };
    }
    this.stage = 'action';
  },

  methods: {
    goOn: function goOn() {
      this.stage = 'action';
    },
    getThisAmount: function getThisAmount(data) {
      var _this = this;

      if (this.emitTimes === 0) {
        this.emitTimes += 1;
        console.log(data);
        console.log(this.amount, this.totalAmount);
        // data: device, num
        this.totalAmount += data.num;
        this.actionData.push(data);
        console.log(this.totalAmount);

        if (this.totalAmount < this.amount) {
          setInterval(function () {
            _this.goOn();
          }, 200);
          // go and take drug from another device.
          var nextDrugStorageId = this.DeviceInQueue.pop(0);
          console.log('[next drugstorageid]', nextDrugStorageId);

          this.instance.get('/api/drug-storage/' + nextDrugStorageId).then(function (res) {
            var data = res.data;
            _this.forAction = {
              defaultNum: _this.amountPayload.amount - _this.totalAmount, // the resident number for child.
              checkNum: data.stock,
              deviceId: data.device.id
            };
            console.log(_this.forAction);
          });
        } else {
          this.$emit('setActionData', this.actionData);
          // this.emitTimes = 0;
          console.log('finished');
        }
      }
    }
  }
});

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_TextInput__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_TextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__flowComp_TextInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flowComp_DateSelection__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flowComp_DateSelection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__flowComp_DateSelection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flowComp_NumberSet__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flowComp_NumberSet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__flowComp_NumberSet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flowComp_PackAndPieceSet__ = __webpack_require__(1353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flowComp_PackAndPieceSet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__flowComp_PackAndPieceSet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ActionWrap__ = __webpack_require__(1304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ActionWrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ActionWrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ComponentBase_ConfirmFlowBase__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__flowComp_RxCheckBarcode__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__flowComp_RxCheckBarcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__flowComp_RxCheckBarcode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__flowComp_MaxStockSet__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__flowComp_MaxStockSet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__flowComp_MaxStockSet__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ConfirmFlow',
  extends: __WEBPACK_IMPORTED_MODULE_9__ComponentBase_ConfirmFlowBase__["a" /* default */],
  props: ['startType'],
  data: function data() {
    return {
      defaultAmount: 0,
      maxAmount: undefined,
      actionData: [],
      patch: '',
      expirationDate: '',
      refillNum: 0,
      amountPayload: null,
      reviewer: undefined
    };
  },

  components: {
    ConfirmText: __WEBPACK_IMPORTED_MODULE_3__flowComp_TextInput___default.a,
    ConfirmExpirationDate: __WEBPACK_IMPORTED_MODULE_4__flowComp_DateSelection___default.a,
    ConfirmStorage: __WEBPACK_IMPORTED_MODULE_5__flowComp_NumberSet___default.a,
    PackAndPieceSet: __WEBPACK_IMPORTED_MODULE_6__flowComp_PackAndPieceSet___default.a,
    ActionWrap: __WEBPACK_IMPORTED_MODULE_7__ActionWrap___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_8__common_Loader___default.a,
    RxCheckBarcode: __WEBPACK_IMPORTED_MODULE_10__flowComp_RxCheckBarcode___default.a,
    MaxStockSet: __WEBPACK_IMPORTED_MODULE_11__flowComp_MaxStockSet___default.a
  },
  methods: {
    getMaxAmountData: function getMaxAmountData(payload) {
      this.patch = payload.patchNumber;
      this.maxAmount = payload.amount;
      this.nextProgress();
    },
    confirmRx: function confirmRx(reviewer) {
      this.reviewer = reviewer.id;
      this.nextProgress();
    },
    getPatch: function getPatch(text) {
      if (this.startType === 'createNewDrugStorage') {
        this.patch = text;
        this.nextProgress();
      } else {
        if (text !== this.currentDrugInDevice.patch_number && this.patchEditable === false) {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: '補充批號與原藥盒批號不同，請確認批號'
          });
        } else {
          if (this.currentDrugInDevice.medication.restrained_class > 0 && text === '') {
            this.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: '管制藥物必須設定批號'
            });
          } else {
            this.patch = text;
            this.nextProgress();
          }
          // this.$store.commit('SET_CURRENT_STEP', 'setExpirationDate');
        }
      }
    },
    getExpirationDate: function getExpirationDate(date) {
      this.expirationDate = date;
      this.nextProgress();
    },
    getPatchAndPieceData: function getPatchAndPieceData(payload) {
      this.amountPayload = payload;
      this.refillNum = parseInt(payload.amount, 10);
      if (this.refillNum + this.currentDrugInDevice.stock > this.currentDrugInDevice.max_stock) {
        this.$store.commit('SET_MESSAGE', { type: 'error', context: '補充數量不能大於總最大庫存' });
      } else {
        // start action.
        this.nextProgress();
      }
    },
    getActionData: function getActionData(data) {
      var _this = this;

      this.actionData = data;
      this.nextProgress();
      setTimeout(function () {
        _this.emitData();
      }, 100);
    },
    saveDrugStorage: function saveDrugStorage() {
      var _this2 = this;

      this.actionData.forEach(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(data) {
          var sentData, refillItem;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  sentData = {
                    id: _this2.currentDrugInDevice.id,
                    device: data.device,
                    stock: _this2.currentDrugInDevice.stock + data.num, // only update here.
                    max_stock: _this2.currentDrugInDevice.max_stock,
                    expired_date: _this2.expirationDate,
                    patch_number: _this2.patch,
                    medication: _this2.currentDrugInDevice.medication.id,
                    number1: data.num,
                    review_employee: _this2.reviewer,
                    pack_count: data.packCount + _this2.currentDrugInDevice.pack_count,
                    type: 'REFILL'
                  };
                  refillItem = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(_this2.$store.state.drugInDevice.RefillDrugInDeviceList, function (o) {
                    return o.id === sentData.id;
                  });

                  if (!refillItem) {
                    _context.next = 5;
                    break;
                  }

                  _context.next = 5;
                  return _this2.instance.delete('/api/refill-order/' + refillItem.refillId + '/');

                case 5:
                  _context.next = 7;
                  return _this2.instance.put('/api/drug-storage/' + sentData.id + '/', sentData);

                case 7:
                  _context.next = 9;
                  return _this2.$store.dispatch('updateCurrentDrugInDevice', sentData.id);

                case 9:
                  _this2.$emit('confirmationFinish');
                  _this2.resetProgress();

                case 11:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    createNewDrugStorageForRefill: function createNewDrugStorageForRefill() {
      var _this3 = this;

      var data = this.actionData[0];
      var sentData = {
        // id: this.currentDrugInDevice.id,
        device: data.device,
        stock: data.num, // only update here.
        max_stock: this.maxAmount,
        expired_date: this.expirationDate,
        patch_number: this.patch,
        medication: this.$store.state.drug.selectedDrug.id,
        number1: data.num,
        review_employee: this.reviewer,
        pack_count: data.packCount,
        type: 'REFILL'
      };

      this.instance.post('/api/drug-storage/', sentData).then(function () {
        _this3.$emit('confirmationFinish');
        _this3.resetProgress();
      });
    },
    emitData: function emitData() {
      console.log('confirm finished');
      if (this.startType === 'createNewDrugStorage') {
        this.createNewDrugStorageForRefill();
      } else {
        this.saveDrugStorage();
      }
    },
    calcRefillPayload: function calcRefillPayload() {
      if (this.startType === 'createNewDrugStorage') {
        this.amountPayload = {
          packCount: 0,
          pieceCount: 0,
          amount: 0,
          maxAmount: this.maxAmount
        };
      } else {
        var packCount = void 0;
        var pieceCount = void 0;
        // automatically calulate the refill amount.
        // const defaultRefillAmount = this.currentDrugInDevice.max_stock - this.currentDrugInDevice.stock;
        // if (this.selectedDrug.pack_content !== 0) {
        //   packCount = Math.floor(defaultRefillAmount / this.selectedDrug.pack_content);
        //   pieceCount = defaultRefillAmount % this.selectedDrug.pack_content;
        // } else {
        //   packCount = 0;
        //   pieceCount = defaultRefillAmount;
        // }

        var defaultRefillAmount = 0;
        this.amountPayload = {
          packCount: packCount,
          pieceCount: pieceCount,
          amount: defaultRefillAmount
        };
      }
    }
  },
  mounted: function mounted() {
    // set device
    var medId = this.$store.state.drug.selectedDrugID;
    this.$store.dispatch('getDrugInDevicesWithSameDrug', medId);
    this.$store.commit('SET_CURRENT_STEP', this.currentProgress);
  },

  computed: {
    selectedDrug: function selectedDrug() {
      return this.$store.getters.selectedDrug;
    },
    patchEditable: function patchEditable() {
      if (this.currentDrugInDevice && this.currentDrugInDevice.stock === 0) {
        return true;
      }
      if (this.startType === 'createNewDrugStorage') {
        return true;
      }
      return false;
    },
    dateEditable: function dateEditable() {
      if (this.currentDrugInDevice && this.currentDrugInDevice.stock === 0) {
        return true;
      }
      if (this.startType === 'createNewDrugStorage') {
        return true;
      }
      return false;
    },
    defaultPatchNumber: function defaultPatchNumber() {
      if (this.currentDrugInDevice) return this.currentDrugInDevice.patch_number;
      return undefined;
    },
    defaultExpirationDate: function defaultExpirationDate() {
      if (this.currentDrugInDevice) return this.currentDrugInDevice.expired_date;
      return undefined;
    },
    defaultRefillAmount: function defaultRefillAmount() {
      if (this.currentDrugInDevice) return this.currentDrugInDevice.max_stock - this.currentDrugInDevice.stock;
      return undefined;
    }
  },
  watch: {
    currentProgress: function currentProgress(val) {
      console.log(val);
      if (val === 'autoCalcRefillPayload') {
        this.calcRefillPayload();
        this.nextProgress();
      }
    }
  }
});

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ComponentBase_MultiFlowBase__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_DrugInfo__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_DrugInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__flowComp_DrugInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flowComp_SystemPanel__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flowComp_SystemPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__flowComp_SystemPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConfirmFlow__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ConfirmFlow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ConfirmFlow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__common_Loader__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'multiFlow',
  extends: __WEBPACK_IMPORTED_MODULE_2__ComponentBase_MultiFlowBase__["a" /* default */],
  props: ['startType'],
  data: function data() {
    return {};
  },

  components: {
    DrugInfo: __WEBPACK_IMPORTED_MODULE_3__flowComp_DrugInfo___default.a,
    SystemPanel: __WEBPACK_IMPORTED_MODULE_4__flowComp_SystemPanel___default.a,
    ConfirmFlow: __WEBPACK_IMPORTED_MODULE_5__ConfirmFlow___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_6__common_Loader___default.a
  },
  created: function created() {
    if (this.startType === 'createNewDrugStorage') {
      // nothing to do here.
    }
    if (this.startType === 'refill') {
      this.$store.dispatch('fromFirstDrugInDevice');
    }
  },

  methods: {
    getConfirmData: function getConfirmData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.nextProgress();

                if (!(_this.nextDrugInDevice !== null)) {
                  _context.next = 9;
                  break;
                }

                // check whether next index is over the keys' array length
                console.log('get confirm data');
                _context.next = 5;
                return _this.$store.dispatch('toNextDrugInDevice');

              case 5:
                setTimeout(function () {
                  _this.resetProgress();
                }, 200);
                _this.$store.commit('SET_CURRENT_STEP', 'setPatch');
                _context.next = 11;
                break;

              case 9:
                console.log('leave multiflow');
                _this.$emit('setAllConfirmData');

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  computed: {
    currentDrugInDeviceIndex: function currentDrugInDeviceIndex() {
      return this.$store.state.drugInDevice.currentDrugInDeviceIndex;
    },
    selectedDrugInDevice: function selectedDrugInDevice() {
      return this.$store.state.drugInDevice.selectedDrugInDevice;
    }
  }
});

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flowComp_PositionSelection__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flowComp_PositionSelection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__flowComp_PositionSelection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flowComp_DrugInDeviceList__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flowComp_DrugInDeviceList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__flowComp_DrugInDeviceList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flowComp_ProgressBar__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flowComp_ProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__flowComp_ProgressBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RemoveDrugFlow_MultiFlow__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RemoveDrugFlow_MultiFlow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__RemoveDrugFlow_MultiFlow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_BottomButtons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_BottomButtons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__common_BottomButtons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ComponentBase_AppBase__ = __webpack_require__(33);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CheckAmount',
  extends: __WEBPACK_IMPORTED_MODULE_9__ComponentBase_AppBase__["a" /* default */],
  components: {
    selectBox: __WEBPACK_IMPORTED_MODULE_4__flowComp_PositionSelection___default.a,
    drugList: __WEBPACK_IMPORTED_MODULE_5__flowComp_DrugInDeviceList___default.a,
    progressBar: __WEBPACK_IMPORTED_MODULE_6__flowComp_ProgressBar___default.a,
    MultiFlow: __WEBPACK_IMPORTED_MODULE_7__RemoveDrugFlow_MultiFlow___default.a,
    BottomButtons: __WEBPACK_IMPORTED_MODULE_8__common_BottomButtons___default.a
  },
  data: function data() {
    return {
      stage: ''
    };
  },
  created: function created() {
    this.stage = 'selectDrug';
    this.progress = this.setupProgress();
    this.multiProgress = this.setupMultiProgress();
    this.confirmProgress = this.setupConfirmProgress();
    this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
  },
  mounted: function mounted() {},

  computed: {},
  methods: {
    setupProgress: function setupProgress() {
      var p = [];
      p.push({ en: 'selectDrug', zh: '選擇藥物' });
      if (this.$store.state.generalSetting.check_amount_first) {
        p.push({ en: 'confirmAmount', zh: '確認數量' });
      }
      p.push({ en: 'action', zh: '移除藥物' });
      return p;
    },
    setupMultiProgress: function setupMultiProgress() {
      return ['confirm', 'finish'];
    },
    setupConfirmProgress: function setupConfirmProgress() {
      var p = [];
      if (this.$store.state.generalSetting.check_amount_first) {
        p.push('confirmAmount');
      }
      p.push('wait');
      p.push('action');
      p.push('finish');
      p.push('setMinStock');
      return p;
    },
    checkAll: function checkAll() {
      this.$store.dispatch('selectAllDrugStorageAndDevices');
    },
    unCheckAll: function unCheckAll() {
      this.$store.dispatch('unSelectAllDrugStorageAndDevices');
    },
    cancel: function cancel() {
      this.$router.push({ name: 'Main' });
      this.$store.dispatch('recordAction', { eventType: 'CANCEL_UNLOAD' });
    },
    startFlow: function startFlow() {
      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.$store.state.drugInDevice.selectedDrugInDevice).length === 0) {
        this.$store.commit('SET_MESSAGE', { type: 'error', context: '請至少選擇一項儲存藥物' });
      } else {
        this.stage = 'setFlowData';
      }
    },
    getAllConfirmData: function getAllConfirmData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$store.dispatch('resetAll');
                _context.next = 3;
                return _this.$store.dispatch('getSystemInfo');

              case 3:
                _context.next = 5;
                return _this.$store.dispatch('getDrugInDevices');

              case 5:
                _this.stage = 'selectDrug';
                _this.$store.commit('SET_CURRENT_STEP', 'selectDrug');

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ComponentBase_ConfirmFlowBase__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flowComp_Action__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flowComp_Action___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__flowComp_Action__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flowComp_NumberSet__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flowComp_NumberSet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__flowComp_NumberSet__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ConfirmFlow',
  extends: __WEBPACK_IMPORTED_MODULE_3__ComponentBase_ConfirmFlowBase__["a" /* default */],
  props: [],
  data: function data() {
    return {
      confirmAmount: 0,
      storageAmount: 0,
      totalStorageInSystemId: null,
      minStorage: null,
      emitTimes: 0,
      confirmPackCount: 0
    };
  },

  components: {
    Action: __WEBPACK_IMPORTED_MODULE_4__flowComp_Action___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_5__common_Loader___default.a,
    NumberSet: __WEBPACK_IMPORTED_MODULE_6__flowComp_NumberSet___default.a
  },
  beforeUpdate: function beforeUpdate() {
    if (this.currentProgress === 'action') {
      this.confirmAmount = this.currentDrugInDevice.stock;
      this.confirmPackCount = this.currentDrugInDevice.pack_count;
    }
  },

  methods: {
    getActionData: function getActionData() {
      this.emitTimes += 1;
      // prevent over emitting.
      if (this.emitTimes === 1) {
        this.emitData();
      }
    },
    getMinStorage: function getMinStorage(val) {
      var _this = this;

      this.instance.patch('/api/total-storage-in-system/' + this.totalStorageInSystemId + '/', {
        min_stock: val
      }).then(function (res) {
        _this.$emit('confirmationFinish');
        _this.resetProgress();
        _this.emitTimes = 0; // reset
      }).catch(function (err) {
        _this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '\u5B89\u5168\u5B58\u91CF\u4E0D\u53EF\u5927\u65BC\u7E3D\u6700\u5927\u5EAB\u5B58\u91CF: ' + err.response.data.max_stock,
          keepOnTop: true
        });
      });
    },
    emitData: function emitData() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var medId;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                medId = _this2.currentDrugInDevice.medication.id;

                _this2.nextProgress(); // let the loader showup
                _context2.next = 4;
                return _this2.instance.delete('/api/drug-storage/' + _this2.currentDrugInDevice.id + '/').then(function () {
                  // check whether other durg storage with same medication exists.
                  _this2.instance.get('/api/drug-storage/', {
                    params: {
                      medication: medId,
                      exclude_return_device: true,
                      device__net__system: _this2.$store.state.device.systemId
                    }
                  }).then(function () {
                    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res) {
                      var filteredList;
                      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              _context.next = 2;
                              return _this2.$store.dispatch('getTotalDrugAmountInstanly', medId);

                            case 2:
                              filteredList = [];

                              res.data.results.forEach(function (item) {
                                var theExpiredDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(item.expired_date);
                                var todayDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()();
                                var remainExpiredDays = theExpiredDate.diff(todayDate, 'days');
                                if (remainExpiredDays >= 0) {
                                  filteredList.push(item);
                                }
                              });
                              if (filteredList.length > 0) {
                                _this2.nextProgress(); // set for the min_stock
                                _this2.instance.get('/api/total-storage-in-system/?medication=' + medId).then(function (res) {
                                  _this2.totalStorageInSystemId = res.data.results[0].id;
                                  _this2.minStorage = parseInt(res.data.results[0].min_stock, 10);
                                  console.log(_this2.minStorage);
                                });
                              } else {
                                _this2.$emit('confirmationFinish');
                                _this2.resetProgress();
                                _this2.emitTimes = 0; // reset
                              }

                            case 5:
                            case 'end':
                              return _context.stop();
                          }
                        }
                      }, _callee, _this2);
                    }));

                    return function (_x) {
                      return _ref.apply(this, arguments);
                    };
                  }());
                });

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    confirmAmountFinish: function confirmAmountFinish(payload) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.$store.dispatch('updateCurrentDrugInDevice', _this3.currentDrugInDevice.id);

              case 2:
                _this3.confirmAmount = payload.totalSum;
                _this3.confirmPackCount = payload.packCount;
                _this3.nextProgress();
                setTimeout(function () {
                  _this3.nextProgress();
                }, 200);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  },
  created: function created() {
    if (this.currentProgress === 'wait') this.nextProgress();
  },

  computed: {}
});

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ComponentBase_MultiFlowBase__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_DrugInfo__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_DrugInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__flowComp_DrugInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConfirmFlow__ = __webpack_require__(1308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConfirmFlow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ConfirmFlow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_Loader__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'multiFlow',
  extends: __WEBPACK_IMPORTED_MODULE_2__ComponentBase_MultiFlowBase__["a" /* default */],
  props: [],
  data: function data() {
    return {};
  },

  components: {
    DrugInfo: __WEBPACK_IMPORTED_MODULE_3__flowComp_DrugInfo___default.a,
    ConfirmFlow: __WEBPACK_IMPORTED_MODULE_4__ConfirmFlow___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_5__common_Loader___default.a
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$store.dispatch('fromFirstDrugInDevice');

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    getConfirmData: function getConfirmData() {
      var _this2 = this;

      this.nextProgress();
      if (this.nextDrugInDevice !== null) {
        // check whether next index is over the keys' array length
        console.log('get confirm data');
        this.$store.dispatch('toNextDrugInDevice');
        setTimeout(function () {
          _this2.resetProgress();
        }, 200);
      } else {
        console.log('leave multiflow');
        this.$emit('setAllConfirmData');
      }
    }
  },
  computed: {}
});

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flowComp_ProgressBar__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flowComp_ProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__flowComp_ProgressBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RemoveOutdatedDrugFlow_MultiFlow__ = __webpack_require__(1312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RemoveOutdatedDrugFlow_MultiFlow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__RemoveOutdatedDrugFlow_MultiFlow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_BottomButtons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_BottomButtons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_BottomButtons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ComponentBase_AppBase__ = __webpack_require__(33);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RemoveOutdatedDrug',
  extends: __WEBPACK_IMPORTED_MODULE_8__ComponentBase_AppBase__["a" /* default */],
  components: {
    progressBar: __WEBPACK_IMPORTED_MODULE_4__flowComp_ProgressBar___default.a,
    MultiFlow: __WEBPACK_IMPORTED_MODULE_5__RemoveOutdatedDrugFlow_MultiFlow___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_6__common_Loader___default.a,
    BottomButtons: __WEBPACK_IMPORTED_MODULE_7__common_BottomButtons___default.a
  },
  data: function data() {
    return {
      tabStage: 'expired',
      graduallyExpireDrug: []
    };
  },
  created: function created() {
    this.stage = 'selectDrug';
    this.$store.commit('SET_DRUG_IN_DEVICE_LIST', this.expiredDrug);
    this.progress = this.setupProgress();
    this.multiProgress = this.setupMultiProgress();
    this.confirmProgress = this.setupConfirmProgress();
    this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
  },
  mounted: function mounted() {
    this.getGraduallyExpireDrug();
    this.$store.commit('SET_PROGRESS', this.progress);
  },

  computed: {
    expiredDrug: function expiredDrug() {
      return this.$store.state.drugInDevice.expiredDrugInDevice;
    },
    drugInDeviceList: function drugInDeviceList() {
      return this.$store.getters.drugInDeviceList;
    }
  },
  methods: {
    setupProgress: function setupProgress() {
      var p = [];
      p.push({ en: 'selectDrug', zh: '選擇過期藥物' });
      if (this.$store.state.generalSetting.check_amount_first) {
        p.push({ en: 'confirmAmount', zh: '確認數量' });
      }
      p.push({ en: 'action', zh: '進行移除' });
      return p;
    },
    setupMultiProgress: function setupMultiProgress() {
      return ['confirm', 'finish'];
    },
    setupConfirmProgress: function setupConfirmProgress() {
      var p = [];
      if (this.$store.state.generalSetting.check_amount_first) {
        p.push('confirmAmount');
      }
      p.push('wait');
      p.push('action');
      p.push('finish');
      p.push('setMinStock');
      return p;
    },
    checkAll: function checkAll() {
      this.$store.dispatch('selectAllDrugStorageAndDevices');
    },
    unCheckAll: function unCheckAll() {
      this.$store.dispatch('unSelectAllDrugStorageAndDevices');
    },
    cancel: function cancel() {
      this.$router.push({ name: 'Main' });
      this.$store.dispatch('recordAction', { eventType: 'CANCEL_OUTDATE' });
    },
    selectDrug: function selectDrug(num) {
      this.$store.dispatch('selectDrugInDevice', { num: num });
    },
    getGraduallyExpireDrug: function getGraduallyExpireDrug() {
      var _this = this;

      return this.instance.get('/api/drug-storage/', {
        params: {
          device__net__system: this.$store.state.device.systemId,
          expired: 'gradually_expired',
          days: this.$store.getters.currentSystem.settings.alert_outdated_day
        }
      }).then(function (res) {
        _this.graduallyExpireDrug = res.data.results;
      });
    },
    startFlow: function startFlow() {
      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.$store.state.drugInDevice.selectedDrugInDevice).length === 0) {
        this.$store.commit('SET_MESSAGE', { type: 'error', context: '請至少選擇一項儲存藥物' });
      } else {
        this.stage = 'setFlowData';
      }
    },
    getAllConfirmData: function getAllConfirmData() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.$store.dispatch('resetAll');
                _context.next = 3;
                return _this2.$store.dispatch('getDrugInDevices');

              case 3:
                _this2.$store.commit('SET_DRUG_IN_DEVICE_LIST', _this2.expiredDrug);
                _this2.stage = 'selectDrug';

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  }
});

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_Action__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_Action___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__flowComp_Action__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flowComp_NumberSet__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flowComp_NumberSet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__flowComp_NumberSet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ComponentBase_ConfirmFlowBase__ = __webpack_require__(37);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ConfirmFlow',
  extends: __WEBPACK_IMPORTED_MODULE_6__ComponentBase_ConfirmFlowBase__["a" /* default */],
  props: [],
  data: function data() {
    return {
      storageAmount: 0,
      totalStorageInSystemId: null,
      minStorage: null,
      confirmAmount: 0,
      emitTimes: 0,
      confirmPackCount: 0
    };
  },

  components: {
    Action: __WEBPACK_IMPORTED_MODULE_3__flowComp_Action___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_4__common_Loader___default.a,
    NumberSet: __WEBPACK_IMPORTED_MODULE_5__flowComp_NumberSet___default.a
  },
  mounted: function mounted() {
    this.$store.commit('SET_CURRENT_STEP', this.currentProgress);
  },
  beforeUpdate: function beforeUpdate() {
    if (this.currentProgress === 'action') {
      this.confirmAmount = this.currentDrugInDevice.stock;
      this.confirmPackCount = this.currentDrugInDevice.pack_count;
    }
  },

  methods: {
    getActionData: function getActionData() {
      this.emitTimes += 1;
      if (this.emitTimes === 1) {
        this.emitData();
      }
    },
    getMinStorage: function getMinStorage(val) {
      var _this = this;

      this.instance.patch('/api/total-storage-in-system/' + this.totalStorageInSystemId + '/', {
        min_stock: val
      }).then(function (res) {
        _this.nextProgress();
        _this.$emit('confirmationFinish');
        _this.resetProgress();
        _this.emitTimes = 0; // reset
      }).catch(function (err) {
        _this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '\u5B89\u5168\u5B58\u91CF\u4E0D\u53EF\u5927\u65BC\u7E3D\u6700\u5927\u5EAB\u5B58\u91CF: ' + err.response.data.max_stock,
          keepOnTop: true
        });
      });
    },
    emitData: function emitData() {
      var _this2 = this;

      var medId = this.currentDrugInDevice.medication.id;
      this.nextProgress();
      this.instance.delete('/api/drug-storage/' + this.currentDrugInDevice.id + '/', {
        data: {
          type: 'OUTDATE'
        }
      }).then(function () {
        // check whether other durg storage with same medication exists.
        _this2.instance.get('/api/drug-storage/', {
          params: {
            medication: medId,
            exclude_return_device: true,
            device__net__system: _this2.$store.state.device.systemId
          }
        }).then(function (res) {
          _this2.$store.dispatch('getTotalDrugAmountInstanly', medId);
          var filteredList = [];
          res.data.results.forEach(function (item) {
            var theExpiredDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(item.expired_date);
            var todayDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()();
            var remainExpiredDays = theExpiredDate.diff(todayDate, 'days');
            if (remainExpiredDays >= 0) {
              filteredList.push(item);
            }
          });
          if (filteredList.length > 0) {
            _this2.nextProgress(); // set for min_stock
            _this2.instance.get('/api/total-storage-in-system/?medication=' + medId).then(function (res) {
              _this2.totalStorageInSystemId = res.data.results[0].id;
              _this2.minStorage = parseInt(res.data.results[0].min_stock, 10);
              console.log(_this2.minStorage);
            });
          } else {
            _this2.$emit('confirmationFinish');
            _this2.resetProgress();
            _this2.emitTimes = 0; // reset
          }
        });
      });
    },
    confirmAmountFinish: function confirmAmountFinish(payload) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.$store.dispatch('updateCurrentDrugInDevice', _this3.currentDrugInDevice.id);

              case 2:
                _this3.confirmAmount = payload.totalSum;
                _this3.confirmPackCount = payload.packCount;
                _this3.nextProgress();
                setTimeout(function () {
                  _this3.nextProgress();
                }, 200);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    }
  },
  created: function created() {
    if (this.currentProgress === 'wait') this.nextProgress();
  },

  computed: {}
});

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ComponentBase_MultiFlowBase__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_DrugInfo__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_DrugInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__flowComp_DrugInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConfirmFlow__ = __webpack_require__(1311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConfirmFlow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ConfirmFlow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_Loader__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'multiFlow',
  extends: __WEBPACK_IMPORTED_MODULE_2__ComponentBase_MultiFlowBase__["a" /* default */],
  props: [],
  data: function data() {
    return {};
  },

  components: {
    DrugInfo: __WEBPACK_IMPORTED_MODULE_3__flowComp_DrugInfo___default.a,
    ConfirmFlow: __WEBPACK_IMPORTED_MODULE_4__ConfirmFlow___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_5__common_Loader___default.a
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$store.dispatch('fromFirstDrugInDevice');

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    getConfirmData: function getConfirmData() {
      var _this2 = this;

      this.nextProgress();
      if (this.nextDrugInDevice !== null) {
        // check whether next index is over the keys' array length
        console.log('get confirm data');
        this.$store.dispatch('toNextDrugInDevice');
        setTimeout(function () {
          _this2.resetProgress();
        }, 200);
      } else {
        console.log('leave multiflow');
        this.$emit('setAllConfirmData');
      }
    }
  },
  computed: {
    selectedDrugInDevice: function selectedDrugInDevice() {
      return this.$store.state.selectedDrugInDevice;
    }
  }
});

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_ProgressBar__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_ProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__flowComp_ProgressBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flowComp_ScanBarcode__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flowComp_ScanBarcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__flowComp_ScanBarcode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flowComp_EventTable__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flowComp_EventTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__flowComp_EventTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flowComp_DrugInDeviceList__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flowComp_DrugInDeviceList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__flowComp_DrugInDeviceList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ReturnDrugFlow_MultiFlow__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ReturnDrugFlow_MultiFlow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ReturnDrugFlow_MultiFlow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_BottomButtons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_BottomButtons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__common_BottomButtons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ComponentBase_AppBase__ = __webpack_require__(33);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReturnDrug',
  extends: __WEBPACK_IMPORTED_MODULE_10__ComponentBase_AppBase__["a" /* default */],
  data: function data() {
    return {
      startType: 'event',
      eventType: 'FETCH',
      drugSetMethod: 'barcode',
      barcodeData: {},
      returnScheduleId: null
    };
  },

  components: {
    progressBar: __WEBPACK_IMPORTED_MODULE_3__flowComp_ProgressBar___default.a,
    scanBarcode: __WEBPACK_IMPORTED_MODULE_4__flowComp_ScanBarcode___default.a,
    eventTable: __WEBPACK_IMPORTED_MODULE_5__flowComp_EventTable___default.a,
    MultiFlow: __WEBPACK_IMPORTED_MODULE_7__ReturnDrugFlow_MultiFlow___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_8__common_Loader___default.a,
    drugList: __WEBPACK_IMPORTED_MODULE_6__flowComp_DrugInDeviceList___default.a,
    BottomButtons: __WEBPACK_IMPORTED_MODULE_9__common_BottomButtons___default.a
  },
  created: function created() {
    if (this.$route.params.drugSetMethod) {
      this.drugSetMethod = this.$route.params.drugSetMethod;
    }
    this.stage = 'selectDrug';
    this.progress = this.setupProgress();
    this.multiProgress = this.setupMultiProgress();
    this.confirmProgress = this.setupConfirmProgress();
    this.actionProgress = this.setupActionWrapProgress();
  },
  mounted: function mounted() {
    this.$store.commit('SET_APP', '一般退藥');
    this.$store.commit('SET_PROGRESS', this.progress);
    this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
  },

  computed: {
    generalSetting: function generalSetting() {
      return this.$store.state.generalSetting;
    }
  },
  methods: {
    setupProgress: function setupProgress() {
      var prog = [];
      if (this.drugSetMethod === 'event') prog.push({ en: 'selectDrug', zh: '選擇事件' });
      if (this.drugSetMethod === 'manual') prog.push({ en: 'selectDrug', zh: '選擇位置' });
      if (this.drugSetMethod === 'barcode') prog.push({ en: 'selectDrug', zh: '掃描條碼' });
      prog.push({ en: 'selectReason', zh: '退藥理由' });
      prog.push({ en: 'medIdInput', zh: '輸入病歷號' });
      prog.push({ en: 'setPatchNo', zh: '確認批號' });
      prog.push({ en: 'setExpiredDate', zh: '確認效期' });
      prog.push({ en: 'setStorage', zh: '退藥數量' });
      if (this.$store.state.user.user.task_privilege.return_drug === false) {
        prog.push({ en: 'rxCheck', zh: '覆核動作' });
      }
      if (this.generalSetting.check_amount_first) {
        prog.push({ en: 'confirmAmount', zh: '確認數量' });
      }
      prog.push({ en: 'action', zh: '進行退藥' });
      return prog;
    },
    setupMultiProgress: function setupMultiProgress() {
      return ['confirm', 'returnEmpty', 'finish'];
    },
    setupConfirmProgress: function setupConfirmProgress() {
      var prog = [];
      prog.push('selectReason');
      prog.push('medIdInput');
      prog.push('setPatchNo');
      prog.push('setExpiredDate');
      prog.push('setStorage');
      if (this.$store.state.user.user.task_privilege.return_drug === false) {
        prog.push('rxCheck');
      }
      prog.push('action');
      return prog;
    },
    setupActionWrapProgress: function setupActionWrapProgress() {
      var prog = [];
      if (this.generalSetting.check_amount_first) {
        prog.push('confirmAmount');
      }
      prog.push('action');
      prog.push('next');
      return prog;
    },
    setDrugSetMethod: function setDrugSetMethod(val) {
      this.$store.dispatch('unSelectAllDrugStorageAndDevices');
      this.$store.dispatch('unSelectAllEvent');
      this.drugSetMethod = val;
      if (val === 'manual') {
        this.startType = 'drugStorage';
      }
      if (val === 'barcode') {
        this.startType = 'event';
      }
      if (val === 'event') {
        this.startType = 'event';
      }
      this.progress = this.setupProgress();
      this.$store.commit('SET_PROGRESS', this.progress);
    },
    cancel: function cancel() {
      this.$router.push({ name: 'Main' });
      this.$store.dispatch('recordAction', { eventType: 'CANCEL_RETURN' });
    },
    startFlow: function startFlow() {
      this.stage = 'setFlowData';
    },
    getAllConfirmData: function getAllConfirmData() {
      this.$store.dispatch('resetAll');
      this.$store.dispatch('getDrugInDevices');
      this.setDrugSetMethod('manual');
      this.stage = 'selectDrug';
      this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
      this.barcodeData = {};
    },
    returnByPackBarcode: function returnByPackBarcode(data) {
      var _this = this;

      // 長庚: 料位號 (3碼) + 數量(3碼) + 病歷號(7碼)
      var barcodeString = data.toString();
      //20190424 modified
      var code;
      var amount;
      var medRecordId;
      console.log('barcodeLen:', barcodeString.length);
      if (barcodeString.length >= 20 && barcodeString.length <= 22) {
        console.log('new barcode type');
        code = barcodeString.slice(0, 3);
        amount = parseInt(barcodeString.slice(3, 6), 10);
        medRecordId = barcodeString.slice(6, 18);
        medRecordId = medRecordId.split(' ').join(''); //filter space char  
        console.log('料位號:', code);
        console.log('數量:', amount);
        console.log('病歷號:', medRecordId);
      } else {
        console.log('old barcode type');
        code = barcodeString.slice(0, 3);
        amount = parseInt(barcodeString.slice(3, 6), 10);
        medRecordId = barcodeString.slice(6, barcodeString.length).split('\r')[0];
        //20190510 新增化療藥局的病歷號會帶空白
        medRecordId = medRecordId.split(' ').join(''); //filter space char
        console.log('料位號:', code);
        console.log('數量:', amount);
        console.log('病歷號:', medRecordId);
      }

      this.instance.get('/api/medication/', {
        params: {
          CGMH_number: code
        }
      }).then(function (res) {
        _this.instance.get('/api/event/', {
          params: {
            event: 'FETCH',
            med_record_no: medRecordId,
            number1: -amount,
            medication: res.data.results[0].id,
            drug_storage__isnull: false
          }
        }).then(function (res) {
          if (res.data.results.length === 0) {
            _this.$store.commit('SET_MESSAGE', { type: 'warn', context: '查無紀錄' });
          } else {
            _this.$store.dispatch('selectEvent', { eventId: res.data.results[0].id }).then(function () {
              _this.barcodeData.medRecordId = medRecordId;
              _this.barcodeData.amount = amount;
              console.log('success');
              _this.stage = 'setFlowData';
            });
          }
        });
      });
    },
    returnBySchedule: function returnBySchedule(data) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.returnScheduleId = parseInt(data.split(':')[1].split('***')[0], 10);
                _this2.drugSetMethod = 'returnSchedule';
                _context.next = 4;
                return _this2.$store.dispatch('setCurrentScheduleById', _this2.returnScheduleId);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    getBarcode: function getBarcode(scaned) {
      var data = scaned.toString();
      if (data.split(':')[0] === '***THC-schedule') {
        this.returnBySchedule(data);
      } else {
        this.returnByPackBarcode(data);
      }
    }
  },
  watch: {
    stage: function stage(val) {
      if (val === 'selectDrug') {
        this.$store.commit('SHOW_LOGOUT', true);
      } else {
        this.$store.commit('SHOW_LOGOUT', false);
      }
    }
  }
});

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flowComp_Action__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flowComp_Action___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__flowComp_Action__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_ReturnSelection__ = __webpack_require__(1357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_ReturnSelection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__flowComp_ReturnSelection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_Loader__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  props: ['amountPayload', 'actionProgress', 'returnToEmptyDeviceId', 'actionRecorded'],
  components: {
    Action: __WEBPACK_IMPORTED_MODULE_2__flowComp_Action___default.a,
    ReturnSelection: __WEBPACK_IMPORTED_MODULE_3__flowComp_ReturnSelection___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_4__common_Loader___default.a
  },
  computed: {
    currentDrugInDevice: function currentDrugInDevice() {
      return this.$store.state.drugInDevice.currentDrugInDevice;
    },
    currentSystem: function currentSystem() {
      return this.$store.getters.currentSystem;
    },
    selectedDrugTotalMax: function selectedDrugTotalMax() {
      return this.$store.state.drug.selectedDrugTotalMax;
    },
    selectedDrugTotalAmount: function selectedDrugTotalAmount() {
      return this.$store.state.drug.selectedDrugTotalAmount;
    },
    currentDevice: function currentDevice() {
      return this.$store.state.device.currentDevice;
    },
    externalCmpn: function externalCmpn() {
      return this.$store.state.externalCmpn;
    }
  },
  data: function data() {
    return {
      stage: '',
      totalAmount: 0, // already return
      DrugStorageQueueID: [], // device queue with same drug
      actionData: [],
      forAction: {
        defaultNum: 0,
        checkNum: 0,
        deviceId: 0
      },
      emitTimes: 0,
      waitThenFinishAction: false,
      waitThenFinishActionEmitTime: 0
    };
  },
  created: function created() {
    // check return to a new drugStorage or not.
    if (this.returnToEmptyDeviceId) {
      this.forAction = {
        defaultNum: this.amountPayload.amount, //
        checkNum: this.amountPayload.amount,
        deviceId: this.returnToEmptyDeviceId
      };
      this.stage = 'action';
    } else {
      // return to original drugstorage
      if (this.currentSystem.settings.return_to_original_cmpn) {
        // make sure this system has space for the return amount.
        if (this.currentDrugInDevice.stock < this.currentDrugInDevice.max_stock) {
          // okay, return to orignal device"s".
          // prepare for the first Action child.
          this.forAction = {
            defaultNum: this.amountPayload.amount, //
            checkNum: this.currentDrugInDevice.max_stock - this.currentDrugInDevice.stock,
            deviceId: this.currentDrugInDevice.device.id
          };
          // if confirm amount first, input currentDrugInDevice first.
          if (this.actionProgress[0] === 'confirmAmount') {
            this.forAction = {
              defaultNum: this.currentDrugInDevice.stock,
              checkNum: this.currentDrugInDevice.max_stock,
              deviceId: this.currentDrugInDevice.device.id
            };
          }

          this.stage = this.actionProgress[0];
          this.$store.commit('SET_CURRENT_STEP', this.actionProgress[0]);
        } else {
          // this system has no space for the return amount, let user choice where they want to return
          this.stage = 'returnSelection';
        }
      } else {
        // not return to original cmpn, thus let user choose.
        this.stage = 'returnSelection';
      }
    }
  },
  mounted: function mounted() {},

  methods: {
    confirmAmountFinish: function confirmAmountFinish() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$store.dispatch('updateCurrentDrugInDevice', _this.currentDrugInDevice.id);

              case 2:
                _this.forAction = {
                  defaultNum: _this.amountPayload.amount - _this.totalAmount, // the remain amount after each action.
                  checkNum: _this.currentDrugInDevice.max_stock - _this.currentDrugInDevice.stock, // the empty space in the drugStorage
                  deviceId: _this.currentDrugInDevice.device.id
                };
                _this.stage = 'next';
                setTimeout(function () {
                  _this.stage = 'action';
                  _this.$store.commit('SET_CURRENT_STEP', 'action');
                }, 200);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getReturnDevice: function getReturnDevice(payload) {
      switch (payload.type) {
        case 'external':
          this.stage = ''; // close return selection view.
          this.$store.commit('SET_MESSAGE', {
            type: 'success',
            context: '退至外部藥盒，系統已記錄事件。',
            keepOnTop: true
          });
          this.$emit('setActionData', { device: payload.deviceId, num: this.amountPayload.amount - this.totalAmount, packCount: 0 });
          this.waitThenFinishAction = true;
          break;
        case 'return':
          this.forAction = {
            checkNum: this.amountPayload.amount - this.totalAmount,
            defaultNum: this.amountPayload.amount - this.totalAmount,
            deviceId: payload.deviceId
          };
          this.stage = 'action';
          break;
        default:
          console.log(payload, 'payload.type not found.');
      }
    },
    getReturnDrugStorage: function getReturnDrugStorage(payload) {
      // this.actionData.push({ drugStorage: payload.drug_storage });
      if (this.$store.state.generalSetting.check_amount_first) {
        this.forAction = {
          checkNum: this.currentDrugInDevice.max_stock,
          defaultNum: this.currentDrugInDevice.stock,
          deviceId: this.currentDrugInDevice.device.id
        };
        this.stage = 'confirmAmount';
      } else {
        this.forAction = {
          defaultNum: this.amountPayload.amount - this.totalAmount,
          deviceId: payload.drug_storage.device.id,
          checkNum: payload.drug_storage.max_stock - payload.drug_storage.stock
        };
        this.stage = 'action';
      }
    },
    getThisAmount: function getThisAmount(data) {
      // data: device, num
      console.log(this.emitTimes);
      if (this.emitTimes === 0) {
        // due to action is watched, thus it will emit serveral times.
        this.totalAmount += data.num;
        this.emitTimes += 1;

        if (data.device === this.externalCmpn.id || data.device === this.currentSystem.return_cmpn || this.returnToEmptyDeviceId) {
          this.$emit('setActionData', data);
        } else {
          // else record the whole drugStorage.
          this.$emit('setActionData', { drugStorage: this.currentDrugInDevice, num: data.num, packCount: data.packCount });
        }

        // not finish return yet;
        if (this.totalAmount < this.amountPayload.amount) {
          // let user choose;
          this.stage = 'returnSelection';
          this.emitTimes = 0;
        } else {
          // if return to external/ return cmpn, record its device id.
          this.waitThenFinishAction = true;
          this.stage = 'finish';
        }
      }
    }
  },
  watch: {
    actionRecorded: function actionRecorded(val) {
      if (val && this.waitThenFinishAction && this.waitThenFinishActionEmitTime === 0) {
        this.$emit('finishAction');
        this.waitThenFinishActionEmitTime += 1;
      }
    }
  }
});

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ComponentBase_ConfirmFlowBase__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flowComp_Reason__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flowComp_Reason___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__flowComp_Reason__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flowComp_NumberSet__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flowComp_NumberSet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__flowComp_NumberSet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__flowComp_DateSelection__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__flowComp_DateSelection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__flowComp_DateSelection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__flowComp_TextInput__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__flowComp_TextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__flowComp_TextInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ActionWrap__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ActionWrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ActionWrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Confirm__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Confirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__common_Confirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__flowComp_RxCheckBarcode__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__flowComp_RxCheckBarcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__flowComp_RxCheckBarcode__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'confirmFlow',
  extends: __WEBPACK_IMPORTED_MODULE_4__ComponentBase_ConfirmFlowBase__["a" /* default */],
  components: {
    ConfirmReason: __WEBPACK_IMPORTED_MODULE_5__flowComp_Reason___default.a,
    ConfirmStorage: __WEBPACK_IMPORTED_MODULE_6__flowComp_NumberSet___default.a,
    ConfirmExpiredDate: __WEBPACK_IMPORTED_MODULE_7__flowComp_DateSelection___default.a,
    ActionWrap: __WEBPACK_IMPORTED_MODULE_9__ActionWrap___default.a,
    TextInput: __WEBPACK_IMPORTED_MODULE_8__flowComp_TextInput___default.a,
    ConfirmModal: __WEBPACK_IMPORTED_MODULE_10__common_Confirm___default.a,
    RxCheckBarcode: __WEBPACK_IMPORTED_MODULE_11__flowComp_RxCheckBarcode___default.a
  },
  props: ['barcodeData', 'startType'],
  data: function data() {
    return {
      reasonId: '',
      storage: 0,
      expiredDate: '',
      patchNo: '',
      device: '',
      returnNum: '',
      medRecordId: '',
      defaultReturnAmount: 0,
      amountPayload: {
        amount: 0,
        packCount: 0
      },
      showPatchConfirmModal: false,
      returnToEmptyDeviceId: undefined,
      recoredEventIDs: [],
      actionRecorded: false,
      reviewer: undefined
    };
  },
  mounted: function mounted() {
    this.$store.commit('SET_CURRENT_STEP', this.currentProgress);
    if (this.startType === 'event') {
      this.medRecordId = this.currentEvent.med_record_no;
      this.patchNo = this.currentEvent.batch_no;
      this.defaultReturnAmount = Math.abs(this.currentEvent.number1);
    }
    if (this.startType === 'drugStorage') {
      this.patchNo = this.currentDrugInDevice.patch_number;
    }
  },

  methods: {
    confirmRx: function confirmRx(reviewer) {
      this.reviewer = reviewer.id;
      this.nextProgress();
    },
    getMedId: function getMedId(data) {
      this.medRecordId = data;
      if (data === '' || data === undefined) {
        this.$store.commit('SET_MESSAGE', { type: 'error', context: '病歷號不可以為空' });
      } else {
        this.nextProgress();
      }
    },
    getPatchNo: function getPatchNo(data) {
      this.patchNo = data;
      if (this.patchNo === this.currentDrugInDevice.patch_number) {
        this.nextProgress();
      } else {
        console.log('not same patch number');
        if (this.currentDrugInDevice.medication.restrained_class > 0 && data === '') {
          this.$store.commit('SET_MESSAGE', { type: 'warn', context: '管制藥物批號不可為空' });
        } else {
          this.showPatchConfirmModal = true;
        }
      }
    },
    confirmPatchChoice: function confirmPatchChoice(response) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!response) {
                  _context.next = 6;
                  break;
                }

                _context.next = 3;
                return _this.$store.dispatch('getSystemInfo');

              case 3:
                // make sure all system are latest.
                _this.returnToEmptyDeviceId = _this.findLargerEmptyDevice();
                console.log(_this.returnToEmptyDeviceId);
                if (_this.returnToEmptyDeviceId !== null) {
                  _this.$store.commit('SET_CURRENT_DEVICE_FROM_ALL', _this.returnToEmptyDeviceId);
                  _this.nextProgress();
                }
                // find empty and larger device to input

              case 6:
                _this.showPatchConfirmModal = false;

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    findLargerEmptyDevice: function findLargerEmptyDevice() {
      var _this2 = this;

      var targetDeviceIndex = '';
      var devicesList = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.allDevices);
      if (this.currentDrugInDevice.device.pos_col === 0) {
        // F type;
        targetDeviceIndex = devicesList.findIndex(function (o) {
          return o.adc_type === 'F' && o.specific_type === null;
        });
      } else {
        // A Type
        targetDeviceIndex = devicesList.findIndex(function (o) {
          return o.adc_type === 'A' && o.drugstorage_set.length === 0 && o.specific_type === null && o.width >= _this2.currentDrugInDevice.device.width;
        });
        console.log(targetDeviceIndex);
        if (targetDeviceIndex === -1) {
          targetDeviceIndex = devicesList.findIndex(function (o) {
            return o.adc_type === 'F' && o.specific_type === null;
          });
        }
      }
      console.log(targetDeviceIndex);
      if (targetDeviceIndex === -1) {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '找不到合適的空藥盒，請聯絡管理人員處理。'
        });
        return null;
      }
      return devicesList[targetDeviceIndex].id;
    },
    getReason: function getReason(reasonId) {
      console.log(reasonId);
      this.reasonId = reasonId;
      if (this.barcodeData.amount !== undefined) {
        // go directly to action.
        this.storage = this.barcodeData.amount;
        this.expiredDate = this.currentEvent.drug_storage.expired_date;
      }
      this.nextProgress();
    },
    getStorage: function getStorage(num) {
      // deprecated.
      this.amountPayload.amount = num;
      this.storage = num;
      if (num > Math.abs(this.currentEvent.number1) && this.returnToEmptyDeviceId === undefined) {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '退回數量不可大於該次取藥數量'
        });
      } else {
        this.nextProgress();
      }
    },
    getMedRecordNo: function getMedRecordNo(val) {
      this.med_record_no = val;
    },
    getExpiredDate: function getExpiredDate(data) {
      console.log(data);
      this.expiredDate = data;
      this.nextProgress();
    },
    getActionData: function getActionData(item) {
      var _this3 = this;

      console.log(item);
      this.actionRecorded = false;
      // handle drugStorage data
      if ('drugStorage' in item) {
        var data = {
          id: item.drugStorage.id,
          device: item.drugStorage.device.id,
          stock: item.drugStorage.stock += item.num,
          medication: item.drugStorage.medication.id,
          reason: this.reasonId,
          med_record_no: this.medRecordId,
          number1: item.num,
          pack_count: item.drugStorage.pack_count += item.packCount,
          type: 'RETURN',
          review_employee: this.reviewer
        };
        this.instance.put('/api/drug-storage/' + item.drugStorage.id + '/', data).then(function (res) {
          _this3.recoredEventIDs.push(res.data);
          _this3.actionRecorded = true;
        });
      } else {
        // handle device data, speific for external cmpn, return cmpn or empty devices.
        var _data = {
          device: item.device,
          stock: item.num,
          max_stock: item.num,
          expired_date: this.expiredDate !== '' ? this.expiredDate : __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD'),
          patch_number: this.patchNo,
          medication: this.currentDrugInDevice.medication.id,
          reason: this.reasonId,
          med_record_no: this.medRecordId,
          number1: item.num,
          pack_count: 0, // since drug on return in pc. not box.
          type: 'RETURN',
          review_employee: this.reviewer
        };

        // dirty hack, not quite sure why sometimes the data is not an object but key.
        // if (this.currentDrugInDevice.medication.id === undefined) {
        //   drugStorage.medication = this.currentDrugInDevice.medication;
        // }

        // if this is returned to external cmpn or return cmpn, then it should create, not put.
        this.instance.post('/api/drug-storage/', _data).then(function (res) {
          _this3.recoredEventIDs.push(res.data);
          _this3.actionRecorded = true;
        });
      }
    },
    finishAction: function finishAction() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var event;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this4.startType === 'event')) {
                  _context2.next = 4;
                  break;
                }

                event = {
                  id: _this4.currentEvent.id,
                  checked: true,
                  related_events: _this4.recoredEventIDs
                };
                _context2.next = 4;
                return _this4.instance.patch('/api/event/' + event.id + '/', event);

              case 4:
                _this4.$emit('confirmationFinish');
                _this4.resetProgress();

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    }
  },
  computed: {
    externalCmpn: function externalCmpn() {
      return this.$store.state.externalCmpn;
    },
    selectedDrugTotalMax: function selectedDrugTotalMax() {
      return this.$store.state.drug.selectedDrugTotalMax;
    },
    defaultExpiredDate: function defaultExpiredDate() {
      if (this.returnToEmptyDeviceId) {
        return null;
      }
      return this.currentDrugInDevice.expired_date;
    },
    expiredDateEditable: function expiredDateEditable() {
      if (this.returnToEmptyDeviceId) {
        return true;
      }
      return false;
    },
    allDevices: function allDevices() {
      return this.$store.state.device.allDevices;
    }
  },
  watch: {
    currentEvent: function currentEvent(val) {
      if (this.startType === 'event') {
        this.medRecordId = this.currentEvent.med_record_no;
        this.patchNo = this.currentEvent.batch_no;
        this.defaultReturnAmount = Math.abs(this.currentEvent.number1);
      }
    },
    currentDrugInDevice: function currentDrugInDevice(val) {
      if (this.startType === 'drugStorage') {
        this.patchNo = this.currentDrugInDevice.patch_number;
      }
    }
  }
});

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ComponentBase_MultiFlowBase__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConfirmFlow__ = __webpack_require__(1315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConfirmFlow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ConfirmFlow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReturnEmptyBottle__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReturnEmptyBottle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ReturnEmptyBottle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_DrugInfo__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_DrugInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__flowComp_DrugInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_Loader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'multiFlow',
  extends: __WEBPACK_IMPORTED_MODULE_0__ComponentBase_MultiFlowBase__["a" /* default */],
  components: {
    ConfirmFlow: __WEBPACK_IMPORTED_MODULE_1__ConfirmFlow___default.a,
    DrugInfo: __WEBPACK_IMPORTED_MODULE_3__flowComp_DrugInfo___default.a,
    ReturnEmptyBottle: __WEBPACK_IMPORTED_MODULE_2__ReturnEmptyBottle___default.a
  },
  props: ['barcodeData', 'startType'],
  data: function data() {
    return {};
  },

  methods: {
    getConfirmData: function getConfirmData() {
      this.resetProgress();
      console.log('get confirm data');
      if (this.nextEvent === null || this.nextDrugInDevice === null) {
        this.$emit('setAllConfirmData');
      } else {
        this.$store.dispatch('toNextEvent');
        console.log('next event');
        this.eventSwitch();
      }
    },
    eventSwitch: function eventSwitch() {
      // dirty hack for waiting
      if (this.$store.state.generalSetting.mode === 'aeth') {
        if (this.currentDrugInDevice.medication.restrained_class > 0) {
          this.nextProgress();
        }
      }
    }
  },
  created: function created() {
    if (this.startType === 'event') {
      console.log(this.selectedEventId);
      this.$store.dispatch('fromFirstEvent');
    }
    if (this.startType === 'drugStorage') {
      this.$store.dispatch('fromFirstDrugInDevice');
    }
    this.eventSwitch();
  },

  computed: {
    selectedEventId: function selectedEventId() {
      return this.$store.state.event.selectedEventId;
    }
  }
});

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flowComp_Action__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flowComp_Action___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__flowComp_Action__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flowComp_Reason__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flowComp_Reason___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__flowComp_Reason__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_Loader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReturnEmptyBottle',
  props: ['controlMed'],
  data: function data() {
    return {
      stage: null,
      controlMedSet: null,
      forAction: null,
      currentMed: null,
      eventRecordPromises: [],
      setIndex: 0,
      emitTimes: 0,
      reasonId: null
    };
  },
  created: function created() {
    this.getControlSet();
    this.promises = [];
    this.stage = 'selectReason';
  },

  components: {
    Action: __WEBPACK_IMPORTED_MODULE_1__flowComp_Action___default.a,
    ConfirmReason: __WEBPACK_IMPORTED_MODULE_2__flowComp_Reason___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_3__common_Loader___default.a
  },
  computed: {
    instance: function instance() {
      return this.$store.getters.instance;
    },
    currentDrugInDevice: function currentDrugInDevice() {
      return this.$store.getters.currentDrugInDevice;
    },
    currentSchedule: function currentSchedule() {
      return this.$store.getters.currentSchedule;
    },
    currentEvent: function currentEvent() {
      return this.$store.state.event.currentEvent;
    }
  },
  methods: {
    getReason: function getReason(reasonId) {
      this.reasonId = reasonId;
      this.stage = 'confirm';
    },
    getControlSet: function getControlSet() {
      var _this = this;

      this.instance.get('/api/control-medication-set/', {
        params: {
          parent_medication: this.controlMed.id
        }
      }).then(function (res) {
        _this.controlMedSet = res.data;
        _this.setCurrentMed(0);
      });
    },
    setCurrentMed: function setCurrentMed(index) {
      this.setIndex = index;
      this.currentMed = this.controlMedSet[index];
      this.$store.dispatch('setDrug', this.currentMed.child_medication.id);
    },
    setReturnStatus: function setReturnStatus(status) {
      // 管制藥組內的藥物僅直接紀錄，不調整drugStorage.
      if (status !== 'RECYCLE_EMPTY' || status !== 'RETURN') {
        var event = {
          event_type: status,
          patient_name: this.currentSchedule.patient.name,
          med_record_no: this.currentSchedule.patient.med_record_number,
          medication: this.currentMed.child_medication.id,
          medication_generic_name: this.currentMed.child_medication.generic_name,
          employee: this.$store.state.user.user.id,
          employee_name: '' + this.$store.state.user.user.last_name + this.$store.state.user.user.first_name,
          device: this.currentDrugInDevice.device.id,
          stock: this.currentMed.child_medication_quantity,
          total_stock: this.currentMed.child_medication_quantity,
          number1: this.currentMed.child_medication_quantity,
          number2: this.currentSchedule.id,
          reason: this.reasonId,
          checked: true
        };
        this.promises.push(this.instance.post('/api/event/', event));
      }
      // if this is the last one med in set, then go to action.
      if (this.setIndex + 1 === this.controlMedSet.length) {
        this.forAction = {
          deviceId: this.currentDrugInDevice.device.id,
          defaultNum: 1,
          checkNum: 1
        };
        this.stage = 'action';
      } else {
        this.setCurrentMed(this.setIndex + 1);
      }
    },
    saveControlSetParentMed: function saveControlSetParentMed(data) {
      var drugStorage = {
        device: this.currentDrugInDevice.device.id,
        stock: this.currentDrugInDevice.stock, // not quite sure whether the control medication set would only with one stock.
        max_stock: this.currentDrugInDevice.max_stock,
        expired_date: this.currentDrugInDevice.expired_date,
        patch_number: this.currentDrugInDevice.patch_number,
        medication: this.currentDrugInDevice.medication.id,
        reason: this.reasonId,
        med_record_no: this.currentSchedule.patient.med_record_number,
        number1: data.num,
        number2: this.currentSchedule.id,
        pack_count: 0,
        type: 'RETURN'
      };
      this.promises.push(this.instance.put('/api/drug-storage/' + this.currentDrugInDevice.id + '/', drugStorage));
      this.promises.push(this.instance.patch('/api/event/' + this.currentEvent.id + '/', { checked: true }));
    },
    getThisAmount: function getThisAmount(data) {
      var _this2 = this;

      console.log(data);
      if (this.emitTimes === 0) {
        this.stage = 'finish';
        this.saveControlSetParentMed(data);
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.all(this.promises).then(function (res) {
          _this2.$emit('returnEmptyBottleFinish');
        });
      }
      this.emitTimes += 1;
    }
  }
});

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flowComp_ProgressBar__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flowComp_ProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__flowComp_ProgressBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flowComp_EventTable__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flowComp_EventTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__flowComp_EventTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ComponentBase_AppBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ReturnEmptyFlow_MultiFlow__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ReturnEmptyFlow_MultiFlow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ReturnEmptyFlow_MultiFlow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_BottomButtons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_BottomButtons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_BottomButtons__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReturnEmpty',
  extends: __WEBPACK_IMPORTED_MODULE_2__ComponentBase_AppBase__["a" /* default */],
  data: function data() {
    return {
      eventType: 'FETCH',
      stage: ''
    };
  },

  components: {
    progressBar: __WEBPACK_IMPORTED_MODULE_0__flowComp_ProgressBar___default.a,
    eventTable: __WEBPACK_IMPORTED_MODULE_1__flowComp_EventTable___default.a,
    BottomButtons: __WEBPACK_IMPORTED_MODULE_5__common_BottomButtons___default.a,
    MultiFlow: __WEBPACK_IMPORTED_MODULE_3__ReturnEmptyFlow_MultiFlow___default.a
  },
  created: function created() {
    this.progress = this.setupProgress();
    this.multiProgress = this.setupMultiProgress();
    this.confirmProgress = this.setupConfirmProgress();
    this.actionProgress = this.setupActionProgress();
    this.$store.commit('SET_CURRENT_STEP', 'selectEvent');
    this.stage = 'eventList';
  },

  methods: {
    cancel: function cancel() {
      this.$router.push({ name: 'Main' });
      this.$store.dispatch('recordAction', { eventType: 'CANCEL_RETURN_EMPTY' });
    },
    setupProgress: function setupProgress() {
      var prog = [];
      prog.push({ en: 'selectEvent', zh: '選擇取藥事件' });
      prog.push({ en: 'setStorage', zh: '退空瓶數量' });
      prog.push({ en: 'action', zh: '開始動作' });
      return prog;
    },
    setupMultiProgress: function setupMultiProgress() {
      var prog = [];
      prog.push('confirm');
      prog.push('finish');
      return prog;
    },
    setupConfirmProgress: function setupConfirmProgress() {
      var prog = [];
      prog.push('setStorage');
      prog.push('action');
      return prog;
    },
    setupActionProgress: function setupActionProgress() {
      var prog = [];
      prog.push('action');
      prog.push('next');
      return prog;
    },
    startFlow: function startFlow() {
      this.stage = 'setFlowData';
    },
    getAllConfirmData: function getAllConfirmData() {
      this.$store.dispatch('resetAll');
      this.$store.dispatch('getDrugInDevices');
      this.stage = 'eventList';
      this.$store.commit('SET_CURRENT_STEP', 'selectEvent');
    }
  }
});

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flowComp_Action__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flowComp_Action___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__flowComp_Action__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_Loader__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ActionWrap',
  props: ['amountPayload'],
  data: function data() {
    return {
      stage: ''
    };
  },

  components: {
    Action: __WEBPACK_IMPORTED_MODULE_2__flowComp_Action___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_3__common_Loader___default.a
  },
  computed: {
    currentEvent: function currentEvent() {
      return this.$store.state.event.currentEvent;
    },
    currentDrugInDevice: function currentDrugInDevice() {
      return this.$store.getters.currentDrugInDevice;
    },
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  mounted: function mounted() {
    this.stage = 'action';
    this.$store.commit('SET_CURRENT_STEP', 'action');
  },

  methods: {
    getThisAmount: function getThisAmount(data) {
      var _this = this;

      this.stage = 'finish';
      // the "num" attribute is the amount of empty amount for returning.
      var sentData = {
        id: this.currentDrugInDevice.id,
        device: this.currentDrugInDevice.device.id,
        stock: this.currentDrugInDevice.stock,
        max_stock: this.currentDrugInDevice.max_stock,
        expired_date: this.currentDrugInDevice.expired_date,
        patch_number: this.currentDrugInDevice.patch_number,
        medication: this.currentDrugInDevice.medication.id,
        number1: data.num,
        pack_count: this.currentDrugInDevice.pack_count,
        empty_count: data.num + this.currentDrugInDevice.empty_count,
        type: 'RETURN_EMPTY'
      };
      // after saving the empty count to drugStorage, we need to update the event as returned.
      this.instance.put('/api/drug-storage/' + sentData.id + '/', sentData).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res) {
          var recoredEventIDs, event;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  recoredEventIDs = [];

                  _this.currentEvent.related_events.forEach(function (item) {
                    if (item.id !== null) {
                      recoredEventIDs.push(item.id);
                    }
                  });
                  recoredEventIDs.push(res.data);
                  event = {
                    id: _this.currentEvent.id,
                    checked: true,
                    related_events: recoredEventIDs
                  };
                  _context.next = 6;
                  return _this.instance.patch('/api/event/' + event.id + '/', event);

                case 6:

                  _this.$emit('setActionData');

                case 7:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
});

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flowComp_NumberSet__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flowComp_NumberSet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__flowComp_NumberSet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ComponentBase_ConfirmFlowBase__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ActionWrap__ = __webpack_require__(1318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ActionWrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ActionWrap__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'confirmFlow',
  extends: __WEBPACK_IMPORTED_MODULE_1__ComponentBase_ConfirmFlowBase__["a" /* default */],
  components: {
    ConfirmStorage: __WEBPACK_IMPORTED_MODULE_0__flowComp_NumberSet___default.a,
    ActionWrap: __WEBPACK_IMPORTED_MODULE_2__ActionWrap___default.a
  },
  data: function data() {
    return {
      amountPayload: {
        emptyCount: 0
      }
    };
  },
  mounted: function mounted() {
    this.$store.commit('SET_CURRENT_STEP', this.currentProgress);
  },

  methods: {
    getStorage: function getStorage(num) {
      this.amountPayload.emptyCount = num;
      if (num > Math.abs(this.currentEvent.number1)) {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '退回藥瓶數量不可大於該次取藥數量'
        });
      } else {
        this.nextProgress();
      }
    },
    getActionData: function getActionData(val) {
      this.resetProgress();
      this.$emit('confirmationFinish');
    }
  }
});

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConfirmFlow__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConfirmFlow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ConfirmFlow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flowComp_DrugInfo__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flowComp_DrugInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__flowComp_DrugInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ComponentBase_MultiFlowBase__ = __webpack_require__(38);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'multiFlow',
  extends: __WEBPACK_IMPORTED_MODULE_3__ComponentBase_MultiFlowBase__["a" /* default */],
  components: {
    ConfirmFlow: __WEBPACK_IMPORTED_MODULE_0__ConfirmFlow___default.a,
    DrugInfo: __WEBPACK_IMPORTED_MODULE_1__flowComp_DrugInfo___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_2__common_Loader___default.a
  },
  methods: {
    getConfirmData: function getConfirmData() {
      var _this = this;

      console.log('get confirm data');
      this.nextProgress();
      console.log(this.currentProgress);
      if (this.nextEvent !== null) {
        this.$store.dispatch('toNextEvent');
        setTimeout(function () {
          _this.resetProgress();
        }, 100);
      } else {
        this.$emit('setAllConfirmData');
      }
    }
  },
  created: function created() {
    this.$store.dispatch('fromFirstEvent');
  },

  computed: {
    selectedEventId: function selectedEventId() {
      return this.$store.state.event.selectedEventId;
    }
  }
});

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ComponentBase_AppBase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_ProgressBar__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_ProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__flowComp_ProgressBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flowComp_ScheduleList__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flowComp_ScheduleList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__flowComp_ScheduleList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flowComp_ComboMedListAndPatient__ = __webpack_require__(1344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flowComp_ComboMedListAndPatient___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__flowComp_ComboMedListAndPatient__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ScheduleFlow_MultiFlow__ = __webpack_require__(1324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ScheduleFlow_MultiFlow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ScheduleFlow_MultiFlow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_BottomButtons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_BottomButtons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_BottomButtons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__flowComp_CreateSchedule__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__flowComp_CreateSchedule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__flowComp_CreateSchedule__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__flowComp_OperatingRoomScheduleList__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__flowComp_OperatingRoomScheduleList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__flowComp_OperatingRoomScheduleList__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Schedule',
  extends: __WEBPACK_IMPORTED_MODULE_2__ComponentBase_AppBase__["a" /* default */],
  components: {
    progressBar: __WEBPACK_IMPORTED_MODULE_3__flowComp_ProgressBar___default.a,
    ScheduleList: __WEBPACK_IMPORTED_MODULE_4__flowComp_ScheduleList___default.a,
    ComboMedListAndPatient: __WEBPACK_IMPORTED_MODULE_5__flowComp_ComboMedListAndPatient___default.a,
    MultiFlow: __WEBPACK_IMPORTED_MODULE_6__ScheduleFlow_MultiFlow___default.a,
    BottomButtons: __WEBPACK_IMPORTED_MODULE_7__common_BottomButtons___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_8__common_Loader___default.a,
    CreateSchedule: __WEBPACK_IMPORTED_MODULE_9__flowComp_CreateSchedule___default.a,
    OperatingRoomScheduleList: __WEBPACK_IMPORTED_MODULE_10__flowComp_OperatingRoomScheduleList___default.a
  },
  data: function data() {
    return {
      fireRefetch: 0,
      starttype: '',
      manualCreateReady: false,
      manualCreateProgress: 0,
      filterOutZeroAmountMed: false,
      scheduleType: 'today',
      manualEnable: true,
      medRecordId: '',
      manualInputMedRecordId: true,
      bedId: undefined,
      gender: undefined
    };
  },
  created: function created() {
    this.stage = 'Start';
    this.startTypeSwitch();
    // if (this.$route.params.stage) {
    //   // this.stage = this.$route.params.stage;
    // } else {
    //   // this.stage = 'ScheduleList';
    // }
    this.progress = this.setupProgress();
    this.multiProgress = this.setupMultiProgress();
    this.confirmProgress = this.setupConfirmProgress();
    this.actionProgress = this.setupActionWrapProgress();
  },
  mounted: function mounted() {
    this.$store.commit('SET_CURRENT_STEP', 'manual');
  },

  computed: {
    currentSchedule: function currentSchedule() {
      return this.$store.getters.currentSchedule;
    },
    DrugsForFetchList: function DrugsForFetchList() {
      return this.$store.state.drug.DrugsForFetchList;
    }
  },
  methods: {
    startTypeSwitch: function startTypeSwitch() {
      //console.log('generalSetting:',this.$store.state.generalSetting);
      var systemSetting = this.$store.state.generalSetting.mode;
      switch (systemSetting) {
        case 'nursing':
          this.starttype = 'HIS';
          this.filterOutZeroAmountMed = true;
          break;
        case 'surgery':
          //this.starttype = 'Manual';
          this.starttype = 'OperatingRoomHIS';
          this.filterOutZeroAmountMed = false;
          break;
        default:
          //this.starttype = 'Manual';
          this.starttype = 'OperatingRoomHIS';
          this.filterOutZeroAmountMed = false;
          break;
      }
    },
    setupProgress: function setupProgress() {
      var p = [];
      p.push({ en: 'manual', zh: '設定排程' });
      p.push({ en: 'selectMeds', zh: '選擇使用藥物' });
      // if (this.starttype === 'Manual') {
      //   // p.push({ en: 'selectMed', zh: '選擇使用藥物' });
      //   // p.push({ en: 'selectBed', zh: '選擇病床' });
      //   // p.push({ en: 'inputMedRecordNo', zh: '輸入病歷號' });
      //   p.push({ en: 'manual', zh: '手動輸入' });
      //   p.push({ en: 'selectMeds', zh: '選擇使用藥物' });
      // }
      // if (this.starttype === 'HIS') {
      //   p.push({ en: 'selectPatient', zh: '選擇病人' });
      //   p.push({ en: 'selectMeds', zh: '選擇使用藥物' });
      // }
      if (this.$store.state.user.user.task_privilege.fetch_drug === false) {
        p.push({ en: 'rxCheck', zh: '覆核動作' });
      }
      if (this.$store.state.generalSetting.check_amount_first) {
        p.push({ en: 'confirmAmount', zh: '確認數量' });
      }
      p.push({ en: 'action', zh: '進行取藥' });
      return p;
    },
    setupMultiProgress: function setupMultiProgress() {
      return ['confirm', 'finish'];
    },
    setupConfirmProgress: function setupConfirmProgress() {
      var prog = [];
      if (this.$store.state.user.user.task_privilege.fetch_drug === false) {
        prog.push('rxCheck');
      }
      prog.push('actionWrap');
      return prog;
    },
    setupActionWrapProgress: function setupActionWrapProgress() {
      var prog = [];
      if (this.$store.state.generalSetting.check_amount_first) {
        prog.push('confirmAmount');
      }
      prog.push('action');
      prog.push('next');
      return prog;
    },
    cancel: function cancel() {
      this.$store.dispatch('recordAction', { eventType: 'CANCEL_FETCH' });
      this.$router.push({ name: 'Main' });
    },
    getSchedule: function getSchedule() {
      if (this.starttype == 'OperatingRoomHIS') {
        this.starttype = 'Manual';
      } else {
        this.stage = 'ComboMedListAndPatient';
      }
    },
    startFlow: function startFlow() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$store.dispatch('printQR', _this.$store.state.drug.DrugsForFetchList);
                // for (let i = 0; i < this.$store.state.drug.DrugsForFetchList.length; i += 1) {
                //   const fetchItem = this.$store.state.drug.DrugsForFetchList[i];
                //   // if (fetchItem.med.restrained_class > 0) {
                //   this.$store.dispatch('printQR', fetchItem);
                //   // }
                // }
                _context.next = 3;
                return _this.$store.dispatch('fromFirstDrug');

              case 3:
                _this.stage = 'startFlow';

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    changeStartType: function changeStartType(val) {
      this.starttype = val;
      this.$store.commit('SET_PROGRESS', this.setupProgress());
    },
    getAllConfirmData: function getAllConfirmData() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.stage = 'finish';
                // refetch data
                _this2.$store.dispatch('resetAll');
                _context2.next = 4;
                return _this2.$store.dispatch('getDrugInDevices');

              case 4:
                //20190516 add
                if (_this2.starttype === 'Manual') {
                  _this2.starttype = 'OperatingRoomHIS';
                  _this2.manualEnable = true;
                  _this2.medRecordId = '';
                  _this2.manualInputMedRecordId = true;
                }
                _this2.stage = 'Start';
                _this2.$store.commit('RESET_SCHEDULE');
                _this2.$store.commit('SET_CURRENT_STEP', 'manual');

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    emitProgress: function emitProgress(val) {
      this.manualCreateProgress = val;
    },
    manualSchedule: function manualSchedule() {
      this.starttype = 'Manual';
    },
    getPatientSchedule: function getPatientSchedule(data) {
      this.manualEnable = data.manualEnable;
      this.medRecordId = data.medRecordId;
      this.bedId = data.bedId;
      this.gender = data.gender;
      if (this.medRecordId === '') {
        this.manualInputMedRecordId = true;
      } else {
        this.manualInputMedRecordId = false;
      }
    }
  },
  watch: {
    stage: function stage(val) {
      if (val === 'Start') {
        this.$store.commit('SHOW_LOGOUT', true);
      } else {
        this.$store.commit('SHOW_LOGOUT', false);
      }
    }
  }
});

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flowComp_Action__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flowComp_Action___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__flowComp_Action__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__flowComp_ActionBreak__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__flowComp_ActionBreak___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__flowComp_ActionBreak__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__common_Loader__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FetchActionWrap',
  props: {
    amount: Number,
    barcodeData: Object,
    medRecordId: String,
    // scheduleId: Number,
    actionProgress: Array,
    startActionType: String,
    reviewer: Object
  },
  components: {
    Action: __WEBPACK_IMPORTED_MODULE_6__flowComp_Action___default.a,
    ActionBreak: __WEBPACK_IMPORTED_MODULE_7__flowComp_ActionBreak___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_8__common_Loader___default.a
  },
  computed: {
    currentDrugInDevice: function currentDrugInDevice() {
      return this.$store.state.drugInDevice.currentDrugInDevice;
    },
    drugStorageWithSameDrug: function drugStorageWithSameDrug() {
      return this.$store.state.drugInDevice.DrugStorageWithSameDrug;
    },
    instance: function instance() {
      return this.$store.state.instance;
    },
    fetchReadOnly: function fetchReadOnly() {
      if (this.barcodeData !== undefined && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.barcodeData).length > 0) return true;
      return false;
    }
  },
  data: function data() {
    return {
      stage: '',
      totalAmount: 0, // already fetched
      drugStorageInQueue: [], // device queue with same drug
      drugStorageList: [],
      theDrugStorage: {},
      theDrugStorageIndex: 0,
      actionData: [],
      forAction: {
        defaultNum: 0,
        checkNum: 0,
        deviceId: 0
      },
      residual: 0,
      getEmitTimes: 0,
      progressIndex: 0,
      scheduleId: undefined,
      oriNextDrugStorageId: undefined
    };
  },
  destroyed: function destroyed() {
    console.log('醫囑取藥 ActionWrap destroyed');
    this.totalAmount = 0;
    this.drugStorageInQueue = {};
    this.drugStorageInQueueId = [];
    this.theDrugStorage = {};
    this.theDrugStorageIndex = 0;
    this.forAction = {
      defaultNum: 0,
      checkNum: 0,
      deviceId: 0
    };
    this.getEmitTimes = 0;
    this.$store.commit('SET_APP_CANCEL_STATUS', true);
  },
  mounted: function mounted() {
    this.$store.commit('SET_APP_CANCEL_STATUS', false);
    // console.log(this.forAction);
    // prepare for the first Action child. remove the first one(user selected one), then set the remains into state.
    this.drugStorageInQueue = this.drugStorageWithSameDrug;
    console.log(this.drugStorageWithSameDrug);

    // this.$store.commit('SET_CONFIRM_STAGE', 'confirmAmount');
    this.moveCurrentStorageToHead(this.currentDrugInDevice.id);
    this.residual = this.amount;
    this.theDrugStorage = this.drugStorageList[this.theDrugStorageIndex];
    this.$store.commit('SET_CURRENT_DRUG_IN_DEVICE', this.theDrugStorage.id);
    // prepare forAction data
    if (this.actionProgress[0] === 'confirmAmount') {
      this.forAction = {
        defaultNum: this.theDrugStorage.stock,
        checkNum: this.theDrugStorage.max_stock,
        deviceId: this.theDrugStorage.device.id
      };
      this.$store.commit('SET_CURRENT_STEP', 'confirmAmount');
    }
    if (this.actionProgress[0] === 'action') {
      this.forAction = {
        defaultNum: this.amount,
        checkNum: this.theDrugStorage.stock,
        deviceId: this.theDrugStorage.device.id
      };
      this.$store.commit('SET_CURRENT_STEP', 'action');
    }
    this.stage = this.actionProgress[0]; // well, it seems that the new refaction could not fit actionWrap flow.
  },

  methods: {
    confirmAmountFinish: function confirmAmountFinish() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var nextDrugStorage, tmpNextDrugStorage;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('drugstorage', _this.theDrugStorage);
                _context.next = 3;
                return _this.$store.dispatch('updateCurrentDrugInDevice', _this.theDrugStorage.id);

              case 3:
                // notice: the stock of drugStorage might change here.
                _this.theDrugStorage = _this.$store.state.drugInDevice.allDrugInDevice[_this.theDrugStorage.id];
                //
                _this.forAction = {
                  defaultNum: _this.amount - _this.totalAmount, // the resident number for child.
                  checkNum: _this.theDrugStorage.stock > _this.residual ? _this.residual : _this.theDrugStorage.stock,
                  deviceId: _this.theDrugStorage.device.id
                };

                _this.stage = 'next';
                // 如果確認之後為0 就跳過該藥盒
                if (_this.currentDrugInDevice.stock === 0) {
                  if (_this.theDrugStorageIndex + 1 < _this.drugStorageList.length) {
                    _this.theDrugStorageIndex += 1;
                    _this.residual = _this.amount - _this.totalAmount;
                    _this.theDrugStorage = _this.drugStorageList[_this.theDrugStorageIndex];
                    _this.forAction = {
                      defaultNum: _this.amount - _this.totalAmount, // the resident number for child.
                      checkNum: _this.theDrugStorage.stock > _this.residual ? _this.residual : _this.theDrugStorage.stock,
                      deviceId: _this.theDrugStorage.device.id
                    };
                    // set next DrugStorage
                    nextDrugStorage = _this.drugStorageList[_this.theDrugStorageIndex];

                    _this.$store.commit('SET_NEXT_DEVICE', nextDrugStorage.device.id);
                    _this.$store.commit('SET_NEXT_DRUG_IN_DEVICE', nextDrugStorage.id);
                    _this.stage = 'break';
                  } else {
                    if (_this.amount - _this.totalAmount > 0) {
                      _this.$store.commit('SET_MESSAGE', {
                        type: 'warn',
                        context: '\u5C1A\u6709' + (_this.amount - _this.totalAmount) + '\u672A\u62FF\uFF0C\u8ACB\u81EA\u884C\u81F3\u5916\u90E8\u85E5\u76D2\u62FF\u53D6\u3002',
                        keepOnTop: true
                      });
                    }
                    //20190426 add
                    console.log('store.state.drugInDevice.currentDrugInDevice:', _this.$store.state.drugInDevice.currentDrugInDevice);
                    console.log('store.state.drugInDevice.nextDrugInDevice:', _this.$store.state.drugInDevice.nextDrugInDevice);
                    if (_this.$store.state.drugInDevice.nextDrugInDevice) {
                      console.log('store.state.drugInDevice.currentDrugInDevice.id:', _this.$store.state.drugInDevice.currentDrugInDevice.id);
                      console.log('store.state.drugInDevice.nextDrugInDevice.id:', _this.$store.state.drugInDevice.nextDrugInDevice.id);
                      //console.log(this.$store.state.drugInDevice);
                      _this.resetNextDrugInDevice();
                      //沒有下個藥要取
                      if (_this.$store.state.drugInDevice.sortedSelectedDrugInDeviceIndex >= _this.$store.state.drugInDevice.sortedSelectedDrugInDevice.length - 1) {
                        console.log('remove:case a');
                        _this.$store.commit('REMOVE_NEXT_DRUG_IN_DEVICE');
                        _this.$store.commit('REMOVE_NEXT_DEVICE');
                      } else //還有下個藥可取
                        {
                          if (_this.$store.state.drugInDevice.currentDrugInDevice.id === _this.$store.state.drugInDevice.nextDrugInDevice.id) {
                            //去撈下個排序的藥的id並設為next device
                            tmpNextDrugStorage = _this.$store.state.drugInDevice.sortedSelectedDrugInDevice[_this.$store.state.drugInDevice.sortedSelectedDrugInDeviceIndex + 1];

                            console.log(tmpNextDrugStorage);
                            if (tmpNextDrugStorage) {
                              console.log('tmpNextDrugStorage.device.id:', tmpNextDrugStorage.device.id);
                              _this.$store.commit('SET_NEXT_DEVICE', tmpNextDrugStorage.device.id);
                              _this.$store.commit('SET_NEXT_DRUG_IN_DEVICE', tmpNextDrugStorage.id);
                            } else {
                              console.log('remove:case b');
                              _this.$store.commit('REMOVE_NEXT_DRUG_IN_DEVICE');
                              _this.$store.commit('REMOVE_NEXT_DEVICE');
                            }
                          }
                        }
                    } else {
                      console.log('remove:case c');
                      _this.$store.commit('REMOVE_NEXT_DRUG_IN_DEVICE');
                      _this.$store.commit('REMOVE_NEXT_DEVICE');
                    }
                    setTimeout(function () {
                      _this.$emit('setActionData');
                    }, 1000);
                  }
                } else {
                  // notice: the stock of drugStorage might change here.
                  _this.theDrugStorage = _this.$store.state.drugInDevice.allDrugInDevice[_this.theDrugStorage.id];
                  //
                  _this.forAction = {
                    defaultNum: _this.amount - _this.totalAmount, // the resident number for child.
                    checkNum: _this.theDrugStorage.stock > _this.residual ? _this.residual : _this.theDrugStorage.stock,
                    deviceId: _this.theDrugStorage.device.id
                  };
                  setTimeout(function () {
                    _this.stage = 'action';
                    _this.$store.commit('SET_CURRENT_STEP', 'action');
                  }, 200);
                  _this.getTotalSumInstanly(_this.amount - _this.totalAmount);
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    moveCurrentStorageToHead: function moveCurrentStorageToHead(drugStorageId) {
      var current = this.drugStorageInQueue[drugStorageId];
      console.log(drugStorageId, current);
      // delete this.drugStorageInQueue[drugStorageId];
      this.drugStorageList = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.drugStorageInQueue);
      // 領藥條件： 最接近過期 > 散裝量最多
      //this.drugStorageList = _.orderBy(this.drugStorageList, [(o) => { return new Date(o.expired_date); }, (o) => { return o.stock - (o.medication.pack_content * o.pack_count); }], ['asc', 'desc']);
      //20190524 
      // 領藥條件： 最接近過期 > 散裝量最小
      this.drugStorageList = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.orderBy(this.drugStorageList, [function (o) {
        return new Date(o.expired_date);
      }, function (o) {
        return o.stock - o.medication.pack_content * o.pack_count;
      }], ['asc', 'asc']);
      // this.drugStorageList.unshift(current); // insert the current one to the head.
      // this.$store.commit('SET_SELECTED_DRUG_IN_DEVICE_DIRECTLY', this.drugStorageList);
    },
    saveData: function saveData(data) {
      var _this2 = this;

      console.log(data);
      var currentDrugStorage = this.theDrugStorage;
      if (this.currentDrugInDevice.stock - data.num < 0) {
        throw new Error('the saving stock should not be miuns');
      } else {
        var remainPc = currentDrugStorage.stock - currentDrugStorage.medication.pack_content * currentDrugStorage.pack_count;
        var remainPackCount = currentDrugStorage.pack_count;
        if (remainPackCount !== 0) {
          remainPackCount = currentDrugStorage.pack_count - Math.ceil((data.num - remainPc) / currentDrugStorage.medication.pack_content);
        }
        console.log(remainPackCount);
        if (this.$store.state.schedule.currentSchedule) {
          this.scheduleId = this.$store.state.schedule.currentSchedule.id;
        }

        var medRecrodNumber = null;
        if (this.medRecordId !== undefined) medRecrodNumber = this.medRecordId;
        if (this.barcodeData !== undefined) medRecrodNumber = this.barcodeData.medRecordId;
        if (this.$store.state.schedule.currentSchedule !== undefined) medRecrodNumber = this.$store.state.schedule.currentSchedule.patient.med_record_number;
        console.log(this.medRecordId, this.barcodeData, this.$store.state.schedule.currentSchedule, medRecrodNumber);

        // becareful that other components used this comp.
        var eventType = 'FETCH';
        if (this.startActionType === 'FETCH_TRANSFER') {
          eventType = 'FETCH_TRANSFER';
        }

        var sentData = {
          id: currentDrugStorage.id,
          device: data.device,
          stock: currentDrugStorage.stock - data.num, // only update here.
          max_stock: currentDrugStorage.max_stock,
          expired_date: currentDrugStorage.expired_date,
          patch_number: currentDrugStorage.patch_number,
          medication: currentDrugStorage.medication.id,
          med_record_no: medRecrodNumber,
          number1: -data.num,
          number2: this.scheduleId,
          pack_count: remainPackCount,
          type: eventType,
          review_employee: this.reviewer === undefined ? undefined : this.reviewer.id
        };
        console.log(sentData);

        this.stage = 'next';
        return this.instance.put('/api/drug-storage/' + sentData.id + '/', sentData).then(function (drugStorageActionRes) {
          // update the amount after saving
          _this2.$store.dispatch('getTotalDrugAmountInstanly', currentDrugStorage.medication.id);

          // record Return Empty if neeed
          if (data.emptyCount > 0) {
            _this2.$store.dispatch('recordAction', { eventType: 'RETURN_EMPTY', number1: data.emptyCount }).then(function () {
              var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(eventActionRes) {
                var event;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        event = {
                          id: drugStorageActionRes.data,
                          checked: true,
                          related_events: [eventActionRes.data]
                        };
                        _context2.next = 3;
                        return _this2.instance.patch('/api/event/' + event.id + '/', event);

                      case 3:
                      case 'end':
                        return _context2.stop();
                    }
                  }
                }, _callee2, _this2);
              }));

              return function (_x) {
                return _ref.apply(this, arguments);
              };
            }());
          }
          if (_this2.$store.state.generalSetting.mode === 'nursing') {
            console.log('send to his');
            console.log('dose value:', _this2.$store.state.drug.doseForHisOutput);
            if (_this2.reviewer !== undefined) {
              console.log('reviewer', _this2.reviewer);
            }
            // send fetch record back to CGMH HIS
            _this2.$store.dispatch('returnFetchDataToCGMHHIS', {
              medication: currentDrugStorage.medication.code,
              //dose: 'xxx',
              //20190403 modified
              dose: _this2.$store.state.drug.doseForHisOutput,
              qty: data.num,
              //rx_user: this.reviewer.id === undefined ? this.$store.state.user.user.username : this.reviewer.username,
              //20190403 modified
              rx_user: _this2.reviewer === undefined ? _this2.$store.state.user.user.username : _this2.reviewer.username
            });
          }
          console.log('set drug storage.');
        }).catch(function (res) {
          console.log('fetch drug error');
        });
      }
    },
    goOn: function goOn() {
      console.log(this.theDrugStorage);
      var defaultNumCalc = 0;
      var checkNumCalc = 0;
      if (this.actionProgress[0] === 'confirmAmount') {
        defaultNumCalc = this.theDrugStorage.stock;
        checkNumCalc = this.theDrugStorage.max_stock;
      }
      if (this.actionProgress[0] === 'action') {
        defaultNumCalc = this.residual;
        checkNumCalc = this.theDrugStorage.stock > this.residual ? this.residual : this.theDrugStorage.stock;
      }

      this.forAction = {
        defaultNum: defaultNumCalc, // the resident number for child.
        checkNum: checkNumCalc,
        deviceId: this.theDrugStorage.device.id
      };
      console.log(this.forAction);
      this.$store.commit('SET_CURRENT_DRUG_IN_DEVICE', this.theDrugStorage.id);
      this.stage = this.actionProgress[0]; // TODO: remove it here.
      this.getEmitTimes = 0;
      this.resetNextDrugInDevice();
    },
    resetNextDrugInDevice: function resetNextDrugInDevice() {
      // reset drugStorage id if it has been changed previous.
      console.log(this.oriNextDrugStorageId);
      if (this.$store.state.drugInDevice.nextDrugInDevice) {
        // save the drugStorage id temporaliy.
        this.oriNextDrugStorageId = this.$store.state.drugInDevice.nextDrugInDevice.id;
      }
      console.log('this.oriNextDrugStorageId:', this.oriNextDrugStorageId);
      if (this.oriNextDrugStorageId) {
        this.$store.commit('SET_NEXT_DEVICE', this.$store.state.drugInDevice.allDrugInDevice[this.oriNextDrugStorageId].device.id);
        this.$store.commit('SET_NEXT_DRUG_IN_DEVICE', this.oriNextDrugStorageId);
      }
    },
    getTotalSumInstanly: function getTotalSumInstanly(val) {
      console.log('get total amount instanly', val, this.residual);
      console.log('theDrugStorageIndex:', this.theDrugStorageIndex);
      console.log('drugStorageList.length:', this.drugStorageList.length);
      // check fetch amount from current drugStorage is enough or not
      if (val < this.residual) {
        //20190429 modified
        //if (this.theDrugStorageIndex + 1 <= this.drugStorageList.length) {
        if (this.theDrugStorageIndex + 1 < this.drugStorageList.length) {
          var nextDrugStorage = this.drugStorageList[this.theDrugStorageIndex + 1];
          console.log(this.$store.state.drugInDevice.nextDrugInDevice);
          if (this.$store.state.drugInDevice.nextDrugInDevice) {
            // save the drugStorage id temporaliy.
            this.oriNextDrugStorageId = this.$store.state.drugInDevice.nextDrugInDevice.id;
          }
          console.log('nextDrugStorage.device.id:', nextDrugStorage.device.id);
          this.$store.commit('SET_NEXT_DEVICE', nextDrugStorage.device.id);
          this.$store.commit('SET_NEXT_DRUG_IN_DEVICE', nextDrugStorage.id);
        } else {
          console.log('no enough amount for fetching.');
        }
      } else {
        this.resetNextDrugInDevice();
        console.log('sortedSelectedDrugInDeviceIndex:', this.$store.state.drugInDevice.sortedSelectedDrugInDeviceIndex);
        console.log('sortedSelectedDrugInDevice.length:', this.$store.state.drugInDevice.sortedSelectedDrugInDevice.length);
        console.log('store.state.drugInDevice.currentDrugInDevice.id:', this.$store.state.drugInDevice.currentDrugInDevice.id);
        if (this.$store.state.drugInDevice.nextDrugInDevice) {
          console.log('store.state.drugInDevice.nextDrugInDevice.id:', this.$store.state.drugInDevice.nextDrugInDevice.id);
        }
        if (this.$store.state.drug.currentDrugIndex >= this.$store.state.drug.DrugsForFetchList.length - 1) {
          console.log('remove:case aa');
          this.$store.commit('REMOVE_NEXT_DRUG_IN_DEVICE');
          this.$store.commit('REMOVE_NEXT_DEVICE');
        } else //還有下個藥可取
          {
            if (this.$store.state.drugInDevice.nextDrugInDevice) {
              if (this.$store.state.drugInDevice.currentDrugInDevice.id === this.$store.state.drugInDevice.nextDrugInDevice.id) {
                //去撈下個排序的藥的id並設為next device
                var tmp2NextDrugStorage = this.$store.state.drugInDevice.sortedSelectedDrugInDevice[this.$store.state.drugInDevice.sortedSelectedDrugInDeviceIndex + 1];
                console.log(tmp2NextDrugStorage);
                if (tmp2NextDrugStorage) {
                  console.log('tmp2NextDrugStorage.device.id:', tmp2NextDrugStorage.device.id);
                  this.$store.commit('SET_NEXT_DEVICE', tmp2NextDrugStorage.device.id);
                  this.$store.commit('SET_NEXT_DRUG_IN_DEVICE', tmp2NextDrugStorage.id);
                } else {
                  console.log('remove:case bb');
                  this.$store.commit('REMOVE_NEXT_DRUG_IN_DEVICE');
                  this.$store.commit('REMOVE_NEXT_DEVICE');
                }
              }
            }
          }
      }
    },
    getThisAmount: function getThisAmount(data) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log(data);
                _this3.getEmitTimes += 1; // prevent over emitting

                if (!(_this3.getEmitTimes === 1)) {
                  _context3.next = 8;
                  break;
                }

                // data: device, num
                _this3.totalAmount += data.num;
                _context3.next = 6;
                return _this3.saveData(data);

              case 6:

                // record Return Empty if neeed
                // if (data.emptyCount > 0) {
                //   await this.$store.dispatch('recordAction', { eventType: 'RETURN_EMPTY', number1: data.emptyCount });
                // }
                // increment the index
                _this3.theDrugStorageIndex += 1;
                // await this.$store.dispatch('getTotalDrugAmountInstanly', this.$store.state.drug.selectedDrugID);
                if (_this3.totalAmount < _this3.amount) {
                  if (_this3.theDrugStorageIndex < _this3.drugStorageList.length) {
                    _this3.residual = _this3.amount - _this3.totalAmount;
                    _this3.theDrugStorage = _this3.drugStorageList[_this3.theDrugStorageIndex];
                    console.log(_this3.theDrugStorage);
                    _this3.stage = 'break';
                  } else {
                    _this3.$store.commit('SET_MESSAGE', {
                      type: 'warn',
                      context: '\u5C1A\u6709' + (_this3.amount - _this3.totalAmount) + '\u672A\u62FF\uFF0C\u8ACB\u81EA\u884C\u81F3\u5916\u90E8\u85E5\u76D2\u62FF\u53D6\u3002',
                      keepOnTop: true
                    });
                    // TODO: here is not emit yet. thus the action will stop at here.
                    // make fetch drug in outside drug box is recorded.
                    _this3.getEmitTimes = 0;
                    setTimeout(function () {
                      _this3.$emit('setActionData');
                    }, 1000);
                  }
                } else {
                  console.log('finished');
                  // this.resetNextDrugInDevice();
                  _this3.$emit('setActionData');
                }

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  }
});

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ComponentBase_ConfirmFlowBase__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ActionWrap__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ActionWrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ActionWrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flowComp_RxCheckBarcode__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flowComp_RxCheckBarcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__flowComp_RxCheckBarcode__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ConfirmFlow',
  extends: __WEBPACK_IMPORTED_MODULE_2__ComponentBase_ConfirmFlowBase__["a" /* default */],
  props: ['confirmProgress', 'actionProgress'],
  data: function data() {
    return {
      reviewer: undefined
    };
  },

  components: {
    ActionWrap: __WEBPACK_IMPORTED_MODULE_3__ActionWrap___default.a,
    RxCheckBarcode: __WEBPACK_IMPORTED_MODULE_4__flowComp_RxCheckBarcode___default.a
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$store.dispatch('getDrugInDevicesWithSameDrug', _this.currentDrug.med.id);

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {},

  computed: {},
  methods: {
    confirmRx: function confirmRx(reviewer) {
      this.reviewer = reviewer;
      this.nextProgress();
    },
    getFetchData: function getFetchData(data) {
      this.$emit('confirmationFinish');
    }
  }
});

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ComponentBase_MultiFlowBase__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flowComp_DrugInfo__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flowComp_DrugInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__flowComp_DrugInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConfirmFlow__ = __webpack_require__(1323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConfirmFlow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ConfirmFlow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_Loader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'multiflow',
  extends: __WEBPACK_IMPORTED_MODULE_0__ComponentBase_MultiFlowBase__["a" /* default */],
  props: ['confirmProgress', 'actionProgress'],
  data: function data() {
    return {
      checkFun: undefined
    };
  },

  components: {
    DrugInfo: __WEBPACK_IMPORTED_MODULE_1__flowComp_DrugInfo___default.a,
    ConfirmFlow: __WEBPACK_IMPORTED_MODULE_2__ConfirmFlow___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_3__common_Loader___default.a
  },
  created: function created() {
    this.stage = 'confirm';
  },

  computed: {
    nextDrug: function nextDrug() {
      return this.$store.getters.nextDrug;
    }
  },
  methods: {
    getConfirmData: function getConfirmData() {
      var _this = this;

      console.log('getConfirmData');
      this.nextProgress();
      this.checkFun = setInterval(function () {
        _this.checkDevicesCloseAndEmit();
      }, 500);
    },
    nextStep: function nextStep() {
      var _this2 = this;

      if (this.nextDrug === null) {
        this.$emit('setAllConfirmData');
      } else {
        this.$store.dispatch('toNextDrug');
        setTimeout(function () {
          _this2.resetProgress();
        }, 100);
      }
    },

    //20190412 modified by aaron
    checkDevicesCloseAndEmit: function checkDevicesCloseAndEmit() {
      if (this.nextDevice) {
        if (this.nextDevice.net.id === this.currentDevice.net.id && this.errorDevices.length > 1) {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            confirm: false,
            context: '請先關閉所有藥盒'
          });
        } else if (this.nextDevice.net.id !== this.currentDevice.net.id && this.errorDevices.length > 0) {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            confirm: false,
            context: '請先關閉所有藥盒及抽屜'
          });
        } else {
          this.$store.commit('CLOSE_MESSAGE');
          if (this.checkFun) {
            clearInterval(this.checkFun);
          }
          this.nextStep();
        }
      } else {
        /*
        this.$store.commit('CLOSE_MESSAGE');
        if (this.checkFun) {
          clearInterval(this.checkFun);
        }
        this.nextStep();
        */
        if (this.errorDevices.length > 0) {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            confirm: false,
            context: '請先關閉所有藥盒及抽屜'
          });
        } else {
          this.$store.commit('CLOSE_MESSAGE');
          if (this.checkFun) {
            clearInterval(this.checkFun);
          }
          this.nextStep();
        }
      }
    }
  }
});

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flowComp_ScanBarcode__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flowComp_ScanBarcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__flowComp_ScanBarcode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flowComp_ProgressBar__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flowComp_ProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__flowComp_ProgressBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flowComp_ScheduleList__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flowComp_ScheduleList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__flowComp_ScheduleList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_EventTable__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_EventTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__flowComp_EventTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ReturnDrugFlow_MultiFlow__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ReturnDrugFlow_MultiFlow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ReturnDrugFlow_MultiFlow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_BottomButtons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_BottomButtons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_BottomButtons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ComponentBase_AppBase__ = __webpack_require__(33);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ScheduleReturn',
  extends: __WEBPACK_IMPORTED_MODULE_6__ComponentBase_AppBase__["a" /* default */],
  components: {
    progressBar: __WEBPACK_IMPORTED_MODULE_1__flowComp_ProgressBar___default.a,
    ScheduleList: __WEBPACK_IMPORTED_MODULE_2__flowComp_ScheduleList___default.a,
    MultiFlow: __WEBPACK_IMPORTED_MODULE_4__ReturnDrugFlow_MultiFlow___default.a,
    BottomButtons: __WEBPACK_IMPORTED_MODULE_5__common_BottomButtons___default.a,
    EventTable: __WEBPACK_IMPORTED_MODULE_3__flowComp_EventTable___default.a,
    scanBarcode: __WEBPACK_IMPORTED_MODULE_0__flowComp_ScanBarcode___default.a
  },
  data: function data() {
    return {
      stage: '',
      fireRefetch: 0,
      eventType: 'FETCH',
      barcodeData: ''
    };
  },
  created: function created() {
    if (this.$route.params.stage) {
      this.stage = this.$route.params.stage;
    } else {
      this.stage = 'scanBarcode';
    }
    this.progress = this.setupProgress();
    this.multiProgress = this.setupMultiProgress();
    this.confirmProgress = this.setupConfirmProgress();
    this.actionProgress = this.setupActionWrapProgress();
  },
  mounted: function mounted() {
    this.$store.commit('SET_CURRENT_STEP', 'selectPatient');
  },

  computed: {
    currentSchedule: function currentSchedule() {
      return this.$store.getters.currentSchedule;
    }
  },
  methods: {
    setupProgress: function setupProgress() {
      var p = [];
      p.push({ en: 'selectPatient', zh: '選擇病人' });
      p.push({ en: 'selectDrug', zh: '選擇使用藥物' });
      p.push({ en: 'selectReason', zh: '選擇理由' });
      p.push({ en: 'setStorage', zh: '退藥數量' });
      if (this.$store.state.user.user.task_privilege.return_drug === false) {
        p.push({ en: 'rxCheck', zh: '覆核動作' });
      }
      if (this.$store.state.generalSetting.check_amount_first) {
        p.push({ en: 'confirmAmount', zh: '確認數量' });
      }
      p.push({ en: 'action', zh: '進行退藥' });
      return p;
    },
    setupMultiProgress: function setupMultiProgress() {
      return ['confirm', 'returnEmpty', 'finish'];
    },
    setupConfirmProgress: function setupConfirmProgress() {
      var prog = [];
      prog.push('selectReason');
      prog.push('setStorage');
      if (this.$store.state.user.user.task_privilege.return_drug === false) {
        prog.push('rxCheck');
      }
      prog.push('action');
      return prog;
    },
    setupActionWrapProgress: function setupActionWrapProgress() {
      var prog = [];
      if (this.$store.state.generalSetting.check_amount_first) {
        prog.push('confirmAmount');
      }
      prog.push('action');
      prog.push('next');
      return prog;
    },
    cancel: function cancel() {
      this.$store.dispatch('recordAction', { eventType: 'CANCEL_RETURN' });
      this.$router.push({ name: 'Main' });
    },
    getSchedule: function getSchedule() {
      this.stage = 'selectDrug';
    },
    startFlow: function startFlow() {
      this.stage = 'startFlow';
    },
    getAllConfirmData: function getAllConfirmData() {
      // refetch data
      this.$store.dispatch('resetAll');
      this.stage = 'scanBarcode';
    },
    getBarcode: function getBarcode(scaned) {
      var data = scaned.toString();
      var returnScheduleId = parseInt(data.split(':')[1].split('***')[0], 10);
      this.$store.dispatch('setCurrentScheduleById', returnScheduleId);
      this.stage = 'selectDrug';
    }
  },
  watch: {
    stage: function stage(val) {
      if (val === 'selectDrug') {
        this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
      }
      if (val === 'ScheduleList' || val === 'scanBarcode') {
        this.$store.commit('SET_CURRENT_STEP', 'selectPatient');
      }
    }
  }
});

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flowComp_ProgressBar__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flowComp_ProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__flowComp_ProgressBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_PositionSelection__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_PositionSelection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__flowComp_PositionSelection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_BottomButtons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_BottomButtons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_BottomButtons__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
  todo: wait for backend for setting up return box.
  todo: post function for saving position.
*/





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SetReturnBox',
  components: {
    progressBar: __WEBPACK_IMPORTED_MODULE_2__flowComp_ProgressBar___default.a,
    selectBox: __WEBPACK_IMPORTED_MODULE_3__flowComp_PositionSelection___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_4__common_Loader___default.a,
    BottomButtons: __WEBPACK_IMPORTED_MODULE_5__common_BottomButtons___default.a
  },
  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  data: function data() {
    return {
      stage: 'loading',
      progress: [{
        en: 'selectPosition',
        zh: '選擇位置'
      }],
      returnCmpn: null,
      returnCmpnId: null
    };
  },

  methods: {
    cancel: function cancel() {
      this.$router.push({ name: 'Main' });
    },
    submit: function submit() {
      var _this = this;

      if (this.$store.state.device.selectedDevicesID.length !== 0) {
        this.stage = 'loading';
        this.instance.patch('/api/system/' + this.$store.getters.currentSystem.id + '/', {
          return_cmpn: this.$store.state.device.selectedDevicesID[0]
        }).then(function () {
          _this.$store.commit('SET_MESSAGE', {
            type: 'success',
            context: '設定成功'
          });
          _this.getFullReturnCmpn();
          // setInterval(() => {
          //   this.stage = 'finish';
          // }, 1000);
          // this.$router.push({ name: 'Main' });
        });
      } else {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '請先選擇位置'
        });
      }
    },
    deleteReturnCmpn: function deleteReturnCmpn() {
      var _this2 = this;

      this.stage = 'loading';
      this.instance.get('/api/event/', {
        params: {
          event: 'RETURN',
          device: this.$store.getters.currentSystem.return_cmpn,
          checked: false
        }
      }).then(function (res) {
        if (res.data.results.length > 0) {
          _this2.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: '尚有未回收之退藥, 請先行回收再刪除退藥盒'
          });
          _this2.$router.push({ name: 'recycleDrug' });
        } else {
          _this2.instance.patch('/api/system/' + _this2.$store.getters.currentSystem.id + '/', {
            return_cmpn: null
          }).then(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _this2.$store.commit('SET_MESSAGE', {
                      type: 'success',
                      context: '刪除成功'
                    });
                    _context.next = 3;
                    return _this2.$store.dispatch('getSystemInfo');

                  case 3:
                    _this2.returnCmpn = null;
                    _this2.stage = 'finish';

                  case 5:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this2);
          })));
        }
      });
    },
    getFullReturnCmpn: function getFullReturnCmpn() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.$store.dispatch('getSystemInfo');

              case 2:
                _this3.returnCmpnId = _this3.$store.getters.currentSystem.return_cmpn;
                console.log(_this3.returnCmpnId);
                // this.$store.state.systems.forEach((sys) => {
                //   if (sys.return_cmpn !== null) this.returnCmpnId = sys.return_cmpn;
                // });
                if (_this3.returnCmpnId !== null) {
                  _this3.instance.get('/api/device/' + _this3.returnCmpnId + '/').then(function (res) {
                    _this3.returnCmpn = res.data;
                    _this3.stage = 'finish';
                  });
                } else {
                  _this3.stage = 'finish';
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    }
  },
  mounted: function mounted() {
    this.$store.commit('SET_APP', '設定退藥盒');
    this.$store.commit('SET_CURRENT_STEP', 'selectPosition');
    this.$store.commit('SET_PROGRESS', this.progress);
    // get return cmpn
    this.getFullReturnCmpn();
  }
});

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flowComp_ProgressBar__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flowComp_ProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__flowComp_ProgressBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_EventTable__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_EventTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__flowComp_EventTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_BottomButtons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_BottomButtons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_BottomButtons__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// the query for event data is more complicate,
// if we want to use the EventTable.vue, refract is needed.








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'StorageError',
  components: {
    progressBar: __WEBPACK_IMPORTED_MODULE_2__flowComp_ProgressBar___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_4__common_Loader___default.a,
    BottomButtons: __WEBPACK_IMPORTED_MODULE_5__common_BottomButtons___default.a,
    EventTable: __WEBPACK_IMPORTED_MODULE_3__flowComp_EventTable___default.a
  },
  data: function data() {
    return {
      stage: 'selectEvent',
      eventType: 'STORAGE_ERROR',
      progress: [{
        en: 'selectEvent',
        zh: '選擇事件'
      }, {
        en: 'confirmEvent',
        zh: '確認事件'
      }]
    };
  },

  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    },
    storageError: function storageError() {
      return this.$store.getters.storageError;
    },
    selectedEventId: function selectedEventId() {
      return this.$store.state.event.selectedEventId;
    }
  },
  mounted: function mounted() {
    this.$store.commit('SET_APP', '存量不符');
    this.$store.commit('SET_PROGRESS', this.progress);
    this.$store.commit('SET_CURRENT_STEP', 'selectEvent');
  },

  methods: {
    cancel: function cancel() {
      this.$router.push({ name: 'Main' });
    },
    startFlow: function startFlow() {
      var _this = this;

      this.stage = 'finish';
      var promises = [];
      this.selectedEventId.forEach(function (eventId) {
        promises.push(_this.instance.patch('/api/event/' + eventId + '/', { checked: true }));
      });
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.all(promises).then(function () {
        _this.$store.dispatch('resetAll');
        // this.$router.push({ name: 'Main' });
        _this.stage = 'selectEvent';
      });
    }
  }
});

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_BottomButtons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_BottomButtons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_BottomButtons__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserManual',
  data: function data() {
    return {
      barcode: ''
    };
  },

  components: {
    BottomButtons: __WEBPACK_IMPORTED_MODULE_0__common_BottomButtons___default.a
  },
  methods: {
    cancel: function cancel() {
      if (this.$store.state.fingerprinterStatus === 'waiting_finger') {
        this.$store.dispatch('sendCancelFingerCaptureCommand');
      }
      this.$router.push({ name: 'Main' });
    }
  },
  mounted: function mounted() {
    this.$store.commit('SET_APP', '使用者選項');
  }
});

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flowComp_ScanBarcode__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flowComp_ScanBarcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__flowComp_ScanBarcode__);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Barcode',
  components: {
    ScanBarcode: __WEBPACK_IMPORTED_MODULE_0__flowComp_ScanBarcode___default.a
  },
  methods: {
    getBarcode: function getBarcode(val) {
      var _this = this;

      this.instance.patch('/api/user/' + this.user.id + '/', {
        barcode: val
      }).then(function (res) {
        _this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功'
        });
        // this.$router.push({ name: 'Main' });
      }).catch(function () {
        _this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '更新失敗'
        });
      });
    }
  },
  computed: {
    user: function user() {
      return this.$store.state.user.user;
    },
    instance: function instance() {
      return this.$store.state.instance;
    }
  }
});

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Barcode',
  components: {},
  mounted: function mounted() {
    this.$store.dispatch('sendScanFingerCommand');
  },

  methods: {
    saveFingerprint: function saveFingerprint(feature) {
      var _this = this;

      this.instance.patch('/api/user/' + this.user.id + '/', {
        fingerprint: feature
      }).then(function (res) {
        _this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功'
        });
        _this.$router.push({ name: 'userManual' });
      }).catch(function () {
        _this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '更新失敗'
        });
      });
    }
  },
  computed: {
    fingerprint: function fingerprint() {
      return this.$store.state.user.fingerprint;
    },
    user: function user() {
      return this.$store.state.user.user;
    },
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  watch: {
    fingerprint: function fingerprint(val) {
      this.saveFingerprint(val);
    }
  }
});

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Password',
  methods: {
    goto: function goto(val) {
      this.$router.push({ name: val });
    }
  }
});

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Password',
  data: function data() {
    return {
      newPass: '',
      newPass2: '',
      passwordSame: true
    };
  },

  methods: {
    resetPassword: function resetPassword(val) {
      var _this = this;

      if (this.newPass === this.newPass2) {
        this.instance.patch('/api/user/' + this.user.id + '/', {
          password: this.newPass
        }).then(function (res) {
          _this.$store.commit('SET_MESSAGE', {
            type: 'success',
            context: '更新成功'
          });
          // this.$router.push({ name: 'Main' });
        }).catch(function () {
          _this.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: '更新失敗'
          });
        });
      } else {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '請確認新密碼一致'
        });
      }
    }
  },
  computed: {
    user: function user() {
      return this.$store.state.user.user;
    },
    instance: function instance() {
      return this.$store.state.instance;
    }
  }
});

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flowComp_ProgressBar__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flowComp_ProgressBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__flowComp_ProgressBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_ScanBarcode__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__flowComp_ScanBarcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__flowComp_ScanBarcode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flowComp_EventTable__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flowComp_EventTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__flowComp_EventTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flowComp_DrugInDeviceList__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flowComp_DrugInDeviceList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__flowComp_DrugInDeviceList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__WasteFlow_MultiFlow__ = __webpack_require__(1335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__WasteFlow_MultiFlow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__WasteFlow_MultiFlow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_BottomButtons__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_BottomButtons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__common_BottomButtons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ComponentBase_AppBase__ = __webpack_require__(33);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Waste',
  extends: __WEBPACK_IMPORTED_MODULE_9__ComponentBase_AppBase__["a" /* default */],
  data: function data() {
    return {
      startType: 'event',
      eventType: 'FETCH',
      drugSetMethod: 'event',
      barcodeData: {},
      returnScheduleId: null
    };
  },

  components: {
    progressBar: __WEBPACK_IMPORTED_MODULE_2__flowComp_ProgressBar___default.a,
    scanBarcode: __WEBPACK_IMPORTED_MODULE_3__flowComp_ScanBarcode___default.a,
    eventTable: __WEBPACK_IMPORTED_MODULE_4__flowComp_EventTable___default.a,
    MultiFlow: __WEBPACK_IMPORTED_MODULE_6__WasteFlow_MultiFlow___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_7__common_Loader___default.a,
    drugList: __WEBPACK_IMPORTED_MODULE_5__flowComp_DrugInDeviceList___default.a,
    BottomButtons: __WEBPACK_IMPORTED_MODULE_8__common_BottomButtons___default.a
  },
  created: function created() {
    if (this.$route.params.drugSetMethod) {
      this.drugSetMethod = this.$route.params.drugSetMethod;
    }
    this.stage = 'selectDrug';
    this.progress = this.setupProgress();
    this.multiProgress = this.setupMultiProgress();
    this.confirmProgress = this.setupConfirmProgress();
    this.actionProgress = this.setupActionWrapProgress();
    this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
  },
  mounted: function mounted() {},

  computed: {
    generalSetting: function generalSetting() {
      return this.$store.state.generalSetting;
    }
  },
  methods: {
    setupProgress: function setupProgress() {
      var prog = [];
      if (this.drugSetMethod === 'event') prog.push({ en: 'selectDrug', zh: '選擇取藥事件' });
      if (this.drugSetMethod === 'manual') prog.push({ en: 'selectDrug', zh: '選擇藥物位置' });
      if (this.drugSetMethod === 'barcode') prog.push({ en: 'selectDrug', zh: '掃描處方籤條碼' });
      // prog.push({ en: 'selectReason', zh: '拋棄理由' });
      // prog.push({ en: 'medIdInput', zh: '輸入病歷號' });
      // prog.push({ en: 'setPatchNo', zh: '確認批號' });
      // prog.push({ en: 'setExpiredDate', zh: '確認效期' });
      prog.push({ en: 'setStorage', zh: '拋棄數量' });
      // if (this.generalSetting.check_amount_first) {
      // prog.push({ en: 'confirmAmount', zh: '確認數量' });
      // }
      // prog.push({ en: 'action', zh: '進行退藥' });
      return prog;
    },
    setupMultiProgress: function setupMultiProgress() {
      return ['confirm', 'returnEmpty', 'finish'];
    },
    setupConfirmProgress: function setupConfirmProgress() {
      var prog = [];
      // prog.push('selectReason');
      // prog.push('medIdInput');
      // prog.push('setPatchNo');
      // prog.push('setExpiredDate');
      prog.push('setStorage');
      // prog.push('action');
      return prog;
    },
    setupActionWrapProgress: function setupActionWrapProgress() {
      var prog = [];
      if (this.generalSetting.check_amount_first) {
        prog.push('confirmAmount');
      }
      prog.push('action');
      prog.push('next');
      return prog;
    },
    setDrugSetMethod: function setDrugSetMethod(val) {
      this.$store.dispatch('unSelectAllDrugStorageAndDevices');
      this.$store.dispatch('unSelectAllEvent');
      this.drugSetMethod = val;
      if (val === 'manual') {
        this.startType = 'drugStorage';
      }
      if (val === 'barcode') {
        this.startType = 'event';
      }
      if (val === 'event') {
        this.startType = 'event';
      }
      this.$store.commit('SET_PROGRESS', this.progress);
    },
    cancel: function cancel() {
      this.$router.push({ name: 'Main' });
      this.$store.dispatch('recordAction', { eventType: 'CANCEL_RETURN' });
    },
    startFlow: function startFlow() {
      this.stage = 'setFlowData';
    },
    getAllConfirmData: function getAllConfirmData() {
      this.$store.dispatch('resetAll');
      this.$store.dispatch('getDrugInDevices');
      this.setDrugSetMethod('event');
      this.stage = 'selectDrug';
      this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
      this.barcodeData = {};
    },
    returnByPackBarcode: function returnByPackBarcode(data) {
      var _this = this;

      // 長庚: 料位號 (3碼) + 數量(3碼) + 病歷號(7碼)
      var barcodeString = data.toString();
      //20190424 modified
      var code;
      var amount;
      var medRecordId;
      console.log('barcodeLen:', barcodeString.length);
      if (barcodeString.length >= 20 && barcodeString.length <= 22) {
        console.log('new barcode type');
        code = barcodeString.slice(0, 3);
        amount = parseInt(barcodeString.slice(3, 6), 10);
        medRecordId = barcodeString.slice(6, 18);
        medRecordId = medRecordId.split(' ').join(''); //filter space char  
        console.log('料位號:', code);
        console.log('數量:', amount);
        console.log('病歷號:', medRecordId);
      } else {
        console.log('old barcode type');
        code = barcodeString.slice(0, 3);
        amount = parseInt(barcodeString.slice(3, 6), 10);
        medRecordId = barcodeString.slice(6, barcodeString.length).split('\r')[0];
        console.log('料位號:', code);
        console.log('數量:', amount);
        console.log('病歷號:', medRecordId);
      }

      this.instance.get('/api/medication/', {
        params: {
          CGMH_number: code
        }
      }).then(function (res) {
        _this.instance.get('/api/event/', {
          params: {
            event: 'FETCH',
            med_record_no: medRecordId,
            number1: -amount,
            medication: res.data.results[0].id,
            drug_storage__isnull: false
            // checked: false,
          }
        }).then(function (res) {
          if (res.data.results.length === 0) {
            _this.$store.commit('SET_MESSAGE', { type: 'warn', context: '查無紀錄' });
          } else {
            _this.$store.dispatch('selectEvent', { eventId: res.data.results[0].id }).then(function () {
              _this.barcodeData.medRecordId = medRecordId;
              _this.barcodeData.amount = amount;
              console.log('success');
              _this.stage = 'setFlowData';
            });
          }
        });
      });
    },
    returnBySchedule: function returnBySchedule(data) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.returnScheduleId = parseInt(data.split(':')[1].split('***')[0], 10);
                _this2.drugSetMethod = 'returnSchedule';
                _context.next = 4;
                return _this2.$store.dispatch('setCurrentScheduleById', _this2.returnScheduleId);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    getBarcode: function getBarcode(scaned) {
      var data = scaned.toString();
      if (data.split(':')[0] === '***THC-schedule') {
        this.returnBySchedule(data);
      } else {
        this.returnByPackBarcode(data);
      }
    }
  },
  watch: {
    stage: function stage(val) {
      if (val === 'selectDrug') {
        this.$store.commit('SHOW_LOGOUT', true);
      } else {
        this.$store.commit('SHOW_LOGOUT', false);
      }
    }
  }
});

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flowComp_NumberSet__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flowComp_NumberSet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__flowComp_NumberSet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ComponentBase_ConfirmFlowBase__ = __webpack_require__(37);
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'confirmFlow',
  extends: __WEBPACK_IMPORTED_MODULE_1__ComponentBase_ConfirmFlowBase__["a" /* default */],
  components: {
    ConfirmStorage: __WEBPACK_IMPORTED_MODULE_0__flowComp_NumberSet___default.a
  },
  props: [],
  data: function data() {
    return {
      storage: 0
    };
  },
  mounted: function mounted() {
    this.$store.commit('SET_CURRENT_STEP', this.currentProgress);
  },

  methods: {
    getStorage: function getStorage(num) {
      this.storage = num;
      if (num > Math.abs(this.currentEvent.number1)) {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '拋棄數量不可大於該次取藥數量'
        });
      } else {
        this.recordWasteEvent(this.storage);
      }
    },
    recordWasteEvent: function recordWasteEvent(num) {
      var _this = this;

      var event = {
        event_type: 'WASTE',
        med_record_no: this.currentEvent.med_record_no,
        medication: this.currentEvent.medication.id,
        medication_generic_name: this.currentEvent.medication.generic_name,
        employee: this.$store.state.user.user.id,
        employee_name: '' + this.$store.state.user.user.last_name + this.$store.state.user.user.first_name,
        // device: this.currentDrugInDevice.device.id,
        // stock: this.currentEvent.child_medication_quantity,
        // total_stock: this.currentMed.child_medication_quantity,
        batch_no: this.currentEvent.batch_no,
        number1: num,
        checked: true
      };
      this.instance.post('/api/event/', event).then(function (res) {
        var recordedEventId = res.data;
        _this.instance.patch('/api/event/' + _this.currentEvent.id + '/', {
          checked: true,
          related_events: [recordedEventId]
        }).then(function () {
          _this.$emit('confirmationFinish');
        });
      });
    }
  },
  computed: {},
  watch: {
    currentEvent: function currentEvent(val) {
      if (this.startType === 'event') {
        this.medRecordId = this.currentEvent.med_record_no;
        this.patchNo = this.currentEvent.batch_no;
        this.defaultReturnAmount = Math.abs(this.currentEvent.number1);
      }
    }
  }
});

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConfirmFlow__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConfirmFlow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ConfirmFlow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flowComp_DrugInfo__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flowComp_DrugInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__flowComp_DrugInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ComponentBase_MultiFlowBase__ = __webpack_require__(38);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'multiFlow',
  extends: __WEBPACK_IMPORTED_MODULE_3__ComponentBase_MultiFlowBase__["a" /* default */],
  components: {
    ConfirmFlow: __WEBPACK_IMPORTED_MODULE_0__ConfirmFlow___default.a,
    DrugInfo: __WEBPACK_IMPORTED_MODULE_1__flowComp_DrugInfo___default.a
  },
  props: [],
  data: function data() {
    return {};
  },

  methods: {
    getConfirmData: function getConfirmData() {
      console.log('get confirm data');
      this.stage = 'finish';
      if (this.nextEvent === null || this.nextDrugInDevice === null) {
        this.$emit('setAllConfirmData');
        this.resetProgress();
      } else {
        this.$store.dispatch('toNextEvent');
        console.log('next event');
        this.eventSwitch();
      }
    }
  },
  created: function created() {
    this.$store.dispatch('fromFirstEvent');
  },

  computed: {
    selectedEventId: function selectedEventId() {
      return this.$store.state.event.selectedEventId;
    }
  }
});

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminPatch'
});

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BottomButtons'
});

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Calendar',
  data: function data() {
    return {
      weekTitle: ['Sun', 'Mon', 'Tue', 'Wen', 'Thu', 'Fri', 'Sat'],
      year: null,
      month: null,
      date: null,
      selectWeekInd: null,
      selectDayInd: null,
      dateSelected: null,
      momentNow: null,
      todayWeekCount: 0,
      todayWeekDay: 0
    };
  },
  created: function created() {
    this.momentNow = __WEBPACK_IMPORTED_MODULE_1_moment___default()();
    this.setData(this.momentNow);
    this.creatMonthMatrix(this.year, this.month);
    this.selectDay(this.todayWeekCount, this.todayWeekDay);
  },

  methods: {
    setData: function setData(momentData) {
      // this.momentNow = momentData;
      this.year = momentData.year();
      this.month = momentData.month() + 1;
      this.date = momentData.date();
    },
    addMonth: function addMonth() {
      this.setData(this.momentNow.add(1, 'months'));
      this.creatMonthMatrix();
    },
    minusMonth: function minusMonth() {
      this.setData(this.momentNow.subtract(1, 'months'));
      this.creatMonthMatrix();
    },
    selectDay: function selectDay(weekInd, dayInd) {
      this.selectWeekInd = weekInd;
      this.selectDayInd = dayInd;
      this.dateSelected = this.monthMatrix[weekInd][dayInd];
      this.$emit('setDatetime', this.year + '-' + this.month + '-' + this.dateSelected);
    },
    creatMonthMatrix: function creatMonthMatrix() {
      var numberOfDaysThisMonth = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.year + '-' + this.month, 'YYYY-MM').daysInMonth();
      var numberOfDaysPreviousMonth = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.year + '-' + this.month, 'YYYY-MM').subtract(1, 'months').daysInMonth();
      /* eslint-disable */
      var calendarMatrix = new Array(Array(7), Array(7), Array(7), Array(7), Array(7), Array(7));
      var start = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.year + '-' + this.month + '-01', 'YYYY-MM-DD').days();
      for (var i = 1; i < numberOfDaysThisMonth + 1; i += 1) {
        var weekday = (i + start - 1) % 7; // shift the start day
        var weekCount = Math.floor((i + start - 1) / 7);
        calendarMatrix[weekCount][weekday] = i;
        if (i === this.momentNow.date()) {
          this.todayWeekCount = weekCount;
          this.todayWeekDay = weekday;
        }
      }
      this.monthMatrix = calendarMatrix;
    }
  }
});

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



//
//
//
//
//
//
//
//
//
//
//
//

/*
  reference from: https://codepen.io/anon/pen/NwLOKq
*/
/* eslint-disable */
var Clock = function () {
  function Clock(id) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Clock);

    this.timezone = parseInt(document.getElementById(id).dataset.timezone, 10);
    // console.log(this.timezone);

    if (this.isDST(new Date())) {
      this.timezone += 1;
    }

    this.handSeconds = document.querySelector('#' + id + ' .hand.seconds');
    this.handMinutes = document.querySelector('#' + id + ' .hand.minutes');
    this.handHours = document.querySelector('#' + id + ' .hand.hours');

    this.getTime();
    this.cycle();
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Clock, [{
    key: 'isDST',
    value: function isDST(now) {
      var jan = new Date(now.getFullYear(), 0, 1);
      var jul = new Date(now.getFullYear(), 6, 1);
      var dst = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());

      return now.getTimezoneOffset() < dst;
    }
  }, {
    key: 'draw',
    value: function draw(hours, minutes, seconds) {
      var drawSeconds = seconds / 60 * 360 + 90;
      var drawMinutes = minutes / 60 * 360 + 90;

      if (hours >= 12) {
        drawHours = hours - 12;
      } else {
        drawHours = hours;
      }
      var drawHours = hours / 12 * 360 + 90;

      this.handSeconds.style.transform = 'rotate(' + drawSeconds + 'deg)';
      this.handMinutes.style.transform = 'rotate(' + drawMinutes + 'deg)';
      this.handHours.style.transform = 'rotate(' + drawHours + 'deg)';

      // fix for animation bump on when clock hands hit zero
      if (drawSeconds === 444 || drawSeconds === 90) {
        this.handSeconds.style.transition = 'all 0s ease 0s';
      } else {
        this.handSeconds.style.transition = 'all 0.05s cubic-bezier(0, 0, 0.52, 2.51) 0s';
      }
    }
  }, {
    key: 'getTime',
    value: function getTime() {
      var now = new Date();

      var hours = now.getUTCHours() + this.timezone;
      var minutes = now.getUTCMinutes();
      var seconds = now.getUTCSeconds();

      this.draw(hours, minutes, seconds);
    }
  }, {
    key: 'cycle',
    value: function cycle() {
      setInterval(this.getTime.bind(this), 1000);
    }
  }]);

  return Clock;
}();

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Clock',
  mounted: function mounted() {
    var taipei = new Clock('taipei');
  }
});

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Confirm',
  props: ['message'],
  methods: {
    yes: function yes() {
      this.$emit('response', true);
    },
    no: function no() {
      this.$emit('response', false);
    }
  }
});

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreateUserForm',
  data: function data() {
    return {
      name: '',
      formMsg: '請填入所有資訊以新增'
    };
  },
  created: function created() {},

  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    },
    formComplete: function formComplete() {
      if (this.name === '') return false;
      return true;
    }
  },
  methods: {
    createMedGroup: function createMedGroup() {
      var _this = this;

      if (this.formComplete) {
        this.instance.post('/api/medication-group/', {
          name: this.name
        }).then(function () {
          _this.$store.commit('SET_MESSAGE', {
            type: 'success',
            context: '新增成功'
          });
          _this.$emit('dataCreated');
          _this.$parent.$refs.vuetable.refresh();
        }).catch(function (err) {
          _this.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: err.response.data
          });
        });
      }
    }
  }
});

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreateDrugStorageForm',
  props: ['devices'],
  data: function data() {
    return {
      currentDevice: {},
      currentMedicine: {},
      searchDrug: '',
      medicines: [],
      deviceId: null,
      stock: 0,
      maxStock: 0,
      inventoried: false
    };
  },

  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    },
    formComplete: function formComplete() {
      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.currentDevice).length === 0) return false;
      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.currentMedicine).length === 0) return false;
      return true;
    }
  },
  methods: {
    setCurrentDevice: function setCurrentDevice() {
      this.currentDevice = this.devices[this.deviceId];
    },
    setMedicine: function setMedicine(index) {
      this.currentMedicine = this.medicines[index];
      this.searchDrug = this.currentMedicine.generic_name;
      this.medicines = [];
    },
    createDrugStorage: function createDrugStorage() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.instance.get('/api/drug-storage/', {
                  params: {
                    device__net__system: _this.$store.state.device.systemId,
                    med_id: _this.currentMedicine.id
                  }
                }).then(function (res) {
                  if (res.data.results.length === 0) {
                    if (parseInt(_this.maxStock, 10) >= parseInt(_this.stock, 10)) {
                      _this.instance.post('/api/drug-storage/', {
                        device: _this.currentDevice.id,
                        medication: _this.currentMedicine.id,
                        stock: _this.stock,
                        max_stock: _this.maxStock,
                        expired_date: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD'),
                        patch_number: null,
                        inventoried_in_tag_system: _this.inventoried,
                        number1: _this.stock,
                        type: 'ADMIN_CREATE'
                      }).then(function (res) {
                        _this.$store.commit('SET_MESSAGE', {
                          type: 'success',
                          context: '新增成功'
                        });
                        _this.$parent.$refs.vuetable.refresh();
                        _this.$emit('cancelForm');
                        _this.$parent.getTagSystem().then(function () {
                          _this.$parent.setCurrentTag();
                          _this.$parent.setCurrentNet();
                        });
                      }).catch(function (err) {
                        console.log(err.response);
                        _this.$store.commit('SET_MESSAGE', {
                          type: 'error',
                          context: '新增失敗'
                        });
                      });
                    } else {
                      _this.$store.commit('SET_MESSAGE', {
                        type: 'error',
                        context: '最大庫存量不可小於庫存量'
                      });
                    }
                  } else {
                    _this.$store.commit('SET_MESSAGE', {
                      type: 'error',
                      context: '此藥物已新增於系統中'
                    });
                  }
                });

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  watch: {
    searchDrug: function searchDrug(val) {
      var _this2 = this;

      if (val.length >= 3 && this.searchDrug !== this.currentMedicine.generic_name) {
        this.instance.get('/api/medication/', {
          params: {
            search: val
          }
        }).then(function (res) {
          _this2.medicines = res.data.results;
        });
      } else {
        this.medicines = [];
      }
    }
  }
});

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreateMedicineForm',
  data: function data() {
    return {
      code: null,
      genericName: null,
      productName: '',
      packageCode1: '',
      packageCode2: '',
      CGMHNumber: null,
      restrainedClass: 0,
      packContent: 0,
      licenseId: undefined,
      manufacturer: undefined
    };
  },

  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    },
    formComplete: function formComplete() {
      if (this.generic_name === null) return false;
      if (this.code === null) return false;
      if (this.CGMHNumber === null) return false;
      return true;
    }
  },
  methods: {
    checkMedWithSameCGMHNumber: function checkMedWithSameCGMHNumber(CGMHNumber) {
      this.instance.get('/api/medication/', {
        params: {
          CGMH_number: CGMHNumber
        }
      }).then(function (res) {
        if (res.data.results.length > 0) {
          return true;
        }
        return false;
      });
    },
    addDrug: function addDrug() {
      var _this = this;

      var newDrug = {
        // type: null,
        code: this.code,
        CGMH_number: this.CGMHNumber,
        // package_code: null,
        package_code2: this.packageCode2,
        generic_name: this.genericName,
        product_name: this.productName,
        // chinese_name: '',
        // content_amount: null,
        // content_unit: '',
        // content_amount_divider: null,
        // content_unit_divider: '',
        // content_percent: null,
        // dosage_unit: '',
        // dose_unit: '',
        // total_content_amount: null,
        // total_content_unit: '',
        pack_content: this.packContent,
        restrained_class: this.restrainedClass,
        license_id: this.licenseId,
        manufacturer: this.manufacturer
        // return_stock: null,
        // return_when_empty: null,
        // rx_check: null,
        // inventory_type: null,
        // drug_picture_1: null,
        // drug_picture_2: null,
        // drug_box_picture: null,
        // group: [],
      };
      this.instance.get('/api/medication/', {
        params: {
          has_code: this.code
        }
      }).then(function (res) {
        if (res.data.results.length === 0) {
          _this.instance.get('/api/medication/', {
            params: {
              has_CGMH_number: _this.CGMHNumber
            }
          }).then(function (res) {
            if (res.data.results.length === 0) {
              _this.instance.post('/api/medication/', newDrug).then(function () {
                _this.$store.commit('SET_MESSAGE', {
                  type: 'success',
                  context: '新增成功'
                });
                _this.$emit('closeForm');
                _this.$parent.$refs.vuetable.refresh();
              }).catch(function (err) {
                _this.$store.commit('SET_MESSAGE', {
                  type: 'error',
                  context: err.response.data
                });
              });
            } else {
              _this.$store.commit('SET_MESSAGE', {
                type: 'warn',
                context: '料位號重複，請重新確認'
              });
            }
          });
        } else {
          _this.$store.commit('SET_MESSAGE', {
            type: 'warn',
            context: '藥碼重複，請重新確認'
          });
        }
      });
    }
  },
  watch: {
    restrainedClass: function restrainedClass(val) {
      if (isNaN(val)) {
        this.restrainedClass = 0;
      } else {
        this.restrainedClass = parseInt(val, 10);
      }
    },
    packContent: function packContent(val) {
      if (isNaN(val)) {
        this.packContent = 0;
      } else {
        this.packContent = parseInt(val, 10);
      }
    }
  }
});

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreateMedicineForm',
  props: ['medicineType'],
  data: function data() {
    return {
      code: null,
      genericName: null,
      productName: '',
      packageCode1: '',
      packageCode2: '',
      CGMHNumber: null,
      restrainedClass: 0,
      packContent: 0
    };
  },

  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    },
    formComplete: function formComplete() {
      if (this.genericName === null || this.genericName === '') return false;
      if (this.code === null || this.code === '') return false;
      // if (this.CGMHNumber === null) return false;
      return true;
    }
  },
  methods: {
    checkMedWithSameCGMHNumber: function checkMedWithSameCGMHNumber(CGMHNumber) {
      this.instance.get('/api/medication/', {
        params: {
          CGMH_number: CGMHNumber
        }
      }).then(function (res) {
        if (res.data.results.length > 0) {
          return true;
        }
        return false;
      });
    },
    addDrug: function addDrug() {
      var _this = this;

      var newDrug = {
        type: this.medicineType,
        code: this.code,
        CGMH_number: null,
        // package_code: null,
        package_code2: null,
        generic_name: this.genericName,
        product_name: null,
        // chinese_name: '',
        // content_amount: null,
        // content_unit: '',
        // content_amount_divider: null,
        // content_unit_divider: '',
        // content_percent: null,
        // dosage_unit: '',
        // dose_unit: '',
        // total_content_amount: null,
        // total_content_unit: '',
        pack_content: 0,
        restrained_class: this.medicineType === 'control' ? 1 : 0
        // return_stock: null,
        // return_when_empty: null,
        // rx_check: null,
        // inventory_type: null,
        // drug_picture_1: null,
        // drug_picture_2: null,
        // drug_box_picture: null,
        // group: [],
      };
      this.instance.get('/api/medication/', {
        params: {
          has_code: this.code
        }
      }).then(function (res) {
        if (res.data.results.length === 0) {
          _this.instance.post('/api/medication/', newDrug).then(function () {
            _this.$store.commit('SET_MESSAGE', {
              type: 'success',
              context: '新增成功'
            });
            _this.$emit('dataCreated');
            _this.$parent.$refs.vuetable.refresh();
          }).catch(function (err) {
            _this.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: err.response.data
            });
          });
        } else {
          _this.$store.commit('SET_MESSAGE', {
            type: 'warn',
            context: '藥碼重複，請重新確認'
          });
        }
      });
    }
  },
  watch: {
    restrainedClass: function restrainedClass(val) {
      if (isNaN(val)) {
        this.restrainedClass = 0;
      } else {
        this.restrainedClass = parseInt(val, 10);
      }
    },
    packContent: function packContent(val) {
      if (isNaN(val)) {
        this.packContent = 0;
      } else {
        this.packContent = parseInt(val, 10);
      }
    }
  }
});

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreateUserForm',
  data: function data() {
    return {
      username: null,
      password: null,
      password2: null,
      jobTitle: null,
      jobTitles: [],
      department: null,
      departments: [],
      loginBarcode: null,
      //medAppPrivilegeGroups: [],
      //medAppPrivilegeGroup: "全部功能",
      serverPrivilege2Groups: [],
      serverPrivilege2Group: "後台操作權限",
      firstName: '',
      lastName: '',
      loginBackCheck: true,
      backManage: false,
      formMsg: '請填入所有資訊以新增'
    };
  },
  created: function created() {
    this.getJobTitle();
    this.getDepartment();
    //this.getMedAppPrivilegeGroup();
    this.getServerPrivilege2Group();
  },

  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    },
    formComplete: function formComplete() {
      if (this.username === null) return false;
      if (this.password === null) return false;
      if (this.password2 === null) return false;
      if (this.jobTitle === null) return false;
      if (this.department === null) return false;
      if (this.loginBarcode === null) return false;
      if (this.firstName === '') return false;
      if (this.lastName === '') return false;
      if (this.password !== this.password2) return false;
      return true;
    }
  },
  methods: {
    createNewUser: function createNewUser() {
      var _this = this;

      if (this.password === this.password2) {
        this.instance.post('/api/user/', {
          username: this.username,
          password: this.password,
          first_name: this.firstName,
          last_name: this.lastName,
          barcode: this.loginBarcode,
          department: this.department,
          title: this.jobTitle,
          //med_app_privilege: this.medAppPrivilegeGroup,
          server_privilege2: this.serverPrivilege2Group,
          is_admin: this.loginBackCheck,
          is_superuser: this.backManage
        }).then(function () {
          _this.$store.commit('SET_MESSAGE', {
            type: 'success',
            context: '新增成功'
          });
          _this.$emit('closeForm');
          _this.$parent.$refs.vuetable.refresh();
        }).catch(function (err) {
          _this.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: err.response.data
          });
        });
      } else {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '請確認密碼一致'
        });
      }
    },
    getDepartment: function getDepartment() {
      var _this2 = this;

      return this.instance.get('/api/department/').then(function (res) {
        _this2.putIntoData(res, 'departments');
      });
    },
    getJobTitle: function getJobTitle() {
      var _this3 = this;

      return this.instance.get('/api/job-title/').then(function (res) {
        _this3.putIntoData(res, 'jobTitles');
      });
    },
    putIntoData: function putIntoData(response, data) {
      var _this4 = this;

      response.data.forEach(function (item) {
        _this4[data].push(item);
      });
    },

    /*
    getMedAppPrivilegeGroup() {
      this.instance.get('/api/med-app-privilege/')
      .then((res) => {
        this.putIntoData(res, 'medAppPrivilegeGroups');
      });
    },
    */
    getServerPrivilege2Group: function getServerPrivilege2Group() {
      var _this5 = this;

      this.instance.get('/api/server-privilege2/').then(function (res) {
        _this5.putIntoData(res, 'serverPrivilege2Groups');
      });
    }
  },
  watch: {
    password2: function password2(val) {
      if (val !== this.password) {
        this.formMsg = '請確認密碼一致';
      } else {
        this.formMsg = '';
      }
    }
  }
});

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FocusModal',
  props: ['message'],
  methods: {
    close: function close() {
      this.$emit('close');
    }
  }
});

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_spinner_src_ClipLoader__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_spinner_src_ClipLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_spinner_src_ClipLoader__);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Loader',
  components: {
    ClipLoader: __WEBPACK_IMPORTED_MODULE_0_vue_spinner_src_ClipLoader___default.a
  }
});

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Message',
  methods: {
    closeModal: function closeModal() {
      this.$store.commit('CLOSE_MESSAGE', true);
    },
    openDevice: function openDevice() {
      this.$store.dispatch('openDevice');
    },
    findDevicesWithSameDrawer: function findDevicesWithSameDrawer(netId) {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.$store.getters.allDevices), function (item) {
        return item.net.id === netId;
      });
    },
    handleDevicesForLockup: function handleDevicesForLockup() {
      var _this = this;

      var promise = [];
      this.forLockDevices.forEach(function (dev) {
        if (dev.type === 'net') {
          var devicesOnSameNet = _this.findDevicesWithSameDrawer(dev.id);
          if (devicesOnSameNet.length === 1) {
            // only lock up F type
            devicesOnSameNet.forEach(function (subDev) {
              promise.push(_this.$store.state.instance.patch('/api/device/' + subDev.id + '/', {
                error: true
              }));
            });
          }
        }
        if (dev.type === 'device') {
          promise.push(_this.$store.state.instance.patch('/api/device/' + dev.id + '/', {
            error: true
          }));
        }
      });

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.all(promise).then(function () {
        _this.$router.push({ name: 'Main' });
        _this.$store.commit('SET_MESSAGE', {
          context: '非預期開啟之裝置已上鎖，請重新執行原動作',
          type: 'warn',
          keepOnTop: true
        });
      });
    },
    openDeviceByIds: function openDeviceByIds() {
      var _this2 = this;

      var promise = [];
      if (this.errorDeviceIDs.length !== 0) {
        this.errorDeviceIDs.forEach(function (id) {
          _this2.$store.dispatch('openDevice', id);
        });
      }
    },
    openDevicesDiff: function openDevicesDiff() {
      if (this.message.type === 'warn') this.openDevice();
      if (this.message.type === 'error') this.openDeviceByIds();
    }
  },
  mounted: function mounted() {
    this.$store.commit('MESSAGE_POPED', true);
  },
  destroyed: function destroyed() {
    this.$store.commit('MESSAGE_POPED', false);
  },

  computed: {
    message: function message() {
      return this.$store.state.message;
    },
    errorDevices: function errorDevices() {
      return this.$store.state.device.errorDevices;
    },
    forLockDevices: function forLockDevices() {
      return this.$store.state.device.forLockDevices;
    },
    errorDeviceIDs: function errorDeviceIDs() {
      var _this3 = this;

      var ids = [];
      this.$store.state.device.errorDevices.forEach(function (dev) {
        console.log(dev);
        if (dev.type === 'box') {
          // _.filter(Object.values(this.$store.getters.allDevices), { system: dev.net.system.relative_index - 1, drawerId: dev.net.row_id, col: dev.relative_col, row: dev.pos_row });
          // ids.push(_.filter(Object.values(this.$store.getters.syst), { system: dev.net.system - 1, drawerId: dev.net.row_id, col: dev.relative_col, row: dev.pos_row })[0].id);
          ids.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(_this3.$store.getters.systems)[dev.system].net_set[dev.drawerId - 1].device_set[dev.boxId].id);
        }
      });
      return ids;
    }
  }
});

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Clock__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Clock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Clock__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'navbar',
  components: {
    Clock: __WEBPACK_IMPORTED_MODULE_1__Clock___default.a
  },
  computed: {
    user: function user() {
      return this.$store.state.user.user;
    },
    currentApp: function currentApp() {
      return this.$store.state.currentApp;
    },
    GreetingMsg: function GreetingMsg() {
      var hourNow = __WEBPACK_IMPORTED_MODULE_0_moment___default()().hour();
      if (hourNow >= 5 && hourNow < 11) {
        return '早安';
      }
      if (hourNow >= 11 && hourNow <= 17) {
        return '午安';
      }
      return '晚安';
    },
    showLogout: function showLogout() {
      return this.$store.state.showLogout;
    }
  },
  methods: {
    logout: function logout() {
      this.$store.dispatch('setOffline');
      this.$store.dispatch('logout');
      this.$router.push({ name: 'Login' });
    }
  },
  watch: {
    // user(val) {
    //   if (val === null || val === undefined) {
    //     this.$store.dispatch('getUser');
    //   }
    // },
  }
});

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PasswordChange',
  props: ['userId'],
  data: function data() {
    return {
      password1: null,
      password2: null,
      errMsg: ''
    };
  },

  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  methods: {
    changePassword: function changePassword() {
      var _this = this;

      if (this.password1 === this.password2) {
        this.instance.patch('/api/user/' + this.userId + '/', {
          password: this.password2
        }).then(function (res) {
          _this.$store.commit('SET_MESSAGE', {
            type: 'success',
            context: '更新成功'
          });
          _this.$emit('closePanel');
        }).catch(function () {
          _this.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: '更新失敗'
          });
        });
      } else {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '請確認新密碼一致'
        });
      }
    },
    closePanel: function closePanel() {
      this.$emit('closePanel');
    }
  },
  watch: {
    password2: function password2() {
      if (this.password2 !== this.password1) {
        this.errMsg = '請確認密碼一致';
      } else {
        this.errMsg = '';
      }
    }
  }
});

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SystemPanel__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SystemPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SystemPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LockDevice__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LockDevice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__LockDevice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LockDrawer__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LockDrawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__LockDrawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ScanBarcode__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ScanBarcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ScanBarcode__);




var _this6 = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







function hasOnlyDrawer(errorDevices) {
  if (errorDevices.length === 1 && errorDevices[0].type === 'drawer') return true;
  return false;
}

function hasOnlyBox(errorDevices) {
  var drawerList = [];
  errorDevices.forEach(function (item) {
    if (item.type === 'drawer') drawerList.push(item);
  });
  if (drawerList.length === 0) return true;
  return false;
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Action',
  props: {
    onlyPc: {
      type: Boolean,
      default: false
    },
    compType: {
      type: String,
      default: 'Action'
    },
    defaultNum: {
      type: Number,
      default: 0
    },
    defaultPackCount: {
      type: Number,
      default: 0
    },
    limitPackCount: {
      type: Boolean,
      default: true
    },
    deviceId: Number,
    checkNum: Number,
    autoCaculateAmount: {
      type: Boolean,
      default: false
    },
    inputReadOnly: {
      type: Boolean,
      default: false
    },
    valueMoreThanZero: {
      type: Boolean,
      default: true
    },
    hasSlot: {
      type: Boolean,
      default: false
    },
    defaultEmptyCount: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      num: 0,
      nextDeviceOnSameNet: true,
      nextDrugStorageOnSameNet: false,
      hasDetctedDrawerOpened: false,
      hasDetctedDeviceAndDrawerOpened: false,
      emitFiredTimes: 0,
      countDownTime: 10000,
      retryTimes: 0,
      accuTime: 0,
      accuFun: null,
      openTimes: 0,
      confirmAvaliable: false,
      forLockUpDevices: [],
      packCount: 0,
      pieces: 0,
      actionTime: 0,
      returnEmptyCount: 0
    };
  },

  components: {
    SystemPanel: __WEBPACK_IMPORTED_MODULE_4__SystemPanel___default.a,
    LockDevice: __WEBPACK_IMPORTED_MODULE_5__LockDevice___default.a,
    LockDrawer: __WEBPACK_IMPORTED_MODULE_6__LockDrawer___default.a,
    ScanBarcode: __WEBPACK_IMPORTED_MODULE_7__ScanBarcode___default.a
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setTimeout(function () {
                _this.checkDefaultNum();
                _this.optimizeNumber();
                _this.$store.commit('SET_CURRENT_DEVICE_FROM_ALL', _this.deviceId);
              }, 200);
              // await this.$store.dispatch('setCurrentDeviceDirectly', this.deviceId);

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    this.hasDetctedDrawerOpened = false;
    this.hasDetctedDeviceAndDrawerOpened = false;
    this.openDevicesById(this.deviceId);
    this.returnEmptyCount = this.defaultEmptyCount;
  },
  destroyed: function destroyed() {
    this.hasDetctedDrawerOpened = false;
    this.hasDetctedDeviceAndDrawerOpened = false;
    console.log('Action destroyed');
    this.stopCountUpTime();
  },

  computed: {
    totalSum: function totalSum() {
      return this.packCount * this.currentDrugPackContent + this.pieces;
    },
    modalStatus: function modalStatus() {
      return this.$store.getters.modalStatus;
    },
    errorDevices: function errorDevices() {
      return this.$store.state.device.errorDevices;
    },
    nextDevice: function nextDevice() {
      //20190422 add
      if (this.$store.state.currentApp.name == '類別取藥') this.$store.state.device.nextDevice = null;
      ///////////// 
      var next = this.$store.state.device.nextDevice;
      if (next !== null) {
        if (next.net.id === this.currentDevice.net.id) {
          this.nextDeviceOnSameNet = true;
        } else {
          this.nextDeviceOnSameNet = false;
        }
      } else {
        this.nextDeviceOnSameNet = false;
      }
      return next;
    },
    nextDrugInDevice: function nextDrugInDevice() {
      //20190422 add
      if (this.$store.state.currentApp.name == '類別取藥') this.$store.state.drugInDevice.nextDrugInDevice = null;
      /////////////
      return this.$store.state.drugInDevice.nextDrugInDevice;
    },
    canDirectlyToNext: function canDirectlyToNext() {
      if (this.nextDevice !== null && this.nextDeviceOnSameNet && this.currentDevice.pos_col === 0) {
        return true;
      }
      return false;
    },
    selectedDrug: function selectedDrug() {
      return this.$store.state.drug.selectedDrug;
    },
    selectedDrugTotalAmount: function selectedDrugTotalAmount() {
      return this.$store.state.drug.selectedDrugTotalAmount;
    },
    showRemainInfo: function showRemainInfo() {
      var appName = this.currentApp.name;
      if (appName === '一般取藥' || appName === '醫囑取藥' || appName === '一般退藥' || appName === '醫囑退藥') return true;
      return false;
    },
    remainTotalAmount: function remainTotalAmount() {
      var appName = this.currentApp.name;
      if (appName === '一般取藥' || appName === '醫囑取藥') return this.selectedDrugTotalAmount - this.num;
      if (appName === '一般退藥' || appName === '醫囑退藥') return this.selectedDrugTotalAmount + this.num;
      return 0;
    },
    remainAmountInDrugInDevice: function remainAmountInDrugInDevice() {
      var appName = this.currentApp.name;
      if (appName === '一般取藥' || appName === '醫囑取藥') return this.currentDrugInDevice.stock - this.num;
      if (appName === '一般退藥' || appName === '醫囑退藥') return this.currentDrugInDevice.stock + this.num;
      return 0;
    },
    currentDevice: function currentDevice() {
      return this.$store.state.device.currentDevice;
    },
    currentDrugInDevice: function currentDrugInDevice() {
      return this.$store.getters.currentDrugInDevice;
    },
    currentApp: function currentApp() {
      return this.$store.state.currentApp;
    },
    instance: function instance() {
      return this.$store.state.instance;
    },
    errorContext: function errorContext() {
      switch (this.currentApp.name) {
        case '新增藥物':
          return {
            type: 'error',
            context: '新增數量不可大於最大庫存',
            keepOnTop: true
          };
        case '一般取藥':
        case '醫囑取藥':
        case '批次取藥':
        case '類別取藥':
        case '套組取藥':
          return {
            type: 'warn',
            context: '取藥數量大於此藥盒庫存量或是處方籤量',
            keepOnTop: true
          };
        case '盤點藥物':
          return {
            type: 'error',
            context: '盤點數量不可大於最大庫存量',
            keepOnTop: true
          };
        case '補充藥物':
          return {
            type: 'error',
            context: '補充後數量不可大於最大庫存量',
            keepOnTop: true
          };
        case '一般退藥':
          return {
            type: 'warn',
            context: '<p>退藥數量大於此藥盒容納數量</p> <p>請先完成目前藥盒動作</p>',
            keepOnTop: true
          };
        default:
          return '';
      }
    },
    goToNext: function goToNext() {
      switch (this.$store.state.currentApp.name) {
        case '一般取藥':
        case '醫囑取藥':
        case '類別取藥':
        case '套組取藥':
        case '一般退藥':
        case '補充藥物':
          if (Math.ceil(this.num) <= Math.ceil(this.checkNum)) {
            return true;
          }
          return false;
        default:
          if (this.nextDevice === null) return false;
          return true;
      }
    },
    constructionContext: function constructionContext() {
      if (this.returnedEmptyBottle() === false) {
        return '請先掃描欲退回藥罐，並放回藥盒';
      }
      if (this.hasDetctedDeviceAndDrawerOpened) {
        if (this.goToNext) {
          if (this.nextDeviceOnSameNet || this.nextDrugStorageOnSameNet) return '關閉藥盒';
          if (hasOnlyDrawer(this.errorDevices)) return '關閉抽屜';
          return '關閉藥盒及抽屜';
        }
        if (hasOnlyDrawer(this.errorDevices)) return '關閉抽屜';
        return '關閉藥盒及抽屜';
      }
      if (this.hasDetctedDrawerOpened) return '關閉抽屜';
      return '';
    },
    currentDrugPackContent: function currentDrugPackContent() {
      if (this.currentDrugInDevice !== null) {
        return this.currentDrugInDevice.medication.pack_content;
      }
      console.log(this.selectedDrug);
      return this.selectedDrug.pack_content;
    }
  },
  methods: {
    countActionTime: function countActionTime() {
      var _this2 = this;

      setInterval(function () {
        _this2.actionTime += 1;
      }, 1000);
    },
    checkNextDrugStorage: function checkNextDrugStorage() {
      if (this.nextDrugInDevice !== null && this.nextDrugInDevice !== undefined) {
        if (this.nextDrugInDevice.device.net.id === this.currentDevice.net.id) {
          this.nextDrugStorageOnSameNet = true;
        } else {
          this.nextDrugStorageOnSameNet = false;
        }
      } else {
        this.nextDrugStorageOnSameNet = false;
      }
    },
    openDevicesById: function openDevicesById(deviceId) {
      this.$store.commit('SET_CURRENT_DEVICE_FROM_ALL', deviceId);
      this.$store.dispatch('openDevice');
    },
    checkDefaultNum: function checkDefaultNum() {
      if (Math.ceil(this.defaultNum) > Math.ceil(this.checkNum)) {
        this.num = Math.ceil(this.checkNum);
        this.$store.commit('SET_MESSAGE', this.errorContext);
      } else {
        this.num = Math.ceil(this.defaultNum);
      }
    },
    countUpTime: function countUpTime() {
      var _this3 = this;

      if (this.accuFun === null && this.modalStatus.lockDrawer === false && this.modalStatus.lockDevice === false) {
        console.log('set count up interval');
        this.accuFun = setInterval(function () {
          _this3.accuTime += 1;
          // console.log('counting time:', this.accuTime);
        }, 1000);
      } else {
        console.log('count up time interval exists');
      }
    },
    stopCountUpTime: function stopCountUpTime() {
      if (this.accuFun) {
        console.log('stopCountUpTime');
        clearInterval(this.accuFun);
        this.accuFun = null;
        this.accuTime = 0;
        this.$store.commit('CLOSE_MESSAGE');
      }
    },
    errorReturned: function errorReturned() {
      // this.stopCountUpTime();
    },
    resetCountUpTime: function resetCountUpTime() {
      this.stopCountUpTime();
      this.countUpTime();
    },
    showLockDeviceModal: function showLockDeviceModal() {
      this.$store.commit('CLOSE_MESSAGE');
      this.$store.commit('SHOW_MODAL', { modalName: 'lockDevice', status: true });
      this.$store.commit('SHOW_MODAL', { modalName: 'lockDrawer', status: false });
    },
    closeLockDeviceModal: function closeLockDeviceModal() {
      this.$store.commit('SHOW_MODAL', { modalName: 'lockDevice', status: false });
    },
    showLockDrawerModal: function showLockDrawerModal() {
      this.$store.commit('CLOSE_MESSAGE');
      this.$store.commit('SHOW_MODAL', { modalName: 'lockDrawer', status: true });
      this.$store.commit('SHOW_MODAL', { modalName: 'lockDevice', status: false });
    },
    closeLockDrawerModal: function closeLockDrawerModal() {
      this.$store.commit('SHOW_MODAL', { modalName: 'lockDrawer', status: false });
      this.showLockDrawerTimeFun = null;
    },
    tryReopenAndShow: function tryReopenAndShow() {
      console.log('tryReopenAndShow');
      this.preventOverEmitOpenDevices();
      this.$store.commit('SET_MESSAGE', {
        type: 'warn',
        context: '藥盒開啟失敗, 重新嘗試中...',
        confirm: false
      });
      this.retryTimes += 1;
    },
    checkTimeOnDrawer: function checkTimeOnDrawer() {
      // if (this.accuTime === 10 || this.accuTime === 20) {
      //   this.tryReopenAndShow();
      // }
      if (this.accuTime === 10) {
        this.showLockDrawerModal();
      }
    },
    checkTimeOnDevice: function checkTimeOnDevice() {
      // if (this.accuTime === 10 || this.accuTime === 20) {
      //   this.tryReopenAndShow();
      // }
      if (this.accuTime === 10) {
        this.showLockDeviceModal();
      }
    },
    optimizeNumber: function optimizeNumber() {
      if (this.autoCaculateAmount) {
        if (this.currentDrugPackContent !== 0) {
          this.pieces = this.num % this.currentDrugPackContent;
          this.packCount = Math.floor(this.num / this.currentDrugPackContent);
        } else {
          this.packCount = 0;
          this.pieces = this.num;
        }
      } else {
        this.packCount = this.defaultPackCount;
        this.pieces = this.num - this.packCount * this.currentDrugPackContent;
        console.log(this.packCount, this.pieces, this.num, this.currentDrugPackContent);
      }
    },
    setConfrimAvaliable: function setConfrimAvaliable() {
      this.confirmAvaliable = true;
    },
    checkPackCount: function checkPackCount() {
      // 看看是否需要檢查藥盒量
      if (this.limitPackCount) {
        if (this.packCount <= this.defaultPackCount) return true;
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '藥盒量不可大於原藥盒量',
          confirm: true,
          keepOnTop: true
        });
        this.packCount = this.defaultPackCount;
        this.pieces = this.num - this.packCount * this.currentDrugPackContent;
        return false;
      }
      return true;
    },
    openDeviceAndResetStatus: function openDeviceAndResetStatus() {
      this.hasDetctedDrawerOpened = false;
      this.hasDetctedDeviceAndDrawerOpened = false;
      this.$store.dispatch('openDevice');
      this.hasDetctedDrawerOpened = false;
      this.hasDetctedDeviceAndDrawerOpened = false;
    },
    confirmReturnEmptyBottle: function confirmReturnEmptyBottle(val) {
      var input = val;
      // get data from barcode and check the drug is as same as current drug.
      if (this.$store.state.generalSetting.fetch_return_empty_same_time) {
        if (input !== '' + this.selectedDrug.package_code) {
          this.$store.commit('SET_MESSAGE', { type: 'error', keepOnTop: true, confirm: true, context: '請確認掃描條碼與藥瓶（身）條碼相同' });
        } else {
          this.returnEmptyCount += 1;
          this.returnEmptyCount = Math.min(this.returnEmptyCount, this.pieces); // the return empty bottle amount will not larager than fetch amount
        }
      }
    },
    returnedEmptyBottle: function returnedEmptyBottle() {
      // this is a shortcut flow for returning empty when fetching.
      //20190422 add 新增類別取藥也需要回空瓶
      if (this.$store.state.generalSetting.fetch_return_empty_same_time && this.compType === 'Action' && (this.currentApp.name === '一般取藥' || this.currentApp.name === '醫囑取藥' || this.currentApp.name === '類別取藥') && this.selectedDrug.return_when_empty) {
        if (this.returnEmptyCount === 0) return false;
        return true;
      }
      return true;
    },
    checkEmitable: function checkEmitable() {
      return this.checkPackCount() && this.returnedEmptyBottle();
    },
    emitData: function emitData() {
      var _this4 = this;

      // the emptyCount value is only used when fetch and return empty at the same time.
      console.log('prepare to emit data');
      var vm = this;
      var val = vm.totalSum;
      if (this.checkEmitable()) {
        if (val < 0) {
          vm.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: '數值不可以少於0',
            confirm: true,
            keepOnTop: true
          });
          setTimeout(function () {
            vm.pieces = 0;
          }, 300);
          this.openDeviceAndResetStatus();
        } else if (val === 0 && vm.valueMoreThanZero) {
          vm.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: '數值不可以為0',
            confirm: true,
            keepOnTop: true
          });
          setTimeout(function () {
            vm.pieces = 1;
          }, 300);
          this.openDeviceAndResetStatus();
        } else if (vm.checkNum !== '') {
          // TODO: context should be changed for different app.
          if (Math.ceil(vm.totalSum) > Math.ceil(vm.checkNum)) {
            vm.$store.commit('SET_MESSAGE', vm.errorContext);
            setTimeout(function () {
              _this4.optimizeNumber();
            }, 300);
            this.openDeviceAndResetStatus();
          } else {
            console.log('hello');
            this.hasDetctedDrawerOpened = false;
            this.hasDetctedDeviceAndDrawerOpened = false;
            vm.$emit('setActionData', {
              device: vm.deviceId,
              num: vm.totalSum,
              packCount: vm.packCount,
              emptyCount: vm.returnEmptyCount
            });
          }
        } else {
          this.hasDetctedDrawerOpened = false;
          this.hasDetctedDeviceAndDrawerOpened = false;
          vm.$emit('setActionData', {
            device: vm.deviceId,
            num: vm.totalSum,
            packCount: vm.packCount,
            emptyCount: vm.returnEmptyCount
          });
        }
      } else {
        this.openDeviceAndResetStatus();
      }
    },
    addNum: function addNum(val) {
      if (this.inputReadOnly !== true) this[val] += 1;
    },
    minusNum: function minusNum(val) {
      if (this.inputReadOnly !== true && this[val] > 0) this[val] -= 1;
    },
    preventOverEmitOpenDevices: function preventOverEmitOpenDevices() {
      this.openTimes += 1;
      if (this.openTimes >= 3 && this.modalStatus.lockDrawer === false && this.modalStatus.lockDevice === false) {
        this.$store.dispatch('openDevice');
        this.openTimes = 0;
      }
    },
    confirmAmountAction: function confirmAmountAction() {
      var _this5 = this;

      if (this.confirmAvaliable) {
        if (this.totalSum <= this.currentDrugInDevice.max_stock) {
          // determine the storage error event.
          var eventType = '';
          if (this.totalSum === this.currentDrugInDevice.stock) {
            eventType = 'PREPARE_MED';
          } else {
            eventType = 'STORAGE_ERROR';
          }

          var data = {
            id: this.currentDrugInDevice.id,
            device: this.currentDrugInDevice.device.id,
            stock: this.totalSum, // only update here.
            max_stock: this.currentDrugInDevice.max_stock,
            expired_date: this.currentDrugInDevice.expired_date,
            patch_number: this.currentDrugInDevice.patch_number,
            medication: this.currentDrugInDevice.medication.id,
            number1: this.totalSum - this.currentDrugInDevice.stock, // origianl stock
            pack_count: this.packCount,
            type: eventType
          };

          this.instance.put('/api/drug-storage/' + data.id + '/', data).then(function (res) {
            console.log(res.data);
            _this5.$emit('confirmAmountFinish', {
              totalSum: _this5.totalSum,
              packCount: _this5.packCount
            });
          });
        } else {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: '\u78BA\u8A8D\u6578\u91CF\u4E0D\u53EF\u5927\u65BC\u6700\u5927\u5EAB\u5B58: ' + this.currentDrugInDevice.max_stock,
            confirm: true,
            keepOnTop: true
          });
        }
      }
    },
    checkErrorDeivcesIsCurrentDevice: function checkErrorDeivcesIsCurrentDevice() {
      this.forLockUpDevices = [];
      for (var i = 0; i < this.errorDevices.length; i += 1) {
        var device = this.errorDevices[i];
        if (device.type === 'drawer') {
          // console.log(device);
          //if (device.drawerId !== this.currentDevice.net.row_id || device.system !== (this.currentDevice.net.system.relative_index - 1)) {
          if (device.drawerId !== this.currentDevice.net.row_id) {
            this.forLockUpDevices.push({ type: 'net', id: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.$store.getters.systems)[device.system].net_set[device.drawerId - 1].id });
          }
        }
        if (device.type === 'box') {
          // console.log(device);
          if (device.row !== this.currentDevice.pos_row || device.col !== this.currentDevice.relative_col) {
            this.forLockUpDevices.push({ type: 'device', id: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.$store.getters.systems)[device.system].net_set[device.drawerId - 1].device_set[device.boxId].id });
          }
        }
      }
      if (this.forLockUpDevices.length > 0) {
        this.$store.commit('SETUP_LOCKED_DEVICES', this.forLockUpDevices);
        return false;
      }
      return true;
    },

    checkErrorDevicesWhenAction: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.throttle(function (vm) {
      // console.log(val, 'this.hasDetctedDrawerOpened:', this.hasDetctedDrawerOpened, 'this.hasDetctedDeviceAndDrawerOpened:', this.hasDetctedDeviceAndDrawerOpened);
      // 先確定現在開啟的是抽屜還是藥盒
      switch (vm.currentDevice.pos_row) {
        // 打開抽屜
        case 0:
          if (vm.hasDetctedDrawerOpened === false) {
            vm.countUpTime();
            vm.checkTimeOnDrawer();
          } else {
            vm.stopCountUpTime();
          }
          if (vm.hasDetctedDrawerOpened && vm.errorDevices.length === 0) {
            vm.emitData();
            return;
          }
          if (vm.errorDevices.length > 0) {
            if (!vm.checkErrorDeivcesIsCurrentDevice()) {
              vm.$store.commit('SET_MESSAGE', {
                type: 'warn',
                context: '偵測到非目前操作藥盒或抽屜開啟，請先將其關閉。',
                confirm: true,
                showUnlock: true,
                showLockDevice: true
              });
            } else {
              if (vm.errorDevices.length === 1) {
                vm.hasDetctedDrawerOpened = true;
              }
            }
          }
          break;
        // 有可能藥盒打不開 需要拉出來
        case 1:
        case 2:
        case 3:
        case 4:
          if (vm.errorDevices.length === 0) {
            // 如果開過藥盒跟抽屜
            if (vm.hasDetctedDeviceAndDrawerOpened) {
              vm.emitData();
            } else {
              if (_this6.hasDetctedDrawerOpened) {
                vm.preventOverEmitOpenDevices(); // reopening
              }
              vm.countUpTime();
              vm.checkTimeOnDrawer();
            }
          } else if (vm.errorDevices.length === 1) {
            // 如果不小心關起來抽屜但藥盒還沒關閉
            if (vm.checkErrorDeivcesIsCurrentDevice()) {
              if (hasOnlyBox(vm.errorDevices)) {
                vm.preventOverEmitOpenDevices();
                if (!vm.$store.state.messagePop && vm.$store.state.message.keepOnTop === false) {
                  vm.$store.commit('SET_MESSAGE', {
                    type: 'warn',
                    context: '請先關閉藥盒',
                    confirm: true,
                    showUnlock: true
                  });
                }
              } else {
                // only drawer open
                _this6.hasDetctedDrawerOpened = true;
                if (vm.hasDetctedDeviceAndDrawerOpened) {
                  // when finishing the action
                  // 如果下一藥盒在同層抽屜，不用關抽屜，關上藥盒就進行下一步驟
                  if (vm.goToNext) {
                    if (vm.nextDeviceOnSameNet || vm.nextDrugStorageOnSameNet) {
                      vm.emitData();
                    }
                  }
                } else {
                  // waiting for device open
                  console.log('waiting for devices opening');
                  if (hasOnlyDrawer(vm.errorDevices) && parseInt(vm.errorDevices[0].position, 10) >= parseInt(vm.currentDevice.pos_row, 10)) {
                    vm.countUpTime();
                    vm.checkTimeOnDevice();
                  } else {
                    vm.stopCountUpTime();
                  }
                  if (!vm.$store.state.messagePop && vm.$store.state.message.keepOnTop === false && vm.$store.state.modalStatus.lockDevice === false) {
                    vm.$store.commit('SET_MESSAGE', {
                      type: 'warn',
                      context: '請拉開抽屜以打開藥盒',
                      confirm: true,
                      showUnlock: true
                    });
                  }
                }
              }
            } else {
              vm.$store.commit('SET_MESSAGE', {
                type: 'warn',
                context: '偵測到非目前操作藥盒或抽屜開啟，請先將其關閉。',
                confirm: true,
                showUnlock: true,
                showLockDevice: true
              });
            }
          } else if (vm.errorDevices.length === 2) {
            vm.stopCountUpTime();
            if (vm.checkErrorDeivcesIsCurrentDevice()) {
              vm.hasDetctedDeviceAndDrawerOpened = true;
              if (vm.$store.state.messagePop && vm.$store.state.message.keepOnTop === false) {
                vm.$store.commit('CLOSE_MESSAGE');
              }
            } else {
              vm.$store.commit('SET_MESSAGE', {
                type: 'warn',
                context: '偵測到非目前操作藥盒或抽屜開啟，請先將其關閉。',
                confirm: true,
                showUnlock: true,
                showLockDevice: true
              });
            }
          } else if (vm.errorDevices.length > 2) {
            vm.stopCountUpTime();
            if (!vm.checkErrorDeivcesIsCurrentDevice()) {
              if (!vm.$store.state.messagePop && vm.$store.state.message.keepOnTop === false) {
                vm.$store.commit('SET_MESSAGE', {
                  type: 'warn',
                  context: '偵測到非目前操作藥盒或抽屜開啟，請先將其關閉。',
                  confirm: true,
                  showUnlock: true,
                  showLockDevice: true
                });
              }
            }
          } else {
            console.log(vm.errorDevices);
          }
          break;
        default:
          console.error(vm.currentDevice);
      }
    }, 150),
    checkErrorDevicesWhenConfirmAmount: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.throttle(function (vm) {
      // console.log(val, 'this.hasDetctedDrawerOpened:', this.hasDetctedDrawerOpened, 'this.hasDetctedDeviceAndDrawerOpened:', this.hasDetctedDeviceAndDrawerOpened);
      // 先確定現在開啟的是抽屜還是藥盒
      switch (vm.currentDevice.pos_row) {
        // 打開抽屜
        case 0:
          if (vm.hasDetctedDrawerOpened === false) {
            vm.countUpTime();
            vm.checkTimeOnDrawer();
          } else {
            vm.stopCountUpTime();
          }
          if (vm.errorDevices.length > 0) {
            if (vm.checkErrorDeivcesIsCurrentDevice()) {
              vm.hasDetctedDrawerOpened = true;
              vm.setConfrimAvaliable();
            } else {
              vm.$store.commit('SET_MESSAGE', {
                type: 'warn',
                context: '偵測到非目前操作藥盒或抽屜開啟，請先將其關閉。',
                confirm: true,
                showUnlock: true,
                showLockDevice: true
              });
            }
          }
          break;
        case 1:
        case 2:
        case 3:
        case 4:
          if (vm.errorDevices.length === 0) {
            // 如果開過藥盒跟抽屜
            if (vm.hasDetctedDeviceAndDrawerOpened) {
              vm.setConfrimAvaliable();
            } else {
              if (_this6.hasDetctedDrawerOpened) {
                vm.preventOverEmitOpenDevices(); // reopening
              }
              vm.countUpTime();
              vm.checkTimeOnDrawer();
            }
          } else if (vm.errorDevices.length === 1) {
            // 如果不小心關起來抽屜但藥盒還沒關閉
            if (vm.checkErrorDeivcesIsCurrentDevice()) {
              if (hasOnlyBox(vm.errorDevices)) {
                vm.preventOverEmitOpenDevices();
                if (!vm.$store.state.messagePop && vm.$store.state.message.keepOnTop === false) {
                  vm.$store.commit('SET_MESSAGE', {
                    type: 'warn',
                    context: '請先關閉藥盒',
                    confirm: true,
                    showUnlock: true
                  });
                }
              } else {
                // only drawer open
                _this6.hasDetctedDrawerOpened = true;
                if (vm.hasDetctedDeviceAndDrawerOpened) {
                  // when finishing the action
                  vm.setConfrimAvaliable();
                } else {
                  // waiting for device open
                  console.log('waiting for devices opening');
                  console.log(parseInt(vm.errorDevices[0].position, 10));
                  if (hasOnlyDrawer(vm.errorDevices) && parseInt(vm.errorDevices[0].position, 10) >= parseInt(vm.currentDevice.pos_row, 10)) {
                    vm.countUpTime();
                    vm.checkTimeOnDevice();
                  } else {
                    vm.stopCountUpTime();
                  }
                  if (!vm.$store.state.messagePop && vm.$store.state.message.keepOnTop === false && vm.$store.state.modalStatus.lockDevice === false) {
                    vm.$store.commit('SET_MESSAGE', {
                      type: 'warn',
                      context: '請拉開抽屜以打開藥盒',
                      confirm: true,
                      showUnlock: true
                    });
                  }
                }
              }
            } else {
              vm.$store.commit('SET_MESSAGE', {
                type: 'warn',
                context: '偵測到非目前操作藥盒或抽屜開啟，請先將其關閉。',
                confirm: true,
                showUnlock: true,
                showLockDevice: true
              });
            }
          } else if (vm.errorDevices.length === 2) {
            vm.stopCountUpTime();
            if (vm.checkErrorDeivcesIsCurrentDevice()) {
              vm.hasDetctedDeviceAndDrawerOpened = true;
              vm.setConfrimAvaliable();
              if (vm.$store.state.messagePop && vm.$store.state.message.keepOnTop === false) {
                vm.$store.commit('CLOSE_MESSAGE');
              }
            } else {
              vm.$store.commit('SET_MESSAGE', {
                type: 'warn',
                context: '偵測到非目前操作藥盒或抽屜開啟，請先將其關閉。',
                confirm: true,
                showUnlock: true,
                showLockDevice: true
              });
            }
          } else if (vm.errorDevices.length > 2) {
            vm.stopCountUpTime();
            if (!vm.checkErrorDeivcesIsCurrentDevice()) {
              if (!vm.$store.state.messagePop && vm.$store.state.message.keepOnTop === false) {
                vm.$store.commit('SET_MESSAGE', {
                  type: 'warn',
                  context: '偵測到非目前操作藥盒或抽屜開啟，請先將其關閉。',
                  confirm: true,
                  showUnlock: true,
                  showLockDevice: true
                });
              }
            }
          } else {
            console.log(vm.errorDevices);
          }
          break;
        default:
          console.error(vm.currentDevice);
      }
    }, 150)
  },
  watch: {
    num: function num(val) {
      // this.debounceCheckNum(this);
      if (isNaN(val)) {
        this.num = 0;
      } else {
        this.num = parseInt(val, 10);
      }
    },
    defaultNum: function defaultNum(val) {
      this.checkDefaultNum();
      this.optimizeNumber();
    },
    errorDevices: function errorDevices() {
      if (this.compType === 'Action') {
        this.checkNextDrugStorage();
        this.checkErrorDevicesWhenAction(this);
      }
      if (this.compType === 'Confirm') {
        this.checkErrorDevicesWhenConfirmAmount(this);
      }
    },
    pieces: function pieces(val) {
      if (isNaN(val)) {
        this.pieces = 0;
      } else {
        this.pieces = parseInt(val, 10);
      }
    },
    packCount: function packCount(val) {
      if (isNaN(val)) {
        console.log('is nan');
        this.packCount = 0;
      } else {
        this.packCount = parseInt(val, 10);
      }
    },
    totalSum: function totalSum(val) {
      this.$emit('setTotalSumInstanly', val);
    },
    compType: function compType(val) {
      if (val === 'Action') {
        this.countActionTime();
      }
    }
  }
});

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ActionBreak',
  props: ['residual'],
  methods: {
    goOn: function goOn() {
      this.$emit('goOn');
    }
  },
  computed: {
    errorDevices: function errorDevices() {
      return this.$store.state.device.errorDevices;
    },
    nextDevice: function nextDevice() {
      return this.$store.state.device.nextDevice;
    },
    currentDevice: function currentDevice() {
      return this.$store.state.device.currentDevice;
    },
    allowToNext: function allowToNext() {
      if (this.nextDevice.net.id === this.currentDevice.net.id && this.errorDevices.length < 2) {
        return true;
      }

      if (this.nextDevice.net.id !== this.currentDevice.net.id && this.errorDevices.length === 0) {
        return true;
      }

      return false;
    },
    warnMessage: function warnMessage() {
      if (this.nextDevice.net.id === this.currentDevice.net.id && this.errorDevices.length > 1) {
        return '請先關閉藥盒';
      }
      if (this.nextDevice.net.id !== this.currentDevice.net.id && this.errorDevices.length > 0) {
        return '請先關閉所有藥盒及抽屜';
      }
      return '';
    }
  }
});

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_Loader__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ComboMedListAndPatient',
  props: {
    filterOutZeroAmountMed: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      getComboMed: false,
      otherFetchEvents: []
    };
  },

  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_4__common_Loader___default.a
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$store.dispatch('getComboMedSet');

            case 2:
              _context.next = 4;
              return _this.checkMedFetched();

            case 4:
              _this.getComboMed = true;
              _this.$store.commit('SET_CURRENT_STEP', 'selectMeds');

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    checkMedFetched: function checkMedFetched() {
      var _this2 = this;

      return this.instance.get('/api/event/', {
        params: {
          number2: this.currentSchedule.id,
          event: 'FETCH'
        }
      }).then(function (res) {
        _this2.otherFetchEvents = [];
        res.data.results.forEach(function (item) {
          var target = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(_this2.comboMedSet, function (s) {
            return s.child_medication.id === item.medication.id;
          });
          if (target) {
            target.fetched = true;
          } else {
            _this2.otherFetchEvents.push(item);
          }
        });
      });
    },
    selectMed: function selectMed(med) {
      this.$store.dispatch('selectComboMed', {
        med: med.child_medication,
        dose: med.child_medication_dose,
        doseUnit: med.child_medication_dose_unit,
        amount: med.child_medication_quantity,
        select: !med.selected,
        drugInDevice: med.drugInDevice
      });
    },
    selectAllMed: function selectAllMed(selectStatus) {
      var _this3 = this;

      this.comboMedSet.forEach(function (med) {
        if (med.amountInSystem !== 0) {
          _this3.$store.dispatch('selectComboMed', {
            med: med.child_medication,
            dose: med.child_medication_dose,
            doseUnit: med.child_medication_dose_unit,
            amount: med.child_medication_quantity,
            select: selectStatus,
            drugInDevice: med.drugInDevice
          });
        }
      });
    },
    addAmount: function addAmount(med, index) {
      this.comboMedSet[index].child_medication_quantity += 1;
      this.$store.dispatch('selectComboMed', {
        med: med.child_medication,
        dose: this.comboMedSet[index].child_medication_dose,
        doseUnit: this.comboMedSet[index].child_medication_dose_unit,
        amount: this.comboMedSet[index].child_medication_quantity,
        select: true,
        drugInDevice: med.drugInDevice
      });
    },
    minusAmount: function minusAmount(med, index) {
      if (this.comboMedSet[index].child_medication_quantity > 0) {
        this.comboMedSet[index].child_medication_quantity -= 1;
        this.$store.dispatch('selectComboMed', {
          med: med.child_medication,
          dose: this.comboMedSet[index].child_medication_dose,
          doseUnit: this.comboMedSet[index].child_medication_dose_unit,
          amount: this.comboMedSet[index].child_medication_quantity,
          select: true
        });
      }
    },
    printQR: function printQR() {
      this.$store.dispatch('printQR');
    }
  },
  computed: {
    instance: function instance() {
      return this.$store.getters.instance;
    },
    comboMedSet: function comboMedSet() {
      if (this.filterOutZeroAmountMed) {
        return this.$store.getters.comboMedSet.filter(function (item) {
          return item.amountInSystem > 0;
        });
      }
      return this.$store.getters.comboMedSet;
    },
    currentSchedule: function currentSchedule() {
      return this.$store.getters.currentSchedule;
    },
    drugsForFetch: function drugsForFetch() {
      return this.$store.getters.drugsForFetch;
    }
  },
  filters: {
    timeOnly: function timeOnly(val) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(val).format('HH:mm');
    },
    fetchZh: function fetchZh(val) {
      if (val) {
        return '已取藥';
      }
      return '未取藥';
    },
    zhLabel: function zhLabel(value) {
      if (value === 'WASTE') return '已拋棄';
      if (value === 'RETURN_EMPTY') return '已退空瓶';
      if (value === 'RETURN') return '已退藥';
      return value;
    }
  }
});

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ScanBarcode__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ScanBarcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ScanBarcode__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreateSchedule',
  props: {
    medRecordId: {
      type: String,
      default: ''
    },
    manualInputMedRecordId: {
      type: Boolean,
      default: true
    },
    bedId: {
      type: Number,
      default: undefined
    },
    gender: {
      type: String,
      default: null
    }
  },
  components: {
    ScanBarcode: __WEBPACK_IMPORTED_MODULE_5__ScanBarcode___default.a
  },
  data: function data() {
    return {
      progress: ['selectMed', 'selectBed', 'inputMedRecordNo'],
      currentProgressIndex: 0,
      comboSet: [],
      currentComboSetIndex: 0,
      combos: [],
      combosets: {},
      beds: [],
      group: [],
      selectMedType: 'set',
      selectedSet: undefined,
      currentGroupIndex: 0,
      //medRecordId: '',
      patientSetId: undefined,
      comboSelected: undefined,
      scheduleCreatedId: undefined
      //bedId: undefined,
    };
  },

  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    },
    currentProgress: function currentProgress() {
      var currentProgress = this.progress[this.currentProgressIndex];
      return currentProgress;
    }
  },
  created: function created() {
    this.getCombo();
    this.getBed();
    // this.getGroup();
    // this.getComboSet();
    // this.$store.commit('SET_CURRENT_STEP', this.currentProgress);
    this.$emit('emitProgress', 0);
  },
  mounted: function mounted() {
    this.$refs.medInput.focus();
  },

  watch: {
    medRecordId: function medRecordId(val) {
      this.$emit('createReady');
    },
    currentProgressIndex: function currentProgressIndex(val) {
      console.log(val);
      this.$emit('emitProgress', val);
    }
  },
  methods: {
    getBarcode: function getBarcode(val) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, returnScheduleId;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = val.toString();
                returnScheduleId = parseInt(data.split(':')[1].split('***')[0], 10);
                _context.next = 4;
                return _this.$store.dispatch('setCurrentScheduleById', returnScheduleId);

              case 4:
                _this.$emit('createDone');

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    previousProgress: function previousProgress() {
      if (this.currentProgressIndex > 0) {
        this.currentProgressIndex -= 1;
        this.$store.commit('SET_CURRENT_STEP', this.currentProgress);
      }
    },
    nextProgress: function nextProgress() {
      if (this.currentProgressIndex < this.progress.length - 1) {
        if (this.checkForm()) {
          this.currentProgressIndex += 1;
          this.$store.commit('SET_CURRENT_STEP', this.currentProgress);
        }
      }
    },
    getCombo: function getCombo() {
      var _this2 = this;

      this.instance.get('/api/medication/', {
        params: {
          type: 'combo'
        }
      }).then(function (res) {
        var sep = {};
        res.data.results.forEach(function (item) {
          item.selected = false;
          var dep = item.generic_name.split('-')[0];
          if (sep[dep] === undefined) {
            sep[dep] = {};
            sep[dep].dep_name = dep;
            sep[dep].combolist = [];
          }
          sep[dep].combolist.push(item);
        });
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(sep).forEach(function (set) {
          set.combolist.sort(function (a, b) {
            return a.generic_name.localeCompare(b.generic_name, 'zh-Hant');
          });
        });
        _this2.combosets = sep;
        _this2.combos = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.orderBy(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(sep), ['dep_name'], ['asc']);
      });
    },
    getBed: function getBed() {
      var _this3 = this;

      this.instance.get('/api/bed/').then(function (res) {
        res.data.forEach(function (item) {
          item.selected = false;
        });
        _this3.beds = res.data;
      });
    },
    setCombo: function setCombo(combo, comboInd) {
      console.log(this.selectedSet);
      this.combosets[this.selectedSet].combolist.forEach(function (combo) {
        combo.selected = false;
      });
      this.combosets[this.selectedSet].combolist[comboInd].selected = true;
      this.comboSelected = combo.id;
    },
    setBed: function setBed(bed, ind) {
      this.beds.forEach(function (item) {
        item.selected = false;
      });
      this.beds[ind].selected = true;
      this.bedId = bed.id;
    },
    checkForm: function checkForm() {
      if (this.medRecordId === '') {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '請先輸入病歷號'
        });
        return false;
      }
      // if (this.bedId === undefined && this.currentProgress === 'selectBed') {
      //   this.$store.commit('SET_MESSAGE', {
      //     type: 'error',
      //     context: '請先輸入床號',
      //   });
      //   return false;
      // }
      if (this.comboSelected === undefined) {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '請先選擇套藥'
        });
        return false;
      }
      return true;
    },
    checkPatientExist: function checkPatientExist() {
      var _this4 = this;

      return this.instance.get('/api/patient/', { params: {
          med_record_number: this.medRecordId,
          gender: this.gender
        } }).then(function (res) {
        if (res.data.length > 0) {
          _this4.patientSetId = res.data[0].id;
          console.log('病人已存在');
        } else {
          console.log('病人不存在');
        }
        //console.log(res);
      });
    },
    createPatient: function createPatient() {
      var _this5 = this;

      if (this.patientSetId === undefined) {
        return this.instance.post('/api/patient/', {
          med_record_number: this.medRecordId
        }).then(function (res) {
          _this5.patientSetId = res.data.id;
          console.log('新增病人');
        });
      }
      return false;
    },
    checkScheduleExist: function checkScheduleExist() {
      var _this6 = this;

      var time = new Date();
      return this.instance.get('/api/schedule/', { params: {
          patient: this.patientSetId,
          date: __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY-MM-DD'),
          medication: this.comboSelected,
          bed: this.bedId
        } }).then(function (res) {
        if (res.data.length > 0) {
          _this6.$store.commit('SET_MESSAGE', { context: '此排程已存在，自動帶入該排程', type: 'warn' });
          _this6.scheduleCreatedId = res.data[0].id;
          console.log('排程已存在');
        } else {
          console.log('排程不存在');
        }
      });
    },
    createSchedule: function createSchedule() {
      var _this7 = this;

      var datetimenow = new Date();
      if (this.scheduleCreatedId === undefined) {
        return this.instance.post('/api/schedule/', {
          patient: this.patientSetId,
          medication: this.comboSelected,
          time: datetimenow.toISOString(),
          bed: this.bedId
        }).then(function (res) {
          _this7.scheduleCreatedId = res.data.id;
          console.log('新增排程');
        });
      }
      return false;
    },
    getSchedule: function getSchedule() {
      var _this8 = this;

      return this.instance.get('/api/schedule/' + this.scheduleCreatedId + '/').then(function (res) {
        _this8.$store.commit('SET_CURRENT_SCHEDULE_DIRECTLY', res.data);
      });
    },
    getGroup: function getGroup() {
      var _this9 = this;

      this.instance.get('/api/medication-group/').then(function (res) {
        res.data.forEach(function (group) {
          group.medicine_set.forEach(function (item) {
            item.selected = false;
            item.drugInDevice = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(_this9.$store.getters.drugInDeviceList, function (drugStorage) {
              return drugStorage.medication.id === item.id && drugStorage.stock > 0;
            });
            item.amountInSystem = 0;
            item.drugInDevice.forEach(function (d) {
              item.amountInSystem += d.stock;
            });
          });
        });
        _this9.group = res.data;
      });
    },
    getComboSet: function getComboSet() {
      var _this10 = this;

      this.instance.get('/api/combo-medication-set/').then(function (res) {
        var comboMedSets = {};
        res.data.forEach(function (relation) {
          if (comboMedSets[relation.parent_medication.id] === undefined) {
            comboMedSets[relation.parent_medication.id] = {};
            comboMedSets[relation.parent_medication.id].id = relation.parent_medication.id;
            comboMedSets[relation.parent_medication.id].name = relation.parent_medication.generic_name;
            comboMedSets[relation.parent_medication.id].childMedSet = [];
            comboMedSets[relation.parent_medication.id].selected = false;
          }
          var childMed = relation.child_medication;
          childMed.selected = false;
          childMed.drugInDevice = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(_this10.$store.getters.drugInDeviceList, function (drugStorage) {
            return drugStorage.medication.id === childMed.id && drugStorage.stock > 0;
          });
          childMed.amountInSystem = 0;
          childMed.drugInDevice.forEach(function (d) {
            childMed.amountInSystem += d.stock;
          });
          comboMedSets[relation.parent_medication.id].childMedSet.push(childMed);
        });
        console.log(comboMedSets);
        _this10.comboSet = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(comboMedSets);
      });
    },
    selectMed: function selectMed(type, index) {
      var med = void 0;
      if (type === 'group') {
        med = this.group[this.currentGroupIndex].medicine_set[index];
      }
      if (type === 'comboSet') {
        med = this.comboSet[this.currentComboSetIndex].childMedSet[index];
        this.comboSelected = this.comboSet[this.currentComboSetIndex].id;
      }
      med.selected = !med.selected;
      var payload = {
        med: med,
        drugStorage: med.drugInDevice,
        amount: 1,
        select: med.selected
      };
      this.$store.dispatch('setDrugListForFetch', payload);
    },
    changeSelectMedType: function changeSelectMedType() {
      if (this.selectMedType === 'set') {
        this.selectMedType = 'group';
      } else {
        this.selectMedType = 'set';
      }
    },
    startAction: function startAction() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this11.checkForm()) {
                  _context2.next = 12;
                  break;
                }

                _context2.next = 3;
                return _this11.checkPatientExist();

              case 3:
                _context2.next = 5;
                return _this11.createPatient();

              case 5:
                _context2.next = 7;
                return _this11.checkScheduleExist();

              case 7:
                _context2.next = 9;
                return _this11.createSchedule();

              case 9:
                _context2.next = 11;
                return _this11.getSchedule();

              case 11:
                _this11.$emit('createDone');

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this11);
      }))();
    },
    gotoFetchDrugGroup: function gotoFetchDrugGroup() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(_this12.medRecordId === '')) {
                  _context3.next = 5;
                  break;
                }

                _this12.$store.commit('SET_MESSAGE', {
                  type: 'error',
                  context: '請先輸入病歷號'
                });
                return _context3.abrupt('return', false);

              case 5:
                _context3.next = 7;
                return _this12.checkPatientExist();

              case 7:
                _context3.next = 9;
                return _this12.createPatient();

              case 9:
                _context3.next = 11;
                return _this12.checkScheduleExist();

              case 11:
                _context3.next = 13;
                return _this12.createSchedule();

              case 13:
                _context3.next = 15;
                return _this12.getSchedule();

              case 15:
                _this12.$router.push({ name: 'fetchDrugGroup' });

              case 16:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this12);
      }))();
    }
  }
});

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CurrentLocationPanel',
  computed: {
    systems: function systems() {
      return this.$store.getters.systems;
    },
    errorDevice: function errorDevice() {
      return this.$store.state.device.errorDevices;
    },
    currentDevice: function currentDevice() {
      return this.$store.getters.currentDevice;
    },
    currentNet: function currentNet() {
      return this.systems[this.currentDevice.net.system_serial].net_set[this.currentDevice.net.row_id - 1];
    },
    numRow: function numRow() {
      var row = 0;
      this.currentNet.device_set.forEach(function (device) {
        if (device.pos_row > row) row = device.pos_row;
      });
      return row;
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DateInput',
  props: ['defaultDate', 'limitedDate'],
  data: function data() {
    return {
      month: '',
      year: '',
      day: '',
      days: '',
      yearRange: []
    };
  },

  watch: {
    month: function month() {
      if ([1, 3, 5, 7, 8, 10, 12].indexOf(this.month) !== -1) {
        this.days = 31;
      } else if ([4, 6, 9, 11].indexOf(this.month) !== -1) {
        this.days = 30;
      } else {
        this.days = 28;
      }
    }
  },
  mounted: function mounted() {
    if (this.defaultDate !== '') {
      var date = new Date(this.defaultDate);
      this.year = date.getFullYear();
      this.month = date.getMonth() + 1; // javasctipt return [0-11] for month... this is so weird...
      this.day = date.getDate();
    }
    this.yearRange = Array(10);
    var thisYear = parseInt(new Date().getFullYear(), 10);
    for (var i = 0; i < 10; i += 1) {
      this.yearRange[i] = thisYear + i;
    }
  },

  methods: {
    saveDate: function saveDate() {
      var date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.year + '-' + this.month + '-' + this.day, 'YYYY-MM-DD');
      if (__WEBPACK_IMPORTED_MODULE_0_moment___default()(date).isBefore(__WEBPACK_IMPORTED_MODULE_0_moment___default()())) {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '設定效期不可以早於今日'
        });
      } else {
        if (this.limitedDate) {
          if (__WEBPACK_IMPORTED_MODULE_0_moment___default()(date).isAfter(__WEBPACK_IMPORTED_MODULE_0_moment___default()(this.limitedDate))) {
            this.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: '\u8A2D\u5B9A\u6548\u671F\u4E0D\u53EF\u4EE5\u665A\u65BC' + __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.limitedDate).format('YYYY-MM-DD')
            });
          } else {
            this.$emit('saveDate', date.format('YYYY-MM-DD'));
          }
        } else {
          this.$emit('saveDate', date.format('YYYY-MM-DD'));
        }
      }
    }
  }
});

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DateInput__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DateInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__DateInput__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'confirmExpirationDate',
  components: {
    DateInput: __WEBPACK_IMPORTED_MODULE_1__DateInput___default.a
  },
  props: {
    defaultExpirationDate: String,
    limitedDate: String,
    editable: {
      default: true,
      type: Boolean
    }
  },
  data: function data() {
    return {
      expirationDate: '',
      showPad: false
    };
  },

  methods: {
    setExpirationDate: function setExpirationDate() {
      if (this.expirationDate !== '') {
        this.$emit('setExpirationDate', this.expirationDate);
      } else {
        this.$store.commit('SET_ERROR', { type: 'error', context: 'expiration date can not be empty.' });
      }
    },
    saveDate: function saveDate(val) {
      this.expirationDate = val;
      this.showPad = false;
    },
    popPad: function popPad() {
      if (this.editable) this.showPad = true;
    },
    closePad: function closePad() {
      this.showPad = false;
    }
  },
  created: function created() {
    if (this.defaultExpirationDate) {
      this.expirationDate = this.defaultExpirationDate;
    } else {
      this.expirationDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(1, 'days').toISOString().substring(0, 10);
    }
  }
});

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RefillToNewDrugStorage__ = __webpack_require__(1356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RefillToNewDrugStorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__RefillToNewDrugStorage__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DrugInDeviceList',
  props: {
    mode: {
      type: String,
      default: ''
    },
    singleSelection: {
      type: Boolean,
      default: false
    },
    viewMode: {
      type: String,
      default: 'drugStorageList' // drugStorageList, medList
    },
    medSelectMode: {
      type: String,
      default: 'automatic'
    },
    showRefillToNewDrugStorage: {
      type: Boolean,
      default: false
    },
    drugItemHeadWidth: {
      type: String,
      default: '40%'
    }
  },
  data: function data() {
    return {
      searchText: '',
      showLoader: false
    };
  },

  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_6__common_Loader___default.a,
    RefillToNewDrugStorage: __WEBPACK_IMPORTED_MODULE_7__RefillToNewDrugStorage___default.a
  },
  created: function created() {
    // this.showLoader = true;
    // this.showLoader = false;

    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    filterDrugInDeviceList: function filterDrugInDeviceList() {
      return this.$store.state.drugInDevice.filterDrugInDeviceList;
    },
    currentApp: function currentApp() {
      return this.$store.state.currentApp;
    },
    instance: function instance() {
      return this.$store.state.instance;
    },
    pillsIcon: function pillsIcon() {
      return __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["e" /* faPills */];
    },
    circleIcon: function circleIcon() {
      return __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["d" /* faCircle */];
    },
    pillBottleIcon: function pillBottleIcon() {
      return __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["f" /* faPrescriptionBottleAlt */];
    },
    allDevices: function allDevices() {
      return this.$store.state.device.allDevices;
    },
    drugStorageByDrug: function drugStorageByDrug() {
      var _this2 = this;

      var byDrug = {};
      this.filterDrugInDeviceList.forEach(function (item) {
        if (byDrug[item.medication.id] === undefined) {
          byDrug[item.medication.id] = {};
          byDrug[item.medication.id].selected = false;
          byDrug[item.medication.id].medication = item.medication;
          byDrug[item.medication.id].stock = 0;
          byDrug[item.medication.id].max_stock = 0;
          byDrug[item.medication.id].lists = [];
          byDrug[item.medication.id].expired_date = __WEBPACK_IMPORTED_MODULE_4_moment___default()(item.expired_date);
        }

        // exclude item with empty stock
        // this should only on mode with fetch app
        if (_this2.$store.state.currentApp.name === '一般取藥') {
          if (item.stock > 0) {
            byDrug[item.medication.id].stock += item.stock;
            byDrug[item.medication.id].max_stock += item.max_stock;
            byDrug[item.medication.id].lists.push(item);
            if (item.selected) byDrug[item.medication.id].selected = true;
            if (__WEBPACK_IMPORTED_MODULE_4_moment___default()(item.expired_date).isBefore(byDrug[item.medication.id].expired_date)) {
              byDrug[item.medication.id].expired_date = __WEBPACK_IMPORTED_MODULE_4_moment___default()(item.expired_date);
            }
          }
        } else {
          byDrug[item.medication.id].stock += item.stock;
          byDrug[item.medication.id].max_stock += item.max_stock;
          byDrug[item.medication.id].lists.push(item);
          if (item.selected) byDrug[item.medication.id].selected = true;
          if (__WEBPACK_IMPORTED_MODULE_4_moment___default()(item.expired_date).isBefore(byDrug[item.medication.id].expired_date)) {
            byDrug[item.medication.id].expired_date = __WEBPACK_IMPORTED_MODULE_4_moment___default()(item.expired_date);
          }
        }
      });

      // exclude medication with none space to refill
      if (this.$store.state.currentApp.name === '補充藥物') {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(byDrug).forEach(function (med) {
          if (med.stock === med.max_stock) {
            delete byDrug[med.medication.id];
          }
        });
      }

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(byDrug).sort(function (a, b) {
        if (a.medication.CGMH_number < b.medication.CGMH_number) {
          return -1;
        }
        if (a.medication.CGMH_number > b.medication.CGMH_number) {
          return 1;
        }
        return 0;
      });
    }
  },
  methods: {
    selectDrug: function selectDrug(drugStorage) {
      var targetIndex = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(this.$store.state.drugInDevice.drugInDeviceList, function (o) {
        return o.id === drugStorage.id;
      });
      this.$store.dispatch('selectDrugInDevice', { num: targetIndex, singleSelection: this.singleSelection });
    },
    selectDrugByMed: function selectDrugByMed(med, index) {
      if (this.medSelectMode === 'automatic') {
        var drugStorageList = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(med.lists, function (o) {
          return o.stock > 0;
        });
        // 效期近的 散裝多的 先
        //const drugStorageListSorted = _.orderBy(drugStorageList, [(o) => { return new Date(o.expired_date); }, (o) => { return o.stock - (o.medication.pack_content * o.pack_count); }], ['asc', 'desc']);
        // 效期近的 散裝少的 先
        var drugStorageListSorted = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.orderBy(drugStorageList, [function (o) {
          return new Date(o.expired_date);
        }, function (o) {
          return o.stock - o.medication.pack_content * o.pack_count;
        }], ['asc', 'asc']);
        this.selectDrug(drugStorageListSorted[0]);
      }
      if (this.medSelectMode === 'selectDrugStorage') {
        this.$emit('setDrugStorageWithSameMed', med.lists);
      }
    },
    refillNewDrugStorage: function refillNewDrugStorage() {
      // refill to a new empty device and create a new drugStorage
      var devicesList = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.allDevices);
      var targetDeviceIndex = devicesList.findIndex(function (o) {
        return o.drugstorage_set.length === 0 && !(o.adc_type === 'A' && o.pos_row === 0);
      });
      if (targetDeviceIndex === -1) {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '無可使用的空藥盒，請聯絡管理人員處理。'
        });
      } else {
        this.$emit('setNewDeviceForRefill', devicesList[targetDeviceIndex].id);
      }
    }
  },
  mounted: function mounted() {
    this.$refs.input.focus();
  },

  watch: {
    searchText: function searchText(val) {
      this.$store.commit('FILTER_DRUG_IN_DEVICE', { mode: this.mode, searchText: val });
    },
    mode: function mode(val) {
      this.$store.commit('FILTER_DRUG_IN_DEVICE', { mode: val, searchText: this.searchText });
    }
  }
});

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_FocusModal__ = __webpack_require__(1341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_FocusModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_FocusModal__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DrugInfo',
  data: function data() {
    return {
      currentDrugInDeviceExpired: false,
      remainExpiredDays: 0,
      lastEvent: undefined,
      foucsMessage: '',
      focusModalStatus: false
    };
  },

  components: {
    FocusModal: __WEBPACK_IMPORTED_MODULE_1__common_FocusModal___default.a
  },
  methods: {
    showFocus: function showFocus(event) {
      console.log(event);
      var target = event.target;
      this.foucsMessage = target.outerHTML;
      this.focusModalStatus = true;
    },
    closeFocus: function closeFocus() {
      this.foucsMessage = '';
      this.focusModalStatus = false;
    },
    checkDrugInDevicesIsExpired: function checkDrugInDevicesIsExpired() {
      if (this.currentDrugInDevice !== null) {
        var expiredDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.currentDrugInDevice.expired_date);
        var today = __WEBPACK_IMPORTED_MODULE_0_moment___default()();
        if (expiredDate.diff(today, 'hours') > 0 && expiredDate.diff(today, 'hours') < 24) {
          this.remainExpiredDays = 1;
        } else {
          this.remainExpiredDays = expiredDate.diff(today, 'days');
        }
        if (this.remainExpiredDays < 0) {
          this.currentDrugInDeviceExpired = true;
        } else {
          this.currentDrugInDeviceExpired = false;
        }
      }
    },
    checkLastEvent: function checkLastEvent() {
      var _this = this;

      if (this.currentDrugInDevice) {
        this.instance.get('/api/event/', {
          params: {
            drug_storage: this.currentDrugInDevice.id,
            last_event: true,
            per_page: 1
          }
        }).then(function (res) {
          _this.lastEvent = res.data.results[0];
        });
      }
    }
  },
  created: function created() {
    if (this.currentDrugInDevice !== null) {
      this.checkDrugInDevicesIsExpired();
      this.checkLastEvent();
    }
  },

  computed: {
    selectedDrug: function selectedDrug() {
      return this.$store.state.drug.selectedDrug;
    },
    currentDrugInDevice: function currentDrugInDevice() {
      return this.$store.getters.currentDrugInDevice;
    },
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  filters: {
    readabletime: function readabletime(val) {
      if (val !== null || val !== undefined) {
        var time = __WEBPACK_IMPORTED_MODULE_0_moment___default()(val);
        return time.format('MM-DD HH:mm');
      }
      return undefined;
    }
  },
  watch: {
    currentDrugInDevice: function currentDrugInDevice(val) {
      if (val !== undefined || val !== null) {
        this.checkDrugInDevicesIsExpired();
        this.checkLastEvent();
      }
    }
  }
});

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DrugInfoWeb',
  computed: {
    iframeSrc: function iframeSrc() {
      var prefix = this.$store.state.generalSetting.weburl_prefix;
      var drugId = this.$store.state.drug.selectedDrug.code;
      return '' + prefix + drugId;
    },
    prefixSet: function prefixSet() {
      var prefix = this.$store.state.generalSetting.weburl_prefix;
      if (prefix === '' || prefix === null || prefix === undefined) return false;
      return true;
    }
  },
  methods: {
    close: function close() {
      this.$emit('closetab');
    }
  }
});

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'selectDrug',
  data: function data() {
    return {
      query: '',
      query_result: ''
    };
  },

  methods: {
    setDrug: function setDrug(drugId) {
      this.$store.dispatch('setDrug', drugId);
    }
  },
  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  mounted: function mounted() {
    this.$refs.input.focus();
  },

  watch: {
    query: function query() {
      var _this = this;

      if (this.query.length > 0) {
        this.instance.get('/api/medication/', {
          params: {
            search: this.query,
            type: 'normal'
          }
        }).then(function (res) {
          _this.query_result = res.data.results;
        });
      }

      if (this.query.length === 0) {
        this.query_result = '';
      }
    }
  }
});

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_free_solid_svg_icons__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_Loader__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EventTable',
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_4__common_Loader___default.a
  },
  props: {
    eventType: {
      type: String
    },
    device: {
      type: Number
    },
    singleSelection: {
      type: Boolean,
      default: false
    },
    number2: {
      type: Number // this is used for schedule id
    },
    hideChecked: {
      type: Boolean,
      default: true
    },
    noChecked: {
      type: Boolean,
      default: false
    },
    returnEmpty: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      fetchStatus: 'start',
      searchText: '',
      queryData: undefined
    };
  },

  methods: {
    selectEvent: function selectEvent(id) {
      this.$store.dispatch('selectEvent', { eventId: id, singleSelection: this.singleSelection });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              data = { event: _this.eventType, drug_storage__isnull: false };

              if (_this.device !== null) {
                data.device = _this.device;
              }
              if (_this.hideChecked) {
                data.checked = false;
              }
              if (_this.number2) {
                data.number2 = _this.number2;
                delete data.checked;
              }
              if (_this.noChecked) {
                delete data.checked;
              }
              if (_this.returnEmpty) {
                data.medication__return_when_empty = true;
              }

              data.system = _this.$store.state.device.systemId;

              _this.queryData = data;
              _context.next = 10;
              return _this.$store.dispatch('getEvents', _this.queryData);

            case 10:
              _this.fetchStatus = 'done';

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    events: function events() {
      return this.$store.state.event.events;
    },
    noteMedicalIcon: function noteMedicalIcon() {
      return __WEBPACK_IMPORTED_MODULE_3__fortawesome_free_solid_svg_icons__["c" /* faNotesMedical */];
    },
    circleIcon: function circleIcon() {
      return __WEBPACK_IMPORTED_MODULE_3__fortawesome_free_solid_svg_icons__["d" /* faCircle */];
    }
  },
  filters: {
    readableTime: function readableTime(value) {
      //20190510修改, 12小時改為24小時制
      //return moment(value).format('YYYY-MM-DD hh:mm');
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format('YYYY-MM-DD HH:mm');
    },
    zhLabel: function zhLabel(value) {
      if (value === 'WASTE') return '已拋棄';
      if (value === 'RETURN_EMPTY') return '已退空瓶';
      if (value === 'RETURN') return '已退藥';
      return value;
    }
  },
  watch: {
    searchText: function searchText(val) {
      this.$store.commit('FILTER_EVENTS', val);
    }
  }
});

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LockDevice',
  data: function data() {
    return {
      context: ''
    };
  },
  destroyed: function destroyed() {
    this.$store.commit('SHOW_MODAL', { modalName: 'lockDevice', status: false });
  },
  mounted: function mounted() {
    this.confirm();
  },

  methods: {
    reset: function reset() {
      var _this = this;

      this.$store.dispatch('resetCabinet');
      this.context = '系統重置中';
      setTimeout(function () {
        _this.$emit('closeLockDeviceModal');
        _this.$store.dispatch('openDevice');
      }, 2000);
    },
    confirm: function confirm() {
      var _this2 = this;

      this.context = '偵測藥盒無法開啟，已紀錄';
      this.$store.state.instance.patch('/api/device/' + this.currentDevice.id + '/', {
        error: true
      }).then(function () {
        // this.context = '已回報, 藥盒上鎖';
        _this2.$emit('errorReturned');
      });
    },
    notify: function notify() {
      this.$store.commit('SHOW_MODAL', { modalName: 'lockDevice', status: false });
      this.$router.push({ name: 'Main' });
    }
  },
  computed: {
    currentDevice: function currentDevice() {
      return this.$store.getters.currentDevice;
    }
  }
});

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);

//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LockDrawer',
  data: function data() {
    return {
      context: ''
    };
  },
  mounted: function mounted() {
    this.confirm();
  },
  destroyed: function destroyed() {
    this.$store.commit('SHOW_MODAL', { modalName: 'lockDrawer', status: false });
  },

  methods: {
    reset: function reset() {
      var _this = this;

      this.$store.dispatch('resetCabinet');
      this.context = '系統重置中';
      setTimeout(function () {
        _this.$emit('closeLockDrawerModal');
        _this.$store.dispatch('openDevice');
      }, 2000);
    },
    findDevicesWithSameDrawer: function findDevicesWithSameDrawer(device) {
      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.allDevices), function (item) {
        return item.net.id === device.net.id;
      });
    },
    confirm: function confirm() {
      var _this2 = this;

      this.context = '偵測抽屜無法開啟，已紀錄';
      var promises = [];
      var devices = this.findDevicesWithSameDrawer(this.currentDevice);
      console.log(devices);
      devices.forEach(function (dev) {
        promises.push(_this2.$store.state.instance.patch('/api/device/' + dev.id + '/', {
          error: true
        }));
      });

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.all(promises).then(function () {
        // this.context = '已回報, 上鎖';
        _this2.$emit('errorReturned');
      });
    },
    notify: function notify() {
      this.$store.commit('SHOW_MODAL', { modalName: 'lockDrawer', status: false });
      this.$router.push({ name: 'Main' });
    }
  },
  computed: {
    currentDevice: function currentDevice() {
      return this.$store.getters.currentDevice;
    },
    allDevices: function allDevices() {
      return this.$store.getters.allDevices;
    }
  }
});

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NumberInput__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NumberInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__NumberInput__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'confirmMaxStock',
  components: {
    NumberInput: __WEBPACK_IMPORTED_MODULE_0__NumberInput___default.a
  },
  data: function data() {
    return {
      amount: 0,
      patchNumber: '',
      // amountData: {
      //   amount: 0,
      //   patchNumber: '',
      // },
      showPad: false
    };
  },

  computed: {
    drug: function drug() {
      return this.$store.state.drug.selectedDrug;
    },
    placeholderText: function placeholderText() {
      if (this.drug.restrained_class > 0) return '此藥物為管制藥物，請輸入批號';
      return '選填批號';
    }
  },
  mounted: function mounted() {
    this.$refs.input.focus();
  },

  methods: {
    setMaxAmountData: function setMaxAmountData() {
      if (this.amount === 0) {
        this.$store.commit('SET_MESSAGE', { type: 'error', context: '最大庫存不可為0' });
      } else {
        if (this.drug.restrained_class > 0) {
          if (this.patchNumber === '') {
            this.$store.commit('SET_MESSAGE', { type: 'error', context: '新增管制藥物，請設定批號' });
          } else {
            this.$emit('setMaxAmountData', { amount: this.amount, patchNumber: this.patchNumber });
          }
        } else {
          this.$emit('setMaxAmountData', { amount: this.amount, patchNumber: this.patchNumber });
        }
      }
    },
    saveNumber: function saveNumber(val) {
      this.showPad = false;
      this.amount = val;
    }
  },
  watch: {
    amount: function amount(val) {
      console.log(val);
      if (isNaN(val)) {
        this.amount = 0;
      } else {
        this.amount = parseInt(this.amount, 10);
      }
    }
  }
});

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MedGroupSelect',
  data: function data() {
    return {
      medGroups: []
    };
  },
  created: function created() {
    this.getMedGroups();
  },
  mounted: function mounted() {
    //
  },

  methods: {
    close: function close() {
      this.$store.commit('SHOW_MODAL', { modalName: 'medGroupSelect', status: false });
    },
    getMedGroups: function getMedGroups() {
      var _this = this;

      this.instance.get('/api/medication-group/').then(function (res) {
        _this.medGroups = res.data;
      });
    },
    selectGroup: function selectGroup(id) {
      this.$emit('setGroup', id);
      this.close();
    }
  },
  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    }
  }
});

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NumberInput',
  props: {
    defaultNumber: Number
  },
  data: function data() {
    return {
      number: 0,
      numberString: '0'
    };
  },

  methods: {
    addNumber: function addNumber(val) {
      this.numberString = '' + this.numberString + val;
      this.stringToNumber();
    },
    removeNumber: function removeNumber() {
      this.numberString = this.numberString.substring(0, this.numberString.length - 1);
      this.stringToNumber();
    },
    stringToNumber: function stringToNumber() {
      if (this.numberString !== '') {
        this.number = parseInt(this.numberString, 10);
      } else {
        this.number = 0;
      }
    },
    saveNumber: function saveNumber() {
      this.$emit('saveNumber', this.number);
    }
  },
  mounted: function mounted() {
    console.log(this.defaultNumber);
    this.$refs.input.focus();
    if (this.defaultNumber !== undefined) this.number = this.defaultNumber;
  },

  watch: {
    number: function number(val) {
      this.number = parseInt(val, 10);
    }
  }
});

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NumberInput__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NumberInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__NumberInput__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NumberSet',
  props: {
    maxAmount: Number,
    defaultAmount: Number,
    inputLabel: String,
    canBeZero: Boolean
  },
  components: {
    NumberInput: __WEBPACK_IMPORTED_MODULE_0__NumberInput___default.a
  },
  data: function data() {
    return {
      storageAmount: 0,
      showPad: false
    };
  },
  mounted: function mounted() {
    this.storageAmount = this.defaultAmount;
    if (this.maxAmount) this.storageAmount = this.maxAmount;
    this.$refs.input.focus();
  },

  watch: {
    storageAmount: function storageAmount(val) {
      if (isNaN(val)) {
        this.storageAmount = 0;
      } else {
        this.storageAmount = parseInt(val, 10);
      }
    },
    defaultAmount: function defaultAmount() {
      this.storageAmount = this.defaultAmount;
    }
  },
  computed: {
    currentApp: function currentApp() {
      return this.$store.state.currentApp;
    }
  },
  methods: {
    setNum: function setNum() {
      if (this.maxAmount) {
        console.log(this.storageAmount > this.maxAmount);
        if (this.storageAmount > this.maxAmount) {
          this.$store.commit('SET_MESSAGE', { type: 'error', context: '\u8A2D\u5B9A\u6578\u91CF\u4E0D\u53EF\u5927\u65BC\u6700\u5927\u5EAB\u5B58\u91CF (' + this.MaxAmount + ').' });
        } else if (this.storageAmount === 0) {
          if (this.canBeZero) {
            this.$emit('setNum', this.storageAmount);
          } else {
            this.$store.commit('SET_MESSAGE', { type: 'error', context: '數量不可為0' });
          }
        } else {
          this.$emit('setNum', this.storageAmount);
        }
      } else {
        if (this.storageAmount === 0) {
          if (this.canBeZero) {
            this.$emit('setNum', this.storageAmount);
          } else {
            this.$store.commit('SET_MESSAGE', { type: 'error', context: '數量不可為0' });
          }
        } else {
          this.$emit('setNum', this.storageAmount);
        }
      }
    },
    saveNumber: function saveNumber(val) {
      this.storageAmount = val;
      this.showPad = false;
    }
  }
});

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SplitLayout__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SplitLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__SplitLayout__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'OperatingRoomScheduleList',
  props: {},
  data: function data() {
    return {
      getScheduled: false,
      scheduleToday: undefined,
      beds: undefined,
      scheduleByPatient: [],
      patientSelected: undefined,
      colormaps: ['#3BB143'],
      faUser: __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["j" /* faUser */],
      faUserMd: __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["l" /* faUserMd */]
    };
  },

  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_6__common_Loader___default.a,
    SplitLayout: __WEBPACK_IMPORTED_MODULE_7__SplitLayout___default.a
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.initSchedules();

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    instance: function instance() {
      return this.$store.getters.instance;
    }
  },
  methods: {
    //get schedule
    initSchedules: function initSchedules() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.getScheduled = false;
                // reset variables
                _this2.$store.commit('RESET_SCHEDULE');
                _this2.scheduleToday = {};
                _this2.scheduleByPatient = [];
                //擷取沒有hidden的schedule
                //await this.$store.dispatch('getSchedule');
                _context2.next = 6;
                return _this2.$store.dispatch('getOperatingRoomSchedule');

              case 6:

                _this2.filterScheduleToday();
                _this2.definePatientAndSchedule();
                _this2.getScheduled = true;

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    filterScheduleToday: function filterScheduleToday() {
      //與排班有關,目前沒有用到
      /*
      if (this.$store.state.generalSetting.shift_system_status) {
        const userId = this.$store.state.user.user.id;
        const filterdSchedule = [];
        Object.values(this.$store.getters.scheduleToday).forEach((sch) => {
          for (let i = 0; i < sch.shift.length; i += 1) {
            const sh = sch.shift[i];
            if (sh.employee === userId) {
              filterdSchedule.push(sch);
              break;
            }
          }
        });
        this.scheduleToday = filterdSchedule;
      } else {
        this.scheduleToday = this.$store.getters.scheduleToday;
      }
      */
      this.scheduleToday = this.$store.getters.scheduleToday;
    },
    definePatientAndSchedule: function definePatientAndSchedule() {
      var patients = {};
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.scheduleToday).forEach(function (sch) {
        var patientId = sch.patient.id;
        if (patients[patientId] === undefined) {
          patients[patientId] = {};
          patients[patientId].patient = sch.patient;
          patients[patientId].schedules = [];
          patients[patientId].bed = sch.bed;
        }
        patients[patientId].schedules.push(sch);
      });

      this.scheduleByPatient = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(patients), ['bed.ward.name', 'bed.code']);
    },
    selecteSchedule: function selecteSchedule(id) {
      this.$store.commit('SET_CURRENT_SCHEDULE_BY_ID', id);
      this.$emit('setSchedule');
    },
    extraInfoZh: function extraInfoZh(val) {
      var context = '';
      if (val.diagnosis_name) {
        context += '<strong><p>\u8A3A\u65B7\u540D\u7A31: ' + val.diagnosis_name + '</p></strong>';
      }
      if (val.surgery_time) {
        context += '<strong><p>\u624B\u8853\u65E5\u671F: ' + val.surgery_time + '</p></strong>';
      }
      if (val.surgery_name) {
        context += '<strong><p>\u624B\u8853\u540D\u7A31: ' + val.surgery_name + '</p></strong>';
      }
      if (val.surgery_room) {
        context += '<strong><p>\u624B\u8853\u623F\u9593: ' + val.surgery_room + '</p></strong>';
      }
      return context;
    },
    patientSelectFun: function patientSelectFun(val) {
      if (this.patientSelected == val) {
        this.patientSelected = undefined;
        this.$emit('setPatientSchedule', {
          medRecordId: "",
          manualEnable: true,
          bedId: undefined,
          gender: undefined
        });
      } else {
        this.patientSelected = val;
        this.$emit('setPatientSchedule', {
          medRecordId: this.scheduleByPatient[val].patient.med_record_number,
          manualEnable: false,
          bedId: this.scheduleByPatient[val].bed.id,
          gender: this.scheduleByPatient[val].patient.gender
        });
      }
    }
  },
  filters: {
    genderZh: function genderZh(val) {
      if (val === 'male') return '男';
      if (val === 'female') return '女';
      return '';
    },
    areaFormat: function areaFormat(obj) {
      return obj.department.name + obj.name;
    }
  },
  watch: {}
});

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NumberInput__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NumberInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__NumberInput__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PackAndPieceSet',
  props: {
    maxAmount: Number,
    defaultAmount: Number,
    defaultPackCount: Number,
    inputLabel: String,
    canBeZero: Boolean
  },
  components: {
    NumberInput: __WEBPACK_IMPORTED_MODULE_0__NumberInput___default.a
  },
  data: function data() {
    return {
      packCount: 0,
      pieceCount: 0,
      showPackPad: false,
      showPiecePad: false
    };
  },
  created: function created() {
    // this.storageAmount = this.defaultAmount;
    // if (this.maxAmount) this.storageAmount = this.maxAmount;
  },
  mounted: function mounted() {
    this.$refs.input.focus();
    this.autoCalcPackAndPiece();
  },

  computed: {
    selectedDrug: function selectedDrug() {
      return this.$store.getters.selectedDrug;
    },
    storageAmount: function storageAmount() {
      return this.packCount * this.selectedDrug.pack_content + this.pieceCount;
    }
  },
  methods: {
    setNum: function setNum() {
      if (this.maxAmount) {
        console.log(this.storageAmount > this.maxAmount);
        if (this.storageAmount > this.maxAmount) {
          this.$store.commit('SET_MESSAGE', { type: 'error', context: '\u8A2D\u5B9A\u6578\u91CF\u4E0D\u53EF\u5927\u65BC\u6700\u5927\u5EAB\u5B58\u91CF (' + this.MaxAmount + ').' });
        } else if (this.storageAmount === 0) {
          if (this.canBeZero) {
            this.emitData();
          } else {
            this.$store.commit('SET_MESSAGE', { type: 'error', context: '數量不可為0' });
          }
        } else {
          this.emitData();
        }
      } else {
        if (this.storageAmount === 0) {
          if (this.canBeZero) {
            this.emitData();
          } else {
            this.$store.commit('SET_MESSAGE', { type: 'error', context: '數量不可為0' });
          }
        } else {
          this.emitData();
        }
      }
    },
    emitData: function emitData() {
      this.$emit('setNum', {
        packCount: this.packCount,
        pieceCount: this.pieceCount,
        amount: this.storageAmount
      });
    },
    saveNumber: function saveNumber(val) {
      this.storageAmount = val;
      this.showPad = false;
    },
    savePackCount: function savePackCount(val) {
      this.packCount = val;
      this.showPackPad = false;
    },
    savePieceCount: function savePieceCount(val) {
      this.pieceCount = val;
      this.showPiecePad = false;
    },
    autoCalcPackAndPiece: function autoCalcPackAndPiece() {
      if (this.defaultPackCount === undefined) {
        if (this.selectedDrug.pack_content !== 0) {
          this.packCount = Math.floor(this.defaultAmount / this.selectedDrug.pack_content);
          this.pieceCount = this.defaultAmount % this.selectedDrug.pack_content;
        } else {
          this.packCount = 0;
          this.pieceCount = this.defaultAmount;
        }
      }
    }
  },
  watch: {
    packCount: function packCount(val) {
      if (isNaN(val)) {
        this.packCount = 0;
      } else {
        this.packCount = val;
      }
    },
    pieceCount: function pieceCount(val) {
      if (isNaN(val)) {
        this.pieceCount = 0;
      } else {
        this.pieceCount = val;
      }
    }
  }
});

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PatientInfo',
  computed: {
    currentSchedule: function currentSchedule() {
      return this.$store.getters.currentSchedule;
    }
  },
  methods: {
    printQR: function printQR() {
      this.$store.dispatch('printQR');
    }
  }
});

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_Loader__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// TODO: singleSelectionMode.
// mode: onlyDrug, emptyAndF




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PositionSelection',
  props: {
    mode: {
      type: String,
      default: 'onlyDrug'
    },
    singleSelect: { // currently used on setting return box.
      type: Boolean,
      default: false
    }
  },
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_2__common_Loader___default.a
  },
  data: function data() {
    return {
      selectedDevice: {},
      showRow: false,
      allSystems: {},
      systemIds: [],
      systemIndex: 0,
      currentNetIndex: 0,
      previousSelectedDevicesID: [],
      previousSelectedDrugStorageID: []
    };
  },
  created: function created() {
    // this.$store.commit('SET_CURRENT_SYSTEM', this.currentSystemIndex);
    // this.$store.commit('SET_CURRENT_NET', 0);
    this.allSystems = this.$store.state.device.systems;
    this.systemIds = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.allSystems);
  },

  computed: {
    currentNet: function currentNet() {
      return this.systemShowed.net_set[this.currentNetIndex];
    },

    // allSystems() {
    //   return this.$store.getters.systems;
    // },
    // currentNetIndex() {
    //   return this.$store.getters.currentNetIndex;
    // },
    systemShowed: function systemShowed() {
      return this.allSystems[this.systemIds[this.systemIndex]];
    },
    numRow: function numRow() {
      var row = 1;
      this.currentNet.device_set.forEach(function (device) {
        if (device.pos_row > row) row = device.pos_row;
      });
      return row;
    },
    selectedDevicesID: function selectedDevicesID() {
      return this.$store.state.device.selectedDevicesID;
    },
    selectedDrugInDeviceID: function selectedDrugInDeviceID() {
      return this.$store.getters.selectedDrugInDeviceID;
    }
  },
  methods: {
    selectNet: function selectNet(net) {
      var netDrugStorageCount = 0;
      net.device_set.forEach(function (device) {
        netDrugStorageCount += device.drugstorage_set.length;
      });

      this.currentNetIndex = net.row_id - 1;
      this.showRow = !this.showRow;
    },
    selecteAllDrugStorageWithNet: function selecteAllDrugStorageWithNet(net) {
      var _this = this;

      net.device_set.forEach(function (device) {
        if (device.drugstorage_set.length >= 0) {
          try {
            device.drugstorage_set.forEach(function (item) {
              _this.selectDrug(item);
            });
          } catch (err) {
            console.log(err);
          }
        }
      });
    },
    selectDevice: function selectDevice(device) {
      if (this.singleSelect) this.$store.dispatch('emptyDevices');

      if (this.mode === 'onlyDrug' && device.error !== true) {
        if (device.drugstorage_set.length >= 1 && device.specific_type !== 'return_device') {
          var drugStorageAllExpired = true;
          device.drugstorage_set.forEach(function (drugstorage) {
            if (drugstorage.expired === false) drugStorageAllExpired = false;
          });
          if (drugStorageAllExpired === false) {
            this.$store.dispatch('selectDrugInDeviceByPosSelection', { deviceId: device.id, drugStorageSet: device.drugstorage_set });
          }
        }
      }
      if (this.mode === 'emptyAndF' && device.specific_type === null && device.error !== true) {
        if (device.drugstorage_set.length === 0) {
          this.$store.commit('ADD_DEVICE_TO_SELECTED_LIST', device.id);
        } else if (this.currentNet.type === 'F' && this.singleSelect === false && device.drugstorage_set.length < 24) {
          this.$store.commit('ADD_DEVICE_TO_SELECTED_LIST', device.id.toString());
        }
      }
      if (this.mode === 'lockDevice' && device.specific_type === 'lock_device' && device.error !== true && device.drugstorage_set.length === 0) {
        this.$store.commit('ADD_DEVICE_TO_SELECTED_LIST', device.id);
      }
    },
    selectDrug: function selectDrug(drugStorage) {
      if (this.mode === 'onlyDrug') {
        var targetIndex = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findIndex(this.$store.state.drugInDevice.drugInDeviceList, function (o) {
          return o.id === drugStorage.id;
        });
        this.$store.dispatch('selectDrugInDevice', { num: targetIndex });
        drugStorage.selected = !drugStorage.selected;
      }
    },
    nextSystem: function nextSystem() {
      if (this.systemIndex + 1 < this.systemIds.length) this.systemIndex += 1;
    },
    previousSystem: function previousSystem() {
      if (this.systemIndex !== 0) this.systemIndex -= 1;
    }
  },
  filters: {
    reverse: function reverse(val) {
      return val.slice().reverse();
    },
    setLength: function setLength(str) {
      if (str.length > 10) return str.substring(0, 10) + '...';
      return str;
    }
  },
  watch: {
    // handle device selected.
    selectedDevicesID: function selectedDevicesID(val) {
      var _this2 = this;

      var targetDevices = this.selectedDevicesID.map(function (id) {
        return _this2.$store.state.device.allDevices[id];
      });
      this.previousSelectedDevicesID.forEach(function (id) {
        if (_this2.selectedDevicesID.indexOf(id) === -1) {
          var cancelDevice = _this2.$store.state.device.allDevices[id];
          var pdevice = _this2.allSystems[cancelDevice.net.system_serial].net_set[cancelDevice.net.row_id - 1].device_set[cancelDevice.index];
          pdevice.selected = false;
          var pnet = _this2.allSystems[cancelDevice.net.system_serial].net_set[cancelDevice.net.row_id - 1];
          pnet.hasDeviceSelected = false;
        }
      });
      // setup this targets
      targetDevices.forEach(function (device) {
        var tdevice = _this2.allSystems[device.net.system_serial].net_set[device.net.row_id - 1].device_set[device.index];
        tdevice.selected = true;
        var tnet = _this2.allSystems[device.net.system_serial].net_set[device.net.row_id - 1];
        tnet.hasDeviceSelected = true;
      });
      // javascript is a pass-by-value language, you must make a copy otherwise you are actually changing the same array.
      this.previousSelectedDevicesID = this.selectedDevicesID.slice();
    },

    // handle drugStorage selected
    selectedDrugInDeviceID: function selectedDrugInDeviceID(val) {
      var _this3 = this;

      var targetDrugStorage = this.selectedDrugInDeviceID.map(function (id) {
        return _this3.$store.state.drugInDevice.allDrugInDevice[id];
      });
      this.previousSelectedDrugStorageID.forEach(function (drugStorageID) {
        // the old one was not found in the new one, indicates that it should be unselected.
        if (_this3.selectedDrugInDeviceID.indexOf(drugStorageID) === -1) {
          var cancelDrugStorage = _this3.$store.state.drugInDevice.allDrugInDevice[drugStorageID];
          var cancelDevice = _this3.$store.state.device.allDevices[cancelDrugStorage.device.id];
          var localDevice = _this3.allSystems[cancelDrugStorage.device.net.system_serial].net_set[cancelDrugStorage.device.net.row_id - 1].device_set[cancelDevice.index];

          // once a item is selected, make the device selected.
          var onceDrugStorageInPreviousDeviceSelected = false;
          localDevice.drugstorage_set.forEach(function (item) {
            if (item.id === parseInt(drugStorageID, 10)) {
              item.selected = false;
            }
            if (item.selected) {
              onceDrugStorageInPreviousDeviceSelected = true;
            }
          });
          if (onceDrugStorageInPreviousDeviceSelected) {
            localDevice.selected = true;
          } else {
            localDevice.selected = false;
          }
        }
      });

      targetDrugStorage.forEach(function (drugStorage) {
        var targetDevice = _this3.$store.state.device.allDevices[drugStorage.device.id];
        var tlocalDevice = _this3.allSystems[drugStorage.device.net.system_serial].net_set[drugStorage.device.net.row_id - 1].device_set[targetDevice.index];
        var onceDrugStorageInTargetDeviceSelected = false;
        // const tlocalNet = this.allSystems[drugStorage.device.net.system.id].net_set[(drugStorage.device.net.row_id - 1)];
        // tlocalNet.hasDeviceSelected = true;
        tlocalDevice.drugstorage_set.forEach(function (item) {
          if (item.id === drugStorage.id) {
            item.selected = true;
          }
          // once a item is selected, make the device selected.
          if (item.selected === true) {
            onceDrugStorageInTargetDeviceSelected = true;
          }
        });
        if (onceDrugStorageInTargetDeviceSelected) {
          tlocalDevice.selected = true;
        } else {
          tlocalDevice.selected = false;
        }
      });

      this.previousSelectedDrugStorageID = this.selectedDrugInDeviceID.slice();
    }
  }
});

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatientInfo__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatientInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PatientInfo__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProgressBar',
  components: {
    PatientInfo: __WEBPACK_IMPORTED_MODULE_0__PatientInfo___default.a
  },
  computed: {
    indOfThisStep: function indOfThisStep() {
      var steps = [];
      this.progress.forEach(function (step) {
        steps.push(step.en);
      });
      // console.log(steps.indexOf(this.currentStep));
      return steps.indexOf(this.currentStep);
    },
    progress: function progress() {
      // console.log(this.$store.state.progress);
      return this.$store.state.progress;
    },
    currentStep: function currentStep() {
      return this.$store.state.currentStep;
    },
    currentSchedule: function currentSchedule() {
      return this.$store.getters.currentSchedule;
    }
  }
});

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Reason',
  data: function data() {
    return {
      selectReason: '',
      customReason: ''
    };
  },

  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    },
    returnReasons: function returnReasons() {
      return this.$store.state.generalSetting.return_reason;
    }
  },
  watch: {
    customReason: function customReason(val) {
      if (val !== '') this.selectReason = '';
    }
  },
  methods: {
    setReason: function setReason(val) {
      this.selectReason = val;
      this.customReason = '';
    },
    confirmReason: function confirmReason() {
      if (this.selectReason === '' && this.customReason === '') {
        this.$store.commit('SET_MESSAGE', { type: 'error', context: '請選擇一項理由或輸入理由' });
      } else {
        if (this.customReason !== '') {
          this.$emit('setReason', this.customReason);
        } else {
          this.$emit('setReason', this.selectReason);
        }
      }
    }
  }
});

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['drugStorageIds'],
  name: 'RefillSelection',
  components: {},
  data: function data() {
    return {
      setUnusedDevice: false,
      emptyDeviceSelected: null
    };
  },

  computed: {
    sameMedDrugStorage: function sameMedDrugStorage() {
      var _this = this;

      var drugStorages = [];
      this.drugStorageIds.forEach(function (id) {
        drugStorages.push(_this.$store.state.drugInDevice.allDrugInDevice[id]);
      });
      return drugStorages;
    }
  },
  methods: {
    setNextDrugStorage: function setNextDrugStorage(drugStorage) {
      this.$store.commit('SELECT_DRUG_IN_DEVICES_FROM_ALL', drugStorage.id);
      this.$store.commit('DRUG_IN_DEVICE_USED', drugStorage.id);
      this.$store.dispatch('setDrug', drugStorage.medication.id);
      this.$emit('selectionDone');
    },
    cancel: function cancel() {
      this.$emit('cancelSelection');
    }
  },
  filters: {
    readableDevice: function readableDevice(device) {
      return '\u7B2C' + device.net.open_times + '\u85E5\u6AC3 - ' + device.net.row_id + '\u5C64 - ' + device.pos_row + '\u5217 - ' + device.relative_col + '\u884C';
    }
  }
});

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RefillToNewDrugStorage'
});

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NumberInput__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NumberInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__NumberInput__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ResetLowAmountLimit',
  props: {
    showNumPad: {
      type: Boolean,
      default: true
    },
    currentAmount: {
      type: Number,
      default: undefined
    },
    limitAmount: {
      type: Number,
      default: undefined
    }
  },
  data: function data() {
    return {
      number: 0,
      showPad: false
    };
  },

  computed: {
    instance: function instance() {
      return this.$store.getters.instance;
    },
    selectedDrugLowAmountLimitData: function selectedDrugLowAmountLimitData() {
      return this.$store.getters.selectedDrugLowAmountLimitData;
    },
    selectedDrugTotalMax: function selectedDrugTotalMax() {
      return this.$store.getters.selectedDrugTotalMax;
    },
    amount: function amount() {
      if (this.currentAmount) return this.currentAmount;
      return this.selectedDrugLowAmountLimitData.min_stock;
    },
    amountLimit: function amountLimit() {
      if (this.limitAmount) return this.limitAmount;
      return this.selectedDrugTotalMax;
    }
  },
  components: {
    NumberInput: __WEBPACK_IMPORTED_MODULE_0__NumberInput___default.a
  },
  methods: {
    useNumPad: function useNumPad() {
      if (this.showNumPad) {
        this.showPad = true;
      }
    },
    saveNumber: function saveNumber(val) {
      this.number = val;
      this.showPad = false;
    },
    cancel: function cancel() {
      this.$emit('closeModal');
    },
    confirm: function confirm() {
      var _this = this;

      if (this.number > this.amountLimit) {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: '\u5B89\u5168\u5B58\u91CF\u4E0D\u53EF\u5927\u65BC\u7E3D\u6700\u5927\u5EAB\u5B58\u91CF: ' + this.amountLimit,
          keepOnTop: true
        });
      } else {
        this.instance.patch('/api/total-storage-in-system/' + this.selectedDrugLowAmountLimitData.id + '/', {
          min_stock: this.number
        }).then(function (res) {
          _this.$emit('closeModal');
          _this.$store.commit('SET_MESSAGE', {
            type: 'success',
            context: '修改完成',
            keepOnTop: true
          });
          _this.$store.dispatch('getLowAmountLimitData', _this.selectedDrugLowAmountLimitData.medication.id);
        });
      }
    }
  },
  watch: {
    number: function number(val) {
      this.number = parseInt(val, 10);
    }
  }
});

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PositionSelection__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PositionSelection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PositionSelection__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReturnSelection',
  components: {
    PositionSelection: __WEBPACK_IMPORTED_MODULE_1__PositionSelection___default.a
  },
  data: function data() {
    return {
      setUnusedDevice: false,
      emptyDeviceSelected: null,
      sameMedDrugStorage: []
    };
  },
  mounted: function mounted() {
    this.$store.commit('DRUG_IN_DEVICE_USED', this.currentDrugInDevice.id);
    if (this.currentSystem.settings.return_to_original_cmpn) {
      this.getSameMedDrugStorage();
    }
  },

  computed: {
    currentSystem: function currentSystem() {
      return this.$store.getters.currentSystem;
    },
    returnCmpn: function returnCmpn() {
      return this.currentSystem.return_cmpn;
    },
    externalCmpn: function externalCmpn() {
      return this.$store.state.externalCmpn;
    },
    existEmptyCmpn: function existEmptyCmpn() {
      var deviceWithDrugStorage = 0;
      this.currentSystem.net_set.forEach(function (net) {
        net.device_set.forEach(function (device) {
          if (device.drugstorage_set.length !== 0) deviceWithDrugStorage += 1;
        });
      });
      if (deviceWithDrugStorage > 0) {
        return true;
      }
      return false;
    },
    instance: function instance() {
      return this.$store.getters.instance;
    },
    currentDrugInDevice: function currentDrugInDevice() {
      return this.$store.getters.currentDrugInDevice;
    },
    hasUsedDrugStorageId: function hasUsedDrugStorageId() {
      return this.$store.getters.hasUsedDrugStorageId;
    },
    drugInDeviceList: function drugInDeviceList() {
      return this.$store.getters.drugInDeviceList;
    }
  },
  methods: {
    setReturnDevice: function setReturnDevice(deviceId, type) {
      this.$emit('setReturnDevice', { deviceId: deviceId, type: type });
    },
    getSameMedDrugStorage: function getSameMedDrugStorage() {
      var _this = this;

      var drugStorageSameMed = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.drugInDeviceList, function (item) {
        return item.medication.id === _this.currentDrugInDevice.medication.id && item.max_stock !== item.stock && item.patch_number === _this.currentDrugInDevice.patch_number;
      });
      console.log(drugStorageSameMed);
      // filter out the drugStorage that has been used.
      this.sameMedDrugStorage = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.reject(drugStorageSameMed, function (o) {
        return _this.hasUsedDrugStorageId.indexOf(parseInt(o.id, 10)) !== -1;
      });
      console.log(this.sameMedDrugStorage);
    },
    setNextDrugStorage: function setNextDrugStorage(drugStorage) {
      this.$store.commit('SELECT_DRUG_IN_DEVICES_FROM_ALL', drugStorage.id);
      this.$store.commit('DRUG_IN_DEVICE_USED', drugStorage.id);
      this.$emit('setReturnDrugStorage', { drug_storage: drugStorage });
    }
  },
  filters: {
    readableDevice: function readableDevice(device) {
      return '\u7B2C' + device.net.open_times + '\u85E5\u6AC3 - ' + device.net.row_id + '\u5C64 - ' + device.pos_row + '\u5217 - ' + device.relative_col + '\u884C';
    }
  }
});

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScanBarcode__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScanBarcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ScanBarcode__);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RxCheckBarcode',
  components: {
    ScanBarcode: __WEBPACK_IMPORTED_MODULE_0__ScanBarcode___default.a
  },
  data: function data() {
    return {
      reviewEmployee: undefined
    };
  },

  computed: {
    instance: function instance() {
      return this.$store.state.instance;
    }
  },
  methods: {
    confirmRx: function confirmRx() {
      this.$emit('confirmRx', this.reviewEmployee);
    },
    getBarcode: function getBarcode(val) {
      var _this = this;

      this.instance.get('/api/user/', {
        params: {
          barcode: val
        }
      }).then(function (res) {
        if (res.data.results.length > 0) {
          var reviewEmployee = res.data.results[0];
          if (reviewEmployee.id === _this.$store.state.user.user.id) {
            _this.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: '自身無法覆核，請找其他人員進行覆核'
            });
          } else if (reviewEmployee.task_privilege.check) {
            // okay
            _this.reviewEmployee = reviewEmployee;
          } else {
            _this.$store.commit('SET_MESSAGE', {
              type: 'warn',
              context: '該人員無覆核權限'
            });
          }
        } else {
          _this.$store.commit('SET_MESSAGE', {
            type: 'warn',
            context: '條碼未找到人員'
          });
        }
      });
    }
  }
});

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ScanBarcode',
  data: function data() {
    return {
      // barcodeRaw: '',
    };
  },

  computed: {
    currentApp: function currentApp() {
      return this.$store.state.currentApp.name;
    },
    barcodeTitle: function barcodeTitle() {
      if (this.currentApp === '新增藥物') return '欲新增藥盒';
      if (this.currentApp === '一般取藥') return '藥單條碼';
      if (this.currentApp === '一般退藥') return '藥單條碼';
      if (this.currentApp === '醫囑退藥') return ' AUTOIX 二維';
      return '';
    }
  },
  mounted: function mounted() {
    var _this = this;

    var pressed = false;
    var chars = [];
    window.addEventListener('keypress', function (e) {
      // console.log(e.which, String.fromCharCode(e.which));
      if (e.which > 13) {
        chars.push(String.fromCharCode(e.which));
      }

      if (pressed === false) {
        setTimeout(function () {
          if (chars.length >= 10) {
            var barcode = chars.join('');
            _this.$emit('setBarcode', barcode);
          }
          chars = [];
          pressed = false;
        }, 500);
      }
      pressed = true;
    });
  }
});

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__common_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SplitLayout__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SplitLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__SplitLayout__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ScheduleList',
  props: {
    filterOutZeroAmountMed: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      getScheduled: false,
      scheduleToday: undefined,
      //scheduleTodayBack: undefined,
      //searchText: '',
      beds: undefined,
      scheduleByWard: [],
      scheduleByPatient: [],
      patientSelected: undefined,
      filteredSchCount: 0,
      colormaps: ['#3BB143'],
      faUser: __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["j" /* faUser */],
      faPrescriptionBottle: __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["k" /* faPrescriptionBottle */]
    };
  },

  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_6__common_Loader___default.a,
    SplitLayout: __WEBPACK_IMPORTED_MODULE_7__SplitLayout___default.a
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.initSchedules();

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    instance: function instance() {
      return this.$store.getters.instance;
    }
  },
  methods: {
    //get schedule
    initSchedules: function initSchedules() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.getScheduled = false;
                // reset variables
                _this2.$store.commit('RESET_SCHEDULE');
                _this2.scheduleToday = {};
                // this.scheduleByWard = [];
                _this2.scheduleByPatient = [];
                //擷取沒有hidden的schedule
                _context2.next = 6;
                return _this2.$store.dispatch('getSchedule');

              case 6:

                _this2.filterScheduleToday();
                // this.defineWardAndBed();
                _this2.definePatientAndSchedule();
                _this2.getScheduled = true;

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    filterScheduleToday: function filterScheduleToday() {
      //與排班有關,目前沒有用到
      if (this.$store.state.generalSetting.shift_system_status) {
        var userId = this.$store.state.user.user.id;
        var filterdSchedule = [];
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.$store.getters.scheduleToday).forEach(function (sch) {
          for (var i = 0; i < sch.shift.length; i += 1) {
            var sh = sch.shift[i];
            if (sh.employee === userId) {
              filterdSchedule.push(sch);
              break;
            }
          }
        });
        this.scheduleToday = filterdSchedule;
      } else {
        this.scheduleToday = this.$store.getters.scheduleToday;
      }
      //this.scheduleTodayBack = this.scheduleToday;
    },
    definePatientAndSchedule: function definePatientAndSchedule() {
      var _this3 = this;

      var patients = {};
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.scheduleToday).forEach(function (sch) {
        var patientId = sch.patient.id;
        if (patients[patientId] === undefined) {
          patients[patientId] = {};
          patients[patientId].patient = sch.patient;
          patients[patientId].schedules = [];
          patients[patientId].bed = sch.bed;
        }
        patients[patientId].schedules.push(sch);
      });

      if (this.filterOutZeroAmountMed) {
        this.filteredSchCount = 0;
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(patients).forEach(function (pat) {
          var filterdSch = [];
          pat.schedules.forEach(function (sch) {
            var hasMedInSystem = false;
            sch.combo_relationship.forEach(function (childMed) {
              if (_this3.$store.state.drugInDevice.medicationCount[childMed.child_medication.id]) hasMedInSystem = true;
            });
            if (hasMedInSystem) {
              filterdSch.push(sch);
              _this3.filteredSchCount += 1;
            }
          });
          pat.schedules = filterdSch;
        });
      }

      this.scheduleByPatient = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(patients), ['bed.ward.name', 'bed.code']);
    },
    selecteSchedule: function selecteSchedule(id) {
      this.$store.commit('SET_CURRENT_SCHEDULE_BY_ID', id);
      this.$emit('setSchedule');
    },
    extraInfoZh: function extraInfoZh(val) {
      var context = '';
      if (val.DRUG_FREQ) {
        context += '\u85E5\u7269\u983B\u7387: ' + val.DRUG_FREQ + ' ';
      }
      if (val.DOSE && val.DOSE_UNIT) {
        context += '\u4F7F\u7528\u5291\u91CF: ' + val.DOSE + ' ' + val.DOSE_UNIT;
      }
      if (val.DRUG_COMM) {
        context += '<p>\u5099\u8A3B: ' + val.DRUG_COMM + '</p>';
      }
      return context;
    }
  },
  filters: {
    genderZh: function genderZh(val) {
      if (val === 'male') return '男';
      if (val === 'female') return '女';
      return '';
    },
    areaFormat: function areaFormat(obj) {
      return obj.department.name + obj.name;
    }
  },
  watch: {}
});

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SystemPanel',
  props: ['unit'],
  computed: {
    systems: function systems() {
      return this.$store.getters.systems;
    },
    selectedDevices: function selectedDevices() {
      if (this.unit === 'drug') {
        return this.$store.state.drug.selectedDrugInDevice;
      }
      return this.$store.state.device.selectedDevices;
    },
    errorDevice: function errorDevice() {
      return this.$store.state.device.errorDevices;
    },
    currentDevice: function currentDevice() {
      return this.$store.getters.currentDevice;
    },
    currentNet: function currentNet() {
      return this.systems[this.currentDevice.net.system_serial].net_set[this.currentDevice.net.row_id - 1];
    },
    numRow: function numRow() {
      var row = 0;
      this.currentNet.device_set.forEach(function (device) {
        if (device.pos_row > row) row = device.pos_row;
      });
      return row;
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'confirmStorage',
  props: {
    defaultContent: String,
    inputLabel: String,
    editable: {
      default: true,
      type: Boolean
    }
  },
  data: function data() {
    return {
      content: ''
    };
  },
  created: function created() {
    // this.content = this.defaultContent;
  },
  mounted: function mounted() {
    console.log(this.defaultContent);
    this.content = this.defaultContent;
    this.$refs.input.focus();
  },

  computed: {
    currentApp: function currentApp() {
      return this.$store.state.currentApp;
    }
  },
  methods: {
    setText: function setText() {
      this.$emit('setText', this.content);
    }
  },
  watch: {
    defaultContent: function defaultContent(val) {
      this.content = val;
    }
  }
});

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UpDownPanel',
  methods: {
    scrollup: function scrollup() {
      var element = document.getElementsByClassName('drug-search-list')[0];
      if (element.scrollTop >= 0) {
        element.scrollTop -= 100;
      } else {
        element.scrollTop = 0;
      }
    },
    scrolldown: function scrolldown() {
      var element = document.getElementsByClassName('drug-search-list')[0];
      if (element.scrollTop <= element.scrollHeight) {
        element.scrollTop += 100;
      } else {
        element.scrollTop = element.scrollHeight;
      }
    }
  }
});

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetable_2__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetable_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetable_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vuex_store__ = __webpack_require__(214);






// self-define components




// font-awesome vue version
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('font-awesome-icon', __WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome__["FontAwesomeIcon"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('font-awesome-layers', __WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome__["FontAwesomeLayers"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('font-awesome-layers-text', __WEBPACK_IMPORTED_MODULE_4__fortawesome_vue_fontawesome__["FontAwesomeLayersText"]);

// settings of vue
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.devtools = true;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.performance = true;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.errorHandler = function (err, vm, info) {
  console.error(err, vm, info);
};

// Vuetable is used in Admin page.
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuetable_2___default.a);

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_7__vuex_store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */]);

/* eslint-disable no-new */
var root = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_7__vuex_store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_5__App___default.a }
});

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__router__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mutation_types__ = __webpack_require__(74);







var _mutations;

/**
 * This compoment is mainly for controlling devices(drawers).
 */








var state = {
  systemId: undefined, // 目前此系統於db的id
  systems: {}, // 此系統若有多藥櫃的話，會用object來儲存layout (抱歉不應該用這麼糟糕的variable name...)
  systemArea: undefined, // 系統位於的區域
  systemLayoutChecked: false, // 系統的layout已經檢查過（從local websocket）
  externalCmpn: null, // 外部藥盒
  currentNetIndex: 0, // 目前操作(點選)的net index
  currentSystem: {}, // 目前操作中的藥櫃 (抱歉不應該用這麼糟糕的variable name...)
  selectedDevicesID: [], // 選擇的裝置 IDs
  selectedDevices: {}, // 選擇的裝置資料
  currentDevice: null, // 目前動作中的裝置
  nextDevice: null, // 下一步奏將操作的裝置
  errorDevices: [], // 目前藥櫃開啟中的藥盒或抽屜
  allDevices: {}, // 系統的所有裝置
  forLockDevices: [] // 上鎖的裝置
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_types__["G" /* RESET_DEVICES_MODULE */], function (state) {
  state.selectedDevicesID = [];
  state.selectedDevices = {};
  state.currentDevice = null; // device working on in the flow.
  state.nextDevice = null;
  state.errorDevices = [];
}), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_types__["H" /* SET_CURRENT_DEVICE_FROM_SELECTED */], function (state, deviceId) {
  // set current device from selectedDevices.
  state.currentDevice = state.selectedDevices[deviceId];

  // set next device for adc control.
  var keys = state.selectedDevicesID;
  var index = keys.indexOf(deviceId.toString());
  if (index < keys.length - 1 && index !== -1) {
    state.nextDevice = state.selectedDevices[keys[index + 1]];
  } else {
    state.nextDevice = null;
  }
}), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_types__["I" /* SET_CURRENT_DEVICE_FROM_ALL */], function (state, deviceId) {
  state.currentDevice = state.allDevices[deviceId];
}), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_types__["J" /* SET_NEXT_DEVICE */], function (state, deviceId) {
  state.nextDevice = state.allDevices[deviceId];
}), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_types__["K" /* REMOVE_NEXT_DEVICE */], function (state) {
  state.nextDevice = null;
}), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_types__["L" /* SET_CURRENT_NET */], function (state, index) {
  state.currentNetIndex = index;
}), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_types__["M" /* ADD_DEVICE_TO_SELECTED_LIST */], function (state, deviceId) {
  // update allDevices
  state.allDevices[deviceId].selected = !state.allDevices[deviceId].selected;
  var index = state.selectedDevicesID.indexOf(deviceId.toString());
  if (index === -1) {
    state.selectedDevices[deviceId] = state.allDevices[deviceId];
  } else {
    // state.selectedDevicesID.splice(index, 1);
    delete state.selectedDevices[deviceId];
  }
  state.selectedDevicesID = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(state.selectedDevices);
}), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_types__["N" /* CHANGE_DEVICE_SELECTED_STATUS */], function (state, deviceId) {
  var targetDevice = state.allDevices[deviceId];
  var sys = state.systems[targetDevice.net.system];
  sys.net_set.forEach(function (net) {
    net.selectedDeviceCount = 0;
    net.device_set.forEach(function (device) {
      if (device.selected === undefined) device.selected = false; // init
      if (device.id === deviceId) {
        device.selected = !device.selected;
        console.log('clicked device: ', device);
      }
      if (device.selected === true) {
        sys.selectedDeviceCount += 1;
        net.selectedDeviceCount += 1;
      } else {
        sys.selectedDeviceCount -= 1;
      }
    });
  });
}), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_12__mutation_types__["O" /* SETUP_LOCKED_DEVICES */], function (state, forLockDevices) {
  state.forLockDevices = forLockDevices;
}), _mutations);

var actions = {
  // 重製藥櫃並且拿取母版序號
  resetAndGetLocalSerialNumber: function resetAndGetLocalSerialNumber(_ref) {
    var dispatch = _ref.dispatch,
        rootState = _ref.rootState;

    rootState.connectionStatus = false;
    dispatch('submitCommand', {
      command: 'reset'
    });
  },

  // 掃描系統layout
  sendScanLocalLayoutCommand: function sendScanLocalLayoutCommand(_ref2) {
    var dispatch = _ref2.dispatch,
        rootState = _ref2.rootState;

    rootState.systemLayoutChecked = false;
    dispatch('submitCommand', {
      command: 'get_layout'
    });
  },
  initSystem: function initSystem(_ref3) {
    var _this = this;

    var dispatch = _ref3.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dispatch('getSystemId');

            case 2:
              _context.next = 4;
              return dispatch('getSystemInfo');

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  // 用母版序號去索取系統ID
  getSystemId: function getSystemId(_ref4) {
    var rootState = _ref4.rootState;

    return __WEBPACK_IMPORTED_MODULE_9_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */] + '/api/system/', { params: { series: rootState.cabinetSerials[0] } }).then(function (res) {
      state.systemId = res.data.results[0].id;
      rootState.connectionStatus = true;
    });
  },

  // init attribute for view usage.
  getSystemInfo: function getSystemInfo(_ref5) {
    var state = _ref5.state,
        commit = _ref5.commit,
        rootState = _ref5.rootState;

    rootState.apps.management.functions.lockBox.ready = false;
    return __WEBPACK_IMPORTED_MODULE_9_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */] + '/api/system/' + state.systemId + '/').then(function (res) {
      var systemCount = 1;
      state.systems = {}; // for child cabinets. sorry for the misleading variable name...
      state.systemArea = res.data.area;
      state.currentSystem = res.data;
      // 其他子藥櫃會用各自的板子序號當作key, 放置各自的資料
      state.systems[res.data.series] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, res.data);
      state.systems[res.data.series].net_set = [];
      state.systems[res.data.series].relative_index = systemCount;

      rootState.generalSetting = res.data.settings;
      rootState.generalSetting.return_reason = res.data.settings.return_reason.split(';');

      // if the setting of return drug to original device is true, then we do not need to show 'recycleDrug' and 'setReturnBox' app
      rootState.apps.management.functions.recycleDrug.privilege = !rootState.generalSetting.return_to_original_cmpn;
      rootState.apps.setting.functions.setReturnBox.privilege = !rootState.generalSetting.return_to_original_cmpn;

      state.currentSystem.net_set.forEach(function (net) {
        // net.selectedDeviceCount = 0;
        if (state.systems[net.system_serial] === undefined) {
          state.systems[net.system_serial] = {};
          state.systems[net.system_serial].net_set = [];
          state.systems[net.system_serial].relative_index = systemCount + 1;
          systemCount += 1;
        }
        state.systems[net.system_serial].net_set.push(net);
        net.hasDeviceSelected = false;
        net.show_row = false;
        var deviceCount = 0;
        net.device_set.forEach(function (device) {
          device.selected = false;
          device.index = deviceCount;
          device.drugstorage_set.forEach(function (item) {
            item.selected = false;
            var itemExpiredDate = __WEBPACK_IMPORTED_MODULE_7_moment___default()(item.expired_date);
            var today = __WEBPACK_IMPORTED_MODULE_7_moment___default()();
            var remainDays = itemExpiredDate.diff(today, 'days');
            item.expired = remainDays < 0; // https://eslint.org/docs/rules/no-unneeded-ternary
          });
          state.allDevices[device.id] = device;
          deviceCount += 1;
        });
      });
      rootState.apps.management.functions.lockBox.ready = true;
    });
  },

  /**
   * open drawer or device from state.currentDevice
   * @param {*} param0 vuex attribute
   */
  openDevice: function openDevice(_ref6, id) {
    var state = _ref6.state,
        dispatch = _ref6.dispatch,
        rootState = _ref6.rootState;

    var targetDevice = void 0;
    if (id !== undefined) {
      targetDevice = state.allDevices[id];
    } else {
      targetDevice = state.allDevices[state.currentDevice.id];
    }
    dispatch('submitCommand', {
      command: 'open_box',
      appendData: [targetDevice.net.system_serial, targetDevice.net.row_id, targetDevice.pos_row, targetDevice.pos_col]
    });
  },

  /**
   * clean out selected device in current system and reset selected item in current system.
   * @param {*} param0 vuex attribute
   */
  emptyDevices: function emptyDevices(_ref7) {
    var state = _ref7.state,
        getters = _ref7.getters;

    state.selectedDevicesID = [];
    state.selectedDevices = {};
    getters.currentSystem.net_set.forEach(function (net) {
      net.device_set.forEach(function (item) {
        item.selected = false;
      });
    });
  }
};

var getters = {
  selectedDevices: function selectedDevices(state, getters) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(state.selectedDevices);
  },
  currentSystem: function currentSystem(state, getters) {
    return state.currentSystem;
  },
  currentDevice: function currentDevice(state, getters) {
    return state.currentDevice;
  },
  systems: function systems(state, getters) {
    return state.systems;
  },
  currentNetIndex: function currentNetIndex(state, getters) {
    return state.currentNetIndex;
  },
  allDevices: function allDevices(state, getters) {
    return state.allDevices;
  }
};

var store = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mutation_types__ = __webpack_require__(74);





var _mutations;

// 主要處理用藥種取藥的流程以及各種與藥種相關的資訊





var state = {
  selectedDrugID: '', // 選擇的藥種ID
  selectedDrug: '', // 選擇的藥種資料
  selectedDrugTotalAmount: 0, // 選擇的藥種總量
  selectedDrugTotalMax: 0, // 選擇的藥物總最大庫存上限(量)
  selectedDrugLowAmountLimitData: null, // 選擇的藥物的安全存量
  drugsForFetch: {}, // 待操作的藥種們
  DrugsForFetchList: [], // 待操作的藥種清單
  currentDrug: null, // 目前操作中的藥種
  nextDrug: null, // 下步驟待操作的藥種
  currentDrugIndex: 0, // 目前操作中的藥種於DrugsForFetchList中的index
  //20190403 add
  doseForHisOutput: 0
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["P" /* RESET_DRUG_MODULE */], function (state) {
  state.selectedDrugID = '';
  state.selectedDrug = '';
  state.selectedDrugTotalAmount = 0;
  state.selectedDrugTotalMax = 0;
  state.selectedDrugLowAmountLimitData = null;
  state.drugsForFetch = {};
  state.DrugsForFetchList = [];
  state.currentDrug = null;
  state.nextDrug = null;
  state.currentDrugIndex = 0;
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["Q" /* SET_CURRENT_DRUG_BY_INDEX */], function (state, index) {
  // 按照系統的由上往下，由外往內排序
  var sortedDrugArray = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.sortBy(state.DrugsForFetchList, ['drugStorage[0].device.net.id', 'drugStorage[0].device.net.row_id', 'drugStorage[0].device.pos_row', 'drugStorage[0].device.relative_col']);
  state.currentDrugIndex = index;
  if (index < sortedDrugArray.length - 1) {
    state.nextDrug = sortedDrugArray[index + 1];
  } else {
    state.nextDrug = null;
  }
  state.currentDrug = sortedDrugArray[index];
}), _mutations);

var actions = {
  /**
   * major function for selecting drug.
   * @param {*} param0 vuex attribute
   * @param {*} drugID selected drug id
   */
  setDrug: function setDrug(_ref, drugID) {
    var _this = this;

    var dispatch = _ref.dispatch,
        state = _ref.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log('set drug ', drugID);
              _context.next = 3;
              return dispatch('setCurrentDrug', drugID);

            case 3:
              _context.next = 5;
              return dispatch('getTotalDrugAmountInstanly', drugID);

            case 5:
              _context.next = 7;
              return dispatch('getLowAmountLimitData', drugID);

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  /**
   * get drug info and set it to selected drug.
   * @param {*} param0 vuex attribute
   * @param {*} drugID selected drug id
   */
  setCurrentDrug: function setCurrentDrug(_ref2, drugID) {
    var state = _ref2.state,
        rootState = _ref2.rootState;

    state.selectedDrugID = drugID;
    return rootState.instance.get('/api/medication/' + drugID + '/').then(function (res) {
      state.selectedDrug = res.data;
      console.log('current drug setted');
    });
  },

  /**
   * get total storage amount of selected drug in ADC.
   * @param {*} param0 vuex attribute
   * @param {*} drugID selected drug id
   */
  getTotalDrugAmount: function getTotalDrugAmount(_ref3, drugID) {
    var state = _ref3.state,
        rootState = _ref3.rootState,
        getters = _ref3.getters;

    console.log('get total drug amount: ', drugID);
    if (drugID !== undefined) {
      var drugStorageSameMed = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(getters.drugInDeviceList, function (item) {
        return item.medication.id === drugID;
      });

      state.selectedDrugTotalAmount = 0;
      state.selectedDrugTotalMax = 0;
      drugStorageSameMed.forEach(function (item) {
        // exclude return device.
        if (item.device.specific_type !== 'return_device') {
          state.selectedDrugTotalAmount += item.stock;
          state.selectedDrugTotalMax += item.max_stock;
        }
      });
      return true;
    }
    return undefined;
  },

  // 重新計算藥物的存量
  getTotalDrugAmountInstanly: function getTotalDrugAmountInstanly(_ref4, drugID) {
    var state = _ref4.state,
        rootState = _ref4.rootState,
        getters = _ref4.getters;

    console.log('getTotalDrugAmountInstanly');
    return rootState.instance.get('/api/drug-storage/', {
      params: {
        medication: drugID,
        device__net__system: rootState.device.systemId
      }
    }).then(function (res) {
      var filteredList = [];
      state.selectedDrugTotalAmount = 0;
      state.selectedDrugTotalMax = 0;
      res.data.results.forEach(function (item) {
        var theExpiredDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()(item.expired_date);
        var todayDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()();
        var remainExpiredDays = theExpiredDate.diff(todayDate, 'days');
        if (remainExpiredDays >= 0 && item.device.specific_type !== 'return_device') {
          state.selectedDrugTotalAmount += item.stock;
          state.selectedDrugTotalMax += item.max_stock;
        }
      });
    });
  },

  // 取得安全存量
  getLowAmountLimitData: function getLowAmountLimitData(_ref5, drugID) {
    var state = _ref5.state,
        rootState = _ref5.rootState;

    return rootState.instance.get('/api/total-storage-in-system/', {
      params: {
        medication: drugID
      }
    }).then(function (res) {
      // there should be only one data. should implement system information in the future.
      state.selectedDrugLowAmountLimitData = res.data.results[0];
    });
  },

  // 設定待取藥種清單
  setDrugListForFetch: function setDrugListForFetch(_ref6, data) {
    var state = _ref6.state,
        commit = _ref6.commit,
        getters = _ref6.getters;

    console.log('setDrugListForFetch', data);
    var drugStorage = null;
    if (data.drugStorage) {
      drugStorage = data.drugStorage;
    } else {
      drugStorage = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(getters.drugInDeviceList, function (drugStorage) {
        return drugStorage.medication.id === data.med.id && drugStorage.stock > 0;
      });
    }
    // sort it by  最接近過期 > 散裝量最多
    //drugStorage = _.orderBy(drugStorage, [(o) => { return new Date(o.expired_date); }, (o) => { return o.stock - (o.medication.pack_content * o.pack_count); }], ['asc', 'desc']);
    //20190524
    // sort it by  最接近過期 > 散裝量最小
    drugStorage = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(drugStorage, [function (o) {
      return new Date(o.expired_date);
    }, function (o) {
      return o.stock - o.medication.pack_content * o.pack_count;
    }], ['asc', 'asc']);
    if (data.select) {
      state.drugsForFetch[data.med.id] = {
        med: data.med,
        drugStorage: drugStorage,
        dose: data.dose,
        doseUnit: data.doseUnit,
        amount: data.amount || 0
      };
      //20140403
      state.doseForHisOutput = data.dose;
    } else {
      delete state.drugsForFetch[data.med.id];
    }
    state.DrugsForFetchList = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(state.drugsForFetch);
  },

  // 從第一個藥種開始動作
  fromFirstDrug: function fromFirstDrug(_ref7) {
    var _this2 = this;

    var state = _ref7.state,
        commit = _ref7.commit,
        dispatch = _ref7.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit('SET_CURRENT_DRUG_BY_INDEX', 0);
              commit('SET_SELECTED_DRUG_IN_DEVICE_DIRECTLY', state.currentDrug.drugStorage);
              _context2.next = 4;
              return dispatch('fromFirstDrugInDevice');

            case 4:
              console.log('nextDrug: ', state.nextDrug);
              if (state.nextDrug) {
                commit('SET_NEXT_DRUG_IN_DEVICE', state.nextDrug.drugStorage[0].id);
                commit('SET_NEXT_DEVICE', state.nextDrug.drugStorage[0].device.id);
              }

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },

  // 準備下一個藥種
  toNextDrug: function toNextDrug(_ref8) {
    var _this3 = this;

    var state = _ref8.state,
        commit = _ref8.commit,
        dispatch = _ref8.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit('SET_CURRENT_DRUG_BY_INDEX', state.currentDrugIndex + 1);
              commit('SET_SELECTED_DRUG_IN_DEVICE_DIRECTLY', state.currentDrug.drugStorage);
              _context3.next = 4;
              return dispatch('fromFirstDrugInDevice');

            case 4:
              console.log('nextDrug: ', state.nextDrug);
              if (state.nextDrug) {
                commit('SET_NEXT_DRUG_IN_DEVICE', state.nextDrug.drugStorage[0].id);
                commit('SET_NEXT_DEVICE', state.nextDrug.drugStorage[0].device.id);
              }

            case 6:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  }
};

var getters = {
  selectedDrugLowAmountLimitData: function selectedDrugLowAmountLimitData(state, getters) {
    return state.selectedDrugLowAmountLimitData;
  },
  selectedDrugID: function selectedDrugID(state, getters) {
    return state.selectedDrugID;
  },
  selectedDrugTotalMax: function selectedDrugTotalMax(state) {
    return state.selectedDrugTotalMax;
  },
  selectedDrug: function selectedDrug(state) {
    return state.selectedDrug;
  },
  drugsForFetch: function drugsForFetch(state) {
    return state.drugsForFetch;
  },
  currentDrug: function currentDrug(state) {
    return state.currentDrug;
  },
  nextDrug: function nextDrug(state) {
    return state.nextDrug;
  }
};

var drugModule = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/* harmony default export */ __webpack_exports__["a"] = (drugModule);

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mutation_types__ = __webpack_require__(74);







var _mutations;

/**
 * drugInDevice is the same thing to DrugStorage in the backend.
 * (I should name them as the same variable name through...)
 * 處理所有跟藥倉相關的流程及資料
 */




var state = {
  selectedDrugInDevice: {}, // 選擇到的藥倉資料們
  selectedDrugInDeviceID: [], // 選擇到的藥倉Ids
  allDrugInDevice: {}, // 所有藥倉
  // other types of drugInDevices
  expiredDrugInDevice: [], // 過期的藥倉
  drugInDeviceLowStockList: [], // 低於安全存量的藥倉
  RefillDrugInDeviceList: [], // 補藥清單內的藥倉
  //
  sortedSelectedDrugInDevice: [], // 排序過的選擇藥倉清單
  sortedSelectedDrugInDeviceIndex: 0, // 目前操作的藥倉index (在排序過的選擇藥倉清單中)
  currentDrugInDevice: null, // 目前操作的藥倉
  currentDrugInDeviceIndex: 0, // 目前操作的藥倉index (在排序過得選擇藥倉清單中)
  nextDrugInDevice: null, // 下一步驟操作的藥倉
  drugInDeviceList: [], // 原始的藥倉清單
  copyDrugInDeviceList: [], // 複製的藥倉清單
  filterDrugInDeviceList: [], // 篩選過後的藥倉清單
  //
  DrugStorageWithSameDrug: {}, // 同種藥物的藥倉們
  DrugStorageWithSameDrugID: [], // 同種藥物的藥倉ids
  expiredDrugCount: 0, // 過期的藥倉數量
  graduallyExpiredDrugCount: 0, // 即期的藥倉清單
  storageErrorCount: 0, // 存量不符數量
  storageError: [], // 存量不符事件
  //
  drugStorageChangedId: undefined, // 於前台改變的藥倉
  drugStorageChangedTime: 0, // 藥倉改變的次數
  hasUsedDrugStorageId: [], // 已使用過的藥倉
  //
  medicationCount: {} // 根據藥種計算數量
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["v" /* RESET_DRUG_IN_DEVICE_MODULE */], function (state) {
  state.selectedDrugInDevice = {};
  state.selectedDrugInDeviceID = [];
  state.sortedSelectedDrugInDevice = [];
  state.sortedSelectedDrugInDeviceIndex = 0;
  state.currentDrugInDevice = null;
  state.drugInDeviceList = [];
  state.copyDrugInDeviceList = [];
  state.drugInDeviceLowStockList = [];
  state.expiredDrugInDevice = [];
  state.filterDrugInDeviceList = [];
  state.RefillDrugInDeviceList = [];
  state.nextDrugInDevice = null;
  state.DrugStorageWithSameDrug = {};
  state.expiredDrugCount = 0;
  state.storageErrorCount = 0;
  state.graduallyExpiredDrugCount = 0;
  state.storageError = [];
  state.hasUsedDrugStorageId = [];
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["w" /* SET_DRUG_IN_DEVICE_LIST */], function (state, drugInDeviceList) {
  // sort the list according to device position.
  var list = drugInDeviceList.length > 0 ? __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.sortBy(drugInDeviceList, ['device.net.id', 'device.net.row_id', 'device.pos_row', 'device.relative_col']) : [];
  state.drugInDeviceList = list;
  state.copyDrugInDeviceList = list;
  state.filterDrugInDeviceList = list;
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["x" /* SELECT_DRUG_IN_DEVICES_FROM_SELECTED */], function (state, drugInDeviceId) {
  var drugInDevice = state.allDrugInDevice[drugInDeviceId];
  if (state.selectedDrugInDevice[drugInDeviceId] === undefined) {
    state.selectedDrugInDevice[drugInDeviceId] = drugInDevice;
  } else {
    delete state.selectedDrugInDevice[drugInDeviceId];
  }
  state.selectedDrugInDeviceID = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(state.selectedDrugInDevice);

  // sort by device id each selection.
  var unsortedList = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(state.selectedDrugInDevice);
  state.sortedSelectedDrugInDevice = unsortedList.length > 0 ? __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.sortBy(unsortedList, ['device.net.id', 'device.net.row_id', 'device.pos_row', 'device.relative_col']) : [];
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["y" /* SELECT_DRUG_IN_DEVICES_FROM_ALL */], function (state, drugInDeviceId) {
  state.currentDrugInDevice = state.allDrugInDevice[drugInDeviceId];
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["z" /* SET_CURRENT_DRUG_IN_DEVICE */], function (state, drugInDeviceId) {
  state.currentDrugInDevice = state.allDrugInDevice[drugInDeviceId];
  state.currentDrugInDeviceIndex = state.sortedSelectedDrugInDevice.findIndex(function (o) {
    return o.id === drugInDeviceId;
  }); // since the return index start from 1
  console.log('state.currentDrugInDeviceIndex', state.currentDrugInDeviceIndex);
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["A" /* SET_NEXT_DRUG_IN_DEVICE */], function (state, drugInDeviceId) {
  if (drugInDeviceId === null) {
    state.nextDrugInDevice = null;
  } else {
    state.nextDrugInDevice = state.allDrugInDevice[drugInDeviceId];
  }
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["B" /* FILTER_DRUG_IN_DEVICE */], function (state, payload) {
  switch (payload.mode) {
    case 'lowStock':
      state.drugInDeviceList = state.drugInDeviceLowStockList;
      break;
    case 'refill':
      state.drugInDeviceList = state.RefillDrugInDeviceList;
      break;
    case '':
      state.drugInDeviceList = state.copyDrugInDeviceList;
      break;
    default:
      state.drugInDeviceList = state.copyDrugInDeviceList;
  }
  if (payload.searchText !== '') {
    state.filterDrugInDeviceList = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.filter(state.drugInDeviceList, function (item) {
      var hasGenericName = item.medication.generic_name.toLowerCase().indexOf(payload.searchText.toLowerCase()) > -1;
      var hasCGMHNumber = item.medication.CGMH_number.toLowerCase().indexOf(payload.searchText.toLowerCase()) > -1;
      var hasCode = item.medication.code.toLowerCase().indexOf(payload.searchText.toLowerCase()) > -1;
      return hasGenericName || hasCGMHNumber || hasCode;
    });
  } else {
    state.filterDrugInDeviceList = state.drugInDeviceList;
  }
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["C" /* SET_SELECTED_DRUG_IN_DEVICE_DIRECTLY */], function (state, drugInDeviceListSortedByCustom) {
  // sortedSelectedDrugInDevice were only access in "SELECT_DRUG_IN_DEVICES_FROM_SELECTED"
  state.sortedSelectedDrugInDevice = drugInDeviceListSortedByCustom;
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["D" /* REMOVE_NEXT_DRUG_IN_DEVICE */], function (state) {
  state.nextDrugInDevice = null;
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["E" /* DRUG_STORAGE_EVENT_FIRED */], function (state, id) {
  state.drugStorageChangedTime += 1;
  state.drugStorageChangedId = id;
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__mutation_types__["F" /* DRUG_IN_DEVICE_USED */], function (state, id) {
  state.hasUsedDrugStorageId.push(id);
  state.hasUsedDrugStorageId = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.uniq(state.hasUsedDrugStorageId);
}), _mutations);

var actions = {
  // get all drugStorage in database, and filter out gradually/expired drugStorage
  getDrugInDevices: function getDrugInDevices(_ref) {
    var state = _ref.state,
        commit = _ref.commit,
        getters = _ref.getters,
        rootState = _ref.rootState;

    // get all drug storage data from server
    return rootState.instance.get('/api/drug-storage/', {
      params: {
        device__net__system: rootState.device.systemId
      }
    }).then(function (res) {
      // reset expired list
      var drugStorageListFiltered = [];
      state.expiredDrugInDevice = [];
      // filtering expired data and drugStroage in return/external device.
      res.data.results.forEach(function (item) {
        var theExpiredDate = __WEBPACK_IMPORTED_MODULE_7_moment___default()(item.expired_date);
        var todayDate = __WEBPACK_IMPORTED_MODULE_7_moment___default()();
        var remainExpiredDays = theExpiredDate.diff(todayDate, 'days');

        // count the all the medication
        if (state.medicationCount[item.medication.id] === undefined) state.medicationCount[item.medication.id] = 0;
        state.medicationCount[item.medication.id] += item.stock;

        item.expired = remainExpiredDays < 0;
        item.selected = false;
        state.allDrugInDevice[item.id] = item;
        if (item.device.specific_type === 'return_device' || item.device.specific_type === 'external_device' || item.device.net === null) {
          // pass here;
        } else {
          // get expired drug storage.
          if (remainExpiredDays < 0) {
            state.expiredDrugInDevice.push(item);
          } else {
            // count gradually expired drugstorage.
            if (remainExpiredDays >= 0 && remainExpiredDays < getters.currentSystem.settings.alert_outdated_day) {
              state.graduallyExpiredDrugCount += 1;
            }
            drugStorageListFiltered.push(item);
          }
        }
      });
      // save the filtered list to state.
      commit('SET_DRUG_IN_DEVICE_LIST', drugStorageListFiltered);
    });
  },

  // select all drugStorage in filterDrugInDeviceList
  selectAllDrugStorageAndDevices: function selectAllDrugStorageAndDevices(_ref2) {
    var state = _ref2.state,
        rootState = _ref2.rootState,
        commit = _ref2.commit;

    state.filterDrugInDeviceList.forEach(function (item) {
      // update selected value for view.
      item.selected = true;
      // instead of recalling "SELECT_DRUG_IN_DEVICES_FROM_SELECTED", directly handle the state date here for faster procedure.
      state.selectedDrugInDevice[item.id] = item;
      // update selected device attr for view updating.
      rootState.device.allDevices[item.device.id].selected = true;
      rootState.device.selectedDevices[item.device.id] = rootState.device.allDevices[item.device.id];
    });
    state.sortedSelectedDrugInDevice = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(state.selectedDrugInDevice), ['device.net.open_times', 'device.net.row_id', 'device.pos_row', 'device.relative_col']);
    rootState.device.selectedDevicesID = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(rootState.device.selectedDevices);
  },

  // unselect all drugStorage in filterDrugInDeviceList
  unSelectAllDrugStorageAndDevices: function unSelectAllDrugStorageAndDevices(_ref3) {
    var state = _ref3.state,
        rootState = _ref3.rootState,
        commit = _ref3.commit;

    // update for view
    state.filterDrugInDeviceList.forEach(function (item) {
      item.selected = false;
      rootState.device.allDevices[item.device.id].selected = false;
    });
    rootState.device.selectedDevices = {};
    rootState.device.selectedDevicesID = [];
    state.selectedDrugInDevice = {};
    state.selectedDrugInDeviceID = [];
    state.sortedSelectedDrugInDevice = [];
  },

  // 選擇所有含有管制藥物的藥倉
  selectAllRestrainedDrugStorage: function selectAllRestrainedDrugStorage(_ref4) {
    var state = _ref4.state,
        rootState = _ref4.rootState,
        commit = _ref4.commit;

    state.filterDrugInDeviceList.forEach(function (item) {
      if (item.medication.restrained_class > 0) {
        // update selected value for view.
        item.selected = true;
        // instead of recalling "SELECT_DRUG_IN_DEVICES_FROM_SELECTED", directly handle the state date here for faster procedure.
        state.selectedDrugInDevice[item.id] = item;
        // update selected device attr for view updating.
        rootState.device.allDevices[item.device.id].selected = true;
        rootState.device.selectedDevices[item.device.id] = rootState.device.allDevices[item.device.id];
      }
    });
    state.sortedSelectedDrugInDevice = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(state.selectedDrugInDevice), ['device.net.open_times', 'device.net.row_id', 'device.pos_row', 'device.relative_col']);
    rootState.device.selectedDevicesID = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(rootState.device.selectedDevices);
  },

  // 選擇所有含有非管制藥的藥倉
  selectAllNormalDrugStorage: function selectAllNormalDrugStorage(_ref5) {
    var state = _ref5.state,
        rootState = _ref5.rootState,
        commit = _ref5.commit;

    state.filterDrugInDeviceList.forEach(function (item) {
      if (item.medication.restrained_class === 0) {
        // update selected value for view.
        item.selected = true;
        // instead of recalling "SELECT_DRUG_IN_DEVICES_FROM_SELECTED", directly handle the state date here for faster procedure.
        state.selectedDrugInDevice[item.id] = item;
        // update selected device attr for view updating.
        rootState.device.allDevices[item.device.id].selected = true;
        rootState.device.selectedDevices[item.device.id] = rootState.device.allDevices[item.device.id];
      }
    });
    state.sortedSelectedDrugInDevice = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(state.selectedDrugInDevice), ['device.net.open_times', 'device.net.row_id', 'device.pos_row', 'device.relative_col']);
    rootState.device.selectedDevicesID = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(rootState.device.selectedDevices);
  },

  // 根據類別選擇藥倉
  selectDrugStorageByGroupId: function selectDrugStorageByGroupId(_ref6, groupId) {
    var state = _ref6.state,
        rootState = _ref6.rootState,
        commit = _ref6.commit;

    state.filterDrugInDeviceList.forEach(function (item) {
      if (item.medication.group.indexOf(groupId) !== -1) {
        // update selected value for view.
        item.selected = true;
        // instead of recalling "SELECT_DRUG_IN_DEVICES_FROM_SELECTED", directly handle the state date here for faster procedure.
        state.selectedDrugInDevice[item.id] = item;
        // update selected device attr for view updating.
        rootState.device.allDevices[item.device.id].selected = true;
        rootState.device.selectedDevices[item.device.id] = rootState.device.allDevices[item.device.id];
      }
    });
    state.sortedSelectedDrugInDevice = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(state.selectedDrugInDevice), ['device.net.open_times', 'device.net.row_id', 'device.pos_row', 'device.relative_col']);
    rootState.device.selectedDevicesID = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(rootState.device.selectedDevices);
  },

  // 選擇藥倉
  selectDrugInDevice: function selectDrugInDevice(_ref7, payload) {
    var dispatch = _ref7.dispatch,
        commit = _ref7.commit,
        state = _ref7.state,
        getters = _ref7.getters;

    if (payload.singleSelection && state.sortedSelectedDrugInDevice.length > 0) {
      state.sortedSelectedDrugInDevice.forEach(function (item) {
        item.selected = !item.selected;
        commit('SELECT_DRUG_IN_DEVICES_FROM_SELECTED', item.id);
      });
    }
    // check other drugStorage exist in this device and compare there status
    var drugInDevice = state.drugInDeviceList[payload.num];
    drugInDevice.selected = !drugInDevice.selected;
    commit('SELECT_DRUG_IN_DEVICES_FROM_SELECTED', drugInDevice.id);

    var isDeviceSelected = false;
    state.sortedSelectedDrugInDevice.forEach(function (item) {
      if (item.device.id === drugInDevice.device.id) {
        isDeviceSelected = isDeviceSelected || item.selected;
      }
    });

    var deviceContained = getters.allDevices[drugInDevice.device.id];
    if (deviceContained.selected !== isDeviceSelected) {
      commit('ADD_DEVICE_TO_SELECTED_LIST', drugInDevice.device.id);
    }
  },

  // 根據位置選擇藥倉
  selectDrugInDeviceByPosSelection: function selectDrugInDeviceByPosSelection(_ref8, payload) {
    var state = _ref8.state,
        commit = _ref8.commit,
        getters = _ref8.getters,
        dispatch = _ref8.dispatch;

    commit('ADD_DEVICE_TO_SELECTED_LIST', payload.deviceId);
    var deviceClicked = getters.allDevices[payload.deviceId];
    // ...deviceClicked.drugstorage_set
    // update view, unify the drugStorage selected status as same as device.
    state.drugInDeviceList.forEach(function (item) {
      if (item.device.id === payload.deviceId) {
        if (item.selected !== deviceClicked.selected) {
          item.selected = deviceClicked.selected;
          commit('SELECT_DRUG_IN_DEVICES_FROM_SELECTED', item.id);
        }
      }
    });
  },

  /**
   * set currentDrugAndDevice from the head of drugStorage list
   * @param {*} param0 vuex attribute
   */
  fromFirstDrugInDevice: function fromFirstDrugInDevice(_ref9) {
    var _this = this;

    var commit = _ref9.commit,
        state = _ref9.state,
        dispatch = _ref9.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log('fromFirstDrugInDevice');
              state.sortedSelectedDrugInDeviceIndex = 0;
              _context.next = 4;
              return dispatch('setCurrentDrugAndDevice', state.sortedSelectedDrugInDeviceIndex);

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  /**
   * set next drugStorage
   * @param {*} param0 vuex attribute
   */
  toNextDrugInDevice: function toNextDrugInDevice(_ref10) {
    var _this2 = this;

    var commit = _ref10.commit,
        state = _ref10.state,
        dispatch = _ref10.dispatch;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              console.log('toNextDrugInDevice');
              state.sortedSelectedDrugInDeviceIndex += 1;
              _context2.next = 4;
              return dispatch('setCurrentDrugAndDevice', state.sortedSelectedDrugInDeviceIndex);

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },

  /**
   * set current device and current drugStorage
   * @param {*} param0 vuex attribute
   * @param {*} index index of selectedDrugInDevice key
   */
  setCurrentDrugAndDevice: function setCurrentDrugAndDevice(_ref11, index) {
    var _this3 = this;

    var commit = _ref11.commit,
        dispatch = _ref11.dispatch,
        state = _ref11.state,
        rootState = _ref11.rootState;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var drugInDevice;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              drugInDevice = state.sortedSelectedDrugInDevice[index];

              console.log('setCurrentDrugAndDevices', index, drugInDevice);
              commit('SET_CURRENT_DRUG_IN_DEVICE', drugInDevice.id);

              // update druginfo
              _context3.next = 5;
              return dispatch('setDrug', drugInDevice.medication.id);

            case 5:

              dispatch('getDrugInDevicesWithSameDrug', drugInDevice.medication.id);
              commit('SET_CURRENT_DEVICE_FROM_ALL', drugInDevice.device.id);
              // set next drugStorage and its device.
              if (state.currentDrugInDeviceIndex !== -1 && state.currentDrugInDeviceIndex + 1 <= state.sortedSelectedDrugInDevice.length - 1) {
                console.log('state.currentDrugInDeviceIndex', state.currentDrugInDeviceIndex);
                commit('SET_NEXT_DRUG_IN_DEVICE', state.sortedSelectedDrugInDevice[state.currentDrugInDeviceIndex + 1].id);
                commit('SET_NEXT_DEVICE', state.nextDrugInDevice.device.id);
              } else {
                commit('REMOVE_NEXT_DRUG_IN_DEVICE');
                commit('REMOVE_NEXT_DEVICE');
              }

            case 8:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },

  // 更新操作的藥倉資料
  updateCurrentDrugInDevice: function updateCurrentDrugInDevice(_ref12, drugInDeviceId) {
    var state = _ref12.state,
        dispatch = _ref12.dispatch,
        rootState = _ref12.rootState;

    console.log('updateCurrentDrugInDevice', drugInDeviceId);
    return rootState.instance.get('/api/drug-storage/' + drugInDeviceId).then(function (res) {
      state.allDrugInDevice[drugInDeviceId] = res.data;
      state.currentDrugInDevice = res.data;
      state.currentDrugInDeviceIndex = state.sortedSelectedDrugInDevice.findIndex(function (o) {
        return o.id === drugInDeviceId;
      }); // since the return index start from 1
      console.log('state.currentDrugInDeviceIndex', state.currentDrugInDeviceIndex);
      dispatch('getTotalDrugAmountInstanly', state.currentDrugInDevice.medication.id);
    });
  },

  // 取得所有同藥種的藥倉
  getDrugInDevicesWithSameDrug: function getDrugInDevicesWithSameDrug(_ref13, medId) {
    var commit = _ref13.commit,
        state = _ref13.state,
        getters = _ref13.getters,
        rootState = _ref13.rootState;

    console.log('dispatch getDrugInDeviceWithSameDrug');
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      console.log('dispath drug in device');
      state.DrugStorageWithSameDrug = {}; // empty the data
      state.DrugStorageWithSameDrugID = [];
      var drugStorageSameMed = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.filter(getters.drugInDeviceList, function (item) {
        return item.medication.id === medId && item.stock > 0;
      });
      // sort the list by expired_date and has_piece, 領藥條件： 最接近過期 > 散裝量最多
      //drugStorageSameMed = _.orderBy(drugStorageSameMed, [(o) => { return new Date(o.expired_date); }, (o) => { return o.stock - (o.medication.pack_content * o.pack_count); }], ['asc', 'desc']);
      //20190524
      // sort the list by expired_date and has_piece, 領藥條件： 最接近過期 > 散裝量最小
      drugStorageSameMed = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.orderBy(drugStorageSameMed, [function (o) {
        return new Date(o.expired_date);
      }, function (o) {
        return o.stock - o.medication.pack_content * o.pack_count;
      }], ['asc', 'asc']);
      drugStorageSameMed.forEach(function (item) {
        state.DrugStorageWithSameDrug[item.id] = item;
        state.DrugStorageWithSameDrugID.push(item.id);
      });
      console.log(drugStorageSameMed);
      resolve();
    });
  },

  // 取得所有補藥規劃的藥倉
  getRefillOrder: function getRefillOrder(_ref14) {
    var commit = _ref14.commit,
        rootState = _ref14.rootState,
        state = _ref14.state;

    return rootState.instance.get('/api/refill-order/', {
      params: {
        drug_storage__device__net__system: rootState.device.systemId
      }
    }).then(function (res) {
      state.RefillDrugInDeviceList = [];
      res.data.forEach(function (item) {
        var drugStorage = item.drug_storage;
        drugStorage.selected = false;
        drugStorage.refillId = item.id;
        state.RefillDrugInDeviceList.push(drugStorage);
      });
    });
  },

  // 取得所有低於安全存量的藥倉
  getLowStockDrugInDevice: function getLowStockDrugInDevice(_ref15) {
    var state = _ref15.state,
        rootState = _ref15.rootState;

    state.drugInDeviceLowStockList = [];
    return rootState.instance.get('/api/low-stock-drug-storage/', {
      params: {
        device__net__system: rootState.device.systemId
      }
    }).then(function (res) {
      res.data.forEach(function (item) {
        item.selected = false;
        var theExpiredDate = __WEBPACK_IMPORTED_MODULE_7_moment___default()(item.expired_date);
        var todayDate = __WEBPACK_IMPORTED_MODULE_7_moment___default()();
        var remainExpiredDays = theExpiredDate.diff(todayDate, 'days');
        if (remainExpiredDays >= 0) {
          state.drugInDeviceLowStockList.push(item);
        }
      });
    });
  }
};

var getters = {
  selectedDrugInDeviceID: function selectedDrugInDeviceID(state, getters) {
    return state.selectedDrugInDeviceID;
  },
  currentDrugInDevice: function currentDrugInDevice(state, getters) {
    return state.currentDrugInDevice;
  },
  hasUsedDrugStorageId: function hasUsedDrugStorageId(state, getters) {
    return state.hasUsedDrugStorageId;
  },
  storageError: function storageError(state, getters) {
    return state.storageError;
  },
  drugInDeviceList: function drugInDeviceList(state) {
    return state.drugInDeviceList;
  },
  DrugStorageWithSameDrugID: function DrugStorageWithSameDrugID(state) {
    return state.DrugStorageWithSameDrugID;
  },
  drugStorageChangeTime: function drugStorageChangeTime(state) {
    return state.drugStorageChangeTime;
  }
};

var store = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mutation_types__ = __webpack_require__(74);






var _mutations;

/**
 * module for handleing events
 */



var state = {
  selectedEventId: [],
  selectedEvent: {},
  currentEvent: {},
  currentEventIndex: 0,
  nextEvent: null,
  nextEventId: null,
  eventPayload: '',
  events: [],
  backupEvents: [],
  medRecordNo: undefined
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["r" /* RESET_EVENT_MODULE */], function (state) {
  state.selectedEventId = [];
  state.selectedEvent = {};
  state.currentEvent = {};
  state.nextEvent = {};
  state.nextEventId = '';
  state.eventPayload = '';
  state.events = [];
  state.backupEvents = [];
  state.medRecordNo = undefined;
}), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["s" /* SET_CURRENT_EVENT */], function (state, eventId) {
  state.currentEvent = state.selectedEvent[eventId];
  // set next event
  var thisIndex = state.selectedEventId.indexOf(eventId);
  state.currentEventIndex = thisIndex;
  if (thisIndex + 1 !== state.selectedEventId.length) {
    state.nextEventId = state.selectedEventId[thisIndex + 1];
    state.nextEvent = state.selectedEvent[state.nextEventId];
  } else {
    state.nextEvent = null;
    state.nextEventId = undefined;
  }
}), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["t" /* FILTER_EVENTS */], function (state, searchText) {
  if (searchText !== '') {
    state.events = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.filter(state.backupEvents, function (item) {
      var hasGenericName = item.medication.generic_name.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
      var hasCGMHNumber = item.medication.CGMH_number.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
      var hasCode = item.medication.code.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
      return hasGenericName || hasCGMHNumber || hasCode;
    });
  } else {
    state.events = state.backupEvents;
  }
}), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["u" /* SET_MED_RECORD_NO */], function (state, val) {
  state.medRecordNo = val;
}), _mutations);

var actions = {
  unSelectAllEvent: function unSelectAllEvent(_ref) {
    var state = _ref.state;

    state.selectedEventId = [];
    state.selectedEvent = {};
  },

  /**
   * select event with given id.
   * @param {*} param0 vuex attribute
   * @param {*} eventId event object id
   */
  selectEvent: function selectEvent(_ref2, payload) {
    var _this = this;

    var state = _ref2.state,
        rootState = _ref2.rootState;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var index;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log(payload);
              if (payload.singleSelection) {
                state.events.forEach(function (event) {
                  event.selected = false;
                });
                state.selectedEvent = {};
                state.selectedEventId = [];
              }

              index = state.selectedEventId.indexOf(payload.eventId.toString());

              state.events.forEach(function (event) {
                if (event.id === payload.eventId) event.selected = !event.selected;
              });

              if (!(index !== -1)) {
                _context.next = 9;
                break;
              }

              state.selectedEventId.splice(index, 1);
              delete state.selectedEvent[payload.eventId];
              _context.next = 13;
              break;

            case 9:
              // add id
              state.selectedEventId.push(payload.eventId);
              // add event
              console.log(payload.eventId);
              _context.next = 13;
              return rootState.instance.get('/api/event/' + payload.eventId + '/').then(function (res) {
                var data = res.data;
                state.selectedEvent[payload.eventId] = res.data;
                state.selectedEventId = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state.selectedEvent);
              });

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  /**
   * query event api with given payload, ex: checked=True, ...
   * @param {*} param0 vuex attribute
   * @param {*} eventPayload payload for query
   */
  getEvents: function getEvents(_ref3, eventPayload) {
    var commit = _ref3.commit,
        rootState = _ref3.rootState;

    state.eventPayload = eventPayload;
    return rootState.instance.get('/api/event/', {
      params: eventPayload
    }).then(function (res) {
      // create "selected" attribute for css.
      var data = res.data.results;
      data.forEach(function (element) {
        element.selected = false;
      });
      state.events = data;
      state.backupEvents = data;
    });
  },

  /**
   * use event Id to set current drugStorage and current device.
   * @param {*} param0 vuex attribute
   * @param {*} eventId event object id
   */
  setCurrentEvent: function setCurrentEvent(_ref4, eventId) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch,
        state = _ref4.state;

    var event = state.selectedEvent[eventId];
    console.log(event);
    commit('SET_CURRENT_EVENT', eventId);
    dispatch('setDrug', event.medication.id);
    commit('SET_CURRENT_DEVICE_FROM_ALL', parseInt(event.device.id, 10));
    commit('SELECT_DRUG_IN_DEVICES_FROM_ALL', event.drug_storage);
    if (state.nextEventId) {
      commit('SET_NEXT_DEVICE', state.selectedEvent[state.nextEventId].device.id);
      commit('SET_NEXT_DRUG_IN_DEVICE', state.selectedEvent[state.nextEventId].drug_storage);
    } else {
      commit('REMOVE_NEXT_DEVICE');
      commit('REMOVE_NEXT_DRUG_IN_DEVICE');
    }
  },
  fromFirstEvent: function fromFirstEvent(_ref5) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch,
        state = _ref5.state;

    var firstEventId = state.selectedEventId[0];
    dispatch('setCurrentEvent', firstEventId);
  },

  /**
   * set next event and its drugStorage and device
   * @param {*} param0 vuex attribute
   */
  toNextEvent: function toNextEvent(_ref6) {
    var _this2 = this;

    var commit = _ref6.commit,
        dispatch = _ref6.dispatch,
        state = _ref6.state;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch('setCurrentEvent', state.nextEventId);

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  refineSelectedEvents: function refineSelectedEvents(_ref7) {
    var commit = _ref7.commit,
        state = _ref7.state;

    var uniqueDeviceIds = {};
    var refineEvents = {};
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(state.selectedEvent).forEach(function (event) {
      if (uniqueDeviceIds[event.device.id]) {
        var eventId = uniqueDeviceIds[event.device.id];
        refineEvents[eventId].sameDeviceEvent.push(event);
        // accumulate `number1`;
        refineEvents[eventId].number1 += event.number1;
      } else {
        refineEvents[event.id] = event;
        refineEvents[event.id].sameDeviceEvent = [];
        refineEvents[event.id].sameDeviceEvent.push(event); // push self in.
        uniqueDeviceIds[event.device.id] = event.id;
      }
    });
    state.selectEvent = refineEvents;
    state.selectedEventId = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(refineEvents);
  },
  selectAllEventItems: function selectAllEventItems(_ref8) {
    var state = _ref8.state;

    state.events.forEach(function (event) {
      event.selected = true;
      state.selectedEventId.push(event.id);
      state.selectedEvent[event.id] = event;
    });
  },
  unSelectAllEventItems: function unSelectAllEventItems(_ref9) {
    var state = _ref9.state;

    state.selectedEventId = [];
    state.selectedEvent = {};
    state.events.forEach(function (event) {
      if (event.selected) {
        event.selected = false;
      }
    });
  },
  recordAction: function recordAction(_ref10, payload) {
    var state = _ref10.state,
        rootState = _ref10.rootState,
        getters = _ref10.getters;

    // const drugStorageId = (getters.currentDrugInDevice !== null ? getters.currentDrugInDevice.id : null);
    var drugStorageId = rootState.drugInDevice.currentDrugInDevice !== null ? rootState.drugInDevice.currentDrugInDevice.id : undefined;
    var number2 = payload.number2 ? payload.number2 : undefined;
    var number1 = payload.number1 ? payload.number1 : undefined;
    return rootState.instance.post('/api/event/', {
      drugStorage: drugStorageId,
      employee: rootState.user.user.id,
      event_type: payload.eventType,
      number1: number1,
      number2: number2,
      med_record_no: state.medRecordNo,
      system: rootState.device.systemId
    });
  }
};

var store = {
  state: state,
  mutations: mutations,
  actions: actions
};

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_qrcode__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_qrcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_qrcode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mutation_types__ = __webpack_require__(74);




var _mutations;





//import $ from 'jquery';


var state = {
  scheduleToday: {},
  currentSchedule: null,
  comboMedSet: []
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["m" /* RESET_SCHEDULE */], function (state) {
  state.scheduleToday = {};
  state.currentSchedule = null;
  state.comboMedSet = [];
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["n" /* SET_TODAY_SCHEDULE */], function (state, data) {
  data.forEach(function (d) {
    state.scheduleToday[d.id] = d;
  });
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["o" /* SET_CURRENT_SCHEDULE_BY_ID */], function (state, id) {
  state.currentSchedule = state.scheduleToday[id];
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["p" /* SET_CURRENT_SCHEDULE_DIRECTLY */], function (state, data) {
  state.currentSchedule = data;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["q" /* SET_SCHEDULE_MED_LIST */], function (state, data) {
  state.scheduleMedList = data;
}), _mutations);

var actions = {
  getSchedule: function getSchedule(_ref, date) {
    var commit = _ref.commit,
        rootState = _ref.rootState;

    return rootState.instance.get('/api/schedule/', {
      params: {
        date: date,
        hidden: false,
        bed__ward__area: rootState.device.systemArea.id
      }
    }).then(function (res) {
      // res.data.sort((a, b) => {
      //   const date1 = new Date(a.time);
      //   const date2 = new Date(b.time);
      //   return date1 - date2;
      // });

      res.data.results.forEach(function (item) {
        // item.selected = false;
        if (item.fetch_event.length > 0) {
          item.fetched = true;
        } else {
          item.fetched = false;
        }
      });
      commit('SET_TODAY_SCHEDULE', res.data.results);
    });
  },

  //20190516 add by aaron
  getOperatingRoomSchedule: function getOperatingRoomSchedule(_ref2) {
    var commit = _ref2.commit,
        rootState = _ref2.rootState;

    return rootState.instance.get('/api/operating-room-schedule/', {
      params: {
        hidden: false
      }
    }).then(function (res) {
      commit('SET_TODAY_SCHEDULE', res.data.results);
    });
  },
  getTodaySchedule: function getTodaySchedule(_ref3) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch,
        rootState = _ref3.rootState;

    return dispatch('getSchedule', __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD'));
  },
  getYesterdaySchedule: function getYesterdaySchedule(_ref4) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch,
        rootState = _ref4.rootState;

    return dispatch('getSchedule', __WEBPACK_IMPORTED_MODULE_5_moment___default()().subtract(1, 'days').format('YYYY-MM-DD'));
  },
  getComboMedSet: function getComboMedSet(_ref5) {
    var state = _ref5.state,
        getters = _ref5.getters,
        rootState = _ref5.rootState;

    return rootState.instance.get('/api/combo-medication-set/', {
      params: {
        parent_medication: state.currentSchedule.medication.id
      }
    }).then(function (res) {
      res.data.forEach(function (item) {
        item.selected = false;
        item.fetched = false;
        item.drugInDevice = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(getters.drugInDeviceList, function (drugStorage) {
          return drugStorage.medication.id === item.child_medication.id && drugStorage.stock > 0;
        });
        item.amountInSystem = 0;
        item.drugInDevice.forEach(function (d) {
          item.amountInSystem += d.stock;
        });
      });
      state.comboMedSet = res.data;
    });
  },
  selectComboMed: function selectComboMed(_ref6, payload) {
    var state = _ref6.state,
        commit = _ref6.commit,
        dispatch = _ref6.dispatch;

    state.comboMedSet.forEach(function (item) {
      if (item.child_medication.id === payload.med.id) {
        item.selected = payload.select;
      }
    });
    dispatch('setDrugListForFetch', payload);
  },
  startSchedulMed: function startSchedulMed(_ref7) {
    var state = _ref7.state,
        commit = _ref7.commit;

    var drugStorageList = [];
    commit('SET_SCHEDULE_MED_LIST', __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(state.selectedMed), ['drugStorage.device.net.id', 'drugStorage.device.net.row_id', 'drugStorage.device.pos_row', 'drugStorage.device.relative_col']));
    state.scheduleMedList.forEach(function (med) {
      drugStorageList.push(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.sortBy(med.drugStorage, [function (o) {
        return __WEBPACK_IMPORTED_MODULE_5_moment___default()(o.expired_date);
      }])[0]);
    });
    commit('SET_SELECTED_DRUG_IN_DEVICE_DIRECTLY', drugStorageList);
    console.log(drugStorageList);
  },
  setCurrentScheduleById: function setCurrentScheduleById(_ref8, id) {
    var state = _ref8.state,
        commit = _ref8.commit,
        rootState = _ref8.rootState;

    return rootState.instance.get('/api/schedule/' + id).then(function (res) {
      state.currentSchedule = res.data;
    }).catch(function (err) {
      commit('SET_MESSAGE', {
        type: 'error',
        context: '找不到此排程'
      });
    });
  },
  printQR: function printQR(_ref9, fetchItem) {
    var state = _ref9.state,
        rootState = _ref9.rootState,
        getters = _ref9.getters;

    // printer setting for TM-T82II, MediaSize: 56mm*60mm, PaperReducion: Top margin
    var QRCanvas = document.createElement('canvas');
    __WEBPACK_IMPORTED_MODULE_6_qrcode___default.a.toCanvas(QRCanvas, '***THC-schedule: ' + state.currentSchedule.id + '***', function (error) {
      if (error) console.error(error);
      console.log('success');
    });
    var CGMHQRCanvas = document.createElement('canvas');
    __WEBPACK_IMPORTED_MODULE_6_qrcode___default.a.toCanvas(CGMHQRCanvas, '' + state.currentSchedule.seq_number, function (error) {
      if (error) console.error(error);
      console.log('success');
    });
    var printWindow = window.open('', 'PRINT', 'height=300,width=400');
    var divMain = document.createElement('div');
    var divLeft = document.createElement('div');
    var divRight = document.createElement('div');
    var divQRwrapper = document.createElement('div');
    var divCGMHQRwrapper = document.createElement('div');
    var schedule = document.createElement('p');
    var scheduleBirthday = document.createElement('p');
    var medRecordNum = document.createElement('p');
    var scheduleTime = document.createElement('p');
    var bed = document.createElement('p');
    var medSet = document.createElement('p');
    var logo = document.createElement('img');
    // style setting
    schedule.style = 'margin: 0';
    scheduleBirthday.style = 'margin: 0';
    medRecordNum.style = 'margin: 0';
    scheduleTime.style = 'margin: 0';
    medSet.style = 'margin: 0';
    bed.style = 'margin: 0';
    // logo.src = '../../assets/img/autoIX_logo.png';
    // logo.width = 180;
    QRCanvas.style.width = '80px';
    QRCanvas.style.height = '80px';
    CGMHQRCanvas.style.width = '80px';
    CGMHQRCanvas.style.height = '80px';
    // console.log(logo);

    if (state.currentSchedule.patient.name) schedule.innerText = state.currentSchedule.patient.name;
    if (state.currentSchedule.patient.birthday) scheduleBirthday.innerText = __WEBPACK_IMPORTED_MODULE_5_moment___default()(state.currentSchedule.patient.birthday).format('YYYY/MM/DD');
    //if (state.currentSchedule.bed) bed.innerText = `床號：${state.currentSchedule.bed.ward.name}${state.currentSchedule.bed.code}`;
    //20190516 modified
    if (state.currentSchedule.bed) {
      if (state.currentSchedule.bed.ward) {
        bed.innerText = '\u5E8A\u865F\uFF1A' + state.currentSchedule.bed.ward.name + state.currentSchedule.bed.code;
      } else {
        bed.innerText = '\u5E8A\u865F\uFF1A' + state.currentSchedule.bed.code;
      }
    }
    medRecordNum.innerHTML = state.currentSchedule.patient.med_record_number;
    var t = new Date(state.currentSchedule.time);
    console.log(t);
    console.log(__WEBPACK_IMPORTED_MODULE_5_moment___default()(t).format('YYYYMMDD'));
    console.log(__WEBPACK_IMPORTED_MODULE_5_moment___default()(t).format('HHmm'));
    scheduleTime.innerHTML = new Date(t).toLocaleDateString();
    if (state.currentSchedule.medication) medSet.innerHTML = state.currentSchedule.medication.generic_name;
    // printWindow.document.write(`<p>${this.currentSchedule.patient.med_record_number}</p>`);
    printWindow.document.body.appendChild(divMain);
    divMain.appendChild(divLeft);
    divMain.appendChild(divRight);

    if (state.currentSchedule.seq_number !== null) {
      var canvasTitle = document.createElement('p');
      canvasTitle.innerText = '工作車條碼';
      canvasTitle.style = 'margin: 0px';
      divQRwrapper.appendChild(canvasTitle);
      divQRwrapper.appendChild(CGMHQRCanvas);
    }

    var ADCcanvasTitle = document.createElement('p');
    ADCcanvasTitle.innerText = '藥櫃條碼';
    ADCcanvasTitle.style = 'margin: 0px';
    divCGMHQRwrapper.appendChild(ADCcanvasTitle);
    divCGMHQRwrapper.appendChild(QRCanvas);

    divRight.appendChild(divQRwrapper);
    divRight.appendChild(divCGMHQRwrapper);
    // divLeft.appendChild(logo);
    divLeft.appendChild(schedule);
    divLeft.appendChild(scheduleBirthday);
    divLeft.appendChild(medRecordNum);
    divLeft.appendChild(medSet);
    divLeft.appendChild(bed);
    divLeft.appendChild(scheduleTime);
    // printWindow.document.body.appendChild(document.createElement('hr'));

    for (var i = 0; i < fetchItem.length; i += 1) {
      var drugForFetch = fetchItem[i];
      var item = document.createElement('div');
      var itemInfo = document.createElement('div');
      itemInfo.innerText = drugForFetch.med.generic_name + ' - ' + drugForFetch.dose + ' ' + drugForFetch.doseUnit;
      item.appendChild(itemInfo);
      item.style = 'font-size: 12px;width: 100%; text-align: left';
      itemInfo.style = 'padding-left: 1rem';
      printWindow.document.body.appendChild(item);
    }

    printWindow.document.body.style = 'text-align: center; display: flex; flex-direction: column; align-items: center;';
    divMain.style = 'display: flex';
    divLeft.style = 'text-align: center; display: flex; flex-direction: column; justify-content: center; align-items: center;';
    divRight.style = 'text-align: center; display: flex; flex-direction: row; justify-content: center; align-items: center;';
    // printWindow.document.write()

    printWindow.print();
    printWindow.close();
  },

  //returnFetchDataToCGMHHIS({ state, rootState, getters }, payload) {
  //20190409 modified by aaron
  returnFetchDataToCGMHHIS: function returnFetchDataToCGMHHIS(_ref10, payload) {
    var state = _ref10.state,
        rootState = _ref10.rootState,
        getters = _ref10.getters,
        dispatch = _ref10.dispatch;

    // payload: { medication: PKA027P, qty: 1, rx_user: A12345678 }
    console.log('returnFetchDataToCGMHHIS', payload);
    var datetimeNow = __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYYMMDD/HHmm');
    var data = {
      CHTNO: state.currentSchedule.patient.med_record_number,
      ODERNO: state.currentSchedule.seq_number,
      DRUG_CODE: payload.medication,
      //20190503 modified
      //DEPOSIT_DATE: datetimeNow.split('/')[0],
      //DEPOSIT_TIME: datetimeNow.split('/')[1],
      DEPOSIT_DATE: __WEBPACK_IMPORTED_MODULE_5_moment___default()(state.currentSchedule.time).format('YYYYMMDD'),
      DEPOSIT_TIME: __WEBPACK_IMPORTED_MODULE_5_moment___default()(state.currentSchedule.time).format('HHmm'),
      ////////////////////////////////////////////////////////////////////
      TAKE_DOSE: payload.dose,
      TAKE_QTY: payload.qty,
      TAKE_NRSIDNO1: rootState.user.user.username,
      TAKE_NRSIDNO2: payload.rx_user
    };
    console.log(data);

    // return retrieve info
    var CGMHHISUrl = 'http://lnkapp.cgmh.org.tw/cghcns/ADCDrug.asmx/Set_ADC_TAKE_DATA';
    //for test
    //const CGMHHISUrl = 'http://httpbin.org/xml';
    //const CGMHHISUrl = 'http://httpbin.org/robots.txt';
    //const CGMHHISUrl = 'http://httpbin.org/ip';

    var urlSearchData = new URLSearchParams();
    //20190517 modified by aaron
    //urlSearchData.set('p_costid', '348H0');
    console.log('p_costid:', state.currentSchedule.p_costid);
    urlSearchData.set('p_costid', state.currentSchedule.p_costid);
    urlSearchData.set('p_args', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([data]));
    fetch(CGMHHISUrl, {
      body: urlSearchData,
      mode: 'no-cors',
      method: 'POST'
      //for test
      //method: 'GET',
    })
    //20190409 modified by aaron
    .then(function (res) {
      //return res.json();
      return res.text();
    }).then(function (json) {
      console.log(json);
      // for test
      //var parser = new DOMParser();
      //var xmlDoc = parser.parseFromString(json,"text/xml");
      //console.log(xmlDoc);
      //console.log(xmlDoc.getElementsByTagName("title")[0].childNodes[0].nodeValue)
      //console.log(json.substring(0,10));
      //
      //console.log(JSON.parse(json));
      //if(json.origin) {
      //if(json.isSucess === "Y") {
      console.log('send to HIS successfully');
      dispatch('recordAction', { eventType: 'HIS_NURSING_SUCCESS' });
      //}
      //else {
      //  console.log('send to HIS failed');
      //  dispatch('recordAction', { eventType: 'HIS_NURSING_FAIL' });
      //}  
    }).catch(function (err) {
      console.log(err);
      console.log('send to HIS error');
      dispatch('recordAction', { eventType: 'HIS_NURSING_ERR' });
    });
    /*
    .then((res) => {
      //console.log(res.json());
      console.log(res);
      console.log('send to HIS successfully');
    })
    .catch((err) => {
      console.log(err);
      console.log('send to HIS failed');
    });
    */
  }
};

var getters = {
  scheduleToday: function scheduleToday(state) {
    return state.scheduleToday;
  },
  comboMedSet: function comboMedSet(state) {
    return state.comboMedSet;
  },
  currentSchedule: function currentSchedule(state) {
    return state.currentSchedule;
  },
  currentScheduleMed: function currentScheduleMed(state) {
    return state.currentScheduleMed;
  },
  nextScheduleMed: function nextScheduleMed(state) {
    return state.nextScheduleMed;
  }
};

var store = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mutation_types__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__functions_readCookie__ = __webpack_require__(13);




var _mutations;

/**
 * module for handling user object.
 */






var state = {
  user: null,
  token: '',
  popedAlert: false, // controling the alert would only show once after logined.
  fingerprint: undefined
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["R" /* LOGOUT */], function (state) {
  state.logout = false;
  state.user = null;
  var date = __WEBPACK_IMPORTED_MODULE_5_moment___default()().year(1970);
  document.cookie = 'Token=;expires=' + date.toDate() + ';path:/';
  state.popedAlert = false;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["S" /* ALERT_POPED */], function (state) {
  state.popedAlert = true;
}), _mutations);

var actions = {
  /**
   * login and get user token
   * @param {*} param0 vuex attribute
   * @param {*} payload payload with username and password
   */
  login: function login(_ref, payload) {
    var commit = _ref.commit,
        state = _ref.state,
        dispatch = _ref.dispatch;

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */] + '/api/token-auth/', {
      username: payload.username,
      password: payload.password,
      recaptchaToken: payload.recaptchaToken
    }).then(function (res) {
      var expiredDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()().add(3, 'days');
      document.cookie = 'Token=' + res.data.token + ';expires=' + expiredDate.toDate() + ';path:/;';
      state.token = res.data.token;
      state.errorMsg = '';
      commit('CREATE_INSTANCE');
    });
  },


  /**
   * get user profile with token
   * @param {*} param0 vuex attribute
   */
  getUser: function getUser(_ref2) {
    var commit = _ref2.commit,
        state = _ref2.state,
        rootState = _ref2.rootState,
        dispatch = _ref2.dispatch;

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */] + '/api/user-info/', {
      headers: {
        Authorization: 'Token ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__functions_readCookie__["a" /* default */])('Token')
      }
    }).then(function (res) {
      state.user = res.data;
      state.logined = true;
      var medAppPrivilege = state.user.med_app_privilege;
      if (medAppPrivilege !== null && medAppPrivilege !== undefined) {
        rootState.apps.management.functions.fetchDrug.privilege = medAppPrivilege.fetch;
        rootState.apps.management.functions.returnDrug.privilege = medAppPrivilege.return_drug;
        rootState.apps.management.functions.refillDrug.privilege = medAppPrivilege.refill;
        rootState.apps.management.functions.inventory.privilege = medAppPrivilege.inventory;
        rootState.apps.management.functions.createDrug.privilege = medAppPrivilege.create;
        rootState.apps.management.functions.removeDrug.privilege = medAppPrivilege.remove;
        rootState.apps.management.functions.removeOutdatedDrug.privilege = medAppPrivilege.remove_outdated;
        rootState.apps.management.functions.schedule.privilege = medAppPrivilege.fetch_by_schedule;
        rootState.apps.management.functions.scheduleReturn.privilege = medAppPrivilege.fetch_by_schedule;
        rootState.apps.management.functions.lockBox.privilege = medAppPrivilege.lockBox;
        rootState.apps.management.functions.fetchDrugSchedule.privilege = medAppPrivilege.batch_fetch;
        rootState.apps.management.functions.waste.privilege = medAppPrivilege.waste;
        rootState.apps.management.functions.recycleEmpty.privilege = medAppPrivilege.recycle_empty;
        rootState.apps.management.functions.returnEmpty.privilege = medAppPrivilege.return_empty;
      }
      dispatch('recordAction', { eventType: 'LOGIN' });
      // rootState.instance.post('/api/user-offline/', { user_id: state.user.id }); // dirty hack
    });
  },
  logout: function logout(_ref3) {
    var commit = _ref3.commit,
        rootState = _ref3.rootState,
        dispatch = _ref3.dispatch;

    // rootState.instance.post('/api/user-offline/', { user_id: state.user.id });
    dispatch('recordAction', { eventType: 'LOGOUT' });
    commit('LOGOUT');
  },
  setOnline: function setOnline(_ref4) {
    var state = _ref4.state,
        rootState = _ref4.rootState;

    return rootState.instance.post('/api/user-online/', {
      user_id: state.user.id
    });
  },
  setOffline: function setOffline(_ref5) {
    var state = _ref5.state,
        rootState = _ref5.rootState;

    return rootState.instance.post('/api/user-offline/', {
      user_id: state.user.id
    });
  },

  /**
   * get token with given barcode.
   * @param {*} param0 vuex attribute
   * @param {String} barcode barcode
   */
  loginWithBarcode: function loginWithBarcode(_ref6, barcode) {
    var commit = _ref6.commit,
        state = _ref6.state;

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */] + '/api/barcode-login/', {
      barcode: barcode
    }).then(function (res) {
      var expiredDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()().add(3, 'days');
      document.cookie = 'Token=' + res.data.token + ';expires=' + expiredDate.toDate() + ';path:/;';
      state.token = res.data.token;
      state.errorMsg = '';
      commit('CREATE_INSTANCE');
    });
  },
  loginWithFingerprint: function loginWithFingerprint(_ref7, feature) {
    var commit = _ref7.commit,
        state = _ref7.state;

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */] + '/api/fingerprint-login/', {
      feature: feature
    }).then(function (res) {
      var expiredDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()().add(3, 'days'); // token expired in three days
      document.cookie = 'Token=' + res.data.token + ';expires=' + expiredDate.toDate() + ';path:/;';
      state.token = res.data.token;
      state.errorMsg = '';
      commit('CREATE_INSTANCE');
    });
  },
  sendScanFingerCommand: function sendScanFingerCommand(_ref8) {
    var dispatch = _ref8.dispatch,
        rootState = _ref8.rootState;

    dispatch('submitCommand', {
      command: 'capture_finger'
    });
  },
  sendCheckFingerPrinterStatusCommand: function sendCheckFingerPrinterStatusCommand(_ref9) {
    var dispatch = _ref9.dispatch,
        rootState = _ref9.rootState;

    dispatch('submitCommand', {
      command: 'check_fingerprinter_status'
    });
  },
  sendGetFingerFeatureCommand: function sendGetFingerFeatureCommand(_ref10) {
    var dispatch = _ref10.dispatch,
        rootState = _ref10.rootState;

    dispatch('submitCommand', {
      command: 'get_finger_feature'
    });
  },
  sendCancelFingerCaptureCommand: function sendCancelFingerCaptureCommand(_ref11) {
    var dispatch = _ref11.dispatch,
        rootState = _ref11.rootState;

    dispatch('submitCommand', {
      command: 'cancel_capture'
    });
  },

  /**
   * async password login function
   * @param {*} param0 vuex attribute
   * @param {*} payload payload for 'login' function
   */
  loginAndGetUser: function loginAndGetUser(_ref12, payload) {
    var _this = this;

    var dispatch = _ref12.dispatch,
        commit = _ref12.commit,
        state = _ref12.state;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dispatch('login', payload);

            case 2:
              _context.next = 4;
              return dispatch('getUser');

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  /**
   * async barcode login function
   * @param {*} param0 vuex attribute
   * @param {*} payload payload for 'barcode login' function
   */
  barcodeLoginAndGetUser: function barcodeLoginAndGetUser(_ref13, payload) {
    var _this2 = this;

    var dispatch = _ref13.dispatch,
        commit = _ref13.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return dispatch('loginWithBarcode', payload.barcode);

            case 2:
              _context2.next = 4;
              return dispatch('getUser');

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  fingerpinrtLoginAndGetUser: function fingerpinrtLoginAndGetUser(_ref14, payload) {
    var _this3 = this;

    var dispatch = _ref14.dispatch;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return dispatch('loginWithFingerprint', payload.feature);

            case 2:
              _context3.next = 4;
              return dispatch('getUser');

            case 4:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  }
};

var userModule = {
  state: state,
  mutations: mutations,
  actions: actions
};

/* harmony default export */ __webpack_exports__["a"] = (userModule);

/***/ }),
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1041 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1052 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1053 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1055 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1056 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1058 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1060 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1061 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1063 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1064 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1065 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1068 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1072 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1075 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1076 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1077 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1078 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1079 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1080 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1081 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1082 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1083 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1084 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1085 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1086 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1087 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1088 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1089 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1090 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1091 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1092 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1093 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1094 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1095 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1096 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1097 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1098 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1099 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1100 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1101 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1102 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1103 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1104 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1106 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1108 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1109 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1110 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1111 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1113 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1114 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1116 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1118 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1119 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1120 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1122 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1123 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1124 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1126 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1127 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1128 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1130 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1149 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1150 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1153 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1156 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 317,
	"./af.js": 317,
	"./ar": 324,
	"./ar-dz": 318,
	"./ar-dz.js": 318,
	"./ar-kw": 319,
	"./ar-kw.js": 319,
	"./ar-ly": 320,
	"./ar-ly.js": 320,
	"./ar-ma": 321,
	"./ar-ma.js": 321,
	"./ar-sa": 322,
	"./ar-sa.js": 322,
	"./ar-tn": 323,
	"./ar-tn.js": 323,
	"./ar.js": 324,
	"./az": 325,
	"./az.js": 325,
	"./be": 326,
	"./be.js": 326,
	"./bg": 327,
	"./bg.js": 327,
	"./bm": 328,
	"./bm.js": 328,
	"./bn": 329,
	"./bn.js": 329,
	"./bo": 330,
	"./bo.js": 330,
	"./br": 331,
	"./br.js": 331,
	"./bs": 332,
	"./bs.js": 332,
	"./ca": 333,
	"./ca.js": 333,
	"./cs": 334,
	"./cs.js": 334,
	"./cv": 335,
	"./cv.js": 335,
	"./cy": 336,
	"./cy.js": 336,
	"./da": 337,
	"./da.js": 337,
	"./de": 340,
	"./de-at": 338,
	"./de-at.js": 338,
	"./de-ch": 339,
	"./de-ch.js": 339,
	"./de.js": 340,
	"./dv": 341,
	"./dv.js": 341,
	"./el": 342,
	"./el.js": 342,
	"./en-SG": 343,
	"./en-SG.js": 343,
	"./en-au": 344,
	"./en-au.js": 344,
	"./en-ca": 345,
	"./en-ca.js": 345,
	"./en-gb": 346,
	"./en-gb.js": 346,
	"./en-ie": 347,
	"./en-ie.js": 347,
	"./en-il": 348,
	"./en-il.js": 348,
	"./en-nz": 349,
	"./en-nz.js": 349,
	"./eo": 350,
	"./eo.js": 350,
	"./es": 353,
	"./es-do": 351,
	"./es-do.js": 351,
	"./es-us": 352,
	"./es-us.js": 352,
	"./es.js": 353,
	"./et": 354,
	"./et.js": 354,
	"./eu": 355,
	"./eu.js": 355,
	"./fa": 356,
	"./fa.js": 356,
	"./fi": 357,
	"./fi.js": 357,
	"./fo": 358,
	"./fo.js": 358,
	"./fr": 361,
	"./fr-ca": 359,
	"./fr-ca.js": 359,
	"./fr-ch": 360,
	"./fr-ch.js": 360,
	"./fr.js": 361,
	"./fy": 362,
	"./fy.js": 362,
	"./ga": 363,
	"./ga.js": 363,
	"./gd": 364,
	"./gd.js": 364,
	"./gl": 365,
	"./gl.js": 365,
	"./gom-latn": 366,
	"./gom-latn.js": 366,
	"./gu": 367,
	"./gu.js": 367,
	"./he": 368,
	"./he.js": 368,
	"./hi": 369,
	"./hi.js": 369,
	"./hr": 370,
	"./hr.js": 370,
	"./hu": 371,
	"./hu.js": 371,
	"./hy-am": 372,
	"./hy-am.js": 372,
	"./id": 373,
	"./id.js": 373,
	"./is": 374,
	"./is.js": 374,
	"./it": 376,
	"./it-ch": 375,
	"./it-ch.js": 375,
	"./it.js": 376,
	"./ja": 377,
	"./ja.js": 377,
	"./jv": 378,
	"./jv.js": 378,
	"./ka": 379,
	"./ka.js": 379,
	"./kk": 380,
	"./kk.js": 380,
	"./km": 381,
	"./km.js": 381,
	"./kn": 382,
	"./kn.js": 382,
	"./ko": 383,
	"./ko.js": 383,
	"./ku": 384,
	"./ku.js": 384,
	"./ky": 385,
	"./ky.js": 385,
	"./lb": 386,
	"./lb.js": 386,
	"./lo": 387,
	"./lo.js": 387,
	"./lt": 388,
	"./lt.js": 388,
	"./lv": 389,
	"./lv.js": 389,
	"./me": 390,
	"./me.js": 390,
	"./mi": 391,
	"./mi.js": 391,
	"./mk": 392,
	"./mk.js": 392,
	"./ml": 393,
	"./ml.js": 393,
	"./mn": 394,
	"./mn.js": 394,
	"./mr": 395,
	"./mr.js": 395,
	"./ms": 397,
	"./ms-my": 396,
	"./ms-my.js": 396,
	"./ms.js": 397,
	"./mt": 398,
	"./mt.js": 398,
	"./my": 399,
	"./my.js": 399,
	"./nb": 400,
	"./nb.js": 400,
	"./ne": 401,
	"./ne.js": 401,
	"./nl": 403,
	"./nl-be": 402,
	"./nl-be.js": 402,
	"./nl.js": 403,
	"./nn": 404,
	"./nn.js": 404,
	"./pa-in": 405,
	"./pa-in.js": 405,
	"./pl": 406,
	"./pl.js": 406,
	"./pt": 408,
	"./pt-br": 407,
	"./pt-br.js": 407,
	"./pt.js": 408,
	"./ro": 409,
	"./ro.js": 409,
	"./ru": 410,
	"./ru.js": 410,
	"./sd": 411,
	"./sd.js": 411,
	"./se": 412,
	"./se.js": 412,
	"./si": 413,
	"./si.js": 413,
	"./sk": 414,
	"./sk.js": 414,
	"./sl": 415,
	"./sl.js": 415,
	"./sq": 416,
	"./sq.js": 416,
	"./sr": 418,
	"./sr-cyrl": 417,
	"./sr-cyrl.js": 417,
	"./sr.js": 418,
	"./ss": 419,
	"./ss.js": 419,
	"./sv": 420,
	"./sv.js": 420,
	"./sw": 421,
	"./sw.js": 421,
	"./ta": 422,
	"./ta.js": 422,
	"./te": 423,
	"./te.js": 423,
	"./tet": 424,
	"./tet.js": 424,
	"./tg": 425,
	"./tg.js": 425,
	"./th": 426,
	"./th.js": 426,
	"./tl-ph": 427,
	"./tl-ph.js": 427,
	"./tlh": 428,
	"./tlh.js": 428,
	"./tr": 429,
	"./tr.js": 429,
	"./tzl": 430,
	"./tzl.js": 430,
	"./tzm": 432,
	"./tzm-latn": 431,
	"./tzm-latn.js": 431,
	"./tzm.js": 432,
	"./ug-cn": 433,
	"./ug-cn.js": 433,
	"./uk": 434,
	"./uk.js": 434,
	"./ur": 435,
	"./ur.js": 435,
	"./uz": 437,
	"./uz-latn": 436,
	"./uz-latn.js": 436,
	"./uz.js": 437,
	"./vi": 438,
	"./vi.js": 438,
	"./x-pseudo": 439,
	"./x-pseudo.js": 439,
	"./yo": 440,
	"./yo.js": 440,
	"./zh-cn": 441,
	"./zh-cn.js": 441,
	"./zh-hk": 442,
	"./zh-hk.js": 442,
	"./zh-tw": 443,
	"./zh-tw.js": 443
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1162;

/***/ }),
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Republic_of_China_Police_Station_Logo.93ce6a4.svg";

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/changhua.bf107fc.png";

/***/ }),
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(516),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1061)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(518),
  /* template */
  __webpack_require__(1392),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(519),
  /* template */
  __webpack_require__(1558),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1075)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(520),
  /* template */
  __webpack_require__(1415),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(521),
  /* template */
  __webpack_require__(1393),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1046)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(522),
  /* template */
  __webpack_require__(1371),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1062)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(523),
  /* template */
  __webpack_require__(1394),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1080)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(524),
  /* template */
  __webpack_require__(1422),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1068)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(525),
  /* template */
  __webpack_require__(1403),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1055)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(526),
  /* template */
  __webpack_require__(1381),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0d49041b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1101)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(527),
  /* template */
  __webpack_require__(1461),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(528),
  /* template */
  __webpack_require__(1441),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1151)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(529),
  /* template */
  __webpack_require__(1544),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(530),
  /* template */
  __webpack_require__(1446),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1150)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(531),
  /* template */
  __webpack_require__(1541),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1060)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(532),
  /* template */
  __webpack_require__(1391),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1157)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(533),
  /* template */
  __webpack_require__(1557),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f9d93542",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1054)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(534),
  /* template */
  __webpack_require__(1379),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1145)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(535),
  /* template */
  __webpack_require__(1536),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1155)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(536),
  /* template */
  __webpack_require__(1549),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1089)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(537),
  /* template */
  __webpack_require__(1439),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3ac38690",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(538),
  /* template */
  __webpack_require__(1475),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1084)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(539),
  /* template */
  __webpack_require__(1426),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-34f09f18",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1083)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(540),
  /* template */
  __webpack_require__(1425),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1149)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(541),
  /* template */
  __webpack_require__(1540),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1073)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(542),
  /* template */
  __webpack_require__(1412),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1134)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(543),
  /* template */
  __webpack_require__(1518),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1138)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(544),
  /* template */
  __webpack_require__(1524),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(545),
  /* template */
  __webpack_require__(1433),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(547),
  /* template */
  __webpack_require__(1495),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(548),
  /* template */
  __webpack_require__(1370),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(549),
  /* template */
  __webpack_require__(1451),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1052)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(550),
  /* template */
  __webpack_require__(1377),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(551),
  /* template */
  __webpack_require__(1416),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1053)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(552),
  /* template */
  __webpack_require__(1378),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1103)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(553),
  /* template */
  __webpack_require__(1466),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1124)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(554),
  /* template */
  __webpack_require__(1502),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1088)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(555),
  /* template */
  __webpack_require__(1436),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1135)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(556),
  /* template */
  __webpack_require__(1519),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1144)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(557),
  /* template */
  __webpack_require__(1534),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1156)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(559),
  /* template */
  __webpack_require__(1551),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1130)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(560),
  /* template */
  __webpack_require__(1514),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1085)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(561),
  /* template */
  __webpack_require__(1427),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1043)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(562),
  /* template */
  __webpack_require__(1367),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(563),
  /* template */
  __webpack_require__(1464),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(564),
  /* template */
  __webpack_require__(1465),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(565),
  /* template */
  __webpack_require__(1382),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1081)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(566),
  /* template */
  __webpack_require__(1423),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(567),
  /* template */
  __webpack_require__(1469),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1158)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(568),
  /* template */
  __webpack_require__(1559),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(569),
  /* template */
  __webpack_require__(1528),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(570),
  /* template */
  __webpack_require__(1532),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1076)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(571),
  /* template */
  __webpack_require__(1417),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(572),
  /* template */
  __webpack_require__(1408),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1148)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(573),
  /* template */
  __webpack_require__(1539),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1106)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(574),
  /* template */
  __webpack_require__(1471),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1064)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(575),
  /* template */
  __webpack_require__(1398),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(576),
  /* template */
  __webpack_require__(1550),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1044)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(577),
  /* template */
  __webpack_require__(1368),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(578),
  /* template */
  __webpack_require__(1437),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1098)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(579),
  /* template */
  __webpack_require__(1457),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(580),
  /* template */
  __webpack_require__(1444),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1071)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(581),
  /* template */
  __webpack_require__(1407),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(582),
  /* template */
  __webpack_require__(1531),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1112)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(583),
  /* template */
  __webpack_require__(1481),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(584),
  /* template */
  __webpack_require__(1504),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(585),
  /* template */
  __webpack_require__(1432),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(586),
  /* template */
  __webpack_require__(1523),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(587),
  /* template */
  __webpack_require__(1477),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(588),
  /* template */
  __webpack_require__(1454),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1039)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(589),
  /* template */
  __webpack_require__(1359),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1069)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(590),
  /* template */
  __webpack_require__(1404),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1056)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(591),
  /* template */
  __webpack_require__(1385),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1132)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(592),
  /* template */
  __webpack_require__(1516),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1066)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(593),
  /* template */
  __webpack_require__(1401),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1131)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(594),
  /* template */
  __webpack_require__(1515),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(595),
  /* template */
  __webpack_require__(1478),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1063)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(596),
  /* template */
  __webpack_require__(1397),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(597),
  /* template */
  __webpack_require__(1395),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(598),
  /* template */
  __webpack_require__(1521),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(599),
  /* template */
  __webpack_require__(1512),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1105)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(600),
  /* template */
  __webpack_require__(1470),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(601),
  /* template */
  __webpack_require__(1556),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1045)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(602),
  /* template */
  __webpack_require__(1369),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-03fe9bc7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1116)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(603),
  /* template */
  __webpack_require__(1485),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(604),
  /* template */
  __webpack_require__(1496),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1042)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(605),
  /* template */
  __webpack_require__(1365),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1070)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(606),
  /* template */
  __webpack_require__(1406),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1096)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(607),
  /* template */
  __webpack_require__(1453),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(608),
  /* template */
  __webpack_require__(1360),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(609),
  /* template */
  __webpack_require__(1420),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(610),
  /* template */
  __webpack_require__(1535),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1072)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(611),
  /* template */
  __webpack_require__(1409),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(612),
  /* template */
  __webpack_require__(1468),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(613),
  /* template */
  __webpack_require__(1553),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1065)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(615),
  /* template */
  __webpack_require__(1399),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(616),
  /* template */
  __webpack_require__(1445),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(617),
  /* template */
  __webpack_require__(1490),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(618),
  /* template */
  __webpack_require__(1486),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1095)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(619),
  /* template */
  __webpack_require__(1452),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1099)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(620),
  /* template */
  __webpack_require__(1458),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1078)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(621),
  /* template */
  __webpack_require__(1419),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1154)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(622),
  /* template */
  __webpack_require__(1548),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e1592b4a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1041)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(623),
  /* template */
  __webpack_require__(1364),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(624),
  /* template */
  __webpack_require__(1429),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(625),
  /* template */
  __webpack_require__(1506),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(626),
  /* template */
  __webpack_require__(1388),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1109)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(627),
  /* template */
  __webpack_require__(1476),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(628),
  /* template */
  __webpack_require__(1438),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1146)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(629),
  /* template */
  __webpack_require__(1537),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(630),
  /* template */
  __webpack_require__(1497),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1141)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(631),
  /* template */
  __webpack_require__(1527),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(632),
  /* template */
  __webpack_require__(1555),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(633),
  /* template */
  __webpack_require__(1396),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(634),
  /* template */
  __webpack_require__(1362),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(635),
  /* template */
  __webpack_require__(1428),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(636),
  /* template */
  __webpack_require__(1511),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(637),
  /* template */
  __webpack_require__(1384),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1115)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(638),
  /* template */
  __webpack_require__(1484),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(639),
  /* template */
  __webpack_require__(1380),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(640),
  /* template */
  __webpack_require__(1530),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1047)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(641),
  /* template */
  __webpack_require__(1372),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(642),
  /* template */
  __webpack_require__(1492),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(643),
  /* template */
  __webpack_require__(1366),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1108)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(645),
  /* template */
  __webpack_require__(1473),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1094)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(646),
  /* template */
  __webpack_require__(1449),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(647),
  /* template */
  __webpack_require__(1410),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1136)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(648),
  /* template */
  __webpack_require__(1520),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(649),
  /* template */
  __webpack_require__(1462),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(650),
  /* template */
  __webpack_require__(1493),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(651),
  /* template */
  __webpack_require__(1474),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(652),
  /* template */
  __webpack_require__(1508),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(653),
  /* template */
  __webpack_require__(1450),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(654),
  /* template */
  __webpack_require__(1503),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1125)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(655),
  /* template */
  __webpack_require__(1505),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1051)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(656),
  /* template */
  __webpack_require__(1376),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0aac6b6a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1079)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(657),
  /* template */
  __webpack_require__(1421),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2d5d60ef",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(658),
  /* template */
  __webpack_require__(1542),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(659),
  /* template */
  __webpack_require__(1443),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(660),
  /* template */
  __webpack_require__(1431),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(661),
  /* template */
  __webpack_require__(1460),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1120)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(662),
  /* template */
  __webpack_require__(1494),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(663),
  /* template */
  __webpack_require__(1430),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(664),
  /* template */
  __webpack_require__(1552),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1147)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(667),
  /* template */
  __webpack_require__(1538),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1142)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(670),
  /* template */
  __webpack_require__(1529),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(671),
  /* template */
  __webpack_require__(1554),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(672),
  /* template */
  __webpack_require__(1383),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1110)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(674),
  /* template */
  __webpack_require__(1479),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1152)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(675),
  /* template */
  __webpack_require__(1545),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ce9648ea",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1137)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(677),
  /* template */
  __webpack_require__(1522),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1104)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(678),
  /* template */
  __webpack_require__(1467),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1090)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(682),
  /* template */
  __webpack_require__(1440),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1118)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(683),
  /* template */
  __webpack_require__(1489),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1111)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(684),
  /* template */
  __webpack_require__(1480),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1123)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(685),
  /* template */
  __webpack_require__(1501),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6c4ed548",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1139)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(689),
  /* template */
  __webpack_require__(1525),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1059)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(692),
  /* template */
  __webpack_require__(1390),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1050)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(693),
  /* template */
  __webpack_require__(1375),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1058)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(695),
  /* template */
  __webpack_require__(1389),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1082)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(698),
  /* template */
  __webpack_require__(1424),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-335d45bd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1067)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(699),
  /* template */
  __webpack_require__(1402),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1122)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(700),
  /* template */
  __webpack_require__(1499),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1117)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(704),
  /* template */
  __webpack_require__(1488),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1074)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(705),
  /* template */
  __webpack_require__(1414),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1091)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(707),
  /* template */
  __webpack_require__(1442),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(713),
  /* template */
  __webpack_require__(1546),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1359 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-10"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_vm._m(0), _c('p', [_vm._v("    ")]), _vm._l((_vm.paras), function(item) {
    return _c('div', [_c('h4', [_c('kbd', {
      staticClass: "navbar-brand-kbd"
    }, [_vm._v("固定桿代碼" + _vm._s(item.fixed_link_code) + "  道路限速" + _vm._s(item.road_speed_limit) + " 舉發車速(超速)" + _vm._s(item.break_value) + " 舉發車速(龜速)" + _vm._s(item.break_value_slow))])])])
  })], 2), _c('div', [_c('vuetable', {
    ref: "vuetable",
    attrs: {
      "api-url": (_vm.server + "/api/interval-speed-data/"),
      "data-path": "results",
      "pagination-path": "",
      "per-page": 20,
      "fields": _vm.fields,
      "css": _vm.boostrapCss,
      "http-options": _vm.httpOptions,
      "append-params": _vm.moreParams,
      "detail-row-component": "ticket-check-detail",
      "sortOrder": _vm.sortOrder
    },
    on: {
      "vuetable:loading": _vm.onLoading,
      "vuetable:loaded": _vm.onLoaded,
      "vuetable:pagination-data": _vm.onPaginationData,
      "vuetable:cell-clicked": _vm.onCellClicked
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s((props.rowIndex + 1) + (_vm.currentPage - 1) * 20))])]
      }
    }])
  }), _c('vuetable-pagination', {
    ref: "pagination",
    attrs: {
      "css": _vm.boostrapCss.pagination
    },
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  })], 1), (_vm.tableDataLen == 0 && _vm.loadingData == false) ? _c('div', [_c('h1', {
    staticClass: "text-center display-4"
  }, [_vm._v("今日無開單資料")])]) : _vm._e()]), _c('div', {
    staticClass: "col-2"
  }, [_vm._m(1), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("開始時間")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.startDate),
      expression: "startDate"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.startDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.startDate = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("結束時間")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.endDate),
      expression: "endDate"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.endDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.endDate = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("過濾條件")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryString),
      expression: "queryString"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "text",
      "placeholder": "輸入車號"
    },
    domProps: {
      "value": (_vm.queryString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.queryString = $event.target.value
      }
    }
  })]), _c('button', {
    staticClass: "btn btn-primary mb-2 w-100",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.onFilterSet
    }
  }, [_vm._v("篩選")])]), (_vm.loadingData) ? _c('Loader', [_c('h4', [_vm._v("資料載入中，請稍等")])]) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('kbd', [_vm._v("區間超速開單資訊")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "text-info"
  }, [_c('strong', [_vm._v("請輸入查詢區間")])])
}]}

/***/ }),
/* 1360 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.stage === 'confirmAmount') ? _c('Action', {
    attrs: {
      "defaultNum": _vm.forAction.defaultNum,
      "autoCaculateAmount": false,
      "compType": 'Confirm',
      "defaultPackCount": _vm.theDrugStorage.pack_count,
      "deviceId": _vm.forAction.deviceId,
      "checkNum": _vm.forAction.checkNum
    },
    on: {
      "confirmAmountFinish": _vm.confirmAmountFinish
    }
  }, [_c('h5', [_vm._v("確認藥盒內數量")])]) : _vm._e(), _vm._v(" "), (_vm.stage === 'action') ? _c('Action', {
    attrs: {
      "defaultNum": _vm.forAction.defaultNum,
      "autoCaculateAmount": false,
      "defaultPackCount": 0,
      "deviceId": _vm.forAction.deviceId,
      "onlyPc": true,
      "inputReadOnly": _vm.fetchReadOnly,
      "checkNum": _vm.forAction.checkNum
    },
    on: {
      "setActionData": _vm.getThisAmount,
      "setTotalSumInstanly": _vm.getTotalSumInstanly
    }
  }, [_c('h5', [_vm._v("自此藥盒取藥數量 (pc)")])]) : _vm._e(), _vm._v(" "), (_vm.stage === 'break') ? _c('ActionBreak', {
    attrs: {
      "residual": _vm.amount - _vm.totalAmount
    },
    on: {
      "goOn": _vm.goOn
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stage === 'next') ? _c('Loader') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1361 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('span', [_vm._v("目前最低存量: " + _vm._s(_vm.amount))]), _c('br'), _c('span', [_vm._v("請輸入欲重新設定之最低存量")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.number),
      expression: "number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.number)
    },
    on: {
      "click": _vm.useNumPad,
      "keydown": _vm.useNumPad,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.number = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("確定")]), _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])])])])]), _c('NumberInput', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPad),
      expression: "showPad"
    }],
    attrs: {
      "defaultNumber": _vm.number
    },
    on: {
      "saveNumber": _vm.saveNumber
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1362 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upper-subpanel--inside"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('DrugInfo')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [(_vm.currentProgress === 'confirm') ? _c('ConfirmFlow', {
    attrs: {
      "confirmProgress": _vm.confirmProgress,
      "currentDrugInDeviceIndex": _vm.currentDrugInDeviceIndex,
      "startType": _vm.startType
    },
    on: {
      "confirmationFinish": _vm.getConfirmData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'finish') ? _c('Loader') : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1363 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    class: {
      'modal-content': true,
      'modal-warning': true,
    }
  }, [_c('div', {
    staticClass: "modal-body text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.yes
    }
  }, [_vm._v("確定")]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.no
    }
  }, [_vm._v("取消")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1364 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.mountedFinished) ? _c('div', {
    key: "main",
    staticClass: "row main-layout"
  }, [_vm._l((_vm.all_functions), function(subfun) {
    return _c('div', {
      class: {
        'col-8': subfun.title === '藥物管理', 'col-4': subfun.title === '藥櫃設定'
      }
    }, [_c('div', {
      staticClass: "main-sublayout"
    }, [_c('p', {
      staticClass: "main-sublayout--title "
    }, [_vm._v(_vm._s(subfun.title))]), _vm._v(" "), _vm._l((subfun.functions), function(fun) {
      return (fun.privilege) ? _c('div', {
        class: {
          'function-button': true,
          'd-inline-block': true,
          'm-1': true,
          'danger-button': fun.url_name === 'disabledDevices',
            'not-ready': fun.ready === false,
        },
        attrs: {
          "id": fun.url_name
        }
      }, [_c('router-link', {
        attrs: {
          "to": {
            name: fun.url_name
          }
        }
      }, [_c('div', {
        staticClass: "icon-wrap"
      }, [_c('img', {
        attrs: {
          "src": ("/static/svg/" + (fun.icon_name)),
          "alt": ""
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "text-center"
      }, [_vm._v("\n                " + _vm._s(fun.name) + "\n              ")]), _vm._v(" "), (fun.url_name === 'removeOutdatedDrug' && _vm.outdateCount !== 0) ? _c('div', {
        staticClass: "badge-alert"
      }, [_c('span', [_vm._v(_vm._s(_vm.outdateCount))])]) : _vm._e(), _vm._v(" "), (fun.url_name === 'refillDrug' && _vm.lowCount !== 0) ? _c('div', {
        staticClass: "badge-alert"
      }, [_c('span', [_vm._v(_vm._s(_vm.lowCount))])]) : _vm._e(), _vm._v(" "), (fun.url_name === 'storageError' && _vm.storageErrorCount !== 0) ? _c('div', {
        staticClass: "badge-alert"
      }, [_c('span', [_vm._v(_vm._s(_vm.storageErrorCount))])]) : _vm._e()])], 1) : _vm._e()
    })], 2)])
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "bottom-layout"
  }, [_c('div', {
    staticClass: "clock"
  }, [_c('Clock'), _vm._v(" "), _c('span', {
    staticClass: "clock-text"
  }, [_c('p', [_vm._v("現在時間")]), _vm._v("\n              " + _vm._s(_vm.time) + "\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "system-env-wrap"
  }, [_c('div', {
    staticClass: "system-env"
  }, [_c('span', [_vm._v("藥櫃溫度")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$store.state.temperature) + " "), _c('span', [_vm._v("℃")])])]), _vm._v(" "), _c('div', {
    staticClass: "system-env"
  }, [_c('span', [_vm._v("藥櫃濕度")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$store.state.humidity) + " "), _c('span', [_vm._v("%")])])])]), _vm._v(" "), _c('span', [_c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("版本: " + _vm._s(_vm.version))]), _vm._v(" "), (_vm.$store.state.device.systemArea !== null) ? _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("藥櫃位置：" + _vm._s(_vm._f("areaFormat")(_vm.$store.state.device.systemArea)))]) : _vm._e()])])])], 2) : _c('div', {
    key: "loading",
    staticClass: "row main-layout"
  }, [_c('div', {
    staticClass: "main-layout--center"
  }, [_c('ClipLoader'), _vm._v(" "), _c('p', [_vm._v("更新系統資訊中")])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1365 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upper-subpanel",
    staticStyle: {
      "margin": "0 -15px"
    }
  }, [_c('div', {
    staticClass: "summary-layout"
  }, [_c('table', {
    staticClass: "table table-fixed"
  }, [_vm._m(0), _c('tbody', _vm._l((_vm.summaryData), function(data) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(data.medication.code))]), _c('td', [_vm._v(_vm._s(data.medication.CGMH_number))]), _c('td', [_vm._v(_vm._s(data.medication.generic_name))]), _c('td', [_vm._v(_vm._s(data.count))]), _c('td', [_vm._v(_vm._s(data.total))])])
  }), 0)])])]), _c('BottomButtons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [_c('th', [_vm._v("藥碼")]), _c('th', [_vm._v("料位號")]), _c('th', [_vm._v("藥物名稱")]), _c('th', [_vm._v("藥盒數量")]), _c('th', [_vm._v("總數量")])])])
}]}

/***/ }),
/* 1366 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-layout"
  }, [_c('div', {
    staticClass: "alert alert-success"
  }, [(_vm.returnToEmptyDeviceId) ? _c('span', [_vm._v("退回不同批號藥物，將退至空藥盒")]) : (_vm.currentDrugInDevice !== null && _vm.currentSystem.settings.return_to_original_cmpn) ? _c('span', [_c('span', [_vm._v("藥盒數量/上限: " + _vm._s(_vm.currentDrugInDevice.stock) + " / " + _vm._s(_vm.currentDrugInDevice.max_stock) + " ")]), _c('span', {
    staticClass: "float-right"
  }, [_vm._v("藥物總數量/上限: " + _vm._s(_vm.$store.state.drug.selectedDrugTotalAmount) + " /" + _vm._s(_vm.$store.state.drug.selectedDrugTotalMax) + " ")])]) : _c('span', [_vm._v("未設定退回原藥盒")])]), (_vm.currentProgress === 'selectReason') ? _c('ConfirmReason', {
    on: {
      "setReason": _vm.getReason
    }
  }) : _vm._e(), _c('TextInput', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentProgress === 'medIdInput'),
      expression: "currentProgress === 'medIdInput'"
    }],
    attrs: {
      "inputLabel": '輸入病歷號',
      "defaultContent": _vm.medRecordId
    },
    on: {
      "setText": _vm.getMedId
    }
  }), _c('TextInput', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentProgress === 'setPatchNo'),
      expression: "currentProgress === 'setPatchNo'"
    }],
    attrs: {
      "inputLabel": '確認批號',
      "defaultContent": _vm.patchNo
    },
    on: {
      "setText": _vm.getPatchNo
    }
  }), (_vm.currentProgress === 'setExpiredDate') ? _c('ConfirmExpiredDate', {
    attrs: {
      "defaultExpirationDate": _vm.defaultExpiredDate,
      "editable": _vm.expiredDateEditable
    },
    on: {
      "setExpirationDate": _vm.getExpiredDate
    }
  }) : _vm._e(), (_vm.currentProgress === 'setStorage') ? _c('ConfirmStorage', {
    attrs: {
      "inputLabel": '設定退藥數量',
      "defaultAmount": _vm.defaultReturnAmount
    },
    on: {
      "setNum": _vm.getStorage
    }
  }) : _vm._e(), (_vm.currentProgress === 'rxCheck') ? _c('RxCheckBarcode', {
    on: {
      "confirmRx": _vm.confirmRx
    }
  }) : _vm._e(), (_vm.currentProgress === 'action') ? _c('ActionWrap', {
    attrs: {
      "amountPayload": _vm.amountPayload,
      "actionProgress": _vm.actionProgress,
      "returnToEmptyDeviceId": _vm.returnToEmptyDeviceId,
      "actionRecorded": _vm.actionRecorded
    },
    on: {
      "setActionData": _vm.getActionData,
      "finishAction": _vm.finishAction
    }
  }) : _vm._e(), (_vm.showPatchConfirmModal) ? _c('ConfirmModal', {
    attrs: {
      "message": '輸入批號與目前藥盒不同，是否繼續退藥？'
    },
    on: {
      "response": _vm.confirmPatchChoice
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1367 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-10"
  }, [_c('div', {
    staticClass: "summary-layout"
  }, [_c('table', {
    staticClass: "table table-fixed"
  }, [_vm._m(0), _c('tbody', _vm._l((_vm.filteredData), function(data) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(data.server))]), _c('td', [_vm._v(_vm._s(data.cmp1_time))]), _c('td', [_vm._v(_vm._s(data.cmp2_time))]), _c('td', [_vm._v(_vm._s(data.check_status))])])
  }), 0)])])]), _c('div', {
    staticClass: "col-2"
  }, [_c('QueryFilter', {
    attrs: {
      "showReportButton": _vm.showReportButton,
      "showDate": _vm.showDate,
      "showStartDate": _vm.showStartDate
    },
    on: {
      "filter": _vm.filter,
      "report": _vm.downloadReport
    }
  }), (_vm.loadingData) ? _c('Loader', [_c('h4', [_vm._v("資料載入中，請稍等")])]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [_c('th', [_vm._v("伺服器電腦時間")]), _c('th', [_vm._v("入口電腦時間")]), _c('th', [_vm._v("出口電腦時間")]), _c('th', [_vm._v("同步結果")])])])
}]}

/***/ }),
/* 1368 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _c('vuetable', {
    ref: "vuetable",
    attrs: {
      "api-url": (_vm.server + "/api/fixed-link-code/"),
      "data-path": "",
      "pagination-path": "",
      "per-page": 20,
      "fields": _vm.fields,
      "css": _vm.boostrapCss,
      "http-options": _vm.httpOptions,
      "append-params": _vm.moreParams,
      "detail-row-component": "para-detail"
    },
    on: {
      "vuetable:pagination-data": _vm.onPaginationData,
      "vuetable:cell-clicked": _vm.onCellClicked
    }
  }), _c('vuetable-pagination', {
    ref: "pagination",
    attrs: {
      "css": _vm.boostrapCss.pagination
    },
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('kbd', [_vm._v("環境參數資訊")])])
}]}

/***/ }),
/* 1369 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "10px 0"
    }
  }, [_c('h3', [_vm._v("Control Panel "), _c('p', [_c('small', [_vm._v("Current Developer: " + _vm._s(_vm.$store.state.user.user.username))])])]), _c('hr'), _c('h5', [_vm._v("cabinet layout in database "), _c('button', {
    on: {
      "click": _vm.initLocalSystem
    }
  }, [_vm._v("Refresh")])]), _c('div', {
    staticClass: "layout-region"
  }, [_c('h5', [_vm._v(_vm._s(_vm.systemName))]), _vm._l((_vm.systemsCopy), function(sys, sys_num) {
    return _c('div', {
      staticClass: "system-layout"
    }, [_c('span', [_vm._v(_vm._s(sys.relative_index) + " (SN:" + _vm._s(sys.serial) + ")")]), _vm._l((sys.net_set), function(net, net_num) {
      return _c('div', {
        staticClass: "net-layout"
      }, [_c('div', {
        staticClass: "net-pos",
        class: {
          'background-green': net.LED_color === 'green', 'bling': net.LED_status, 'status-badge': true
        }
      }, [_c('span', [_vm._v(_vm._s(net.position))])]), _c('div', {
        staticClass: "net-content"
      }, [_c('span', {
        attrs: {
          "id": "netID"
        }
      }, [_vm._v("Drawer " + _vm._s(net.row_id) + " (id:" + _vm._s(net.id) + ")")]), _c('button', {
        on: {
          "click": function($event) {
            return _vm.openAllDevices(net)
          }
        }
      }, [_vm._v("OpenAll")]), _c('button', {
        staticClass: "float-right",
        on: {
          "click": function($event) {
            return _vm.toggleNet(sys_num, net_num)
          }
        }
      }, [_vm._v("Expand / Close")]), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (net.toggled),
          expression: "net.toggled"
        }],
        staticClass: "device-wrap"
      }, _vm._l((net.device_set), function(device) {
        return _c('div', {
          staticClass: "device-layout",
          class: {
            'background-green': device.LED_color === 'green', 'bling': device.LED_status
          }
        }, [_c('p', [_vm._v(_vm._s(device.pos_row) + " - " + _vm._s(device.relative_col) + " (w=" + _vm._s(device.width) + ",r=" + _vm._s(device.pos_col) + ",id=" + _vm._s(device.id) + ")")]), _c('div', [_c('button', {
          staticClass: "btn btn-primary btn-sm",
          on: {
            "click": function($event) {
              return _vm.openDeviceById(device.id)
            }
          }
        }, [(device.pos_row === 0) ? _c('span', [_vm._v("OpenDrawer")]) : _c('span', [_vm._v("Open")])]), _c('button', {
          staticClass: "btn btn-danger btn-sm",
          on: {
            "click": function($event) {
              return _vm.delDevice(device.id)
            }
          }
        }, [_vm._v("Remove")])])])
      }), 0)])])
    })], 2)
  })], 2), _c('hr'), _c('h5', [_vm._v("Detected Layout "), _c('button', {
    on: {
      "click": _vm.getDetectedDevices
    }
  }, [_vm._v("Refresh")])]), (_vm.detectedDevices.length !== 0) ? _c('div', {
    staticClass: "layout-region"
  }, [_c('div', {
    staticClass: "net-layout"
  }, [_c('div', {
    staticClass: "device-wrap"
  }, _vm._l((_vm.detectedDevices), function(device) {
    return _c('div', {
      staticClass: "device-layout"
    }, [_c('p', {
      staticClass: "text-center"
    }, [_vm._v("System: " + _vm._s(device.net.system))]), _c('p', {
      staticClass: "text-center"
    }, [_vm._v("Net:" + _vm._s(device.net.row_id) + " ")]), _c('p', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(device.pos_row) + " - " + _vm._s(device.relative_col) + " - width: " + _vm._s(device.width))]), _c('div', [_c('button', {
      staticClass: "btn btn-info btn-sm",
      on: {
        "click": function($event) {
          return _vm.setupDetectedDevice(device.id)
        }
      }
    }, [_vm._v("Add")]), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.removeDetectedDevice(device.id)
        }
      }
    }, [_vm._v("Remove")])])])
  }), 0)])]) : _c('p', [_c('small', [_vm._v("No newly detected device in database.")])]), _c('hr'), _c('h5', [_vm._v("Testing tool")]), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.openTargetDrawerAndDevices($event)
      }
    }
  }, [_c('span', [_vm._v("藥櫃編號 ")]), _c('input', {
    attrs: {
      "placeholder": "cabinet index",
      "name": "cabInd",
      "type": "number"
    }
  }), _c('span', [_vm._v("抽屜編號")]), _c('input', {
    attrs: {
      "placeholder": "drawer index",
      "name": "drawerInd",
      "type": "number"
    }
  }), _c('span', [_vm._v(" ")]), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("開啟整層抽屜及藥盒")]), _c('small', [_vm._v("  (可按enter進行測試)")]), _c('p', [_vm._v("last tested cabinet index: " + _vm._s(_vm.previousTestCabInd) + ", drawer index: " + _vm._s(_vm.previousTestDrawerInd))]), _c('p', [_vm._v("目前測試次數: " + _vm._s(_vm.testTimes))])]), _c('hr'), _c('h5', [_vm._v("Other command")]), _c('button', {
    on: {
      "click": _vm.sendLayoutCommand
    }
  }, [_vm._v("Rescan layout")]), _c('button', {
    on: {
      "click": _vm.removeAllDevices
    }
  }, [_vm._v("Remove All Devices")]), _c('button', {
    on: {
      "click": _vm.removeAllDrugStorages
    }
  }, [_vm._v("Remove All DrugStorages")]), _c('button', {
    on: {
      "click": _vm.createRandomDrugStorages
    }
  }, [_vm._v("Create Random DrugStorages")]), _c('button', {
    on: {
      "click": _vm.removeAllEvent
    }
  }, [_vm._v("Remove all Events")])])
},staticRenderFns: []}

/***/ }),
/* 1370 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DataImportBase', {
    attrs: {
      "title": '標籤藥物儲存',
      "uploadUrl": '/upload-tag-drug-storage-table/',
      "downloadUrl": '/export-tag-drug-storage-table/'
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1371 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-10"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_vm._m(0), _c('p', [_vm._v("    ")]), _vm._l((_vm.paras), function(item) {
    return _c('div', [_c('h4', [_c('kbd', {
      staticClass: "navbar-brand-kbd"
    }, [_vm._v("固定桿代碼" + _vm._s(item.fixed_link_code) + "  道路限速" + _vm._s(item.road_speed_limit) + " 舉發車速(超速)" + _vm._s(item.break_value) + " 舉發車速(龜速)" + _vm._s(item.break_value_slow))])])])
  })], 2), _c('div', [_c('vuetable', {
    ref: "vuetable",
    attrs: {
      "api-url": (_vm.server + "/api/interval-speed-data/"),
      "data-path": "results",
      "pagination-path": "",
      "per-page": 20,
      "row-class": _vm.onRowClass,
      "fields": _vm.fields,
      "css": _vm.boostrapCss,
      "http-options": _vm.httpOptions,
      "append-params": _vm.moreParams,
      "detail-row-component": "check-detail"
    },
    on: {
      "vuetable:loading": _vm.onLoading,
      "vuetable:loaded": _vm.onLoaded,
      "vuetable:pagination-data": _vm.onPaginationData,
      "vuetable:cell-clicked": _vm.onCellClicked
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s((props.rowIndex + 1) + (_vm.currentPage - 1) * 20))])]
      }
    }])
  }), _c('vuetable-pagination', {
    ref: "pagination",
    attrs: {
      "css": _vm.boostrapCss.pagination
    },
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  })], 1), (_vm.tableDataLen == 0 && _vm.loadingData == false) ? _c('div', [_c('h1', {
    staticClass: "text-center display-4"
  }, [_vm._v("今日無違規資料")])]) : _vm._e()]), _c('div', {
    staticClass: "col-2"
  }, [_vm._m(1), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("開始時間")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.startDate),
      expression: "startDate"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.startDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.startDate = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("結束時間")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.endDate),
      expression: "endDate"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.endDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.endDate = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("過濾條件")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryString),
      expression: "queryString"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "text",
      "placeholder": "輸入車號或開單狀態"
    },
    domProps: {
      "value": (_vm.queryString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.queryString = $event.target.value
      }
    }
  })]), _c('button', {
    staticClass: "btn btn-primary mb-2 w-100",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.onFilterSet
    }
  }, [_vm._v("篩選")]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("警示車速(km/hr)")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alarmSpeed),
      expression: "alarmSpeed"
    }],
    staticClass: "form-control form-control-sm text-danger",
    attrs: {
      "type": "number",
      "placeholder": "輸入警示車速"
    },
    domProps: {
      "value": (_vm.alarmSpeed)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.alarmSpeed = $event.target.value
      }
    }
  }), _c('label', [_vm._v("警示違規筆數")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alarmIllegalNum),
      expression: "alarmIllegalNum"
    }],
    staticClass: "form-control form-control-sm text-danger",
    attrs: {
      "type": "number",
      "placeholder": "輸入警示違規筆數"
    },
    domProps: {
      "value": (_vm.alarmIllegalNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.alarmIllegalNum = $event.target.value
      }
    }
  }), _c('h3', {
    staticClass: "text-danger",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("違規件數:" + _vm._s(_vm.totalIllegalNum))])]), (_vm.totalIllegalNum > _vm.alarmIllegalNum) ? _c('div', [_c('h4', {
    staticClass: "text-danger"
  }, [_vm._v("違規筆數異常，請注意!!     ")])]) : _vm._e()]), (_vm.loadingData) ? _c('Loader', [_c('h4', [_vm._v("資料載入中，請稍等")])]) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('kbd', [_vm._v("區間測速資訊")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "text-info"
  }, [_c('strong', [_vm._v("請輸入查詢區間")])])
}]}

/***/ }),
/* 1372 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upper-subpanel row"
  }, [_c('progressBar'), _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [(_vm.drugSetMethod === 'barcode' && _vm.stage === 'selectDrug') ? _c('scanBarcode', {
    on: {
      "setBarcode": _vm.getBarcode
    }
  }, [_c('div', {
    staticClass: "with-child-centered"
  }, [_c('h3', [_vm._v("請掃描藥單條碼進行"), _c('strong', [_vm._v("退藥")])])])]) : _vm._e(), (_vm.drugSetMethod === 'event' && _vm.stage === 'selectDrug') ? _c('eventTable', {
    attrs: {
      "eventType": _vm.eventType,
      "singleSelection": true,
      "noChecked": true
    }
  }) : _vm._e(), (_vm.drugSetMethod === 'returnSchedule' && _vm.stage === 'selectDrug') ? _c('eventTable', {
    attrs: {
      "eventType": _vm.eventType,
      "singleSelection": false,
      "number2": _vm.returnScheduleId
    }
  }) : _vm._e(), (_vm.drugSetMethod === 'manual' && _vm.stage === 'selectDrug') ? _c('div', {
    staticClass: "druglist-wrap"
  }, [_c('drugList', {
    attrs: {
      "singleSelection": true
    }
  })], 1) : _vm._e(), (_vm.stage === 'setFlowData') ? _c('MultiFlow', {
    attrs: {
      "multiProgress": _vm.multiProgress,
      "confirmProgress": _vm.confirmProgress,
      "actionProgress": _vm.actionProgress,
      "startType": _vm.startType,
      "barcodeData": _vm.barcodeData
    },
    on: {
      "setAllConfirmData": _vm.getAllConfirmData
    }
  }) : _vm._e(), (_vm.stage === 'finish') ? _c('Loader') : _vm._e()], 1)], 1), _c('BottomButtons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  }), (_vm.stage !== 'setFlowData' && _vm.generalSetting.mode === 'aeth') ? _c('action-button', {
    attrs: {
      "slot": "button-3",
      "title": "病人列表"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'scheduleReturn',
          params: {
            stage: 'ScheduleList'
          }
        })
      }
    },
    slot: "button-3"
  }) : _vm._e(), (_vm.stage !== 'setFlowData') ? _c('action-button', {
    attrs: {
      "slot": "button-3",
      "title": "手動退藥"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDrugSetMethod('manual')
      }
    },
    slot: "button-3"
  }) : _vm._e(), (_vm.stage !== 'setFlowData' && _vm.generalSetting.mode !== 'aeth') ? _c('action-button', {
    attrs: {
      "slot": "button-3",
      "title": "掃描條碼"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDrugSetMethod('barcode')
      }
    },
    slot: "button-3"
  }) : _vm._e(), (_vm.stage !== 'setFlowData') ? _c('action-button', {
    attrs: {
      "slot": "button-4",
      "title": "取藥紀錄"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDrugSetMethod('event')
      }
    },
    slot: "button-4"
  }) : _vm._e(), (_vm.stage !== 'setFlowData') ? _c('action-button', {
    attrs: {
      "slot": "button-9",
      "title": "開始退藥",
      "clickable": _vm.$store.state.drugInDevice.selectedDrugInDeviceID.length > 0 || _vm.$store.state.event.selectedEventId.length > 0
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startFlow($event)
      }
    },
    slot: "button-9"
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1373 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "with-child-centered",
    staticStyle: {
      "height": "100%"
    }
  }, [(_vm.getScheduled === false) ? _c('Loader') : _vm._e(), (_vm.scheduleByPatient.length > 0 && _vm.getScheduled) ? _c('div', {
    staticClass: "schedules-wrapper"
  }, [(_vm.filteredSchCount === 0 & _vm.filterOutZeroAmountMed) ? _c('div', {
    staticClass: "with-child-centered"
  }, [_c('h4', [_vm._v("今日無病人須於此藥櫃操作")])]) : _c('SplitLayout', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }, [_c('h5', {
    staticClass: "text-center"
  }, [_vm._v("1.選擇病人")]), _c('div', {
    staticStyle: {
      "height": "418px",
      "overflow-y": "auto"
    }
  }, _vm._l((_vm.scheduleByPatient), function(patient, ind) {
    return _c('div', {
      class: {
        'surgery-item': true, 'sch-selected': ind === _vm.patientSelected
      },
      style: ({
        display: 'inline-block',
        width: '98%',
        backgroundColor: _vm.colormaps[(ind % _vm.colormaps.length)],
        color: 'white',
        border: '1px solid transparent'
      }),
      on: {
        "click": function($event) {
          _vm.patientSelected = ind
        }
      }
    }, [_c('p', [_c('span', {
      staticStyle: {
        "padding-right": "1rem"
      }
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": _vm.faUser,
        "color": "white"
      }
    })], 1), _c('strong', [_c('span', [_vm._v(_vm._s(patient.patient.med_record_number) + " ")]), _c('span', [_vm._v(_vm._s(patient.patient.name) + " ")]), (patient.patient.gender) ? _c('span', [_vm._v("( " + _vm._s(_vm._f("genderZh")(patient.patient.gender)) + " )")]) : _vm._e()]), _c('span', {
      staticClass: "float-right"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("areaFormat")(_vm.$store.state.device.systemArea)))]), _c('span', [_vm._v(_vm._s(patient.bed.ward.name))]), _c('span', [_vm._v(_vm._s(patient.bed.code))])])])])
  }), 0)]), _c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('h5', {
    staticClass: "text-center"
  }, [_vm._v("2.選擇藥單")]), _c('div', {
    staticStyle: {
      "height": "418px",
      "overflow-y": "auto"
    }
  }, [(_vm.patientSelected !== undefined) ? _c('div', _vm._l((_vm.scheduleByPatient[_vm.patientSelected].schedules), function(schedule, ind) {
    return _c('div', {
      class: {
        'surgery-item': true, 'fetched-schedule': schedule.fetched
      },
      style: ({
        display: 'inline-block',
        width: '98%'
      }),
      on: {
        "click": function($event) {
          return _vm.selecteSchedule(schedule.id)
        }
      }
    }, [_c('p', [_c('span', {
      staticStyle: {
        "padding-right": "1rem"
      }
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": _vm.faPrescriptionBottle,
        "color": "black"
      }
    })], 1), _c('span', [_vm._v(_vm._s(schedule.combo_relationship[0].child_medication.generic_name))])]), (schedule.extra_info) ? _c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.extraInfoZh(JSON.parse(schedule.extra_info)))
      }
    }) : _vm._e(), _c('p')])
  }), 0) : _c('div', {
    staticClass: "with-child-centered"
  }, [_c('p', [_vm._v("請先選擇病人")])])])])])], 1) : _vm._e(), (_vm.scheduleByPatient.length === 0 && _vm.getScheduled) ? _c('div', {
    staticClass: "with-child-centered"
  }, [_c('h4', [_vm._v("無排程資料")])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1374 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('SystemPanel', [_c('div', {
    staticClass: "confirm-form confirm-form-with-syspanel"
  }, [_vm._t("default", [_c('h5', [_vm._v("此藥盒數量")])]), _vm._v(" "), (_vm.onlyPc) ? _c('div', {
    staticClass: "interactive-input--wrap"
  }, [_c('div', {
    staticClass: "interactive-input"
  }, [(_vm.inputReadOnly === false) ? _c('div', {
    staticClass: "calculate-button add-button",
    on: {
      "click": function($event) {
        return _vm.addNum('pieces')
      }
    }
  }, [_vm._v("+")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pieces),
      expression: "pieces"
    }],
    ref: "input",
    class: {
      'form-control': true, 'long-input': _vm.inputReadOnly, 'width-input': true
    },
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "type": "number",
      "readonly": _vm.inputReadOnly,
      "min": "0"
    },
    domProps: {
      "value": (_vm.pieces)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pieces = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.inputReadOnly === false) ? _c('div', {
    staticClass: "calculate-button miuns-button",
    on: {
      "click": function($event) {
        return _vm.minusNum('pieces')
      }
    }
  }, [_vm._v("−")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.hasSlot === false && _vm.onlyPc === false) ? _c('div', {
    staticClass: "interactive-input--wrap row"
  }, [_c('div', {
    staticClass: "col-10"
  }, [_c('div', {
    staticClass: "interactive-input"
  }, [_c('div', {
    staticClass: "input-unit"
  }, [_vm._v("盒/瓶")]), _vm._v(" "), (_vm.inputReadOnly === false) ? _c('div', {
    staticClass: "calculate-button add-button",
    on: {
      "click": function($event) {
        return _vm.addNum('packCount')
      }
    }
  }, [_vm._v("+")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packCount),
      expression: "packCount"
    }],
    ref: "input",
    class: {
      'form-control': true, 'long-input': _vm.inputReadOnly
    },
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "type": "number",
      "readonly": _vm.inputReadOnly,
      "min": "0"
    },
    domProps: {
      "value": (_vm.packCount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.packCount = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.inputReadOnly === false) ? _c('div', {
    staticClass: "calculate-button miuns-button",
    on: {
      "click": function($event) {
        return _vm.minusNum('packCount')
      }
    }
  }, [_vm._v("−")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-multiply"
  }, [_vm._v("X " + _vm._s(_vm.selectedDrug.pack_content))])]), _vm._v(" "), _c('div', {
    staticClass: "interactive-input"
  }, [_c('div', {
    staticClass: "input-unit"
  }, [_vm._v("pc.")]), _vm._v(" "), (_vm.inputReadOnly === false) ? _c('div', {
    staticClass: "calculate-button add-button",
    on: {
      "click": function($event) {
        return _vm.addNum('pieces')
      }
    }
  }, [_vm._v("+")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pieces),
      expression: "pieces"
    }],
    ref: "input",
    class: {
      'form-control': true, 'long-input': _vm.inputReadOnly
    },
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "type": "number",
      "readonly": _vm.inputReadOnly,
      "min": "0"
    },
    domProps: {
      "value": (_vm.pieces)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pieces = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.inputReadOnly === false) ? _c('div', {
    staticClass: "calculate-button miuns-button",
    on: {
      "click": function($event) {
        return _vm.minusNum('pieces')
      }
    }
  }, [_vm._v("−")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-multiply"
  }, [_vm._v("X 1")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-2 amount-sum"
  }, [_c('p', [_vm._v("總數量")]), _vm._v(" "), _c('div', {
    staticClass: "total-num"
  }, [_vm._v("\n          " + _vm._s(_vm.totalSum) + "\n        ")])])]) : _vm._e(), _vm._v(" "), (_vm.hasSlot) ? _vm._t("interactive") : _vm._e(), _vm._v(" "), (_vm.compType === 'Action') ? _c('div', [(_vm.showRemainInfo) ? _c('p', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_vm._v("預計剩餘藥物數量 / 藥盒內數量: " + _vm._s(_vm.remainTotalAmount) + " / " + _vm._s(_vm.remainAmountInDrugInDevice))]) : _vm._e(), _vm._v(" "), (_vm.canDirectlyToNext) ? _c('button', {
    staticClass: "btn btn-lg confirm-button",
    on: {
      "click": _vm.emitData
    }
  }, [_vm._v("關閉抽屜或點選以完成動作")]) : _c('p', {
    staticClass: "hint-text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.constructionContext))]), _vm._v(" "), (_vm.goToNext === false) ? _c('span', [_vm._v("完成動作")]) : _c('span', [_vm._v("進入下一動作")])])]) : _vm._e(), _vm._v(" "), (_vm.compType === 'Confirm') ? _c('div', {
    staticClass: "fake-button-wrap"
  }, [_c('button', {
    staticClass: "btn control-button control-button-red confirm-amount-button",
    attrs: {
      "disabled": !_vm.confirmAvaliable
    },
    on: {
      "click": _vm.confirmAmountAction
    }
  }, [_vm._v("確認數量")])]) : _vm._e()], 2), _vm._v(" "), (_vm.modalStatus.lockDevice) ? _c('lock-device', {
    on: {
      "errorReturned": _vm.errorReturned
    }
  }) : _vm._e(), _vm._v(" "), (_vm.modalStatus.lockDrawer) ? _c('lock-drawer', {
    on: {
      "errorReturned": _vm.errorReturned
    }
  }) : _vm._e(), _vm._v(" "), _c('scan-barcode', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    on: {
      "setBarcode": _vm.confirmReturnEmptyBottle
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1375 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body modal-error"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.context))]), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-white",
    on: {
      "click": _vm.notify
    }
  }, [_vm._v("回主畫面")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1376 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upper-subpanel row"
  }, [_c('progressBar'), _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [(_vm.stage === 'selectEvent') ? _c('EventTable', {
    attrs: {
      "eventType": _vm.eventType
    }
  }) : _vm._e(), (_vm.stage === 'finish') ? _c('Loader') : _vm._e()], 1)], 1), _c('bottom-buttons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  }), _c('action-button', {
    attrs: {
      "slot": "button-9",
      "title": "確認事件",
      "clickable": _vm.selectedEventId.length > 0
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startFlow($event)
      }
    },
    slot: "button-9"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1377 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "locked-mask"
  }, [_c('div', {
    staticClass: "mask-message"
  }, [_c('h5', [_vm._v("目前前台登入中的使用者")]), _c('hr'), _vm._l((_vm.loginedUsers), function(user) {
    return _c('div', {
      staticClass: "text-center"
    }, [_c('span', [_vm._v(_vm._s(user.username) + " ")]), (user.first_name || user.last_name) ? _c('span', [_vm._v("(" + _vm._s(user.last_name) + " " + _vm._s(user.first_name) + ")")]) : _vm._e()])
  }), _c('hr'), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("請等待前台操作完畢")])], 2)])
},staticRenderFns: []}

/***/ }),
/* 1378 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), (_vm.department == 'Admin') ? _c('h4', {
    staticClass: "text-danger"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isMerge),
      expression: "isMerge"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isMerge) ? _vm._i(_vm.isMerge, null) > -1 : (_vm.isMerge)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isMerge,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isMerge = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isMerge = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isMerge = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("是否整合南北向數據報表")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "custom-functions-wrapper"
  }, _vm._l((_vm.reportFunctions), function(func) {
    return _c('div', {
      staticClass: "custom-function"
    }, [_c('h5', [_vm._v(" " + _vm._s(func.name))]), _c('hr'), _c('QueryFilter', {
      attrs: {
        "showDate": func.query_by_date,
        "showEventType": false,
        "showSystem": false,
        "showFilterButton": false
      },
      on: {
        "report": function($event) {
          return _vm.report($event, func.function_name, func.name, func.query_by_date)
        }
      }
    })], 1)
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('kbd', [_vm._v("違規停車報表")])])
}]}

/***/ }),
/* 1379 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shift-layout"
  }, [_c('div', {
    staticClass: "user-pool",
    on: {
      "drop": function($event) {
        $event.preventDefault();
        return _vm.onDrop('unset', $event)
      },
      "dragover": function($event) {
        $event.preventDefault();
        return _vm.onDragover($event)
      }
    }
  }, [_c('h6', [_vm._v("帳號清單")]), _vm._l((_vm.users), function(user) {
    return _c('div', {
      staticClass: "user-item",
      attrs: {
        "id": ("user-" + (user.id)),
        "userid": user.id,
        "draggable": "draggable"
      },
      on: {
        "drag": function($event) {
          return _vm.onDrag($event)
        }
      }
    }, [_vm._v(_vm._s(user.last_name) + _vm._s(user.first_name))])
  })], 2), _c('div', {
    staticClass: "shift-schedule"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('label', {
    staticClass: "mr-2"
  }, [_vm._v("排程日期")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentDate),
      expression: "currentDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.currentDate)
    },
    on: {
      "change": function($event) {
        return _vm.getShift(_vm.currentDate)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentDate = $event.target.value
      }
    }
  })]), _c('table', {
    staticClass: "table table-sm table-bordered"
  }, [_vm._m(0), _c('tbody', _vm._l((_vm.shiftTable), function(shiftRow) {
    return _c('tr', {
      staticClass: "text-center"
    }, [_c('td', {
      staticStyle: {
        "width": "50px"
      }
    }, [_vm._v(_vm._s(shiftRow.bed.code))]), _c('td', {
      attrs: {
        "bedid": shiftRow.bed.id
      },
      on: {
        "drop": function($event) {
          $event.preventDefault();
          return _vm.onDrop('response', $event)
        },
        "dragover": function($event) {
          $event.preventDefault();
          return _vm.onDragover($event)
        }
      }
    }, _vm._l((shiftRow.response), function(shift) {
      return (shiftRow.response.length > 0) ? _c('div', {
        staticClass: "user-item"
      }, [_vm._v(_vm._s(shift.employee.last_name) + _vm._s(shift.employee.first_name)), _c('span', {
        staticClass: "badge badge-danger",
        on: {
          "click": function($event) {
            return _vm.deleteShift(shift.shiftId)
          }
        }
      }, [_vm._v("X")])]) : _vm._e()
    }), 0), _c('td', {
      attrs: {
        "bedid": shiftRow.bed.id
      },
      on: {
        "drop": function($event) {
          $event.preventDefault();
          return _vm.onDrop('circular', $event)
        },
        "dragover": function($event) {
          $event.preventDefault();
          return _vm.onDragover($event)
        }
      }
    }, _vm._l((shiftRow.circular), function(shift) {
      return (shiftRow.circular.length > 0) ? _c('div', {
        staticClass: "user-item"
      }, [_vm._v(_vm._s(shift.employee.last_name) + _vm._s(shift.employee.first_name)), _c('span', {
        staticClass: "badge badge-danger",
        on: {
          "click": function($event) {
            return _vm.deleteShift(shift.shiftId)
          }
        }
      }, [_vm._v("X")])]) : _vm._e()
    }), 0), _c('td', {
      attrs: {
        "bedid": shiftRow.bed.id
      },
      on: {
        "drop": function($event) {
          $event.preventDefault();
          return _vm.onDrop('management', $event)
        },
        "dragover": function($event) {
          $event.preventDefault();
          return _vm.onDragover($event)
        }
      }
    }, _vm._l((shiftRow.management), function(shift) {
      return (shiftRow.management.length > 0) ? _c('div', {
        staticClass: "user-item"
      }, [_vm._v(_vm._s(shift.employee.last_name) + _vm._s(shift.employee.first_name)), _c('span', {
        staticClass: "badge badge-danger",
        on: {
          "click": function($event) {
            return _vm.deleteShift(shift.shiftId)
          }
        }
      }, [_vm._v("X")])]) : _vm._e()
    }), 0)])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-center"
  }, [_c('th', [_vm._v("床號")]), _c('th', [_vm._v("值班人員")]), _c('th', [_vm._v("流動人員 ")]), _c('th', [_vm._v("負責人員")])])])
}]}

/***/ }),
/* 1380 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-layout"
  }, [_c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("\n    此藥物總存量: " + _vm._s(_vm.selectedDrugTotalAmount) + " \n  ")]), _vm._v(" "), (_vm.currentProgress === 'confirmAmount') ? _c('Action', {
    attrs: {
      "defaultNum": _vm.currentDrugInDevice.stock,
      "autoCaculateAmount": false,
      "compType": 'Confirm',
      "valueMoreThanZero": false,
      "defaultPackCount": _vm.currentDrugInDevice.pack_count,
      "deviceId": _vm.currentDrugInDevice.device.id,
      "checkNum": _vm.currentDrugInDevice.max_stock
    },
    on: {
      "confirmAmountFinish": _vm.confirmAmountFinish
    }
  }, [_c('h5', [_vm._v("確認藥盒內數量")])]) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'action') ? _c('Action', {
    attrs: {
      "defaultNum": _vm.currentDrugInDevice.stock,
      "deviceId": _vm.currentDrugInDevice.device.id,
      "defaultPackCount": _vm.currentDrugInDevice.pack_count,
      "valueMoreThanZero": false,
      "inputReadOnly": true
    },
    on: {
      "setActionData": _vm.getActionData
    }
  }, [_c('h5', [_vm._v("藥物移除數量")])]) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'setMinStock') ? _c('NumberSet', {
    attrs: {
      "defaultAmount": _vm.minStorage,
      "canBeZero": true,
      "inputLabel": '更新安全存量'
    },
    on: {
      "setNum": _vm.getMinStorage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'finish') ? _c('Loader') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1381 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Data.stock),
      expression: "Data.stock"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.Data.stock)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Data, "stock", $event.target.value)
      }
    }
  })])])]), _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Data.max_stock),
      expression: "Data.max_stock"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.Data.max_stock)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Data, "max_stock", $event.target.value)
      }
    }
  })])])]), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Data.expired_date),
      expression: "Data.expired_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.Data.expired_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Data, "expired_date", $event.target.value)
      }
    }
  })])])]), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Data.patch_number),
      expression: "Data.patch_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Data.patch_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Data, "patch_number", $event.target.value)
      }
    }
  })])])]), _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "action-button-group"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.update
    }
  }, [_vm._v("更新")]), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.del
    }
  }, [_vm._v("刪除")]), _c('Confirm', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.confirm),
      expression: "confirm"
    }],
    attrs: {
      "message": '確定刪除?'
    },
    on: {
      "response": _vm.confirmDel
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("庫存")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("最大庫存")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("有效期限")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("批號")])])
}]}

/***/ }),
/* 1382 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  " + _vm._s(_vm.rowData) + "\n  "), _c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.rowData.system_set), function(row) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rowData.department.name))]), _vm._v(" "), _vm._m(1, true)])
  }), 0)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("名稱")]), _vm._v(" "), _c('th', [_vm._v("位置")]), _vm._v(" "), _c('th', [_vm._v("動作")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('button', {
    staticClass: "btn btn-danger"
  }, [_vm._v("刪除")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-inline"
  }, [_c('select', {
    staticClass: "form-control col-10"
  }, [_c('option', [_vm._v("Default select")])]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("新增")])])])
}]}

/***/ }),
/* 1383 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("新增藥物"), _c('span', {
    staticClass: "icon-right",
    on: {
      "click": function($event) {
        return _vm.$emit('closeForm')
      }
    }
  }, [_vm._v("X")])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.genericName),
      expression: "genericName"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.genericName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.genericName = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CGMHNumber),
      expression: "CGMHNumber"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.CGMHNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.CGMHNumber = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packageCode2),
      expression: "packageCode2"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.packageCode2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.packageCode2 = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productName),
      expression: "productName"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.productName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.productName = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "input-group col-6"
  }, [_vm._m(5), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packContent),
      expression: "packContent"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.packContent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.packContent = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-group col-6"
  }, [_vm._m(6), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.restrainedClass),
      expression: "restrainedClass"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.restrainedClass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.restrainedClass = $event.target.value
      }
    }
  })])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(7), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licenseId),
      expression: "licenseId"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.licenseId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.licenseId = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.manufacturer),
      expression: "manufacturer"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.manufacturer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.manufacturer = $event.target.value
      }
    }
  })])]), _c('hr'), _c('button', {
    staticClass: "btn btn-secondary float-right",
    attrs: {
      "disabled": _vm.formComplete === false
    },
    on: {
      "click": _vm.addDrug
    }
  }, [_vm._v("新增")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("藥碼*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("學名*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("料位號*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("藥盒條碼")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("產品名")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("單包裝含量*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("管制等級*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("衛生署字號")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("製造廠商")])])
}]}

/***/ }),
/* 1384 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upper-subpanel--inside"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('DrugInfo')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [(_vm.currentProgress === 'confirm') ? _c('ConfirmFlow', {
    attrs: {
      "confirmProgress": _vm.confirmProgress
    },
    on: {
      "confirmationFinish": _vm.getConfirmData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'finish') ? _c('Loader') : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1385 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-10"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_vm._m(0), _c('p', [_vm._v("   ")]), _vm._l((_vm.paras), function(item) {
    return _c('div', [_c('h4', [(item.fixed_link_code == 'B01') ? _c('kbd', {
      staticClass: "navbar-brand-kbd"
    }, [_vm._v("固定桿代碼D01/D03")]) : _vm._e()])])
  })], 2), _c('div', [_c('vuetable', {
    ref: "vuetable",
    attrs: {
      "api-url": (_vm.server + "/api/shoulder-data/"),
      "data-path": "results",
      "pagination-path": "",
      "per-page": 20,
      "fields": _vm.fields,
      "css": _vm.boostrapCss,
      "http-options": _vm.httpOptions,
      "append-params": _vm.moreParams,
      "detail-row-component": "ticket-shoulder-check-detail",
      "sortOrder": _vm.sortOrder
    },
    on: {
      "vuetable:loading": _vm.onLoading,
      "vuetable:loaded": _vm.onLoaded,
      "vuetable:pagination-data": _vm.onPaginationData,
      "vuetable:cell-clicked": _vm.onCellClicked
    }
  }), _c('vuetable-pagination', {
    ref: "pagination",
    attrs: {
      "css": _vm.boostrapCss.pagination
    },
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  })], 1), (_vm.tableDataLen == 0 && _vm.loadingData == false) ? _c('div', [_c('h1', {
    staticClass: "text-center display-4"
  }, [_vm._v("今日無開單資料")])]) : _vm._e()]), _c('div', {
    staticClass: "col-2"
  }, [_vm._m(1), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("開始時間")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.startDate),
      expression: "startDate"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.startDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.startDate = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("結束時間")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.endDate),
      expression: "endDate"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.endDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.endDate = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("過濾條件")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryString),
      expression: "queryString"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "text",
      "placeholder": "輸入車號"
    },
    domProps: {
      "value": (_vm.queryString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.queryString = $event.target.value
      }
    }
  })]), _c('button', {
    staticClass: "btn btn-primary mb-2 w-100",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.onFilterSet
    }
  }, [_vm._v("篩選")])]), (_vm.loadingData) ? _c('Loader', [_c('h4', [_vm._v("資料載入中，請稍等")])]) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('kbd', [_vm._v("行駛路肩開單資訊")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "text-info"
  }, [_c('strong', [_vm._v("請輸入查詢區間")])])
}]}

/***/ }),
/* 1386 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drug-search-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "搜尋藥物名稱"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  }), (_vm.showLoader) ? _c('Loader') : _c('div', {
    staticClass: "drug-search-list"
  }, [(_vm.filterDrugInDeviceList.length !== 0) ? _c('div', [_vm._l((_vm.filterDrugInDeviceList), function(drug, num) {
    return (_vm.viewMode === 'drugStorageList') ? _c('div', {
      class: {
        'btn': true, 'drug-button': true, 'drug-selected': drug.selected, 'avoid-clicks': (drug.stock === 0 && _vm.currentApp.name === '一般取藥') || (drug.max_stock === drug.stock && _vm.currentApp.name === '補充藥物')
      },
      on: {
        "click": function($event) {
          return _vm.selectDrug(drug)
        }
      }
    }, [_c('div', {
      staticClass: "drug-head",
      style: ({
        width: _vm.drugItemHeadWidth
      })
    }, [_c('div', {
      staticClass: "drug-head-icon-wrap"
    }, [_c('font-awesome-layers', {
      staticClass: "fa-lg"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": _vm.circleIcon,
        "size": "lg",
        "color": "orange"
      }
    }), _c('font-awesome-icon', {
      attrs: {
        "icon": _vm.pillBottleIcon,
        "transform": "shrink-6 right-3",
        "color": "white"
      }
    })], 1)], 1), _c('div', {
      staticClass: "drug-head--content"
    }, [_c('span', [_vm._v(_vm._s(drug.medication.CGMH_number) + " - " + _vm._s(drug.medication.code))]), _c('p', [_vm._v(_vm._s(drug.medication.generic_name))])])]), _c('div', {
      staticClass: "drug-item"
    }, [_c('div', {
      staticClass: "info-col",
      attrs: {
        "id": "posistion"
      }
    }, [_c('div', {
      staticClass: "info-col-head"
    }, [_c('span', [_vm._v("位置(櫃-層-列-行)")])]), _c('div', {
      staticClass: "info-col-content"
    }, [_c('p', [_vm._v(_vm._s(drug.device.net.open_times) + " - " + _vm._s(drug.device.net.row_id) + " - " + _vm._s(drug.device.pos_row) + " - " + _vm._s(drug.device.relative_col))])])]), _c('div', {
      staticClass: "info-col",
      attrs: {
        "id": "max-amount"
      }
    }, [_c('div', {
      staticClass: "info-col-head"
    }, [_c('span', [_vm._v("庫存量(最大量)")])]), _c('div', {
      staticClass: "info-col-content"
    }, [_c('p', [_vm._v(_vm._s(drug.stock) + "(" + _vm._s(drug.max_stock) + ")")])])]), _c('div', {
      staticClass: "info-col",
      attrs: {
        "id": "patch"
      }
    }, [_c('div', {
      staticClass: "info-col-head"
    }, [_c('span', [_vm._v("批號")])]), _c('div', {
      staticClass: "info-col-content"
    }, [(drug.patch_number === undefined || drug.patch_number === null || drug.patch_number === '') ? _c('p', [_vm._v("未設定")]) : _c('p', [_vm._v(_vm._s(drug.patch_number))])])]), _c('div', {
      staticClass: "info-col",
      attrs: {
        "id": "expired-date"
      }
    }, [_c('div', {
      staticClass: "info-col-head"
    }, [_c('span', [_vm._v("有效期限")])]), _c('div', {
      staticClass: "info-col-content"
    }, [_c('p', [_vm._v(_vm._s(drug.expired_date))])])])])]) : _vm._e()
  }), _vm._l((_vm.drugStorageByDrug), function(item) {
    return (_vm.viewMode === 'medList') ? _c('div', {
      staticClass: "drug-button btn drug-button-by-med",
      class: {
        'avoid-clicks': (item.stock === 0 && _vm.currentApp.name === '一般取藥'), 'drug-selected': item.selected
      },
      on: {
        "click": function($event) {
          return _vm.selectDrugByMed(item)
        }
      }
    }, [_c('div', {
      staticClass: "drug-head",
      style: ({
        width: _vm.drugItemHeadWidth
      })
    }, [_c('div', {
      staticClass: "drug-head-icon-wrap"
    }, [_c('font-awesome-layers', {
      staticClass: "fa-lg"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": _vm.circleIcon,
        "size": "lg",
        "color": "red"
      }
    }), _c('font-awesome-icon', {
      attrs: {
        "icon": _vm.pillsIcon,
        "transform": "shrink-6 right-2",
        "color": "white"
      }
    })], 1)], 1), _c('div', {
      staticClass: "drug-head--content"
    }, [_c('span', [_vm._v(_vm._s(item.medication.CGMH_number) + " - " + _vm._s(item.medication.code))]), _c('p', [_vm._v(_vm._s(item.medication.generic_name))])])]), _c('div', {
      staticClass: "drug-item"
    }, [_c('div', {
      staticClass: "info-col"
    }, [_c('div', {
      staticClass: "info-col-head"
    }, [_c('span', [_vm._v("藥倉數量")])]), _c('div', {
      staticClass: "info-col-content"
    }, [_c('span', [_vm._v(_vm._s(item.lists.length))])])]), (_vm.$store.state.currentApp.name === '補充藥物') ? _c('div', {
      staticClass: "info-col"
    }, [_c('div', {
      staticClass: "info-col-head"
    }, [_c('span', [_vm._v("可補量")])]), _c('div', {
      staticClass: "info-col-content"
    }, [_c('span', [_vm._v(_vm._s(item.max_stock - item.stock))])])]) : _c('div', {
      staticClass: "info-col"
    }, [_c('div', {
      staticClass: "info-col-head"
    }, [_c('span', [_vm._v("目前存量")])]), _c('div', {
      staticClass: "info-col-content"
    }, [_c('span', [_vm._v(_vm._s(item.stock))])])])])]) : _vm._e()
  }), (_vm.showRefillToNewDrugStorage) ? _c('RefillToNewDrugStorage', {
    on: {
      "refillNewDrugStorage": _vm.refillNewDrugStorage
    }
  }) : _vm._e()], 2) : _c('div', [_c('span', [_vm._v(" 無任何資料")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1387 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upper-subpanel--inside"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('DrugInfo')], 1), _c('div', {
    staticClass: "col-6"
  }, [(_vm.currentProgress === 'medIdInput') ? _c('MedIdInput', {
    attrs: {
      "inputLabel": '輸入病歷號'
    },
    on: {
      "setText": _vm.getMedId
    }
  }) : _vm._e(), (_vm.currentProgress === 'confirm') ? _c('ConfirmFlow', {
    attrs: {
      "actionProgress": _vm.actionProgress,
      "confirmProgress": _vm.confirmProgress,
      "medRecordId": _vm.medRecordId
    },
    on: {
      "confirmationFinish": _vm.getConfirmData
    }
  }) : _vm._e(), (_vm.currentProgress === 'finish') ? _c('Loader') : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1388 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upper-subpanel--inside"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('DrugInfo')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [(_vm.currentProgress === 'confirm') ? _c('ConfirmFlow', {
    attrs: {
      "confirmProgress": _vm.confirmProgress
    },
    on: {
      "confirmationFinish": _vm.getConfirmData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'finish') ? _c('Loader') : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1389 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content modal-success"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('h5', {
    staticClass: "text-center"
  }, [_vm._v("選擇藥物類別")]), _c('div', {
    staticClass: "group-wrapper"
  }, _vm._l((_vm.medGroups), function(group) {
    return _c('div', {
      staticClass: "group-button",
      on: {
        "click": function($event) {
          return _vm.selectGroup(group.id)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(group.name))])])
  }), 0), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-white",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1390 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body modal-error"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.context))]), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-white",
    on: {
      "click": _vm.notify
    }
  }, [_vm._v("回主畫面")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1391 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-layout"
  }, [_c('div', {
    staticClass: "combo-table"
  }, [_vm._m(0), _vm._l((_vm.comboMedsEvent), function(med) {
    return _c('div', {
      staticClass: "combo-row"
    }, [_c('div', {
      staticClass: "combo-cell"
    }, [_vm._v(_vm._s(med.child_medication.generic_name) + " ")]), _c('div', {
      staticClass: "combo-cell"
    }, [_vm._v(_vm._s(_vm._f("fetchedZh")(med.fetched)) + " ")]), _c('div', {
      staticClass: "combo-cell"
    }, [(med.event) ? _c('span', [_vm._v(_vm._s(med.event.employee_name) + " 於 " + _vm._s(_vm._f("timeFromNow")(med.event.record_time)) + "取 " + _vm._s(-(med.event.number1)) + " 單位藥量")]) : _vm._e()])])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "combo-table--head"
  }, [_c('div', {
    staticClass: "combo-cell"
  }, [_vm._v("藥名")]), _c('div', {
    staticClass: "combo-cell"
  }, [_vm._v("取藥狀況")]), _c('div', {
    staticClass: "combo-cell"
  }, [_vm._v("取藥事件")])])
}]}

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "navbar navbar-expand-lg navbar-light container-fluid navbar-admin bg-success text-white"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.home
    }
  }, [_vm._v("首頁")]), _vm._v("\n      \n    "), (_vm.user !== null || _vm.user !== undefined) ? _c('span', {
    attrs: {
      "id": "greeting"
    }
  }, [_vm._v(_vm._s(_vm.GreetingMsg) + ", \n      "), (_vm.user.first_name !== null && _vm.user.last_name !== null) ? _c('span', [_vm._v(_vm._s(_vm.user.last_name) + _vm._s(_vm.user.first_name))]) : _c('span', [_vm._v(_vm._s(_vm.user.username))]), _vm._v(" "), (_vm.user.title !== null) ? _c('span', [_vm._v(_vm._s(_vm.user.title.name))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbarSupportedContent"
    }
  }, [_c('ul', {
    staticClass: "navbar-nav ml-auto"
  }, _vm._l((_vm.navs), function(nav) {
    return (Object.keys(nav.child).length > 0) ? _c('li', {
      staticClass: "nav-item dropdown"
    }, [(nav.privilege) ? _c('div', {
      staticClass: "nav-link dropdown-toggle",
      attrs: {
        "role": "button",
        "data-toggle": "dropdown",
        "aria-haspopup": "true",
        "aria-expanded": "false"
      }
    }, [_vm._v("\n            " + _vm._s(nav.name) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "dropdown-menu",
      attrs: {
        "aria-labelledby": "navbarDropdown"
      }
    }, _vm._l((nav.child), function(child) {
      return (child.privilege) ? _c('router-link', {
        key: child.name,
        staticClass: "dropdown-item",
        attrs: {
          "to": {
            name: child.url
          }
        }
      }, [_vm._v(_vm._s(child.name))]) : _vm._e()
    }), 1)]) : _c('li', {
      staticClass: "nav-item"
    }, [(nav.privilege) ? _c('router-link', {
      staticClass: "nav-link",
      attrs: {
        "to": {
          name: nav.url
        }
      }
    }, [_vm._v("\n            " + _vm._s(nav.name) + "\n          ")]) : _vm._e()], 1)
  }), 0)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("登出")])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid main-container"
  }, [_c('locked-mask', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pageShouldChecked && _vm.frontendLogined),
      expression: "pageShouldChecked && frontendLogined"
    }]
  }), _vm._v(" "), (_vm.$route.name === 'Admin') ? _c('div', {
    class: {
      'admin-hero': true, 'admin-blur': (_vm.pageShouldChecked && _vm.frontendLogined)
    }
  }, [_c('h1', {
    staticClass: "display-4"
  }, [_vm._v("歡迎使用")]), _vm._v(" "), _c('h1', {
    staticClass: "display-4 bg-info text-white rounded"
  }, [_vm._v("彰化台61科技執法後台管理系統")]), _vm._v(" "), (_vm.department == 'Admin') ? _c('div', [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "custom-control custom-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fixedLinkCode4SuperUser),
      expression: "fixedLinkCode4SuperUser"
    }],
    staticClass: "custom-control-input",
    attrs: {
      "type": "radio",
      "id": "defaultGroupExample1",
      "value": "B01"
    },
    domProps: {
      "checked": _vm._q(_vm.fixedLinkCode4SuperUser, "B01")
    },
    on: {
      "change": function($event) {
        _vm.fixedLinkCode4SuperUser = "B01"
      }
    }
  }), _vm._v(" "), _vm._m(3)])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'admin-blur': (_vm.pageShouldChecked && _vm.frontendLogined)
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "container-fluid main-footer bg-warning text-dark"
  }, [_c('p', [_c('small', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Copyright © EST")]), _vm._v(" "), _c('small', {
    staticClass: "float-right font-weight-bold"
  }, [_vm._v("version:" + _vm._s(_vm.version))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "navbar-brand mb-0 h2",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "navbar-brand",
    attrs: {
      "src": __webpack_require__(1187),
      "alt": "changhua-logo",
      "height": "60px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggler",
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "1rem"
    },
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbarSupportedContent",
      "aria-controls": "navbarSupportedContent",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('kbd', [_vm._v("查詢地點選擇 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "custom-control-label",
    attrs: {
      "for": "defaultGroupExample1"
    }
  }, [_c('h5', [_vm._v("台61彰化段(北上)")])])
}]}

/***/ }),
/* 1393 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h6', [_vm._v("藥櫃清單")]), _c('vuetable', {
    ref: "vuetable",
    attrs: {
      "api-url": (_vm.server + "/api/system/?type=ADC"),
      "data-path": "results",
      "pagination-path": "",
      "fields": _vm.fields,
      "api-mode": true,
      "css": _vm.boostrapCss,
      "http-options": _vm.httpOptions,
      "detail-row-component": "adc-detail"
    },
    on: {
      "vuetable:cell-clicked": _vm.onCellClicked
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1394 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), (_vm.img_string == "關閉照片") ? _c('div', {
    staticClass: "col-2"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plt_no),
      expression: "plt_no"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.plt_no)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.plt_no = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.carName),
      expression: "carName"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.carName = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.carTypes), function(item) {
    return _c('option', {
      domProps: {
        "value": item.car_name
      }
    }, [_vm._v(_vm._s(item.car_name))])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": this.$store.state.user.user.username == 'estcheck'
    },
    on: {
      "click": _vm.breakLaw
    }
  }, [_vm._v("確認認證")])]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.showImg
    }
  }, [_vm._v(_vm._s(_vm.img_string))]), _vm._v("\n                   \n    "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": this.$store.state.user.user.username == 'estcheck'
    },
    on: {
      "click": _vm.uncertain
    }
  }, [_vm._v("無法開單")]), _vm._v("\n                   \n    "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": this.$store.state.user.user.username == 'estcheck'
    },
    on: {
      "click": _vm.pass
    }
  }, [_vm._v("未違規")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-10"
  }, [_c('img', {
    staticClass: "car-image",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "bigpic",
      "src": "bigpic"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('kbd', [_vm._v("車牌號碼")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('kbd', [_vm._v("車別 ")])])
}]}

/***/ }),
/* 1395 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-layout"
  }, [_c('div', {
    staticClass: "alert alert-success"
  }, [_c('span', [_vm._v("此藥盒最大存量: " + _vm._s(_vm.currentDrugInDevice.max_stock))]), _vm._v(" "), _c('span', {
    staticClass: "float-right"
  }, [_vm._v("此藥物安全存量: " + _vm._s(_vm.selectedDrugLowAmountLimitData.min_stock))])]), _vm._v(" "), (_vm.currentProgress === 'rxCheck') ? _c('RxCheckBarcode', {
    on: {
      "confirmRx": _vm.confirmRx
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'action') ? _c('Action', {
    attrs: {
      "defaultNum": _vm.currentDrugInDevice.stock,
      "deviceId": _vm.currentDrugInDevice.device.id,
      "checkNum": _vm.currentDrugInDevice.max_stock,
      "valueMoreThanZero": false,
      "defaultPackCount": _vm.currentDrugInDevice.pack_count,
      "limitPackCount": false
    },
    on: {
      "setActionData": _vm.getActionData
    }
  }, [_c('h5', [_vm._v("此藥盒目前數量")])]) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'next') ? _c('Loader') : _vm._e(), _vm._v(" "), (_vm.modalStatus.lowAmount) ? _c('ResetLowAmonutModal', {
    on: {
      "closeModal": _vm.closeModal
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1396 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-layout"
  }, [(_vm.currentDrugInDevice) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("\n    此藥盒目前數量/上限: " + _vm._s(_vm.currentDrugInDevice.stock) + " / " + _vm._s(_vm.currentDrugInDevice.max_stock) + "\n  ")]) : _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("\n    補藥至未使用藥盒\n  ")]), _vm._v(" "), (_vm.currentProgress === 'setPatch') ? _c('ConfirmText', {
    attrs: {
      "inputLabel": '確認批號',
      "defaultContent": _vm.defaultPatchNumber,
      "editable": _vm.patchEditable
    },
    on: {
      "setText": _vm.getPatch
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'setMaxAmount') ? _c('MaxStockSet', {
    on: {
      "setMaxAmountData": _vm.getMaxAmountData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'setExpirationDate') ? _c('ConfirmExpirationDate', {
    attrs: {
      "defaultExpirationDate": _vm.defaultExpirationDate,
      "editable": _vm.dateEditable
    },
    on: {
      "setExpirationDate": _vm.getExpirationDate
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'setRefillNum') ? _c('PackAndPieceSet', {
    attrs: {
      "defaultAmount": _vm.defaultRefillAmount,
      "inputLabel": '補充數量'
    },
    on: {
      "setNum": _vm.getPatchAndPieceData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'rxCheck') ? _c('rx-check-barcode', {
    on: {
      "confirmRx": _vm.confirmRx
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'action') ? _c('ActionWrap', {
    attrs: {
      "startType": _vm.startType,
      "amountPayload": _vm.amountPayload
    },
    on: {
      "setActionData": _vm.getActionData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'finish') ? _c('Loader') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1397 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upper-subpanel row"
  }, [_c('ProgressBar'), _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [(_vm.stage === 'selectDrug') ? _c('SplitLayout', [_c('SelectBox', {
    attrs: {
      "slot": "left",
      "mode": 'onlyDrug'
    },
    slot: "left"
  }), _c('DrugList', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  })], 1) : _vm._e(), (_vm.stage === 'setFlowData') ? _c('MultiFlow', {
    attrs: {
      "multiProgress": _vm.multiProgress,
      "confirmProgress": _vm.confirmProgress
    },
    on: {
      "setAllConfirmData": _vm.getAllConfirmData
    }
  }) : _vm._e(), (_vm.stage === 'finish') ? _c('Loader') : _vm._e()], 1)], 1), _c('BottomButtons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  }), (_vm.stage !== 'setFlowData') ? _c('action-button', {
    attrs: {
      "slot": "button-3",
      "title": "管制藥品"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectAllRestrainedMed($event)
      }
    },
    slot: "button-3"
  }) : _vm._e(), (_vm.stage !== 'setFlowData') ? _c('action-button', {
    attrs: {
      "slot": "button-4",
      "title": "一般藥品"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectAllNormalMed($event)
      }
    },
    slot: "button-4"
  }) : _vm._e(), (_vm.stage !== 'setFlowData') ? _c('action-button', {
    attrs: {
      "slot": "button-4",
      "title": "類別藥物"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectMedByGroup($event)
      }
    },
    slot: "button-4"
  }) : _vm._e(), (_vm.stage !== 'setFlowData') ? _c('action-button', {
    attrs: {
      "slot": "button-7",
      "title": "取消選擇"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.unCheckAll($event)
      }
    },
    slot: "button-7"
  }) : _vm._e(), (_vm.stage !== 'setFlowData') ? _c('action-button', {
    attrs: {
      "slot": "button-6",
      "title": "選擇全部"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.checkAll($event)
      }
    },
    slot: "button-6"
  }) : _vm._e(), (_vm.stage !== 'setFlowData') ? _c('action-button', {
    attrs: {
      "slot": "button-9",
      "title": "開始盤點"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startFlow($event)
      }
    },
    slot: "button-9"
  }) : _vm._e(), (_vm.stage === 'setFlowData') ? _c('action-button', {
    attrs: {
      "slot": "button-8",
      "title": "重設安全存量"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.showLowAmountModal($event)
      }
    },
    slot: "button-8"
  }) : _vm._e()], 1), _c('MedicineGroupSelect', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modalStatus.medGroupSelect),
      expression: "modalStatus.medGroupSelect"
    }],
    on: {
      "setGroup": _vm.getGroupAndSelect
    }
  }), _c('ConfirmModal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showInterruptModal),
      expression: "showInterruptModal"
    }],
    attrs: {
      "message": '是否繼續上次盤點進度？'
    },
    on: {
      "response": _vm.goBackInterrupt
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1398 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('h5', [_vm._v("退藥理由"), _c('button', {
    staticClass: "btn btn-sm btn-info icon-right",
    on: {
      "click": function($event) {
        _vm.createReason = !_vm.createReason
      }
    }
  }, [_vm._v("新增退藥理由")])]), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.createReason) ? _c('div', {
    staticClass: "create-form"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reason),
      expression: "reason"
    }],
    staticClass: "form-control mr-2",
    attrs: {
      "type": "text",
      "placeholder": "輸入欲新增理由"
    },
    domProps: {
      "value": (_vm.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reason = $event.target.value
      }
    }
  }), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.addReason
    }
  }, [_vm._v("新增")])])]) : _vm._e()]), _c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(0), _c('tbody', _vm._l((_vm.returnReason), function(reason, ind) {
    return _c('tr', [_c('th', [_vm._v(_vm._s(reason))]), _c('th', [_c('button', {
      staticClass: "btn btn-sm btn-danger",
      on: {
        "click": function($event) {
          return _vm.deleteReason(ind)
        }
      }
    }, [_vm._v("刪除")])])])
  }), 0)])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("理由")]), _c('th', [_vm._v("動作")])])])
}]}

/***/ }),
/* 1399 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upper-subpanel row"
  }, [_c('progressBar'), _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [(_vm.stage === 'loading') ? _c('Loader') : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stage === 'selectDrug' && _vm.schedules.length > 0 && _vm.viewMethod === 'list'),
      expression: "stage === 'selectDrug' && schedules.length > 0 && viewMethod === 'list'"
    }],
    staticClass: "med-schedule-wrapper"
  }, [_c('div', {
    staticClass: "med-select",
    staticStyle: {
      "height": "100%"
    }
  }, _vm._l((_vm.schedules), function(item, index) {
    return _c('div', {
      staticClass: "med-button",
      class: {
        'selected-med-button': item.selected, 'unselectable': item.amountInSystem === 0
      },
      on: {
        "click": function($event) {
          return _vm.selectMed(index)
        }
      }
    }, [_c('div', {
      attrs: {
        "id": "med_desc"
      }
    }, [_c('h6', [_vm._v(_vm._s(item.medication.code) + " - " + _vm._s(item.medication.CGMH_number))]), _c('h6', [_vm._v(_vm._s(item.medication.generic_name))])]), _c('div', [_c('div', {
      attrs: {
        "id": "amount"
      }
    }, [_c('span', [_vm._v("取藥數量")]), _c('span', [_vm._v(_vm._s(item.amount))])]), _c('div', {
      attrs: {
        "id": "date"
      }
    }, [_c('span', [_vm._v("取藥日期")]), _c('span', [_vm._v(_vm._s(item.fetch_date))])]), _c('div', {
      attrs: {
        "id": "patient"
      }
    }, [_c('span', [_vm._v("病歷號")]), _c('span', [_vm._v(_vm._s(item.patient.med_record_number))])]), _c('div', {
      attrs: {
        "id": "remain_amount"
      }
    }, [_c('span', [_vm._v("系統存量")]), _c('span', [_vm._v(_vm._s(item.amountInSystem))])])])])
  }), 0)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stage === 'selectDrug' && _vm.schedules.length > 0 && _vm.viewMethod === 'drugCategory'),
      expression: "stage === 'selectDrug' && schedules.length > 0 && viewMethod === 'drugCategory'"
    }],
    staticClass: "drug-list-wrapper"
  }, _vm._l((_vm.schedulesByDrug), function(drug) {
    return _c('div', {
      staticClass: "drug-list-item",
      class: {
        'selected-med-button': drug.selected, 'unselectable': drug.amountInSystem === 0
      },
      on: {
        "click": function($event) {
          return _vm.selectScheduleByDrug(drug)
        }
      }
    }, [_c('div', {
      staticClass: "fixed-icon"
    }, [_c('font-awesome-layers', {
      staticClass: "fa-lg fa-fw"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": _vm.faCircle,
        "size": "lg",
        "color": "red"
      }
    }), _c('font-awesome-icon', {
      attrs: {
        "icon": _vm.faPills,
        "transform": "shrink-6 right-2",
        "color": "white"
      }
    })], 1)], 1), _c('div', [_c('p', [_vm._v(_vm._s(drug.medication.CGMH_number) + " - " + _vm._s(drug.medication.code))]), _c('p', [_c('small', [_vm._v(_vm._s(drug.medication.generic_name))])])]), _c('div', [_c('p', [_c('small', [_vm._v("藥物庫存量: " + _vm._s(drug.amountInSystem) + " / 藥單張數: " + _vm._s(drug.listSet.length))])])])])
  }), 0), (_vm.stage === 'selectDrug' && _vm.schedules.length === 0) ? _c('div', {
    staticClass: "with-child-centered"
  }, [_c('h3', [_vm._v("無取藥資料")])]) : _vm._e(), (_vm.stage === 'startFlow') ? _c('MultiFlow', {
    attrs: {
      "multiProgress": _vm.multiProgress,
      "confirmProgress": _vm.confirmProgress,
      "actionProgress": _vm.actionProgress,
      "schedules": _vm.schedules,
      "summarySelectedMed": _vm.summarySelectedMed
    },
    on: {
      "setAllConfirmData": _vm.getAllConfirmData
    }
  }) : _vm._e()], 1)], 1), _c('BottomButtons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面",
      "clickable": _vm.currentApp.cancel
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  }), (_vm.stage === 'selectDrug') ? _c('action-button', {
    attrs: {
      "slot": "button-4",
      "title": "列表模式"
    },
    nativeOn: {
      "click": function($event) {
        _vm.viewMethod = 'list'
      }
    },
    slot: "button-4"
  }) : _vm._e(), (_vm.stage === 'selectDrug') ? _c('action-button', {
    attrs: {
      "slot": "button-3",
      "title": "藥物模式"
    },
    nativeOn: {
      "click": function($event) {
        _vm.viewMethod = 'drugCategory'
      }
    },
    slot: "button-3"
  }) : _vm._e(), (_vm.stage === 'selectDrug') ? _c('action-button', {
    attrs: {
      "slot": "button-7",
      "title": "選擇全部"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectAll($event)
      }
    },
    slot: "button-7"
  }) : _vm._e(), (_vm.stage === 'selectDrug') ? _c('action-button', {
    attrs: {
      "slot": "button-7",
      "title": "取消全選"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deselectAll($event)
      }
    },
    slot: "button-7"
  }) : _vm._e(), (_vm.stage === 'selectDrug') ? _c('action-button', {
    attrs: {
      "slot": "button-9",
      "title": "開始取藥",
      "clickable": Object.values(_vm.summarySelectedMed).length > 0
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startFlow($event)
      }
    },
    slot: "button-9"
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1400 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('h4', {
    attrs: {
      "for": "storage-amount"
    }
  }, [_vm._v(_vm._s(_vm.inputLabel))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }],
    ref: "input",
    staticClass: "form-control custom-input",
    attrs: {
      "type": "text",
      "id": "storage-amount",
      "readonly": _vm.editable === false
    },
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "button-wrap"
  }, [_c('button', {
    staticClass: "btn btn-lg confirm-button",
    on: {
      "click": _vm.setText
    }
  }, [_vm._v("確認")])])])
},staticRenderFns: []}

/***/ }),
/* 1401 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-row"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.showImg
    }
  }, [_vm._v(_vm._s(_vm.img_string))]), _vm._v("\n         \n    "), (this.$store.state.user.user.username == 'aaron') ? _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.returnModify
    }
  }, [_vm._v("退回修正")]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-10"
  }, [_c('img', {
    staticClass: "car-image",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "bigpic",
      "src": "bigpic"
    }
  })])])
}]}

/***/ }),
/* 1402 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.inputLabel))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('h6', {
    staticClass: "text-center"
  }, [_vm._v("藥盒數量 (" + _vm._s(this.selectedDrug.pack_content) + " pc/盒)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packCount),
      expression: "packCount"
    }],
    ref: "input",
    staticClass: "form-control custom-input",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.packCount)
    },
    on: {
      "click": function($event) {
        _vm.showPackPad = true
      },
      "keydown": function($event) {
        _vm.showPackPad = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.packCount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showPackPad) ? _c('NumberInput', {
    attrs: {
      "defaultNumber": _vm.defaultPackCount
    },
    on: {
      "saveNumber": _vm.savePackCount
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('h6', {
    staticClass: "text-center"
  }, [_vm._v("散藥數量（pc）")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pieceCount),
      expression: "pieceCount"
    }],
    ref: "input",
    staticClass: "form-control custom-input",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.pieceCount)
    },
    on: {
      "click": function($event) {
        _vm.showPiecePad = true
      },
      "keydown": function($event) {
        _vm.showPiecePad = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pieceCount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showPiecePad) ? _c('NumberInput', {
    attrs: {
      "defaultNumber": _vm.defaultPieceCount
    },
    on: {
      "saveNumber": _vm.savePieceCount
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "total-amount--text"
  }, [_vm._v("總數量：" + _vm._s(_vm.storageAmount))])], 1), _vm._v(" "), _c('div', {
    staticClass: "button-wrap"
  }, [_c('button', {
    staticClass: "btn btn-lg confirm-button",
    on: {
      "click": _vm.setNum
    }
  }, [_vm._v("確認")])])])
},staticRenderFns: []}

/***/ }),
/* 1403 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-10"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_vm._m(0), _c('p', [_vm._v("   ")]), _vm._l((_vm.paras), function(item) {
    return _c('div', [_c('h4', [(item.fixed_link_code == 'B01') ? _c('kbd', {
      staticClass: "navbar-brand-kbd"
    }, [_vm._v("固定桿代碼B02")]) : _vm._e()]), _c('h4', [(item.fixed_link_code == 'B03') ? _c('kbd', {
      staticClass: "navbar-brand-kbd"
    }, [_vm._v("固定桿代碼B04")]) : _vm._e()])])
  })], 2), _c('div', [_c('vuetable', {
    ref: "vuetable",
    attrs: {
      "api-url": (_vm.server + "/api/cross-line-data/"),
      "data-path": "results",
      "pagination-path": "",
      "per-page": 20,
      "fields": _vm.fields,
      "css": _vm.boostrapCss,
      "http-options": _vm.httpOptions,
      "append-params": _vm.moreParams,
      "detail-row-component": "cross-line-check-detail"
    },
    on: {
      "vuetable:loading": _vm.onLoading,
      "vuetable:loaded": _vm.onLoaded,
      "vuetable:pagination-data": _vm.onPaginationData,
      "vuetable:cell-clicked": _vm.onCellClicked
    }
  }), _c('vuetable-pagination', {
    ref: "pagination",
    attrs: {
      "css": _vm.boostrapCss.pagination
    },
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  })], 1), (_vm.tableDataLen == 0 && _vm.loadingData == false) ? _c('div', [_c('h1', {
    staticClass: "text-center display-4"
  }, [_vm._v("今日無違規資料")])]) : _vm._e()]), _c('div', {
    staticClass: "col-2"
  }, [_vm._m(1), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("開始時間")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.startDate),
      expression: "startDate"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.startDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.startDate = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("結束時間")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.endDate),
      expression: "endDate"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.endDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.endDate = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("過濾條件")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryString),
      expression: "queryString"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "text",
      "placeholder": "輸入車號或開單狀態"
    },
    domProps: {
      "value": (_vm.queryString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.queryString = $event.target.value
      }
    }
  })]), _c('button', {
    staticClass: "btn btn-primary mb-2 w-100",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.onFilterSet
    }
  }, [_vm._v("篩選")])]), (_vm.loadingData) ? _c('Loader', [_c('h4', [_vm._v("資料載入中，請稍等")])]) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('kbd', [_vm._v("違規停車資訊")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "text-info"
  }, [_c('strong', [_vm._v("請輸入查詢區間")])])
}]}

/***/ }),
/* 1404 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-10"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_vm._m(0), _c('p', [_vm._v("   ")]), _vm._l((_vm.paras), function(item) {
    return _c('div', [_c('h4', [(item.fixed_link_code == 'B01') ? _c('kbd', {
      staticClass: "navbar-brand-kbd"
    }, [_vm._v("固定桿代碼B02")]) : _vm._e()]), _c('h4', [(item.fixed_link_code == 'B03') ? _c('kbd', {
      staticClass: "navbar-brand-kbd"
    }, [_vm._v("固定桿代碼B04")]) : _vm._e()])])
  })], 2), _c('div', [_c('vuetable', {
    ref: "vuetable",
    attrs: {
      "api-url": (_vm.server + "/api/cross-line-data/"),
      "data-path": "results",
      "pagination-path": "",
      "per-page": 20,
      "fields": _vm.fields,
      "css": _vm.boostrapCss,
      "http-options": _vm.httpOptions,
      "append-params": _vm.moreParams,
      "detail-row-component": "ticket-cross-line-check-detail",
      "sortOrder": _vm.sortOrder
    },
    on: {
      "vuetable:loading": _vm.onLoading,
      "vuetable:loaded": _vm.onLoaded,
      "vuetable:pagination-data": _vm.onPaginationData,
      "vuetable:cell-clicked": _vm.onCellClicked
    }
  }), _c('vuetable-pagination', {
    ref: "pagination",
    attrs: {
      "css": _vm.boostrapCss.pagination
    },
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  })], 1), (_vm.tableDataLen == 0 && _vm.loadingData == false) ? _c('div', [_c('h1', {
    staticClass: "text-center display-4"
  }, [_vm._v("今日無開單資料")])]) : _vm._e()]), _c('div', {
    staticClass: "col-2"
  }, [_vm._m(1), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("開始時間")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.startDate),
      expression: "startDate"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.startDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.startDate = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("結束時間")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.endDate),
      expression: "endDate"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.endDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.endDate = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("過濾條件")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryString),
      expression: "queryString"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "text",
      "placeholder": "輸入車號"
    },
    domProps: {
      "value": (_vm.queryString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.queryString = $event.target.value
      }
    }
  })]), _c('button', {
    staticClass: "btn btn-primary mb-2 w-100",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.onFilterSet
    }
  }, [_vm._v("篩選")])]), (_vm.loadingData) ? _c('Loader', [_c('h4', [_vm._v("資料載入中，請稍等")])]) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('kbd', [_vm._v("違規停車開單資訊")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "text-info"
  }, [_c('strong', [_vm._v("請輸入查詢區間")])])
}]}

/***/ }),
/* 1405 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "col-6"
  }, [_vm._t("left")], 2), _c('div', {
    staticClass: "col-6"
  }, [_vm._t("right")], 2)])
},staticRenderFns: []}

/***/ }),
/* 1406 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upper-subpanel row"
  }, [_c('progressBar'), _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [(_vm.stage === 'scanBarcode') ? _c('scanBarcode', {
    on: {
      "setBarcode": _vm.getBarcode
    }
  }, [_c('div', {
    staticClass: "with-child-centered"
  }, [_c('h3', [_vm._v("請掃描藥單條碼進行"), _c('strong', [_vm._v("取藥")])])])]) : _vm._e(), (_vm.stage === 'selectDrug') ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "col-12",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('drugList', {
    attrs: {
      "singleSelection": false,
      "viewMode": 'medList'
    }
  })], 1)]) : _vm._e(), (_vm.stage === 'setFlowData') ? _c('MultiFlow', {
    attrs: {
      "startActionType": _vm.startActionType,
      "multiProgress": _vm.multiProgress,
      "confirmProgress": _vm.confirmProgress,
      "actionProgress": _vm.actionProgress,
      "barcodeData": _vm.barcodeData
    },
    on: {
      "setAllConfirmData": _vm.getAllConfirmData
    }
  }) : _vm._e(), (_vm.stage === 'finish') ? _c('Loader') : _vm._e()], 1)], 1), _c('BottomButtons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面",
      "id": "cancel",
      "clickable": _vm.currentApp.cancel
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  }), (_vm.stage !== 'setFlowData' && _vm.stage !== 'finish') ? _c('action-button', {
    attrs: {
      "slot": "button-4",
      "title": "掃描條碼"
    },
    nativeOn: {
      "click": function($event) {
        _vm.stage = 'scanBarcode'
      }
    },
    slot: "button-4"
  }) : _vm._e(), (_vm.stage !== 'setFlowData' && _vm.stage !== 'finish') ? _c('action-button', {
    attrs: {
      "slot": "button-5",
      "title": "全部藥物"
    },
    nativeOn: {
      "click": function($event) {
        _vm.stage = 'selectDrug'
      }
    },
    slot: "button-5"
  }) : _vm._e(), (_vm.stage === 'selectDrug') ? _c('action-button', {
    attrs: {
      "slot": "button-8",
      "title": "調撥藥品"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startFlow('FETCH_TRANSFER')
      }
    },
    slot: "button-8"
  }) : _vm._e(), (_vm.stage === 'selectDrug') ? _c('action-button', {
    attrs: {
      "slot": "button-9",
      "title": "開始取藥"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startFlow('FETCH')
      }
    },
    slot: "button-9"
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1407 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _c('div', {
    staticClass: "user-layout-head"
  }, [_c('button', {
    staticClass: "btn btn-info icon-right",
    on: {
      "click": function($event) {
        _vm.createForm = true
      }
    }
  }, [_vm._v("新增使用者")]), (_vm.createForm) ? _c('CreateUserForm', {
    on: {
      "closeForm": _vm.closeForm
    }
  }) : _vm._e(), _c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onFilterSet($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control mr-2",
    attrs: {
      "type": "text",
      "placeholder": "輸入帳號,姓或名"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("搜尋")])])], 1), _c('h6', [_vm._v("使用者清單")]), _c('vuetable', {
    ref: "vuetable",
    attrs: {
      "api-url": (_vm.server + "/api/normal-user/"),
      "data-path": "results",
      "pagination-path": "",
      "per-page": 20,
      "fields": _vm.fields,
      "css": _vm.boostrapCss,
      "http-options": _vm.httpOptions,
      "append-params": _vm.moreParams,
      "detail-row-component": "user-detail"
    },
    on: {
      "vuetable:pagination-data": _vm.onPaginationData,
      "vuetable:cell-clicked": _vm.onCellClicked
    }
  }), _c('vuetable-pagination', {
    ref: "pagination",
    attrs: {
      "css": _vm.boostrapCss.pagination
    },
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('kbd', [_vm._v("使用者清單資訊")])])
}]}

/***/ }),
/* 1408 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drug-panel"
  }, [_c('div', {
    staticClass: "drug-panel--heads"
  }, [_c('button', {
    staticClass: "btn btn-info icon-right",
    on: {
      "click": function($event) {
        _vm.createDrugGroupForm = true
      }
    }
  }, [_vm._v("新增群組")]), (_vm.createDrugGroupForm) ? _c('CreateDrugGroupForm', {
    on: {
      "closeForm": _vm.closeDrugGroupForm,
      "dataCreated": _vm.dataCreated
    }
  }) : _vm._e()], 1), _c('vuetable', {
    ref: "vuetableGroup",
    attrs: {
      "api-url": (_vm.server + "/api/medication-group/"),
      "data-path": "",
      "fields": _vm.categoryField,
      "http-options": _vm.httpOptions,
      "pagination-path": "",
      "css": _vm.boostrapCss,
      "detail-row-component": "drug-group-detail"
    },
    on: {
      "vuetable:cell-clicked": _vm.onGroupClicked
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(props) {
        return [_c('button', {
          staticClass: "btn btn-danger btn-sm",
          on: {
            "click": function($event) {
              return _vm.deleteGroup(props.rowData)
            }
          }
        }, [_vm._v("刪除群組")])]
      }
    }])
  }, [_c('medicationGroupCount')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1409 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upper-subpanel row"
  }, [_c('progressBar'), _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [(_vm.getMedGroup === false && _vm.stage === 'medGroupList') ? _c('Loader') : _vm._e(), (_vm.getMedGroup && _vm.stage === 'medGroupList' && Object.values(_vm.group).length !== 0) ? _c('div', {
    staticClass: "med-group-wrapper"
  }, [_c('ul', {
    staticClass: "nav nav-pills nav-fill nav-autoix"
  }, _vm._l((_vm.group), function(g, index) {
    return _c('li', {
      staticClass: "nav-item",
      on: {
        "click": function($event) {
          _vm.currentGroupIndex = index
        }
      }
    }, [_c('div', {
      staticClass: "nav-link",
      class: {
        'active': _vm.currentGroupIndex === index
      }
    }, [_vm._v(_vm._s(g.name))])])
  }), 0), _c('div', {
    staticClass: "med-select"
  }, _vm._l((_vm.group[_vm.currentGroupIndex].medicine_set), function(med, index) {
    return _c('div', {
      staticClass: "med-button",
      class: {
        'selected-med-button': med.selected, 'unselectable': med.amountInSystem === 0
      },
      on: {
        "click": function($event) {
          return _vm.selectMed(index)
        }
      }
    }, [_c('div', {
      attrs: {
        "id": "med_desc"
      }
    }, [_c('h6', [_vm._v(_vm._s(med.code) + " - " + _vm._s(med.CGMH_number))]), _c('h6', [_vm._v(_vm._s(med.generic_name))])]), _c('div', {
      attrs: {
        "id": "remain_amount"
      }
    }, [_c('span', [_vm._v("系統存量")]), _c('span', [_vm._v(_vm._s(med.amountInSystem))])])])
  }), 0)]) : _vm._e(), (_vm.getMedGroup && _vm.stage === 'medGroupList' && Object.values(_vm.group).length === 0) ? _c('div', {
    staticClass: "with-child-centered"
  }, [_c('h4', [_vm._v("未設定類別藥物")])]) : _vm._e(), (_vm.stage === 'startFlow') ? _c('MultiFlow', {
    attrs: {
      "multiProgress": _vm.multiProgress,
      "confirmProgress": _vm.confirmProgress,
      "actionProgress": _vm.actionProgress
    },
    on: {
      "setAllConfirmData": _vm.getAllConfirmData
    }
  }) : _vm._e()], 1)], 1), _c('BottomButtons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面",
      "clickable": _vm.currentApp.cancel
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  }), (_vm.$store.state.user.user.med_app_privilege.fetch_by_schedule && _vm.stage !== 'startFlow') ? _c('action-button', {
    attrs: {
      "slot": "button-3",
      "title": "醫囑取藥"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'schedule',
          params: {
            stage: 'ComboMedListAndPatient'
          }
        })
      }
    },
    slot: "button-3"
  }) : _vm._e(), (_vm.stage !== 'startFlow') ? _c('action-button', {
    attrs: {
      "slot": "button-9",
      "title": "開始取藥",
      "clickable": _vm.DrugsForFetchList.length > 0
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startFlow($event)
      }
    },
    slot: "button-9"
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1410 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.stage === 'action') ? _c('Action', {
    attrs: {
      "inputReadOnly": true,
      "defaultNum": _vm.amountPayload.emptyCount,
      "deviceId": _vm.currentEvent.device.id,
      "onlyPc": true
    },
    on: {
      "setActionData": _vm.getThisAmount
    }
  }, [_c('h5', [_vm._v("此藥盒取出空瓶數量")])]) : _vm._e(), (_vm.stage === 'finish') ? _c('Loader') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1411 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [(_vm.medicineType === 'control') ? _c('p', [_vm._v("新增管制藥組")]) : _vm._e(), (_vm.medicineType === 'combo') ? _c('p', [_vm._v("新增套藥"), _c('span', {
    staticClass: "icon-right",
    on: {
      "click": function($event) {
        return _vm.$emit('closeForm')
      }
    }
  }, [_vm._v("X")])]) : _vm._e(), _c('hr'), _c('form', {
    staticClass: "form-row",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addDrug($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group col-5"
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-group col-5"
  }, [_vm._m(1), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.genericName),
      expression: "genericName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.genericName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.genericName = $event.target.value
      }
    }
  })]), _c('button', {
    staticClass: "btn btn-secondary float-right",
    attrs: {
      "disabled": _vm.formComplete === false,
      "type": "submit"
    }
  }, [_vm._v("新增")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("代稱*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("全名*")])])
}]}

/***/ }),
/* 1412 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-row"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.showImg
    }
  }, [_vm._v(_vm._s(_vm.img_string))]), _vm._v("\n                   \n    "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": this.$store.state.user.user.username == 'estcheck'
    },
    on: {
      "click": _vm.returnModify
    }
  }, [_vm._v("退回修正")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-10"
  }, [_c('img', {
    staticClass: "car-image",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "bigpic",
      "src": "bigpic"
    }
  })])])
}]}

/***/ }),
/* 1413 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('h4', {
    staticClass: "text-center",
    attrs: {
      "for": "storage-amount"
    }
  }, [_vm._v(_vm._s(_vm.inputLabel))]), _vm._v(" "), (_vm.inputLabel === '更新安全存量') ? _c('h6', [_vm._v("\n      目前此藥物還有數量 "), _c('strong', [_vm._v(_vm._s(_vm.$store.state.drug.selectedDrugTotalAmount))]), _vm._v(" 在藥櫃中\n    ")]) : _vm._e(), _vm._v(" "), (_vm.inputLabel === '更新安全存量') ? _c('h6', [_vm._v("\n      (總最大庫存數量 "), _c('strong', [_vm._v(_vm._s(_vm.$store.state.drug.selectedDrugTotalMax))]), _vm._v(")\n    ")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storageAmount),
      expression: "storageAmount"
    }],
    ref: "input",
    staticClass: "form-control custom-input",
    attrs: {
      "type": "number",
      "id": "storage-amount",
      "min": "0"
    },
    domProps: {
      "value": (_vm.storageAmount)
    },
    on: {
      "click": function($event) {
        _vm.showPad = true
      },
      "keydown": function($event) {
        _vm.showPad = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.storageAmount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showPad) ? _c('NumberInput', {
    attrs: {
      "defaultNumber": _vm.storageAmount
    },
    on: {
      "saveNumber": _vm.saveNumber
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "button-wrap"
  }, [_c('button', {
    staticClass: "btn btn-lg confirm-button",
    on: {
      "click": _vm.setNum
    }
  }, [_vm._v("確認")])])])
},staticRenderFns: []}

/***/ }),
/* 1414 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drug-button btn drug-button-by-med",
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "padding": "1.5rem 0"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('refillNewDrugStorage')
      }
    }
  }, [_c('span', [_vm._v("無相同批號？補藥至新的藥盒")])])
},staticRenderFns: []}

/***/ }),
/* 1415 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.rowData.parent_system !== null) ? _c('div', {
    staticClass: "detail-layout"
  }, [_c('h5', {
    staticClass: "text-center"
  }, [_vm._v("請在母系統設定")])]) : _c('div', {
    staticClass: "detail-layout"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('h6', [_vm._v("系統設定")]), _c('hr'), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("系統名稱")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.systemName),
      expression: "systemName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.systemName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.systemName = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("所屬區域")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.areaId),
      expression: "areaId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.areaId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.area), function(item) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 0)]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("管理者")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adminId),
      expression: "adminId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.adminId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.user), function(item) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 0)])]), _c('div', {
    staticClass: "col-3"
  }, [_c('h6', [_vm._v("其他設定")]), _c('hr'), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("藥物即期提醒時間(天)")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.alert_outdated_day),
      expression: "settings.alert_outdated_day"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.settings.alert_outdated_day)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings, "alert_outdated_day", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("前台自動登出(分)")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.app_login_timeout),
      expression: "settings.app_login_timeout"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.settings.app_login_timeout)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings, "app_login_timeout", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "switch-wrapper"
  }, [_c('div', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.return_to_original_cmpn),
      expression: "settings.return_to_original_cmpn"
    }],
    attrs: {
      "id": "switch-original-cmpn",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.return_to_original_cmpn) ? _vm._i(_vm.settings.return_to_original_cmpn, null) > -1 : (_vm.settings.return_to_original_cmpn)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.settings.return_to_original_cmpn,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.settings, "return_to_original_cmpn", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.settings, "return_to_original_cmpn", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.settings, "return_to_original_cmpn", $$c)
        }
      }
    }
  }), _c('label', {
    staticClass: "slider",
    class: {
      'slider-on': _vm.settings.return_to_original_cmpn
    },
    attrs: {
      "for": "switch-original-cmpn"
    }
  })]), _c('span', {
    staticClass: "switch-title"
  }, [_vm._v("退回原藥盒")])]), _c('div', {
    staticClass: "switch-wrapper"
  }, [_c('div', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.check_amount_first),
      expression: "settings.check_amount_first"
    }],
    attrs: {
      "id": "switch-check-amount",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.check_amount_first) ? _vm._i(_vm.settings.check_amount_first, null) > -1 : (_vm.settings.check_amount_first)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.settings.check_amount_first,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.settings, "check_amount_first", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.settings, "check_amount_first", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.settings, "check_amount_first", $$c)
        }
      }
    }
  }), _c('label', {
    staticClass: "slider",
    class: {
      'slider-on': _vm.settings.check_amount_first
    },
    attrs: {
      "for": "switch-check-amount"
    }
  })]), _c('span', {
    staticClass: "switch-title"
  }, [_vm._v("動作前確認藥物")])]), (_vm.settings.type === 'nursing') ? _c('div', {
    staticClass: "switch-wrapper"
  }, [_c('div', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.fetch_return_empty_same_time),
      expression: "settings.fetch_return_empty_same_time"
    }],
    attrs: {
      "id": "switch-fetch-and-return-empty",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.fetch_return_empty_same_time) ? _vm._i(_vm.settings.fetch_return_empty_same_time, null) > -1 : (_vm.settings.fetch_return_empty_same_time)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.settings.fetch_return_empty_same_time,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.settings, "fetch_return_empty_same_time", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.settings, "fetch_return_empty_same_time", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.settings, "fetch_return_empty_same_time", $$c)
        }
      }
    }
  }), _c('label', {
    staticClass: "slider",
    class: {
      'slider-on': _vm.settings.fetch_return_empty_same_time
    },
    attrs: {
      "for": "switch-fetch-and-return-empty"
    }
  })]), _c('span', {
    staticClass: "switch-title"
  }, [_vm._v("取藥時同時退回藥瓶")])]) : _vm._e()])]), _c('div', {
    staticClass: "col-3"
  }, [_c('h6', [_vm._v("退藥理由")]), _c('hr'), _c('table', {
    staticClass: "table"
  }, [_vm._m(0), _c('tbody', _vm._l((_vm.returnReason), function(reason, ind) {
    return _c('tr', [_c('th', {
      staticStyle: {
        "vertical-align": "middle"
      }
    }, [_c('span', [_vm._v(_vm._s(reason))])]), _c('th', [_c('button', {
      staticClass: "btn btn-sm btn-danger",
      on: {
        "click": function($event) {
          return _vm.deleteReason(ind)
        }
      }
    }, [_vm._v("刪除")])])])
  }), 0)]), _c('button', {
    staticClass: "btn btn-sm btn-info mb-2",
    on: {
      "click": function($event) {
        _vm.createReason = !_vm.createReason
      }
    }
  }, [_vm._v("新增退藥理由")]), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.createReason) ? _c('div', {
    staticClass: "create-form"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reason),
      expression: "reason"
    }],
    staticClass: "form-control mr-1",
    attrs: {
      "type": "text",
      "placeholder": "輸入欲新增理由"
    },
    domProps: {
      "value": (_vm.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reason = $event.target.value
      }
    }
  }), _c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": _vm.addReason
    }
  }, [_vm._v("新增")])])]) : _vm._e()])], 1), (_vm.rowData.settings.mode === 'aeth') ? _c('div', {
    staticClass: "col-3"
  }, [_c('h6', [_vm._v("排程設定")]), _c('hr'), _c('div', {
    staticClass: "switch-wrapper mb-2"
  }, [_c('div', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.shift_system_status),
      expression: "settings.shift_system_status"
    }],
    attrs: {
      "id": "switch-shift",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.shift_system_status) ? _vm._i(_vm.settings.shift_system_status, null) > -1 : (_vm.settings.shift_system_status)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.settings.shift_system_status,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.settings, "shift_system_status", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.settings, "shift_system_status", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.settings, "shift_system_status", $$c)
        }
      }
    }
  }), _c('label', {
    staticClass: "slider",
    class: {
      'slider-on': _vm.settings.shift_system_status
    },
    attrs: {
      "for": "switch-shift"
    }
  })]), _c('span', {
    staticClass: "switch-title"
  }, [_vm._v("使用班表系統")])]), _c('div', {
    staticClass: "mb-2"
  }, [(_vm.settings.shift_system_status) ? _c('router-link', {
    staticClass: "btn btn-sm btn-info",
    attrs: {
      "to": {
        name: 'ShiftArrange'
      }
    }
  }, [_vm._v("檢視班表設定")]) : _vm._e()], 1), _c('div', [_c('router-link', {
    staticClass: "btn btn-sm btn-info",
    attrs: {
      "to": {
        name: 'ScheduleList'
      }
    }
  }, [_vm._v("檢視手術排程")])], 1)]) : _vm._e()]), _c('hr'), _c('button', {
    staticClass: "btn btn-primary float-right mb-2",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("儲存設定")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [_c('th', {
    staticClass: "w-75"
  }, [_vm._v("理由")]), _c('th', [_vm._v("動作")])])])
}]}

/***/ }),
/* 1416 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Patch', [_c('h5', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("紀錄報表")])])
},staticRenderFns: []}

/***/ }),
/* 1417 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drug-group-detail--layout"
  }, [_vm._l((_vm.medicineSet), function(med, num) {
    return _c('div', {
      staticClass: "single-med"
    }, [_c('span', [_vm._v(_vm._s(med.generic_name))]), _c('div', {
      staticClass: "btn-remove",
      on: {
        "click": function($event) {
          return _vm.deleteDrugFromGroup(num)
        }
      }
    }, [_vm._v("x")])])
  }), _c('hr'), _c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addDrugToGroup($event)
      }
    }
  }, [_c('div', {
    staticClass: "search-dynamic",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchDrug),
      expression: "searchDrug"
    }],
    staticClass: "form-control mr-2",
    attrs: {
      "placeholder": "輸入藥碼, 學名或料位號"
    },
    domProps: {
      "value": (_vm.searchDrug)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchDrug = $event.target.value
      }
    }
  }), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.addDrugToGroup
    }
  }, [_vm._v("新增")])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchMedicines.length !== 0),
      expression: "searchMedicines.length !== 0"
    }],
    staticClass: "input-options-wrap"
  }, _vm._l((_vm.searchMedicines), function(med, num) {
    return _c('div', {
      staticClass: "input-option",
      on: {
        "click": function($event) {
          return _vm.setMedicine(num)
        }
      }
    }, [_vm._v(_vm._s(med.code) + " - " + _vm._s(med.CGMH_number) + " - " + _vm._s(med.generic_name))])
  }), 0)])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("選擇藥物")])])
}]}

/***/ }),
/* 1418 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    class: {
      'modal-content': true,
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('span', [_vm._v("請輸入新密碼")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password1),
      expression: "password1"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.password1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("請再一次輸入新密碼")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password2),
      expression: "password2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.password2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password2 = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errMsg !== '') ? _c('span', {
    staticClass: "error-message"
  }, [_c('small', [_vm._v(_vm._s(_vm.errMsg))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.password1 !== _vm.password2
    },
    on: {
      "click": _vm.changePassword
    }
  }, [_vm._v("確定更改")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": _vm.closePanel
    }
  }, [_vm._v("取消")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1419 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upper-subpanel--inside"
  }, [(_vm.stage === 'confirm') ? _c('ConfirmFlow', {
    attrs: {
      "actionType": _vm.actionType
    },
    on: {
      "confirmationFinish": _vm.getConfirmData
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1420 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-layout"
  }, [_c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("\n    此藥物總存量: " + _vm._s(_vm.selectedDrugTotalAmount) + " \n    "), (_vm.perscription !== 0) ? _c('span', {
    staticClass: "float-right"
  }, [_vm._v("處方籤數量: " + _vm._s(_vm.perscription))]) : _vm._e()]), _vm._v(" "), (_vm.currentProgress === 'setFetchNum') ? _c('ConfirmStorage', {
    attrs: {
      "defaultAmount": _vm.defaultAmount,
      "inputLabel": '處方籤數量'
    },
    on: {
      "setNum": _vm.getStorageAmount
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'MedIdInput') ? _c('MedIdInput', {
    attrs: {
      "inputLabel": _vm.textInpuTitle
    },
    on: {
      "setText": _vm.getMedId
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'rxCheck') ? _c('rx-check-barcode', {
    on: {
      "confirmRx": _vm.confirmRx
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'actionWrap') ? _c('ActionWrap', {
    attrs: {
      "startActionType": _vm.startActionType,
      "actionProgress": _vm.actionProgress,
      "medRecordId": _vm.medRecordId,
      "barcodeData": _vm.barcodeData,
      "reviewer": _vm.reviewer,
      "amount": _vm.perscription
    },
    on: {
      "setActionData": _vm.getFetchData
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1421 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upper-subpanel"
  }, [_c('router-view')], 1), _vm._v(" "), _c('bottom-buttons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1422 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-10"
  }, [_c('viewer', [_c('img', {
    staticClass: "car-image",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "bigpic",
      "src": "bigpic"
    }
  })])], 1), _vm._v(" "), (_vm.img_string == "關閉照片") ? _c('div', {
    staticClass: "col-2"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plt_no),
      expression: "plt_no"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.plt_no)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.plt_no = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.carName),
      expression: "carName"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.carName = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.carTypes), function(item) {
    return _c('option', {
      domProps: {
        "value": item.car_name
      }
    }, [_vm._v(_vm._s(item.car_name))])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": this.$store.state.user.user.username == 'estcheck'
    },
    on: {
      "click": _vm.breakLaw
    }
  }, [_vm._v("確認認證")])]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.showImg
    }
  }, [_vm._v(_vm._s(_vm.img_string))]), _vm._v("\n                   \n    "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": this.$store.state.user.user.username == 'estcheck'
    },
    on: {
      "click": _vm.uncertain
    }
  }, [_vm._v("無法開單")]), _vm._v("\n                   \n    "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": this.$store.state.user.user.username == 'estcheck'
    },
    on: {
      "click": _vm.pass
    }
  }, [_vm._v("未違規")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('kbd', [_vm._v("車牌號碼")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('kbd', [_vm._v("車別")])])
}]}

/***/ }),
/* 1423 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.rowData.combo.length > 0) ? _c('div', {
    staticClass: "combo-detail"
  }, [_vm._m(0), _vm._l((_vm.rowData.combo), function(pair) {
    return _c('div', {
      staticClass: "one-med"
    }, [_c('div', {
      attrs: {
        "id": "medication_generic_name"
      }
    }, [_vm._v(_vm._s(pair.medication.generic_name) + " ")]), _c('div', {
      staticClass: "text-center",
      attrs: {
        "id": "dose"
      }
    }, [_vm._v(_vm._s(pair.dose))]), _c('div', {
      staticClass: "text-center",
      attrs: {
        "id": "action"
      }
    }, [_c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.deleteFromCombo(pair.relation_id)
        }
      }
    }, [_vm._v("刪除")])])])
  })], 2) : _vm._e(), _c('span', [_vm._v("新增藥物至此套藥組")]), _c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addDrugToCombo($event)
      }
    }
  }, [_c('div', {
    staticClass: "search-dynamic",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "input-group mr-2"
  }, [_vm._m(1), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchDrug),
      expression: "searchDrug"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "輸入藥碼, 學名或料位號"
    },
    domProps: {
      "value": (_vm.searchDrug)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchDrug = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-group mr-2"
  }, [_vm._m(2), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dose),
      expression: "dose"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "輸入預設劑量",
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": (_vm.dose)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dose = $event.target.value
      }
    }
  })]), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.pairAddable === false
    }
  }, [_vm._v("新增")]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchMedicines.length !== 0),
      expression: "searchMedicines.length !== 0"
    }],
    staticClass: "input-options-wrap"
  }, _vm._l((_vm.searchMedicines), function(med, num) {
    return _c('div', {
      staticClass: "input-option",
      on: {
        "click": function($event) {
          return _vm.setMedicine(num)
        }
      }
    }, [_vm._v(_vm._s(med.code) + " - " + _vm._s(med.CGMH_number) + " - " + _vm._s(med.generic_name) + "    ")])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "combo-detail--head"
  }, [_c('div', [_vm._v("藥物名稱")]), _c('div', {
    staticClass: "text-center"
  }, [_vm._v("數量")]), _c('div', {
    staticClass: "text-center"
  }, [_vm._v("刪除")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("藥物")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("劑量")])])
}]}

/***/ }),
/* 1424 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "with-child-centered",
    staticStyle: {
      "height": "100%"
    }
  }, [(_vm.getScheduled === false) ? _c('Loader') : _vm._e(), (_vm.scheduleByPatient.length > 0 && _vm.getScheduled) ? _c('div', {
    staticClass: "schedules-wrapper"
  }, [(false) ? _c('div', {
    staticClass: "with-child-centered"
  }, [_c('h4', [_vm._v("今日無病人須於此藥櫃操作")])]) : _c('SplitLayout', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }, [_c('h5', {
    staticClass: "text-center"
  }, [_vm._v("1.選擇病人")]), _c('div', {
    staticStyle: {
      "height": "418px",
      "overflow-y": "auto"
    }
  }, _vm._l((_vm.scheduleByPatient), function(patient, ind) {
    return _c('div', {
      class: {
        'surgery-item': true, 'sch-selected': ind === _vm.patientSelected
      },
      style: ({
        display: 'inline-block',
        width: '98%',
        backgroundColor: _vm.colormaps[(ind % _vm.colormaps.length)],
        color: 'white',
        border: '1px solid transparent'
      }),
      on: {
        "click": function($event) {
          return _vm.patientSelectFun(ind)
        }
      }
    }, [_c('p', [_c('span', {
      staticStyle: {
        "padding-right": "1rem"
      }
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": _vm.faUser,
        "color": "white"
      }
    })], 1), _c('strong', [_c('span', [_vm._v(_vm._s(patient.patient.med_record_number) + " ")]), _c('span', [_vm._v(_vm._s(patient.patient.name) + " ")]), (patient.patient.gender) ? _c('span', [_vm._v("( " + _vm._s(_vm._f("genderZh")(patient.patient.gender)) + " )")]) : _vm._e()]), _c('span', {
      staticClass: "float-right"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("areaFormat")(_vm.$store.state.device.systemArea)))]), _c('span', [_vm._v(_vm._s(patient.bed.code))])])])])
  }), 0)]), _c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('h5', {
    staticClass: "text-center"
  }, [_vm._v("2.手術相關資訊")]), _c('div', {
    staticStyle: {
      "height": "418px",
      "overflow-y": "auto"
    }
  }, [(_vm.patientSelected !== undefined) ? _c('div', _vm._l((_vm.scheduleByPatient[_vm.patientSelected].schedules), function(schedule, ind) {
    return _c('div', {
      class: {
        'surgery-item': true
      },
      style: ({
        display: 'inline-block',
        width: '98%'
      }),
      on: {
        "click": function($event) {
          return _vm.selecteSchedule(schedule.id)
        }
      }
    }, [_c('p', [_c('span', {
      staticStyle: {
        "padding-right": "1rem"
      }
    }, [_c('font-awesome-icon', {
      staticStyle: {
        "font-size": "32px"
      },
      attrs: {
        "icon": _vm.faUserMd,
        "color": "black"
      }
    })], 1)]), (schedule.extra_info) ? _c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.extraInfoZh(JSON.parse(schedule.extra_info)))
      }
    }) : _vm._e(), _c('p')])
  }), 0) : _c('div', {
    staticClass: "with-child-centered"
  }, [_c('p', [_vm._v("請先選擇病人")])])])])])], 1) : _vm._e(), (_vm.scheduleByPatient.length === 0 && _vm.getScheduled) ? _c('div', {
    staticClass: "with-child-centered",
    on: {
      "click": _vm.manualSchedule
    }
  }, [_c('h4', [_vm._v("無排程資料")])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1425 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-row"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.showImg
    }
  }, [_vm._v(_vm._s(_vm.img_string))]), _vm._v("\n                   \n    "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": this.$store.state.user.user.username == 'estcheck'
    },
    on: {
      "click": _vm.returnModify
    }
  }, [_vm._v("退回修正")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-10"
  }, [_c('img', {
    staticClass: "car-image",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "bigpic",
      "src": "bigpic"
    }
  })])])
}]}

/***/ }),
/* 1426 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-10"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_vm._m(0), _c('p', [_vm._v("    ")]), _vm._l((_vm.paras), function(item) {
    return _c('div', [_c('h4', [_c('kbd', {
      staticClass: "navbar-brand-kbd"
    }, [_vm._v("固定桿代碼" + _vm._s(item.fixed_link_code) + "  道路限速" + _vm._s(item.road_speed_limit) + " 舉發車速(超速)" + _vm._s(item.break_value) + " 舉發車速(龜速)" + _vm._s(item.break_value_slow))])])])
  }), _c('p', [_vm._v("       ")]), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioValue),
      expression: "radioValue"
    }],
    attrs: {
      "type": "radio",
      "id": "radio1",
      "name": "radios",
      "value": "t1",
      "checked": ""
    },
    domProps: {
      "checked": _vm._q(_vm.radioValue, "t1")
    },
    on: {
      "change": function($event) {
        _vm.radioValue = "t1"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radio1"
    }
  }, [_vm._v("違規")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioValue),
      expression: "radioValue"
    }],
    attrs: {
      "type": "radio",
      "id": "radio2",
      "name": "radios",
      "value": "t23",
      "checked": ""
    },
    domProps: {
      "checked": _vm._q(_vm.radioValue, "t23")
    },
    on: {
      "change": function($event) {
        _vm.radioValue = "t23"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radio2"
    }
  }, [_vm._v("未違規&無法開單")])])], 2), (_vm.waitConfirmFlag == true && _vm.loadingData == true) ? _c('div', [_c('h1', {
    staticClass: "text-center display-4"
  }, [_vm._v("認證資料處理中")])]) : _vm._e(), _c('div', [_c('vuetable', {
    ref: "vuetable",
    attrs: {
      "api-url": (_vm.server + "/api/interval-speed-data/"),
      "data-path": "results",
      "pagination-path": "",
      "per-page": 1000,
      "fields": _vm.fields,
      "css": _vm.boostrapCss,
      "http-options": _vm.httpOptions,
      "append-params": _vm.moreParams,
      "detail-row-component": "confirm-check-detail",
      "sortOrder": _vm.sortOrder
    },
    on: {
      "vuetable:loading": _vm.onLoading,
      "vuetable:loaded": _vm.onLoaded,
      "vuetable:pagination-data": _vm.onPaginationData,
      "vuetable:cell-clicked": _vm.onCellClicked
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s((props.rowIndex + 1) + (_vm.currentPage - 1) * 1000))])]
      }
    }])
  }), _c('vuetable-pagination', {
    ref: "pagination",
    attrs: {
      "css": _vm.boostrapCss.pagination
    },
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  })], 1), (_vm.tableDataLen == 0 && _vm.loadingData == false) ? _c('div', [_c('h1', {
    staticClass: "text-center display-4"
  }, [_vm._v("今日無認證資料")])]) : _vm._e()]), _c('div', {
    staticClass: "col-2"
  }, [_vm._m(1), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("開始時間")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.startDate),
      expression: "startDate"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.startDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.startDate = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("結束時間")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.endDate),
      expression: "endDate"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.endDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.endDate = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("過濾條件")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryString),
      expression: "queryString"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "text",
      "placeholder": "輸入車號"
    },
    domProps: {
      "value": (_vm.queryString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.queryString = $event.target.value
      }
    }
  })]), _c('button', {
    staticClass: "btn btn-primary mb-2 w-100",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.onFilterSet
    }
  }, [_vm._v("篩選")]), _c('button', {
    staticClass: "btn btn-danger mb-2 w-100",
    attrs: {
      "type": "submit",
      "disabled": _vm.tableDataLen == 0 || _vm.waitConfirmFlag == true || _vm.radioValue != 't1'
    },
    on: {
      "click": _vm.confirmTicket
    }
  }, [_vm._v("開單確認")]), _c('button', {
    staticClass: "btn btn-warning mb-2 w-100",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.downloadErrorImg
    }
  }, [_vm._v("下載無法開單照片")])]), (_vm.loadingData) ? _c('Loader', [_c('h4', [_vm._v("資料載入中，請稍等")])]) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('kbd', [_vm._v("區間超速認證資訊")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "text-info"
  }, [_c('strong', [_vm._v("請輸入查詢區間")])])
}]}

/***/ }),
/* 1427 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-10"
  }, [(_vm.isOldType == false) ? _c('div', {
    staticClass: "summary-layout"
  }, [_c('table', {
    staticClass: "table table-fixed"
  }, [_vm._m(0), _c('tbody', _vm._l((_vm.filteredData), function(data) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(data.check_loc))]), _c('td', [_vm._v(_vm._s(data.check_time))]), _c('td', [_vm._v(_vm._s(data.check_NTPtime))]), _c('td', [_vm._v(_vm._s(data.check_status))])])
  }), 0)])]) : _c('div', [_c('table', {
    staticClass: "table table-fixed"
  }, [_vm._m(1), _c('tbody', _vm._l((_vm.filteredData), function(data) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(data.check_loc))]), _c('td', [_vm._v(_vm._s(data.check_NTPtime))]), _c('td', [_vm._v(_vm._s(data.check_status))])])
  }), 0)])])]), _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('QueryFilter', {
    attrs: {
      "showReportButton": _vm.showReportButton,
      "showDate": _vm.showDate,
      "showStartDate": _vm.showStartDate
    },
    on: {
      "filter": _vm.filter,
      "report": _vm.downloadReport
    }
  })], 1), (_vm.loadingData) ? _c('Loader', [_c('h4', [_vm._v("資料載入中，請稍等")])]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [_c('th', [_vm._v("地點")]), _c('th', [_vm._v("系統時間")]), _c('th', [_vm._v("NTP Server時間")]), _c('th', [_vm._v("校時結果")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [_c('th', [_vm._v("地點")]), _c('th', [_vm._v("NTP Server時間")]), _c('th', [_vm._v("校時結果")])])])
}]}

/***/ }),
/* 1428 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upper-subpanel row"
  }, [_c('progressBar'), _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [(_vm.stage === 'selectDrug') ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('selectBox')], 1), _c('div', {
    staticClass: "col-6"
  }, [_c('drugList')], 1)]) : _vm._e(), (_vm.stage === 'setFlowData') ? _c('MultiFlow', {
    attrs: {
      "multiProgress": _vm.multiProgress,
      "confirmProgress": _vm.confirmProgress
    },
    on: {
      "setAllConfirmData": _vm.getAllConfirmData
    }
  }) : _vm._e()], 1)], 1), _c('BottomButtons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  }), (_vm.stage !== 'setFlowData') ? _c('action-button', {
    attrs: {
      "slot": "button-8",
      "title": "取消全選"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.unCheckAll($event)
      }
    },
    slot: "button-8"
  }) : _vm._e(), (_vm.stage !== 'setFlowData') ? _c('action-button', {
    attrs: {
      "slot": "button-7",
      "title": "選擇全部"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.checkAll($event)
      }
    },
    slot: "button-7"
  }) : _vm._e(), (_vm.stage !== 'setFlowData') ? _c('action-button', {
    attrs: {
      "slot": "button-9",
      "title": "開始移除"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startFlow($event)
      }
    },
    slot: "button-9"
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1429 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upper-subpanel row"
  }, [_c('progressBar'), (_vm.currentSystem.return_cmpn !== null) ? _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [(_vm.stage === 'selectEvent') ? _c('EventTable', {
    attrs: {
      "eventType": _vm.eventType,
      "device": _vm.currentSystem.return_cmpn
    }
  }) : _vm._e(), (_vm.stage === 'setFlowData') ? _c('MultiFlow', {
    attrs: {
      "multiProgress": _vm.multiProgress,
      "confirmProgress": _vm.confirmProgress
    },
    on: {
      "setAllConfirmData": _vm.getAllConfirmData
    }
  }) : _vm._e(), (_vm.stage === 'finish') ? _c('Loader') : _vm._e()], 1) : _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [_vm._m(0)])], 1), _c('BottomButtons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  }), (_vm.stage === 'selectEvent') ? _c('action-button', {
    attrs: {
      "slot": "button-9",
      "title": "開始回收",
      "clickable": _vm.$store.state.event.selectedEventId.length !== 0
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startFlow($event)
      }
    },
    slot: "button-9"
  }) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upper-subpanel--inside"
  }, [_c('h3', [_vm._v("請先至首頁設定退藥盒")])])
}]}

/***/ }),
/* 1430 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-layout"
  }, [_c('div', {
    staticClass: "alert alert-success"
  }, [_c('span', [_vm._v("原取藥數量: " + _vm._s(Math.abs(_vm.currentEvent.number1)))])]), (_vm.currentProgress === 'setStorage') ? _c('ConfirmStorage', {
    attrs: {
      "inputLabel": '設定拋棄藥物數量',
      "defaultAmount": Math.abs(_vm.currentEvent.number1)
    },
    on: {
      "setNum": _vm.getStorage
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1431 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-manual-wrap"
  }, [_c('div', {
    staticClass: "function-button d-inline-block",
    on: {
      "click": function($event) {
        return _vm.goto('userBarcode')
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n      更改條碼\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "function-button d-inline-block",
    on: {
      "click": function($event) {
        return _vm.goto('userPassword')
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n      更改密碼\n    ")])]), _vm._v(" "), (_vm.$store.state.generalSetting.can_login_with_fingerprinter) ? _c('div', {
    staticClass: "function-button d-inline-block",
    on: {
      "click": function($event) {
        return _vm.goto('userFingerprint')
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n      更改指紋\n    ")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-wrap"
  }, [_c('img', {
    attrs: {
      "src": "/static/svg/barcode.svg",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-wrap"
  }, [_c('img', {
    attrs: {
      "src": "/static/svg/key.svg",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-wrap"
  }, [_c('img', {
    attrs: {
      "src": "/static/svg/fingerprint.svg",
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 1432 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h6', [_vm._v("待補藥清單")]), _vm._v(" "), _c('vuetable', {
    ref: "vuetable",
    attrs: {
      "api-url": (_vm.server + "/api/refill-order/?drug_storage__device__net__system__type=Tag"),
      "data-path": "",
      "pagination-path": "",
      "fields": _vm.fields,
      "api-mode": true,
      "css": _vm.boostrapCss,
      "http-options": _vm.httpOptions
    },
    on: {
      "vuetable:cell-clicked": _vm.onCellClicked
    },
    scopedSlots: _vm._u([{
      key: "num-refill",
      fn: function(props) {
        return [_c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v(_vm._s(props.rowData.drug_storage.max_stock - props.rowData.drug_storage.stock))])]
      }
    }, {
      key: "action",
      fn: function(props) {
        return [_c('button', {
          staticClass: "btn btn-danger",
          on: {
            "click": function($event) {
              return _vm.deleteOrder(props.rowData.id)
            }
          }
        }, [_vm._v("刪除")])]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1433 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Patch', [_c('h5', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("資料匯入")])])
},staticRenderFns: []}

/***/ }),
/* 1434 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.systemShowed) ? _c('div', {
    staticClass: "upper-subpanel--inside"
  }, [(_vm.systemIndex > 0) ? _c('div', {
    staticClass: "btn-system-change",
    attrs: {
      "id": "prev-system"
    },
    on: {
      "click": _vm.previousSystem
    }
  }) : _vm._e(), _c('span', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.selectedDevicesID))]), _c('span', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.selectedDrugInDeviceID))]), _c('div', {
    staticClass: "system-wrapper"
  }, [_c('div', {
    staticClass: "one-system"
  }, [_c('p', {
    staticClass: "text-center",
    staticStyle: {
      "margin-top": "0px",
      "margin-bottom": "5px"
    }
  }, [_c('strong', [_vm._v("藥櫃編號: " + _vm._s(_vm.systemShowed.relative_index))])]), _c('div', {
    staticClass: "net-wrap"
  }, _vm._l((_vm.systemShowed.net_set), function(net, net_key) {
    return _c('div', {
      class: {
        'one-net': true, 'selected': net_key === (_vm.currentNet.row_id - 1)
      },
      attrs: {
        "id": 'net-' + net_key
      },
      on: {
        "click": function($event) {
          return _vm.selectNet(net)
        }
      }
    }, [_vm._v(_vm._s(net.row_id) + " - " + _vm._s(net.type)), (net.hasDeviceSelected) ? _c('span', {
      staticClass: "device-badge"
    }) : _vm._e(), (_vm.mode === 'onlyDrug') ? _c('span', {
      staticClass: "btn btn-select",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.selecteAllDrugStorageWithNet(net)
        }
      }
    }, [_vm._v("選擇整層")]) : _vm._e()])
  }), 0), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRow),
      expression: "showRow"
    }],
    staticClass: "row-model"
  }, [_c('div', {
    staticClass: "model-mask",
    on: {
      "click": function($event) {
        _vm.showRow = !_vm.showRow
      }
    }
  }), _c('div', {
    staticClass: "row-wrap"
  }, [_c('div', {
    staticClass: "row-info"
  }, [_c('span', [_vm._v("第 " + _vm._s(_vm.currentNet.row_id) + " 層")])]), _vm._l((_vm.numRow), function(n) {
    return _c('div', {
      staticClass: "one-net-row",
      style: ({
        'height': 100 / _vm.numRow + '%',
        order: n
      })
    }, _vm._l((_vm.currentNet.device_set), function(device) {
      return (device.pos_row === n || _vm.currentNet.type === 'F') ? _c('div', {
        class: {
          'one-device': true, 'selected-arise': device.selected, 'return-cmpn': device.specific_type === 'return_device', 'lock-cmpn': device.specific_type === 'lock_device', 'lock-cmpn-full': (device.specific_type === 'lock_device' && device.drugstorage_set.length > 0), 'device-in-F': _vm.currentNet.type === 'F'
        },
        style: ({
          'width': (100 * (device.width / 6)) + '%'
        }),
        attrs: {
          "id": ("device-" + (device.pos_row) + "-" + (device.relative_col))
        },
        on: {
          "click": function($event) {
            return _vm.selectDevice(device)
          }
        }
      }, [_c('span', {
        staticClass: "device-position"
      }, [_vm._v(_vm._s(device.pos_row) + " - " + _vm._s(device.relative_col))]), (device.drugstorage_set !== '') ? _c('div', {
        staticClass: "drug-pop"
      }, [(device.specific_type == 'return_device') ? _c('span', [_vm._v("退藥盒")]) : (device.specific_type == 'lock_device') ? _c('span', [_vm._v("保管盒")]) : _vm._l((device.drugstorage_set), function(storage) {
        return _c('div', {
          staticClass: "device-drug",
          class: {
            'selected': storage.selected, 'expired': storage.expired
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.selectDrug(storage)
            }
          }
        }, [_c('span', [_vm._v(_vm._s(storage.medication.code) + " / " + _vm._s(storage.medication.CGMH_number))]), _c('span', [_vm._v(_vm._s(_vm._f("setLength")(storage.medication.generic_name)))]), (storage.expired) ? _c('span', [_vm._v("已過期")]) : _c('span', [_c('small', [_vm._v(_vm._s(storage.expired_date))])])])
      })], 2) : _vm._e(), (device.error) ? _c('div', {
        staticClass: "error-device-mask"
      }, [_c('p', [_vm._v("藥盒已鎖定")])]) : _vm._e()]) : _vm._e()
    }), 0)
  })], 2)])]), _vm._m(0)], 1)]), (_vm.systemIndex + 1 < _vm.systemIds.length) ? _c('div', {
    staticClass: "btn-system-change",
    attrs: {
      "id": "next-system"
    },
    on: {
      "click": _vm.nextSystem
    }
  }) : _vm._e()]) : _c('Loader')
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cabinet-bottom-wrap"
  }, [_c('div', {
    staticClass: "cabinet-bottom float-left"
  }), _c('div', {
    staticClass: "cabinet-bottom float-right"
  })])
}]}

/***/ }),
/* 1435 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-form"
  }, [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("剩餘數量: "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.residual))])]), _vm._v(" "), (!_vm.allowToNext) ? _c('h6', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.warnMessage))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button-wrap"
  }, [_c('button', {
    staticClass: "btn  btn-lg confirm-button",
    attrs: {
      "disabled": !_vm.allowToNext
    },
    on: {
      "click": _vm.goOn
    }
  }, [_vm._v("繼續動作")])])])
},staticRenderFns: []}

/***/ }),
/* 1436 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-10"
  }, [(_vm.isChartType || _vm.user == 'esttw') ? _c('div', [_c('ve-line', {
    attrs: {
      "data": _vm.chartData,
      "y-axis": _vm.yaxis,
      "colors": _vm.colors
    }
  })], 1) : _vm._e(), (_vm.timeErrorFlag && _vm.isChartType) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.errorContext)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "summary-layout"
  }, [_c('table', {
    staticClass: "table table-fixed"
  }, [_vm._m(0), _c('tbody', _vm._l((_vm.filteredData), function(data) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(data.check_loc))]), _c('td', [_vm._v(_vm._s(data.ipcam1_time))]), _c('td', [_vm._v(_vm._s(data.ipcam2_time))]), _c('td', [_vm._v(_vm._s(data.ipcam3_time))]), _c('td', [_vm._v(_vm._s(data.check_time))]), _c('td', [_vm._v(_vm._s(data.check_status))])])
  }), 0)])])]), _c('div', {
    staticClass: "col-2"
  }, [_c('QueryFilter', {
    attrs: {
      "showReportButton": _vm.showReportButton,
      "showDate": _vm.showDate,
      "showStartDate": _vm.showStartDate
    },
    on: {
      "filter": _vm.filter,
      "report": _vm.downloadReport
    }
  }), (_vm.loadingData) ? _c('Loader', [_c('h4', [_vm._v("資料載入中，請稍等")])]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [_c('th', [_vm._v("地點")]), _c('th', [_vm._v("攝影機#1時間")]), _c('th', [_vm._v("攝影機#2時間")]), _c('th', [_vm._v("攝影機#3時間")]), _c('th', [_vm._v("系統時間")]), _c('th', [_vm._v("對時結果")])])])
}]}

/***/ }),
/* 1437 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-2"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("姓")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-2"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-2"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("職稱")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.title = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.jobTitle), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-2"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("單位")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.department),
      expression: "department"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.department = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.departments), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-2"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("警員代碼")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.barcode),
      expression: "barcode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.barcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.barcode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-2"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("後台操作權限")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.serverPrivilege2),
      expression: "serverPrivilege2"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.serverPrivilege2 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.serverPrivilege2Group), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [(_vm.rowData.is_superuser === false) ? _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isSuperuser),
      expression: "isSuperuser"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isSuperuser) ? _vm._i(_vm.isSuperuser, null) > -1 : (_vm.isSuperuser)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isSuperuser,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isSuperuser = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isSuperuser = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isSuperuser = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("能否後台設定")])])]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.updateUser
    }
  }, [_vm._v("更新")]), _vm._v(" "), (_vm.rowData.is_superuser === false) ? _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.showConfirm = true
      }
    }
  }, [_vm._v("刪除")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        _vm.showPasswordChange = true
      }
    }
  }, [_vm._v("變更密碼")]), _vm._v(" "), _c('Confirm', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showConfirm),
      expression: "showConfirm"
    }],
    attrs: {
      "message": '確定刪除此使用者?'
    },
    on: {
      "response": _vm.confirmDel
    }
  }), _vm._v(" "), (_vm.showPasswordChange) ? _c('password-change', {
    attrs: {
      "userId": _vm.rowData.id
    },
    on: {
      "closePanel": _vm.closePanel
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1438 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.stage === 'action') ? _c('Action', {
    attrs: {
      "inputReadOnly": true,
      "defaultNum": _vm.amountPayload.emptyCount,
      "deviceId": _vm.currentEvent.device.id,
      "onlyPc": true
    },
    on: {
      "setActionData": _vm.getThisAmount
    }
  }, [_c('h5', [_vm._v("此藥盒取出空瓶數量")])]) : _vm._e(), (_vm.stage === 'finish') ? _c('Loader') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-login-layout"
  }, [_c('div', {
    staticClass: "login-content"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    ref: "password",
    staticClass: "login-method-wrap",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "username"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('vue-recaptcha', {
    ref: "recaptcha",
    attrs: {
      "size": "invisible",
      "sitekey": "6Le-LLwZAAAAAAIgW13yIFTeYzeX36TICYZXRc93"
    },
    on: {
      "verify": _vm.onCaptchaVerified,
      "expired": _vm.onCaptchaExpired
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning btn-lg",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n        登入\n      ")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-type--img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1186),
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_c('kbd', [_vm._v("彰化台61科技執法後端管理系統")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("帳號")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("密碼")])])
}]}

/***/ }),
/* 1440 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upper-subpanel--inside"
  }, [(_vm.getComboMed === false) ? _c('Loader') : _c('div', {
    staticClass: "combomed-list-wrapper"
  }, [_c('div', {
    staticClass: "med-list"
  }, [(_vm.comboMedSet.length === 0) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "align-items": "center",
      "height": "100%"
    }
  }, [_c('h5', [_vm._v("未設定藥物組合")])]) : _c('div', [_vm._l((_vm.comboMedSet), function(med, index) {
    return _c('div', {
      staticClass: "combomed-button",
      class: {
        'combomed-button-selected': med.selected, 'unselectable': med.amountInSystem === 0, 'fetched-button': med.fetched
      }
    }, [_c('div', {
      staticClass: "combomed-detail",
      on: {
        "click": function($event) {
          return _vm.selectMed(med)
        }
      }
    }, [_c('div', {
      class: {
        'fetched': med.fetched
      },
      attrs: {
        "id": "fetch_status"
      }
    }, [_vm._v(_vm._s(_vm._f("fetchZh")(med.fetched)))]), _c('div', {
      attrs: {
        "id": "med_info"
      }
    }, [_c('h6', [_vm._v(_vm._s(med.child_medication.code) + " - " + _vm._s(med.child_medication.CGMH_number))]), _c('span', [_c('small', [_vm._v(_vm._s(med.child_medication.generic_name) + " ")]), (med.child_medication.product_name) ? _c('small', [_vm._v(_vm._s(med.child_medication.product_name))]) : _vm._e()])]), _c('div', [(med.parent_medication.type === 'combo') ? _c('p', {
      attrs: {
        "id": "combo-name"
      }
    }, [_c('span', [_vm._v("套藥")]), _c('span', [_vm._v(_vm._s(med.parent_medication.generic_name))])]) : _vm._e(), _c('p', {
      attrs: {
        "id": "remain_amount"
      }
    }, [_c('span', [_vm._v("系統存量")]), _c('span', [_vm._v(_vm._s(med.amountInSystem))])]), (med.child_medication_dose) ? _c('p', {
      attrs: {
        "id": "dose"
      }
    }, [_c('span', [_vm._v("用藥劑量")]), _c('span', [_vm._v(_vm._s(med.child_medication_dose)), (med.child_medication_dose_unit) ? _c('span', [_vm._v(_vm._s(med.child_medication_dose_unit) + " ")]) : _vm._e()])]) : _vm._e(), (med.child_medication_quantity) ? _c('p', {
      attrs: {
        "id": "dose"
      }
    }, [_c('span', [_vm._v("取藥數量")]), _c('span', [_vm._v(_vm._s(med.child_medication_quantity) + " "), (med.child_medication_quantity_unit) ? _c('span', [_vm._v(_vm._s(med.child_medication_quantity_unit))]) : _vm._e()])]) : _vm._e()])])])
  }), (_vm.otherFetchEvents.length > 0) ? _c('div', _vm._l((_vm.otherFetchEvents), function(event) {
    return _c('div', {
      staticClass: "combomed-button other-fetch-events"
    }, [_c('div', {
      staticClass: "combomed-detail"
    }, [(event.related_events.length === 0) ? _c('div', {
      staticStyle: {
        "background-color": "green",
        "color": "white"
      },
      attrs: {
        "id": "fetch_status"
      }
    }, [_vm._v("已取藥")]) : _c('div', {
      staticStyle: {
        "background-color": "red",
        "color": "white"
      },
      attrs: {
        "id": "fetch_status"
      }
    }, _vm._l((event.related_events), function(e) {
      return _c('div', [_vm._v(_vm._s(_vm._f("zhLabel")(e.event_type.event_name)))])
    }), 0), _c('div', {
      attrs: {
        "id": "med_info"
      }
    }, [_c('h6', [_vm._v(_vm._s(event.medication.code) + " - " + _vm._s(event.medication.CGMH_number))]), _c('span', [_c('small', [_vm._v(_vm._s(event.medication_generic_name))])])]), _c('div', [_c('p', {
      attrs: {
        "id": "dose"
      }
    }, [_c('span', [_vm._v("數量")]), _c('span', [_vm._v(_vm._s(Math.abs(event.number1)))])])])])])
  }), 0) : _vm._e()], 2)])]), _c('div', {
    staticClass: "fake-bottom-buttons"
  }, [_c('action-button', {
    attrs: {
      "title": "選擇全部"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectAllMed(true)
      }
    }
  }), _c('action-button', {
    attrs: {
      "title": "取消選擇"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectAllMed(false)
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1441 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vuetable', {
    ref: "vuetable2",
    attrs: {
      "fields": _vm.fields,
      "api-url": (_vm.server + "/api/drug-storage/"),
      "css": _vm.boostrapCss,
      "data-path": "results",
      "pagination-path": "",
      "perPage": 100,
      "append-params": _vm.moreParams,
      "detail-row-component": "adc-drug-detail"
    },
    on: {
      "vuetable:cell-clicked": _vm.onCellClicked
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1442 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    attrs: {
      "id": "return-panel"
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "modal-body--title"
  }, [(_vm.currentSystem.settings.return_to_original_cmpn) ? _c('h5', {
    staticClass: "text-center"
  }, [_vm._v("此藥盒已無空間放入，請選擇下方位置退藥")]) : _c('h5', {
    staticClass: "text-center"
  }, [_vm._v("未設定退回原藥盒，請選擇以下位置進行退藥")])]), (_vm.sameMedDrugStorage.length !== 0) ? _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.sameMedDrugStorage), function(storage) {
    return _c('div', {
      staticClass: "col-6"
    }, [_c('div', {
      staticClass: "cmpn-button",
      on: {
        "click": function($event) {
          return _vm.setNextDrugStorage(storage)
        }
      }
    }, [_c('p', [_vm._v(_vm._s(_vm._f("readableDevice")(storage.device)))]), _c('p', [_vm._v(_vm._s(storage.stock) + " / " + _vm._s(storage.max_stock))]), _c('p', [_vm._v("批號:"), (storage.patch_number !== '' && storage.patch_number !== null && storage.patch_number !== undefined) ? _c('span', [_vm._v(_vm._s(storage.patch_number))]) : _c('span', [_vm._v("無")])])])])
  }), 0) : _vm._e(), _c('hr'), _c('div', {
    staticClass: "row"
  }, [(_vm.returnCmpn !== null) ? _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "cmpn-button",
    on: {
      "click": function($event) {
        return _vm.setReturnDevice(_vm.returnCmpn, 'return')
      }
    }
  }, [_c('p', [_vm._v("退藥盒")])])]) : _vm._e(), (_vm.externalCmpn !== null) ? _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "cmpn-button",
    on: {
      "click": function($event) {
        return _vm.setReturnDevice(_vm.externalCmpn.id, 'external')
      }
    }
  }, [_c('p', [_vm._v("外部藥盒")])])]) : _vm._e()])])])])])
},staticRenderFns: []}

/***/ }),
/* 1443 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-manual-wrap"
  }, [_c('h3', [_vm._v("請掃描指紋以更新登入用指紋")])])
}]}

/***/ }),
/* 1444 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  123\n")])
},staticRenderFns: []}

/***/ }),
/* 1445 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.stage === 'confirmAmount') ? _c('Action', {
    attrs: {
      "defaultNum": _vm.forAction.defaultNum,
      "autoCaculateAmount": false,
      "compType": 'Confirm',
      "defaultPackCount": _vm.theDrugStorage.pack_count,
      "deviceId": _vm.forAction.deviceId,
      "checkNum": _vm.forAction.checkNum
    },
    on: {
      "confirmAmountFinish": _vm.confirmAmountFinish
    }
  }, [_c('h5', [_vm._v("確認藥盒內數量")])]) : _vm._e(), _vm._v(" "), (_vm.stage === 'action') ? _c('Action', {
    attrs: {
      "defaultNum": _vm.forAction.defaultNum,
      "autoCaculateAmount": false,
      "defaultPackCount": 0,
      "deviceId": _vm.forAction.deviceId,
      "onlyPc": true,
      "inputReadOnly": _vm.fetchReadOnly,
      "checkNum": _vm.forAction.checkNum
    },
    on: {
      "setActionData": _vm.getThisAmount,
      "setTotalSumInstanly": _vm.getTotalSumInstanly
    }
  }, [_c('h5', [_vm._v("自此藥盒取藥數量 (pc)")])]) : _vm._e(), _vm._v(" "), (_vm.stage === 'break') ? _c('ActionBreak', {
    attrs: {
      "residual": _vm.amount - _vm.totalAmount
    },
    on: {
      "goOn": _vm.goOn
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stage === 'next') ? _c('Loader', [(_vm.saveTaskCount !== 0) ? _c('p', {
    staticClass: "text-center"
  }, [_vm._v("\n      儲存第 " + _vm._s(_vm.saveProgress) + " 藥單中 \n    ")]) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1446 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onFilterSet($event)
      }
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.systemId),
      expression: "systemId"
    }],
    staticClass: "form-control mr-2",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.systemId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("選擇系統")]), _vm._l((_vm.systems), function(sys) {
    return _c('option', {
      domProps: {
        "value": sys.id
      }
    }, [_vm._v(_vm._s(sys.name))])
  })], 2), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("搜尋")])]), _c('hr'), _c('vuetable', {
    ref: "vuetable",
    attrs: {
      "pagination-path": "",
      "fields": _vm.fields,
      "api-mode": false,
      "css": _vm.boostrapCss,
      "append-params": _vm.moreParams,
      "http-options": _vm.httpOptions
    },
    on: {
      "vuetable:cell-clicked": _vm.onCellClicked
    },
    scopedSlots: _vm._u([{
      key: "num-refill",
      fn: function(props) {
        return [_c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v(_vm._s(props.rowData.max_stock - props.rowData.stock))])]
      }
    }])
  }), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.setRefill
    }
  }, [_vm._v("設定補藥項目")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_vm._v("待補充清單"), _c('small', [_vm._v("（尚未列入為補藥規劃）")])])
}]}

/***/ }),
/* 1447 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [(_vm.$store.state.user.user.username === 'ict' || _vm.$store.state.user.user.username === 'weian') ? _c('div', {
    staticClass: "col-6"
  }, [_c('h5', [_vm._v("匯入" + _vm._s(_vm.title) + "資訊")]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "fileupload"
    }
  }, [_vm._v("請選擇欲上傳的excel檔案")]), _c('input', {
    staticClass: "form-control-file",
    attrs: {
      "id": "fileupload",
      "type": "file",
      "name": "medtable"
    },
    on: {
      "change": _vm.onChange
    }
  })]), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.upload
    }
  }, [_vm._v("上傳檔案")])]) : _vm._e(), _c('div', {
    staticClass: "col-6"
  }, [_c('h5', [_vm._v("匯出" + _vm._s(_vm.title) + "資訊")]), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    on: {
      "click": _vm.download
    }
  }, [_vm._v("下載資料庫")])])]), _c('div', {
    staticClass: "col-12"
  }, [_c('hr'), (_vm.uploadProgress !== 0) ? _c('h6', [_vm._v("上傳中...")]) : _vm._e(), (_vm.uploadProgress !== 0) ? _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar",
    style: ({
      width: (_vm.uploadProgress + "%")
    }),
    attrs: {
      "role": "progressbar",
      "aria-valuenow": _vm.uploadProgress,
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })]) : _vm._e(), (_vm.resultMsg.length !== 0) ? _c('p', [_vm._v("上傳結果:")]) : _vm._e(), _vm._l((_vm.resultMsg), function(msg) {
    return _c('p', {
      staticStyle: {
        "margin": "0"
      }
    }, [_vm._v(_vm._s(msg))])
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 1448 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upper-subpanel--inside"
  }, [_vm._t("default", [_c('h3', [_vm._v("請掃描" + _vm._s(_vm.barcodeTitle) + "條碼")])]), _vm._v(" "), (this.barcodeTitle === '藥單條碼') ? _c('img', {
    staticClass: "med-pack",
    attrs: {
      "src": "/static/img/med_pack.jpg",
      "alt": ""
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1449 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upper-subpanel row"
  }, [_c('progressBar'), _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [(_vm.stage === 'eventList') ? _c('eventTable', {
    attrs: {
      "eventType": _vm.eventType,
      "returnEmpty": true,
      "singleSelection": true
    }
  }) : _vm._e(), (_vm.stage === 'setFlowData') ? _c('MultiFlow', {
    attrs: {
      "multiProgress": _vm.multiProgress,
      "confirmProgress": _vm.confirmProgress,
      "actionProgress": _vm.actionProgress
    },
    on: {
      "setAllConfirmData": _vm.getAllConfirmData
    }
  }) : _vm._e(), (_vm.stage === 'finish') ? _c('Loader') : _vm._e()], 1)], 1), _c('BottomButtons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  }), (_vm.stage !== 'setFlowData') ? _c('action-button', {
    attrs: {
      "slot": "button-9",
      "title": "開始動作",
      "clickable": _vm.$store.state.drugInDevice.selectedDrugInDeviceID.length > 0 || _vm.$store.state.event.selectedEventId.length > 0
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startFlow($event)
      }
    },
    slot: "button-9"
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1450 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upper-subpanel--inside"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('DrugInfo')], 1), _c('div', {
    staticClass: "col-6"
  }, [(_vm.currentProgress === 'confirm') ? _c('ConfirmFlow', {
    attrs: {
      "confirmProgress": _vm.confirmProgress,
      "actionProgress": _vm.actionProgress
    },
    on: {
      "confirmationFinish": _vm.getConfirmData
    }
  }) : _vm._e(), (_vm.currentProgress === 'finish') ? _c('Loader') : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1451 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DataImportBase', {
    attrs: {
      "title": '使用者',
      "uploadUrl": '/upload-user-table/',
      "downloadUrl": '/export-user-table/'
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1452 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upper-subpanel row"
  }, [_c('progressBar'), _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [(_vm.stage === 'select') ? _c('div', {
    staticClass: "lockbox-choose-button--wrapper"
  }, [_c('h5', {
    staticClass: "text-center"
  }, [_vm._v("請選擇欲操作之動作")]), _c('hr'), _c('div', {
    staticClass: "choose-buttons"
  }, [_c('div', {
    staticClass: "lockbox-choose-button shadow",
    attrs: {
      "id": "lock"
    },
    on: {
      "click": function($event) {
        return _vm.selectAction('lock')
      }
    }
  }, [_c('font-awesome-layers', {
    staticClass: "fa-2x fa-fw"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": _vm.arrowDownIcon,
      "transform": "shrink-6 up-10"
    }
  }), _c('font-awesome-icon', {
    attrs: {
      "icon": _vm.boxOpenIcon,
      "transform": "down-1"
    }
  })], 1), _c('h5', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("存放藥物")])], 1), _c('div', {
    staticClass: "lockbox-choose-button shadow",
    attrs: {
      "id": "unlock"
    },
    on: {
      "click": function($event) {
        return _vm.selectAction('unlock')
      }
    }
  }, [_c('font-awesome-layers', {
    staticClass: "fa-2x fa-fw"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": _vm.arrowUpIcon,
      "transform": "shrink-6 up-10"
    }
  }), _c('font-awesome-icon', {
    attrs: {
      "icon": _vm.boxOpenIcon,
      "transform": "down-1"
    }
  })], 1), _c('h5', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("取出藥物")])], 1)])]) : _vm._e(), (_vm.stage === 'lock') ? _c('div', {
    staticClass: "row lock-device-position-selection-wrapper"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('PositionSelection', {
    attrs: {
      "mode": "lockDevice"
    }
  })], 1), _vm._m(0)]) : _vm._e(), (_vm.stage === 'unlock') ? _c('div', [_c('div', {
    staticClass: "password-wrap"
  }, [_c('h5', {
    staticClass: "text-center"
  }, [_vm._v("請輸入開鎖密碼")]), _c('form', {
    staticClass: "input-group",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.confirmPassword($event)
      }
    }
  }, [_vm._m(1), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control mr-2",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "clickt": _vm.confirmPassword
    }
  }, [_vm._v("確認")])])])]) : _vm._e(), (_vm.stage === 'selectLockedBox') ? _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [(Object.keys(_vm.lockedAndFilledDevices).length > 0) ? _c('div', {
    staticClass: "locked-filled-devices-list"
  }, _vm._l((_vm.lockedAndFilledDevices), function(dev, num) {
    return _c('div', {
      staticClass: "locked-filled-device",
      class: {
        'shadow': dev.selected, 'lock-selected': dev.selected
      },
      on: {
        "click": function($event) {
          return _vm.selectDevice(num)
        }
      }
    }, [_c('span', [_vm._v("第" + _vm._s(dev.net.system.open_times) + "藥櫃 - 第" + _vm._s(dev.net.row_id) + "層 - 第" + _vm._s(dev.pos_row) + "列 - 第" + _vm._s(dev.relative_col) + "行")])])
  }), 0) : _c('div', {
    staticClass: "with-child-centered"
  }, [_c('h5', [_vm._v("未有已使用之藥盒")])])]) : _vm._e(), (_vm.stage === 'startFlow') ? _c('div', [_c('MultiFlow', {
    attrs: {
      "actionType": _vm.actionType
    },
    on: {
      "setAllConfirmData": _vm.getAllConfirmData
    }
  })], 1) : _vm._e(), (_vm.stage === 'loader') ? _c('Loader') : _vm._e()], 1)], 1), _c('BottomButtons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面",
      "id": "cancel"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  }), (_vm.stage === 'selectLockedBox') ? _c('action-button', {
    attrs: {
      "slot": "button-8",
      "title": "選擇全部"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectAllDevices($event)
      }
    },
    slot: "button-8"
  }) : _vm._e(), _c('action-button', {
    attrs: {
      "slot": "button-9",
      "title": "開始動作",
      "id": "startflow",
      "clickable": _vm.selectedDevicesID.length > 0
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startflow($event)
      }
    },
    slot: "button-9"
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-6 with-child-centered"
  }, [_c('h5', [_vm._v("請於左側選擇未使用之保管藥盒")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("密碼")])])
}]}

/***/ }),
/* 1453 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upper-subpanel row"
  }, [_c('progressBar'), _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [(_vm.getMedGroup === false && _vm.stage === 'medGroupList') ? _c('Loader') : _vm._e(), (_vm.getMedGroup && _vm.stage === 'medGroupList') ? _c('div', {
    staticClass: "med-group-wrapper"
  }, [_c('ul', {
    staticClass: "nav nav-pills nav-fill nav-autoix"
  }, _vm._l((_vm.group), function(g, index) {
    return _c('li', {
      staticClass: "nav-item",
      on: {
        "click": function($event) {
          _vm.currentGroupIndex = index
        }
      }
    }, [_c('div', {
      staticClass: "nav-link",
      class: {
        'active': _vm.currentGroupIndex === index
      }
    }, [_vm._v(_vm._s(g.name))])])
  }), 0), _c('div', {
    staticClass: "med-select"
  }, _vm._l((_vm.group[_vm.currentGroupIndex].childMedSet), function(med, index) {
    return _c('div', {
      staticClass: "med-button",
      class: {
        'selected-med-button': med.selected, 'unselectable': med.amountInSystem === 0
      },
      on: {
        "click": function($event) {
          return _vm.selectMed(index)
        }
      }
    }, [_c('div', {
      attrs: {
        "id": "med_desc"
      }
    }, [_c('h6', [_vm._v(_vm._s(med.code) + " - " + _vm._s(med.CGMH_number))]), _c('h6', [_vm._v(_vm._s(med.generic_name))])]), _c('div', {
      attrs: {
        "id": "remain_amount"
      }
    }, [_c('span', [_vm._v("系統存量")]), _c('span', [_vm._v(_vm._s(med.amountInSystem))])])])
  }), 0)]) : _vm._e(), (_vm.stage === 'startFlow') ? _c('MultiFlow', {
    attrs: {
      "multiProgress": _vm.multiProgress,
      "confirmProgress": _vm.confirmProgress,
      "actionProgress": _vm.actionProgress
    },
    on: {
      "setAllConfirmData": _vm.getAllConfirmData
    }
  }) : _vm._e()], 1)], 1), _c('BottomButtons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面",
      "clickable": _vm.currentApp.cancel
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  }), (_vm.$store.state.user.user.med_app_privilege.fetch_by_schedule) ? _c('action-button', {
    attrs: {
      "slot": "button-3",
      "title": "醫囑取藥"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'schedule',
          params: {
            stage: 'ComboMedListAndPatient'
          }
        })
      }
    },
    slot: "button-3"
  }) : _vm._e(), (_vm.$store.state.user.user.med_app_privilege.fetch_by_schedule) ? _c('action-button', {
    attrs: {
      "slot": "button-4",
      "title": "類別取藥"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'fetchDrugGroup'
        })
      }
    },
    slot: "button-4"
  }) : _vm._e(), _c('action-button', {
    attrs: {
      "slot": "button-9",
      "title": "開始取藥"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startFlow($event)
      }
    },
    slot: "button-9"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1454 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Patch', [_c('h5', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("罰單管理")])])
},staticRenderFns: []}

/***/ }),
/* 1455 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "event-list"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "輸入藥物名稱以搜尋事件"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  }), (_vm.events.length === 0) ? _c('div', {
    staticClass: "upper-subpanel--inside"
  }, [(_vm.fetchStatus === 'start') ? _c('Loader') : _vm._e(), (_vm.fetchStatus === 'done') ? _c('h3', [_vm._v("無事件紀錄")]) : _vm._e()], 1) : _c('div', {
    staticClass: "drug-search-list",
    staticStyle: {
      "height": "91%"
    }
  }, _vm._l((_vm.events), function(item) {
    return _c('div', {
      class: {
        'btn': true, 'drug-button': true, 'drug-selected': item.selected, 'returned-schedule': (_vm.number2 && item.checked)
      },
      on: {
        "click": function($event) {
          return _vm.selectEvent(item.id)
        }
      }
    }, [_c('div', {
      staticClass: "drug-head"
    }, [_c('div', {
      staticClass: "drug-head-icon-wrap"
    }, [_c('font-awesome-layers', {
      staticClass: "fa-lg"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": _vm.circleIcon,
        "size": "lg",
        "color": "yellowgreen"
      }
    }), _c('font-awesome-icon', {
      attrs: {
        "icon": _vm.noteMedicalIcon,
        "transform": "shrink-6 right-2",
        "color": "white"
      }
    })], 1)], 1), _c('div', {
      staticClass: "drug-head--content"
    }, [(item.medication.CGMH_number !== null) ? _c('span', [_vm._v("[ " + _vm._s(item.medication.CGMH_number) + " - "), _c('span', [_vm._v(_vm._s(item.medication.code) + " ]")])]) : _vm._e(), _c('span', [_vm._v(_vm._s(item.medication.generic_name))]), _c('span', [_c('small', [_vm._v(_vm._s(item.event_type.event_name_zh) + "事件")])])])]), _c('div', {
      staticClass: "drug-item"
    }, [_c('div', {
      staticClass: "info-col"
    }, [_vm._m(0, true), _c('div', {
      staticClass: "info-col-content"
    }, [_c('p', [_vm._v(_vm._s(item.employee_name))])])]), _c('div', {
      staticClass: "info-col",
      staticStyle: {
        "width": "50px"
      }
    }, [_vm._m(1, true), _c('div', {
      staticClass: "info-col-content"
    }, [_c('p', [_vm._v(_vm._s(item.number1))])])]), _c('div', {
      staticClass: "info-col"
    }, [_vm._m(2, true), _c('div', {
      staticClass: "info-col-content"
    }, [(item.med_record_no === '' || item.med_record_no === undefined || item.med_record_no === null) ? _c('p', [_vm._v("未設定")]) : _c('p', [_vm._v(_vm._s(item.med_record_no))])])]), _c('div', {
      staticClass: "info-col"
    }, [_vm._m(3, true), (item.drug_storage) ? _c('div', {
      staticClass: "info-col-content"
    }, [(item.batch_no === '' || item.batch_no === undefined || item.batch_no === null) ? _c('p', [_vm._v("未設定")]) : _c('p', [_vm._v(_vm._s(item.batch_no))])]) : _vm._e()]), _c('div', {
      staticClass: "info-col",
      staticStyle: {
        "width": "130px"
      }
    }, [_vm._m(4, true), _c('div', {
      staticClass: "info-col-content"
    }, [_c('p', [_vm._v(_vm._s(_vm._f("readableTime")(item.record_time)))])])]), _c('div', {
      staticClass: "info-col"
    }, [(item.medication.restrained_class > 0) ? _c('div', {
      staticClass: "label-badge restrained-badge"
    }, [_c('span', [_vm._v("管制藥")])]) : _vm._e(), (item.event_type.event_name === 'FETCH' && item.related_events.length === 0) ? _c('div', {
      staticClass: "label-badge",
      class: {
        'returned-badge': item.checked, 'unretured-badge': item.checked === false
      }
    }, [(item.checked) ? _c('span', [_vm._v("已退藥")]) : _c('span', [_vm._v("未退藥")])]) : _vm._e(), (item.event_type.event_name === 'FETCH' && item.checked && item.related_events.length > 0) ? _c('div', {
      staticClass: "label-badge",
      class: {
        'returned-badge': item.checked
      }
    }, _vm._l((item.related_events), function(e) {
      return _c('span', [_vm._v(_vm._s(_vm._f("zhLabel")(e.event_type.event_name)) + " ")])
    }), 0) : _vm._e()])])])
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-col-head"
  }, [_c('span', [_vm._v("使用者")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-col-head"
  }, [_c('span', [_vm._v("數量")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-col-head"
  }, [_c('span', [_vm._v("病歷號")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-col-head"
  }, [_c('span', [_vm._v("批號")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-col-head"
  }, [_c('span', [_vm._v("時間")])])
}]}

/***/ }),
/* 1456 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "400px"
    }
  }, [_c('ScanBarcode', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    on: {
      "setBarcode": _vm.getBarcode
    }
  }), (_vm.reviewEmployee === undefined) ? _c('div', {
    staticClass: "with-child-centered"
  }, [_c('h4', [_vm._v("覆核人員請刷條碼")])]) : _c('div', {
    staticClass: "with-child-centered"
  }, [_c('h4', [_vm._v("覆核人員")]), _c('h4', [_c('strong', [_vm._v(_vm._s(_vm.reviewEmployee.last_name) + _vm._s(_vm.reviewEmployee.first_name))])]), _c('button', {
    staticClass: "btn btn-lg confirm-button",
    on: {
      "click": _vm.confirmRx
    }
  }, [_vm._v("確認覆核")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1457 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h5', [_vm._v("前台權限"), _c('span', {
    staticClass: "icon-right",
    on: {
      "click": function($event) {
        _vm.createMedAppP = true
      }
    }
  }, [_vm._v(" + ")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.createMedAppP) ? _c('div', {
    staticClass: "create-form"
  }, [_c('p', [_vm._v("新增前台權限樣板 "), _c('span', {
    staticClass: "icon-right",
    on: {
      "click": function($event) {
        _vm.createMedAppP = false
      }
    }
  }, [_vm._v(" X ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("名稱")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medAppName),
      expression: "medAppName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.medAppName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.medAppName = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._l((_vm.fields.medApp), function(field) {
    return (field.name !== 'name' && field.name !== '__slot:action') ? _c('div', {
      staticClass: "form-check form-check-inline"
    }, [_c('label', {
      staticClass: "form-check-label"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkedMedApp),
        expression: "checkedMedApp"
      }],
      staticClass: "form-check-input",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": field.name,
        "checked": Array.isArray(_vm.checkedMedApp) ? _vm._i(_vm.checkedMedApp, field.name) > -1 : (_vm.checkedMedApp)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.checkedMedApp,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = field.name,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.checkedMedApp = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.checkedMedApp = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checkedMedApp = $$c
          }
        }
      }
    }), _vm._v(_vm._s(field.title) + "\n        ")])]) : _vm._e()
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.addMedAppP
    }
  }, [_vm._v("新增")])], 2) : _vm._e()]), _vm._v(" "), _c('vuetable', {
    ref: "vuetableMedApp",
    attrs: {
      "api-url": (_vm.server + "/api/med-app-privilege/"),
      "data-path": "",
      "pagination-path": "",
      "fields": _vm.fields.medApp,
      "api-mode": true,
      "css": _vm.boostrapCss,
      "http-options": _vm.httpOptions,
      "detail-row-component": "user-group-settings-detail"
    },
    on: {
      "vuetable:cell-clicked": _vm.onCellClicked
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function(props) {
        return [_c('button', {
          staticClass: "btn btn-danger",
          on: {
            "click": function($event) {
              return _vm.deleteMedAppP(props.rowData.id)
            }
          }
        }, [_vm._v("刪除")])]
      }
    }])
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("後台權限 "), _c('span', {
    staticClass: "icon-right",
    on: {
      "click": function($event) {
        _vm.createServerP = true
      }
    }
  }, [_vm._v(" + ")])]), _vm._v(" "), (_vm.createServerP) ? _c('div', {
    staticClass: "create-form"
  }, [_c('p', [_vm._v("新增後台權限樣板 "), _c('span', {
    staticClass: "icon-right",
    on: {
      "click": function($event) {
        _vm.createServerP = false
      }
    }
  }, [_vm._v(" X ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("名稱")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.serverName),
      expression: "serverName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.serverName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.serverName = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._l((_vm.fields.server), function(field) {
    return (field.name !== 'name' && field.name !== '__slot:action') ? _c('div', {
      staticClass: "form-check form-check-inline"
    }, [_c('label', {
      staticClass: "form-check-label"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkedServer),
        expression: "checkedServer"
      }],
      staticClass: "form-check-input",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": field.name,
        "checked": Array.isArray(_vm.checkedServer) ? _vm._i(_vm.checkedServer, field.name) > -1 : (_vm.checkedServer)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.checkedServer,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = field.name,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.checkedServer = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.checkedServer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checkedServer = $$c
          }
        }
      }
    }), _vm._v(_vm._s(field.title) + "\n      ")])]) : _vm._e()
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.addServerP
    }
  }, [_vm._v("新增")])], 2) : _vm._e(), _vm._v(" "), _c('vuetable', {
    ref: "vuetableServer",
    attrs: {
      "api-url": (_vm.server + "/api/server-privilege/"),
      "data-path": "",
      "pagination-path": "",
      "fields": _vm.fields.server,
      "api-mode": true,
      "css": _vm.boostrapCss,
      "http-options": _vm.httpOptions
    },
    on: {
      "vuetable:cell-clicked": _vm.onCellClicked
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function(props) {
        return [_c('button', {
          staticClass: "btn btn-danger",
          on: {
            "click": function($event) {
              return _vm.deleteServerP(props.rowData.id)
            }
          }
        }, [_vm._v("刪除")])]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1458 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-layout w-100 m-2"
  }, [_c('div', {
    staticClass: "alert alert-success"
  }, [_c('span', [_vm._v("目前操作藥盒：" + _vm._s(_vm.selectedDevicesID.indexOf(_vm.currentDevice.id.toString()) + 1) + " / " + _vm._s(_vm.selectedDevicesID.length))])]), _c('Action', {
    attrs: {
      "deviceId": _vm.currentDevice.id,
      "defaultNum": _vm.fakeNumber,
      "checkNum": _vm.fakeNumber,
      "hasSlot": true,
      "valueMoreThanZero": false
    },
    on: {
      "setActionData": _vm.getActionData
    }
  }, [(_vm.actionType === 'lock') ? _c('div', {
    staticClass: "instruction-wrapper"
  }, [_c('font-awesome-layers', {
    staticClass: "fa-3x fa-fw"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": _vm.arrowDownIcon,
      "transform": "shrink-6 up-10"
    }
  }), _c('font-awesome-icon', {
    attrs: {
      "icon": _vm.boxOpenIcon,
      "transform": "down-1"
    }
  })], 1), _c('h4', {
    staticClass: "text-center"
  }, [_vm._v("請將藥物放入藥盒內")])], 1) : _vm._e(), (_vm.actionType === 'unlock') ? _c('div', {
    staticClass: "instruction-wrapper"
  }, [_c('font-awesome-layers', {
    staticClass: "fa-3x fa-fw"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": _vm.arrowUpIcon,
      "transform": "shrink-6 up-10"
    }
  }), _c('font-awesome-icon', {
    attrs: {
      "icon": _vm.boxOpenIcon,
      "transform": "down-1"
    }
  })], 1), _c('h4', {
    staticClass: "text-center"
  }, [_vm._v("請將藥物自藥盒取出")])], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1459 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-layout"
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 1460 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-manual-wrap"
  }, [_c('form', {
    staticStyle: {
      "width": "30%"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.resetPassword($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("請輸入新密碼")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPass),
      expression: "newPass"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "新密碼",
      "required": ""
    },
    domProps: {
      "value": (_vm.newPass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPass = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPass2),
      expression: "newPass2"
    }],
    staticClass: "form-control ",
    attrs: {
      "type": "password",
      "placeholder": "確認新密碼",
      "required": ""
    },
    domProps: {
      "value": (_vm.newPass2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPass2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("更新")])])])
},staticRenderFns: []}

/***/ }),
/* 1461 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loadingData) ? _c('Loader') : _vm._e(), _c('div', [_c('button', {
    staticClass: "btn btn-primary float-right",
    on: {
      "click": _vm.download
    }
  }, [_vm._v("下載目前報告")]), _vm._m(0), _c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onFilterSet($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medName),
      expression: "medName"
    }],
    staticClass: "form-control mr-2",
    attrs: {
      "type": "text",
      "placeholder": "輸入流水號, 車號或日期"
    },
    domProps: {
      "value": (_vm.medName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.medName = $event.target.value
      }
    }
  }), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("搜尋")])]), _c('hr'), _c('div', [_c('vuetable', {
    ref: "vuetable",
    attrs: {
      "api-url": (_vm.server + "/api/drug-storage-summary/"),
      "data-path": "",
      "fields": _vm.fields,
      "http-options": _vm.httpOptions,
      "pagination-path": "",
      "perPage": 30,
      "row-class": _vm.onRowClass,
      "css": _vm.boostrapCss,
      "detail-row-component": "adc-drug-detail-drug-storage",
      "append-params": _vm.moreParams
    },
    on: {
      "vuetable:cell-clicked": _vm.onCellClicked
    },
    scopedSlots: _vm._u([{
      key: "total_amount",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(props.rowData.total_amount))])]
      }
    }])
  })], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('kbd', [_vm._v("區間測速資訊")])])
}]}

/***/ }),
/* 1462 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upper-subpanel--inside"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('DrugInfo')], 1), _c('div', {
    staticClass: "col-6"
  }, [(_vm.currentProgress === 'confirm') ? _c('ConfirmFlow', {
    attrs: {
      "confirmProgress": _vm.confirmProgress,
      "actionProgress": _vm.actionProgress
    },
    on: {
      "confirmationFinish": _vm.getConfirmData
    }
  }) : _vm._e(), (_vm.currentProgress === 'finish') ? _c('Loader') : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1463 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.filterEvent($event)
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDate),
      expression: "showDate"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("開始時間")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.startDate),
      expression: "startDate"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.startDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.startDate = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("結束時間")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.endDate),
      expression: "endDate"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.endDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.endDate = $event.target.value
      }
    }
  })])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showStartDate),
      expression: "showStartDate"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("查詢日期")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.startDate),
      expression: "startDate"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.startDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.startDate = $event.target.value
      }
    }
  })])]), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFilterButton),
      expression: "showFilterButton"
    }],
    staticClass: "btn btn-primary mb-2 w-100",
    attrs: {
      "type": "submit",
      "value": "查詢"
    },
    on: {
      "click": _vm.filterEvent
    }
  }), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showReportButton),
      expression: "showReportButton"
    }],
    staticClass: "btn btn-info mb-2 w-100",
    on: {
      "click": _vm.getReport
    }
  }, [_vm._v("下載報告")])])
},staticRenderFns: []}

/***/ }),
/* 1464 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Patch', [_c('h5', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("系統設定")])])
},staticRenderFns: []}

/***/ }),
/* 1465 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h6', [_vm._v("區域清單")]), _vm._v(" "), _c('vuetable', {
    ref: "vuetable",
    attrs: {
      "api-url": (_vm.server + "/api/area/"),
      "data-path": "",
      "pagination-path": "",
      "fields": _vm.fields,
      "api-mode": true,
      "css": _vm.boostrapCss,
      "http-options": _vm.httpOptions
    },
    on: {
      "vuetable:cell-clicked": _vm.onCellClicked
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(props) {
        return [_c('button', {
          staticClass: "btn btn-danger",
          on: {
            "click": function($event) {
              return _vm.deleteArea(props.rowData.id)
            }
          }
        }, [_vm._v("刪除")])]
      }
    }])
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("區域名稱")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.areaName),
      expression: "areaName"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.areaName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.areaName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("所屬單位")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedDepartment),
      expression: "selectedDepartment"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedDepartment = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.departments), function(dep) {
    return _c('option', {
      domProps: {
        "value": dep.id
      }
    }, [_vm._v(_vm._s(dep.name))])
  }), 0)])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.createArea
    }
  }, [_vm._v("新增區域")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1466 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _c('h4', [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioValue),
      expression: "radioValue"
    }],
    attrs: {
      "type": "radio",
      "id": "radio1",
      "name": "radios",
      "value": "illegalCar",
      "checked": ""
    },
    domProps: {
      "checked": _vm._q(_vm.radioValue, "illegalCar")
    },
    on: {
      "change": function($event) {
        _vm.radioValue = "illegalCar"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radio1"
    }
  }, [_vm._v("違規車輛")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioValue),
      expression: "radioValue"
    }],
    attrs: {
      "type": "radio",
      "id": "radio2",
      "name": "radios",
      "value": "legalCar"
    },
    domProps: {
      "checked": _vm._q(_vm.radioValue, "legalCar")
    },
    on: {
      "change": function($event) {
        _vm.radioValue = "legalCar"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radio2"
    }
  }, [_vm._v("未違規車輛")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radioValue),
      expression: "radioValue"
    }],
    attrs: {
      "type": "radio",
      "id": "radio3",
      "name": "radios",
      "value": "allCar"
    },
    domProps: {
      "checked": _vm._q(_vm.radioValue, "allCar")
    },
    on: {
      "change": function($event) {
        _vm.radioValue = "allCar"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radio3"
    }
  }, [_vm._v("全部車輛")])]), _c('hr'), _c('div', {
    staticClass: "custom-functions-wrapper"
  }, _vm._l((_vm.reportFunctions), function(func) {
    return _c('div', {
      staticClass: "custom-function"
    }, [_c('h5', [_vm._v(" " + _vm._s(func.name))]), _c('hr'), _c('QueryFilter', {
      attrs: {
        "showDate": func.query_by_date,
        "showEventType": false,
        "showSystem": false,
        "showFilterButton": false
      },
      on: {
        "report": function($event) {
          return _vm.report($event, func.function_name, func.name, func.query_by_date)
        }
      }
    })], 1)
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('kbd', [_vm._v("區間速率報表")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "text-info"
  }, [_c('strong', [_vm._v("明細報表輸出類型")])])
}]}

/***/ }),
/* 1467 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar navbar-toggleable-sm custom-navbar"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-title"
  }, [_c('p', [_vm._v(_vm._s(_vm.currentApp.name))])]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto menu-info"
  }, [(_vm.user !== null || _vm.user !== undefined) ? _c('span', {
    attrs: {
      "id": "greeting"
    }
  }, [_vm._v(_vm._s(_vm.GreetingMsg) + ", \n      "), (_vm.user.first_name !== null && _vm.user.last_name !== null) ? _c('span', [_vm._v(_vm._s(_vm.user.last_name) + _vm._s(_vm.user.first_name))]) : _c('span', [_vm._v(_vm._s(_vm.user.username))]), _vm._v(" "), (_vm.user.title !== null) ? _c('span', [_vm._v(_vm._s(_vm.user.title.name))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.showLogout) ? _c('div', {
    staticClass: "logout-button",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("登出")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1468 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.stage === 'confirmAmount') ? _c('Action', {
    attrs: {
      "defaultNum": _vm.forAction.defaultNum,
      "autoCaculateAmount": false,
      "compType": 'Confirm',
      "defaultPackCount": _vm.theDrugStorage.pack_count,
      "deviceId": _vm.forAction.deviceId,
      "checkNum": _vm.forAction.checkNum
    },
    on: {
      "confirmAmountFinish": _vm.confirmAmountFinish
    }
  }, [_c('h5', [_vm._v("確認藥盒內數量")])]) : _vm._e(), _vm._v(" "), (_vm.stage === 'action') ? _c('Action', {
    attrs: {
      "defaultNum": _vm.forAction.defaultNum,
      "autoCaculateAmount": false,
      "defaultPackCount": 0,
      "deviceId": _vm.forAction.deviceId,
      "onlyPc": true,
      "inputReadOnly": _vm.fetchReadOnly,
      "checkNum": _vm.forAction.checkNum
    },
    on: {
      "setActionData": _vm.getThisAmount,
      "setTotalSumInstanly": _vm.getTotalSumInstanly
    }
  }, [_c('h5', [_vm._v("自此藥盒取藥數量 (pc)")])]) : _vm._e(), _vm._v(" "), (_vm.stage === 'break') ? _c('ActionBreak', {
    attrs: {
      "residual": _vm.amount - _vm.totalAmount
    },
    on: {
      "goOn": _vm.goOn
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stage === 'next') ? _c('Loader') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1469 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drug-panel"
  }, [_c('div', {
    staticClass: "drug-panel--head"
  }, [_c('button', {
    staticClass: "btn btn-info icon-right",
    on: {
      "click": function($event) {
        _vm.createForm = true
      }
    }
  }, [_vm._v("新增套藥")]), (_vm.createForm) ? _c('CreateSpecialMedicineForm', {
    attrs: {
      "medicineType": 'combo'
    },
    on: {
      "closeForm": _vm.closeForm,
      "dataCreated": _vm.dataCreated
    }
  }) : _vm._e()], 1), _c('vuetable', {
    ref: "vuetableCombo",
    attrs: {
      "track-by": 'id',
      "api-mode": false,
      "fields": _vm.comboField,
      "pagination-path": "",
      "css": _vm.boostrapCss,
      "detail-row-component": "combo-detail",
      "item-actions": "itemActions"
    },
    on: {
      "vuetable:cell-clicked": _vm.onComboClicked
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(props) {
        return [_c('button', {
          staticClass: "btn btn-danger btn-sm",
          on: {
            "click": function($event) {
              return _vm.deleteCombo(props.rowData)
            }
          }
        }, [_vm._v("刪除套藥")])]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1470 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.currentProgress !== 'action') ? _c('CurrentLocationPanel') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "system-panel-wrapper"
  }, [(_vm.currentProgress === 'setMaxStock') ? _c('confirmMaxStock', {
    on: {
      "setMaxAmountData": _vm.getMaxAmountData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'setExpiredDate') ? _c('confirmExpirationDate', {
    on: {
      "setExpirationDate": _vm.getExpirationDate
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.currentProgress === 'action') ? _c('Action', {
    attrs: {
      "defaultNum": _vm.maxAmount,
      "deviceId": _vm.$store.state.device.currentDevice.id,
      "autoCaculateAmount": true,
      "checkNum": _vm.maxAmount,
      "limitPackCount": false
    },
    on: {
      "setActionData": _vm.getActionData
    }
  }, [_c('h6', [_vm._v("此藥盒新增數量")])]) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'next') ? _c('Loader') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1471 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-layout"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('h6', [_vm._v("藥物資訊")]), _c('hr'), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("藥碼")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicineData.code),
      expression: "medicineData.code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.medicineData.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.medicineData, "code", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("料位號")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicineData.CGMH_number),
      expression: "medicineData.CGMH_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.medicineData.CGMH_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.medicineData, "CGMH_number", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("學名")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicineData.generic_name),
      expression: "medicineData.generic_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.medicineData.generic_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.medicineData, "generic_name", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("產品名")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicineData.product_name),
      expression: "medicineData.product_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.medicineData.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.medicineData, "product_name", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "col-2"
  }, [_c('h6', [_vm._v("藥盒資訊")]), _c('hr'), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("藥盒條碼")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicineData.package_code2),
      expression: "medicineData.package_code2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.medicineData.package_code2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.medicineData, "package_code2", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("藥瓶（身）條碼")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicineData.package_code),
      expression: "medicineData.package_code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.medicineData.package_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.medicineData, "package_code", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("盒裝數量")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicineData.pack_content),
      expression: "medicineData.pack_content"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "title": "調整盒裝數會影響藥盒內藥物數量，請務必重新盤點"
    },
    domProps: {
      "value": (_vm.medicineData.pack_content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.medicineData, "pack_content", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "col-2"
  }, [_c('h6', [_vm._v("其他資訊")]), _c('hr'), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("管制等級")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicineData.restrained_class),
      expression: "medicineData.restrained_class"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.medicineData.restrained_class)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.medicineData, "restrained_class", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("衛生署字號")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicineData.license_id),
      expression: "medicineData.license_id"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.medicineData.license_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.medicineData, "license_id", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("製造廠商")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicineData.manufacturer),
      expression: "medicineData.manufacturer"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.medicineData.manufacturer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.medicineData, "manufacturer", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "switch-wrapper"
  }, [_c('div', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicineData.return_when_empty),
      expression: "medicineData.return_when_empty"
    }],
    attrs: {
      "id": "switch-return-when-empty",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.medicineData.return_when_empty) ? _vm._i(_vm.medicineData.return_when_empty, null) > -1 : (_vm.medicineData.return_when_empty)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.medicineData.return_when_empty,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.medicineData, "return_when_empty", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.medicineData, "return_when_empty", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.medicineData, "return_when_empty", $$c)
        }
      }
    }
  }), _c('label', {
    staticClass: "slider",
    class: {
      'slider-on': _vm.medicineData.return_when_empty
    },
    attrs: {
      "for": "switch-return-when-empty"
    }
  })]), _c('span', {
    staticClass: "switch-title"
  }, [_vm._v("需退空瓶")])]), _c('div', {
    staticClass: "switch-wrapper"
  }, [_c('div', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicineData.rx_check),
      expression: "medicineData.rx_check"
    }],
    attrs: {
      "id": "switch-rx-check",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.medicineData.rx_check) ? _vm._i(_vm.medicineData.rx_check, null) > -1 : (_vm.medicineData.rx_check)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.medicineData.rx_check,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.medicineData, "rx_check", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.medicineData, "rx_check", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.medicineData, "rx_check", $$c)
        }
      }
    }
  }), _c('label', {
    staticClass: "slider",
    class: {
      'slider-on': _vm.medicineData.rx_check
    },
    attrs: {
      "for": "switch-rx-check"
    }
  })]), _c('span', {
    staticClass: "switch-title"
  }, [_vm._v("需覆核")])])]), _c('div', {
    staticClass: "col-5"
  }, [_c('h6', [_vm._v("藥物圖片")]), _c('hr'), _c('div', {
    staticClass: "drug-image-setting"
  }, [_c('div', {
    staticClass: "drug-image-wrapper"
  }, [(_vm.medicineData.drug_picture_1) ? _c('img', {
    staticClass: "drug-image",
    attrs: {
      "src": _vm.medicineData.drug_picture_1
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("藥物照片(ㄧ)")]), _c('input', {
    staticClass: "form-control-file",
    attrs: {
      "type": "file",
      "id": (_vm.rowIndex + "-photo1")
    },
    on: {
      "change": _vm.onChange
    }
  })])]), _c('div', {
    staticClass: "drug-image-setting"
  }, [_c('div', {
    staticClass: "drug-image-wrapper"
  }, [(_vm.medicineData.drug_picture_2) ? _c('img', {
    staticClass: "drug-image",
    attrs: {
      "src": _vm.medicineData.drug_picture_2
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("藥物照片(二)")]), _c('input', {
    staticClass: "form-control-file",
    attrs: {
      "type": "file",
      "id": (_vm.rowIndex + "-photo2")
    },
    on: {
      "change": _vm.onChange
    }
  })])]), _c('div', {
    staticClass: "drug-image-setting"
  }, [_c('div', {
    staticClass: "drug-image-wrapper"
  }, [(_vm.medicineData.drug_box_picture) ? _c('img', {
    staticClass: "drug-image",
    attrs: {
      "src": _vm.medicineData.drug_box_picture
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("藥盒照片")]), _c('input', {
    staticClass: "form-control-file",
    attrs: {
      "type": "file",
      "id": (_vm.rowIndex + "-photo3")
    },
    on: {
      "change": _vm.onChange
    }
  })])])])]), _c('button', {
    staticClass: "btn btn-primary mr-2",
    on: {
      "click": _vm.updateMedicine
    }
  }, [_vm._v("儲存")]), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.deleteMedicine
    }
  }, [_vm._v("刪除")])])
},staticRenderFns: []}

/***/ }),
/* 1472 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('h6', {
    staticClass: "text-center",
    attrs: {
      "for": "amount"
    }
  }, [_vm._v("最大庫存")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amount),
      expression: "amount"
    }],
    ref: "input",
    staticClass: "form-control custom-input",
    attrs: {
      "id": "amount",
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.amount)
    },
    on: {
      "click": function($event) {
        _vm.showPad = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showPad) ? _c('NumberInput', {
    attrs: {
      "defaultNumber": _vm.amount
    },
    on: {
      "saveNumber": _vm.saveNumber
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('h6', {
    staticClass: "text-center",
    attrs: {
      "for": "patch"
    }
  }, [_vm._v("批號")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.patchNumber),
      expression: "patchNumber"
    }],
    staticClass: "form-control custom-input",
    attrs: {
      "id": "patchnumber",
      "placeholder": _vm.placeholderText
    },
    domProps: {
      "value": (_vm.patchNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.patchNumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "button-wrap"
  }, [_c('button', {
    staticClass: "btn btn-lg confirm-button",
    on: {
      "click": _vm.setMaxAmountData
    }
  }, [_vm._v("確認")])])])
},staticRenderFns: []}

/***/ }),
/* 1473 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-layout"
  }, [_c('div', {
    staticClass: "alert alert-success"
  }, [_c('span', [_vm._v("管制組藥退藥（" + _vm._s(_vm.currentMed.parent_medication.generic_name) + "）")])]), (_vm.stage === 'selectReason') ? _c('ConfirmReason', {
    on: {
      "setReason": _vm.getReason
    }
  }) : _vm._e(), (_vm.stage === 'confirm') ? _c('div', {
    staticClass: "confirm-form"
  }, [_c('h5', {
    staticClass: "text-center"
  }, [_vm._v("選擇使用情形 (" + _vm._s(_vm.setIndex + 1) + "/" + _vm._s(this.controlMedSet.length) + ")")]), _c('div', {
    staticClass: "button-wrap",
    on: {
      "click": function($event) {
        return _vm.setReturnStatus('RECYCLE_EMPTY')
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-lg confirm-button"
  }, [_vm._v("已使用（退空瓶）")])]), _c('div', {
    staticClass: "button-wrap",
    on: {
      "click": function($event) {
        return _vm.setReturnStatus('RETURN')
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-lg confirm-button"
  }, [_vm._v("未使用（退藥）")])])]) : _vm._e(), (_vm.stage === 'action') ? _c('Action', {
    attrs: {
      "inputReadOnly": true,
      "defaultNum": _vm.forAction.defaultNum,
      "deviceId": _vm.forAction.deviceId,
      "checkNum": _vm.forAction.checkNum,
      "defaultPackCount": 0,
      "limitPackCount": false
    },
    on: {
      "setActionData": _vm.getThisAmount
    }
  }, [_c('h5', [_c('strong', [_c('span', [_vm._v("退回管制組藥")])])])]) : _vm._e(), (_vm.stage === 'finish') ? _c('Loader') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1474 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.stage === 'confirmAmount') ? _c('Action', {
    attrs: {
      "defaultNum": _vm.forAction.defaultNum,
      "autoCaculateAmount": false,
      "compType": 'Confirm',
      "defaultPackCount": _vm.theDrugStorage.pack_count,
      "deviceId": _vm.forAction.deviceId,
      "checkNum": _vm.forAction.checkNum
    },
    on: {
      "confirmAmountFinish": _vm.confirmAmountFinish
    }
  }, [_c('h5', [_vm._v("確認藥盒內數量")])]) : _vm._e(), _vm._v(" "), (_vm.stage === 'action') ? _c('Action', {
    attrs: {
      "defaultNum": _vm.forAction.defaultNum,
      "autoCaculateAmount": false,
      "defaultPackCount": 0,
      "deviceId": _vm.forAction.deviceId,
      "onlyPc": true,
      "inputReadOnly": _vm.fetchReadOnly,
      "checkNum": _vm.forAction.checkNum
    },
    on: {
      "setActionData": _vm.getThisAmount,
      "setTotalSumInstanly": _vm.getTotalSumInstanly
    }
  }, [_c('h5', [_vm._v("自此藥盒取藥數量 (pc)")])]) : _vm._e(), _vm._v(" "), (_vm.stage === 'break') ? _c('ActionBreak', {
    attrs: {
      "residual": _vm.amount - _vm.totalAmount
    },
    on: {
      "goOn": _vm.goOn
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stage === 'next') ? _c('Loader') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1475 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Patch', [_c('h5', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("認證管理")])])
},staticRenderFns: []}

/***/ }),
/* 1476 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upper-subpanel row"
  }, [_c('progressBar'), _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [(_vm.stage === 'eventList') ? _c('eventTable', {
    attrs: {
      "eventType": _vm.eventType
    }
  }) : _vm._e(), (_vm.stage === 'setFlowData') ? _c('MultiFlow', {
    attrs: {
      "multiProgress": _vm.multiProgress,
      "confirmProgress": _vm.confirmProgress,
      "actionProgress": _vm.actionProgress
    },
    on: {
      "setAllConfirmData": _vm.getAllConfirmData
    }
  }) : _vm._e(), (_vm.stage === 'finish') ? _c('Loader') : _vm._e()], 1)], 1), _c('BottomButtons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  }), (_vm.stage !== 'setFlowData') ? _c('action-button', {
    attrs: {
      "slot": "button-6",
      "title": "取消全選"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$store.dispatch('unSelectAllEventItems')
      }
    },
    slot: "button-6"
  }) : _vm._e(), (_vm.stage !== 'setFlowData') ? _c('action-button', {
    attrs: {
      "slot": "button-7",
      "title": "選擇全部"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$store.dispatch('selectAllEventItems')
      }
    },
    slot: "button-7"
  }) : _vm._e(), (_vm.stage !== 'setFlowData') ? _c('action-button', {
    attrs: {
      "slot": "button-9",
      "title": "開始動作",
      "clickable": _vm.$store.state.drugInDevice.selectedDrugInDeviceID.length > 0 || _vm.$store.state.event.selectedEventId.length > 0
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startFlow($event)
      }
    },
    slot: "button-9"
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1477 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h6', [_vm._v("標籤清單")]), _c('vuetable', {
    ref: "vuetable",
    attrs: {
      "api-url": (_vm.server + "/api/system/?type=Tag"),
      "data-path": "results",
      "pagination-path": "",
      "fields": _vm.fields,
      "api-mode": true,
      "css": _vm.boostrapCss,
      "http-options": _vm.httpOptions,
      "detail-row-component": "tag-detail"
    },
    on: {
      "vuetable:cell-clicked": _vm.onCellClicked
    }
  }), _c('vuetable-pagination', {
    ref: "pagination",
    attrs: {
      "css": _vm.boostrapCss.pagination
    },
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1478 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-panel"
  }, [_c('Navbar'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 1479 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("新增使用者"), _c('span', {
    staticClass: "icon-right",
    on: {
      "click": function($event) {
        return _vm.$emit('closeForm')
      }
    }
  }, [_vm._v("X")])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password2),
      expression: "password2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.password2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password2 = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "input-group col-6"
  }, [_vm._m(3), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-group col-6"
  }, [_vm._m(4), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  })])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginBarcode),
      expression: "loginBarcode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.loginBarcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.loginBarcode = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "input-group col-6"
  }, [_vm._m(6), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.jobTitle),
      expression: "jobTitle"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.jobTitle = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.jobTitles), function(job) {
    return _c('option', {
      domProps: {
        "value": job.id
      }
    }, [_vm._v(_vm._s(job.name))])
  }), 0)]), _c('div', {
    staticClass: "input-group col-6"
  }, [_vm._m(7), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.department),
      expression: "department"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.department = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.departments), function(dep) {
    return _c('option', {
      domProps: {
        "value": dep.id
      }
    }, [_vm._v(_vm._s(dep.name))])
  }), 0)])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.serverPrivilege2Group),
      expression: "serverPrivilege2Group"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.serverPrivilege2Group = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.serverPrivilege2Groups), function(privilege) {
    return _c('option', {
      domProps: {
        "value": privilege.id
      }
    }, [_vm._v(_vm._s(privilege.name) + " ")])
  }), 0)])]), _c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.backManage),
      expression: "backManage"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "backManage"
    },
    domProps: {
      "checked": Array.isArray(_vm.backManage) ? _vm._i(_vm.backManage, null) > -1 : (_vm.backManage)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.backManage,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.backManage = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.backManage = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.backManage = $$c
        }
      }
    }
  }), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "backManage"
    }
  }, [_vm._v("能否後台設定")])]), _c('hr'), _c('span', {
    staticClass: "errorMsg"
  }, [_vm._v(_vm._s(_vm.formMsg))]), _c('button', {
    staticClass: "btn btn-secondary float-right",
    attrs: {
      "disabled": _vm.formComplete === false
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createNewUser($event)
      }
    }
  }, [_vm._v("新增")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("帳號*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("密碼*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("再次輸入密碼* ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("姓*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("名*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("警員代碼*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("職稱*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("單位*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("後台操作權限*")])])
}]}

/***/ }),
/* 1480 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.currentDevice) ? _c('div', {
    staticClass: "alert alert-info row",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('div', {
    staticClass: "col-8 alert-text--wrap"
  }, [_c('strong', [_vm._v("目前位置")]), _vm._v(" "), _c('p', [_vm._v("\n      第 " + _vm._s(_vm.currentDevice.net.open_times) + " 藥櫃, 第 " + _vm._s(_vm.currentDevice.net.row_id) + " 層\n      "), (_vm.currentDevice.pos_row !== 0) ? _c('span', [_vm._v("\n        , 第 " + _vm._s(_vm.currentDevice.pos_row) + " 列, 第 " + _vm._s(_vm.currentDevice.relative_col) + " 行\n      ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "small-net col-4"
  }, [_vm._l((_vm.numRow), function(n) {
    return _c('div', {
      staticClass: "small-row",
      style: ({
        order: n,
        height: ((100/_vm.numRow) + "%")
      })
    }, _vm._l((_vm.currentNet.device_set), function(box) {
      return (box.pos_row === n) ? _c('div', {
        class: {
          'small-box': true,
          'current-box': box.pos_row === _vm.currentDevice.pos_row &&
            box.relative_col === _vm.currentDevice.relative_col
        }
      }) : _vm._e()
    }), 0)
  }), _vm._v(" "), (_vm.currentDevice.pos_row === 0) ? _c('div', {
    staticClass: "small-row",
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "small-box current-box"
  }, [_vm._v("\n        " + _vm._s(_vm.currentDevice.net.row_id) + "\n      ")])]) : _vm._e()], 2)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1481 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-layout"
  }, [(_vm.tagSystems.length === 0) ? _c('div', {
    staticClass: "empty-layout"
  }, [_c('img', {
    attrs: {
      "src": "/static/svg/empty-inbox.svg"
    }
  }), _c('p', [_vm._v("無標籤系統資料")])]) : _c('div', [_c('h6', [_vm._v(" 標籤系統清單")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-group col-6"
  }, [_vm._m(0), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tagId),
      expression: "tagId"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tagId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.setCurrentTag]
    }
  }, _vm._l((_vm.tagSystems), function(tag, num) {
    return _c('option', {
      domProps: {
        "value": num
      }
    }, [_vm._v(_vm._s(tag.name))])
  }), 0)]), _c('div', {
    staticClass: "input-group col-6"
  }, [_vm._m(1), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.netId),
      expression: "netId"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.netId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.setCurrentNet]
    }
  }, _vm._l((_vm.nets), function(net, num) {
    return _c('option', {
      domProps: {
        "value": num
      }
    }, [_vm._v(_vm._s(net.row_id) + " ")])
  }), 0)])]), _c('hr'), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.netId !== ''),
      expression: "netId !== ''"
    }]
  }, [_c('button', {
    staticClass: "btn btn-info icon-right",
    on: {
      "click": _vm.popCreateForm
    }
  }, [_vm._v("新增藥物儲存")]), (_vm.createForm) ? _c('CreateDrugStorageForm', {
    attrs: {
      "devices": _vm.devices
    },
    on: {
      "cancelForm": _vm.cancelForm
    }
  }) : _vm._e(), _c('vuetable', {
    ref: "vuetable",
    attrs: {
      "api-url": (_vm.server + "/api/drug-storage/"),
      "data-path": "results",
      "fields": _vm.fields,
      "http-options": _vm.httpOptions,
      "pagination-path": "",
      "css": _vm.boostrapCss,
      "append-params": _vm.moreParams,
      "perPage": 20,
      "sortOrder": _vm.sortOrder,
      "track-by": "id"
    },
    on: {
      "vuetable:pagination-data": _vm.onPaginationData
    }
  }), _c('vuetable-pagination', {
    ref: "pagination",
    attrs: {
      "css": _vm.boostrapCss.pagination
    },
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("選擇系統")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("選擇欄位")])])
}]}

/***/ }),
/* 1482 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "half-layout"
  }, [(_vm.currentDevice) ? _c('div', {
    staticClass: "alert alert-info row"
  }, [_c('div', {
    staticClass: "col-8 alert-text--wrap"
  }, [_c('strong', [_vm._v("目前位置")]), _vm._v(" "), _c('p', [_vm._v("\n        第 " + _vm._s(_vm.currentDevice.net.open_times) + " 藥櫃, 第 " + _vm._s(_vm.currentDevice.net.row_id) + " 層\n        "), (_vm.currentDevice.pos_row !== 0) ? _c('span', [_vm._v("\n          , 第 " + _vm._s(_vm.currentDevice.pos_row) + " 列, 第 " + _vm._s(_vm.currentDevice.relative_col) + " 行\n        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "small-net col-4"
  }, [_vm._l((_vm.numRow), function(n) {
    return _c('div', {
      staticClass: "small-row",
      style: ({
        order: n,
        height: ((100/_vm.numRow) + "%")
      })
    }, _vm._l((_vm.currentNet.device_set), function(box) {
      return (box.pos_row === n) ? _c('div', {
        class: {
          'small-box': true,
          'current-box': box.pos_row === _vm.currentDevice.pos_row &&
            box.relative_col === _vm.currentDevice.relative_col
        }
      }) : _vm._e()
    }), 0)
  }), _vm._v(" "), (_vm.currentDevice.pos_row === 0) ? _c('div', {
    staticClass: "small-row",
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "small-box current-box"
  }, [_vm._v("\n          " + _vm._s(_vm.currentDevice.net.row_id) + "\n        ")])]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('span', [_c('strong', [_vm._v("偵測開啟位置: ")]), _vm._v(" "), _vm._l((_vm.errorDevice), function(device) {
    return (_vm.errorDevice) ? _c('span', [(device.type === 'drawer' && device.drawerId === _vm.currentDevice.net.row_id) ? _c('span', {
      staticClass: "alert-device-text"
    }, [_vm._v("抽屜 " + _vm._s(device.drawerId) + " ")]) : _vm._e(), _vm._v(" "), (device.type === 'drawer' && device.drawerId !== _vm.currentDevice.net.row_id) ? _c('span', {
      staticClass: "error-device-text"
    }, [_vm._v("抽屜 " + _vm._s(device.drawerId) + " ")]) : _vm._e(), _vm._v(" "), (device.type === 'box' && device.row === _vm.currentDevice.pos_row && device.col === _vm.currentDevice.relative_col) ? _c('span', {
      staticClass: "alert-device-text"
    }, [_vm._v("藥盒 " + _vm._s(device.row) + " - " + _vm._s(device.col) + "  ")]) : _vm._e(), _vm._v(" "), (device.type === 'box' && (device.row !== _vm.currentDevice.pos_row || device.col !== _vm.currentDevice.relative_col)) ? _c('span', {
      staticClass: "error-device-text"
    }, [_vm._v("藥盒 " + _vm._s(device.row) + " - " + _vm._s(device.col) + "  ")]) : _vm._e()]) : _vm._e()
  })], 2)])], 2)
},staticRenderFns: []}

/***/ }),
/* 1483 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lower-subpanel-wrap"
  }, [_vm._t("button-1", [_vm._m(0)]), _vm._t("button-2", [_vm._m(1)]), _vm._t("button-3", [_vm._m(2)]), _vm._t("button-4", [_vm._m(3)]), _vm._t("button-5", [_vm._m(4)]), _vm._t("button-6", [_vm._m(5)]), _vm._t("button-7", [_vm._m(6)]), _vm._t("button-8", [_vm._m(7)]), _vm._t("button-9", [_vm._m(8)])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn control-button control-button-red button-transparent"
  }, [_c('div', {
    staticClass: "button-inside-wrap"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn control-button control-button-red button-transparent"
  }, [_c('div', {
    staticClass: "button-inside-wrap"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn control-button control-button-red button-transparent"
  }, [_c('div', {
    staticClass: "button-inside-wrap"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn control-button control-button-red button-transparent"
  }, [_c('div', {
    staticClass: "button-inside-wrap"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn control-button control-button-red button-transparent"
  }, [_c('div', {
    staticClass: "button-inside-wrap"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn control-button control-button-red button-transparent"
  }, [_c('div', {
    staticClass: "button-inside-wrap"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn control-button control-button-red button-transparent"
  }, [_c('div', {
    staticClass: "button-inside-wrap"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn control-button control-button-red button-transparent"
  }, [_c('div', {
    staticClass: "button-inside-wrap"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn control-button control-button-red button-transparent"
  }, [_c('div', {
    staticClass: "button-inside-wrap"
  })])
}]}

/***/ }),
/* 1484 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upper-subpanel row"
  }, [_c('progressBar'), _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [(_vm.stage === 'selectDrug') ? _c('div', {
    staticClass: "row outdated-row",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "margin": "0"
    }
  }, [_c('ul', {
    staticClass: "nav nav-pills nav-fill nav-autoix"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('div', {
    staticClass: "nav-link",
    class: {
      'active': _vm.tabStage === 'expired'
    },
    on: {
      "click": function($event) {
        _vm.tabStage = 'expired'
      }
    }
  }, [_vm._v("過期藥物")])]), _c('li', {
    staticClass: "nav-item"
  }, [_c('div', {
    staticClass: "nav-link",
    class: {
      'active': _vm.tabStage === 'generallyExpired'
    },
    on: {
      "click": function($event) {
        _vm.tabStage = 'generallyExpired'
      }
    }
  }, [_vm._v("即期藥物")])])]), (_vm.tabStage === 'expired') ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "drug-search-list small-drug-list"
  }, [(_vm.drugInDeviceList.length === 0) ? _c('div', {
    staticClass: "with-child-centered"
  }, [_c('h5', [_vm._v("無過期藥物")])]) : _vm._l((_vm.drugInDeviceList), function(drug, num) {
    return _c('div', {
      class: {
        'btn': true, 'drug-button': true, 'drug-selected': drug.selected
      },
      on: {
        "click": function($event) {
          return _vm.selectDrug(num)
        }
      }
    }, [_c('div', {
      staticClass: "drug-head"
    }, [_c('div', {
      staticClass: "drug-head--content"
    }, [(drug.medication.CGMH_number !== null) ? _c('span', [_vm._v("[ " + _vm._s(drug.medication.CGMH_number) + " - "), _c('span', [_vm._v(_vm._s(drug.medication.code) + " ]")])]) : _vm._e(), _c('p', [_vm._v(_vm._s(drug.medication.generic_name))])])]), _c('div', {
      staticClass: "drug-item"
    }, [_c('div', {
      staticClass: "info-col",
      attrs: {
        "id": "position"
      }
    }, [_vm._m(0, true), _c('div', {
      staticClass: "info-col-content"
    }, [_c('p', [_vm._v(_vm._s(drug.device.net.open_times) + " - " + _vm._s(drug.device.net.row_id) + " - " + _vm._s(drug.device.pos_row) + " - " + _vm._s(drug.device.relative_col))])])]), _c('div', {
      staticClass: "info-col",
      attrs: {
        "id": "max-amount"
      }
    }, [_vm._m(1, true), _c('div', {
      staticClass: "info-col-content"
    }, [_c('p', [_vm._v(_vm._s(drug.stock) + "(" + _vm._s(drug.max_stock) + ")")])])]), _c('div', {
      staticClass: "info-col",
      attrs: {
        "id": "patch"
      }
    }, [_vm._m(2, true), _c('div', {
      staticClass: "info-col-content"
    }, [(drug.patch_number === '' || drug.patch_number === undefined || drug.patch_number === null) ? _c('p', [_vm._v("未設定")]) : _c('p', [_vm._v(_vm._s(drug.patch_number))])])]), _c('div', {
      staticClass: "info-col",
      attrs: {
        "id": "expired-date"
      }
    }, [_vm._m(3, true), _c('div', {
      staticClass: "info-col-content"
    }, [_c('p', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(drug.expired_date))])])])])])
  })], 2)]) : _vm._e(), (_vm.tabStage === 'generallyExpired') ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "drug-search-list small-drug-list"
  }, [(_vm.graduallyExpireDrug.length === 0) ? _c('div', {
    staticClass: "with-child-centered"
  }, [_c('h5', [_vm._v("無即期藥物")])]) : _vm._l((_vm.graduallyExpireDrug), function(drug, num) {
    return _c('div', {
      class: {
        'btn': true, 'drug-button': true, 'drug-selected': drug.selected, 'unselectable-button': true
      }
    }, [_c('div', {
      staticClass: "drug-head"
    }, [_c('div', {
      staticClass: "drug-head--content"
    }, [(drug.medication.CGMH_number !== null) ? _c('span', [_vm._v("[ " + _vm._s(drug.medication.CGMH_number) + " - "), _c('span', [_vm._v(_vm._s(drug.medication.code) + " ]")])]) : _vm._e(), _c('p', [_vm._v(_vm._s(drug.medication.generic_name))])])]), _c('div', {
      staticClass: "drug-item"
    }, [_c('div', {
      staticClass: "info-col",
      attrs: {
        "id": "position"
      }
    }, [_vm._m(4, true), _c('div', {
      staticClass: "info-col-content"
    }, [_c('p', [_vm._v(_vm._s(drug.device.net.open_times) + " - " + _vm._s(drug.device.net.row_id) + " - " + _vm._s(drug.device.pos_row) + " - " + _vm._s(drug.device.relative_col))])])]), _c('div', {
      staticClass: "info-col",
      attrs: {
        "id": "max-amount"
      }
    }, [_vm._m(5, true), _c('div', {
      staticClass: "info-col-content"
    }, [_c('p', [_vm._v(_vm._s(drug.stock) + "(" + _vm._s(drug.max_stock) + ")")])])]), _c('div', {
      staticClass: "info-col",
      attrs: {
        "id": "patch"
      }
    }, [_vm._m(6, true), _c('div', {
      staticClass: "info-col-content"
    }, [(drug.patch_number === '' || drug.patch_number === undefined || drug.patch_number === null) ? _c('p', [_vm._v("未設定")]) : _c('p', [_vm._v(_vm._s(drug.patch_number))])])]), _c('div', {
      staticClass: "info-col",
      attrs: {
        "id": "expired-date"
      }
    }, [_vm._m(7, true), _c('div', {
      staticClass: "info-col-content"
    }, [_c('p', [_vm._v(_vm._s(drug.expired_date))])])])])])
  })], 2)]) : _vm._e()]) : _vm._e(), (_vm.stage === 'setFlowData') ? _c('MultiFlow', {
    attrs: {
      "multiProgress": _vm.multiProgress,
      "confirmProgress": _vm.confirmProgress
    },
    on: {
      "setAllConfirmData": _vm.getAllConfirmData
    }
  }) : _vm._e(), (_vm.stage === 'finish') ? _c('Loader') : _vm._e()], 1)], 1), _c('BottomButtons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  }), (_vm.stage !== 'setFlowData') ? _c('action-button', {
    attrs: {
      "slot": "button-8",
      "title": "取消選擇"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.unCheckAll($event)
      }
    },
    slot: "button-8"
  }) : _vm._e(), (_vm.stage !== 'setFlowData') ? _c('action-button', {
    attrs: {
      "slot": "button-7",
      "title": "全部選擇"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.checkAll($event)
      }
    },
    slot: "button-7"
  }) : _vm._e(), (_vm.stage !== 'setFlowData') ? _c('action-button', {
    attrs: {
      "slot": "button-9",
      "title": "開始移除"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startFlow($event)
      }
    },
    slot: "button-9"
  }) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-col-head"
  }, [_c('span', [_vm._v("位置(藥櫃-層-列-行)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-col-head"
  }, [_c('span', [_vm._v("庫存量(最大量)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-col-head"
  }, [_c('span', [_vm._v("批號")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-col-head"
  }, [_c('span', [_vm._v("有效期限")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-col-head"
  }, [_c('span', [_vm._v("位置(藥櫃-層-列-行)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-col-head"
  }, [_c('span', [_vm._v("庫存量(最大量)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-col-head"
  }, [_c('span', [_vm._v("批號")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-col-head"
  }, [_c('span', [_vm._v("有效期限")])])
}]}

/***/ }),
/* 1485 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upper-subpanel row"
  }, [_c('div', {
    staticClass: "error-wrap"
  }, [_c('div', {
    staticClass: "disable-device-wrap"
  }, _vm._l((_vm.disableDevices), function(dev) {
    return _c('div', {
      staticClass: "disable-device"
    }, [_c('p', [_vm._v("藥盒位置：" + _vm._s(dev.net.open_times) + " - " + _vm._s(dev.net.row_id) + " - " + _vm._s(dev.pos_row) + " - " + _vm._s(dev.relative_col))])])
  }), 0), _vm._m(0)])]), _c('BottomButtons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hint-msg"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v("已鎖定藥盒清單。請將此畫面拍下，並與工程人員聯絡，謝謝！")])])
}]}

/***/ }),
/* 1486 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upper-subpanel--inside"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('DrugInfo')], 1), _c('div', {
    staticClass: "col-6"
  }, [(_vm.currentProgress === 'confirm') ? _c('ConfirmFlow', {
    attrs: {
      "confirmProgress": _vm.confirmProgress,
      "actionProgress": _vm.actionProgress,
      "schedules": _vm.schedules,
      "summarySelectedMed": _vm.summarySelectedMed
    },
    on: {
      "confirmationFinish": _vm.getConfirmData
    }
  }) : _vm._e(), (_vm.currentProgress === 'finish') ? _c('Loader') : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1487 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tablePagination && _vm.tablePagination.last_page > 1),
      expression: "tablePagination && tablePagination.last_page > 1"
    }],
    class: _vm.css.wrapperClass
  }, [_c('a', {
    class: ['btn-nav', _vm.css.linkClass, _vm.isOnFirstPage ? _vm.css.disabledClass : ''],
    on: {
      "click": function($event) {
        return _vm.loadPage(1)
      }
    }
  }, [(_vm.css.icons.first != '') ? _c('i', {
    class: [_vm.css.icons.first]
  }) : _c('span', [_vm._v("«")])]), _vm._v(" "), _c('a', {
    class: ['btn-nav', _vm.css.linkClass, _vm.isOnFirstPage ? _vm.css.disabledClass : ''],
    on: {
      "click": function($event) {
        return _vm.loadPage('prev')
      }
    }
  }, [(_vm.css.icons.next != '') ? _c('i', {
    class: [_vm.css.icons.prev]
  }) : _c('span', [_vm._v(" ‹")])]), _vm._v(" "), (_vm.notEnoughPages) ? [_vm._l((_vm.totalPage), function(n) {
    return [_c('a', {
      class: [_vm.css.pageClass, _vm.isCurrentPage(n) ? _vm.css.activeClass : ''],
      domProps: {
        "innerHTML": _vm._s(n)
      },
      on: {
        "click": function($event) {
          return _vm.loadPage(n)
        }
      }
    })]
  })] : [_vm._l((_vm.windowSize), function(n) {
    return [_c('a', {
      class: [_vm.css.pageClass, _vm.isCurrentPage(_vm.windowStart + n - 1) ? _vm.css.activeClass : ''],
      domProps: {
        "innerHTML": _vm._s(_vm.windowStart + n - 1)
      },
      on: {
        "click": function($event) {
          return _vm.loadPage(_vm.windowStart + n - 1)
        }
      }
    })]
  })], _vm._v(" "), _c('a', {
    class: ['btn-nav', _vm.css.linkClass, _vm.isOnLastPage ? _vm.css.disabledClass : ''],
    on: {
      "click": function($event) {
        return _vm.loadPage('next')
      }
    }
  }, [(_vm.css.icons.next != '') ? _c('i', {
    class: [_vm.css.icons.next]
  }) : _c('span', [_vm._v("› ")])]), _vm._v(" "), _c('a', {
    class: ['btn-nav', _vm.css.linkClass, _vm.isOnLastPage ? _vm.css.disabledClass : ''],
    on: {
      "click": function($event) {
        return _vm.loadPage(_vm.totalPage)
      }
    }
  }, [(_vm.css.icons.last != '') ? _c('i', {
    class: [_vm.css.icons.last]
  }) : _c('span', [_vm._v("»")])])], 2)
},staticRenderFns: []}

/***/ }),
/* 1488 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    attrs: {
      "id": "return-panel"
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_vm._m(0), (_vm.sameMedDrugStorage.length !== 0) ? _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.sameMedDrugStorage), function(storage) {
    return _c('div', {
      staticClass: "col-6"
    }, [_c('div', {
      staticClass: "cmpn-button",
      on: {
        "click": function($event) {
          return _vm.setNextDrugStorage(storage)
        }
      }
    }, [_c('p', [_vm._v(_vm._s(_vm._f("readableDevice")(storage.device)))]), _c('p', [_vm._v(_vm._s(storage.stock) + " / " + _vm._s(storage.max_stock))]), _c('p', [_vm._v("批號:"), (storage.patch_number !== '' && storage.patch_number !== null && storage.patch_number !== undefined) ? _c('span', [_vm._v(_vm._s(storage.patch_number))]) : _c('span', [_vm._v("未設定")])])])])
  }), 0) : _vm._e()]), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body--title"
  }, [_c('h5', {
    staticClass: "text-center"
  }, [_vm._v("此藥物存放於多藥盒，請選擇欲補充藥盒")])])
}]}

/***/ }),
/* 1489 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upper-subpanel--inside",
    staticStyle: {
      "display": "block",
      "padding": "0.5rem 1rem"
    }
  }, [_c('ScanBarcode', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    on: {
      "setBarcode": _vm.getBarcode
    }
  }), _c('div', {
    staticStyle: {
      "display": "block",
      "margin": "10px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "20px",
      "white-space": "nowrap",
      "display": "inline-block"
    }
  }, [_vm._v("1. 請輸入病歷號(或直接掃描 QR Code帶入先前排程): ")]), (_vm.manualInputMedRecordId == true) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medRecordId),
      expression: "medRecordId"
    }],
    ref: "medInput",
    staticClass: "form-control-sm form-control",
    staticStyle: {
      "width": "200px",
      "display": "inline-block"
    },
    domProps: {
      "value": (_vm.medRecordId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.medRecordId = $event.target.value
      }
    }
  })]) : _vm._e(), (_vm.manualInputMedRecordId == false) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medRecordId),
      expression: "medRecordId"
    }],
    ref: "medInput",
    staticClass: "form-control-sm form-control",
    staticStyle: {
      "width": "200px",
      "display": "inline-block"
    },
    attrs: {
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.medRecordId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.medRecordId = $event.target.value
      }
    }
  })]) : _vm._e()]), _c('div', [_c('p', [_vm._v("2. 選擇類別: "), (_vm.selectedSet) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.selectedSet))]) : _vm._e()]), (_vm.selectedSet === undefined) ? _c('div', {
    staticClass: "button-wrapper"
  }, _vm._l((_vm.combos), function(set, set_ind) {
    return _c('div', {
      staticClass: "control-button-custom control-button control-button-green m-1",
      staticStyle: {
        "width": "120px"
      },
      on: {
        "click": function($event) {
          _vm.selectedSet = set.dep_name
        }
      }
    }, [_c('div', {
      staticClass: "button-inside-wrap"
    }, [_vm._v(_vm._s(set.dep_name))])])
  }), 0) : _vm._e(), _c('p', [_vm._v("3. 選擇套藥")]), (_vm.selectedSet !== undefined) ? _c('div', {
    staticClass: "button-wrapper"
  }, _vm._l((_vm.combosets[_vm.selectedSet].combolist), function(combo, combo_ind) {
    return _c('div', {
      staticClass: "control-button-custom control-button control-button-green m-1",
      class: {
        'control-button-selected': combo.selected
      },
      on: {
        "click": function($event) {
          return _vm.setCombo(combo, combo_ind)
        }
      }
    }, [_c('div', {
      staticClass: "button-inside-wrap"
    }, [_vm._v(_vm._s(combo.generic_name))])])
  }), 0) : _vm._e()]), _c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "500px",
      "bottom": "-97px"
    }
  }, [_c('button', {
    staticClass: "btn control-button control-button-red",
    on: {
      "click": _vm.gotoFetchDrugGroup
    }
  }, [_vm._v("類別取藥")])]), _c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "10px",
      "bottom": "-97px"
    }
  }, [_c('button', {
    staticClass: "btn control-button control-button-red",
    on: {
      "click": _vm.startAction
    }
  }, [_vm._v("下一步驟")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1490 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-layout"
  }, [_c('div', {
    staticClass: "alert alert-success"
  }, [_c('span', [_vm._v("此藥物總存量:  " + _vm._s(_vm.selectedDrugTotalAmount))]), _c('span', {
    staticClass: "float-right"
  })]), (_vm.currentProgress === 'rxCheck') ? _c('RxCheckBarcode', {
    on: {
      "confirmRx": _vm.confirmRx
    }
  }) : _vm._e(), (_vm.currentProgress === 'actionWrap') ? _c('ActionWrap', {
    attrs: {
      "actionProgress": _vm.actionProgress,
      "amount": _vm.currentDrug.amount,
      "barcodeData": _vm.barcodeData,
      "schedules": _vm.schedules,
      "summarySelectedMed": _vm.summarySelectedMed,
      "reviewer": _vm.reviewer
    },
    on: {
      "setActionData": _vm.getFetchData
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1491 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-layout"
  }, [_c('div', {
    staticClass: "progress-wrap"
  }, _vm._l((_vm.progress), function(step, n) {
    return _c('div', {
      class: {
        'step': true, 'step-last': (n + 1) === _vm.progress.length
      }
    }, [_c('div', {
      class: {
        'point-wrap': true
      }
    }, [_c('div', {
      class: {
        point: true,
          'done-step': n <= _vm.indOfThisStep,
          'current-step': n === _vm.indOfThisStep,
      }
    }, [_c('p', [_vm._v(_vm._s(n + 1))])]), _vm._v(" "), _c('p', {
      staticClass: "point-title"
    }, [_vm._v(_vm._s(step.zh))])])])
  }), 0), _vm._v(" "), (_vm.currentSchedule && _vm.$store.state.currentApp.name === '醫囑取藥') ? _c('patient-info') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1492 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.stage === 'returnSelection') ? _c('ReturnSelection', {
    on: {
      "setReturnDevice": _vm.getReturnDevice,
      "setReturnDrugStorage": _vm.getReturnDrugStorage
    }
  }) : _vm._e(), (_vm.stage === 'confirmAmount') ? _c('Action', {
    attrs: {
      "defaultNum": _vm.forAction.defaultNum,
      "autoCaculateAmount": false,
      "compType": 'Confirm',
      "defaultPackCount": _vm.currentDrugInDevice.pack_count,
      "deviceId": _vm.forAction.deviceId,
      "checkNum": _vm.forAction.checkNum
    },
    on: {
      "confirmAmountFinish": _vm.confirmAmountFinish
    }
  }, [_c('h5', [_vm._v("確認藥盒內數量")])]) : _vm._e(), (_vm.stage === 'action') ? _c('Action', {
    attrs: {
      "inputReadOnly": true,
      "defaultNum": _vm.forAction.defaultNum,
      "deviceId": _vm.forAction.deviceId,
      "checkNum": _vm.forAction.checkNum,
      "defaultPackCount": _vm.amountPayload.packCount,
      "limitPackCount": false
    },
    on: {
      "setActionData": _vm.getThisAmount
    }
  }, [_c('h5', [_c('strong', [(this.currentDevice.specific_type === 'return_device') ? _c('span', [_vm._v("退至退藥盒")]) : (_vm.returnToEmptyDeviceId) ? _c('span', [_vm._v("退至空藥盒")]) : _c('span', [_vm._v("退至原藥盒")])])])]) : _vm._e(), (_vm.stage === 'finish') ? _c('Loader') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1493 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upper-subpanel row"
  }, [_c('progressBar'), _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [(_vm.stage === 'Start' && _vm.starttype === 'Manual') ? _c('CreateSchedule', {
    attrs: {
      "medRecordId": _vm.medRecordId,
      "manualInputMedRecordId": _vm.manualInputMedRecordId,
      "bedId": _vm.bedId,
      "gender": _vm.gender
    },
    on: {
      "createDone": _vm.getSchedule,
      "createReady": function($event) {
        _vm.manualCreateReady = true
      },
      "emitProgress": _vm.emitProgress
    }
  }) : _vm._e(), (_vm.stage === 'Start' && _vm.starttype === 'OperatingRoomHIS') ? _c('OperatingRoomScheduleList', {
    on: {
      "setSchedule": _vm.getSchedule,
      "setPatientSchedule": _vm.getPatientSchedule
    }
  }) : _vm._e(), (_vm.stage === 'Start' && _vm.starttype === 'HIS') ? _c('ScheduleList', {
    attrs: {
      "filterOutZeroAmountMed": _vm.filterOutZeroAmountMed
    },
    on: {
      "setSchedule": _vm.getSchedule
    }
  }) : _vm._e(), (_vm.stage === 'ComboMedListAndPatient') ? _c('ComboMedListAndPatient', {
    attrs: {
      "filterOutZeroAmountMed": _vm.filterOutZeroAmountMed
    }
  }) : _vm._e(), (_vm.stage === 'startFlow') ? _c('MultiFlow', {
    attrs: {
      "multiProgress": _vm.multiProgress,
      "confirmProgress": _vm.confirmProgress,
      "actionProgress": _vm.actionProgress
    },
    on: {
      "setAllConfirmData": _vm.getAllConfirmData
    }
  }) : _vm._e(), (_vm.stage === 'finish') ? _c('Loader') : _vm._e()], 1)], 1), _c('BottomButtons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面",
      "clickable": _vm.currentApp.cancel
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  }), (_vm.stage === 'ComboMedListAndPatient') ? _c('action-button', {
    attrs: {
      "slot": "button-4",
      "title": "類別取藥"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'fetchDrugGroup'
        })
      }
    },
    slot: "button-4"
  }) : _vm._e(), (_vm.stage === 'ComboMedListAndPatient') ? _c('action-button', {
    attrs: {
      "slot": "button-9",
      "title": "開始取藥",
      "clickable": _vm.DrugsForFetchList.length > 0
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startFlow($event)
      }
    },
    slot: "button-9"
  }) : _vm._e(), (_vm.starttype === 'OperatingRoomHIS') ? _c('action-button', {
    attrs: {
      "slot": "button-9",
      "title": "手動排程",
      "clickable": _vm.manualEnable === true
    },
    nativeOn: {
      "click": function($event) {
        return _vm.manualSchedule($event)
      }
    },
    slot: "button-9"
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1494 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upper-subpanel row"
  }, [_c('progressBar'), _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [(_vm.drugSetMethod === 'event' && _vm.stage === 'selectDrug') ? _c('eventTable', {
    attrs: {
      "eventType": _vm.eventType,
      "singleSelection": true,
      "noChecked": false
    }
  }, [_c('drugList', {
    attrs: {
      "singleSelection": true
    }
  })], 1) : _vm._e(), (_vm.stage === 'setFlowData') ? _c('MultiFlow', {
    attrs: {
      "multiProgress": _vm.multiProgress,
      "confirmProgress": _vm.confirmProgress,
      "actionProgress": _vm.actionProgress,
      "startType": _vm.startType,
      "barcodeData": _vm.barcodeData
    },
    on: {
      "setAllConfirmData": _vm.getAllConfirmData
    }
  }) : _vm._e(), (_vm.stage === 'finish') ? _c('Loader') : _vm._e()], 1)], 1), _c('BottomButtons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  }), (_vm.stage !== 'setFlowData') ? _c('action-button', {
    attrs: {
      "slot": "button-9",
      "title": "開始拋棄",
      "clickable": _vm.$store.state.drugInDevice.selectedDrugInDeviceID.length > 0 || _vm.$store.state.event.selectedEventId.length > 0
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startFlow($event)
      }
    },
    slot: "button-9"
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1495 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DataImportBase', {
    attrs: {
      "title": '藥物',
      "uploadUrl": '/upload-medication-table/',
      "downloadUrl": '/export-medication-table/'
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1496 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upper-subpanel row"
  }, [_c('progressbar'), _vm._v(" "), _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [_c('drugSelection'), _vm._v(" "), (_vm.showWeb) ? _c('drugInfoWeb', {
    on: {
      "closetab": _vm.closetab
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('bottom-buttons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1497 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upper-subpanel--inside"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('DrugInfo')], 1), _c('div', {
    staticClass: "col-6"
  }, [(_vm.currentProgress === 'confirm') ? _c('ConfirmFlow', {
    attrs: {
      "confirmProgress": _vm.confirmProgress,
      "actionProgress": _vm.actionProgress
    },
    on: {
      "confirmationFinish": _vm.getConfirmData
    }
  }) : _vm._e(), (_vm.currentProgress === 'finish') ? _c('Loader') : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1498 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader-wrapper"
  }, [_c('ClipLoader', {
    attrs: {
      "color": '#FF3811'
    }
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1499 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patient-info-wrapper"
  }, [_c('div', {
    staticClass: "patient-info"
  }, [_c('span', [_vm._v(_vm._s(_vm.currentSchedule.patient.med_record_number)), _c('small', [_vm._v(_vm._s(_vm.currentSchedule.patient.name))])]), (_vm.currentSchedule.bed) ? _c('span', [_vm._v("病床：" + _vm._s(_vm.currentSchedule.bed.code))]) : _vm._e()]), _c('div', {
    staticClass: "gender-img"
  }, [(_vm.currentSchedule.patient.gender === 'male') ? _c('img', {
    attrs: {
      "src": "static/svg/masculine.svg"
    }
  }) : _vm._e(), (_vm.currentSchedule.patient.gender === 'female') ? _c('img', {
    attrs: {
      "src": "static/svg/femenine.svg"
    }
  }) : _vm._e(), (_vm.currentSchedule.patient.gender === null) ? _c('span', [_vm._v("性別未定義")]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 1500 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upper-subpanel--inside"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('DrugInfo')], 1), _c('div', {
    staticClass: "col-6"
  }, [(_vm.currentProgress === 'confirm') ? _c('ConfirmFlow', {
    attrs: {
      "confirmProgress": _vm.confirmProgress,
      "actionProgress": _vm.actionProgress,
      "barcodeData": _vm.barcodeData,
      "startType": _vm.startType
    },
    on: {
      "confirmationFinish": _vm.getConfirmData
    }
  }) : _vm._e(), (_vm.currentProgress === 'returnEmpty') ? _c('ReturnEmptyBottle', {
    attrs: {
      "controlMed": _vm.currentDrugInDevice.medication
    },
    on: {
      "returnEmptyBottleFinish": _vm.getConfirmData
    }
  }) : _vm._e(), (_vm.currentProgress === 'finish') ? _c('Loader') : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1501 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "date-input-mask"
  }, [_c('div', {
    staticClass: "input-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5"
  }, [_c('h5', [_vm._v("年份")]), _vm._v(" "), _vm._l((_vm.yearRange), function(n) {
    return _c('div', {
      class: {
        'bg-date-number': true, 'date-selected': n === _vm.year
      },
      on: {
        "click": function($event) {
          _vm.year = n
        }
      }
    }, [_c('span', [_vm._v(_vm._s(n))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_c('h5', [_vm._v("月份")]), _vm._v(" "), _vm._l(((1, 12)), function(n) {
    return _c('div', {
      class: {
        'bg-date-number': true, 'date-selected': n === _vm.month
      },
      on: {
        "click": function($event) {
          _vm.month = n
        }
      }
    }, [_c('span', [_vm._v(_vm._s(n))])])
  })], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h5', [_vm._v("日期")]), _vm._v(" "), _vm._l((_vm.days), function(n) {
    return _c('div', {
      class: {
        'bg-date-number': true, 'date-selected': n === _vm.day
      },
      on: {
        "click": function($event) {
          _vm.day = n
        }
      }
    }, [_c('span', [_vm._v(_vm._s(n))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "submit-date",
    on: {
      "click": _vm.saveDate
    }
  }, [_vm._v("提交日期")])])])
},staticRenderFns: []}

/***/ }),
/* 1502 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-10"
  }, [_c('vuetable', {
    ref: "vuetable",
    attrs: {
      "api-url": (_vm.server + "/api/event/"),
      "data-path": "results",
      "fields": _vm.fields,
      "http-options": _vm.httpOptions,
      "css": _vm.boostrapCss,
      "pagination-path": "",
      "append-params": _vm.moreParams,
      "per-page": 20
    },
    on: {
      "vuetable:pagination-data": _vm.onPaginationData
    }
  }), _c('vuetable-pagination', {
    ref: "pagination",
    attrs: {
      "css": _vm.boostrapCss.pagination
    },
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  })], 1), _c('div', {
    staticClass: "col-2"
  }, [_c('QueryFilter', {
    attrs: {
      "showMedRecordNum": true,
      "showMedication": true
    },
    on: {
      "filter": _vm.filter,
      "report": _vm.report
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1503 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upper-subpanel row"
  }, [_c('progressBar'), _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [(_vm.stage === 'scanBarcode') ? _c('scanBarcode', {
    on: {
      "setBarcode": _vm.getBarcode
    }
  }) : _vm._e(), (_vm.stage === 'ScheduleList') ? _c('ScheduleList', {
    attrs: {
      "fireRefetch": _vm.fireRefetch,
      "viewMode": 'scheduleList',
      "filterOutZeroAmountMed": true
    },
    on: {
      "setSchedule": _vm.getSchedule
    }
  }) : _vm._e(), (_vm.stage === 'selectDrug') ? _c('EventTable', {
    attrs: {
      "eventType": _vm.eventType,
      "singleSelection": false,
      "number2": _vm.$store.state.schedule.currentSchedule.id
    }
  }) : _vm._e(), (_vm.stage === 'startFlow') ? _c('MultiFlow', {
    attrs: {
      "startType": 'event',
      "barcodeData": _vm.barcodeData,
      "multiProgress": _vm.multiProgress,
      "confirmProgress": _vm.confirmProgress,
      "actionProgress": _vm.actionProgress
    },
    on: {
      "setAllConfirmData": _vm.getAllConfirmData
    }
  }) : _vm._e()], 1)], 1), _c('BottomButtons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  }), ((_vm.stage === 'ScheduleList' || _vm.stage === 'scanBarcode') && _vm.$store.state.generalSetting.mode === 'nursing') ? _c('action-button', {
    attrs: {
      "slot": "button-3",
      "title": "病人列表"
    },
    nativeOn: {
      "click": function($event) {
        _vm.stage = 'ScheduleList'
      }
    },
    slot: "button-3"
  }) : _vm._e(), (_vm.stage === 'ScheduleList' || _vm.stage === 'scanBarcode') ? _c('action-button', {
    attrs: {
      "slot": "button-3",
      "title": "掃描條碼"
    },
    nativeOn: {
      "click": function($event) {
        _vm.stage = 'scanBarcode'
      }
    },
    slot: "button-3"
  }) : _vm._e(), (_vm.stage === 'selectDrug') ? _c('action-button', {
    attrs: {
      "slot": "button-9",
      "title": "開始退藥",
      "clickable": _vm.$store.state.drugInDevice.selectedDrugInDeviceID.length > 0 || _vm.$store.state.event.selectedEventId.length > 0
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startFlow($event)
      }
    },
    slot: "button-9"
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1504 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h6', [_vm._v("待補充清單")]), _vm._v(" "), _c('vuetable', {
    ref: "vuetable",
    attrs: {
      "api-url": (_vm.server + "/api/drug-storage-not-full/"),
      "data-path": "",
      "pagination-path": "",
      "fields": _vm.fields,
      "api-mode": true,
      "css": _vm.boostrapCss,
      "http-options": _vm.httpOptions
    },
    on: {
      "vuetable:cell-clicked": _vm.onCellClicked
    },
    scopedSlots: _vm._u([{
      key: "num-refill",
      fn: function(props) {
        return [_c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v(_vm._s(props.rowData.max_stock - props.rowData.stock))])]
      }
    }])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.setRefill
    }
  }, [_vm._v("設定補藥項目")])], 1)
},staticRenderFns: []}

/***/ }),
/* 1505 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row upper-subpanel"
  }, [_c('progressBar'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.stage === 'loading') ? _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [_c('Loader')], 1) : _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [(_vm.returnCmpn !== null) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "upper-subpanel--half"
  }, [_c('h3', [_vm._v("目前設定位置")]), _vm._v(" "), _c('p', [_vm._v("\n                第 " + _vm._s(_vm.returnCmpn.net.open_times) + " 藥櫃 - 第 " + _vm._s(_vm.returnCmpn.net.row_id) + " 層 - 第 " + _vm._s(_vm.returnCmpn.pos_row) + " 列 - 第 " + _vm._s(_vm.returnCmpn.relative_col) + " 行\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg confirm-button",
    on: {
      "click": _vm.deleteReturnCmpn
    }
  }, [_vm._v("刪除退藥盒")])])])]) : _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('selectBox', {
    attrs: {
      "mode": 'emptyAndF',
      "singleSelect": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "upper-subpanel--half"
  }, [_c('h3', [_vm._v("請在左側點選未使用藥盒")]), _vm._v(" "), _c('h3', [_vm._v("以設定退藥盒")])])])])])])], 1), _vm._v(" "), _c('bottom-buttons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  }), _vm._v(" "), (_vm.returnCmpn === null) ? _c('action-button', {
    attrs: {
      "slot": "button-9",
      "title": "設定完成"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submit($event)
      }
    },
    slot: "button-9"
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1506 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-layout"
  }, [_c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("\n    此藥物總存量: " + _vm._s(_vm.selectedDrugTotalAmount) + " \n  ")]), _vm._v(" "), (_vm.currentProgress === 'action') ? _c('Action', {
    attrs: {
      "inputReadOnly": true,
      "defaultPackContent": 0,
      "checkNum": _vm.currentEvent.number1,
      "defaultNum": _vm.currentEvent.number1,
      "deviceId": _vm.currentEvent.device.id
    },
    on: {
      "setActionData": _vm.getActionData
    }
  }, [_c('h5', [_vm._v("回收退藥盒藥物")])]) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'finish') ? _c('Loader') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1507 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "number-input-mask"
  }, [_c('div', {
    staticClass: "input-content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.number),
      expression: "number"
    }],
    ref: "input",
    staticClass: "number-area",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.number)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.saveNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.number = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "bg-number-button",
    on: {
      "click": function($event) {
        return _vm.addNumber('1')
      }
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "bg-number-button",
    on: {
      "click": function($event) {
        return _vm.addNumber('2')
      }
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "bg-number-button",
    on: {
      "click": function($event) {
        return _vm.addNumber('3')
      }
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "bg-number-button",
    on: {
      "click": _vm.removeNumber
    }
  }, [_vm._v("DEL")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_c('div', {
    staticClass: "col-9"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "bg-number-button",
    on: {
      "click": function($event) {
        return _vm.addNumber('4')
      }
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "bg-number-button",
    on: {
      "click": function($event) {
        return _vm.addNumber('5')
      }
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "bg-number-button",
    on: {
      "click": function($event) {
        return _vm.addNumber('6')
      }
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "bg-number-button",
    on: {
      "click": function($event) {
        return _vm.addNumber('7')
      }
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "bg-number-button",
    on: {
      "click": function($event) {
        return _vm.addNumber('8')
      }
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "bg-number-button",
    on: {
      "click": function($event) {
        return _vm.addNumber('9')
      }
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "bg-number-button bg-number-bottom",
    on: {
      "click": function($event) {
        return _vm.addNumber('0')
      }
    }
  }, [_vm._v("0")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "bg-number-button bg-number-right",
    on: {
      "click": _vm.saveNumber
    }
  }, [_vm._v("確認")])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1508 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-layout"
  }, [_c('div', {
    staticClass: "alert alert-success"
  }, [_c('span', [_vm._v("此藥物總存量:  " + _vm._s(_vm.selectedDrugTotalAmount))]), _c('span', {
    staticClass: "float-right"
  })]), (_vm.currentProgress === 'rxCheck') ? _c('RxCheckBarcode', {
    on: {
      "confirmRx": _vm.confirmRx
    }
  }) : _vm._e(), (_vm.currentProgress === 'actionWrap') ? _c('ActionWrap', {
    attrs: {
      "actionProgress": _vm.actionProgress,
      "medRecordId": _vm.currentSchedule.patient.med_record_number,
      "amount": _vm.currentDrug.amount,
      "scheduleId": _vm.currentSchedule.id,
      "reviewer": _vm.reviewer
    },
    on: {
      "setActionData": _vm.getFetchData
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1509 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-form"
  }, [_c('h5', {
    staticClass: "text-center"
  }, [_vm._v("選擇退藥理由")]), _vm._v(" "), _c('div', {
    staticClass: "reasons-wrap"
  }, _vm._l((_vm.returnReasons), function(reason, n) {
    return _c('div', {
      class: {
        'btn drug-button': true, 'item-selected': _vm.selectReason === reason, 'reason-button': true
      },
      on: {
        "click": function($event) {
          return _vm.setReason(reason)
        }
      }
    }, [_vm._v("\n      " + _vm._s(reason) + "\n    ")])
  }), 0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('h6', {
    staticClass: "col-3 col-form-label"
  }, [_vm._v("其他")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customReason),
      expression: "customReason"
    }],
    staticClass: "col-9 form-control",
    attrs: {
      "type": "text",
      "placeholder": "自訂理由"
    },
    domProps: {
      "value": (_vm.customReason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customReason = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "button-wrap"
  }, [_c('button', {
    staticClass: "btn confirm-button btn-lg",
    on: {
      "click": _vm.confirmReason
    }
  }, [_vm._v("確認理由")])])])
},staticRenderFns: []}

/***/ }),
/* 1510 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "v-spinner"
  }, [_c('div', {
    staticClass: "v-clip",
    style: (_vm.spinnerStyle)
  })])
},staticRenderFns: []}

/***/ }),
/* 1511 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-layout"
  }, [_c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("\n    此藥物總存量: " + _vm._s(_vm.selectedDrugTotalAmount) + " \n  ")]), _vm._v(" "), (_vm.currentProgress === 'confirmAmount') ? _c('Action', {
    attrs: {
      "defaultNum": _vm.currentDrugInDevice.stock,
      "autoCaculateAmount": false,
      "compType": 'Confirm',
      "valueMoreThanZero": false,
      "defaultPackCount": _vm.currentDrugInDevice.pack_count,
      "deviceId": _vm.currentDrugInDevice.device.id,
      "checkNum": _vm.currentDrugInDevice.max_stock
    },
    on: {
      "confirmAmountFinish": _vm.confirmAmountFinish
    }
  }, [_c('h5', [_vm._v("確認藥盒內數量")])]) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'action') ? _c('Action', {
    attrs: {
      "defaultNum": _vm.currentDrugInDevice.stock,
      "deviceId": _vm.currentDrugInDevice.device.id,
      "defaultPackCount": _vm.currentDrugInDevice.pack_count,
      "inputReadOnly": true,
      "valueMoreThanZero": false
    },
    on: {
      "setActionData": _vm.getActionData
    }
  }, [_c('h5', [_vm._v("移除藥物數量")])]) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'finish') ? _c('Loader') : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'setMinStock') ? _c('NumberSet', {
    attrs: {
      "defaultAmount": _vm.minStorage,
      "canBeZero": true,
      "inputLabel": '更新安全存量'
    },
    on: {
      "setNum": _vm.getMinStorage
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1512 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row upper-subpanel"
  }, [_c('progressBar'), _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [(_vm.stage === 'scanBarcode') ? _c('scanBarcode', {
    on: {
      "setBarcode": _vm.getBarcode
    }
  }) : _vm._e(), (_vm.stage === 'selectDrug') ? _c('selectDrug') : _vm._e(), (_vm.stage === 'selectPosition') ? _c('SplitLayout', [_c('DrugInfo', {
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }), _c('SelectBox', {
    attrs: {
      "slot": "right",
      "mode": 'emptyAndF'
    },
    slot: "right"
  })], 1) : _vm._e(), (_vm.stage === 'setFlowData') ? _c('MultiFlow', {
    attrs: {
      "multiProgress": _vm.multiProgress,
      "confirmProgress": _vm.confirmProgress
    },
    on: {
      "setAllConfirmData": _vm.getAllConfirmData
    }
  }) : _vm._e(), (_vm.stage === 'finishAddDrug') ? _c('Loader') : _vm._e()], 1)], 1), _c('BottomButtons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  }), (_vm.stage === 'scanBarcode' || _vm.stage === 'selectDrug') ? _c('action-button', {
    attrs: {
      "slot": "button-5",
      "title": "全部藥物"
    },
    nativeOn: {
      "click": function($event) {
        _vm.stage = 'selectDrug'
      }
    },
    slot: "button-5"
  }) : _vm._e(), (_vm.stage === 'scanBarcode' || _vm.stage === 'selectDrug') ? _c('action-button', {
    attrs: {
      "slot": "button-6",
      "title": "掃描條碼"
    },
    nativeOn: {
      "click": function($event) {
        _vm.stage = 'scanBarcode'
      }
    },
    slot: "button-6"
  }) : _vm._e(), (_vm.stage === 'selectPosition') ? _c('action-button', {
    attrs: {
      "slot": "button-9",
      "title": "確認位置"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.confrimPosition($event)
      }
    },
    slot: "button-9"
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1513 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isFixedHeader) ? _c('div', [_c('div', {
    staticClass: "vuetable-head-wrapper"
  }, [_c('table', {
    class: ['vuetable', _vm.css.tableClass, _vm.css.tableHeaderClass]
  }, [_c('thead', [_c('tr', [_vm._l((_vm.tableFields), function(field, fieldIndex) {
    return [(field.visible) ? [(_vm.isSpecialField(field.name)) ? [(_vm.extractName(field.name) == '__checkbox') ? _c('th', {
      key: fieldIndex,
      class: ['vuetable-th-checkbox-' + _vm.trackBy, field.titleClass],
      style: ({
        width: field.width
      })
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.checkCheckboxesState(field.name)
      },
      on: {
        "change": function($event) {
          return _vm.toggleAllCheckboxes(field.name, $event)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.extractName(field.name) == '__component') ? _c('th', {
      key: fieldIndex,
      class: ['vuetable-th-component-' + _vm.trackBy, field.titleClass, _vm.sortClass(field), {
        'sortable': _vm.isSortable(field)
      }],
      style: ({
        width: field.width
      }),
      domProps: {
        "innerHTML": _vm._s(_vm.renderTitle(field))
      },
      on: {
        "click": function($event) {
          return _vm.orderBy(field, $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.extractName(field.name) == '__slot') ? _c('th', {
      key: fieldIndex,
      class: ['vuetable-th-slot-' + _vm.extractArgs(field.name), field.titleClass, _vm.sortClass(field), {
        'sortable': _vm.isSortable(field)
      }],
      style: ({
        width: field.width
      }),
      domProps: {
        "innerHTML": _vm._s(_vm.renderTitle(field))
      },
      on: {
        "click": function($event) {
          return _vm.orderBy(field, $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.extractName(field.name) == '__sequence') ? _c('th', {
      key: fieldIndex,
      class: ['vuetable-th-sequence', field.titleClass || ''],
      style: ({
        width: field.width
      }),
      domProps: {
        "innerHTML": _vm._s(_vm.renderTitle(field))
      }
    }) : _vm._e(), _vm._v(" "), (_vm.notIn(_vm.extractName(field.name), ['__sequence', '__checkbox', '__component', '__slot'])) ? _c('th', {
      key: fieldIndex,
      class: ['vuetable-th-' + field.name, field.titleClass || ''],
      style: ({
        width: field.width
      }),
      domProps: {
        "innerHTML": _vm._s(_vm.renderTitle(field))
      }
    }) : _vm._e()] : [_c('th', {
      key: fieldIndex,
      class: ['vuetable-th-' + field.name, field.titleClass, _vm.sortClass(field), {
        'sortable': _vm.isSortable(field)
      }],
      style: ({
        width: field.width
      }),
      attrs: {
        "id": '_' + field.name
      },
      domProps: {
        "innerHTML": _vm._s(_vm.renderTitle(field))
      },
      on: {
        "click": function($event) {
          return _vm.orderBy(field, $event)
        }
      }
    })]] : _vm._e()]
  }), _vm._v(" "), (_vm.scrollVisible) ? _c('th', {
    staticClass: "vuetable-gutter-col",
    style: ({
      width: _vm.scrollBarWidth
    })
  }) : _vm._e()], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "vuetable-body-wrapper",
    style: ({
      height: _vm.tableHeight
    })
  }, [_c('table', {
    class: ['vuetable', _vm.css.tableClass, _vm.css.tableBodyClass]
  }, [_c('colgroup', [_vm._l((_vm.tableFields), function(field, fieldIndex) {
    return [(field.visible) ? [_c('col', {
      key: fieldIndex,
      class: ['vuetable-th-' + field.name, field.titleClass],
      style: ({
        width: field.width
      }),
      attrs: {
        "id": '_col_' + field.name
      }
    })] : _vm._e()]
  })], 2), _vm._v(" "), _c('tbody', {
    staticClass: "vuetable-body"
  }, [_vm._l((_vm.tableData), function(item, itemIndex) {
    return [_c('tr', {
      key: itemIndex,
      class: _vm.onRowClass(item, itemIndex),
      attrs: {
        "item-index": itemIndex,
        "render": _vm.onRowChanged(item)
      },
      on: {
        "click": function($event) {
          return _vm.onRowClicked(item, $event)
        },
        "dblclick": function($event) {
          return _vm.onRowDoubleClicked(item, $event)
        }
      }
    }, [_vm._l((_vm.tableFields), function(field, fieldIndex) {
      return [(field.visible) ? [(_vm.isSpecialField(field.name)) ? [(_vm.extractName(field.name) == '__sequence') ? _c('td', {
        key: fieldIndex,
        class: ['vuetable-sequence', field.dataClass],
        domProps: {
          "innerHTML": _vm._s(_vm.renderSequence(itemIndex))
        }
      }) : _vm._e(), _vm._v(" "), (_vm.extractName(field.name) == '__handle') ? _c('td', {
        key: fieldIndex,
        class: ['vuetable-handle', field.dataClass],
        domProps: {
          "innerHTML": _vm._s(_vm.renderIconTag(['handle-icon', _vm.css.handleIcon]))
        }
      }) : _vm._e(), _vm._v(" "), (_vm.extractName(field.name) == '__checkbox') ? _c('td', {
        key: fieldIndex,
        class: ['vuetable-checkboxes', field.dataClass]
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.rowSelected(item, field.name)
        },
        on: {
          "change": function($event) {
            return _vm.toggleCheckbox(item, field.name, $event)
          }
        }
      })]) : _vm._e(), _vm._v(" "), (_vm.extractName(field.name) === '__component') ? _c('td', {
        key: fieldIndex,
        class: ['vuetable-component', field.dataClass]
      }, [_c(_vm.extractArgs(field.name), {
        tag: "component",
        attrs: {
          "row-data": item,
          "row-index": itemIndex,
          "row-field": field.sortField
        }
      })], 1) : _vm._e(), _vm._v(" "), (_vm.extractName(field.name) === '__slot') ? _c('td', {
        key: fieldIndex,
        class: ['vuetable-slot', field.dataClass]
      }, [_vm._t(_vm.extractArgs(field.name), null, {
        "rowData": item,
        "rowIndex": itemIndex,
        "rowField": field.sortField
      })], 2) : _vm._e()] : [_c('td', {
        key: fieldIndex,
        class: field.dataClass,
        domProps: {
          "innerHTML": _vm._s(_vm.renderNormalField(field, item))
        },
        on: {
          "click": function($event) {
            return _vm.onCellClicked(item, field, $event)
          },
          "dblclick": function($event) {
            return _vm.onCellDoubleClicked(item, field, $event)
          },
          "contextmenu": function($event) {
            return _vm.onCellRightClicked(item, field, $event)
          }
        }
      })]] : _vm._e()]
    })], 2), _vm._v(" "), (_vm.useDetailRow) ? [_c('transition', {
      key: itemIndex,
      attrs: {
        "name": _vm.detailRowTransition
      }
    }, [(_vm.isVisibleDetailRow(item[_vm.trackBy])) ? _c('tr', {
      class: [_vm.css.detailRowClass],
      on: {
        "click": function($event) {
          return _vm.onDetailRowClick(item, $event)
        }
      }
    }, [_c('td', {
      attrs: {
        "colspan": _vm.countVisibleFields
      }
    }, [_c(_vm.detailRowComponent, {
      tag: "component",
      attrs: {
        "row-data": item,
        "row-index": itemIndex
      }
    })], 1)]) : _vm._e()])] : _vm._e()]
  }), _vm._v(" "), (_vm.displayEmptyDataRow) ? [_c('tr', [_c('td', {
    staticClass: "vuetable-empty-result",
    attrs: {
      "colspan": _vm.countVisibleFields
    },
    domProps: {
      "innerHTML": _vm._s(_vm.noDataTemplate)
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.lessThanMinRows) ? _vm._l((_vm.blankRows), function(i) {
    return _c('tr', {
      key: i,
      staticClass: "blank-row"
    }, [_vm._l((_vm.tableFields), function(field, fieldIndex) {
      return [(field.visible) ? _c('td', {
        key: fieldIndex
      }, [_vm._v(" ")]) : _vm._e()]
    })], 2)
  }) : _vm._e()], 2)])])]) : _c('table', {
    class: ['vuetable', _vm.css.tableClass]
  }, [_c('thead', [_c('tr', [_vm._l((_vm.tableFields), function(field, fieldIndex) {
    return [(field.visible) ? [(_vm.isSpecialField(field.name)) ? [(_vm.extractName(field.name) == '__checkbox') ? _c('th', {
      key: fieldIndex,
      class: ['vuetable-th-checkbox-' + _vm.trackBy, field.titleClass],
      style: ({
        width: field.width
      })
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.checkCheckboxesState(field.name)
      },
      on: {
        "change": function($event) {
          return _vm.toggleAllCheckboxes(field.name, $event)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.extractName(field.name) == '__component') ? _c('th', {
      key: fieldIndex,
      class: ['vuetable-th-component-' + _vm.trackBy, field.titleClass, _vm.sortClass(field), {
        'sortable': _vm.isSortable(field)
      }],
      style: ({
        width: field.width
      }),
      domProps: {
        "innerHTML": _vm._s(_vm.renderTitle(field))
      },
      on: {
        "click": function($event) {
          return _vm.orderBy(field, $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.extractName(field.name) == '__slot') ? _c('th', {
      key: fieldIndex,
      class: ['vuetable-th-slot-' + _vm.extractArgs(field.name), field.titleClass, _vm.sortClass(field), {
        'sortable': _vm.isSortable(field)
      }],
      style: ({
        width: field.width
      }),
      domProps: {
        "innerHTML": _vm._s(_vm.renderTitle(field))
      },
      on: {
        "click": function($event) {
          return _vm.orderBy(field, $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.extractName(field.name) == '__sequence') ? _c('th', {
      key: fieldIndex,
      class: ['vuetable-th-sequence', field.titleClass || '', _vm.sortClass(field)],
      style: ({
        width: field.width
      }),
      domProps: {
        "innerHTML": _vm._s(_vm.renderTitle(field))
      }
    }) : _vm._e(), _vm._v(" "), (_vm.notIn(_vm.extractName(field.name), ['__sequence', '__checkbox', '__component', '__slot'])) ? _c('th', {
      key: fieldIndex,
      class: ['vuetable-th-' + field.name, field.titleClass || '', _vm.sortClass(field)],
      style: ({
        width: field.width
      }),
      domProps: {
        "innerHTML": _vm._s(_vm.renderTitle(field))
      }
    }) : _vm._e()] : [_c('th', {
      key: fieldIndex,
      class: ['vuetable-th-' + field.name, field.titleClass, _vm.sortClass(field), {
        'sortable': _vm.isSortable(field)
      }],
      style: ({
        width: field.width
      }),
      attrs: {
        "id": '_' + field.name
      },
      domProps: {
        "innerHTML": _vm._s(_vm.renderTitle(field))
      },
      on: {
        "click": function($event) {
          return _vm.orderBy(field, $event)
        }
      }
    })]] : _vm._e()]
  })], 2)]), _vm._v(" "), _c('tbody', {
    staticClass: "vuetable-body"
  }, [_vm._l((_vm.tableData), function(item, itemIndex) {
    return [_c('tr', {
      key: itemIndex,
      class: _vm.onRowClass(item, itemIndex),
      attrs: {
        "item-index": itemIndex,
        "render": _vm.onRowChanged(item)
      },
      on: {
        "dblclick": function($event) {
          return _vm.onRowDoubleClicked(item, $event)
        },
        "click": function($event) {
          return _vm.onRowClicked(item, $event)
        }
      }
    }, [_vm._l((_vm.tableFields), function(field, fieldIndex) {
      return [(field.visible) ? [(_vm.isSpecialField(field.name)) ? [(_vm.extractName(field.name) == '__sequence') ? _c('td', {
        key: fieldIndex,
        class: ['vuetable-sequence', field.dataClass],
        domProps: {
          "innerHTML": _vm._s(_vm.renderSequence(itemIndex))
        }
      }) : _vm._e(), _vm._v(" "), (_vm.extractName(field.name) == '__handle') ? _c('td', {
        key: fieldIndex,
        class: ['vuetable-handle', field.dataClass],
        domProps: {
          "innerHTML": _vm._s(_vm.renderIconTag(['handle-icon', _vm.css.handleIcon]))
        }
      }) : _vm._e(), _vm._v(" "), (_vm.extractName(field.name) == '__checkbox') ? _c('td', {
        key: fieldIndex,
        class: ['vuetable-checkboxes', field.dataClass]
      }, [_c('input', {
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.rowSelected(item, field.name)
        },
        on: {
          "change": function($event) {
            return _vm.toggleCheckbox(item, field.name, $event)
          }
        }
      })]) : _vm._e(), _vm._v(" "), (_vm.extractName(field.name) === '__component') ? _c('td', {
        key: fieldIndex,
        class: ['vuetable-component', field.dataClass]
      }, [_c(_vm.extractArgs(field.name), {
        tag: "component",
        attrs: {
          "row-data": item,
          "row-index": itemIndex,
          "row-field": field.sortField
        }
      })], 1) : _vm._e(), _vm._v(" "), (_vm.extractName(field.name) === '__slot') ? _c('td', {
        key: fieldIndex,
        class: ['vuetable-slot', field.dataClass]
      }, [_vm._t(_vm.extractArgs(field.name), null, {
        "rowData": item,
        "rowIndex": itemIndex,
        "rowField": field.sortField
      })], 2) : _vm._e()] : [(_vm.hasCallback(field)) ? _c('td', {
        key: fieldIndex,
        class: field.dataClass,
        domProps: {
          "innerHTML": _vm._s(_vm.callCallback(field, item))
        },
        on: {
          "click": function($event) {
            return _vm.onCellClicked(item, field, $event)
          },
          "dblclick": function($event) {
            return _vm.onCellDoubleClicked(item, field, $event)
          },
          "contextmenu": function($event) {
            return _vm.onCellRightClicked(item, field, $event)
          }
        }
      }) : _c('td', {
        key: fieldIndex,
        class: field.dataClass,
        domProps: {
          "innerHTML": _vm._s(_vm.getObjectValue(item, field.name, ''))
        },
        on: {
          "click": function($event) {
            return _vm.onCellClicked(item, field, $event)
          },
          "dblclick": function($event) {
            return _vm.onCellDoubleClicked(item, field, $event)
          },
          "contextmenu": function($event) {
            return _vm.onCellRightClicked(item, field, $event)
          }
        }
      })]] : _vm._e()]
    })], 2), _vm._v(" "), (_vm.useDetailRow) ? [_c('transition', {
      key: itemIndex,
      attrs: {
        "name": _vm.detailRowTransition
      }
    }, [(_vm.isVisibleDetailRow(item[_vm.trackBy])) ? _c('tr', {
      class: [_vm.css.detailRowClass],
      on: {
        "click": function($event) {
          return _vm.onDetailRowClick(item, $event)
        }
      }
    }, [_c('td', {
      attrs: {
        "colspan": _vm.countVisibleFields
      }
    }, [_c(_vm.detailRowComponent, {
      tag: "component",
      attrs: {
        "row-data": item,
        "row-index": itemIndex
      }
    })], 1)]) : _vm._e()])] : _vm._e()]
  }), _vm._v(" "), (_vm.displayEmptyDataRow) ? [_c('tr', [_c('td', {
    staticClass: "vuetable-empty-result",
    attrs: {
      "colspan": _vm.countVisibleFields
    },
    domProps: {
      "innerHTML": _vm._s(_vm.noDataTemplate)
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.lessThanMinRows) ? _vm._l((_vm.blankRows), function(i) {
    return _c('tr', {
      key: i,
      staticClass: "blank-row"
    }, [_vm._l((_vm.tableFields), function(field, fieldIndex) {
      return [(field.visible) ? _c('td', {
        key: fieldIndex
      }, [_vm._v(" ")]) : _vm._e()]
    })], 2)
  }) : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 1514 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-10"
  }, [_c('vuetable', {
    ref: "vuetable",
    attrs: {
      "pagination-path": "",
      "fields": _vm.fields,
      "api-mode": false,
      "css": _vm.boostrapCss,
      "append-params": _vm.moreParams,
      "http-options": _vm.httpOptions
    },
    on: {
      "vuetable:pagination-data": _vm.onPaginationData
    }
  }), _c('vuetable-pagination', {
    ref: "pagination",
    attrs: {
      "css": _vm.boostrapCss.pagination
    },
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  })], 1), _c('div', {
    staticClass: "col-2"
  }, [_c('QueryFilter', {
    attrs: {
      "showReportButton": _vm.showReportButton,
      "showDate": _vm.showDate,
      "showStartDate": _vm.showStartDate
    },
    on: {
      "filter": _vm.filter
    }
  }), (_vm.loadingData) ? _c('Loader', [_c('h4', [_vm._v("資料載入中，請稍等")])]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1515 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-row"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.showImg
    }
  }, [_vm._v(_vm._s(_vm.img_string))]), _vm._v("\n         \n    "), (this.$store.state.user.user.username == 'aaron') ? _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.returnModify
    }
  }, [_vm._v("退回修正")]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-10"
  }, [_c('img', {
    staticClass: "car-image",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "bigpic",
      "src": "bigpic"
    }
  })])])
}]}

/***/ }),
/* 1516 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-row"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.showImg
    }
  }, [_vm._v(_vm._s(_vm.img_string))]), _vm._v("\n         \n    "), (this.$store.state.user.user.username == 'aaron') ? _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.returnModify
    }
  }, [_vm._v("退回修正")]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-10"
  }, [_c('img', {
    staticClass: "car-image",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "bigpic",
      "src": "bigpic"
    }
  })])])
}]}

/***/ }),
/* 1517 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drug-info--layout"
  }, [_c('div', {
    staticClass: "drug-table"
  }, [_c('div', {
    staticClass: "drug-table--row drug-img--row"
  }, [_vm._m(0), _c('div', {
    staticClass: "drug-table--cell"
  }, [(_vm.selectedDrug.drug_picture_1 !== null) ? _c('img', {
    staticClass: "drug-table--cell-image",
    attrs: {
      "src": _vm.selectedDrug.drug_picture_1
    },
    on: {
      "click": _vm.showFocus
    }
  }) : _vm._e(), (_vm.selectedDrug.drug_picture_1 === null) ? _c('span', {
    staticStyle: {
      "margin": "0 60px"
    }
  }, [_vm._v("無照片")]) : _vm._e(), (_vm.selectedDrug.drug_picture_2 !== null) ? _c('img', {
    staticClass: "drug-table--cell-image",
    attrs: {
      "src": _vm.selectedDrug.drug_picture_2
    },
    on: {
      "click": _vm.showFocus
    }
  }) : _vm._e(), (_vm.selectedDrug.drug_picture_2 === null) ? _c('span', {
    staticStyle: {
      "margin": "0 60px"
    }
  }, [_vm._v("無照片")]) : _vm._e()])]), _c('div', {
    staticClass: "drug-table--row drug-desc--row"
  }, [_vm._m(1), _c('div', {
    staticClass: "drug-table--cell"
  }, [_c('span', [_vm._v(_vm._s(_vm.selectedDrug.generic_name))])])]), _c('div', {
    staticClass: "drug-table--row drug-desc--row"
  }, [_vm._m(2), _c('div', {
    staticClass: "drug-table--cell"
  }, [(_vm.selectedDrug.product_name === null) ? _c('span', [_vm._v("未設定")]) : _c('span', [_vm._v(_vm._s(_vm.selectedDrug.product_name))])])]), _c('div', {
    staticClass: "drug-table--row drug-desc--row"
  }, [_vm._m(3), _c('div', {
    staticClass: "drug-table--cell"
  }, [_c('span', [_vm._v(_vm._s(_vm.selectedDrug.code) + " / " + _vm._s(_vm.selectedDrug.CGMH_number))])])]), (_vm.currentDrugInDevice === null) ? _c('div', {
    staticClass: "drug-table--row"
  }, [_vm._m(4), _c('div', {
    staticClass: "drug-table--cell"
  }, [_c('span', [_vm._v(_vm._s(_vm.selectedDrug.note))])])]) : _vm._e(), (_vm.currentDrugInDevice !== null) ? _c('div', {
    staticClass: "drug-table--row"
  }, [_vm._m(5), _c('div', {
    staticClass: "drug-table--cell"
  }, [_c('span', {
    class: {
      'color-red': _vm.remainExpiredDays < 30
    }
  }, [_vm._v(_vm._s(_vm.currentDrugInDevice.expired_date) + " "), (_vm.currentDrugInDeviceExpired) ? _c('span', [_vm._v("(已過期)")]) : _vm._e(), (_vm.remainExpiredDays < 30 && !_vm.currentDrugInDeviceExpired) ? _c('span', [_vm._v("(剩餘 " + _vm._s(_vm.remainExpiredDays) + " 天過期)")]) : _vm._e()])])]) : _vm._e(), (_vm.currentDrugInDevice !== null) ? _c('div', {
    staticClass: "drug-table--row"
  }, [_vm._m(6), _c('div', {
    staticClass: "drug-table--cell"
  }, [_c('span', [_vm._v(_vm._s(_vm.currentDrugInDevice.patch_number))])])]) : _vm._e(), (_vm.currentDrugInDevice !== null && _vm.lastEvent) ? _c('div', {
    staticClass: "drug-table--row"
  }, [_vm._m(7), _c('div', {
    staticClass: "drug-table--cell"
  }, [(Object.values(_vm.lastEvent).length === 0) ? _c('span', [_vm._v("無")]) : _c('span', [_vm._v(_vm._s(_vm._f("readabletime")(_vm.lastEvent.record_time)) + " 由 " + _vm._s(_vm.lastEvent.employee_name) + " 進行 " + _vm._s(_vm.lastEvent.event_type.event_name_zh) + " "), (_vm.lastEvent.number1) ? _c('span', [_vm._v("(數量: " + _vm._s(_vm.lastEvent.number1) + ")")]) : _vm._e()])])]) : _vm._e()]), (_vm.focusModalStatus) ? _c('FocusModal', {
    attrs: {
      "message": _vm.foucsMessage
    },
    on: {
      "close": _vm.closeFocus
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drug-table--cell drug-table--cell-head"
  }, [_c('span', [_vm._v("藥物圖片")]), _c('div', [_vm._v("(點擊放大)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drug-table--cell drug-table--cell-head"
  }, [_c('span', [_vm._v("學名")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drug-table--cell drug-table--cell-head"
  }, [_c('span', [_vm._v("商品名")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drug-table--cell drug-table--cell-head"
  }, [_c('span', [_vm._v("藥碼 / 料位號")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drug-table--cell drug-table--cell-head"
  }, [_c('span', [_vm._v("注意事項")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drug-table--cell drug-table--cell-head"
  }, [_c('span', [_vm._v("有效期限")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drug-table--cell drug-table--cell-head"
  }, [_c('span', [_vm._v("批號")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drug-table--cell drug-table--cell-head"
  }, [_c('span', [_vm._v("上次操作事件")])])
}]}

/***/ }),
/* 1518 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-10"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_vm._m(0), _c('p', [_vm._v("   ")]), _vm._l((_vm.paras), function(item) {
    return _c('div', [_c('h4', [(item.fixed_link_code == 'B01') ? _c('kbd', {
      staticClass: "navbar-brand-kbd"
    }, [_vm._v("固定桿代碼B02")]) : _vm._e()]), _c('h4', [(item.fixed_link_code == 'B03') ? _c('kbd', {
      staticClass: "navbar-brand-kbd"
    }, [_vm._v("固定桿代碼B04")]) : _vm._e()])])
  })], 2), (_vm.waitConfirmFlag == true && _vm.loadingData == true) ? _c('div', [_c('h1', {
    staticClass: "text-center display-4"
  }, [_vm._v("認證資料處理中")])]) : _vm._e(), _c('div', [_c('vuetable', {
    ref: "vuetable",
    attrs: {
      "api-url": (_vm.server + "/api/cross-line-data/"),
      "data-path": "results",
      "pagination-path": "",
      "per-page": 1000,
      "fields": _vm.fields,
      "css": _vm.boostrapCss,
      "http-options": _vm.httpOptions,
      "append-params": _vm.moreParams,
      "detail-row-component": "confirm-cross-line-check-detail",
      "sortOrder": _vm.sortOrder
    },
    on: {
      "vuetable:loading": _vm.onLoading,
      "vuetable:loaded": _vm.onLoaded,
      "vuetable:pagination-data": _vm.onPaginationData,
      "vuetable:cell-clicked": _vm.onCellClicked
    }
  }), _c('vuetable-pagination', {
    ref: "pagination",
    attrs: {
      "css": _vm.boostrapCss.pagination
    },
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  })], 1), (_vm.tableDataLen == 0 && _vm.loadingData == false) ? _c('div', [_c('h1', {
    staticClass: "text-center display-4"
  }, [_vm._v("今日無認證資料")])]) : _vm._e()]), _c('div', {
    staticClass: "col-2"
  }, [_vm._m(1), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("開始時間")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.startDate),
      expression: "startDate"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.startDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.startDate = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("結束時間")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.endDate),
      expression: "endDate"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.endDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.endDate = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("過濾條件")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryString),
      expression: "queryString"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "text",
      "placeholder": "輸入車號"
    },
    domProps: {
      "value": (_vm.queryString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.queryString = $event.target.value
      }
    }
  })]), _c('button', {
    staticClass: "btn btn-primary mb-2 w-100",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.onFilterSet
    }
  }, [_vm._v("篩選")]), _c('button', {
    staticClass: "btn btn-danger mb-2 w-100",
    attrs: {
      "type": "submit",
      "disabled": _vm.tableDataLen == 0 || _vm.waitConfirmFlag == true
    },
    on: {
      "click": _vm.confirmTicket
    }
  }, [_vm._v("開單確認")]), _c('button', {
    staticClass: "btn btn-warning mb-2 w-100",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.downloadErrorImg
    }
  }, [_vm._v("下載無法開單照片")])]), (_vm.loadingData) ? _c('Loader', [_c('h4', [_vm._v("資料載入中，請稍等")])]) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('kbd', [_vm._v("違規停車認證資訊")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "text-info"
  }, [_c('strong', [_vm._v("請輸入查詢區間")])])
}]}

/***/ }),
/* 1519 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-10"
  }, [_c('div', {
    staticClass: "summary-layout"
  }, [_c('table', {
    staticClass: "table table-fixed"
  }, [_vm._m(0), _c('tbody', _vm._l((_vm.filteredData), function(data) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(data.check_loc))]), _c('td', [_vm._v(_vm._s(data.check_time))]), _c('td', [_vm._v(_vm._s(data.check_NTPtime))]), _c('td', [_vm._v(_vm._s(data.check_diffms))]), _c('td', [_vm._v(_vm._s(data.check_status))])])
  }), 0)])])]), _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('QueryFilter', {
    attrs: {
      "showReportButton": _vm.showReportButton,
      "showDate": _vm.showDate,
      "showStartDate": _vm.showStartDate
    },
    on: {
      "filter": _vm.filter,
      "report": _vm.downloadReport
    }
  })], 1), (_vm.loadingData) ? _c('Loader', [_c('h4', [_vm._v("資料載入中，請稍等")])]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [_c('th', [_vm._v("地點")]), _c('th', [_vm._v("主機時間")]), _c('th', [_vm._v("NTP時間")]), _c('th', [_vm._v("偏差毫秒(<1000)")]), _c('th', [_vm._v("狀態")])])])
}]}

/***/ }),
/* 1520 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-layout"
  }, [_c('div', {
    staticClass: "alert alert-success"
  }, [_c('span', [_vm._v("原取藥數量: " + _vm._s(Math.abs(_vm.currentEvent.number1)))])]), (_vm.currentProgress === 'setStorage') ? _c('ConfirmStorage', {
    attrs: {
      "inputLabel": '設定退回空瓶數量',
      "defaultAmount": Math.abs(_vm.currentEvent.number1)
    },
    on: {
      "setNum": _vm.getStorage
    }
  }) : _vm._e(), (_vm.currentProgress === 'action') ? _c('ActionWrap', {
    attrs: {
      "actionProgress": _vm.actionProgress,
      "amountPayload": _vm.amountPayload
    },
    on: {
      "setActionData": _vm.getActionData
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1521 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('SplitLayout', [_c('DrugInfo', {
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }), _c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [(_vm.currentProgress === 'confirm') ? _c('ConfirmFlow', {
    attrs: {
      "confirmProgress": _vm.confirmProgress
    },
    on: {
      "confirmationFinish": _vm.getConfirmData
    }
  }) : _vm._e(), (_vm.currentProgress === 'finish') ? _c('Loader') : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1522 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal message-modal"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    class: {
      'modal-content': true,
      'modal-error': _vm.message.type === 'error',
        'modal-warning': _vm.message.type === 'warn',
        'modal-success': _vm.message.type === 'success',
        'modal-clean': _vm.message.type === 'clean',
    }
  }, [_c('div', {
    staticClass: "modal-body text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.message.context)
    }
  }), _vm._v(" "), (_vm.message.confirm || _vm.message.showUnlock) ? _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.message.confirm) ? _c('div', {
    staticClass: "btn btn-white",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("確定")]) : _vm._e(), _vm._v(" "), (_vm.message.showUnlock) ? _c('div', {
    staticClass: "btn btn-white",
    on: {
      "click": _vm.openDevicesDiff
    }
  }, [_vm._v("重新解鎖")]) : _vm._e(), _vm._v(" "), (_vm.message.showLockDevice) ? _c('div', {
    staticClass: "btn btn-white",
    on: {
      "click": _vm.handleDevicesForLockup
    }
  }, [_vm._v("問題藥盒上鎖")]) : _vm._e()]) : _vm._e()])])])])
},staticRenderFns: []}

/***/ }),
/* 1523 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("系統名稱")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.systemName),
      expression: "systemName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.systemName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.systemName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("所屬區域")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.systemArea),
      expression: "systemArea"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.systemArea = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.area), function(item) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("管理者")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.systemAdmin),
      expression: "systemAdmin"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.systemAdmin = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.user), function(item) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 0)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("儲存設定")])])
},staticRenderFns: []}

/***/ }),
/* 1524 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-10"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_vm._m(0), _c('p', [_vm._v("   ")]), _vm._l((_vm.paras), function(item) {
    return _c('div', [_c('h4', [(item.fixed_link_code == 'B01') ? _c('kbd', {
      staticClass: "navbar-brand-kbd"
    }, [_vm._v("固定桿代碼D01/D03")]) : _vm._e()])])
  })], 2), (_vm.waitConfirmFlag == true && _vm.loadingData == true) ? _c('div', [_c('h1', {
    staticClass: "text-center display-4"
  }, [_vm._v("認證資料處理中")])]) : _vm._e(), _c('div', [_c('vuetable', {
    ref: "vuetable",
    attrs: {
      "api-url": (_vm.server + "/api/shoulder-data/"),
      "data-path": "results",
      "pagination-path": "",
      "per-page": 1000,
      "fields": _vm.fields,
      "css": _vm.boostrapCss,
      "http-options": _vm.httpOptions,
      "append-params": _vm.moreParams,
      "detail-row-component": "confirm-shoulder-check-detail",
      "sortOrder": _vm.sortOrder
    },
    on: {
      "vuetable:loading": _vm.onLoading,
      "vuetable:loaded": _vm.onLoaded,
      "vuetable:pagination-data": _vm.onPaginationData,
      "vuetable:cell-clicked": _vm.onCellClicked
    }
  }), _c('vuetable-pagination', {
    ref: "pagination",
    attrs: {
      "css": _vm.boostrapCss.pagination
    },
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  })], 1), (_vm.tableDataLen == 0 && _vm.loadingData == false) ? _c('div', [_c('h1', {
    staticClass: "text-center display-4"
  }, [_vm._v("今日無認證資料")])]) : _vm._e()]), _c('div', {
    staticClass: "col-2"
  }, [_vm._m(1), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("開始時間")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.startDate),
      expression: "startDate"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.startDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.startDate = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("結束時間")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.endDate),
      expression: "endDate"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.endDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.endDate = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("過濾條件")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryString),
      expression: "queryString"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "text",
      "placeholder": "輸入車號"
    },
    domProps: {
      "value": (_vm.queryString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.queryString = $event.target.value
      }
    }
  })]), _c('button', {
    staticClass: "btn btn-primary mb-2 w-100",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.onFilterSet
    }
  }, [_vm._v("篩選")]), _c('button', {
    staticClass: "btn btn-danger mb-2 w-100",
    attrs: {
      "type": "submit",
      "disabled": _vm.tableDataLen == 0 || _vm.waitConfirmFlag == true
    },
    on: {
      "click": _vm.confirmTicket
    }
  }, [_vm._v("開單確認")]), _c('button', {
    staticClass: "btn btn-warning mb-2 w-100",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.downloadErrorImg
    }
  }, [_vm._v("下載無法開單照片")])]), (_vm.loadingData) ? _c('Loader', [_c('h4', [_vm._v("資料載入中，請稍等")])]) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('kbd', [_vm._v("行駛路肩認證資訊")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "text-info"
  }, [_c('strong', [_vm._v("請輸入查詢區間")])])
}]}

/***/ }),
/* 1525 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "web-mask",
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "web"
  }, [_c('div', {
    staticClass: "web-head"
  }, [_vm._v("\n      " + _vm._s(this.$store.state.drug.selectedDrug.generic_name) + "\n      "), _c('div', {
    staticClass: "close-button",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("×")])]), _vm._v(" "), (_vm.prefixSet) ? _c('iframe', {
    attrs: {
      "src": _vm.iframeSrc,
      "frameborder": "0"
    }
  }) : _c('div', {
    staticClass: "with-child-centered",
    staticStyle: {
      "width": "1000px",
      "height": "600px"
    }
  }, [_vm._v("未設定外部網址")])])])
},staticRenderFns: []}

/***/ }),
/* 1526 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upper-subpanel--inside"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "with-child-centered"
  }, [_c('h5', [_vm._v("請輸入藥物名稱")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    ref: "input",
    staticClass: "form-control drug-search-input",
    attrs: {
      "type": "text",
      "id": "drug-name",
      "name": "drug_name",
      "placeholder": "輸入藥物名稱"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn control-button-red",
    on: {
      "click": function($event) {
        _vm.query = ''
      }
    }
  }, [_vm._v("重新輸入")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [(_vm.query_result) ? _c('div', {
    staticClass: "drug-search-list drug-search-list--large",
    attrs: {
      "id": "drug-search-list"
    }
  }, _vm._l((_vm.query_result), function(drug) {
    return _c('div', {
      staticClass: "btn drug-button",
      on: {
        "click": function($event) {
          return _vm.setDrug(drug.id)
        }
      }
    }, [_c('h6', [_c('span', [_vm._v("[ \n            "), (drug.CGMH_number !== null) ? _c('span', [_vm._v(_vm._s(drug.CGMH_number) + " - ")]) : _vm._e(), _vm._v("\n            " + _vm._s(drug.code) + " ]\n          ")]), _vm._v(" \n          " + _vm._s(drug.product_name) + "\n        ")]), _vm._v(" "), _c('span', {
      staticClass: "drug-generic-name"
    }, [_vm._v(_vm._s(drug.generic_name))])])
  }), 0) : _c('div', {
    staticClass: "with-child-centered"
  }, [_c('h5', [_vm._v("未搜尋到任何藥物")])])])])
},staticRenderFns: []}

/***/ }),
/* 1527 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upper-subpanel row"
  }, [_c('progressBar'), _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [(_vm.stage === 'selectDrug' || _vm.stage === 'selectLowStock' || _vm.stage === 'refill' || _vm.stage === 'DrugStorageInOneMed') ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('ScanBarcode', {
    staticStyle: {
      "flex-direction": "column"
    },
    on: {
      "setBarcode": _vm.getBarcode
    }
  }, [_c('div', {
    staticClass: "with-child-centered"
  }, [(_vm.stage === 'selectDrug') ? _c('h2', [_vm._v("[ 手動藥倉補藥 ]")]) : _vm._e(), (_vm.stage === 'selectLowStock') ? _c('h2', [_vm._v("[ 存量過低藥物 ]")]) : _vm._e(), (_vm.stage === 'refill') ? _c('h2', [_vm._v("[ 藥倉補藥規劃 ]")]) : _vm._e(), (_vm.stage === 'DrugStorageInOneMed') ? _c('div', [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("請選擇待補藥盒或補藥至新藥盒")])]) : _c('div', [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("請掃描藥盒(身)條碼進行補藥")]), _c('h4', {
    staticClass: "text-center"
  }, [_vm._v("或於右方選擇待補藥物種類")])])])])], 1), _c('div', {
    staticClass: "col-6"
  }, [(_vm.stage === 'selectDrug') ? _c('drugList', {
    attrs: {
      "viewMode": 'medList',
      "medSelectMode": 'selectDrugStorage',
      "drugItemHeadWidth": '500px'
    },
    on: {
      "setDrugStorageWithSameMed": _vm.getDrugStorageWithSameMed
    }
  }) : _vm._e(), (_vm.stage === 'selectLowStock') ? _c('drugList', {
    attrs: {
      "mode": 'lowStock',
      "viewMode": 'medList',
      "medSelectMode": 'selectDrugStorage'
    },
    on: {
      "setDrugStorageWithSameMed": _vm.getDrugStorageWithSameMed
    }
  }) : _vm._e(), (_vm.stage === 'refill') ? _c('drugList', {
    attrs: {
      "mode": 'refill',
      "viewMode": 'medList',
      "medSelectMode": 'selectDrugStorage'
    },
    on: {
      "setDrugStorageWithSameMed": _vm.getDrugStorageWithSameMed
    }
  }) : _vm._e(), (_vm.stage === 'DrugStorageInOneMed') ? _c('drugList', {
    attrs: {
      "showRefillToNewDrugStorage": true
    },
    on: {
      "setNewDeviceForRefill": _vm.getNewDeviceForRefill
    }
  }) : _vm._e()], 1)]) : _vm._e(), (_vm.stage === 'setFlowData') ? _c('MultiFlow', {
    attrs: {
      "startType": _vm.startType,
      "multiProgress": _vm.multiProgress,
      "confirmProgress": _vm.confirmProgress
    },
    on: {
      "setAllConfirmData": _vm.getAllConfirmData
    }
  }) : _vm._e(), (_vm.stage === 'finish') ? _c('Loader') : _vm._e()], 1)], 1), _c('BottomButtons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  }), _c('action-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 'selectDrug'),
      expression: "currentStep === 'selectDrug'"
    }],
    attrs: {
      "slot": "button-3",
      "title": "手動補藥"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.changeStage('selectDrug')
      }
    },
    slot: "button-3"
  }), _c('action-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 'selectDrug'),
      expression: "currentStep === 'selectDrug'"
    }],
    attrs: {
      "slot": "button-4",
      "title": "存量過低"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.changeStage('selectLowStock')
      }
    },
    slot: "button-4"
  }), _c('action-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 'selectDrug'),
      expression: "currentStep === 'selectDrug'"
    }],
    attrs: {
      "slot": "button-5",
      "title": "補藥規劃"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.changeStage('refill')
      }
    },
    slot: "button-5"
  }), (_vm.currentStep === 'selectDrug') ? _c('action-button', {
    attrs: {
      "slot": "button-7",
      "title": "選擇全部"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectAll($event)
      }
    },
    slot: "button-7"
  }) : _vm._e(), (_vm.currentStep === 'selectDrug') ? _c('action-button', {
    attrs: {
      "slot": "button-7",
      "title": "取消選擇"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deselectAll($event)
      }
    },
    slot: "button-7"
  }) : _vm._e(), (_vm.stage !== 'setFlowData') ? _c('action-button', {
    attrs: {
      "slot": "button-9",
      "title": "開始補充"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startFlow($event)
      }
    },
    slot: "button-9"
  }) : _vm._e()], 1), (_vm.showRefillSelection) ? _c('RefillSelection', {
    attrs: {
      "drugStorageIds": _vm.drugStorageIdsForSelected
    },
    on: {
      "selectionDone": _vm.selectionDone,
      "cancelSelection": _vm.cancelSelection
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1528 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drug-panel"
  }, [_c('div', {
    staticClass: "drug-panel--head"
  }, [_c('button', {
    staticClass: "btn btn-info icon-right",
    on: {
      "click": function($event) {
        _vm.createForm = true
      }
    }
  }, [_vm._v("新增藥組")]), (_vm.createForm) ? _c('CreateSpecialMedicineForm', {
    attrs: {
      "medicineType": 'control'
    },
    on: {
      "closeForm": _vm.closeForm,
      "dataCreated": _vm.dataCreated
    }
  }) : _vm._e()], 1), _c('vuetable', {
    ref: "vuetableCombo",
    attrs: {
      "track-by": 'id',
      "api-mode": false,
      "fields": _vm.comboField,
      "pagination-path": "",
      "css": _vm.boostrapCss,
      "detail-row-component": "control-detail",
      "item-actions": "itemActions"
    },
    on: {
      "vuetable:cell-clicked": _vm.onControlClicked
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(props) {
        return [_c('button', {
          staticClass: "btn btn-danger btn-sm",
          on: {
            "click": function($event) {
              return _vm.deleteControl(props.rowData)
            }
          }
        }, [_vm._v("刪除套藥")])]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1529 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("新增藥物群組"), _c('span', {
    staticClass: "icon-right",
    on: {
      "click": function($event) {
        return _vm.$emit('closeForm')
      }
    }
  }, [_vm._v("X")])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _c('hr'), _c('span', {
    staticClass: "errorMsg"
  }, [_vm._v(_vm._s(_vm.formMsg))]), _c('button', {
    staticClass: "btn btn-secondary float-right",
    attrs: {
      "disabled": _vm.formComplete === false
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createMedGroup($event)
      }
    }
  }, [_vm._v("新增")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("名稱*")])])
}]}

/***/ }),
/* 1530 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upper-subpanel--inside"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('DrugInfo')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [(_vm.currentProgress === 'confirm') ? _c('ConfirmFlow', {
    attrs: {
      "confirmProgress": _vm.confirmProgress
    },
    on: {
      "confirmationFinish": _vm.getConfirmData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'finish') ? _c('Loader') : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1531 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Patch', [_c('h5', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("標籤管理")])])
},staticRenderFns: []}

/***/ }),
/* 1532 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drug-panel"
  }, [_c('div', {
    staticClass: "drug-panel--head"
  }, [_c('button', {
    staticClass: "btn btn-info icon-right",
    on: {
      "click": function($event) {
        _vm.createForm = true
      }
    }
  }, [_vm._v("新增藥物")]), (_vm.createForm) ? _c('CreateMedicineForm', {
    on: {
      "closeForm": _vm.closeForm
    }
  }) : _vm._e(), _c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onFilterSet($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medName),
      expression: "medName"
    }],
    staticClass: "form-control mr-2",
    attrs: {
      "type": "text",
      "placeholder": "輸入藥碼, 學名或料位號"
    },
    domProps: {
      "value": (_vm.medName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.medName = $event.target.value
      }
    }
  }), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("搜尋")])])], 1), _c('vuetable', {
    ref: "vuetableMed",
    attrs: {
      "api-url": (_vm.server + "/api/medication/?type=normal"),
      "data-path": "results",
      "fields": _vm.fields,
      "http-options": _vm.httpOptions,
      "pagination-path": "",
      "css": _vm.boostrapCss,
      "perPage": 30,
      "detail-row-component": "drug-settings-detail",
      "append-params": _vm.moreParams
    },
    on: {
      "vuetable:pagination-data": _vm.onPaginationData,
      "vuetable:cell-clicked": _vm.onMedClicked
    }
  }), _c('vuetable-pagination', {
    ref: "pagination",
    attrs: {
      "css": _vm.boostrapCss.pagination
    },
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1533 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: {
      'container-fluid': true, 'basic-layout': true, 'autoix-layout': _vm.$route.meta.appType === 'cabinet', 'control-panel-layout': _vm.$route.meta.appType === 'admin', 'developer-layout': _vm.$route.meta.appType === 'developer'
    },
    attrs: {
      "id": "app"
    }
  }, [(_vm.$store.state.message.status) ? _c('Message') : _vm._e(), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoader),
      expression: "showLoader"
    }],
    staticClass: "global-loader"
  }, [_c('Loader')], 1), _vm._v(" "), (_vm.user !== null && _vm.user.is_superuser && (_vm.user.username === 'ict' || _vm.user.username === 'weian')) ? _c('div', {
    staticClass: "dev-panel-wrap"
  }, [_c('div', {
    staticClass: "open-panel-button"
  }, [_c('div', {
    staticClass: "btn btn-info",
    on: {
      "click": _vm.showPanel
    }
  }, [(!_vm.openPanel) ? _c('span', [_vm._v("OpenPanel")]) : _c('span', [_vm._v("ClosePanel")])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-right"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.openPanel),
      expression: "openPanel"
    }],
    staticClass: "dev-panel"
  }, [_c('div', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.$store.dispatch('openDevice')
      }
    }
  }, [_vm._v("重新解鎖")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.$store.dispatch('resetAndGetLocalSerialNumber')
      }
    }
  }, [_vm._v("重置藥櫃")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-info",
    attrs: {
      "to": {
        name: 'Main'
      }
    }
  }, [_vm._v("User Panel")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-info",
    attrs: {
      "to": {
        name: 'Admin'
      }
    }
  }, [_vm._v("Admin Panel")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-info",
    attrs: {
      "to": {
        name: 'DevPanel'
      }
    }
  }, [_vm._v("Developer Panel")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-info",
    attrs: {
      "to": {
        name: 'UserImport'
      }
    }
  }, [_vm._v("User Batch Import")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-info",
    attrs: {
      "to": {
        name: 'UserGroupSettings'
      }
    }
  }, [_vm._v("User Group Setting")]), _vm._v(" "), (_vm.currentDevice !== null) ? _c('p', [_vm._v("Current Device: " + _vm._s(_vm.currentDevice.id))]) : _vm._e()], 1)])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1534 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-10"
  }, [_c('div', {
    staticClass: "summary-layout"
  }, [_c('table', {
    staticClass: "table table-fixed"
  }, [_vm._m(0), _c('tbody', _vm._l((_vm.filteredData), function(data) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(data.check_loc))]), _c('td', [_vm._v(_vm._s(data.check_time))]), _c('td', [_vm._v(_vm._s(data.check_otherpctime))]), _c('td', [_vm._v(_vm._s(data.check_diffms))]), _c('td', [_vm._v(_vm._s(data.check_status))])])
  }), 0)])])]), _c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('QueryFilter', {
    attrs: {
      "showReportButton": _vm.showReportButton,
      "showDate": _vm.showDate,
      "showStartDate": _vm.showStartDate
    },
    on: {
      "filter": _vm.filter,
      "report": _vm.downloadReport
    }
  })], 1), (_vm.loadingData) ? _c('Loader', [_c('h4', [_vm._v("資料載入中，請稍等")])]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [_c('th', [_vm._v("地點")]), _c('th', [_vm._v("主機時間")]), _c('th', [_vm._v("獨立主機時間")]), _c('th', [_vm._v("偏差毫秒(<200)")]), _c('th', [_vm._v("狀態")])])])
}]}

/***/ }),
/* 1535 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upper-subpanel--inside"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('DrugInfo')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [(_vm.currentProgress === 'confirm') ? _c('ConfirmFlow', {
    attrs: {
      "startActionType": _vm.startActionType,
      "confirmProgress": _vm.confirmProgress,
      "actionProgress": _vm.actionProgress,
      "barcodeData": _vm.barcodeData
    },
    on: {
      "confirmationFinish": _vm.getConfirmData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'finish') ? _c('Loader') : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1536 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), (_vm.img_string == "關閉照片") ? _c('div', {
    staticClass: "col-2"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plt_no),
      expression: "plt_no"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.plt_no)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.plt_no = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.carName),
      expression: "carName"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.carName = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.carTypes), function(item) {
    return _c('option', {
      domProps: {
        "value": item.car_name
      }
    }, [_vm._v(_vm._s(item.car_name))])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.breakLaw
    }
  }, [_vm._v("確認認證")])]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.showImg
    }
  }, [_vm._v(_vm._s(_vm.img_string))]), _vm._v("\n                   \n    "), _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": _vm.uncertain
    }
  }, [_vm._v("無法開單")]), _vm._v("\n                   \n    "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.pass
    }
  }, [_vm._v("未違規")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-10"
  }, [_c('img', {
    staticClass: "car-image",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "bigpic",
      "src": "bigpic"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('kbd', [_vm._v("車牌號碼")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('kbd', [_vm._v("車別")])])
}]}

/***/ }),
/* 1537 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-layout"
  }, [_c('div', {
    staticClass: "alert alert-success"
  }, [_c('span', [_vm._v("原退回空瓶數量: " + _vm._s(Math.abs(_vm.currentEvent.number1)))])]), (_vm.currentProgress === 'action') ? _c('ActionWrap', {
    attrs: {
      "actionProgress": _vm.actionProgress,
      "amountPayload": _vm.amountPayload
    },
    on: {
      "setActionData": _vm.getActionData
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1538 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar-wrapper"
  }, [_c('div', {
    staticClass: "calendar-title"
  }, [_c('div', {
    staticClass: "change-month month-add",
    on: {
      "click": _vm.minusMonth
    }
  }, [_vm._v("<")]), _c('div', {
    staticClass: "year-month-info"
  }, [_vm._v(_vm._s(_vm.year) + " - " + _vm._s(_vm.month))]), _c('div', {
    staticClass: "change-month month-minus",
    on: {
      "click": _vm.addMonth
    }
  }, [_vm._v(">")])]), _c('div', {
    staticClass: "calendar"
  }, [_c('div', {
    staticClass: "calendar-head"
  }, _vm._l((_vm.weekTitle), function(title) {
    return _c('div', {
      staticClass: "week-title--text"
    }, [_vm._v(_vm._s(title))])
  }), 0), _vm._l((_vm.monthMatrix), function(week, weekInd) {
    return _c('div', {
      staticClass: "calendar-content-week"
    }, _vm._l((week), function(day, dayInd) {
      return _c('div', {
        staticClass: "calendar-content-days",
        class: {
          'avaliable': day !== undefined, 'unavaliable': day === undefined
        }
      }, [(day === undefined) ? _c('div', {
        staticClass: "calendar-content-text"
      }, [_vm._v("X")]) : _c('div', {
        staticClass: "calendar-content-text",
        class: {
          'selected-day': dayInd === _vm.selectDayInd && weekInd === _vm.selectWeekInd,
        },
        on: {
          "click": function($event) {
            return _vm.selectDay(weekInd, dayInd)
          }
        }
      }, [_vm._v(_vm._s(day))])])
    }), 0)
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 1539 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drug-setting-panel"
  }, [_c('div', {
    staticClass: "nav flex-column nav-pills nav-fill drug-setting-nav"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'DrugDBSettings'
      }
    }
  }, [_vm._v("藥物資料庫")]), _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'DrugGroupSettings'
      }
    }
  }, [_vm._v("藥物群組")]), (_vm.serverPrivilege.schedule) ? _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'ComboSettings'
      }
    }
  }, [_vm._v("套藥設定")]) : _vm._e()], 1), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 1540 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-row"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.showImg
    }
  }, [_vm._v(_vm._s(_vm.img_string))]), _vm._v("\n                   \n    "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": this.$store.state.user.user.username == 'estcheck'
    },
    on: {
      "click": _vm.returnModify
    }
  }, [_vm._v("退回修正")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-10"
  }, [_c('img', {
    staticClass: "car-image",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "bigpic",
      "src": "bigpic"
    }
  })])])
}]}

/***/ }),
/* 1541 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onFilterSet($event)
      }
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.systemId),
      expression: "systemId"
    }],
    staticClass: "form-control mr-2",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.systemId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("選擇系統")]), _vm._l((_vm.systems), function(sys) {
    return _c('option', {
      domProps: {
        "value": sys.id
      }
    }, [_vm._v(_vm._s(sys.name))])
  })], 2), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("搜尋")])]), _c('hr'), _c('div', {
    attrs: {
      "id": "planning-table"
    }
  }, [_c('vuetable', {
    ref: "vuetable",
    attrs: {
      "api-url": (_vm.server + "/api/refill-order/"),
      "data-path": "",
      "pagination-path": "",
      "fields": _vm.fields,
      "api-mode": true,
      "css": _vm.boostrapCss,
      "http-options": _vm.httpOptions,
      "append-params": _vm.moreParams
    },
    on: {
      "vuetable:cell-clicked": _vm.onCellClicked
    },
    scopedSlots: _vm._u([{
      key: "medication-name",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(props.rowData.drug_storage.medication.code) + " - " + _vm._s(props.rowData.drug_storage.medication.generic_name))])]
      }
    }, {
      key: "num-refill",
      fn: function(props) {
        return [_c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v(_vm._s(props.rowData.drug_storage.max_stock - props.rowData.drug_storage.stock))])]
      }
    }, {
      key: "refill-box",
      fn: function(props) {
        return [(props.rowData.drug_storage.medication.pack_content === 0) ? _c('span', [_vm._v(_vm._s(props.rowData.drug_storage.max_stock - props.rowData.drug_storage.stock) + " pc")]) : _c('span', [_vm._v(_vm._s(Math.floor((props.rowData.drug_storage.max_stock - props.rowData.drug_storage.stock) / props.rowData.drug_storage.medication.pack_content)) + " 盒 " + _vm._s((props.rowData.drug_storage.max_stock - props.rowData.drug_storage.stock) % props.rowData.drug_storage.medication.pack_content) + " pc")])]
      }
    }])
  })], 1), _c('button', {
    staticClass: "btn btn-primary mr-2",
    on: {
      "click": _vm.deleteOrder
    }
  }, [_vm._v("刪除補藥項目")]), _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": _vm.outputTable
    }
  }, [_vm._v("下載報告")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_vm._v("待補藥清單"), _c('small', [_vm._v("（已列入為補藥規劃")])])
}]}

/***/ }),
/* 1542 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-manual-wrap"
  }, [_c('scan-barcode', {
    on: {
      "setBarcode": _vm.getBarcode
    }
  }, [_c('h3', [_vm._v("請掃描條碼以更新登入用條碼")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1543 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('h4', {
    attrs: {
      "for": "expiration-date"
    }
  }, [_vm._v("設定有效期限")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.expirationDate),
      expression: "expirationDate"
    }],
    staticClass: "form-control custom-input",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "type": "date",
      "id": "expiration-date",
      "readonly": _vm.editable === false
    },
    domProps: {
      "value": (_vm.expirationDate)
    },
    on: {
      "click": _vm.popPad,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.expirationDate = $event.target.value
      }
    }
  }), _c('DateInput', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPad),
      expression: "showPad"
    }],
    attrs: {
      "defaultDate": _vm.expirationDate,
      "limitedDate": _vm.limitedDate
    },
    on: {
      "saveDate": _vm.saveDate,
      "closePad": _vm.closePad
    }
  })], 1), _c('div', {
    staticClass: "button-wrap"
  }, [_c('button', {
    staticClass: "btn btn-lg confirm-button",
    on: {
      "click": _vm.setExpirationDate
    }
  }, [_vm._v("確認")])])])
},staticRenderFns: []}

/***/ }),
/* 1544 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h6', [_vm._v("批次取藥清單        ")]), _c('hr'), _c('form', {
    staticClass: "form-inline mb-2",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onFilterSet($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryString),
      expression: "queryString"
    }],
    staticClass: "form-control mr-2 w-25",
    attrs: {
      "type": "text",
      "placeholder": "輸入藥碼、料位號、學名或病歷號查詢"
    },
    domProps: {
      "value": (_vm.queryString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.queryString = $event.target.value
      }
    }
  }), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("搜尋")])]), _c('vuetable', {
    ref: "vuetable",
    attrs: {
      "api-url": (_vm.server + "/api/fetch-schedule/"),
      "data-path": "results",
      "pagination-path": "",
      "fields": _vm.fields,
      "per-page": 30,
      "api-mode": true,
      "css": _vm.boostrapCss,
      "http-options": _vm.httpOptions,
      "append-params": _vm.moreParams
    },
    on: {
      "vuetable:pagination-data": _vm.onPaginationData
    }
  }), _c('vuetable-pagination', {
    ref: "pagination",
    attrs: {
      "css": _vm.boostrapCss.pagination
    },
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  }), _c('button', {
    staticClass: "btn btn-danger btn-sm mt-2",
    on: {
      "click": _vm.deleteSchedule
    }
  }, [_vm._v("刪除選擇藥單")]), _c('hr'), _c('div', [_c('input', {
    attrs: {
      "type": "file",
      "id": "batch-file-input"
    }
  }), _c('button', {
    staticClass: "btn btn-info btn-sm",
    on: {
      "click": _vm.uploadFile
    }
  }, [_vm._v("上傳批次檔")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1545 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    class: {
      'modal-content': true,
      'modal-warning': true,
    }
  }, [_c('div', {
    staticClass: "modal-body text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("關閉")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1546 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "btn control-button control-button-red",
    on: {
      "click": _vm.scrollup
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "btn control-button control-button-red",
    on: {
      "click": _vm.scrolldown
    }
  }, [_vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button-inside-wrap"
  }, [_c('img', {
    attrs: {
      "src": "/static/svg/up-arrow.svg",
      "alt": "",
      "width": "50px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button-inside-wrap"
  }, [_c('img', {
    staticStyle: {
      "transform": "rotate(180deg)"
    },
    attrs: {
      "src": "/static/svg/up-arrow.svg",
      "alt": "",
      "width": "50px"
    }
  })])
}]}

/***/ }),
/* 1547 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "widget clock",
    attrs: {
      "id": "taipei",
      "data-timezone": "+8"
    }
  }, [_c('div', {
    staticClass: "hand seconds"
  }), _vm._v(" "), _c('div', {
    staticClass: "hand minutes"
  }), _vm._v(" "), _c('div', {
    staticClass: "hand hours"
  }), _vm._v(" "), _c('div', {
    staticClass: "hand-cap"
  })])])
}]}

/***/ }),
/* 1548 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-layout"
  }, [_c('p', {
    staticClass: "app-info"
  }, [_c('small', [_vm._v("Powered By ICT - v" + _vm._s(_vm.version))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSaver),
      expression: "showSaver"
    }],
    staticClass: "top-panel",
    attrs: {
      "id": "top-panel"
    },
    on: {
      "click": _vm.closeScreenSaver
    }
  }, [_c('div', {
    staticClass: "logo-wrap"
  }, [_c('p', [_vm._v("電子藥櫃操作系統")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [(_vm.connected) ? _c('img', {
    staticClass: "connect-icon",
    attrs: {
      "src": "/static/svg/wifi-green.svg",
      "alt": "connected",
      "id": "connected-icon"
    }
  }) : _c('img', {
    staticClass: "connect-icon",
    attrs: {
      "src": "/static/svg/wifi-red.svg",
      "alt": "disconnected",
      "id": "disconnected-icon"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.connectionMsg))])]), (_vm.connected) ? _c('p', [_c('small', [_vm._v("Last connected time: " + _vm._s(_vm.lastConnectedTime))])]) : _c('p', [_c('small', [_vm._v("Last retry time: " + _vm._s(_vm.lastRetryTime))])]), _vm._v(" "), _c('p')]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.$store.state.generalSetting) ? _c('div', {
    staticClass: "bottom-panel",
    attrs: {
      "id": "bottom-panel"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "col-6 barcode-login-panel"
  }, [_c('div', {
    ref: "barcode",
    staticClass: "login-method-wrap"
  }, [_c('ScanBarcode', {
    on: {
      "setBarcode": _vm.getBarcodeToLogin
    }
  }, [_c('div', {
    staticClass: "login-type--img"
  }, [_c('div', [_c('img', {
    staticClass: "m-2",
    attrs: {
      "src": "/static/svg/barcode-black.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "m-2",
    attrs: {
      "src": "/static/svg/fingerprint-black.svg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h4', [_vm._v("\n                請掃描條碼 / 指紋登入 \n              ")]), _vm._v(" "), _c('h6', [(_vm.$store.state.generalSetting.can_login_with_fingerprinter === false) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("指紋功能未開啟")]) : _c('span', [(_vm.$store.state.fingerprinterConnected) ? _c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("(指紋機已連線)")]) : _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("(指紋機未連線)")])])])])])], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-6 account-login-panel"
  }, [_c('form', {
    ref: "password",
    staticClass: "login-method-wrap",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "username",
      "onkeypress": "if (event.keyCode == 13) {return false;}"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "password",
      "onkeypress": "if (event.keyCode == 13) {return false;}"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg login-button",
    attrs: {
      "type": "submit",
      "id": "login-submit"
    }
  }, [_vm._v("\n            帳號登入\n          ")])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "triangle-wrap"
  }, [_c('p', {
    staticClass: "login-hint"
  }, [_vm._v("點選以登入")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line"
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("帳號")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("密碼")])])
}]}

/***/ }),
/* 1549 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-10"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_vm._m(0), _c('p', [_vm._v("   ")]), _vm._l((_vm.paras), function(item) {
    return _c('div', [_c('h4', [(item.fixed_link_code == 'B01') ? _c('kbd', {
      staticClass: "navbar-brand-kbd"
    }, [_vm._v("固定桿代碼D01/D03")]) : _vm._e()])])
  })], 2), _c('div', [_c('vuetable', {
    ref: "vuetable",
    attrs: {
      "api-url": (_vm.server + "/api/shoulder-data/"),
      "data-path": "results",
      "pagination-path": "",
      "per-page": 20,
      "fields": _vm.fields,
      "css": _vm.boostrapCss,
      "http-options": _vm.httpOptions,
      "append-params": _vm.moreParams,
      "detail-row-component": "shoulder-check-detail"
    },
    on: {
      "vuetable:loading": _vm.onLoading,
      "vuetable:loaded": _vm.onLoaded,
      "vuetable:pagination-data": _vm.onPaginationData,
      "vuetable:cell-clicked": _vm.onCellClicked
    }
  }), _c('vuetable-pagination', {
    ref: "pagination",
    attrs: {
      "css": _vm.boostrapCss.pagination
    },
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  })], 1), (_vm.tableDataLen == 0 && _vm.loadingData == false) ? _c('div', [_c('h1', {
    staticClass: "text-center display-4"
  }, [_vm._v("今日無違規資料")])]) : _vm._e()]), _c('div', {
    staticClass: "col-2"
  }, [_vm._m(1), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("開始時間")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.startDate),
      expression: "startDate"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.startDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.startDate = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("結束時間")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.endDate),
      expression: "endDate"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.endDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.endDate = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("過濾條件")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryString),
      expression: "queryString"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "text",
      "placeholder": "輸入車號或開單狀態"
    },
    domProps: {
      "value": (_vm.queryString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.queryString = $event.target.value
      }
    }
  })]), _c('button', {
    staticClass: "btn btn-primary mb-2 w-100",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.onFilterSet
    }
  }, [_vm._v("篩選")])]), (_vm.loadingData) ? _c('Loader', [_c('h4', [_vm._v("資料載入中，請稍等")])]) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('kbd', [_vm._v("行駛路肩資訊")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "text-info"
  }, [_c('strong', [_vm._v("請輸入查詢區間")])])
}]}

/***/ }),
/* 1550 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-2"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("道路限速")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.road_speed_limit),
      expression: "road_speed_limit"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.road_speed_limit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.road_speed_limit = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-2"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("舉發車速(超速)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.break_value),
      expression: "break_value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.break_value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.break_value = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-2"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("舉發車速(龜速)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.break_value_slow),
      expression: "break_value_slow"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.break_value_slow)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.break_value_slow = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-2"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("警示違規車速")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alarmSpeed),
      expression: "alarmSpeed"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.alarmSpeed)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.alarmSpeed = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-2"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("警示違規筆數")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alarmIllegalNum),
      expression: "alarmIllegalNum"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.alarmIllegalNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.alarmIllegalNum = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.updatePara
    }
  }, [_vm._v("更新")])])])
},staticRenderFns: []}

/***/ }),
/* 1551 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _c('div', {
    staticClass: "custom-functions-wrapper"
  }, _vm._l((_vm.reportFunctions), function(func) {
    return _c('div', {
      staticClass: "custom-function"
    }, [_c('h5', [_vm._v(" " + _vm._s(func.name))]), _c('hr'), _c('QueryFilter', {
      attrs: {
        "showDate": func.query_by_date,
        "showEventType": false,
        "showSystem": false,
        "showFilterButton": false
      },
      on: {
        "report": function($event) {
          return _vm.report($event, func.function_name, func.name, func.query_by_date)
        }
      }
    })], 1)
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('kbd', [_vm._v("行駛路肩報表")])])
}]}

/***/ }),
/* 1552 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upper-subpanel--inside"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('DrugInfo')], 1), _c('div', {
    staticClass: "col-6"
  }, [(_vm.currentProgress === 'confirm') ? _c('ConfirmFlow', {
    attrs: {
      "confirmProgress": _vm.confirmProgress
    },
    on: {
      "confirmationFinish": _vm.getConfirmData
    }
  }) : _vm._e(), (_vm.currentProgress === 'finish') ? _c('Loader') : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 1553 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-layout"
  }, [_c('div', {
    staticClass: "alert alert-success"
  }, [_c('span', [_vm._v("此藥物總存量:  " + _vm._s(_vm.selectedDrugTotalAmount))]), _c('span', {
    staticClass: "float-right"
  })]), (_vm.currentProgress === 'rxCheck') ? _c('RxCheckBarcode', {
    on: {
      "confirmRx": _vm.confirmRx
    }
  }) : _vm._e(), (_vm.currentProgress === 'action') ? _c('ActionWrap', {
    attrs: {
      "actionProgress": _vm.actionProgress,
      "medRecordId": _vm.medRecordId,
      "amount": _vm.currentDrug.amount,
      "reviewer": _vm.reviewer
    },
    on: {
      "setActionData": _vm.getFetchData
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1554 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("新增藥物儲存"), _c('span', {
    staticClass: "icon-right",
    on: {
      "click": function($event) {
        return _vm.$emit('cancelForm')
      }
    }
  }, [_vm._v("X")])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "search-dynamic"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceId),
      expression: "deviceId"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.deviceId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.setCurrentDevice]
    }
  }, _vm._l((_vm.devices), function(device, num) {
    return _c('option', {
      domProps: {
        "value": num
      }
    }, [_vm._v(_vm._s(device.series))])
  }), 0)])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "search-dynamic"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchDrug),
      expression: "searchDrug"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.searchDrug)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchDrug = $event.target.value
      }
    }
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.medicines.length !== 0),
      expression: "medicines.length !== 0"
    }],
    staticClass: "input-options-wrap"
  }, _vm._l((_vm.medicines), function(med, num) {
    return _c('div', {
      staticClass: "input-option",
      on: {
        "click": function($event) {
          return _vm.setMedicine(num)
        }
      }
    }, [_vm._v(_vm._s(med.code) + " - " + _vm._s(med.CGMH_number) + " - " + _vm._s(med.generic_name))])
  }), 0)])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-group col-6"
  }, [_vm._m(2), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stock),
      expression: "stock"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.stock)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.stock = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-group col-6"
  }, [_vm._m(3), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maxStock),
      expression: "maxStock"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.maxStock)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.maxStock = $event.target.value
      }
    }
  })])])]), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inventoried),
      expression: "inventoried"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "name": "defaultLogin",
      "value": "password"
    },
    domProps: {
      "checked": Array.isArray(_vm.inventoried) ? _vm._i(_vm.inventoried, "password") > -1 : (_vm.inventoried)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.inventoried,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "password",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.inventoried = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.inventoried = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.inventoried = $$c
        }
      }
    }
  }), _c('span', [_vm._v("盤點與否")])])]), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.formComplete === false
    },
    on: {
      "click": _vm.createDrugStorage
    }
  }, [_vm._v("新增")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("選擇位置")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("選擇藥物")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("儲存數量")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("最大存量")])])
}]}

/***/ }),
/* 1555 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.stage === 'action') ? _c('Action', {
    attrs: {
      "defaultNum": _vm.forAction.defaultNum,
      "deviceId": _vm.forAction.deviceId,
      "inputReadOnly": false,
      "defaultPackCount": _vm.amountPayload.packCount,
      "limitPackCount": false,
      "checkNum": _vm.forAction.checkNum
    },
    on: {
      "setActionData": _vm.getThisAmount
    }
  }, [_c('h5', [_vm._v("此藥盒補藥數量")])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1556 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upper-subpanel--inside"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('DrugInfo')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "confirm-layout"
  }, [_c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("\n        此藥物總數量: " + _vm._s(_vm.selectedDrugTotalAmount) + " \n        "), _c('span', {
    staticClass: "float-right"
  }, [_vm._v("(新增位置: " + _vm._s(_vm.selectedDevicesID.indexOf(_vm.currentDevice.id.toString()) + 1) + "/" + _vm._s(_vm.selectedDevicesID.length) + ")")])]), _vm._v(" "), (_vm.currentProgress === 'confirm') ? _c('confirmFlow', {
    attrs: {
      "confirmProgress": _vm.confirmProgress
    },
    on: {
      "confirmationFinish": _vm.getConfirmData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'setMinStorage') ? _c('set-min-storage', {
    attrs: {
      "defaultAmount": _vm.minStorage,
      "canBeZero": true,
      "inputLabel": '更新安全存量'
    },
    on: {
      "setNum": _vm.getMinStorage
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1557 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "schedule-layout"
  }, [_c('div', {
    staticClass: "schedule-list-wrapper"
  }, [_c('vuetable', {
    ref: "vuetable",
    attrs: {
      "api-mode": false,
      "css": _vm.boostrapCss,
      "fields": _vm.fields,
      "detail-row-component": "schedule-detail"
    },
    on: {
      "vuetable:cell-clicked": _vm.onCellClicked
    }
  })], 1), _c('div', [_c('Calendar', {
    on: {
      "setDatetime": _vm.getDatetime
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1558 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Patch', [_c('h5', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("藥櫃管理")])])
},staticRenderFns: []}

/***/ }),
/* 1559 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.rowData.combo.length > 0) ? _c('div', {
    staticClass: "combo-detail"
  }, [_vm._m(0), _vm._l((_vm.rowData.combo), function(pair) {
    return _c('div', {
      staticClass: "one-med"
    }, [_c('div', {
      attrs: {
        "id": "medication_generic_name"
      }
    }, [_vm._v(_vm._s(pair.medication.generic_name) + " ")]), _c('div', {
      staticClass: "text-center",
      attrs: {
        "id": "dose"
      }
    }, [_vm._v(_vm._s(pair.dose))]), _c('div', {
      staticClass: "text-center",
      attrs: {
        "id": "action"
      }
    }, [_c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.deleteFromControl(pair.relation_id)
        }
      }
    }, [_vm._v("刪除")])])])
  })], 2) : _vm._e(), _c('span', [_vm._v("新增藥物至此套藥組")]), _c('div', {
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "search-dynamic",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "input-group mr-2"
  }, [_vm._m(1), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchDrug),
      expression: "searchDrug"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "輸入藥碼, 學名或料位號"
    },
    domProps: {
      "value": (_vm.searchDrug)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchDrug = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "input-group mr-2"
  }, [_vm._m(2), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dose),
      expression: "dose"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "輸入預設劑量",
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": (_vm.dose)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dose = $event.target.value
      }
    }
  })]), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.pairAddable === false
    },
    on: {
      "click": _vm.addDrugToControl
    }
  }, [_vm._v("新增")]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchMedicines.length !== 0),
      expression: "searchMedicines.length !== 0"
    }],
    staticClass: "input-options-wrap"
  }, _vm._l((_vm.searchMedicines), function(med, num) {
    return _c('div', {
      staticClass: "input-option",
      on: {
        "click": function($event) {
          return _vm.setMedicine(num)
        }
      }
    }, [_vm._v(_vm._s(med.code) + " - " + _vm._s(med.CGMH_number) + " - " + _vm._s(med.generic_name) + "    ")])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "combo-detail--head"
  }, [_c('div', [_vm._v("藥物名稱")]), _c('div', {
    staticClass: "text-center"
  }, [_vm._v("數量")]), _c('div', {
    staticClass: "text-center"
  }, [_vm._v("刪除")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("藥物")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("劑量")])])
}]}

/***/ })
],[714]);


// WEBPACK FOOTER //
// static/js/app.84b7c797d4795b0490dd.js